/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
}, $27fcf98b67c2a783$var$d = "finalized";
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d)) return !1;
        this[$27fcf98b67c2a783$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d] = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$u = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1);
function $e5ed8027d647799b$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != l ? l : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, l = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e5ed8027d647799b$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$V(t, i);
        if (this.el = $e5ed8027d647799b$var$N.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$H : "?" === i[1] ? $e5ed8027d647799b$var$L : "@" === i[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$u()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e5ed8027d647799b$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e5ed8027d647799b$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e5ed8027d647799b$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$d(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.k($e5ed8027d647799b$var$u()), this.k($e5ed8027d647799b$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$S(this, t, i, 0), n = !$e5ed8027d647799b$var$d(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$S(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$d(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$S(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$V,
    L: $e5ed8027d647799b$var$M,
    R: $e5ed8027d647799b$var$v,
    D: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    V: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$L,
    N: $e5ed8027d647799b$var$z,
    U: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$B || $e5ed8027d647799b$var$B($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.8.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $27fcf98b67c2a783$export$c7c07a37856565d);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $b2fdcbe153c88f81$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $b2fdcbe153c88f81$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $b2fdcbe153c88f81$var$e(n, t, o) : $b2fdcbe153c88f81$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(t) {
    return (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $15c76e2f7983b497$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $15c76e2f7983b497$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(i, n) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(e) {
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $43ca3aec390b0561$var$n;
const $43ca3aec390b0561$var$e = null != (null === ($43ca3aec390b0561$var$n = window.HTMLSlotElement) || void 0 === $43ca3aec390b0561$var$n ? void 0 : $43ca3aec390b0561$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $43ca3aec390b0561$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $43ca3aec390b0561$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $15c76e2f7983b497$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/*! @azure/msal-browser v2.38.3 2023-10-27 */ /*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $87ab789688594f61$var$extendStatics = function(d, b) {
    $87ab789688594f61$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $87ab789688594f61$var$extendStatics(d, b);
};
function $87ab789688594f61$export$a8ba968b8961cb8a(d, b) {
    $87ab789688594f61$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $87ab789688594f61$export$18ce0697a983be9b = function() {
    $87ab789688594f61$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87ab789688594f61$export$18ce0697a983be9b.apply(this, arguments);
};
function $87ab789688594f61$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $87ab789688594f61$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $87ab789688594f61$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $87ab789688594f61$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $87ab789688594f61$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($87ab789688594f61$export$8d051b38c9118094(arguments[i]));
    return ar;
}


/*! @azure/msal-common v13.3.1 2023-10-27 */ /*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a296cc98de023397$var$extendStatics = function(d, b) {
    $a296cc98de023397$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a296cc98de023397$var$extendStatics(d, b);
};
function $a296cc98de023397$export$a8ba968b8961cb8a(d, b) {
    $a296cc98de023397$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a296cc98de023397$export$18ce0697a983be9b = function() {
    $a296cc98de023397$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a296cc98de023397$export$18ce0697a983be9b.apply(this, arguments);
};
function $a296cc98de023397$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a296cc98de023397$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a296cc98de023397$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $709b0e48f6b53a82$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    REGIONAL_AUTH_NON_MSI_QUERY_STRING: "allowestsrnonmsi=true",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
var $709b0e48f6b53a82$export$893b1b5b686d84ef = [
    $709b0e48f6b53a82$export$a002182e51710d39.OPENID_SCOPE,
    $709b0e48f6b53a82$export$a002182e51710d39.PROFILE_SCOPE,
    $709b0e48f6b53a82$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
var $709b0e48f6b53a82$export$268e88275f5afab2 = (0, $a296cc98de023397$export$6388937ca91ccae8)($709b0e48f6b53a82$export$893b1b5b686d84ef, [
    $709b0e48f6b53a82$export$a002182e51710d39.EMAIL_SCOPE
]);
/**
 * Request header names
 */ var $709b0e48f6b53a82$export$28d77f87efed1d88;
(function(HeaderNames) {
    HeaderNames["CONTENT_TYPE"] = "Content-Type";
    HeaderNames["RETRY_AFTER"] = "Retry-After";
    HeaderNames["CCS_HEADER"] = "X-AnchorMailbox";
    HeaderNames["WWWAuthenticate"] = "WWW-Authenticate";
    HeaderNames["AuthenticationInfo"] = "Authentication-Info";
    HeaderNames["X_MS_REQUEST_ID"] = "x-ms-request-id";
    HeaderNames["X_MS_HTTP_VERSION"] = "x-ms-httpver";
})($709b0e48f6b53a82$export$28d77f87efed1d88 || ($709b0e48f6b53a82$export$28d77f87efed1d88 = {}));
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ var $709b0e48f6b53a82$export$81ab9ba9bd28255c;
(function(PersistentCacheKeys) {
    PersistentCacheKeys["ID_TOKEN"] = "idtoken";
    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
    PersistentCacheKeys["ADAL_ID_TOKEN"] = "adal.idtoken";
    PersistentCacheKeys["ERROR"] = "error";
    PersistentCacheKeys["ERROR_DESC"] = "error.description";
    PersistentCacheKeys["ACTIVE_ACCOUNT"] = "active-account";
    PersistentCacheKeys["ACTIVE_ACCOUNT_FILTERS"] = "active-account-filters"; // new cache entry for active_account for a more robust version for browser
})($709b0e48f6b53a82$export$81ab9ba9bd28255c || ($709b0e48f6b53a82$export$81ab9ba9bd28255c = {}));
/**
 * String constants related to AAD Authority
 */ var $709b0e48f6b53a82$export$e18ac120172ed505;
(function(AADAuthorityConstants) {
    AADAuthorityConstants["COMMON"] = "common";
    AADAuthorityConstants["ORGANIZATIONS"] = "organizations";
    AADAuthorityConstants["CONSUMERS"] = "consumers";
})($709b0e48f6b53a82$export$e18ac120172ed505 || ($709b0e48f6b53a82$export$e18ac120172ed505 = {}));
/**
 * Keys in the hashParams sent by AAD Server
 */ var $709b0e48f6b53a82$export$cf7709e7db2ddf5d;
(function(AADServerParamKeys) {
    AADServerParamKeys["CLIENT_ID"] = "client_id";
    AADServerParamKeys["REDIRECT_URI"] = "redirect_uri";
    AADServerParamKeys["RESPONSE_TYPE"] = "response_type";
    AADServerParamKeys["RESPONSE_MODE"] = "response_mode";
    AADServerParamKeys["GRANT_TYPE"] = "grant_type";
    AADServerParamKeys["CLAIMS"] = "claims";
    AADServerParamKeys["SCOPE"] = "scope";
    AADServerParamKeys["ERROR"] = "error";
    AADServerParamKeys["ERROR_DESCRIPTION"] = "error_description";
    AADServerParamKeys["ACCESS_TOKEN"] = "access_token";
    AADServerParamKeys["ID_TOKEN"] = "id_token";
    AADServerParamKeys["REFRESH_TOKEN"] = "refresh_token";
    AADServerParamKeys["EXPIRES_IN"] = "expires_in";
    AADServerParamKeys["STATE"] = "state";
    AADServerParamKeys["NONCE"] = "nonce";
    AADServerParamKeys["PROMPT"] = "prompt";
    AADServerParamKeys["SESSION_STATE"] = "session_state";
    AADServerParamKeys["CLIENT_INFO"] = "client_info";
    AADServerParamKeys["CODE"] = "code";
    AADServerParamKeys["CODE_CHALLENGE"] = "code_challenge";
    AADServerParamKeys["CODE_CHALLENGE_METHOD"] = "code_challenge_method";
    AADServerParamKeys["CODE_VERIFIER"] = "code_verifier";
    AADServerParamKeys["CLIENT_REQUEST_ID"] = "client-request-id";
    AADServerParamKeys["X_CLIENT_SKU"] = "x-client-SKU";
    AADServerParamKeys["X_CLIENT_VER"] = "x-client-VER";
    AADServerParamKeys["X_CLIENT_OS"] = "x-client-OS";
    AADServerParamKeys["X_CLIENT_CPU"] = "x-client-CPU";
    AADServerParamKeys["X_CLIENT_CURR_TELEM"] = "x-client-current-telemetry";
    AADServerParamKeys["X_CLIENT_LAST_TELEM"] = "x-client-last-telemetry";
    AADServerParamKeys["X_MS_LIB_CAPABILITY"] = "x-ms-lib-capability";
    AADServerParamKeys["X_APP_NAME"] = "x-app-name";
    AADServerParamKeys["X_APP_VER"] = "x-app-ver";
    AADServerParamKeys["POST_LOGOUT_URI"] = "post_logout_redirect_uri";
    AADServerParamKeys["ID_TOKEN_HINT"] = "id_token_hint";
    AADServerParamKeys["DEVICE_CODE"] = "device_code";
    AADServerParamKeys["CLIENT_SECRET"] = "client_secret";
    AADServerParamKeys["CLIENT_ASSERTION"] = "client_assertion";
    AADServerParamKeys["CLIENT_ASSERTION_TYPE"] = "client_assertion_type";
    AADServerParamKeys["TOKEN_TYPE"] = "token_type";
    AADServerParamKeys["REQ_CNF"] = "req_cnf";
    AADServerParamKeys["OBO_ASSERTION"] = "assertion";
    AADServerParamKeys["REQUESTED_TOKEN_USE"] = "requested_token_use";
    AADServerParamKeys["ON_BEHALF_OF"] = "on_behalf_of";
    AADServerParamKeys["FOCI"] = "foci";
    AADServerParamKeys["CCS_HEADER"] = "X-AnchorMailbox";
    AADServerParamKeys["RETURN_SPA_CODE"] = "return_spa_code";
    AADServerParamKeys["NATIVE_BROKER"] = "nativebroker";
    AADServerParamKeys["LOGOUT_HINT"] = "logout_hint";
})($709b0e48f6b53a82$export$cf7709e7db2ddf5d || ($709b0e48f6b53a82$export$cf7709e7db2ddf5d = {}));
/**
 * Claims request keys
 */ var $709b0e48f6b53a82$export$c125cda26c71ef54;
(function(ClaimsRequestKeys) {
    ClaimsRequestKeys["ACCESS_TOKEN"] = "access_token";
    ClaimsRequestKeys["XMS_CC"] = "xms_cc";
})($709b0e48f6b53a82$export$c125cda26c71ef54 || ($709b0e48f6b53a82$export$c125cda26c71ef54 = {}));
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ var $709b0e48f6b53a82$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * SSO Types - generated to populate hints
 */ var $709b0e48f6b53a82$export$7f68224783b2bd08;
(function(SSOTypes) {
    SSOTypes["ACCOUNT"] = "account";
    SSOTypes["SID"] = "sid";
    SSOTypes["LOGIN_HINT"] = "login_hint";
    SSOTypes["ID_TOKEN"] = "id_token";
    SSOTypes["DOMAIN_HINT"] = "domain_hint";
    SSOTypes["ORGANIZATIONS"] = "organizations";
    SSOTypes["CONSUMERS"] = "consumers";
    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})($709b0e48f6b53a82$export$7f68224783b2bd08 || ($709b0e48f6b53a82$export$7f68224783b2bd08 = {}));
/**
 * allowed values for codeVerifier
 */ var $709b0e48f6b53a82$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for response_mode
 */ var $709b0e48f6b53a82$export$f990a5bae1260b8c;
(function(ResponseMode) {
    ResponseMode["QUERY"] = "query";
    ResponseMode["FRAGMENT"] = "fragment";
    ResponseMode["FORM_POST"] = "form_post";
})($709b0e48f6b53a82$export$f990a5bae1260b8c || ($709b0e48f6b53a82$export$f990a5bae1260b8c = {}));
/**
 * allowed grant_type
 */ var $709b0e48f6b53a82$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["IMPLICIT_GRANT"] = "implicit";
    GrantType["AUTHORIZATION_CODE_GRANT"] = "authorization_code";
    GrantType["CLIENT_CREDENTIALS_GRANT"] = "client_credentials";
    GrantType["RESOURCE_OWNER_PASSWORD_GRANT"] = "password";
    GrantType["REFRESH_TOKEN_GRANT"] = "refresh_token";
    GrantType["DEVICE_CODE_GRANT"] = "device_code";
    GrantType["JWT_BEARER"] = "urn:ietf:params:oauth:grant-type:jwt-bearer";
})($709b0e48f6b53a82$export$ce68f19b50b39c0b || ($709b0e48f6b53a82$export$ce68f19b50b39c0b = {}));
/**
 * Account types in Cache
 */ var $709b0e48f6b53a82$export$23244fafa2e7f55c;
(function(CacheAccountType) {
    CacheAccountType["MSSTS_ACCOUNT_TYPE"] = "MSSTS";
    CacheAccountType["ADFS_ACCOUNT_TYPE"] = "ADFS";
    CacheAccountType["MSAV1_ACCOUNT_TYPE"] = "MSA";
    CacheAccountType["GENERIC_ACCOUNT_TYPE"] = "Generic"; // NTLM, Kerberos, FBA, Basic etc
})($709b0e48f6b53a82$export$23244fafa2e7f55c || ($709b0e48f6b53a82$export$23244fafa2e7f55c = {}));
/**
 * Separators used in cache
 */ var $709b0e48f6b53a82$export$520854da2ba5d734;
(function(Separators) {
    Separators["CACHE_KEY_SEPARATOR"] = "-";
    Separators["CLIENT_INFO_SEPARATOR"] = ".";
})($709b0e48f6b53a82$export$520854da2ba5d734 || ($709b0e48f6b53a82$export$520854da2ba5d734 = {}));
/**
 * Credential Type stored in the cache
 */ var $709b0e48f6b53a82$export$eca2dc7e6e608a68;
(function(CredentialType) {
    CredentialType["ID_TOKEN"] = "IdToken";
    CredentialType["ACCESS_TOKEN"] = "AccessToken";
    CredentialType["ACCESS_TOKEN_WITH_AUTH_SCHEME"] = "AccessToken_With_AuthScheme";
    CredentialType["REFRESH_TOKEN"] = "RefreshToken";
})($709b0e48f6b53a82$export$eca2dc7e6e608a68 || ($709b0e48f6b53a82$export$eca2dc7e6e608a68 = {}));
/**
 * Combine all cache types
 */ var $709b0e48f6b53a82$export$ba193b555633db78;
(function(CacheType) {
    CacheType[CacheType["ADFS"] = 1001] = "ADFS";
    CacheType[CacheType["MSA"] = 1002] = "MSA";
    CacheType[CacheType["MSSTS"] = 1003] = "MSSTS";
    CacheType[CacheType["GENERIC"] = 1004] = "GENERIC";
    CacheType[CacheType["ACCESS_TOKEN"] = 2001] = "ACCESS_TOKEN";
    CacheType[CacheType["REFRESH_TOKEN"] = 2002] = "REFRESH_TOKEN";
    CacheType[CacheType["ID_TOKEN"] = 2003] = "ID_TOKEN";
    CacheType[CacheType["APP_METADATA"] = 3001] = "APP_METADATA";
    CacheType[CacheType["UNDEFINED"] = 9999] = "UNDEFINED";
})($709b0e48f6b53a82$export$ba193b555633db78 || ($709b0e48f6b53a82$export$ba193b555633db78 = {}));
/**
 * More Cache related constants
 */ var $709b0e48f6b53a82$export$7e1bea6dc1b6b32e = "appmetadata";
var $709b0e48f6b53a82$export$476989d62bcb4c85 = "client_info";
var $709b0e48f6b53a82$export$978fe7ab5e74b539 = "1";
var $709b0e48f6b53a82$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400 // 24 Hours
};
var $709b0e48f6b53a82$export$5d365d77acfcb55d;
(function(AuthorityMetadataSource) {
    AuthorityMetadataSource["CONFIG"] = "config";
    AuthorityMetadataSource["CACHE"] = "cache";
    AuthorityMetadataSource["NETWORK"] = "network";
    AuthorityMetadataSource["HARDCODED_VALUES"] = "hardcoded_values";
})($709b0e48f6b53a82$export$5d365d77acfcb55d || ($709b0e48f6b53a82$export$5d365d77acfcb55d = {}));
var $709b0e48f6b53a82$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ var $709b0e48f6b53a82$export$901491a717da2ba5;
(function(AuthenticationScheme) {
    AuthenticationScheme["BEARER"] = "Bearer";
    AuthenticationScheme["POP"] = "pop";
    AuthenticationScheme["SSH"] = "ssh-cert";
})($709b0e48f6b53a82$export$901491a717da2ba5 || ($709b0e48f6b53a82$export$901491a717da2ba5 = {}));
/**
 * Constants related to throttling
 */ var $709b0e48f6b53a82$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
var $709b0e48f6b53a82$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ var $709b0e48f6b53a82$export$fa8b29062cab1da;
(function(PasswordGrantConstants) {
    PasswordGrantConstants["username"] = "username";
    PasswordGrantConstants["password"] = "password";
})($709b0e48f6b53a82$export$fa8b29062cab1da || ($709b0e48f6b53a82$export$fa8b29062cab1da = {}));
/**
 * Response codes
 */ var $709b0e48f6b53a82$export$20ba0879771a17be;
(function(ResponseCodes) {
    ResponseCodes[ResponseCodes["httpSuccess"] = 200] = "httpSuccess";
    ResponseCodes[ResponseCodes["httpBadRequest"] = 400] = "httpBadRequest";
})($709b0e48f6b53a82$export$20ba0879771a17be || ($709b0e48f6b53a82$export$20ba0879771a17be = {}));
/**
 * Region Discovery Sources
 */ var $709b0e48f6b53a82$export$3d4a3e11df589b40;
(function(RegionDiscoverySources) {
    RegionDiscoverySources["FAILED_AUTO_DETECTION"] = "1";
    RegionDiscoverySources["INTERNAL_CACHE"] = "2";
    RegionDiscoverySources["ENVIRONMENT_VARIABLE"] = "3";
    RegionDiscoverySources["IMDS"] = "4";
})($709b0e48f6b53a82$export$3d4a3e11df589b40 || ($709b0e48f6b53a82$export$3d4a3e11df589b40 = {}));
/**
 * Region Discovery Outcomes
 */ var $709b0e48f6b53a82$export$92a685f9218422bd;
(function(RegionDiscoveryOutcomes) {
    RegionDiscoveryOutcomes["CONFIGURED_MATCHES_DETECTED"] = "1";
    RegionDiscoveryOutcomes["CONFIGURED_NO_AUTO_DETECTION"] = "2";
    RegionDiscoveryOutcomes["CONFIGURED_NOT_DETECTED"] = "3";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_SUCCESSFUL"] = "4";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_FAILED"] = "5";
})($709b0e48f6b53a82$export$92a685f9218422bd || ($709b0e48f6b53a82$export$92a685f9218422bd = {}));
var $709b0e48f6b53a82$export$aa4af185ea049f6b;
(function(CacheOutcome) {
    CacheOutcome["NO_CACHE_HIT"] = "0";
    CacheOutcome["FORCE_REFRESH"] = "1";
    CacheOutcome["NO_CACHED_ACCESS_TOKEN"] = "2";
    CacheOutcome["CACHED_ACCESS_TOKEN_EXPIRED"] = "3";
    CacheOutcome["REFRESH_CACHED_ACCESS_TOKEN"] = "4";
    CacheOutcome["CLAIMS_REQUESTED_CACHE_SKIPPED"] = "5";
})($709b0e48f6b53a82$export$aa4af185ea049f6b || ($709b0e48f6b53a82$export$aa4af185ea049f6b = {}));
var $709b0e48f6b53a82$export$70dd17b99a838729;
(function(JsonTypes) {
    JsonTypes["Jwt"] = "JWT";
    JsonTypes["Jwk"] = "JWK";
    JsonTypes["Pop"] = "pop";
})($709b0e48f6b53a82$export$70dd17b99a838729 || ($709b0e48f6b53a82$export$70dd17b99a838729 = {}));
var $709b0e48f6b53a82$export$14c29d43b22a755f = 86400000;

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ var $a207a6b3d34d3093$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: "unexpected_error",
        desc: "Unexpected error in authentication."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ var $a207a6b3d34d3093$export$145273558d58e0ac = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(AuthError, _super);
    function AuthError(errorCode, errorMessage, suberror) {
        var _this = this;
        var errorString = errorMessage ? errorCode + ": " + errorMessage : errorCode;
        _this = _super.call(this, errorString) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.errorCode = errorCode || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.errorMessage = errorMessage || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.subError = suberror || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.name = "AuthError";
        return _this;
    }
    AuthError.prototype.setCorrelationId = function(correlationId) {
        this.correlationId = correlationId;
    };
    /**
     * Creates an error that is thrown when something unexpected happens in the library.
     * @param errDesc
     */ AuthError.createUnexpectedError = function(errDesc) {
        return new AuthError($a207a6b3d34d3093$export$930cbd4733f218f0.unexpectedError.code, $a207a6b3d34d3093$export$930cbd4733f218f0.unexpectedError.desc + ": " + errDesc);
    };
    /**
     * Creates an error for post request failures.
     * @param errDesc
     * @returns
     */ AuthError.createPostRequestFailed = function(errDesc) {
        return new AuthError($a207a6b3d34d3093$export$930cbd4733f218f0.postRequestFailed.code, $a207a6b3d34d3093$export$930cbd4733f218f0.postRequestFailed.desc + ": " + errDesc);
    };
    return AuthError;
}(Error);


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ var $2d9ea0d849f19272$export$e16d6a6c677acec5 = [
    "interaction_required",
    "consent_required",
    "login_required"
];
var $2d9ea0d849f19272$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required"
];
/**
 * Interaction required errors defined by the SDK
 */ var $2d9ea0d849f19272$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No refresh token found in the cache. Please sign-in."
    },
    native_account_unavailable: {
        code: "native_account_unavailable",
        desc: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API."
    }
};
/**
 * Error thrown when user interaction is required.
 */ var $2d9ea0d849f19272$export$6ba3e818c6bc76ba = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(InteractionRequiredAuthError, _super);
    function InteractionRequiredAuthError(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
        _this.timestamp = timestamp || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.traceId = traceId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.correlationId = correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.claims = claims || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        _this.name = "InteractionRequiredAuthError";
        return _this;
    }
    /**
     * Helper function used to determine if an error thrown by the server requires interaction to resolve
     * @param errorCode
     * @param errorString
     * @param subError
     */ InteractionRequiredAuthError.isInteractionRequiredError = function(errorCode, errorString, subError) {
        var isInteractionRequiredErrorCode = !!errorCode && $2d9ea0d849f19272$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
        var isInteractionRequiredSubError = !!subError && $2d9ea0d849f19272$export$9689959ec6716811.indexOf(subError) > -1;
        var isInteractionRequiredErrorDesc = !!errorString && $2d9ea0d849f19272$export$e16d6a6c677acec5.some(function(irErrorCode) {
            return errorString.indexOf(irErrorCode) > -1;
        });
        return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
    };
    /**
     * Creates an error thrown when the authorization code required for a token request is null or empty.
     */ InteractionRequiredAuthError.createNoTokensFoundError = function() {
        return new InteractionRequiredAuthError($2d9ea0d849f19272$export$d44d3b7b7a580eb6.noTokensFoundError.code, $2d9ea0d849f19272$export$d44d3b7b7a580eb6.noTokensFoundError.desc);
    };
    /**
     * Creates an error thrown when the native broker returns ACCOUNT_UNAVAILABLE status, indicating that the account was removed and interactive sign-in is required
     * @returns
     */ InteractionRequiredAuthError.createNativeAccountUnavailableError = function() {
        return new InteractionRequiredAuthError($2d9ea0d849f19272$export$d44d3b7b7a580eb6.native_account_unavailable.code, $2d9ea0d849f19272$export$d44d3b7b7a580eb6.native_account_unavailable.desc);
    };
    return InteractionRequiredAuthError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));

/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ var $c1ca1b67a2077729$export$2f2811a3e1b21823;
(function(PerformanceEvents) {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ PerformanceEvents["AcquireTokenByCode"] = "acquireTokenByCode";
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ PerformanceEvents["AcquireTokenByRefreshToken"] = "acquireTokenByRefreshToken";
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ PerformanceEvents["AcquireTokenSilent"] = "acquireTokenSilent";
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ PerformanceEvents["AcquireTokenSilentAsync"] = "acquireTokenSilentAsync";
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ PerformanceEvents["AcquireTokenPopup"] = "acquireTokenPopup";
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ PerformanceEvents["CryptoOptsGetPublicKeyThumbprint"] = "cryptoOptsGetPublicKeyThumbprint";
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ PerformanceEvents["CryptoOptsSignJwt"] = "cryptoOptsSignJwt";
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ PerformanceEvents["SilentCacheClientAcquireToken"] = "silentCacheClientAcquireToken";
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ PerformanceEvents["SilentIframeClientAcquireToken"] = "silentIframeClientAcquireToken";
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ PerformanceEvents["SilentRefreshClientAcquireToken"] = "silentRefreshClientAcquireToken";
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ PerformanceEvents["SsoSilent"] = "ssoSilent";
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ PerformanceEvents["StandardInteractionClientGetDiscoveredAuthority"] = "standardInteractionClientGetDiscoveredAuthority";
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ PerformanceEvents["FetchAccountIdWithNativeBroker"] = "fetchAccountIdWithNativeBroker";
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ PerformanceEvents["NativeInteractionClientAcquireToken"] = "nativeInteractionClientAcquireToken";
    /**
     * Time spent creating default headers for requests to token endpoint
     */ PerformanceEvents["BaseClientCreateTokenRequestHeaders"] = "baseClientCreateTokenRequestHeaders";
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ PerformanceEvents["BrokerHandhshake"] = "brokerHandshake";
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ PerformanceEvents["AcquireTokenByRefreshTokenInBroker"] = "acquireTokenByRefreshTokenInBroker";
    /**
     * Time taken for token acquisition by broker
     */ PerformanceEvents["AcquireTokenByBroker"] = "acquireTokenByBroker";
    /**
     * Time spent on the network for refresh token acquisition
     */ PerformanceEvents["RefreshTokenClientExecuteTokenRequest"] = "refreshTokenClientExecuteTokenRequest";
    /**
     * Time taken for acquiring refresh token , records RT size
     */ PerformanceEvents["RefreshTokenClientAcquireToken"] = "refreshTokenClientAcquireToken";
    /**
     * Time taken for acquiring cached refresh token
     */ PerformanceEvents["RefreshTokenClientAcquireTokenWithCachedRefreshToken"] = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ PerformanceEvents["RefreshTokenClientAcquireTokenByRefreshToken"] = "refreshTokenClientAcquireTokenByRefreshToken";
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ PerformanceEvents["RefreshTokenClientCreateTokenRequestBody"] = "refreshTokenClientCreateTokenRequestBody";
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ PerformanceEvents["AcquireTokenFromCache"] = "acquireTokenFromCache";
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ PerformanceEvents["AcquireTokenBySilentIframe"] = "acquireTokenBySilentIframe";
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ PerformanceEvents["InitializeBaseRequest"] = "initializeBaseRequest";
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ PerformanceEvents["InitializeSilentRequest"] = "initializeSilentRequest";
    PerformanceEvents["InitializeClientApplication"] = "initializeClientApplication";
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ PerformanceEvents["SilentIframeClientTokenHelper"] = "silentIframeClientTokenHelper";
    /**
     * SilentHandler
     */ PerformanceEvents["SilentHandlerInitiateAuthRequest"] = "silentHandlerInitiateAuthRequest";
    PerformanceEvents["SilentHandlerMonitorIframeForHash"] = "silentHandlerMonitorIframeForHash";
    PerformanceEvents["SilentHandlerLoadFrame"] = "silentHandlerLoadFrame";
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ PerformanceEvents["StandardInteractionClientCreateAuthCodeClient"] = "standardInteractionClientCreateAuthCodeClient";
    PerformanceEvents["StandardInteractionClientGetClientConfiguration"] = "standardInteractionClientGetClientConfiguration";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationRequest"] = "standardInteractionClientInitializeAuthorizationRequest";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationCodeRequest"] = "standardInteractionClientInitializeAuthorizationCodeRequest";
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ PerformanceEvents["GetAuthCodeUrl"] = "getAuthCodeUrl";
    /**
     * Functions from InteractionHandler (msal-browser)
     */ PerformanceEvents["HandleCodeResponseFromServer"] = "handleCodeResponseFromServer";
    PerformanceEvents["HandleCodeResponseFromHash"] = "handleCodeResponseFromHash";
    PerformanceEvents["UpdateTokenEndpointAuthority"] = "updateTokenEndpointAuthority";
    /**
     * APIs in Authorization Code Client (msal-common)
     */ PerformanceEvents["AuthClientAcquireToken"] = "authClientAcquireToken";
    PerformanceEvents["AuthClientExecuteTokenRequest"] = "authClientExecuteTokenRequest";
    PerformanceEvents["AuthClientCreateTokenRequestBody"] = "authClientCreateTokenRequestBody";
    PerformanceEvents["AuthClientCreateQueryString"] = "authClientCreateQueryString";
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PerformanceEvents["PopTokenGenerateCnf"] = "popTokenGenerateCnf";
    PerformanceEvents["PopTokenGenerateKid"] = "popTokenGenerateKid";
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ PerformanceEvents["HandleServerTokenResponse"] = "handleServerTokenResponse";
    /**
     * Authority functions
     */ PerformanceEvents["AuthorityFactoryCreateDiscoveredInstance"] = "authorityFactoryCreateDiscoveredInstance";
    PerformanceEvents["AuthorityResolveEndpointsAsync"] = "authorityResolveEndpointsAsync";
    PerformanceEvents["AuthorityGetCloudDiscoveryMetadataFromNetwork"] = "authorityGetCloudDiscoveryMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateCloudDiscoveryMetadata"] = "authorityUpdateCloudDiscoveryMetadata";
    PerformanceEvents["AuthorityGetEndpointMetadataFromNetwork"] = "authorityGetEndpointMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateEndpointMetadata"] = "authorityUpdateEndpointMetadata";
    PerformanceEvents["AuthorityUpdateMetadataWithRegionalInformation"] = "authorityUpdateMetadataWithRegionalInformation";
    /**
     * Region Discovery functions
     */ PerformanceEvents["RegionDiscoveryDetectRegion"] = "regionDiscoveryDetectRegion";
    PerformanceEvents["RegionDiscoveryGetRegionFromIMDS"] = "regionDiscoveryGetRegionFromIMDS";
    PerformanceEvents["RegionDiscoveryGetCurrentVersion"] = "regionDiscoveryGetCurrentVersion";
    PerformanceEvents["AcquireTokenByCodeAsync"] = "acquireTokenByCodeAsync";
    PerformanceEvents["GetEndpointMetadataFromNetwork"] = "getEndpointMetadataFromNetwork";
    PerformanceEvents["GetCloudDiscoveryMetadataFromNetworkMeasurement"] = "getCloudDiscoveryMetadataFromNetworkMeasurement";
    PerformanceEvents["HandleRedirectPromiseMeasurement"] = "handleRedirectPromiseMeasurement";
    PerformanceEvents["UpdateCloudDiscoveryMetadataMeasurement"] = "updateCloudDiscoveryMetadataMeasurement";
    PerformanceEvents["UsernamePasswordClientAcquireToken"] = "usernamePasswordClientAcquireToken";
    PerformanceEvents["NativeMessageHandlerHandshake"] = "nativeMessageHandlerHandshake";
    /**
     * Cache operations
     */ PerformanceEvents["ClearTokensAndKeysWithClaims"] = "clearTokensAndKeysWithClaims";
})($c1ca1b67a2077729$export$2f2811a3e1b21823 || ($c1ca1b67a2077729$export$2f2811a3e1b21823 = {}));
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ var $c1ca1b67a2077729$export$bc3547c8ae7b1db;
(function(PerformanceEventStatus) {
    PerformanceEventStatus[PerformanceEventStatus["NotStarted"] = 0] = "NotStarted";
    PerformanceEventStatus[PerformanceEventStatus["InProgress"] = 1] = "InProgress";
    PerformanceEventStatus[PerformanceEventStatus["Completed"] = 2] = "Completed";
})($c1ca1b67a2077729$export$bc3547c8ae7b1db || ($c1ca1b67a2077729$export$bc3547c8ae7b1db = {}));
var $c1ca1b67a2077729$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status"
]);

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ var $18269c32984fce6f$export$ea52035eac03daf0 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(ServerError, _super);
    function ServerError(errorCode, errorMessage, subError) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        _this.name = "ServerError";
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    return ServerError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ var $0f344e7ceaf1df75$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
var $0f344e7ceaf1df75$export$fec113838800867f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
var $0f344e7ceaf1df75$export$3536098be6c7dadb;
(function(NativeExtensionMethod) {
    NativeExtensionMethod["HandshakeRequest"] = "Handshake";
    NativeExtensionMethod["HandshakeResponse"] = "HandshakeResponse";
    NativeExtensionMethod["GetToken"] = "GetToken";
    NativeExtensionMethod["Response"] = "Response";
})($0f344e7ceaf1df75$export$3536098be6c7dadb || ($0f344e7ceaf1df75$export$3536098be6c7dadb = {}));
var $0f344e7ceaf1df75$export$573384e47a12d835;
(function(BrowserCacheLocation) {
    BrowserCacheLocation["LocalStorage"] = "localStorage";
    BrowserCacheLocation["SessionStorage"] = "sessionStorage";
    BrowserCacheLocation["MemoryStorage"] = "memoryStorage";
})($0f344e7ceaf1df75$export$573384e47a12d835 || ($0f344e7ceaf1df75$export$573384e47a12d835 = {}));
/**
 * HTTP Request types supported by MSAL.
 */ var $0f344e7ceaf1df75$export$c774c31b4c31da8;
(function(HTTP_REQUEST_TYPE) {
    HTTP_REQUEST_TYPE["GET"] = "GET";
    HTTP_REQUEST_TYPE["POST"] = "POST";
})($0f344e7ceaf1df75$export$c774c31b4c31da8 || ($0f344e7ceaf1df75$export$c774c31b4c31da8 = {}));
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ var $0f344e7ceaf1df75$export$21d55bedf0d269fb;
(function(TemporaryCacheKeys) {
    TemporaryCacheKeys["AUTHORITY"] = "authority";
    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireToken.account";
    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
    TemporaryCacheKeys["REQUEST_STATE"] = "request.state";
    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.id_token";
    TemporaryCacheKeys["ORIGIN_URI"] = "request.origin";
    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
    TemporaryCacheKeys["URL_HASH"] = "urlHash";
    TemporaryCacheKeys["REQUEST_PARAMS"] = "request.params";
    TemporaryCacheKeys["SCOPES"] = "scopes";
    TemporaryCacheKeys["INTERACTION_STATUS_KEY"] = "interaction.status";
    TemporaryCacheKeys["CCS_CREDENTIAL"] = "ccs.credential";
    TemporaryCacheKeys["CORRELATION_ID"] = "request.correlationId";
    TemporaryCacheKeys["NATIVE_REQUEST"] = "request.native";
    TemporaryCacheKeys["REDIRECT_CONTEXT"] = "request.redirect.context";
})($0f344e7ceaf1df75$export$21d55bedf0d269fb || ($0f344e7ceaf1df75$export$21d55bedf0d269fb = {}));
var $0f344e7ceaf1df75$export$f6ce23cce692699f;
(function(StaticCacheKeys) {
    StaticCacheKeys["ACCOUNT_KEYS"] = "msal.account.keys";
    StaticCacheKeys["TOKEN_KEYS"] = "msal.token.keys";
})($0f344e7ceaf1df75$export$f6ce23cce692699f || ($0f344e7ceaf1df75$export$f6ce23cce692699f = {}));
/**
 * Cache keys stored in-memory
 */ var $0f344e7ceaf1df75$export$8f546f90896bcfa9;
(function(InMemoryCacheKeys) {
    InMemoryCacheKeys["WRAPPER_SKU"] = "wrapper.sku";
    InMemoryCacheKeys["WRAPPER_VER"] = "wrapper.version";
})($0f344e7ceaf1df75$export$8f546f90896bcfa9 || ($0f344e7ceaf1df75$export$8f546f90896bcfa9 = {}));
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ var $0f344e7ceaf1df75$export$192d74ad69b40705;
(function(ApiId) {
    ApiId[ApiId["acquireTokenRedirect"] = 861] = "acquireTokenRedirect";
    ApiId[ApiId["acquireTokenPopup"] = 862] = "acquireTokenPopup";
    ApiId[ApiId["ssoSilent"] = 863] = "ssoSilent";
    ApiId[ApiId["acquireTokenSilent_authCode"] = 864] = "acquireTokenSilent_authCode";
    ApiId[ApiId["handleRedirectPromise"] = 865] = "handleRedirectPromise";
    ApiId[ApiId["acquireTokenByCode"] = 866] = "acquireTokenByCode";
    ApiId[ApiId["acquireTokenSilent_silentFlow"] = 61] = "acquireTokenSilent_silentFlow";
    ApiId[ApiId["logout"] = 961] = "logout";
    ApiId[ApiId["logoutPopup"] = 962] = "logoutPopup";
})($0f344e7ceaf1df75$export$192d74ad69b40705 || ($0f344e7ceaf1df75$export$192d74ad69b40705 = {}));
/*
 * Interaction type of the API - used for state and telemetry
 */ var $0f344e7ceaf1df75$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($0f344e7ceaf1df75$export$4ec29255e7e7f68f || ($0f344e7ceaf1df75$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ var $0f344e7ceaf1df75$export$bec20eda0179362b;
(function(InteractionStatus) {
    /**
     * Initial status before interaction occurs
     */ InteractionStatus["Startup"] = "startup";
    /**
     * Status set when all login calls occuring
     */ InteractionStatus["Login"] = "login";
    /**
     * Status set when logout call occuring
     */ InteractionStatus["Logout"] = "logout";
    /**
     * Status set for acquireToken calls
     */ InteractionStatus["AcquireToken"] = "acquireToken";
    /**
     * Status set for ssoSilent calls
     */ InteractionStatus["SsoSilent"] = "ssoSilent";
    /**
     * Status set when handleRedirect in progress
     */ InteractionStatus["HandleRedirect"] = "handleRedirect";
    /**
     * Status set when interaction is complete
     */ InteractionStatus["None"] = "none";
})($0f344e7ceaf1df75$export$bec20eda0179362b || ($0f344e7ceaf1df75$export$bec20eda0179362b = {}));
var $0f344e7ceaf1df75$export$7e12949cd6884193 = {
    scopes: (0, $709b0e48f6b53a82$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ var $0f344e7ceaf1df75$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
var $0f344e7ceaf1df75$export$8abb9de997bb4e44;
(function(WrapperSKU) {
    WrapperSKU["React"] = "@azure/msal-react";
    WrapperSKU["Angular"] = "@azure/msal-angular";
})($0f344e7ceaf1df75$export$8abb9de997bb4e44 || ($0f344e7ceaf1df75$export$8abb9de997bb4e44 = {}));
// DatabaseStorage Constants
var $0f344e7ceaf1df75$export$3c22ff8b64b8f565 = "msal.db";
var $0f344e7ceaf1df75$export$6a9022b4c5fcea02 = 1;
var $0f344e7ceaf1df75$export$9d785db034fb436f = $0f344e7ceaf1df75$export$3c22ff8b64b8f565 + ".keys";
var $0f344e7ceaf1df75$export$4394baa7e922d42d;
(function(CacheLookupPolicy) {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ CacheLookupPolicy[CacheLookupPolicy["Default"] = 0] = "Default";
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ CacheLookupPolicy[CacheLookupPolicy["AccessToken"] = 1] = "AccessToken";
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ CacheLookupPolicy[CacheLookupPolicy["AccessTokenAndRefreshToken"] = 2] = "AccessTokenAndRefreshToken";
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ CacheLookupPolicy[CacheLookupPolicy["RefreshToken"] = 3] = "RefreshToken";
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ CacheLookupPolicy[CacheLookupPolicy["RefreshTokenAndNetwork"] = 4] = "RefreshTokenAndNetwork";
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ CacheLookupPolicy[CacheLookupPolicy["Skip"] = 5] = "Skip";
})($0f344e7ceaf1df75$export$4394baa7e922d42d || ($0f344e7ceaf1df75$export$4394baa7e922d42d = {}));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ /*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $d75ac04924415c22$export$7d28d6e0c10c5bab = {
    missingKidError: {
        code: "missing_kid_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided."
    },
    missingAlgError: {
        code: "missing_alg_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ var $d75ac04924415c22$export$980ad46b7a115fad = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(JoseHeaderError, _super);
    function JoseHeaderError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "JoseHeaderError";
        Object.setPrototypeOf(_this, JoseHeaderError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when keyId isn't set on JOSE header.
     */ JoseHeaderError.createMissingKidError = function() {
        return new JoseHeaderError($d75ac04924415c22$export$7d28d6e0c10c5bab.missingKidError.code, $d75ac04924415c22$export$7d28d6e0c10c5bab.missingKidError.desc);
    };
    /**
     * Creates an error thrown when algorithm isn't set on JOSE header.
     */ JoseHeaderError.createMissingAlgError = function() {
        return new JoseHeaderError($d75ac04924415c22$export$7d28d6e0c10c5bab.missingAlgError.code, $d75ac04924415c22$export$7d28d6e0c10c5bab.missingAlgError.desc);
    };
    return JoseHeaderError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $e27b4fc303942e21$export$91748d132e6cb9b3 = /** @class */ function() {
    function JoseHeader(options) {
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ JoseHeader.getShrHeaderString = function(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $d75ac04924415c22$export$980ad46b7a115fad).createMissingKidError();
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $d75ac04924415c22$export$980ad46b7a115fad).createMissingAlgError();
        var shrHeader = new JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $709b0e48f6b53a82$export$70dd17b99a838729).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    };
    return JoseHeader;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class for math specific functions in browser.
 */ var $d5728265d3667971$export$6a7ef315a0d1ef07 = /** @class */ function() {
    function MathUtils() {}
    /**
     * Decimal to Hex
     *
     * @param num
     */ MathUtils.decimalToHex = function(num) {
        var hex = num.toString(16);
        while(hex.length < 2)hex = "0" + hex;
        return hex;
    };
    return MathUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $ca5806521448c4be$export$62dc58eaf2cdc52 = /** @class */ function() {
    function GuidGenerator(cryptoObj) {
        this.cryptoObj = cryptoObj;
    }
    /*
     * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
     * pseudo-random numbers.
     * The algorithm is as follows:
     *     Set the two most significant bits (bits 6 and 7) of the
     *        clock_seq_hi_and_reserved to zero and one, respectively.
     *     Set the four most significant bits (bits 12 through 15) of the
     *        time_hi_and_version field to the 4-bit version number from
     *        Section 4.1.3. Version4
     *     Set all the other bits to randomly (or pseudo-randomly) chosen
     *     values.
     * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
     * time-low               = 4hexOctet
     * time-mid               = 2hexOctet
     * time-high-and-version  = 2hexOctet
     * clock-seq-and-reserved = hexOctet:
     * clock-seq-low          = hexOctet
     * node                   = 6hexOctet
     * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
     * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
     * y values are 8, 9, A, B
     */ GuidGenerator.prototype.generateGuid = function() {
        try {
            var buffer = new Uint8Array(16);
            this.cryptoObj.getRandomValues(buffer);
            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
            return (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[0]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[1]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[2]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[3]) + "-" + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[4]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[5]) + "-" + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[6]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[7]) + "-" + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[8]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[9]) + "-" + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[10]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[11]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[12]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[13]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[14]) + (0, $d5728265d3667971$export$6a7ef315a0d1ef07).decimalToHex(buffer[15]);
        } catch (err) {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            for(var i = 0; i < 36; i++){
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") // each x and y needs to be random
                r = Math.random() * 16 | 0;
                if (guidHolder[i] === "x") guidResponse += hex[r];
                else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???
                    guidResponse += hex[r];
                } else guidResponse += guidHolder[i];
            }
            return guidResponse;
        }
    };
    /**
     * verifies if a string is  GUID
     * @param guid
     */ GuidGenerator.prototype.isGuid = function(guid) {
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(guid);
    };
    return GuidGenerator;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for strings in a browser. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $fe7ad92e4391e722$export$27a4bf5378101665 = /** @class */ function() {
    function BrowserStringUtils() {}
    /**
     * Converts string to Uint8Array
     * @param sDOMStr
     */ BrowserStringUtils.stringToUtf8Arr = function(sDOMStr) {
        var nChr;
        var nArrLen = 0;
        var nStrLen = sDOMStr.length;
        /* mapping... */ for(var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++){
            nChr = sDOMStr.charCodeAt(nMapIdx);
            nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
        }
        var aBytes = new Uint8Array(nArrLen);
        /* transcription... */ for(var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++){
            nChr = sDOMStr.charCodeAt(nChrIdx);
            if (nChr < 128) /* one byte */ aBytes[nIdx++] = nChr;
            else if (nChr < 0x800) {
                /* two bytes */ aBytes[nIdx++] = 192 + (nChr >>> 6);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x10000) {
                /* three bytes */ aBytes[nIdx++] = 224 + (nChr >>> 12);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x200000) {
                /* four bytes */ aBytes[nIdx++] = 240 + (nChr >>> 18);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x4000000) {
                /* five bytes */ aBytes[nIdx++] = 248 + (nChr >>> 24);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else /* if (nChr <= 0x7fffffff) */ {
                /* six bytes */ aBytes[nIdx++] = 252 + (nChr >>> 30);
                aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
        }
        return aBytes;
    };
    /**
     * Converst string to ArrayBuffer
     * @param dataString
     */ BrowserStringUtils.stringToArrayBuffer = function(dataString) {
        var data = new ArrayBuffer(dataString.length);
        var dataView = new Uint8Array(data);
        for(var i = 0; i < dataString.length; i++)dataView[i] = dataString.charCodeAt(i);
        return data;
    };
    /**
     * Converts Uint8Array to a string
     * @param aBytes
     */ BrowserStringUtils.utf8ArrToString = function(aBytes) {
        var sView = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        for(var nPart = void 0, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++){
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */ /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */ (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */ (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */ (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */ (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */ (nPart - 192 << 6) + aBytes[++nIdx] - 128 : /* nPart < 127 ? */ /* one byte */ nPart);
        }
        return sView;
    };
    /**
     * Returns stringified jwk.
     * @param jwk
     */ BrowserStringUtils.getSortedObjectString = function(obj) {
        return JSON.stringify(obj, Object.keys(obj).sort());
    };
    return BrowserStringUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $d811768bdff141fb$export$d99f397851818755 = /** @class */ function() {
    function Base64Encode() {}
    /**
     * Returns URL Safe b64 encoded string from a plaintext string.
     * @param input
     */ Base64Encode.prototype.urlEncode = function(input) {
        return encodeURIComponent(this.encode(input).replace(/=/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_"));
    };
    /**
     * Returns URL Safe b64 encoded string from an int8Array.
     * @param inputArr
     */ Base64Encode.prototype.urlEncodeArr = function(inputArr) {
        return this.base64EncArr(inputArr).replace(/=/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_");
    };
    /**
     * Returns b64 encoded string from plaintext string.
     * @param input
     */ Base64Encode.prototype.encode = function(input) {
        var inputUtf8Arr = (0, $fe7ad92e4391e722$export$27a4bf5378101665).stringToUtf8Arr(input);
        return this.base64EncArr(inputUtf8Arr);
    };
    /**
     * Base64 encode byte array
     * @param aBytes
     */ Base64Encode.prototype.base64EncArr = function(aBytes) {
        var eqLen = (3 - aBytes.length % 3) % 3;
        var sB64Enc = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        for(var nMod3 = void 0, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++){
            nMod3 = nIdx % 3;
            /* Uncomment the following line in order to split the output in lines 76-character long: */ /*
             *if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
             */ nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                sB64Enc += String.fromCharCode(this.uint6ToB64(nUint24 >>> 18 & 63), this.uint6ToB64(nUint24 >>> 12 & 63), this.uint6ToB64(nUint24 >>> 6 & 63), this.uint6ToB64(nUint24 & 63));
                nUint24 = 0;
            }
        }
        return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
    };
    /**
     * Base64 string to array encoding helper
     * @param nUint6
     */ Base64Encode.prototype.uint6ToB64 = function(nUint6) {
        return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 43 : nUint6 === 63 ? 47 : 65;
    };
    return Base64Encode;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $98dc98c6cc205193$export$fe555b2490ffa3fb = /** @class */ function() {
    function Base64Decode() {}
    /**
     * Returns a URL-safe plaintext decoded string from b64 encoded input.
     * @param input
     */ Base64Decode.prototype.decode = function(input) {
        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
        switch(encodedString.length % 4){
            case 0:
                break;
            case 2:
                encodedString += "==";
                break;
            case 3:
                encodedString += "=";
                break;
            default:
                throw new Error("Invalid base64 string");
        }
        var inputUtf8Arr = this.base64DecToArr(encodedString);
        return (0, $fe7ad92e4391e722$export$27a4bf5378101665).utf8ArrToString(inputUtf8Arr);
    };
    /**
     * Decodes base64 into Uint8Array
     * @param base64String
     * @param nBlockSize
     */ Base64Decode.prototype.base64DecToArr = function(base64String, nBlockSize) {
        var sB64Enc = base64String.replace(/[^A-Za-z0-9\+\/]/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        var nInLen = sB64Enc.length;
        var nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2;
        var aBytes = new Uint8Array(nOutLen);
        for(var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++){
            nMod4 = nInIdx & 3;
            nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
            if (nMod4 === 3 || nInLen - nInIdx === 1) {
                for(nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++)aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                nUint24 = 0;
            }
        }
        return aBytes;
    };
    /**
     * Base64 string to array decoding helper
     * @param charNum
     */ Base64Decode.prototype.b64ToUint6 = function(charNum) {
        return charNum > 64 && charNum < 91 ? charNum - 65 : charNum > 96 && charNum < 123 ? charNum - 71 : charNum > 47 && charNum < 58 ? charNum + 4 : charNum === 43 ? 62 : charNum === 47 ? 63 : 0;
    };
    return Base64Decode;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ /*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $859b00ae06117652$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: "client_info_decoding_error",
        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
    },
    clientInfoEmptyError: {
        code: "client_info_empty_error",
        desc: "The client info was empty. Please review the trace to determine the root cause."
    },
    tokenParsingError: {
        code: "token_parsing_error",
        desc: "Token cannot be parsed. Please review stack trace to determine root cause."
    },
    nullOrEmptyToken: {
        code: "null_or_empty_token",
        desc: "The token is null or empty. Please review the trace to determine the root cause."
    },
    endpointResolutionError: {
        code: "endpoints_resolution_error",
        desc: "Error: could not resolve endpoints. Please check network and try again."
    },
    networkError: {
        code: "network_error",
        desc: "Network request failed. Please check network trace to determine root cause."
    },
    unableToGetOpenidConfigError: {
        code: "openid_config_error",
        desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
    },
    hashNotDeserialized: {
        code: "hash_not_deserialized",
        desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
    },
    blankGuidGenerated: {
        code: "blank_guid_generated",
        desc: "The guid generated was blank. Please review the trace to determine the root cause."
    },
    invalidStateError: {
        code: "invalid_state",
        desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
    },
    stateMismatchError: {
        code: "state_mismatch",
        desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
    },
    stateNotFoundError: {
        code: "state_not_found",
        desc: "State not found"
    },
    nonceMismatchError: {
        code: "nonce_mismatch",
        desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
    },
    nonceNotFoundError: {
        code: "nonce_not_found",
        desc: "nonce not found"
    },
    authTimeNotFoundError: {
        code: "auth_time_not_found",
        desc: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information."
    },
    maxAgeTranspiredError: {
        code: "max_age_transpired",
        desc: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication."
    },
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
    },
    multipleMatchingTokens: {
        code: "multiple_matching_tokens",
        desc: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account."
    },
    multipleMatchingAccounts: {
        code: "multiple_matching_accounts",
        desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
    },
    multipleMatchingAppMetadata: {
        code: "multiple_matching_appMetadata",
        desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
    },
    tokenRequestCannotBeMade: {
        code: "request_cannot_be_made",
        desc: "Token request cannot be made without authorization code or refresh token."
    },
    appendEmptyScopeError: {
        code: "cannot_append_empty_scope",
        desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
    },
    removeEmptyScopeError: {
        code: "cannot_remove_empty_scope",
        desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
    },
    appendScopeSetError: {
        code: "cannot_append_scopeset",
        desc: "Cannot append ScopeSet due to error."
    },
    emptyInputScopeSetError: {
        code: "empty_input_scopeset",
        desc: "Empty input ScopeSet cannot be processed."
    },
    DeviceCodePollingCancelled: {
        code: "device_code_polling_cancelled",
        desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
    },
    DeviceCodeExpired: {
        code: "device_code_expired",
        desc: "Device code is expired."
    },
    DeviceCodeUnknownError: {
        code: "device_code_unknown_error",
        desc: "Device code stopped polling for unknown reasons."
    },
    NoAccountInSilentRequest: {
        code: "no_account_in_silent_request",
        desc: "Please pass an account object, silent flow is not supported without account information"
    },
    invalidCacheRecord: {
        code: "invalid_cache_record",
        desc: "Cache record object was null or undefined."
    },
    invalidCacheEnvironment: {
        code: "invalid_cache_environment",
        desc: "Invalid environment when attempting to create cache entry"
    },
    noAccountFound: {
        code: "no_account_found",
        desc: "No account found in cache for given key."
    },
    CachePluginError: {
        code: "no cache plugin set on CacheManager",
        desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
    },
    noCryptoObj: {
        code: "no_crypto_object",
        desc: "No crypto object detected. This is required for the following operation: "
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    unexpectedAccountType: {
        code: "unexpected_account_type",
        desc: "Unexpected account type."
    },
    unexpectedCredentialType: {
        code: "unexpected_credential_type",
        desc: "Unexpected credential type."
    },
    invalidAssertion: {
        code: "invalid_assertion",
        desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
    },
    invalidClientCredential: {
        code: "invalid_client_credential",
        desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
    },
    tokenRefreshRequired: {
        code: "token_refresh_required",
        desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
    },
    userTimeoutReached: {
        code: "user_timeout_reached",
        desc: "User defined timeout for device code polling reached"
    },
    tokenClaimsRequired: {
        code: "token_claims_cnf_required_for_signedjwt",
        desc: "Cannot generate a POP jwt if the token_claims are not populated"
    },
    noAuthorizationCodeFromServer: {
        code: "authorization_code_missing_from_server_response",
        desc: "Server response does not contain an authorization code to proceed"
    },
    noAzureRegionDetected: {
        code: "no_azure_region_detected",
        desc: "No azure region was detected and no fallback was made available"
    },
    accessTokenEntityNullError: {
        code: "access_token_entity_null",
        desc: "Access token entity is null, please check logs and cache to ensure a valid access token is present."
    },
    bindingKeyNotRemovedError: {
        code: "binding_key_not_removed",
        desc: "Could not remove the credential's binding key from storage."
    },
    logoutNotSupported: {
        code: "end_session_endpoint_not_supported",
        desc: "Provided authority does not support logout."
    },
    keyIdMissing: {
        code: "key_id_missing",
        desc: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key."
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    userCanceledError: {
        code: "user_canceled",
        desc: "User canceled the flow."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ var $859b00ae06117652$export$a839ff85a7957561 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(ClientAuthError, _super);
    function ClientAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientAuthError";
        Object.setPrototypeOf(_this, ClientAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when client info object doesn't decode correctly.
     * @param caughtError
     */ ClientAuthError.createClientInfoDecodingError = function(caughtError) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.clientInfoDecodingError.code, $859b00ae06117652$export$51eee17394e135b.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
    };
    /**
     * Creates an error thrown if the client info is empty.
     * @param rawClientInfo
     */ ClientAuthError.createClientInfoEmptyError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.clientInfoEmptyError.code, "" + $859b00ae06117652$export$51eee17394e135b.clientInfoEmptyError.desc);
    };
    /**
     * Creates an error thrown when the id token extraction errors out.
     * @param err
     */ ClientAuthError.createTokenParsingError = function(caughtExtractionError) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.tokenParsingError.code, $859b00ae06117652$export$51eee17394e135b.tokenParsingError.desc + " Failed with error: " + caughtExtractionError);
    };
    /**
     * Creates an error thrown when the id token string is null or empty.
     * @param invalidRawTokenString
     */ ClientAuthError.createTokenNullOrEmptyError = function(invalidRawTokenString) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.nullOrEmptyToken.code, $859b00ae06117652$export$51eee17394e135b.nullOrEmptyToken.desc + " Raw Token Value: " + invalidRawTokenString);
    };
    /**
     * Creates an error thrown when the endpoint discovery doesn't complete correctly.
     */ ClientAuthError.createEndpointDiscoveryIncompleteError = function(errDetail) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.endpointResolutionError.code, $859b00ae06117652$export$51eee17394e135b.endpointResolutionError.desc + " Detail: " + errDetail);
    };
    /**
     * Creates an error thrown when the fetch client throws
     */ ClientAuthError.createNetworkError = function(endpoint, errDetail) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.networkError.code, $859b00ae06117652$export$51eee17394e135b.networkError.desc + " | Fetch client threw: " + errDetail + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Creates an error thrown when the openid-configuration endpoint cannot be reached or does not contain the required data
     */ ClientAuthError.createUnableToGetOpenidConfigError = function(errDetail) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.unableToGetOpenidConfigError.code, $859b00ae06117652$export$51eee17394e135b.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + errDetail);
    };
    /**
     * Creates an error thrown when the hash cannot be deserialized.
     * @param hashParamObj
     */ ClientAuthError.createHashNotDeserializedError = function(hashParamObj) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.hashNotDeserialized.code, $859b00ae06117652$export$51eee17394e135b.hashNotDeserialized.desc + " Given Object: " + hashParamObj);
    };
    /**
     * Creates an error thrown when the state cannot be parsed.
     * @param invalidState
     */ ClientAuthError.createInvalidStateError = function(invalidState, errorString) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidStateError.code, $859b00ae06117652$export$51eee17394e135b.invalidStateError.desc + " Invalid State: " + invalidState + ", Root Err: " + errorString);
    };
    /**
     * Creates an error thrown when two states do not match.
     */ ClientAuthError.createStateMismatchError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.stateMismatchError.code, $859b00ae06117652$export$51eee17394e135b.stateMismatchError.desc);
    };
    /**
     * Creates an error thrown when the state is not present
     * @param missingState
     */ ClientAuthError.createStateNotFoundError = function(missingState) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.stateNotFoundError.code, $859b00ae06117652$export$51eee17394e135b.stateNotFoundError.desc + ":  " + missingState);
    };
    /**
     * Creates an error thrown when the nonce does not match.
     */ ClientAuthError.createNonceMismatchError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.nonceMismatchError.code, $859b00ae06117652$export$51eee17394e135b.nonceMismatchError.desc);
    };
    /**
     * Creates an error thrown when max_age was provided in the request, but auth_time is not in the token claims
     * @param missingNonce
     */ ClientAuthError.createAuthTimeNotFoundError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.authTimeNotFoundError.code, $859b00ae06117652$export$51eee17394e135b.authTimeNotFoundError.desc);
    };
    /**
     * Creates an error thrown when too much time has elapsed since the last end-user authentication
     */ ClientAuthError.createMaxAgeTranspiredError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.maxAgeTranspiredError.code, $859b00ae06117652$export$51eee17394e135b.maxAgeTranspiredError.desc);
    };
    /**
     * Creates an error thrown when the mnonce is not present
     * @param missingNonce
     */ ClientAuthError.createNonceNotFoundError = function(missingNonce) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.nonceNotFoundError.code, $859b00ae06117652$export$51eee17394e135b.nonceNotFoundError.desc + ":  " + missingNonce);
    };
    /**
     * Throws error when multiple tokens are in cache.
     */ ClientAuthError.createMultipleMatchingTokensInCacheError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.multipleMatchingTokens.code, $859b00ae06117652$export$51eee17394e135b.multipleMatchingTokens.desc + ".");
    };
    /**
     * Throws error when multiple accounts are in cache for the given params
     */ ClientAuthError.createMultipleMatchingAccountsInCacheError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.multipleMatchingAccounts.code, $859b00ae06117652$export$51eee17394e135b.multipleMatchingAccounts.desc);
    };
    /**
     * Throws error when multiple appMetada are in cache for the given clientId.
     */ ClientAuthError.createMultipleMatchingAppMetadataInCacheError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.multipleMatchingAppMetadata.code, $859b00ae06117652$export$51eee17394e135b.multipleMatchingAppMetadata.desc);
    };
    /**
     * Throws error when no auth code or refresh token is given to ServerTokenRequestParameters.
     */ ClientAuthError.createTokenRequestCannotBeMadeError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.tokenRequestCannotBeMade.code, $859b00ae06117652$export$51eee17394e135b.tokenRequestCannotBeMade.desc);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */ ClientAuthError.createAppendEmptyScopeToSetError = function(givenScope) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.appendEmptyScopeError.code, $859b00ae06117652$export$51eee17394e135b.appendEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */ ClientAuthError.createRemoveEmptyScopeFromSetError = function(givenScope) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.removeEmptyScopeError.code, $859b00ae06117652$export$51eee17394e135b.removeEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append null or empty ScopeSet.
     * @param appendError
     */ ClientAuthError.createAppendScopeSetError = function(appendError) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.appendScopeSetError.code, $859b00ae06117652$export$51eee17394e135b.appendScopeSetError.desc + " Detail Error: " + appendError);
    };
    /**
     * Throws error if ScopeSet is null or undefined.
     * @param givenScopeSet
     */ ClientAuthError.createEmptyInputScopeSetError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.emptyInputScopeSetError.code, "" + $859b00ae06117652$export$51eee17394e135b.emptyInputScopeSetError.desc);
    };
    /**
     * Throws error if user sets CancellationToken.cancel = true during polling of token endpoint during device code flow
     */ ClientAuthError.createDeviceCodeCancelledError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.DeviceCodePollingCancelled.code, "" + $859b00ae06117652$export$51eee17394e135b.DeviceCodePollingCancelled.desc);
    };
    /**
     * Throws error if device code is expired
     */ ClientAuthError.createDeviceCodeExpiredError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.DeviceCodeExpired.code, "" + $859b00ae06117652$export$51eee17394e135b.DeviceCodeExpired.desc);
    };
    /**
     * Throws error if device code is expired
     */ ClientAuthError.createDeviceCodeUnknownError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.DeviceCodeUnknownError.code, "" + $859b00ae06117652$export$51eee17394e135b.DeviceCodeUnknownError.desc);
    };
    /**
     * Throws error when silent requests are made without an account object
     */ ClientAuthError.createNoAccountInSilentRequestError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.NoAccountInSilentRequest.code, "" + $859b00ae06117652$export$51eee17394e135b.NoAccountInSilentRequest.desc);
    };
    /**
     * Throws error when cache record is null or undefined.
     */ ClientAuthError.createNullOrUndefinedCacheRecord = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidCacheRecord.code, $859b00ae06117652$export$51eee17394e135b.invalidCacheRecord.desc);
    };
    /**
     * Throws error when provided environment is not part of the CloudDiscoveryMetadata object
     */ ClientAuthError.createInvalidCacheEnvironmentError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidCacheEnvironment.code, $859b00ae06117652$export$51eee17394e135b.invalidCacheEnvironment.desc);
    };
    /**
     * Throws error when account is not found in cache.
     */ ClientAuthError.createNoAccountFoundError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.noAccountFound.code, $859b00ae06117652$export$51eee17394e135b.noAccountFound.desc);
    };
    /**
     * Throws error if ICachePlugin not set on CacheManager.
     */ ClientAuthError.createCachePluginError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.CachePluginError.code, "" + $859b00ae06117652$export$51eee17394e135b.CachePluginError.desc);
    };
    /**
     * Throws error if crypto object not found.
     * @param operationName
     */ ClientAuthError.createNoCryptoObjectError = function(operationName) {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.noCryptoObj.code, "" + $859b00ae06117652$export$51eee17394e135b.noCryptoObj.desc + operationName);
    };
    /**
     * Throws error if cache type is invalid.
     */ ClientAuthError.createInvalidCacheTypeError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidCacheType.code, "" + $859b00ae06117652$export$51eee17394e135b.invalidCacheType.desc);
    };
    /**
     * Throws error if unexpected account type.
     */ ClientAuthError.createUnexpectedAccountTypeError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.unexpectedAccountType.code, "" + $859b00ae06117652$export$51eee17394e135b.unexpectedAccountType.desc);
    };
    /**
     * Throws error if unexpected credential type.
     */ ClientAuthError.createUnexpectedCredentialTypeError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.unexpectedCredentialType.code, "" + $859b00ae06117652$export$51eee17394e135b.unexpectedCredentialType.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */ ClientAuthError.createInvalidAssertionError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidAssertion.code, "" + $859b00ae06117652$export$51eee17394e135b.invalidAssertion.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */ ClientAuthError.createInvalidCredentialError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.invalidClientCredential.code, "" + $859b00ae06117652$export$51eee17394e135b.invalidClientCredential.desc);
    };
    /**
     * Throws error if token cannot be retrieved from cache due to refresh being required.
     */ ClientAuthError.createRefreshRequiredError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.tokenRefreshRequired.code, $859b00ae06117652$export$51eee17394e135b.tokenRefreshRequired.desc);
    };
    /**
     * Throws error if the user defined timeout is reached.
     */ ClientAuthError.createUserTimeoutReachedError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.userTimeoutReached.code, $859b00ae06117652$export$51eee17394e135b.userTimeoutReached.desc);
    };
    /*
     * Throws error if token claims are not populated for a signed jwt generation
     */ ClientAuthError.createTokenClaimsRequiredError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.tokenClaimsRequired.code, $859b00ae06117652$export$51eee17394e135b.tokenClaimsRequired.desc);
    };
    /**
     * Throws error when the authorization code is missing from the server response
     */ ClientAuthError.createNoAuthCodeInServerResponseError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.noAuthorizationCodeFromServer.code, $859b00ae06117652$export$51eee17394e135b.noAuthorizationCodeFromServer.desc);
    };
    ClientAuthError.createBindingKeyNotRemovedError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.bindingKeyNotRemovedError.code, $859b00ae06117652$export$51eee17394e135b.bindingKeyNotRemovedError.desc);
    };
    /**
     * Thrown when logout is attempted for an authority that doesnt have an end_session_endpoint
     */ ClientAuthError.createLogoutNotSupportedError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.logoutNotSupported.code, $859b00ae06117652$export$51eee17394e135b.logoutNotSupported.desc);
    };
    /**
     * Create an error when kid attribute is missing from a PoP token's cache record
     */ ClientAuthError.createKeyIdMissingError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.keyIdMissing.code, $859b00ae06117652$export$51eee17394e135b.keyIdMissing.desc);
    };
    /**
     * Create an error when the client does not have network connectivity
     */ ClientAuthError.createNoNetworkConnectivityError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.noNetworkConnectivity.code, $859b00ae06117652$export$51eee17394e135b.noNetworkConnectivity.desc);
    };
    /**
     * Create an error when the user cancels the flow
     */ ClientAuthError.createUserCanceledError = function() {
        return new ClientAuthError($859b00ae06117652$export$51eee17394e135b.userCanceledError.code, $859b00ae06117652$export$51eee17394e135b.userCanceledError.desc);
    };
    return ClientAuthError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ var $33fadf35800e4b73$export$ecc754f99843e759 = /** @class */ function() {
    function StringUtils() {}
    /**
     * decode a JWT
     *
     * @param authToken
     */ StringUtils.decodeAuthToken = function(authToken) {
        if (StringUtils.isEmpty(authToken)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenNullOrEmptyError(authToken);
        var tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = tokenPartsRegex.exec(authToken);
        if (!matches || matches.length < 4) throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenParsingError("Given token is malformed: " + JSON.stringify(authToken));
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    /**
     * Check if a string is empty.
     *
     * @param str
     */ StringUtils.isEmpty = function(str) {
        return typeof str === "undefined" || !str || 0 === str.length;
    };
    /**
     * Check if stringified object is empty
     * @param strObj
     */ StringUtils.isEmptyObj = function(strObj) {
        if (strObj && !StringUtils.isEmpty(strObj)) try {
            var obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    };
    StringUtils.startsWith = function(str, search) {
        return str.indexOf(search) === 0;
    };
    StringUtils.endsWith = function(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    };
    /**
     * Parses string into an object.
     *
     * @param query
     */ StringUtils.queryStringToObject = function(query) {
        var obj = {};
        var params = query.split("&");
        var decode = function(s) {
            return decodeURIComponent(s.replace(/\+/g, " "));
        };
        params.forEach(function(pair) {
            if (pair.trim()) {
                var _a = pair.split(/=(.+)/g, 2), key = _a[0], value = _a[1]; // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    };
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ StringUtils.trimArrayEntries = function(arr) {
        return arr.map(function(entry) {
            return entry.trim();
        });
    };
    /**
     * Removes empty strings from array
     * @param arr
     */ StringUtils.removeEmptyStringsFromArray = function(arr) {
        return arr.filter(function(entry) {
            return !StringUtils.isEmpty(entry);
        });
    };
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ StringUtils.jsonParseHelper = function(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    };
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ StringUtils.matchPattern = function(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ var regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?")); // eslint-disable-line security/detect-non-literal-regexp
        return regex.test(input);
    };
    return StringUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $52ceb16ced3151d8$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: "pkce_not_created",
        desc: "The PKCE code challenge and verifier could not be generated."
    },
    cryptoDoesNotExist: {
        code: "crypto_nonexistent",
        desc: "The crypto object or function is not available."
    },
    httpMethodNotImplementedError: {
        code: "http_method_not_implemented",
        desc: "The HTTP method given has not been implemented in this library."
    },
    emptyNavigateUriError: {
        code: "empty_navigate_uri",
        desc: "Navigation URI is empty. Please check stack trace for more info."
    },
    hashEmptyError: {
        code: "hash_empty_error",
        desc: "Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    hashDoesNotContainStateError: {
        code: "no_state_in_hash",
        desc: "Hash does not contain state. Please verify that the request originated from msal."
    },
    hashDoesNotContainKnownPropertiesError: {
        code: "hash_does_not_contain_known_properties",
        desc: "Hash does not contain known properites. Please verify that your redirectUri is not changing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    unableToParseStateError: {
        code: "unable_to_parse_state",
        desc: "Unable to parse state. Please verify that the request originated from msal."
    },
    stateInteractionTypeMismatchError: {
        code: "state_interaction_type_mismatch",
        desc: "Hash contains state but the interaction type does not match the caller."
    },
    interactionInProgress: {
        code: "interaction_in_progress",
        desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
    },
    popupWindowError: {
        code: "popup_window_error",
        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
    },
    emptyWindowError: {
        code: "empty_window_error",
        desc: "window.open returned null or undefined window object."
    },
    userCancelledError: {
        code: "user_cancelled",
        desc: "User cancelled the flow."
    },
    monitorPopupTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in popup failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    monitorIframeTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in iframe failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    redirectInIframeError: {
        code: "redirect_in_iframe",
        desc: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
    },
    blockTokenRequestsInHiddenIframeError: {
        code: "block_iframe_reload",
        desc: "Request was blocked inside an iframe because MSAL detected an authentication response. For more visit: aka.ms/msaljs/browser-errors"
    },
    blockAcquireTokenInPopupsError: {
        code: "block_nested_popups",
        desc: "Request was blocked inside a popup because MSAL detected it was running in a popup."
    },
    iframeClosedPrematurelyError: {
        code: "iframe_closed_prematurely",
        desc: "The iframe being monitored was closed prematurely."
    },
    silentLogoutUnsupportedError: {
        code: "silent_logout_unsupported",
        desc: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead."
    },
    noAccountError: {
        code: "no_account_error",
        desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
    },
    silentPromptValueError: {
        code: "silent_prompt_value_error",
        desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'."
    },
    noTokenRequestCacheError: {
        code: "no_token_request_cache_error",
        desc: "No token request found in cache."
    },
    unableToParseTokenRequestCacheError: {
        code: "unable_to_parse_token_request_cache_error",
        desc: "The cached token request could not be parsed."
    },
    noCachedAuthorityError: {
        code: "no_cached_authority_error",
        desc: "No cached authority found."
    },
    authRequestNotSet: {
        code: "auth_request_not_set_error",
        desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    notInBrowserEnvironment: {
        code: "non_browser_environment",
        desc: "Login and token requests are not supported in non-browser environments."
    },
    databaseNotOpen: {
        code: "database_not_open",
        desc: "Database is not open!"
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
    },
    getRequestFailed: {
        code: "get_request_failed",
        desc: "Network request failed. Please check the network trace to determine root cause."
    },
    failedToParseNetworkResponse: {
        code: "failed_to_parse_response",
        desc: "Failed to parse network response. Check network trace."
    },
    unableToLoadTokenError: {
        code: "unable_to_load_token",
        desc: "Error loading token to cache."
    },
    signingKeyNotFoundInStorage: {
        code: "crypto_key_not_found",
        desc: "Cryptographic Key or Keypair not found in browser storage."
    },
    authCodeRequired: {
        code: "auth_code_required",
        desc: "An authorization code must be provided (as the `code` property on the request) to this flow."
    },
    authCodeOrNativeAccountRequired: {
        code: "auth_code_or_nativeAccountId_required",
        desc: "An authorization code or nativeAccountId must be provided to this flow."
    },
    spaCodeAndNativeAccountPresent: {
        code: "spa_code_and_nativeAccountId_present",
        desc: "Request cannot contain both spa code and native account id."
    },
    databaseUnavailable: {
        code: "database_unavailable",
        desc: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts."
    },
    unableToAcquireTokenFromNativePlatform: {
        code: "unable_to_acquire_token_from_native_platform",
        desc: "Unable to acquire token from native platform. For a list of possible reasons visit aka.ms/msaljs/browser-errors."
    },
    nativeHandshakeTimeout: {
        code: "native_handshake_timeout",
        desc: "Timed out while attempting to establish connection to browser extension"
    },
    nativeExtensionNotInstalled: {
        code: "native_extension_not_installed",
        desc: "Native extension is not installed. If you think this is a mistake call the initialize function."
    },
    nativeConnectionNotEstablished: {
        code: "native_connection_not_established",
        desc: "Connection to native platform has not been established. Please install a compatible browser extension and run initialize(). For more please visit aka.ms/msaljs/browser-errors."
    },
    nativeBrokerCalledBeforeInitialize: {
        code: "native_broker_called_before_initialize",
        desc: "You must call and await the initialize function before attempting to call any other MSAL API when native brokering is enabled. For more please visit aka.ms/msaljs/browser-errors."
    },
    nativePromptNotSupported: {
        code: "native_prompt_not_supported",
        desc: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ var $52ceb16ced3151d8$export$f8eb6760ca13876a = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(BrowserAuthError, _super);
    function BrowserAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        Object.setPrototypeOf(_this, BrowserAuthError.prototype);
        _this.name = "BrowserAuthError";
        return _this;
    }
    /**
     * Creates an error thrown when PKCE is not implemented.
     * @param errDetail
     */ BrowserAuthError.createPkceNotGeneratedError = function(errDetail) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.pkceNotGenerated.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.pkceNotGenerated.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when the crypto object is unavailable.
     * @param errDetail
     */ BrowserAuthError.createCryptoNotAvailableError = function(errDetail) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.cryptoDoesNotExist.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.cryptoDoesNotExist.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when an HTTP method hasn't been implemented by the browser class.
     * @param method
     */ BrowserAuthError.createHttpMethodNotImplementedError = function(method) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.httpMethodNotImplementedError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.httpMethodNotImplementedError.desc + " Given Method: " + method);
    };
    /**
     * Creates an error thrown when the navigation URI is empty.
     */ BrowserAuthError.createEmptyNavigationUriError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.emptyNavigateUriError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.emptyNavigateUriError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     * @param hashValue
     */ BrowserAuthError.createEmptyHashError = function(hashValue) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.hashEmptyError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.hashEmptyError.desc + " Given Url: " + hashValue);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */ BrowserAuthError.createHashDoesNotContainStateError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.hashDoesNotContainStateError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.hashDoesNotContainStateError.desc);
    };
    /**
     * Creates an error thrown when the hash string value does not contain known properties
     */ BrowserAuthError.createHashDoesNotContainKnownPropertiesError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.hashDoesNotContainKnownPropertiesError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.hashDoesNotContainKnownPropertiesError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */ BrowserAuthError.createUnableToParseStateError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToParseStateError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToParseStateError.desc);
    };
    /**
     * Creates an error thrown when the state value in the hash does not match the interaction type of the API attempting to consume it.
     */ BrowserAuthError.createStateInteractionTypeMismatchError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.stateInteractionTypeMismatchError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.stateInteractionTypeMismatchError.desc);
    };
    /**
     * Creates an error thrown when a browser interaction (redirect or popup) is in progress.
     */ BrowserAuthError.createInteractionInProgressError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.interactionInProgress.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.interactionInProgress.desc);
    };
    /**
     * Creates an error thrown when the popup window could not be opened.
     * @param errDetail
     */ BrowserAuthError.createPopupWindowError = function(errDetail) {
        var errorMessage = $52ceb16ced3151d8$export$6deffaef56f0bd5a.popupWindowError.desc;
        errorMessage = !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(errDetail) ? errorMessage + " Details: " + errDetail : errorMessage;
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.popupWindowError.code, errorMessage);
    };
    /**
     * Creates an error thrown when window.open returns an empty window object.
     * @param errDetail
     */ BrowserAuthError.createEmptyWindowCreatedError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.emptyWindowError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.emptyWindowError.desc);
    };
    /**
     * Creates an error thrown when the user closes a popup.
     */ BrowserAuthError.createUserCancelledError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.userCancelledError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.userCancelledError.desc);
    };
    /**
     * Creates an error thrown when monitorPopupFromHash times out for a given popup.
     */ BrowserAuthError.createMonitorPopupTimeoutError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.monitorPopupTimeoutError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.monitorPopupTimeoutError.desc);
    };
    /**
     * Creates an error thrown when monitorIframeFromHash times out for a given iframe.
     */ BrowserAuthError.createMonitorIframeTimeoutError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.monitorIframeTimeoutError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.monitorIframeTimeoutError.desc);
    };
    /**
     * Creates an error thrown when navigateWindow is called inside an iframe or brokered applications.
     * @param windowParentCheck
     */ BrowserAuthError.createRedirectInIframeError = function(windowParentCheck) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.redirectInIframeError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.redirectInIframeError.desc + " (window.parent !== window) => " + windowParentCheck);
    };
    /**
     * Creates an error thrown when an auth reload is done inside an iframe.
     */ BrowserAuthError.createBlockReloadInHiddenIframeError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.blockTokenRequestsInHiddenIframeError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.blockTokenRequestsInHiddenIframeError.desc);
    };
    /**
     * Creates an error thrown when a popup attempts to call an acquireToken API
     * @returns
     */ BrowserAuthError.createBlockAcquireTokenInPopupsError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.blockAcquireTokenInPopupsError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.blockAcquireTokenInPopupsError.desc);
    };
    /**
     * Creates an error thrown when an iframe is found to be closed before the timeout is reached.
     */ BrowserAuthError.createIframeClosedPrematurelyError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.iframeClosedPrematurelyError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.iframeClosedPrematurelyError.desc);
    };
    /**
     * Creates an error thrown when the logout API is called on any of the silent interaction clients
     */ BrowserAuthError.createSilentLogoutUnsupportedError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.silentLogoutUnsupportedError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.silentLogoutUnsupportedError.desc);
    };
    /**
     * Creates an error thrown when the account object is not provided in the acquireTokenSilent API.
     */ BrowserAuthError.createNoAccountError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.noAccountError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.noAccountError.desc);
    };
    /**
     * Creates an error thrown when a given prompt value is invalid for silent requests.
     */ BrowserAuthError.createSilentPromptValueError = function(givenPrompt) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.silentPromptValueError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.silentPromptValueError.desc + " Given value: " + givenPrompt);
    };
    /**
     * Creates an error thrown when the cached token request could not be retrieved from the cache
     */ BrowserAuthError.createUnableToParseTokenRequestCacheError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToParseTokenRequestCacheError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToParseTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when the token request could not be retrieved from the cache
     */ BrowserAuthError.createNoTokenRequestCacheError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.noTokenRequestCacheError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.noTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when handleCodeResponse is called before initiateAuthRequest (InteractionHandler)
     */ BrowserAuthError.createAuthRequestNotSetError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.authRequestNotSet.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.authRequestNotSet.desc);
    };
    /**
     * Creates an error thrown when the authority could not be retrieved from the cache
     */ BrowserAuthError.createNoCachedAuthorityError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.noCachedAuthorityError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.noCachedAuthorityError.desc);
    };
    /**
     * Creates an error thrown if cache type is invalid.
     */ BrowserAuthError.createInvalidCacheTypeError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.invalidCacheType.code, "" + $52ceb16ced3151d8$export$6deffaef56f0bd5a.invalidCacheType.desc);
    };
    /**
     * Create an error thrown when login and token requests are made from a non-browser environment
     */ BrowserAuthError.createNonBrowserEnvironmentError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.notInBrowserEnvironment.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.notInBrowserEnvironment.desc);
    };
    /**
     * Create an error thrown when indexDB database is not open
     */ BrowserAuthError.createDatabaseNotOpenError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.databaseNotOpen.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.databaseNotOpen.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to no internet
     */ BrowserAuthError.createNoNetworkConnectivityError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.noNetworkConnectivity.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.noNetworkConnectivity.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to reasons other than internet connectivity
     */ BrowserAuthError.createPostRequestFailedError = function(errorDesc, endpoint) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.postRequestFailed.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.postRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when get request fails due to reasons other than internet connectivity
     */ BrowserAuthError.createGetRequestFailedError = function(errorDesc, endpoint) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.getRequestFailed.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.getRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when network client fails to parse network response
     */ BrowserAuthError.createFailedToParseNetworkResponseError = function(endpoint) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.failedToParseNetworkResponse.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.failedToParseNetworkResponse.desc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when the necessary information is not available to sideload tokens
     */ BrowserAuthError.createUnableToLoadTokenError = function(errorDetail) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToLoadTokenError.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToLoadTokenError.desc + " | " + errorDetail);
    };
    /**
     * Create an error thrown when the queried cryptographic key is not found in IndexedDB
     */ BrowserAuthError.createSigningKeyNotFoundInStorageError = function(keyId) {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.signingKeyNotFoundInStorage.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.signingKeyNotFoundInStorage.desc + " | No match found for KeyId: " + keyId);
    };
    /**
     * Create an error when an authorization code is required but not provided
     */ BrowserAuthError.createAuthCodeRequiredError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.authCodeRequired.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.authCodeRequired.desc);
    };
    /**
     * Create an error when an authorization code or native account ID is required but not provided
     */ BrowserAuthError.createAuthCodeOrNativeAccountIdRequiredError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.authCodeOrNativeAccountRequired.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.authCodeOrNativeAccountRequired.desc);
    };
    /**
     * Create an error when both authorization code and native account ID are provided
     */ BrowserAuthError.createSpaCodeAndNativeAccountIdPresentError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.spaCodeAndNativeAccountPresent.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.spaCodeAndNativeAccountPresent.desc);
    };
    /**
     * Create an error when IndexedDB is unavailable
     */ BrowserAuthError.createDatabaseUnavailableError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.databaseUnavailable.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.databaseUnavailable.desc);
    };
    /**
     * Create an error when native token acquisition is not possible
     */ BrowserAuthError.createUnableToAcquireTokenFromNativePlatformError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToAcquireTokenFromNativePlatform.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.unableToAcquireTokenFromNativePlatform.desc);
    };
    /**
     * Create an error thrown when Handshake with browser extension times out
     */ BrowserAuthError.createNativeHandshakeTimeoutError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeHandshakeTimeout.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeHandshakeTimeout.desc);
    };
    /**
     * Create an error thrown when browser extension is not installed
     */ BrowserAuthError.createNativeExtensionNotInstalledError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeExtensionNotInstalled.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeExtensionNotInstalled.desc);
    };
    /**
     * Create an error when native connection has not been established
     * @returns
     */ BrowserAuthError.createNativeConnectionNotEstablishedError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeConnectionNotEstablished.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeConnectionNotEstablished.desc);
    };
    /**
     * Create an error thrown when the initialize function hasn't been called
     */ BrowserAuthError.createNativeBrokerCalledBeforeInitialize = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeBrokerCalledBeforeInitialize.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.nativeBrokerCalledBeforeInitialize.desc);
    };
    /**
     * Create an error thrown when requesting a token directly from the native platform with an unsupported prompt parameter e.g. select_account, login or create
     * These requests must go through eSTS to ensure eSTS is aware of the new account
     */ BrowserAuthError.createNativePromptParameterNotSupportedError = function() {
        return new BrowserAuthError($52ceb16ced3151d8$export$6deffaef56f0bd5a.nativePromptNotSupported.code, $52ceb16ced3151d8$export$6deffaef56f0bd5a.nativePromptNotSupported.desc);
    };
    return BrowserAuthError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
var $f36e3989fdce385c$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * Class which exposes APIs to generate PKCE codes and code verifiers.
 */ var $f36e3989fdce385c$export$562113aa73225ba6 = /** @class */ function() {
    function PkceGenerator(cryptoObj) {
        this.base64Encode = new (0, $d811768bdff141fb$export$d99f397851818755)();
        this.cryptoObj = cryptoObj;
    }
    /**
     * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
     */ PkceGenerator.prototype.generateCodes = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var codeVerifier, codeChallenge;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        codeVerifier = this.generateCodeVerifier();
                        return [
                            4 /*yield*/ ,
                            this.generateCodeChallengeFromVerifier(codeVerifier)
                        ];
                    case 1:
                        codeChallenge = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                verifier: codeVerifier,
                                challenge: codeChallenge
                            }
                        ];
                }
            });
        });
    };
    /**
     * Generates a random 32 byte buffer and returns the base64
     * encoded string to be used as a PKCE Code Verifier
     */ PkceGenerator.prototype.generateCodeVerifier = function() {
        try {
            // Generate random values as utf-8
            var buffer = new Uint8Array($f36e3989fdce385c$var$RANDOM_BYTE_ARR_LENGTH);
            this.cryptoObj.getRandomValues(buffer);
            // encode verifier as base64
            var pkceCodeVerifierB64 = this.base64Encode.urlEncodeArr(buffer);
            return pkceCodeVerifierB64;
        } catch (e) {
            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPkceNotGeneratedError(e);
        }
    };
    /**
     * Creates a base64 encoded PKCE Code Challenge string from the
     * hash created from the PKCE Code Verifier supplied
     */ PkceGenerator.prototype.generateCodeChallengeFromVerifier = function(pkceCodeVerifier) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var pkceHashedCodeVerifier, e_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cryptoObj.sha256Digest(pkceCodeVerifier)
                        ];
                    case 1:
                        pkceHashedCodeVerifier = _a.sent();
                        // encode hash as base64
                        return [
                            2 /*return*/ ,
                            this.base64Encode.urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier))
                        ];
                    case 2:
                        e_1 = _a.sent();
                        throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPkceNotGeneratedError(e_1);
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return PkceGenerator;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $63a2121db92719b9$export$b3934e1e9b87df7a = /** @class */ function() {
    function ModernBrowserCrypto() {}
    ModernBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window.crypto.getRandomValues(dataBuffer);
    };
    ModernBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.generateKey(algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.exportKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), key)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.importKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), keyData, algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.sign(algorithm, key, data)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.digest(algorithm, data)
                ];
            });
        });
    };
    return ModernBrowserCrypto;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $8fa3bff382d47bde$export$67e475a39cf5b913 = /** @class */ function() {
    function MsrBrowserCrypto() {}
    MsrBrowserCrypto.prototype.initPrng = function(entropy) {
        // Turn into array, as initPrng seems to not always like Uint8Array (even though it should support both)
        return window.msrCrypto.initPrng((0, $87ab789688594f61$export$afc72e2116322959)(entropy));
    };
    MsrBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window.msrCrypto.getRandomValues(dataBuffer);
    };
    MsrBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.generateKey(algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.exportKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), key)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.importKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), keyData, algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.sign(algorithm, key, data)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.digest(algorithm, data)
                ];
            });
        });
    };
    return MsrBrowserCrypto;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $28e337b7fd78aa24$export$642a89235724bda7 = /** @class */ function() {
    function MsBrowserCrypto() {}
    MsBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window["msCrypto"].getRandomValues(dataBuffer);
    };
    MsBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msGenerateKey = window["msCrypto"].subtle.generateKey(algorithm, extractable, keyUsages);
                        msGenerateKey.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msGenerateKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msExportKey = window["msCrypto"].subtle.exportKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), key);
                        msExportKey.addEventListener("complete", function(e) {
                            var resultBuffer = e.target.result;
                            var resultString = (0, $fe7ad92e4391e722$export$27a4bf5378101665).utf8ArrToString(new Uint8Array(resultBuffer)).replace(/\r/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).replace(/\n/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).replace(/\t/g, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).split(" ").join((0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).replace("\x00", (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
                            try {
                                resolve(JSON.parse(resultString));
                            } catch (e) {
                                reject(e);
                            }
                        });
                        msExportKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var keyString, keyBuffer;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                keyString = (0, $fe7ad92e4391e722$export$27a4bf5378101665).getSortedObjectString(keyData);
                keyBuffer = (0, $fe7ad92e4391e722$export$27a4bf5378101665).stringToArrayBuffer(keyString);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msImportKey = window["msCrypto"].subtle.importKey((0, $0f344e7ceaf1df75$export$1294c3e3f84694cd), keyBuffer, algorithm, extractable, keyUsages);
                        msImportKey.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msImportKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msSign = window["msCrypto"].subtle.sign(algorithm, key, data);
                        msSign.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msSign.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var digestOperation = window["msCrypto"].subtle.digest(algorithm, data.buffer);
                        digestOperation.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        digestOperation.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    return MsBrowserCrypto;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $320409a2968f9f12$export$daccd9364f884077 = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    storageNotSupportedError: {
        code: "storage_not_supported",
        desc: "Given storage configuration option was not supported."
    },
    noRedirectCallbacksSet: {
        code: "no_redirect_callbacks",
        desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
        code: "invalid_callback_object",
        desc: "The object passed for the callback was invalid. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    stubPcaInstanceCalled: {
        code: "stubbed_public_client_application_called",
        desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
    },
    inMemRedirectUnavailable: {
        code: "in_mem_redirect_unavailable",
        desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
    },
    entropyNotProvided: {
        code: "entropy_not_provided",
        desc: "The available browser crypto interface requires entropy set via system.cryptoOptions.entropy configuration option."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ var $320409a2968f9f12$export$2eb7a1dfdc4c5fba = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(BrowserConfigurationAuthError, _super);
    function BrowserConfigurationAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(_this, BrowserConfigurationAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */ BrowserConfigurationAuthError.createRedirectUriEmptyError = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.redirectUriNotSet.code, $320409a2968f9f12$export$daccd9364f884077.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */ BrowserConfigurationAuthError.createPostLogoutRedirectUriEmptyError = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.postLogoutUriNotSet.code, $320409a2968f9f12$export$daccd9364f884077.postLogoutUriNotSet.desc);
    };
    /**
     * Creates error thrown when given storage location is not supported.
     * @param givenStorageLocation
     */ BrowserConfigurationAuthError.createStorageNotSupportedError = function(givenStorageLocation) {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.storageNotSupportedError.code, $320409a2968f9f12$export$daccd9364f884077.storageNotSupportedError.desc + " Given Location: " + givenStorageLocation);
    };
    /**
     * Creates error thrown when redirect callbacks are not set before calling loginRedirect() or acquireTokenRedirect().
     */ BrowserConfigurationAuthError.createRedirectCallbacksNotSetError = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.noRedirectCallbacksSet.code, $320409a2968f9f12$export$daccd9364f884077.noRedirectCallbacksSet.desc);
    };
    /**
     * Creates error thrown when the stub instance of PublicClientApplication is called.
     */ BrowserConfigurationAuthError.createStubPcaInstanceCalledError = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.stubPcaInstanceCalled.code, $320409a2968f9f12$export$daccd9364f884077.stubPcaInstanceCalled.desc);
    };
    /*
     * Create an error thrown when in-memory storage is used and storeAuthStateInCookie=false.
     */ BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.inMemRedirectUnavailable.code, $320409a2968f9f12$export$daccd9364f884077.inMemRedirectUnavailable.desc);
    };
    /**
     * Creates an error thrown when a crypto interface that requires entropy is initialized without entropy
     */ BrowserConfigurationAuthError.createEntropyNotProvided = function() {
        return new BrowserConfigurationAuthError($320409a2968f9f12$export$daccd9364f884077.entropyNotProvided.code, $320409a2968f9f12$export$daccd9364f884077.entropyNotProvided.desc);
    };
    return BrowserConfigurationAuthError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // RSA KeyGen Algorithm
var $40b4b6b3e358a65d$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
var $40b4b6b3e358a65d$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
var $40b4b6b3e358a65d$var$MODULUS_LENGTH = 2048;
// Public Exponent
var $40b4b6b3e358a65d$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
/**
 * This class implements functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ var $40b4b6b3e358a65d$export$bdaac271e902e541 = /** @class */ function() {
    function BrowserCrypto(logger, cryptoOptions) {
        var _a, _b;
        this.logger = logger;
        this.cryptoOptions = cryptoOptions;
        if (this.hasBrowserCrypto()) {
            // Use standard modern web crypto if available
            this.logger.verbose("BrowserCrypto: modern crypto interface available");
            this.subtleCrypto = new (0, $63a2121db92719b9$export$b3934e1e9b87df7a)();
        } else if (this.hasIECrypto()) {
            // For IE11, use msCrypto interface
            this.logger.verbose("BrowserCrypto: MS crypto interface available");
            this.subtleCrypto = new (0, $28e337b7fd78aa24$export$642a89235724bda7)();
        } else if (this.hasMsrCrypto() && ((_a = this.cryptoOptions) === null || _a === void 0 ? void 0 : _a.useMsrCrypto)) {
            // For other browsers, use MSR Crypto if found
            this.logger.verbose("BrowserCrypto: MSR crypto interface available");
            this.subtleCrypto = new (0, $8fa3bff382d47bde$export$67e475a39cf5b913)();
        } else {
            if (this.hasMsrCrypto()) this.logger.info("BrowserCrypto: MSR Crypto interface available but system.cryptoOptions.useMsrCrypto not enabled");
            this.logger.error("BrowserCrypto: No crypto interfaces available.");
            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createCryptoNotAvailableError("Browser crypto, msCrypto, or msrCrypto interfaces not available.");
        }
        // Mainly needed for MSR Crypto: https://github.com/microsoft/MSR-JavaScript-Crypto#random-number-generator-prng
        if (this.subtleCrypto.initPrng) {
            this.logger.verbose("BrowserCrypto: Interface requires entropy");
            if (!((_b = this.cryptoOptions) === null || _b === void 0 ? void 0 : _b.entropy)) {
                this.logger.error("BrowserCrypto: Interface requires entropy but none provided.");
                throw (0, $320409a2968f9f12$export$2eb7a1dfdc4c5fba).createEntropyNotProvided();
            }
            this.logger.verbose("BrowserCrypto: Entropy provided");
            this.subtleCrypto.initPrng(this.cryptoOptions.entropy);
        }
        this.keygenAlgorithmOptions = {
            name: $40b4b6b3e358a65d$var$PKCS1_V15_KEYGEN_ALG,
            hash: $40b4b6b3e358a65d$var$S256_HASH_ALG,
            modulusLength: $40b4b6b3e358a65d$var$MODULUS_LENGTH,
            publicExponent: $40b4b6b3e358a65d$var$PUBLIC_EXPONENT
        };
    }
    /**
     * Check whether IE crypto or other browser cryptography is available.
     */ BrowserCrypto.prototype.hasIECrypto = function() {
        return "msCrypto" in window;
    };
    /**
     * Check whether browser crypto is available.
     */ BrowserCrypto.prototype.hasBrowserCrypto = function() {
        return "crypto" in window;
    };
    /**
     * Check whether MSR crypto polyfill is available
     */ BrowserCrypto.prototype.hasMsrCrypto = function() {
        return "msrCrypto" in window;
    };
    /**
     * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
     * @param dataString
     */ BrowserCrypto.prototype.sha256Digest = function(dataString) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var data;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                data = (0, $fe7ad92e4391e722$export$27a4bf5378101665).stringToUtf8Arr(dataString);
                // MSR Crypto wants object with name property, instead of string
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.digest({
                        name: $40b4b6b3e358a65d$var$S256_HASH_ALG
                    }, data)
                ];
            });
        });
    };
    /**
     * Populates buffer with cryptographically random values.
     * @param dataBuffer
     */ BrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return this.subtleCrypto.getRandomValues(dataBuffer);
    };
    /**
     * Generates a keypair based on current keygen algorithm config.
     * @param extractable
     * @param usages
     */ BrowserCrypto.prototype.generateKeyPair = function(extractable, usages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.generateKey(this.keygenAlgorithmOptions, extractable, usages)
                ];
            });
        });
    };
    /**
     * Export key as Json Web Key (JWK)
     * @param key
     * @param format
     */ BrowserCrypto.prototype.exportJwk = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.exportKey(key)
                ];
            });
        });
    };
    /**
     * Imports key as Json Web Key (JWK), can set extractable and usages.
     * @param key
     * @param format
     * @param extractable
     * @param usages
     */ BrowserCrypto.prototype.importJwk = function(key, extractable, usages) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.importKey(key, this.keygenAlgorithmOptions, extractable, usages)
                ];
            });
        });
    };
    /**
     * Signs given data with given key
     * @param key
     * @param data
     */ BrowserCrypto.prototype.sign = function(key, data) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.sign(this.keygenAlgorithmOptions, key, data)
                ];
            });
        });
    };
    return BrowserCrypto;
}();




/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

/*! @azure/msal-browser v2.38.3 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ var $d7762c100436f113$export$286b0f3b569e5f16 = /** @class */ function() {
    function DatabaseStorage() {
        this.dbName = (0, $0f344e7ceaf1df75$export$3c22ff8b64b8f565);
        this.version = (0, $0f344e7ceaf1df75$export$6a9022b4c5fcea02);
        this.tableName = (0, $0f344e7ceaf1df75$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ DatabaseStorage.prototype.open = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var openDB = window.indexedDB.open(_this.dbName, _this.version);
                        openDB.addEventListener("upgradeneeded", function(e) {
                            var event = e;
                            event.target.result.createObjectStore(_this.tableName);
                        });
                        openDB.addEventListener("success", function(e) {
                            var event = e;
                            _this.db = event.target.result;
                            _this.dbOpen = true;
                            resolve();
                        });
                        openDB.addEventListener("error", function() {
                            return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseUnavailableError());
                        });
                    })
                ];
            });
        });
    };
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ DatabaseStorage.prototype.closeConnection = function() {
        var db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    };
    /**
     * Opens database if it's not already open
     */ DatabaseStorage.prototype.validateDbIsOpen = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.dbOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.open()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ DatabaseStorage.prototype.getItem = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGet = objectStore.get(key);
                                dbGet.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGet.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ DatabaseStorage.prototype.setItem = function(key, payload) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbPut = objectStore.put(payload, key);
                                dbPut.addEventListener("success", function() {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbPut.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ DatabaseStorage.prototype.removeItem = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbDelete = objectStore.delete(key);
                                dbDelete.addEventListener("success", function() {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbDelete.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ DatabaseStorage.prototype.getKeys = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGetKeys = objectStore.getAllKeys();
                                dbGetKeys.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGetKeys.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ DatabaseStorage.prototype.containsKey = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbContainsKey = objectStore.count(key);
                                dbContainsKey.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result === 1);
                                });
                                dbContainsKey.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ DatabaseStorage.prototype.deleteDatabase = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                // Check if database being deleted exists
                if (this.db && this.dbOpen) this.closeConnection();
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var deleteDbRequest = window.indexedDB.deleteDatabase((0, $0f344e7ceaf1df75$export$3c22ff8b64b8f565));
                        deleteDbRequest.addEventListener("success", function() {
                            return resolve(true);
                        });
                        deleteDbRequest.addEventListener("blocked", function() {
                            return resolve(true);
                        });
                        deleteDbRequest.addEventListener("error", function() {
                            return reject(false);
                        });
                    })
                ];
            });
        });
    };
    return DatabaseStorage;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $ee22f9373d02691a$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {
        this.cache = new Map();
    }
    MemoryStorage.prototype.getItem = function(key) {
        return this.cache.get(key) || null;
    };
    MemoryStorage.prototype.setItem = function(key, value) {
        this.cache.set(key, value);
    };
    MemoryStorage.prototype.removeItem = function(key) {
        this.cache.delete(key);
    };
    MemoryStorage.prototype.getKeys = function() {
        var cacheKeys = [];
        this.cache.forEach(function(value, key) {
            cacheKeys.push(key);
        });
        return cacheKeys;
    };
    MemoryStorage.prototype.containsKey = function(key) {
        return this.cache.has(key);
    };
    MemoryStorage.prototype.clear = function() {
        this.cache.clear();
    };
    return MemoryStorage;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ var $be5eac0ea7afd09e$export$b38f35aab37afcde = /** @class */ function() {
    function AsyncMemoryStorage(logger, storeName) {
        this.inMemoryCache = new (0, $ee22f9373d02691a$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $d7762c100436f113$export$286b0f3b569e5f16)();
        this.logger = logger;
        this.storeName = storeName;
    }
    AsyncMemoryStorage.prototype.handleDatabaseAccessError = function(error) {
        if (error instanceof (0, $52ceb16ced3151d8$export$f8eb6760ca13876a) && error.errorCode === (0, $52ceb16ced3151d8$export$6deffaef56f0bd5a).databaseUnavailable.code) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    };
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ AsyncMemoryStorage.prototype.getItem = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var item, e_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        item = this.inMemoryCache.getItem(key);
                        if (!!item) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.getItem(key)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_1 = _a.sent();
                        this.handleDatabaseAccessError(e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            item
                        ];
                }
            });
        });
    };
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ AsyncMemoryStorage.prototype.setItem = function(key, value) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_2;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.inMemoryCache.setItem(key, value);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.setItem(key, value)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        this.handleDatabaseAccessError(e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ AsyncMemoryStorage.prototype.removeItem = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_3;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.inMemoryCache.removeItem(key);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.removeItem(key)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_3 = _a.sent();
                        this.handleDatabaseAccessError(e_3);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ AsyncMemoryStorage.prototype.getKeys = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cacheKeys, e_4;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        cacheKeys = this.inMemoryCache.getKeys();
                        if (!(cacheKeys.length === 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.getKeys()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_4 = _a.sent();
                        this.handleDatabaseAccessError(e_4);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            cacheKeys
                        ];
                }
            });
        });
    };
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ AsyncMemoryStorage.prototype.containsKey = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var containsKey, e_5;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        containsKey = this.inMemoryCache.containsKey(key);
                        if (!!containsKey) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.containsKey(key)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_5 = _a.sent();
                        this.handleDatabaseAccessError(e_5);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            containsKey
                        ];
                }
            });
        });
    };
    /**
     * Clears in-memory Map
     */ AsyncMemoryStorage.prototype.clearInMemory = function() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("Deleting in-memory keystore " + this.storeName);
        this.inMemoryCache.clear();
        this.logger.verbose("In-memory keystore " + this.storeName + " deleted");
    };
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ AsyncMemoryStorage.prototype.clearPersistent = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var dbDeleted, e_6;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.logger.verbose("Deleting persistent keystore");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.deleteDatabase()
                        ];
                    case 1:
                        dbDeleted = _a.sent();
                        if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
                        return [
                            2 /*return*/ ,
                            dbDeleted
                        ];
                    case 2:
                        e_6 = _a.sent();
                        this.handleDatabaseAccessError(e_6);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AsyncMemoryStorage;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $11d7ee2f89fae1b9$export$8aedbc9f96e92cd4;
(function(CryptoKeyStoreNames) {
    CryptoKeyStoreNames["asymmetricKeys"] = "asymmetricKeys";
    CryptoKeyStoreNames["symmetricKeys"] = "symmetricKeys";
})($11d7ee2f89fae1b9$export$8aedbc9f96e92cd4 || ($11d7ee2f89fae1b9$export$8aedbc9f96e92cd4 = {}));
/**
 * MSAL CryptoKeyStore DB Version 2
 */ var $11d7ee2f89fae1b9$export$fb0c2afa49bfcd68 = /** @class */ function() {
    function CryptoKeyStore(logger) {
        this.logger = logger;
        this.asymmetricKeys = new (0, $be5eac0ea7afd09e$export$b38f35aab37afcde)(this.logger, $11d7ee2f89fae1b9$export$8aedbc9f96e92cd4.asymmetricKeys);
        this.symmetricKeys = new (0, $be5eac0ea7afd09e$export$b38f35aab37afcde)(this.logger, $11d7ee2f89fae1b9$export$8aedbc9f96e92cd4.symmetricKeys);
    }
    CryptoKeyStore.prototype.clear = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Delete in-memory keystores
                        this.asymmetricKeys.clearInMemory();
                        this.symmetricKeys.clearInMemory();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.asymmetricKeys.clearPersistent()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) this.logger.error("Clearing keystore failed with error: " + e_1.message);
                        else this.logger.error("Clearing keystore failed with unknown error");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return CryptoKeyStore;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ var $13c91413da988abc$export$c274a7f0ebd24b14 = /** @class */ function() {
    function CryptoOps(logger, performanceClient, cryptoConfig) {
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        this.browserCrypto = new (0, $40b4b6b3e358a65d$export$bdaac271e902e541)(this.logger, cryptoConfig);
        this.b64Encode = new (0, $d811768bdff141fb$export$d99f397851818755)();
        this.b64Decode = new (0, $98dc98c6cc205193$export$fe555b2490ffa3fb)();
        this.guidGenerator = new (0, $ca5806521448c4be$export$62dc58eaf2cdc52)(this.browserCrypto);
        this.pkceGenerator = new (0, $f36e3989fdce385c$export$562113aa73225ba6)(this.browserCrypto);
        this.cache = new (0, $11d7ee2f89fae1b9$export$fb0c2afa49bfcd68)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ CryptoOps.prototype.createNewGuid = function() {
        return this.guidGenerator.generateGuid();
    };
    /**
     * Encodes input string to base64.
     * @param input
     */ CryptoOps.prototype.base64Encode = function(input) {
        return this.b64Encode.encode(input);
    };
    /**
     * Decodes input string from base64.
     * @param input
     */ CryptoOps.prototype.base64Decode = function(input) {
        return this.b64Decode.decode(input);
    };
    /**
     * Generates PKCE codes used in Authorization Code Flow.
     */ CryptoOps.prototype.generatePkceCodes = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.pkceGenerator.generateCodes()
                ];
            });
        });
    };
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ CryptoOps.prototype.getPublicKeyThumbprint = function(request) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var publicKeyThumbMeasurement, keyPair, publicKeyJwk, pubKeyThumprintObj, publicJwkString, publicJwkHash, privateKeyJwk, unextractablePrivateKey;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        publicKeyThumbMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.generateKeyPair(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES)
                        ];
                    case 1:
                        keyPair = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(keyPair.publicKey)
                        ];
                    case 2:
                        publicKeyJwk = _b.sent();
                        pubKeyThumprintObj = {
                            e: publicKeyJwk.e,
                            kty: publicKeyJwk.kty,
                            n: publicKeyJwk.n
                        };
                        publicJwkString = (0, $fe7ad92e4391e722$export$27a4bf5378101665).getSortedObjectString(pubKeyThumprintObj);
                        return [
                            4 /*yield*/ ,
                            this.hashString(publicJwkString)
                        ];
                    case 3:
                        publicJwkHash = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(keyPair.privateKey)
                        ];
                    case 4:
                        privateKeyJwk = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.importJwk(privateKeyJwk, false, [
                                "sign"
                            ])
                        ];
                    case 5:
                        unextractablePrivateKey = _b.sent();
                        // Store Keypair data in keystore
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.setItem(publicJwkHash, {
                                privateKey: unextractablePrivateKey,
                                publicKey: keyPair.publicKey,
                                requestMethod: request.resourceRequestMethod,
                                requestUri: request.resourceRequestUri
                            })
                        ];
                    case 6:
                        // Store Keypair data in keystore
                        _b.sent();
                        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            publicJwkHash
                        ];
                }
            });
        });
    };
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ CryptoOps.prototype.removeTokenBindingKey = function(kid) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var keyFound;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.removeItem(kid)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.containsKey(kid)
                        ];
                    case 2:
                        keyFound = _a.sent();
                        return [
                            2 /*return*/ ,
                            !keyFound
                        ];
                }
            });
        });
    };
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ CryptoOps.prototype.clearKeystore = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cache.clear()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ CryptoOps.prototype.signJwt = function(payload, kid, correlationId) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var signJwtMeasurement, cachedKeyPair, publicKeyJwk, publicKeyJwkString, encodedKeyIdThumbprint, shrHeader, encodedShrHeader, encodedPayload, tokenString, tokenBuffer, signatureBuffer, encodedSignature, signedJwt;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        signJwtMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.getItem(kid)
                        ];
                    case 1:
                        cachedKeyPair = _b.sent();
                        if (!cachedKeyPair) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSigningKeyNotFoundInStorageError(kid);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(cachedKeyPair.publicKey)
                        ];
                    case 2:
                        publicKeyJwk = _b.sent();
                        publicKeyJwkString = (0, $fe7ad92e4391e722$export$27a4bf5378101665).getSortedObjectString(publicKeyJwk);
                        encodedKeyIdThumbprint = this.b64Encode.urlEncode(JSON.stringify({
                            kid: kid
                        }));
                        shrHeader = (0, $e27b4fc303942e21$export$91748d132e6cb9b3).getShrHeaderString({
                            kid: encodedKeyIdThumbprint,
                            alg: publicKeyJwk.alg
                        });
                        encodedShrHeader = this.b64Encode.urlEncode(shrHeader);
                        // Generate payload
                        payload.cnf = {
                            jwk: JSON.parse(publicKeyJwkString)
                        };
                        encodedPayload = this.b64Encode.urlEncode(JSON.stringify(payload));
                        tokenString = encodedShrHeader + "." + encodedPayload;
                        tokenBuffer = (0, $fe7ad92e4391e722$export$27a4bf5378101665).stringToArrayBuffer(tokenString);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.sign(cachedKeyPair.privateKey, tokenBuffer)
                        ];
                    case 3:
                        signatureBuffer = _b.sent();
                        encodedSignature = this.b64Encode.urlEncodeArr(new Uint8Array(signatureBuffer));
                        signedJwt = tokenString + "." + encodedSignature;
                        if (signJwtMeasurement) signJwtMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            signedJwt
                        ];
                }
            });
        });
    };
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ CryptoOps.prototype.hashString = function(plainText) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hashBuffer, hashBytes;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.sha256Digest(plainText)
                        ];
                    case 1:
                        hashBuffer = _a.sent();
                        hashBytes = new Uint8Array(hashBuffer);
                        return [
                            2 /*return*/ ,
                            this.b64Encode.urlEncodeArr(hashBytes)
                        ];
                }
            });
        });
    };
    CryptoOps.POP_KEY_USAGES = [
        "sign",
        "verify"
    ];
    CryptoOps.EXTRACTABLE = true;
    return CryptoOps;
}();


/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $1f27a522af777978$export$865f57d401606752 = {
    createNewGuid: function() {
        var notImplErr = "Crypto interface - createNewGuid() has not been implemented";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    base64Decode: function() {
        var notImplErr = "Crypto interface - base64Decode() has not been implemented";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    base64Encode: function() {
        var notImplErr = "Crypto interface - base64Encode() has not been implemented";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    generatePkceCodes: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - generatePkceCodes() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    getPublicKeyThumbprint: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - getPublicKeyThumbprint() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    removeTokenBindingKey: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - removeTokenBindingKey() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    clearKeystore: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - clearKeystore() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    signJwt: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - signJwt() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    hashString: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - hashString() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    }
};

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $5f18ed8a9f930396$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($5f18ed8a9f930396$export$243e62d78d3b544d || ($5f18ed8a9f930396$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ var $5f18ed8a9f930396$export$efa9a398d6368992 = /** @class */ function() {
    function Logger(loggerOptions, packageName, packageVersion) {
        // Current log level, defaults to info.
        this.level = $5f18ed8a9f930396$export$243e62d78d3b544d.Info;
        var defaultLoggerCallback = function() {
            return;
        };
        var setLoggerOptions = loggerOptions || Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $5f18ed8a9f930396$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    }
    Logger.createDefaultLoggerOptions = function() {
        return {
            loggerCallback: function() {
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Info
        };
    };
    /**
     * Create new Logger with existing configurations.
     */ Logger.prototype.clone = function(packageName, packageVersion, correlationId) {
        return new Logger({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    };
    /**
     * Log message with required options.
     */ Logger.prototype.logMessage = function(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        var timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        var logHeader;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(options.correlationId)) logHeader = "[" + timestamp + "] : [" + options.correlationId + "]";
        else if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(this.correlationId)) logHeader = "[" + timestamp + "] : [" + this.correlationId + "]";
        else logHeader = "[" + timestamp + "]";
        var log = logHeader + " : " + this.packageName + "@" + this.packageVersion + " : " + $5f18ed8a9f930396$export$243e62d78d3b544d[options.logLevel] + " - " + logMessage;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    };
    /**
     * Execute callback with message.
     */ Logger.prototype.executeCallback = function(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    };
    /**
     * Logs error messages.
     */ Logger.prototype.error = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs error messages with PII.
     */ Logger.prototype.errorPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs warning messages.
     */ Logger.prototype.warning = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs warning messages with PII.
     */ Logger.prototype.warningPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs info messages.
     */ Logger.prototype.info = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs info messages with PII.
     */ Logger.prototype.infoPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages.
     */ Logger.prototype.verbose = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages with PII.
     */ Logger.prototype.verbosePii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs trace messages.
     */ Logger.prototype.trace = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs trace messages with PII.
     */ Logger.prototype.tracePii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $5f18ed8a9f930396$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Returns whether PII Logging is enabled or not.
     */ Logger.prototype.isPiiLoggingEnabled = function() {
        return this.piiLoggingEnabled || false;
    };
    return Logger;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $aac62f65fee01d05$export$820526014323765f = /** @class */ function() {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     */ function PerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) {
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.queueMeasurements = new Map();
        this.preQueueTimeByCorrelationId = new Map();
    }
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this function can be changed to abstract at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */ /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ PerformanceClient.prototype.startPerformanceMeasurement = function(measureName, correlationId) {
        return {};
    };
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this incorrectly-named function will be removed at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */ /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ PerformanceClient.prototype.startPerformanceMeasuremeant = function(measureName, correlationId) {
        return {};
    };
    /**
     * Get integral fields.
     * Override to change the set.
     */ PerformanceClient.prototype.getIntFields = function() {
        return 0, $c1ca1b67a2077729$export$f16d39729f4b7302;
    };
    /**
     * Gets map of pre-queue times by correlation Id
     *
     * @param {PerformanceEvents} eventName
     * @param {string} correlationId
     * @returns {number}
     */ PerformanceClient.prototype.getPreQueueTime = function(eventName, correlationId) {
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        if (!preQueueEvent) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue times found for correlationId: " + correlationId + ", unable to add queue measurement");
            return;
        } else if (preQueueEvent.name !== eventName) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue time found for " + eventName + ", unable to add queue measurement");
            return;
        }
        return preQueueEvent.time;
    };
    /**
     * Calculates the difference between current time and time when function was queued.
     * Note: It is possible to have 0 as the queue time if the current time and the queued time was the same.
     *
     * @param {number} preQueueTime
     * @param {number} currentTime
     * @returns {number}
     */ PerformanceClient.prototype.calculateQueuedTime = function(preQueueTime, currentTime) {
        if (preQueueTime < 1) {
            this.logger.trace("PerformanceClient: preQueueTime should be a positive integer and not " + preQueueTime);
            return 0;
        }
        if (currentTime < 1) {
            this.logger.trace("PerformanceClient: currentTime should be a positive integer and not " + currentTime);
            return 0;
        }
        if (currentTime < preQueueTime) {
            this.logger.trace("PerformanceClient: currentTime is less than preQueueTime, check how time is being retrieved");
            return 0;
        }
        return currentTime - preQueueTime;
    };
    /**
     * Adds queue measurement time to QueueMeasurements array for given correlation ID.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */ PerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime, manuallyCompleted) {
        if (!correlationId) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: correlationId not provided for " + eventName + ", cannot add queue measurement");
            return;
        }
        if (queueTime === 0) // Possible for there to be no queue time after calculation
        this.logger.trace("PerformanceClient.addQueueMeasurement: queue time provided for " + eventName + " is " + queueTime);
        else if (!queueTime) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: no queue time provided for " + eventName);
            return;
        }
        var queueMeasurement = {
            eventName: eventName,
            queueTime: queueTime,
            manuallyCompleted: manuallyCompleted
        };
        // Adds to existing correlation Id if present in queueMeasurements
        var existingMeasurements = this.queueMeasurements.get(correlationId);
        if (existingMeasurements) {
            existingMeasurements.push(queueMeasurement);
            this.queueMeasurements.set(correlationId, existingMeasurements);
        } else {
            // Sets new correlation Id if not present in queueMeasurements
            this.logger.trace("PerformanceClient.addQueueMeasurement: adding correlationId " + correlationId + " to queue measurements");
            var measurementArray = [
                queueMeasurement
            ];
            this.queueMeasurements.set(correlationId, measurementArray);
        }
        // Delete processed pre-queue event.
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */ PerformanceClient.prototype.startMeasurement = function(measureName, correlationId) {
        var _this = this;
        var _a, _b;
        // Generate a placeholder correlation if the request does not provide one
        var eventCorrelationId = correlationId || this.generateId();
        if (!correlationId) this.logger.info("PerformanceClient: No correlation id provided for " + measureName + ", generating", eventCorrelationId);
        // Duplicate code to address spelling error will be removed at the next major version bump.
        this.logger.trace("PerformanceClient: Performance measurement started for " + measureName, eventCorrelationId);
        var performanceMeasurement = this.startPerformanceMeasuremeant(measureName, eventCorrelationId);
        performanceMeasurement.startMeasurement();
        var inProgressEvent = {
            eventId: this.generateId(),
            status: (0, $c1ca1b67a2077729$export$bc3547c8ae7b1db).InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: (_a = this.applicationTelemetry) === null || _a === void 0 ? void 0 : _a.appName,
            appVersion: (_b = this.applicationTelemetry) === null || _b === void 0 ? void 0 : _b.appVersion
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            endMeasurement: function(event) {
                return _this.endMeasurement((0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, inProgressEvent), event), performanceMeasurement);
            },
            discardMeasurement: function() {
                return _this.discardMeasurements(inProgressEvent.correlationId);
            },
            addStaticFields: function(fields) {
                return _this.addStaticFields(fields, inProgressEvent.correlationId);
            },
            increment: function(counters) {
                return _this.increment(counters, inProgressEvent.correlationId);
            },
            measurement: performanceMeasurement,
            event: inProgressEvent
        };
    };
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {IPerformanceMeasurement} measurement
     * @returns {(PerformanceEvent | null)}
     */ PerformanceClient.prototype.endMeasurement = function(event, measurement) {
        var _this = this;
        var _a, _b;
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace("PerformanceClient: Measurement not found for " + event.eventId, event.correlationId);
            return null;
        }
        var isRoot = event.eventId === rootEvent.eventId;
        var queueInfo = {
            totalQueueTime: 0,
            totalQueueCount: 0,
            manuallyCompletedCount: 0
        };
        if (isRoot) {
            queueInfo = this.getQueueInfo(event.correlationId);
            this.discardCache(rootEvent.correlationId);
        } else (_a = rootEvent.incompleteSubMeasurements) === null || _a === void 0 || _a.delete(event.eventId);
        measurement === null || measurement === void 0 || measurement.endMeasurement();
        var durationMs = measurement === null || measurement === void 0 ? void 0 : measurement.flushMeasurement();
        // null indicates no measurement was taken (e.g. needed performance APIs not present)
        if (!durationMs) {
            this.logger.trace("PerformanceClient: Performance measurement not taken", rootEvent.correlationId);
            return null;
        }
        this.logger.trace("PerformanceClient: Performance measurement ended for " + event.name + ": " + durationMs + " ms", event.correlationId);
        // Add sub-measurement attribute to root event.
        if (!isRoot) {
            rootEvent[event.name + "DurationMs"] = Math.floor(durationMs);
            return (0, $a296cc98de023397$export$18ce0697a983be9b)({}, rootEvent);
        }
        var finalEvent = (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, rootEvent), event);
        var incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        (_b = finalEvent.incompleteSubMeasurements) === null || _b === void 0 || _b.forEach(function(subMeasurement) {
            _this.logger.trace("PerformanceClient: Incomplete submeasurement " + subMeasurement.name + " found for " + event.name, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        finalEvent = (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, finalEvent), {
            durationMs: Math.round(durationMs),
            queuedTimeMs: queueInfo.totalQueueTime,
            queuedCount: queueInfo.totalQueueCount,
            queuedManuallyCompletedCount: queueInfo.manuallyCompletedCount,
            status: (0, $c1ca1b67a2077729$export$bc3547c8ae7b1db).Completed,
            incompleteSubsCount: incompleteSubsCount
        });
        this.truncateIntegralFields(finalEvent, this.getIntFields());
        this.emitEvents([
            finalEvent
        ], event.correlationId);
        return finalEvent;
    };
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */ PerformanceClient.prototype.addStaticFields = function(fields, correlationId) {
        this.logger.trace("PerformanceClient: Updating static fields");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) this.eventsByCorrelationId.set(correlationId, (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, event), fields));
        else this.logger.trace("PerformanceClient: Event not found for", correlationId);
    };
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param counters {Counters}
     * @param correlationId {string} correlation identifier
     */ PerformanceClient.prototype.increment = function(counters, correlationId) {
        this.logger.trace("PerformanceClient: Updating counters");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) for(var counter in counters){
            if (!event.hasOwnProperty(counter)) event[counter] = 0;
            event[counter] += counters[counter];
        }
        else this.logger.trace("PerformanceClient: Event not found for", correlationId);
    };
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */ PerformanceClient.prototype.cacheEventByCorrelationId = function(event) {
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " added/updated", event.correlationId);
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, {
                name: event.name,
                startTimeMs: event.startTimeMs
            });
        } else {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " started", event.correlationId);
            this.eventsByCorrelationId.set(event.correlationId, (0, $a296cc98de023397$export$18ce0697a983be9b)({}, event));
        }
    };
    PerformanceClient.prototype.getQueueInfo = function(correlationId) {
        var queueMeasurementForCorrelationId = this.queueMeasurements.get(correlationId);
        if (!queueMeasurementForCorrelationId) this.logger.trace("PerformanceClient: no queue measurements found for for correlationId: " + correlationId);
        var totalQueueTime = 0;
        var totalQueueCount = 0;
        var manuallyCompletedCount = 0;
        queueMeasurementForCorrelationId === null || queueMeasurementForCorrelationId === void 0 || queueMeasurementForCorrelationId.forEach(function(measurement) {
            totalQueueTime += measurement.queueTime;
            totalQueueCount++;
            manuallyCompletedCount += measurement.manuallyCompleted ? 1 : 0;
        });
        return {
            totalQueueTime: totalQueueTime,
            totalQueueCount: totalQueueCount,
            manuallyCompletedCount: manuallyCompletedCount
        };
    };
    /**
     * Removes measurements for a given correlation id.
     *
     * @param {string} correlationId
     */ PerformanceClient.prototype.discardMeasurements = function(correlationId) {
        this.logger.trace("PerformanceClient: Performance measurements discarded", correlationId);
        this.eventsByCorrelationId.delete(correlationId);
    };
    /**
     * Removes cache for a given correlation id.
     *
     * @param {string} correlationId correlation identifier
     */ PerformanceClient.prototype.discardCache = function(correlationId) {
        this.discardMeasurements(correlationId);
        this.logger.trace("PerformanceClient: QueueMeasurements discarded", correlationId);
        this.queueMeasurements.delete(correlationId);
        this.logger.trace("PerformanceClient: Pre-queue times discarded", correlationId);
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ PerformanceClient.prototype.addPerformanceCallback = function(callback) {
        var callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose("PerformanceClient: Performance callback registered with id: " + callbackId);
        return callbackId;
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ PerformanceClient.prototype.removePerformanceCallback = function(callbackId) {
        var result = this.callbacks.delete(callbackId);
        if (result) this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " removed.");
        else this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " not removed.");
        return result;
    };
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */ PerformanceClient.prototype.emitEvents = function(events, correlationId) {
        var _this = this;
        this.logger.verbose("PerformanceClient: Emitting performance events", correlationId);
        this.callbacks.forEach(function(callback, callbackId) {
            _this.logger.trace("PerformanceClient: Emitting event to callback " + callbackId, correlationId);
            callback.apply(null, [
                events
            ]);
        });
    };
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     * @param {Set<string>} intFields integral fields.
     */ PerformanceClient.prototype.truncateIntegralFields = function(event, intFields) {
        intFields.forEach(function(key) {
            if (key in event && typeof event[key] === "number") event[key] = Math.floor(event[key]);
        });
    };
    return PerformanceClient;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $3f63c095ec9831d5$export$647004217f4122f0 = /** @class */ function() {
    function StubPerformanceMeasurement() {}
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */ StubPerformanceMeasurement.prototype.startMeasurement = function() {};
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */ StubPerformanceMeasurement.prototype.endMeasurement = function() {};
    StubPerformanceMeasurement.prototype.flushMeasurement = function() {
        return null;
    };
    return StubPerformanceMeasurement;
}();
var $3f63c095ec9831d5$export$c70f2989a65fda3e = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(StubPerformanceClient, _super);
    function StubPerformanceClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StubPerformanceClient.prototype.generateId = function() {
        return "callback-id";
    };
    StubPerformanceClient.prototype.startPerformanceMeasuremeant = function() {
        return new $3f63c095ec9831d5$export$647004217f4122f0();
    };
    StubPerformanceClient.prototype.startPerformanceMeasurement = function() {
        return new $3f63c095ec9831d5$export$647004217f4122f0();
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.calculateQueuedTime = function(preQueueTime, currentTime) {
        return 0;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime) {
        return;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.setPreQueueTime = function(eventName, correlationId) {
        return;
    };
    return StubPerformanceClient;
}((0, $aac62f65fee01d05$export$820526014323765f));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base type for credentials to be stored in the cache: eg: ACCESS_TOKEN, ID_TOKEN etc
 *
 * Key:Value Schema:
 *
 * Key: <home_account_id*>-<environment>-<credential_type>-<client_id>-<realm*>-<target*>-<requestedClaims*>-<scheme*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      tokenType: Matches the authentication scheme for which the token was issued (i.e. Bearer or pop)
 *      requestedClaimsHash: Matches the SHA 256 hash of the claims object included in the token request
 *      userAssertionHash: Matches the SHA 256 hash of the obo_assertion for the OBO flow
 * }
 */ var $65c107818bc998e1$export$39bc12230e4d3f33 = /** @class */ function() {
    function CredentialEntity() {}
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ CredentialEntity.prototype.generateAccountId = function() {
        return CredentialEntity.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
    };
    /**
     * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
     */ CredentialEntity.prototype.generateCredentialId = function() {
        return CredentialEntity.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
    };
    /**
     * Generate target key component as per schema: <target>
     */ CredentialEntity.prototype.generateTarget = function() {
        return CredentialEntity.generateTargetForCacheKey(this.target);
    };
    /**
     * generates credential key
     */ CredentialEntity.prototype.generateCredentialKey = function() {
        return CredentialEntity.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId, this.tokenType, this.requestedClaimsHash);
    };
    /**
     * returns the type of the cache (in this case credential)
     */ CredentialEntity.prototype.generateType = function() {
        switch(this.credentialType){
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).ID_TOKEN;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN:
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).ACCESS_TOKEN;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).REFRESH_TOKEN;
            default:
                throw (0, $859b00ae06117652$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
    };
    /**
     * generates credential key
     * <home_account_id*>-\<environment>-<credential_type>-<client_id>-<realm\*>-<target\*>-<scheme\*>
     */ CredentialEntity.generateCredentialCacheKey = function(homeAccountId, environment, credentialType, clientId, realm, target, familyId, tokenType, requestedClaimsHash) {
        var credentialKey = [
            this.generateAccountIdForCacheKey(homeAccountId, environment),
            this.generateCredentialIdForCacheKey(credentialType, clientId, realm, familyId),
            this.generateTargetForCacheKey(target),
            this.generateClaimsHashForCacheKey(requestedClaimsHash),
            this.generateSchemeForCacheKey(tokenType)
        ];
        return credentialKey.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * generates Account Id for keys
     * @param homeAccountId
     * @param environment
     */ CredentialEntity.generateAccountIdForCacheKey = function(homeAccountId, environment) {
        var accountId = [
            homeAccountId,
            environment
        ];
        return accountId.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generates Credential Id for keys
     * @param credentialType
     * @param realm
     * @param clientId
     * @param familyId
     */ CredentialEntity.generateCredentialIdForCacheKey = function(credentialType, clientId, realm, familyId) {
        var clientOrFamilyId = credentialType === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN ? familyId || clientId : clientId;
        var credentialId = [
            credentialType,
            clientOrFamilyId,
            realm || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        ];
        return credentialId.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate target key component as per schema: <target>
     */ CredentialEntity.generateTargetForCacheKey = function(scopes) {
        return (scopes || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate requested claims key component as per schema: <requestedClaims>
     */ CredentialEntity.generateClaimsHashForCacheKey = function(requestedClaimsHash) {
        return (requestedClaimsHash || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate scheme key componenet as per schema: <scheme>
     */ CredentialEntity.generateSchemeForCacheKey = function(tokenType) {
        /*
         * PoP Tokens and SSH certs include scheme in cache key
         * Cast to lowercase to handle "bearer" from ADFS
         */ return tokenType && tokenType.toLowerCase() !== (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER.toLowerCase() ? tokenType.toLowerCase() : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    return CredentialEntity;
}();



/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class which exposes functions for managing date and time operations.
 */ var $c4ca7dc1578a1e7a$export$3117a0de16ab2854 = /** @class */ function() {
    function TimeUtils() {}
    /**
     * return the current time in Unix time (seconds).
     */ TimeUtils.nowSeconds = function() {
        // Date.getTime() returns in milliseconds.
        return Math.round(new Date().getTime() / 1000.0);
    };
    /**
     * check if a token is expired based on given UTC time in seconds.
     * @param expiresOn
     */ TimeUtils.isTokenExpired = function(expiresOn, offset) {
        // check for access token expiry
        var expirationSec = Number(expiresOn) || 0;
        var offsetCurrentTimeSec = TimeUtils.nowSeconds() + offset;
        // If current time + offset is greater than token expiration time, then token is expired.
        return offsetCurrentTimeSec > expirationSec;
    };
    /**
     * If the current time is earlier than the time that a token was cached at, we must discard the token
     * i.e. The system clock was turned back after acquiring the cached token
     * @param cachedAt
     * @param offset
     */ TimeUtils.wasClockTurnedBack = function(cachedAt) {
        var cachedAtSec = Number(cachedAt);
        return cachedAtSec > TimeUtils.nowSeconds();
    };
    /**
     * Waits for t number of milliseconds
     * @param t number
     * @param value T
     */ TimeUtils.delay = function(t, value) {
        return new Promise(function(resolve) {
            return setTimeout(function() {
                return resolve(value);
            }, t);
        });
    };
    return TimeUtils;
}();



/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * JWT Token representation class. Parses token string and generates claims object.
 */ var $557a50de248ab1f3$export$3a170961dab30083 = /** @class */ function() {
    function AuthToken(rawToken, crypto) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(rawToken)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenNullOrEmptyError(rawToken);
        this.rawToken = rawToken;
        this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
    }
    /**
     * Extract token by decoding the rawToken
     *
     * @param encodedToken
     */ AuthToken.extractTokenClaims = function(encodedToken, crypto) {
        var decodedToken = (0, $33fadf35800e4b73$export$ecc754f99843e759).decodeAuthToken(encodedToken);
        // token will be decoded to get the username
        try {
            var base64TokenPayload = decodedToken.JWSPayload;
            // base64Decode() should throw an error if there is an issue
            var base64Decoded = crypto.base64Decode(base64TokenPayload);
            return JSON.parse(base64Decoded);
        } catch (err) {
            throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenParsingError(err);
        }
    };
    /**
     * Determine if the token's max_age has transpired
     */ AuthToken.checkMaxAge = function(authTime, maxAge) {
        /*
         * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
         * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
         * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
         */ var fiveMinuteSkew = 300000; // five minutes in milliseconds
        if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $859b00ae06117652$export$a839ff85a7957561).createMaxAgeTranspiredError();
    };
    return AuthToken;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ACCESS_TOKEN Credential Type
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-accesstoken-clientId-contoso.com-user.read
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      cachedAt: Absolute device time when entry was created in the cache.
 *      expiresOn: Token expiry time, calculated based on current UTC time in seconds. Represented as a string.
 *      extendedExpiresOn: Additional extended expiry time until when token is valid in case of server-side outage. Represented as string in UTC seconds.
 *      keyId: used for POP and SSH tokenTypes
 *      tokenType: Type of the token issued. Usually "Bearer"
 * }
 */ var $c2e674572252645d$export$6b7a8e14ec177765 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(AccessTokenEntity, _super);
    function AccessTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create AccessTokenEntity
     * @param homeAccountId
     * @param environment
     * @param accessToken
     * @param clientId
     * @param tenantId
     * @param scopes
     * @param expiresOn
     * @param extExpiresOn
     */ AccessTokenEntity.createAccessTokenEntity = function(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, cryptoUtils, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
        var _a, _b;
        var atEntity = new AccessTokenEntity();
        atEntity.homeAccountId = homeAccountId;
        atEntity.credentialType = (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        atEntity.secret = accessToken;
        var currentTime = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
        atEntity.cachedAt = currentTime.toString();
        /*
         * Token expiry time.
         * This value should be  calculated based on the current UTC time measured locally and the value  expires_in Represented as a string in JSON.
         */ atEntity.expiresOn = expiresOn.toString();
        atEntity.extendedExpiresOn = extExpiresOn.toString();
        if (refreshOn) atEntity.refreshOn = refreshOn.toString();
        atEntity.environment = environment;
        atEntity.clientId = clientId;
        atEntity.realm = tenantId;
        atEntity.target = scopes;
        atEntity.userAssertionHash = userAssertionHash;
        atEntity.tokenType = (0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(tokenType) ? (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER : tokenType;
        if (requestedClaims) {
            atEntity.requestedClaims = requestedClaims;
            atEntity.requestedClaimsHash = requestedClaimsHash;
        }
        /*
         * Create Access Token With Auth Scheme instead of regular access token
         * Cast to lower to handle "bearer" from ADFS
         */ if (((_a = atEntity.tokenType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER.toLowerCase()) {
            atEntity.credentialType = (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
            switch(atEntity.tokenType){
                case (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP:
                    // Make sure keyId is present and add it to credential
                    var tokenClaims = (0, $557a50de248ab1f3$export$3a170961dab30083).extractTokenClaims(accessToken, cryptoUtils);
                    if (!((_b = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _b === void 0 ? void 0 : _b.kid)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenClaimsRequiredError();
                    atEntity.keyId = tokenClaims.cnf.kid;
                    break;
                case (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH:
                    atEntity.keyId = keyId;
            }
        }
        return atEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AccessTokenEntity.isAccessTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
    };
    return AccessTokenEntity;
}((0, $65c107818bc998e1$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $6fc13ebc332ded7c$export$575e1419cfbab7f8(rawClientInfo, crypto) {
    if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(rawClientInfo)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createClientInfoEmptyError();
    try {
        var decodedClientInfo = crypto.base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $859b00ae06117652$export$a839ff85a7957561).createClientInfoDecodingError(e.message);
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $6fc13ebc332ded7c$export$63508a6d6b7dbe07(homeAccountId) {
    if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(homeAccountId)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createClientInfoDecodingError("Home account ID was empty.");
    var clientInfoParts = homeAccountId.split((0, $709b0e48f6b53a82$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}




/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ var $974d1aabbdaa4f9c$export$cd82032b224a3839;
(function(AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
    AuthorityType[AuthorityType["Dsts"] = 2] = "Dsts";
    AuthorityType[AuthorityType["Ciam"] = 3] = "Ciam";
})($974d1aabbdaa4f9c$export$cd82032b224a3839 || ($974d1aabbdaa4f9c$export$cd82032b224a3839 = {}));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      clientInfo: Full base64 encoded client info received from ESTS
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      idTokenClaims: Object containing claims parsed from ID token
 *      nativeAccountId: Account identifier on the native device
 * }
 */ var $6ff18147f1afb887$export$680160523e6bfa6a = /** @class */ function() {
    function AccountEntity() {}
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ AccountEntity.prototype.generateAccountId = function() {
        var accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ AccountEntity.prototype.generateAccountKey = function() {
        return AccountEntity.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    };
    /**
     * returns the type of the cache (in this case account)
     */ AccountEntity.prototype.generateType = function() {
        switch(this.authorityType){
            case (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).ADFS;
            case (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).MSAV1_ACCOUNT_TYPE:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).MSA;
            case (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).MSSTS;
            case (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE:
                return (0, $709b0e48f6b53a82$export$ba193b555633db78).GENERIC;
            default:
                throw (0, $859b00ae06117652$export$a839ff85a7957561).createUnexpectedAccountTypeError();
        }
    };
    /**
     * Returns the AccountInfo interface for this account.
     */ AccountEntity.prototype.getAccountInfo = function() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            idTokenClaims: this.idTokenClaims,
            nativeAccountId: this.nativeAccountId
        };
    };
    /**
     * Generates account key from interface
     * @param accountInterface
     */ AccountEntity.generateAccountCacheKey = function(accountInterface) {
        var accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            accountInterface.tenantId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        ];
        return accountKey.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param clientInfo
     * @param authority
     * @param idToken
     * @param policy
     */ AccountEntity.createAccount = function(clientInfo, homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment, nativeAccountId) {
        var _a, _b, _c, _d, _e, _f;
        var account = new AccountEntity();
        account.authorityType = (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        account.clientInfo = clientInfo;
        account.homeAccountId = homeAccountId;
        account.nativeAccountId = nativeAccountId;
        var env = environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.tid) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        if (idToken) {
            account.idTokenClaims = idToken.claims;
            // How do you account for MSA CID here?
            account.localAccountId = ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.oid) || ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.sub) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            /*
             * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
             * In most cases it will contain a single email. This field should not be relied upon if a custom
             * policy is configured to return more than 1 email.
             */ var preferredUsername = (_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.preferred_username;
            var email = ((_e = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _e === void 0 ? void 0 : _e.emails) ? idToken.claims.emails[0] : null;
            account.username = preferredUsername || email || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            account.name = (_f = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _f === void 0 ? void 0 : _f.name;
        }
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        return account;
    };
    /**
     * Builds non-AAD/ADFS account.
     * @param authority
     * @param idToken
     */ AccountEntity.createGenericAccount = function(homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment) {
        var _a, _b, _c, _d;
        var account = new AccountEntity();
        account.authorityType = authority && authority.authorityType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Adfs ? (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE : (0, $709b0e48f6b53a82$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = homeAccountId;
        // non AAD scenarios can have empty realm
        account.realm = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var env = environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        if (idToken) {
            // How do you account for MSA CID here?
            account.localAccountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.oid) || ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.sub) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            // upn claim for most ADFS scenarios
            account.username = ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.upn) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            account.name = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.name) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            account.idTokenClaims = idToken === null || idToken === void 0 ? void 0 : idToken.claims;
        }
        account.environment = env;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        /*
         * add uniqueName to claims
         * account.name = idToken.claims.uniqueName;
         */ return account;
    };
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ AccountEntity.generateHomeAccountId = function(serverClientInfo, authType, logger, cryptoObj, idToken) {
        var _a;
        var accountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.sub) ? idToken.claims.sub : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        // since ADFS does not have tid and does not set client_info
        if (authType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Adfs || authType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Dsts) return accountId;
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            var clientInfo = (0, $6fc13ebc332ded7c$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj);
            if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(clientInfo.uid) && !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(clientInfo.utid)) return "" + clientInfo.uid + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid;
        } catch (e) {}
        // default to "sub" claim
        logger.verbose("No client info in response");
        return accountId;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AccountEntity.isAccountEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    };
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ AccountEntity.accountInfoIsEqual = function(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        var claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            var accountAClaims = accountA.idTokenClaims || {};
            var accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    };
    return AccountEntity;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * APP_METADATA Cache
 *
 * Key:Value Schema:
 *
 * Key: appmetadata-<environment>-<client_id>
 *
 * Value:
 * {
 *      clientId: client ID of the application
 *      environment: entity that issued the token, represented as a full host
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 * }
 */ var $3fe60484fc3744c3$export$b939be19f91a34cc = /** @class */ function() {
    function AppMetadataEntity() {}
    /**
     * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
     */ AppMetadataEntity.prototype.generateAppMetadataKey = function() {
        return AppMetadataEntity.generateAppMetadataCacheKey(this.environment, this.clientId);
    };
    /**
     * Generate AppMetadata Cache Key
     */ AppMetadataEntity.generateAppMetadataCacheKey = function(environment, clientId) {
        var appMetaDataKeyArray = [
            (0, $709b0e48f6b53a82$export$7e1bea6dc1b6b32e),
            environment,
            clientId
        ];
        return appMetaDataKeyArray.join((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Creates AppMetadataEntity
     * @param clientId
     * @param environment
     * @param familyId
     */ AppMetadataEntity.createAppMetadataEntity = function(clientId, environment, familyId) {
        var appMetadata = new AppMetadataEntity();
        appMetadata.clientId = clientId;
        appMetadata.environment = environment;
        if (familyId) appMetadata.familyId = familyId;
        return appMetadata;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AppMetadataEntity.isAppMetadataEntity = function(key, entity) {
        if (!entity) return false;
        return key.indexOf((0, $709b0e48f6b53a82$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
    };
    return AppMetadataEntity;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $a0e50176ce139744$export$49e7dcb371a5f08e = /** @class */ function() {
    function AuthorityMetadataEntity() {
        this.expiresAt = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds() + (0, $709b0e48f6b53a82$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
    }
    /**
     * Update the entity with new aliases, preferred_cache and preferred_network values
     * @param metadata
     * @param fromNetwork
     */ AuthorityMetadataEntity.prototype.updateCloudDiscoveryMetadata = function(metadata, fromNetwork) {
        this.aliases = metadata.aliases;
        this.preferred_cache = metadata.preferred_cache;
        this.preferred_network = metadata.preferred_network;
        this.aliasesFromNetwork = fromNetwork;
    };
    /**
     * Update the entity with new endpoints
     * @param metadata
     * @param fromNetwork
     */ AuthorityMetadataEntity.prototype.updateEndpointMetadata = function(metadata, fromNetwork) {
        this.authorization_endpoint = metadata.authorization_endpoint;
        this.token_endpoint = metadata.token_endpoint;
        this.end_session_endpoint = metadata.end_session_endpoint;
        this.issuer = metadata.issuer;
        this.endpointsFromNetwork = fromNetwork;
        this.jwks_uri = metadata.jwks_uri;
    };
    /**
     * Save the authority that was used to create this cache entry
     * @param authority
     */ AuthorityMetadataEntity.prototype.updateCanonicalAuthority = function(authority) {
        this.canonical_authority = authority;
    };
    /**
     * Reset the exiresAt value
     */ AuthorityMetadataEntity.prototype.resetExpiresAt = function() {
        this.expiresAt = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds() + (0, $709b0e48f6b53a82$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
    };
    /**
     * Returns whether or not the data needs to be refreshed
     */ AuthorityMetadataEntity.prototype.isExpired = function() {
        return this.expiresAt <= (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AuthorityMetadataEntity.isAuthorityMetadataEntity = function(key, entity) {
        if (!entity) return false;
        return key.indexOf((0, $709b0e48f6b53a82$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
    };
    return AuthorityMetadataEntity;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 */ var $969cc688182846d2$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    claimsRequestParsingError: {
        code: "claims_request_parsing_error",
        desc: "Could not parse the given claims request object."
    },
    authorityUriInsecure: {
        code: "authority_uri_insecure",
        desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
    },
    urlParseError: {
        code: "url_parse_error",
        desc: "URL could not be parsed into appropriate segments."
    },
    urlEmptyError: {
        code: "empty_url_error",
        desc: "URL was empty or null."
    },
    emptyScopesError: {
        code: "empty_input_scopes_error",
        desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
    },
    nonArrayScopesError: {
        code: "nonarray_input_scopes_error",
        desc: "Scopes cannot be passed as non-array."
    },
    clientIdSingleScopeError: {
        code: "clientid_input_scopes_error",
        desc: "Client ID can only be provided as a single scope."
    },
    invalidPrompt: {
        code: "invalid_prompt_value",
        desc: "Supported prompt values are 'login', 'select_account', 'consent', 'create', 'none' and 'no_session'.  Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest"
    },
    invalidClaimsRequest: {
        code: "invalid_claims",
        desc: "Given claims parameter must be a stringified JSON object."
    },
    tokenRequestEmptyError: {
        code: "token_request_empty",
        desc: "Token request was empty and not found in cache."
    },
    logoutRequestEmptyError: {
        code: "logout_request_empty",
        desc: "The logout request was null or undefined."
    },
    invalidCodeChallengeMethod: {
        code: "invalid_code_challenge_method",
        desc: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".'
    },
    invalidCodeChallengeParams: {
        code: "pkce_params_missing",
        desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
    },
    invalidCloudDiscoveryMetadata: {
        code: "invalid_cloud_discovery_metadata",
        desc: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields"
    },
    invalidAuthorityMetadata: {
        code: "invalid_authority_metadata",
        desc: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields."
    },
    untrustedAuthority: {
        code: "untrusted_authority",
        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
    },
    invalidAzureCloudInstance: {
        code: "invalid_azure_cloud_instance",
        desc: "Invalid AzureCloudInstance provided. Please refer MSAL JS docs: aks.ms/msaljs/azure_cloud_instance for valid values"
    },
    missingSshJwk: {
        code: "missing_ssh_jwk",
        desc: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme."
    },
    missingSshKid: {
        code: "missing_ssh_kid",
        desc: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme."
    },
    missingNonceAuthenticationHeader: {
        code: "missing_nonce_authentication_header",
        desc: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce."
    },
    invalidAuthenticationHeader: {
        code: "invalid_authentication_header",
        desc: "Invalid authentication header provided"
    },
    authorityMismatch: {
        code: "authority_mismatch",
        desc: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ var $969cc688182846d2$export$ac9d9d20c2327339 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(ClientConfigurationError, _super);
    function ClientConfigurationError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientConfigurationError";
        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */ ClientConfigurationError.createRedirectUriEmptyError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.redirectUriNotSet.code, $969cc688182846d2$export$8a1024301e8298df.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */ ClientConfigurationError.createPostLogoutRedirectUriEmptyError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.postLogoutUriNotSet.code, $969cc688182846d2$export$8a1024301e8298df.postLogoutUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the claims request could not be successfully parsed
     */ ClientConfigurationError.createClaimsRequestParsingError = function(claimsRequestParseError) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.claimsRequestParsingError.code, $969cc688182846d2$export$8a1024301e8298df.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
    };
    /**
     * Creates an error thrown if authority uri is given an insecure protocol.
     * @param urlString
     */ ClientConfigurationError.createInsecureAuthorityUriError = function(urlString) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.authorityUriInsecure.code, $969cc688182846d2$export$8a1024301e8298df.authorityUriInsecure.desc + " Given URI: " + urlString);
    };
    /**
     * Creates an error thrown if URL string does not parse into separate segments.
     * @param urlString
     */ ClientConfigurationError.createUrlParseError = function(urlParseError) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.urlParseError.code, $969cc688182846d2$export$8a1024301e8298df.urlParseError.desc + " Given Error: " + urlParseError);
    };
    /**
     * Creates an error thrown if URL string is empty or null.
     * @param urlString
     */ ClientConfigurationError.createUrlEmptyError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.urlEmptyError.code, $969cc688182846d2$export$8a1024301e8298df.urlEmptyError.desc);
    };
    /**
     * Error thrown when scopes are empty.
     * @param scopesValue
     */ ClientConfigurationError.createEmptyScopesArrayError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.emptyScopesError.code, "" + $969cc688182846d2$export$8a1024301e8298df.emptyScopesError.desc);
    };
    /**
     * Error thrown when client id scope is not provided as single scope.
     * @param inputScopes
     */ ClientConfigurationError.createClientIdSingleScopeError = function(inputScopes) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.clientIdSingleScopeError.code, $969cc688182846d2$export$8a1024301e8298df.clientIdSingleScopeError.desc + " Given Scopes: " + inputScopes);
    };
    /**
     * Error thrown when prompt is not an allowed type.
     * @param promptValue
     */ ClientConfigurationError.createInvalidPromptError = function(promptValue) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidPrompt.code, $969cc688182846d2$export$8a1024301e8298df.invalidPrompt.desc + " Given value: " + promptValue);
    };
    /**
     * Creates error thrown when claims parameter is not a stringified JSON object
     */ ClientConfigurationError.createInvalidClaimsRequestError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidClaimsRequest.code, $969cc688182846d2$export$8a1024301e8298df.invalidClaimsRequest.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */ ClientConfigurationError.createEmptyLogoutRequestError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.logoutRequestEmptyError.code, $969cc688182846d2$export$8a1024301e8298df.logoutRequestEmptyError.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */ ClientConfigurationError.createEmptyTokenRequestError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.tokenRequestEmptyError.code, $969cc688182846d2$export$8a1024301e8298df.tokenRequestEmptyError.desc);
    };
    /**
     * Throws error when an invalid code_challenge_method is passed by the user
     */ ClientConfigurationError.createInvalidCodeChallengeMethodError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidCodeChallengeMethod.code, $969cc688182846d2$export$8a1024301e8298df.invalidCodeChallengeMethod.desc);
    };
    /**
     * Throws error when both params: code_challenge and code_challenge_method are not passed together
     */ ClientConfigurationError.createInvalidCodeChallengeParamsError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidCodeChallengeParams.code, $969cc688182846d2$export$8a1024301e8298df.invalidCodeChallengeParams.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */ ClientConfigurationError.createInvalidCloudDiscoveryMetadataError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidCloudDiscoveryMetadata.code, $969cc688182846d2$export$8a1024301e8298df.invalidCloudDiscoveryMetadata.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */ ClientConfigurationError.createInvalidAuthorityMetadataError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidAuthorityMetadata.code, $969cc688182846d2$export$8a1024301e8298df.invalidAuthorityMetadata.desc);
    };
    /**
     * Throws error when provided authority is not a member of the trusted host list
     */ ClientConfigurationError.createUntrustedAuthorityError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.untrustedAuthority.code, $969cc688182846d2$export$8a1024301e8298df.untrustedAuthority.desc);
    };
    /**
     * Throws error when the AzureCloudInstance is set to an invalid value
     */ ClientConfigurationError.createInvalidAzureCloudInstanceError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidAzureCloudInstance.code, $969cc688182846d2$export$8a1024301e8298df.invalidAzureCloudInstance.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key is omitted from the request
     */ ClientConfigurationError.createMissingSshJwkError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.missingSshJwk.code, $969cc688182846d2$export$8a1024301e8298df.missingSshJwk.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key ID is omitted from the request
     */ ClientConfigurationError.createMissingSshKidError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.missingSshKid.code, $969cc688182846d2$export$8a1024301e8298df.missingSshKid.desc);
    };
    /**
     * Throws error when provided headers don't contain a header that a server nonce can be extracted from
     */ ClientConfigurationError.createMissingNonceAuthenticationHeadersError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.missingNonceAuthenticationHeader.code, $969cc688182846d2$export$8a1024301e8298df.missingNonceAuthenticationHeader.desc);
    };
    /**
     * Throws error when a provided header is invalid in any way
     */ ClientConfigurationError.createInvalidAuthenticationHeaderError = function(invalidHeaderName, details) {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.invalidAuthenticationHeader.code, $969cc688182846d2$export$8a1024301e8298df.invalidAuthenticationHeader.desc + ". Invalid header: " + invalidHeaderName + ". Details: " + details);
    };
    /**
     * Create an error when the authority provided in request does not match authority provided in account or MSAL.js configuration.
     */ ClientConfigurationError.createAuthorityMismatchError = function() {
        return new ClientConfigurationError($969cc688182846d2$export$8a1024301e8298df.authorityMismatch.code, $969cc688182846d2$export$8a1024301e8298df.authorityMismatch.desc);
    };
    return ClientConfigurationError;
}((0, $859b00ae06117652$export$a839ff85a7957561));





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ var $57be63d7f846af92$export$b9b82b0f94ae1f99 = /** @class */ function() {
    function ScopeSet(inputScopes) {
        var _this = this;
        // Filter empty string and null/undefined array items
        var scopeArr = inputScopes ? (0, $33fadf35800e4b73$export$ecc754f99843e759).trimArrayEntries((0, $a296cc98de023397$export$6388937ca91ccae8)(inputScopes)) : [];
        var filteredInput = scopeArr ? (0, $33fadf35800e4b73$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach(function(scope) {
            return _this.scopes.add(scope);
        });
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ ScopeSet.fromString = function(inputScopeString) {
        var scopeString = inputScopeString || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var inputScopes = scopeString.split(" ");
        return new ScopeSet(inputScopes);
    };
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ ScopeSet.createSearchScopes = function(inputScopeString) {
        var scopeSet = new ScopeSet(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $709b0e48f6b53a82$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    };
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */ ScopeSet.prototype.validateInputScopes = function(inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createEmptyScopesArrayError();
    };
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ ScopeSet.prototype.containsScope = function(scope) {
        var lowerCaseScopes = this.printScopesLowerCase().split(" ");
        var lowerCaseScopesSet = new ScopeSet(lowerCaseScopes);
        // compare lowercase scopes
        return !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(scope) ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    };
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ ScopeSet.prototype.containsScopeSet = function(scopeSet) {
        var _this = this;
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every(function(scope) {
            return _this.containsScope(scope);
        });
    };
    /**
     * Check if set of scopes contains only the defaults
     */ ScopeSet.prototype.containsOnlyOIDCScopes = function() {
        var _this = this;
        var defaultScopeCount = 0;
        (0, $709b0e48f6b53a82$export$268e88275f5afab2).forEach(function(defaultScope) {
            if (_this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    };
    /**
     * Appends single scope if passed
     * @param newScope
     */ ScopeSet.prototype.appendScope = function(newScope) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(newScope)) this.scopes.add(newScope.trim());
    };
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ ScopeSet.prototype.appendScopes = function(newScopes) {
        var _this = this;
        try {
            newScopes.forEach(function(newScope) {
                return _this.appendScope(newScope);
            });
        } catch (e) {
            throw (0, $859b00ae06117652$export$a839ff85a7957561).createAppendScopeSetError(e);
        }
    };
    /**
     * Removes element from set of scopes.
     * @param scope
     */ ScopeSet.prototype.removeScope = function(scope) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(scope)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createRemoveEmptyScopeFromSetError(scope);
        this.scopes.delete(scope.trim());
    };
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ ScopeSet.prototype.removeOIDCScopes = function() {
        var _this = this;
        (0, $709b0e48f6b53a82$export$268e88275f5afab2).forEach(function(defaultScope) {
            _this.scopes.delete(defaultScope);
        });
    };
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ ScopeSet.prototype.unionScopeSets = function(otherScopes) {
        if (!otherScopes) throw (0, $859b00ae06117652$export$a839ff85a7957561).createEmptyInputScopeSetError();
        var unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach(function(scope) {
            return unionScopes.add(scope.toLowerCase());
        });
        this.scopes.forEach(function(scope) {
            return unionScopes.add(scope.toLowerCase());
        });
        return unionScopes;
    };
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ ScopeSet.prototype.intersectingScopeSets = function(otherScopes) {
        if (!otherScopes) throw (0, $859b00ae06117652$export$a839ff85a7957561).createEmptyInputScopeSetError();
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        var unionScopes = this.unionScopeSets(otherScopes);
        var sizeOtherScopes = otherScopes.getScopeCount();
        var sizeThisScopes = this.getScopeCount();
        var sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    };
    /**
     * Returns size of set of scopes.
     */ ScopeSet.prototype.getScopeCount = function() {
        return this.scopes.size;
    };
    /**
     * Returns the scopes as an array of string values
     */ ScopeSet.prototype.asArray = function() {
        var array = [];
        this.scopes.forEach(function(val) {
            return array.push(val);
        });
        return array;
    };
    /**
     * Prints scopes into a space-delimited string
     */ ScopeSet.prototype.printScopes = function() {
        if (this.scopes) {
            var scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ ScopeSet.prototype.printScopesLowerCase = function() {
        return this.printScopes().toLowerCase();
    };
    return ScopeSet;
}();






/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/* eslint-disable header/header */ var $c148700c4e017537$export$a8ff84c12d48cfa6 = "@azure/msal-common";
var $c148700c4e017537$export$83d89fbfd8236492 = "13.3.1";


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 */ var $673bcd64dd27ec5e$export$996e3ea69314b5c6 = /** @class */ function() {
    function CacheManager(clientId, cryptoImpl, logger) {
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $c148700c4e017537$export$a8ff84c12d48cfa6), (0, $c148700c4e017537$export$83d89fbfd8236492));
    }
    /**
     * Returns all accounts in cache
     */ CacheManager.prototype.getAllAccounts = function() {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        if (allAccountKeys.length < 1) return [];
        var accountEntities = allAccountKeys.reduce(function(accounts, key) {
            var entity = _this.getAccount(key);
            if (!entity) return accounts;
            accounts.push(entity);
            return accounts;
        }, []);
        if (accountEntities.length < 1) return [];
        else {
            var allAccounts = accountEntities.map(function(accountEntity) {
                return _this.getAccountInfoFromEntity(accountEntity);
            });
            return allAccounts;
        }
    };
    /**
     * Gets accountInfo object based on provided filters
     */ CacheManager.prototype.getAccountInfoFilteredBy = function(accountFilter) {
        var allAccounts = this.getAccountsFilteredBy(accountFilter);
        if (allAccounts.length > 0) return this.getAccountInfoFromEntity(allAccounts[0]);
        else return null;
    };
    CacheManager.prototype.getAccountInfoFromEntity = function(accountEntity) {
        var accountInfo = accountEntity.getAccountInfo();
        var idToken = this.getIdToken(accountInfo);
        if (idToken) {
            accountInfo.idToken = idToken.secret;
            accountInfo.idTokenClaims = new (0, $557a50de248ab1f3$export$3a170961dab30083)(idToken.secret, this.cryptoImpl).claims;
        }
        return accountInfo;
    };
    /**
     * saves a cache record
     * @param cacheRecord
     */ CacheManager.prototype.saveCacheRecord = function(cacheRecord) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!cacheRecord) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNullOrUndefinedCacheRecord();
                        if (!!cacheRecord.account) this.setAccount(cacheRecord.account);
                        if (!!cacheRecord.idToken) this.setIdTokenCredential(cacheRecord.idToken);
                        if (!!!cacheRecord.accessToken) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.saveAccessToken(cacheRecord.accessToken)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!cacheRecord.refreshToken) this.setRefreshTokenCredential(cacheRecord.refreshToken);
                        if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * saves access token credential
     * @param credential
     */ CacheManager.prototype.saveAccessToken = function(credential) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var accessTokenFilter, tokenKeys, currentScopes, removedAccessTokens;
            var _this = this;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        accessTokenFilter = {
                            clientId: credential.clientId,
                            credentialType: credential.credentialType,
                            environment: credential.environment,
                            homeAccountId: credential.homeAccountId,
                            realm: credential.realm,
                            tokenType: credential.tokenType,
                            requestedClaimsHash: credential.requestedClaimsHash
                        };
                        tokenKeys = this.getTokenKeys();
                        currentScopes = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(credential.target);
                        removedAccessTokens = [];
                        tokenKeys.accessToken.forEach(function(key) {
                            if (!_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
                            var tokenEntity = _this.getAccessTokenCredential(key);
                            if (tokenEntity && _this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                                var tokenScopeSet = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                                if (tokenScopeSet.intersectingScopeSets(currentScopes)) removedAccessTokens.push(_this.removeAccessToken(key));
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedAccessTokens)
                        ];
                    case 1:
                        _a.sent();
                        this.setAccessTokenCredential(credential);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param homeAccountId
     * @param environment
     * @param realm
     */ CacheManager.prototype.getAccountsFilteredBy = function(accountFilter) {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        var matchingAccounts = [];
        allAccountKeys.forEach(function(cacheKey) {
            if (!_this.isAccountKey(cacheKey, accountFilter.homeAccountId, accountFilter.realm)) // Don't parse value if the key doesn't match the account filters
            return;
            var entity = _this.getAccount(cacheKey);
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !_this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.localAccountId && !_this.matchLocalAccountId(entity, accountFilter.localAccountId)) return;
            if (!!accountFilter.username && !_this.matchUsername(entity, accountFilter.username)) return;
            if (!!accountFilter.environment && !_this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !_this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !_this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    };
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ CacheManager.prototype.isAccountKey = function(key, homeAccountId, tenantId) {
        if (key.split((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    };
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ CacheManager.prototype.isCredentialKey = function(key) {
        if (key.split((0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        var lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            var clientIdValidation = "" + (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + this.clientId + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR;
            var familyIdValidation = "" + (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + (0, $709b0e48f6b53a82$export$978fe7ab5e74b539) + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    };
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ CacheManager.prototype.credentialMatchesFilter = function(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    };
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ CacheManager.prototype.getAppMetadataFilteredBy = function(filter) {
        return this.getAppMetadataFilteredByInternal(filter.environment, filter.clientId);
    };
    /**
     * Support function to help match appMetadata
     * @param environment
     * @param clientId
     */ CacheManager.prototype.getAppMetadataFilteredByInternal = function(environment, clientId) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingAppMetadata = {};
        allCacheKeys.forEach(function(cacheKey) {
            // don't parse any non-appMetadata type cache entities
            if (!_this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            var entity = _this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!environment && !_this.matchEnvironment(entity, environment)) return;
            if (!!clientId && !_this.matchClientId(entity, clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    };
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ CacheManager.prototype.getAuthorityMetadataByAlias = function(host) {
        var _this = this;
        var allCacheKeys = this.getAuthorityMetadataKeys();
        var matchedEntity = null;
        allCacheKeys.forEach(function(cacheKey) {
            // don't parse any non-authorityMetadata type cache entities
            if (!_this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(_this.clientId) === -1) return;
            // Attempt retrieval
            var entity = _this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    };
    /**
     * Removes all accounts and related tokens from cache.
     */ CacheManager.prototype.removeAllAccounts = function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allAccountKeys, removedAccounts;
            var _this = this;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        allAccountKeys = this.getAccountKeys();
                        removedAccounts = [];
                        allAccountKeys.forEach(function(cacheKey) {
                            removedAccounts.push(_this.removeAccount(cacheKey));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedAccounts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ CacheManager.prototype.removeAccount = function(accountKey) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var account;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        account = this.getAccount(accountKey);
                        if (!account) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAccountFoundError();
                        return [
                            4 /*yield*/ ,
                            this.removeAccountContext(account)
                        ];
                    case 1:
                        _a.sent();
                        this.removeItem(accountKey);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ CacheManager.prototype.removeAccountContext = function(account) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allTokenKeys, accountId, removedCredentials;
            var _this = this;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        allTokenKeys = this.getTokenKeys();
                        accountId = account.generateAccountId();
                        removedCredentials = [];
                        allTokenKeys.idToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) _this.removeIdToken(key);
                        });
                        allTokenKeys.accessToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) removedCredentials.push(_this.removeAccessToken(key));
                        });
                        allTokenKeys.refreshToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) _this.removeRefreshToken(key);
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedCredentials)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ CacheManager.prototype.removeAccessToken = function(key) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credential, accessTokenWithAuthSchemeEntity, kid;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        credential = this.getAccessTokenCredential(key);
                        if (!credential) return [
                            2 /*return*/ 
                        ];
                        if (!(credential.credentialType.toLowerCase() === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase())) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(credential.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            4
                        ];
                        accessTokenWithAuthSchemeEntity = credential;
                        kid = accessTokenWithAuthSchemeEntity.keyId;
                        if (!kid) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cryptoImpl.removeTokenBindingKey(kid)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a.sent();
                        throw (0, $859b00ae06117652$export$a839ff85a7957561).createBindingKeyNotRemovedError();
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.removeItem(key)
                        ];
                }
            });
        });
    };
    /**
     * Removes all app metadata objects from cache.
     */ CacheManager.prototype.removeAppMetadata = function() {
        var _this = this;
        var allCacheKeys = this.getKeys();
        allCacheKeys.forEach(function(cacheKey) {
            if (_this.isAppMetadata(cacheKey)) _this.removeItem(cacheKey);
        });
        return true;
    };
    /**
     * Retrieve the cached credentials into a cacherecord
     * @param account
     * @param clientId
     * @param scopes
     * @param environment
     * @param authScheme
     */ CacheManager.prototype.readCacheRecord = function(account, request, environment) {
        var tokenKeys = this.getTokenKeys();
        var cachedAccount = this.readAccountFromCache(account);
        var cachedIdToken = this.getIdToken(account, tokenKeys);
        var cachedAccessToken = this.getAccessToken(account, request, tokenKeys);
        var cachedRefreshToken = this.getRefreshToken(account, false, tokenKeys);
        var cachedAppMetadata = this.readAppMetadataFromCache(environment);
        if (cachedAccount && cachedIdToken) cachedAccount.idTokenClaims = new (0, $557a50de248ab1f3$export$3a170961dab30083)(cachedIdToken.secret, this.cryptoImpl).claims;
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    };
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ CacheManager.prototype.readAccountFromCache = function(account) {
        var accountKey = (0, $6ff18147f1afb887$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey);
    };
    /**
     * Retrieve IdTokenEntity from cache
     * @param clientId
     * @param account
     * @param inputRealm
     */ CacheManager.prototype.getIdToken = function(account, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getIdToken called");
        var idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: account.tenantId
        };
        var idTokens = this.getIdTokensByFilter(idTokenFilter, tokenKeys);
        var numIdTokens = idTokens.length;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            this.commonLogger.info("CacheManager:getIdToken - Multiple id tokens found, clearing them");
            idTokens.forEach(function(idToken) {
                _this.removeIdToken(idToken.generateCredentialKey());
            });
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning id token");
        return idTokens[0];
    };
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ CacheManager.prototype.getIdTokensByFilter = function(filter, tokenKeys) {
        var _this = this;
        var idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        var idTokens = [];
        idTokenKeys.forEach(function(key) {
            if (!_this.idTokenKeyMatchesFilter(key, (0, $a296cc98de023397$export$18ce0697a983be9b)({
                clientId: _this.clientId
            }, filter))) return;
            var idToken = _this.getIdTokenCredential(key);
            if (idToken && _this.credentialMatchesFilter(idToken, filter)) idTokens.push(idToken);
        });
        return idTokens;
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ CacheManager.prototype.idTokenKeyMatchesFilter = function(inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    };
    /**
     * Removes idToken from the cache
     * @param key
     */ CacheManager.prototype.removeIdToken = function(key) {
        this.removeItem(key);
    };
    /**
     * Removes refresh token from the cache
     * @param key
     */ CacheManager.prototype.removeRefreshToken = function(key) {
        this.removeItem(key);
    };
    /**
     * Retrieve AccessTokenEntity from cache
     * @param clientId
     * @param account
     * @param scopes
     * @param authScheme
     */ CacheManager.prototype.getAccessToken = function(account, request, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getAccessToken called");
        var scopes = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        var authScheme = request.authenticationScheme || (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ var credentialType = authScheme && authScheme.toLowerCase() !== (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        var accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        var accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        var accessTokens = [];
        accessTokenKeys.forEach(function(key) {
            // Validate key
            if (_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                var accessToken = _this.getAccessTokenCredential(key);
                // Validate value
                if (accessToken && _this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        var numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach(function(accessToken) {
                _this.removeAccessToken(accessToken.generateCredentialKey());
            });
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ CacheManager.prototype.accessTokenKeyMatchesFilter = function(inputKey, filter, keyMustContainAllScopes) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            var scopes = filter.target.asArray();
            for(var i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    };
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ CacheManager.prototype.getAccessTokensByFilter = function(filter) {
        var _this = this;
        var tokenKeys = this.getTokenKeys();
        var accessTokens = [];
        tokenKeys.accessToken.forEach(function(key) {
            if (!_this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            var accessToken = _this.getAccessTokenCredential(key);
            if (accessToken && _this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    };
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param clientId
     * @param account
     * @param familyRT
     */ CacheManager.prototype.getRefreshToken = function(account, familyRT, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        var id = familyRT ? (0, $709b0e48f6b53a82$export$978fe7ab5e74b539) : undefined;
        var refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        var refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        var refreshTokens = [];
        refreshTokenKeys.forEach(function(key) {
            // Validate key
            if (_this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                var refreshToken = _this.getRefreshTokenCredential(key);
                // Validate value
                if (refreshToken && _this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        var numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ CacheManager.prototype.refreshTokenKeyMatchesFilter = function(inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    };
    /**
     * Retrieve AppMetadataEntity from cache
     */ CacheManager.prototype.readAppMetadataFromCache = function(environment) {
        var appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        var appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        var appMetadataEntries = Object.keys(appMetadata).map(function(key) {
            return appMetadata[key];
        });
        var numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $859b00ae06117652$export$a839ff85a7957561).createMultipleMatchingAppMetadataInCacheError();
        return appMetadataEntries[0];
    };
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ CacheManager.prototype.isAppMetadataFOCI = function(environment) {
        var appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $709b0e48f6b53a82$export$978fe7ab5e74b539));
    };
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ CacheManager.prototype.matchHomeAccountId = function(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    };
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ CacheManager.prototype.matchLocalAccountId = function(entity, localAccountId) {
        return !!(typeof entity.localAccountId === "string" && localAccountId === entity.localAccountId);
    };
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ CacheManager.prototype.matchUsername = function(entity, username) {
        return !!(typeof entity.username === "string" && username.toLowerCase() === entity.username.toLowerCase());
    };
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ CacheManager.prototype.matchUserAssertionHash = function(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    };
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ CacheManager.prototype.matchEnvironment = function(entity, environment) {
        var cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    };
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ CacheManager.prototype.matchCredentialType = function(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    };
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ CacheManager.prototype.matchClientId = function(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    };
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ CacheManager.prototype.matchFamilyId = function(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    };
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ CacheManager.prototype.matchRealm = function(entity, realm) {
        return !!(entity.realm && realm === entity.realm);
    };
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ CacheManager.prototype.matchNativeAccountId = function(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    };
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ CacheManager.prototype.matchTarget = function(entity, target) {
        var isNotAccessTokenCredential = entity.credentialType !== (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        var entityScopeSet = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    };
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ CacheManager.prototype.matchTokenType = function(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    };
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ CacheManager.prototype.matchKeyId = function(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    };
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ CacheManager.prototype.isAppMetadata = function(key) {
        return key.indexOf((0, $709b0e48f6b53a82$export$7e1bea6dc1b6b32e)) !== -1;
    };
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ CacheManager.prototype.isAuthorityMetadata = function(key) {
        return key.indexOf((0, $709b0e48f6b53a82$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    };
    /**
     * returns cache key used for cloud instance metadata
     */ CacheManager.prototype.generateAuthorityMetadataCacheKey = function(authority) {
        return (0, $709b0e48f6b53a82$export$d483f966e66f4db5).CACHE_KEY + "-" + this.clientId + "-" + authority;
    };
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ CacheManager.toObject = function(obj, json) {
        for(var propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    };
    return CacheManager;
}();
var $673bcd64dd27ec5e$export$b7254d304b3004b6 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(DefaultStorageClass, _super);
    function DefaultStorageClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultStorageClass.prototype.setAccount = function() {
        var notImplErr = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccount = function() {
        var notImplErr = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setIdTokenCredential = function() {
        var notImplErr = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getIdTokenCredential = function() {
        var notImplErr = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAccessTokenCredential = function() {
        var notImplErr = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccessTokenCredential = function() {
        var notImplErr = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setRefreshTokenCredential = function() {
        var notImplErr = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getRefreshTokenCredential = function() {
        var notImplErr = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAppMetadata = function() {
        var notImplErr = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAppMetadata = function() {
        var notImplErr = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setServerTelemetry = function() {
        var notImplErr = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getServerTelemetry = function() {
        var notImplErr = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAuthorityMetadata = function() {
        var notImplErr = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadata = function() {
        var notImplErr = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadataKeys = function() {
        var notImplErr = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setThrottlingCache = function() {
        var notImplErr = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getThrottlingCache = function() {
        var notImplErr = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.removeItem = function() {
        var notImplErr = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.containsKey = function() {
        var notImplErr = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getKeys = function() {
        var notImplErr = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccountKeys = function() {
        var notImplErr = "Storage interface - getAccountKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getTokenKeys = function() {
        var notImplErr = "Storage interface - getTokenKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.clear = function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Storage interface - clear() has not been implemented for the cacheStorage interface.";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    };
    DefaultStorageClass.prototype.updateCredentialCacheKey = function() {
        var notImplErr = "Storage interface - updateCredentialCacheKey() has not been implemented for the cacheStorage interface.";
        throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    return DefaultStorageClass;
}($673bcd64dd27ec5e$export$996e3ea69314b5c6);

/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $531468341ade26af$export$17b7b3ac1abef49f;
(function(CcsCredentialType) {
    CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
    CcsCredentialType["UPN"] = "UPN";
})($531468341ade26af$export$17b7b3ac1abef49f || ($531468341ade26af$export$17b7b3ac1abef49f = {}));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ID_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-idtoken-clientId-contoso.com-
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      realm: Full tenant or organizational identifier that the account belongs to
 * }
 */ var $7ca7a2bf38aafdcd$export$49ed297fa7d02bde = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(IdTokenEntity, _super);
    function IdTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create IdTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */ IdTokenEntity.createIdTokenEntity = function(homeAccountId, environment, idToken, clientId, tenantId) {
        var idTokenEntity = new IdTokenEntity();
        idTokenEntity.credentialType = (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN;
        idTokenEntity.homeAccountId = homeAccountId;
        idTokenEntity.environment = environment;
        idTokenEntity.clientId = clientId;
        idTokenEntity.secret = idToken;
        idTokenEntity.realm = tenantId;
        return idTokenEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ IdTokenEntity.isIdTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity["credentialType"] === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN;
    };
    return IdTokenEntity;
}((0, $65c107818bc998e1$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ var $d3c398c9af34ca18$export$871e33217042c65e = /** @class */ function() {
    function ProtocolUtils() {}
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ ProtocolUtils.setRequestState = function(cryptoObj, userState, meta) {
        var libraryState = ProtocolUtils.generateLibraryState(cryptoObj, meta);
        return !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(userState) ? "" + libraryState + (0, $709b0e48f6b53a82$export$a002182e51710d39).RESOURCE_DELIM + userState : libraryState;
    };
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ ProtocolUtils.generateLibraryState = function(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoCryptoObjectError("generateLibraryState");
        // Create a state object containing a unique id and the timestamp of the request creation
        var stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        var stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    };
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ ProtocolUtils.parseRequestState = function(cryptoObj, state) {
        if (!cryptoObj) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoCryptoObjectError("parseRequestState");
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(state)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidStateError(state, "Null, undefined or empty state");
        try {
            // Split the state between library state and user passed state and decode them separately
            var splitState = state.split((0, $709b0e48f6b53a82$export$a002182e51710d39).RESOURCE_DELIM);
            var libraryState = splitState[0];
            var userState = splitState.length > 1 ? splitState.slice(1).join((0, $709b0e48f6b53a82$export$a002182e51710d39).RESOURCE_DELIM) : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            var libraryStateString = cryptoObj.base64Decode(libraryState);
            var libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(userState) ? userState : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidStateError(state, e);
        }
    };
    return ProtocolUtils;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * REFRESH_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
 *
 * Value:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 * }
 */ var $ced2d4950dbd0255$export$2f7722c9adbc0a1b = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(RefreshTokenEntity, _super);
    function RefreshTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create RefreshTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */ RefreshTokenEntity.createRefreshTokenEntity = function(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash) {
        var rtEntity = new RefreshTokenEntity();
        rtEntity.clientId = clientId;
        rtEntity.credentialType = (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN;
        rtEntity.environment = environment;
        rtEntity.homeAccountId = homeAccountId;
        rtEntity.secret = refreshToken;
        rtEntity.userAssertionHash = userAssertionHash;
        if (familyId) rtEntity.familyId = familyId;
        return rtEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ RefreshTokenEntity.isRefreshTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity["credentialType"] === (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN;
    };
    return RefreshTokenEntity;
}((0, $65c107818bc998e1$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $87bb5d62a25750b6$export$ff670b37c5e10296 = /** @class */ function() {
    function ServerTelemetryEntity() {
        this.failedRequests = [];
        this.errors = [];
        this.cacheHits = 0;
    }
    /**
     * validates if a given cache entry is "Telemetry", parses <key,value>
     * @param key
     * @param entity
     */ ServerTelemetryEntity.isServerTelemetryEntity = function(key, entity) {
        var validateKey = key.indexOf((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
        var validateEntity = true;
        if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
        return validateKey && validateEntity;
    };
    return ServerTelemetryEntity;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $7c9010589300d207$export$15b974958510ada9 = /** @class */ function() {
    function ThrottlingEntity() {}
    /**
     * validates if a given cache entry is "Throttling", parses <key,value>
     * @param key
     * @param entity
     */ ThrottlingEntity.isThrottlingEntity = function(key, entity) {
        var validateKey = false;
        if (key) validateKey = key.indexOf((0, $709b0e48f6b53a82$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
        var validateEntity = true;
        if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
        return validateKey && validateEntity;
    };
    return ThrottlingEntity;
}();




/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $5ad3654d70d3fe4a$export$2baa60fa09b100be = /** @class */ function() {
    function BrowserStorage(cacheLocation) {
        this.validateWindowStorage(cacheLocation);
        this.windowStorage = window[cacheLocation];
    }
    BrowserStorage.prototype.validateWindowStorage = function(cacheLocation) {
        if (cacheLocation !== (0, $0f344e7ceaf1df75$export$573384e47a12d835).LocalStorage && cacheLocation !== (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage) throw (0, $320409a2968f9f12$export$2eb7a1dfdc4c5fba).createStorageNotSupportedError(cacheLocation);
        var storageSupported = !!window[cacheLocation];
        if (!storageSupported) throw (0, $320409a2968f9f12$export$2eb7a1dfdc4c5fba).createStorageNotSupportedError(cacheLocation);
    };
    BrowserStorage.prototype.getItem = function(key) {
        return this.windowStorage.getItem(key);
    };
    BrowserStorage.prototype.setItem = function(key, value) {
        this.windowStorage.setItem(key, value);
    };
    BrowserStorage.prototype.removeItem = function(key) {
        this.windowStorage.removeItem(key);
    };
    BrowserStorage.prototype.getKeys = function() {
        return Object.keys(this.windowStorage);
    };
    BrowserStorage.prototype.containsKey = function(key) {
        return this.windowStorage.hasOwnProperty(key);
    };
    return BrowserStorage;
}();



/*! @azure/msal-browser v2.38.3 2023-10-27 */ /*! @azure/msal-common v13.3.1 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ var $adf27a3fcf515e87$export$3abcdca7229e54f2 = /** @class */ function() {
    function UrlString(url) {
        this._urlString = url;
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(this._urlString)) // Throws error if url is empty
        throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlEmptyError();
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(this.getHash())) this._urlString = UrlString.canonicalizeUri(url);
    }
    Object.defineProperty(UrlString.prototype, "urlString", {
        get: function() {
            return this._urlString;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ UrlString.canonicalizeUri = function(url) {
        if (url) {
            var lowerCaseUrl = url.toLowerCase();
            if ((0, $33fadf35800e4b73$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $33fadf35800e4b73$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    };
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ UrlString.prototype.validateAsUri = function() {
        // Attempts to parse url for uri components
        var components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlParseError(e);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + this.urlString);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInsecureAuthorityUriError(this.urlString);
    };
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ UrlString.appendQueryString = function(url, queryString) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(queryString)) return url;
        return url.indexOf("?") < 0 ? url + "?" + queryString : url + "&" + queryString;
    };
    /**
     * Returns a url with the hash removed
     * @param url
     */ UrlString.removeHashFromUrl = function(url) {
        return UrlString.canonicalizeUri(url.split("#")[0]);
    };
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ UrlString.prototype.replaceTenantPath = function(tenantId) {
        var urlObject = this.getUrlComponents();
        var pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $709b0e48f6b53a82$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $709b0e48f6b53a82$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return UrlString.constructAuthorityUriFromObject(urlObject);
    };
    /**
     * Returns the anchor part(#) of the URL
     */ UrlString.prototype.getHash = function() {
        return UrlString.parseHash(this.urlString);
    };
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ UrlString.prototype.getUrlComponents = function() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        var match = this.urlString.match(regEx);
        if (!match) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + this.urlString);
        // Url component object
        var urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        var pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter(function(val) {
            return val && val.length > 0;
        }); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(urlComponents.QueryString) && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    };
    UrlString.getDomainFromUrl = function(url) {
        var regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        var match = url.match(regEx);
        if (!match) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + url);
        return match[2];
    };
    UrlString.getAbsoluteUrl = function(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $709b0e48f6b53a82$export$a002182e51710d39).FORWARD_SLASH) {
            var url = new UrlString(baseUrl);
            var baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    };
    /**
     * Parses hash string from given string. Returns empty string if no hash symbol is found.
     * @param hashString
     */ UrlString.parseHash = function(hashString) {
        var hashIndex1 = hashString.indexOf("#");
        var hashIndex2 = hashString.indexOf("#/");
        if (hashIndex2 > -1) return hashString.substring(hashIndex2 + 2);
        else if (hashIndex1 > -1) return hashString.substring(hashIndex1 + 1);
        return (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Parses query string from given string. Returns empty string if no query symbol is found.
     * @param queryString
     */ UrlString.parseQueryString = function(queryString) {
        var queryIndex1 = queryString.indexOf("?");
        var queryIndex2 = queryString.indexOf("/?");
        if (queryIndex2 > -1) return queryString.substring(queryIndex2 + 2);
        else if (queryIndex1 > -1) return queryString.substring(queryIndex1 + 1);
        return (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    UrlString.constructAuthorityUriFromObject = function(urlObject) {
        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    };
    /**
     * Returns URL hash as server auth code response object.
     */ UrlString.getDeserializedHash = function(hash) {
        // Check if given hash is empty
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(hash)) return {};
        // Strip the # symbol if present
        var parsedHash = UrlString.parseHash(hash);
        // If # symbol was not present, above will return empty string, so give original hash value
        var deserializedHash = (0, $33fadf35800e4b73$export$ecc754f99843e759).queryStringToObject((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(parsedHash) ? hash : parsedHash);
        // Check if deserialization didn't work
        if (!deserializedHash) throw (0, $859b00ae06117652$export$a839ff85a7957561).createHashNotDeserializedError(JSON.stringify(deserializedHash));
        return deserializedHash;
    };
    /**
     * Returns URL query string as server auth code response object.
     */ UrlString.getDeserializedQueryString = function(query) {
        // Check if given query is empty
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(query)) return {};
        // Strip the ? symbol if present
        var parsedQueryString = UrlString.parseQueryString(query);
        // If ? symbol was not present, above will return empty string, so give original query value
        var deserializedQueryString = (0, $33fadf35800e4b73$export$ecc754f99843e759).queryStringToObject((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(parsedQueryString) ? query : parsedQueryString);
        // Check if deserialization didn't work
        if (!deserializedQueryString) throw (0, $859b00ae06117652$export$a839ff85a7957561).createHashNotDeserializedError(JSON.stringify(deserializedQueryString));
        return deserializedQueryString;
    };
    /**
     * Check if the hash of the URL string contains known properties
     */ UrlString.hashContainsKnownProperties = function(hash) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(hash) || hash.indexOf("=") < 0) // Hash doesn't contain key/value pairs
        return false;
        var parameters = UrlString.getDeserializedHash(hash);
        return !!(parameters.code || parameters.error_description || parameters.error || parameters.state);
    };
    return UrlString;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $e57b35ef8cb8f153$export$83c579d74a9d4ed7 = /** @class */ function() {
    function BrowserProtocolUtils() {}
    /**
     * Extracts the BrowserStateObject from the state string.
     * @param browserCrypto
     * @param state
     */ BrowserProtocolUtils.extractBrowserRequestState = function(browserCrypto, state) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(state)) return null;
        try {
            var requestStateObj = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(browserCrypto, state);
            return requestStateObj.libraryState.meta;
        } catch (e) {
            throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidStateError(state, e);
        }
    };
    /**
     * Parses properties of server response from url hash
     * @param locationHash Hash from url
     */ BrowserProtocolUtils.parseServerResponseFromHash = function(locationHash) {
        if (!locationHash) return {};
        var hashUrlString = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(locationHash);
        return (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(hashUrlString.getHash());
    };
    return BrowserProtocolUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ var $d59662ac7a9a476c$export$44d7291b5c8cc149 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(BrowserCacheManager, _super);
    function BrowserCacheManager(clientId, cacheConfig, cryptoImpl, logger) {
        var _this = _super.call(this, clientId, cryptoImpl, logger) || this;
        // Cookie life calculation (hours * minutes * seconds * ms)
        _this.COOKIE_LIFE_MULTIPLIER = 86400000;
        _this.cacheConfig = cacheConfig;
        _this.logger = logger;
        _this.internalStorage = new (0, $ee22f9373d02691a$export$d7392285c701ecf5)();
        _this.browserStorage = _this.setupBrowserStorage(_this.cacheConfig.cacheLocation);
        _this.temporaryCacheStorage = _this.setupTemporaryCacheStorage(_this.cacheConfig.temporaryCacheLocation, _this.cacheConfig.cacheLocation);
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            _this.migrateCacheEntries();
            _this.createKeyMaps();
        }
        return _this;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */ BrowserCacheManager.prototype.setupBrowserStorage = function(cacheLocation) {
        switch(cacheLocation){
            case (0, $0f344e7ceaf1df75$export$573384e47a12d835).LocalStorage:
            case (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage:
                try {
                    return new (0, $5ad3654d70d3fe4a$export$2baa60fa09b100be)(cacheLocation);
                } catch (e) {
                    this.logger.verbose(e);
                    break;
                }
        }
        this.cacheConfig.cacheLocation = (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage;
        return new (0, $ee22f9373d02691a$export$d7392285c701ecf5)();
    };
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured temporaryCacheLocation.
     * @param temporaryCacheLocation
     * @param cacheLocation
     */ BrowserCacheManager.prototype.setupTemporaryCacheStorage = function(temporaryCacheLocation, cacheLocation) {
        switch(cacheLocation){
            case (0, $0f344e7ceaf1df75$export$573384e47a12d835).LocalStorage:
            case (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage:
                try {
                    /*
                     * When users do not explicitly choose their own temporaryCacheLocation,
                     * temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                     */ return new (0, $5ad3654d70d3fe4a$export$2baa60fa09b100be)(temporaryCacheLocation || (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage);
                } catch (e) {
                    this.logger.verbose(e);
                    return this.internalStorage;
                }
            case (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage:
            default:
                return this.internalStorage;
        }
    };
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */ BrowserCacheManager.prototype.migrateCacheEntries = function() {
        var _this = this;
        var idTokenKey = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ID_TOKEN;
        var clientInfoKey = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).CLIENT_INFO;
        var errorKey = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ERROR;
        var errorDescKey = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ERROR_DESC;
        var idTokenValue = this.browserStorage.getItem(idTokenKey);
        var clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        var errorValue = this.browserStorage.getItem(errorKey);
        var errorDescValue = this.browserStorage.getItem(errorDescKey);
        var values = [
            idTokenValue,
            clientInfoValue,
            errorValue,
            errorDescValue
        ];
        var keysToMigrate = [
            (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ID_TOKEN,
            (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).CLIENT_INFO,
            (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ERROR,
            (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ERROR_DESC
        ];
        keysToMigrate.forEach(function(cacheKey, index) {
            return _this.migrateCacheEntry(cacheKey, values[index]);
        });
    };
    /**
     * Utility function to help with migration.
     * @param newKey
     * @param value
     * @param storeAuthStateInCookie
     */ BrowserCacheManager.prototype.migrateCacheEntry = function(newKey, value) {
        if (value) this.setTemporaryCache(newKey, value, true);
    };
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */ BrowserCacheManager.prototype.createKeyMaps = function() {
        var _this = this;
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        var accountKeys = this.getItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).ACCOUNT_KEYS);
        var tokenKeys = this.getItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        var allKeys = this.browserStorage.getKeys();
        allKeys.forEach(function(key) {
            if (_this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                var value = _this.getItem(key);
                if (value) {
                    var credObj = _this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) switch(credObj["credentialType"]){
                        case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN:
                            if ((0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde).isIdTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - idToken with key: " + key + " found, saving key to token key map");
                                var idTokenEntity = (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, idTokenEntity);
                                _this.addTokenKey(newKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed idToken validation on key: " + key);
                            }
                            break;
                        case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                        case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                            if ((0, $c2e674572252645d$export$6b7a8e14ec177765).isAccessTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - accessToken with key: " + key + " found, saving key to token key map");
                                var accessTokenEntity = (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $c2e674572252645d$export$6b7a8e14ec177765)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, accessTokenEntity);
                                _this.addTokenKey(newKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed accessToken validation on key: " + key);
                            }
                            break;
                        case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                            if ((0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b).isRefreshTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - refreshToken with key: " + key + " found, saving key to token key map");
                                var refreshTokenEntity = (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, refreshTokenEntity);
                                _this.addTokenKey(newKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: " + key);
                            }
                            break;
                    }
                }
            }
            if (_this.isAccountKey(key)) {
                var value = _this.getItem(key);
                if (value) {
                    var accountObj = _this.validateAndParseJson(value);
                    if (accountObj && (0, $6ff18147f1afb887$export$680160523e6bfa6a).isAccountEntity(accountObj)) {
                        _this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        _this.logger.tracePii("BrowserCacheManager:createKeyMaps - account with key: " + key + " found, saving key to account key map");
                        _this.addAccountKeyToMap(key);
                    }
                }
            }
        });
    };
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ BrowserCacheManager.prototype.validateAndParseJson = function(jsonValue) {
        try {
            var parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    };
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */ BrowserCacheManager.prototype.getItem = function(key) {
        return this.browserStorage.getItem(key);
    };
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setItem = function(key, value) {
        this.browserStorage.setItem(key, value);
    };
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */ BrowserCacheManager.prototype.getAccount = function(accountKey) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        var account = this.getItem(accountKey);
        if (!account) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        var parsedAccount = this.validateAndParseJson(account);
        if (!parsedAccount || !(0, $6ff18147f1afb887$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $6ff18147f1afb887$export$680160523e6bfa6a)(), parsedAccount);
    };
    /**
     * set account entity in the platform cache
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setAccount = function(account) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        var key = account.generateAccountKey();
        this.setItem(key, JSON.stringify(account));
        this.addAccountKeyToMap(key);
    };
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ BrowserCacheManager.prototype.getAccountKeys = function() {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        var accountKeys = this.getItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).ACCOUNT_KEYS);
        if (accountKeys) return JSON.parse(accountKeys);
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    };
    /**
     * Add a new account to the key map
     * @param key
     */ BrowserCacheManager.prototype.addAccountKeyToMap = function(key) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii("BrowserCacheManager.addAccountKeyToMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        } else this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
    };
    /**
     * Remove an account from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeAccountKeyFromMap = function(key) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii("BrowserCacheManager.removeAccountKeyFromMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        var removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    };
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ BrowserCacheManager.prototype.removeAccount = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                _super.prototype.removeAccount.call(this, key);
                this.removeAccountKeyFromMap(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeIdToken = function(key) {
        _super.prototype.removeIdToken.call(this, key);
        this.removeTokenKey(key, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN);
    };
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeAccessToken = function(key) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                _super.prototype.removeAccessToken.call(this, key);
                this.removeTokenKey(key, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeRefreshToken = function(key) {
        _super.prototype.removeRefreshToken.call(this, key);
        this.removeTokenKey(key, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    };
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ BrowserCacheManager.prototype.getTokenKeys = function() {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        var item = this.getItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId);
        if (item) {
            var tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
            else this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
        } else this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    };
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ BrowserCacheManager.prototype.addTokenKey = function(key, type) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                if (tokenKeys.accessToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - accessToken added to map");
                    tokenKeys.accessToken.push(key);
                }
                break;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error("BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: " + type);
                (0, $859b00ae06117652$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
        this.setItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ BrowserCacheManager.prototype.removeTokenKey = function(key, type) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: " + key + " from map");
                var idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: " + key + " from map");
                var accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: " + key + " from map");
                var refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error("BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: " + type);
                (0, $859b00ae06117652$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
        this.setItem((0, $0f344e7ceaf1df75$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ BrowserCacheManager.prototype.getIdTokenCredential = function(idTokenKey) {
        var value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        var parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde)(), parsedIdToken);
    };
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ BrowserCacheManager.prototype.setIdTokenCredential = function(idToken) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        var idTokenKey = idToken.generateCredentialKey();
        this.setItem(idTokenKey, JSON.stringify(idToken));
        this.addTokenKey(idTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ID_TOKEN);
    };
    /**
     * generates accessToken entity from a string
     * @param key
     */ BrowserCacheManager.prototype.getAccessTokenCredential = function(accessTokenKey) {
        var value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        var parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $c2e674572252645d$export$6b7a8e14ec177765).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $c2e674572252645d$export$6b7a8e14ec177765)(), parsedAccessToken);
    };
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ BrowserCacheManager.prototype.setAccessTokenCredential = function(accessToken) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        var accessTokenKey = accessToken.generateCredentialKey();
        this.setItem(accessTokenKey, JSON.stringify(accessToken));
        this.addTokenKey(accessTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    };
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ BrowserCacheManager.prototype.getRefreshTokenCredential = function(refreshTokenKey) {
        var value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        var parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b)(), parsedRefreshToken);
    };
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ BrowserCacheManager.prototype.setRefreshTokenCredential = function(refreshToken) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        var refreshTokenKey = refreshToken.generateCredentialKey();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
        this.addTokenKey(refreshTokenKey, (0, $709b0e48f6b53a82$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    };
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ BrowserCacheManager.prototype.getAppMetadata = function(appMetadataKey) {
        var value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $3fe60484fc3744c3$export$b939be19f91a34cc).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $3fe60484fc3744c3$export$b939be19f91a34cc)(), parsedMetadata);
    };
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ BrowserCacheManager.prototype.setAppMetadata = function(appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        var appMetadataKey = appMetadata.generateAppMetadataKey();
        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
    };
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ BrowserCacheManager.prototype.getServerTelemetry = function(serverTelemetryKey) {
        var value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $87bb5d62a25750b6$export$ff670b37c5e10296).isServerTelemetryEntity(serverTelemetryKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $87bb5d62a25750b6$export$ff670b37c5e10296)(), parsedMetadata);
    };
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ BrowserCacheManager.prototype.setServerTelemetry = function(serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    };
    /**
     *
     */ BrowserCacheManager.prototype.getAuthorityMetadata = function(key) {
        var value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $a0e50176ce139744$export$49e7dcb371a5f08e).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $a0e50176ce139744$export$49e7dcb371a5f08e)(), parsedMetadata);
        }
        return null;
    };
    /**
     *
     */ BrowserCacheManager.prototype.getAuthorityMetadataKeys = function() {
        var _this = this;
        var allKeys = this.internalStorage.getKeys();
        return allKeys.filter(function(key) {
            return _this.isAuthorityMetadata(key);
        });
    };
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ BrowserCacheManager.prototype.setWrapperMetadata = function(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $0f344e7ceaf1df75$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $0f344e7ceaf1df75$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    };
    /**
     * Returns wrapper metadata from in-memory storage
     */ BrowserCacheManager.prototype.getWrapperMetadata = function() {
        var sku = this.internalStorage.getItem((0, $0f344e7ceaf1df75$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var version = this.internalStorage.getItem((0, $0f344e7ceaf1df75$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    };
    /**
     *
     * @param entity
     */ BrowserCacheManager.prototype.setAuthorityMetadata = function(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    };
    /**
     * Gets the active account
     */ BrowserCacheManager.prototype.getActiveAccount = function() {
        var activeAccountKeyFilters = this.generateCacheKey((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        var activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            var activeAccountKeyLocal = this.generateCacheKey((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
            var activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            var activeAccount = this.getAccountInfoByFilter({
                localAccountId: activeAccountValueLocal
            })[0] || null;
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount);
                return activeAccount;
            }
            return null;
        }
        var activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoByFilter({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId
            })[0] || null;
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    };
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ BrowserCacheManager.prototype.setActiveAccount = function(account) {
        var activeAccountKey = this.generateCacheKey((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        var activeAccountKeyLocal = this.generateCacheKey((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            var activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId
            };
            this.browserStorage.setItem(activeAccountKey, JSON.stringify(activeAccountValue));
            this.browserStorage.setItem(activeAccountKeyLocal, account.localAccountId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    };
    /**
     * Gets a list of accounts that match all of the filters provided
     * @param account
     */ BrowserCacheManager.prototype.getAccountInfoByFilter = function(accountFilter) {
        var allAccounts = this.getAllAccounts();
        this.logger.trace("BrowserCacheManager.getAccountInfoByFilter: total " + allAccounts.length + " accounts found");
        return allAccounts.filter(function(accountObj) {
            if (accountFilter.username && accountFilter.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountFilter.homeAccountId && accountFilter.homeAccountId !== accountObj.homeAccountId) return false;
            if (accountFilter.localAccountId && accountFilter.localAccountId !== accountObj.localAccountId) return false;
            if (accountFilter.tenantId && accountFilter.tenantId !== accountObj.tenantId) return false;
            if (accountFilter.environment && accountFilter.environment !== accountObj.environment) return false;
            return true;
        });
    };
    /**
     * Checks the cache for accounts matching loginHint or SID
     * @param loginHint
     * @param sid
     */ BrowserCacheManager.prototype.getAccountInfoByHints = function(loginHint, sid) {
        var matchingAccounts = this.getAllAccounts().filter(function(accountInfo) {
            if (sid) {
                var accountSid = accountInfo.idTokenClaims && accountInfo.idTokenClaims["sid"];
                return sid === accountSid;
            }
            if (loginHint) return loginHint === accountInfo.username;
            return false;
        });
        if (matchingAccounts.length === 1) return matchingAccounts[0];
        else if (matchingAccounts.length > 1) throw (0, $859b00ae06117652$export$a839ff85a7957561).createMultipleMatchingAccountsInCacheError();
        return null;
    };
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ BrowserCacheManager.prototype.getThrottlingCache = function(throttlingCacheKey) {
        var value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        var parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $7c9010589300d207$export$15b974958510ada9).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $7c9010589300d207$export$15b974958510ada9)(), parsedThrottlingCache);
    };
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ BrowserCacheManager.prototype.setThrottlingCache = function(throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    };
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ BrowserCacheManager.prototype.getTemporaryCache = function(cacheKey, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            var itemCookie = this.getItemCookie(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        var value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $0f344e7ceaf1df75$export$573384e47a12d835).LocalStorage) {
                var item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    };
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setTemporaryCache = function(cacheKey, value, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.setItemCookie(key, value);
        }
    };
    /**
     * Removes the cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ BrowserCacheManager.prototype.removeItem = function(key) {
        this.browserStorage.removeItem(key);
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.clearItemCookie(key);
        }
    };
    /**
     * Checks whether key is in cache.
     * @param key
     */ BrowserCacheManager.prototype.containsKey = function(key) {
        return this.browserStorage.containsKey(key) || this.temporaryCacheStorage.containsKey(key);
    };
    /**
     * Gets all keys in window.
     */ BrowserCacheManager.prototype.getKeys = function() {
        return (0, $87ab789688594f61$export$afc72e2116322959)(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
    };
    /**
     * Clears all cache entries created by MSAL.
     */ BrowserCacheManager.prototype.clear = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Removes all accounts and their credentials
                        return [
                            4 /*yield*/ ,
                            this.removeAllAccounts()
                        ];
                    case 1:
                        // Removes all accounts and their credentials
                        _a.sent();
                        this.removeAppMetadata();
                        // Removes all remaining MSAL cache items
                        this.getKeys().forEach(function(cacheKey) {
                            // Check if key contains msal prefix; For now, we are clearing all the cache items created by MSAL.js
                            if ((_this.browserStorage.containsKey(cacheKey) || _this.temporaryCacheStorage.containsKey(cacheKey)) && (cacheKey.indexOf((0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(_this.clientId) !== -1)) _this.removeItem(cacheKey);
                        });
                        this.internalStorage.clear();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param credential
     * @returns
     */ BrowserCacheManager.prototype.clearTokensAndKeysWithClaims = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var tokenKeys, removedAccessTokens;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("BrowserCacheManager.clearTokensAndKeysWithClaims called");
                        tokenKeys = this.getTokenKeys();
                        removedAccessTokens = [];
                        tokenKeys.accessToken.forEach(function(key) {
                            // if the access token has claims in its key, remove the token key and the token
                            var credential = _this.getAccessTokenCredential(key);
                            if ((credential === null || credential === void 0 ? void 0 : credential.requestedClaimsHash) && key.includes(credential.requestedClaimsHash.toLowerCase())) removedAccessTokens.push(_this.removeAccessToken(key));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedAccessTokens)
                        ];
                    case 1:
                        _a.sent();
                        // warn if any access tokens are removed
                        if (removedAccessTokens.length > 0) this.logger.warning(removedAccessTokens.length + " access tokens with claims in the cache keys have been removed from the cache.");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Add value to cookies
     * @param cookieName
     * @param cookieValue
     * @param expires
     */ BrowserCacheManager.prototype.setItemCookie = function(cookieName, cookieValue, expires) {
        var cookieStr = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue) + ";path=/;SameSite=Lax;";
        if (expires) {
            var expireTime = this.getCookieExpirationTime(expires);
            cookieStr += "expires=" + expireTime + ";";
        }
        if (this.cacheConfig.secureCookies) cookieStr += "Secure;";
        document.cookie = cookieStr;
    };
    /**
     * Get one item by key from cookies
     * @param cookieName
     */ BrowserCacheManager.prototype.getItemCookie = function(cookieName) {
        var name = encodeURIComponent(cookieName) + "=";
        var cookieList = document.cookie.split(";");
        for(var i = 0; i < cookieList.length; i++){
            var cookie = cookieList[i];
            while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
            if (cookie.indexOf(name) === 0) return decodeURIComponent(cookie.substring(name.length, cookie.length));
        }
        return (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
     */ BrowserCacheManager.prototype.clearMsalCookies = function() {
        var _this = this;
        var cookiePrefix = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + this.clientId;
        var cookieList = document.cookie.split(";");
        cookieList.forEach(function(cookie) {
            while(cookie.charAt(0) === " ")// eslint-disable-next-line no-param-reassign
            cookie = cookie.substring(1);
            if (cookie.indexOf(cookiePrefix) === 0) {
                var cookieKey = cookie.split("=")[0];
                _this.clearItemCookie(cookieKey);
            }
        });
    };
    /**
     * Clear an item in the cookies by key
     * @param cookieName
     */ BrowserCacheManager.prototype.clearItemCookie = function(cookieName) {
        this.setItemCookie(cookieName, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, -1);
    };
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     */ BrowserCacheManager.prototype.getCookieExpirationTime = function(cookieLifeDays) {
        var today = new Date();
        var expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
        return expr.toUTCString();
    };
    /**
     * Gets the cache object referenced by the browser
     */ BrowserCacheManager.prototype.getCache = function() {
        return this.browserStorage;
    };
    /**
     * interface compat, we cannot overwrite browser cache; Functionality is supported by individual entities in browser
     */ BrowserCacheManager.prototype.setCache = function() {
    // sets nothing
    };
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ BrowserCacheManager.prototype.generateCacheKey = function(key) {
        var generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $33fadf35800e4b73$export$ecc754f99843e759).startsWith(key, (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX) || (0, $33fadf35800e4b73$export$ecc754f99843e759).startsWith(key, (0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ADAL_ID_TOKEN)) return key;
            return (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + this.clientId + "." + key;
        }
        return JSON.stringify(key);
    };
    /**
     * Create authorityKey to cache authority
     * @param state
     */ BrowserCacheManager.prototype.generateAuthorityKey = function(stateString) {
        var stateId = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).AUTHORITY + "." + stateId);
    };
    /**
     * Create Nonce key to cache nonce
     * @param state
     */ BrowserCacheManager.prototype.generateNonceKey = function(stateString) {
        var stateId = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).NONCE_IDTOKEN + "." + stateId);
    };
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */ BrowserCacheManager.prototype.generateStateKey = function(stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        var stateId = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_STATE + "." + stateId);
    };
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */ BrowserCacheManager.prototype.getCachedAuthority = function(cachedState) {
        var stateCacheKey = this.generateStateKey(cachedState);
        var state = this.getTemporaryCache(stateCacheKey);
        if (!state) return null;
        var authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    };
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */ BrowserCacheManager.prototype.updateCacheEntries = function(state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        var stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        var nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        var authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            var ccsCredential = {
                credential: account.homeAccountId,
                type: (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
            this.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        } else if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(loginHint)) {
            var ccsCredential = {
                credential: loginHint,
                type: (0, $531468341ade26af$export$17b7b3ac1abef49f).UPN
            };
            this.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    };
    /**
     * Reset all temporary cache items
     * @param state
     */ BrowserCacheManager.prototype.resetRequestCache = function(state) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(state)) this.getKeys().forEach(function(key) {
            if (key.indexOf(state) !== -1) _this.removeItem(key);
        });
        // delete generic interactive request parameters
        if (state) {
            this.removeItem(this.generateStateKey(state));
            this.removeItem(this.generateNonceKey(state));
            this.removeItem(this.generateAuthorityKey(state));
        }
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).URL_HASH));
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CORRELATION_ID));
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CCS_CREDENTIAL));
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    };
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */ BrowserCacheManager.prototype.cleanRequestByState = function(stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            var stateKey = this.generateStateKey(stateString);
            var cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + cachedState);
            this.resetRequestCache(cachedState || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        }
        this.clearMsalCookies();
    };
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */ BrowserCacheManager.prototype.cleanRequestByInteractionType = function(interactionType) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.getKeys().forEach(function(key) {
            // If this key is not the state key, move on
            if (key.indexOf((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_STATE) === -1) return;
            // Retrieve state value, return if not a valid value
            var stateValue = _this.temporaryCacheStorage.getItem(key);
            if (!stateValue) return;
            // Extract state and ensure it matches given InteractionType, then clean request cache
            var parsedState = (0, $e57b35ef8cb8f153$export$83c579d74a9d4ed7).extractBrowserRequestState(_this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                _this.logger.infoPii("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + stateValue);
                _this.resetRequestCache(stateValue);
            }
        });
        this.clearMsalCookies();
        this.setInteractionInProgress(false);
    };
    BrowserCacheManager.prototype.cacheCodeRequest = function(authCodeRequest, browserCrypto) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        var encodedValue = browserCrypto.base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
    };
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ BrowserCacheManager.prototype.getCachedRequest = function(state, browserCrypto) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        var encodedTokenRequest = this.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoTokenRequestCacheError();
        var parsedRequest = this.validateAndParseJson(browserCrypto.base64Decode(encodedTokenRequest));
        if (!parsedRequest) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToParseTokenRequestCacheError();
        this.removeItem(this.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(parsedRequest.authority)) {
            var authorityCacheKey = this.generateAuthorityKey(state);
            var cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoCachedAuthorityError();
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    };
    /**
     * Gets cached native request for redirect flows
     */ BrowserCacheManager.prototype.getCachedNativeRequest = function() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        var cachedRequest = this.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        var parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    };
    BrowserCacheManager.prototype.isInteractionInProgress = function(matchClientId) {
        var clientId = this.getInteractionInProgress();
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    };
    BrowserCacheManager.prototype.getInteractionInProgress = function() {
        var key = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY;
        return this.getTemporaryCache(key, false);
    };
    BrowserCacheManager.prototype.setInteractionInProgress = function(inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        var key = (0, $709b0e48f6b53a82$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createInteractionInProgressError();
            else // No interaction is in progress
            this.setTemporaryCache(key, this.clientId, false);
        } else if (!inProgress && this.getInteractionInProgress() === this.clientId) this.removeItem(key);
    };
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     */ BrowserCacheManager.prototype.getLegacyLoginHint = function() {
        // Only check for adal/msal token if no SSO params are being used
        var adalIdTokenString = this.getTemporaryCache((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        var msalIdTokenString = this.getTemporaryCache((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ID_TOKEN, true);
        if (msalIdTokenString) {
            this.removeItem(this.generateCacheKey((0, $709b0e48f6b53a82$export$81ab9ba9bd28255c).ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        var cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            var cachedIdToken = new (0, $557a50de248ab1f3$export$3a170961dab30083)(cachedIdTokenString, this.cryptoImpl);
            if (cachedIdToken.claims && cachedIdToken.claims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return cachedIdToken.claims.preferred_username;
            } else if (cachedIdToken.claims && cachedIdToken.claims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return cachedIdToken.claims.upn;
            } else this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
        }
        return null;
    };
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */ BrowserCacheManager.prototype.updateCredentialCacheKey = function(currentCacheKey, credential) {
        var updatedCacheKey = credential.generateCredentialKey();
        if (currentCacheKey !== updatedCacheKey) {
            var cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem);
                this.logger.verbose("Updated an outdated " + credential.credentialType + " cache key");
                return updatedCacheKey;
            } else this.logger.error("Attempted to update an outdated " + credential.credentialType + " cache key but no item matching the outdated key was found in storage");
        }
        return currentCacheKey;
    };
    /**
     * Returns application id as redirect context during AcquireTokenRedirect flow.
     */ BrowserCacheManager.prototype.getRedirectRequestContext = function() {
        return this.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REDIRECT_CONTEXT, true);
    };
    /**
     * Sets application id as the redirect context during AcquireTokenRedirect flow.
     * @param value
     */ BrowserCacheManager.prototype.setRedirectRequestContext = function(value) {
        this.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).REDIRECT_CONTEXT, value, true);
    };
    return BrowserCacheManager;
}((0, $673bcd64dd27ec5e$export$996e3ea69314b5c6));
var $d59662ac7a9a476c$export$8e2d54002f8f6e5d = function(clientId, logger) {
    var cacheOptions = {
        cacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: true
    };
    return new $d59662ac7a9a476c$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $1f27a522af777978$export$865f57d401606752), logger);
};


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $c7d869c1a2513d67$export$4cda21933050d9ec;
(function(AzureCloudInstance) {
    // AzureCloudInstance is not specified.
    AzureCloudInstance[AzureCloudInstance["None"] = 0] = "None";
    // Microsoft Azure public cloud
    AzureCloudInstance["AzurePublic"] = "https://login.microsoftonline.com";
    // Microsoft PPE
    AzureCloudInstance["AzurePpe"] = "https://login.windows-ppe.net";
    // Microsoft Chinese national cloud
    AzureCloudInstance["AzureChina"] = "https://login.chinacloudapi.cn";
    // Microsoft German national cloud ("Black Forest")
    AzureCloudInstance["AzureGermany"] = "https://login.microsoftonline.de";
    // US Government cloud
    AzureCloudInstance["AzureUsGovernment"] = "https://login.microsoftonline.us";
})($c7d869c1a2513d67$export$4cda21933050d9ec || ($c7d869c1a2513d67$export$4cda21933050d9ec = {}));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Token renewal offset default in seconds
var $e0e4999fede2ba19$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
var $e0e4999fede2ba19$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: $e0e4999fede2ba19$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
var $e0e4999fede2ba19$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: function() {
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $5f18ed8a9f930396$export$243e62d78d3b544d).Info,
    correlationId: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
};
var $e0e4999fede2ba19$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: true
};
var $e0e4999fede2ba19$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    sendGetRequestAsync: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Network interface - sendGetRequestAsync() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    sendPostRequestAsync: function() {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Network interface - sendPostRequestAsync() has not been implemented";
                throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    }
};
var $e0e4999fede2ba19$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $709b0e48f6b53a82$export$a002182e51710d39).SKU,
    version: (0, $c148700c4e017537$export$83d89fbfd8236492),
    cpu: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
};
var $e0e4999fede2ba19$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
var $e0e4999fede2ba19$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $c7d869c1a2513d67$export$4cda21933050d9ec).None,
    tenant: "" + (0, $709b0e48f6b53a82$export$a002182e51710d39).DEFAULT_COMMON_TENANT
};
var $e0e4999fede2ba19$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $e0e4999fede2ba19$export$57a091701dcdabb2(_a) {
    var userAuthOptions = _a.authOptions, userSystemOptions = _a.systemOptions, userLoggerOption = _a.loggerOptions, userCacheOptions = _a.cacheOptions, storageImplementation = _a.storageInterface, networkImplementation = _a.networkInterface, cryptoImplementation = _a.cryptoInterface, clientCredentials = _a.clientCredentials, libraryInfo = _a.libraryInfo, telemetry = _a.telemetry, serverTelemetryManager = _a.serverTelemetryManager, persistencePlugin = _a.persistencePlugin, serializableCache = _a.serializableCache;
    var loggerOptions = (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, $e0e4999fede2ba19$var$DEFAULT_LOGGER_IMPLEMENTATION), userLoggerOption);
    return {
        authOptions: $e0e4999fede2ba19$var$buildAuthOptions(userAuthOptions),
        systemOptions: (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, $e0e4999fede2ba19$export$f7a7dd6bfc156d75), userSystemOptions),
        loggerOptions: loggerOptions,
        cacheOptions: (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, $e0e4999fede2ba19$var$DEFAULT_CACHE_OPTIONS), userCacheOptions),
        storageInterface: storageImplementation || new (0, $673bcd64dd27ec5e$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $1f27a522af777978$export$865f57d401606752), new (0, $5f18ed8a9f930396$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $e0e4999fede2ba19$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $1f27a522af777978$export$865f57d401606752),
        clientCredentials: clientCredentials || $e0e4999fede2ba19$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, $e0e4999fede2ba19$var$DEFAULT_LIBRARY_INFO), libraryInfo),
        telemetry: (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, $e0e4999fede2ba19$var$DEFAULT_TELEMETRY_OPTIONS), telemetry),
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $e0e4999fede2ba19$var$buildAuthOptions(authOptions) {
    return (0, $a296cc98de023397$export$18ce0697a983be9b)({
        clientCapabilities: [],
        azureCloudOptions: $e0e4999fede2ba19$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false
    }, authOptions);
}

/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ var $03c18bc06fdce898$export$73a3e3dedd37150d;
(function(ProtocolMode) {
    ProtocolMode["AAD"] = "AAD";
    ProtocolMode["OIDC"] = "OIDC";
})($03c18bc06fdce898$export$73a3e3dedd37150d || ($03c18bc06fdce898$export$73a3e3dedd37150d = {}));

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $f835417272f1072c$export$6d95060a8ed7155a = {
    sendGetRequestAsync: function() {
        var notImplErr = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject((0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr));
    },
    sendPostRequestAsync: function() {
        var notImplErr = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject((0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError(notImplErr));
    }
};


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ var $9221eb50ca62ba28$export$4c206ef5be879972 = /** @class */ function() {
    function FetchClient() {}
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ FetchClient.prototype.sendGetRequestAsync = function(url, options) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response, e_1, _a;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).GET,
                                headers: this.getFetchHeaders(options)
                            })
                        ];
                    case 1:
                        response = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        if (window.navigator.onLine) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createGetRequestFailedError(e_1, url);
                        else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
                    case 3:
                        _b.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            (_a.body = _b.sent(), _a.status = response.status, _a)
                        ];
                    case 5:
                        _b.sent();
                        throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url);
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ FetchClient.prototype.sendPostRequestAsync = function(url, options) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var reqBody, response, e_3, _a;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reqBody = options && options.body || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).POST,
                                headers: this.getFetchHeaders(options),
                                body: reqBody
                            })
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_3 = _b.sent();
                        if (window.navigator.onLine) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPostRequestFailedError(e_3, url);
                        else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
                    case 4:
                        _b.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            (_a.body = _b.sent(), _a.status = response.status, _a)
                        ];
                    case 6:
                        _b.sent();
                        throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url);
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Fetch API Headers object from string map
     * @param inputHeaders
     */ FetchClient.prototype.getFetchHeaders = function(options) {
        var headers = new Headers();
        if (!(options && options.headers)) return headers;
        var optionsHeaders = options.headers;
        Object.keys(optionsHeaders).forEach(function(key) {
            headers.append(key, optionsHeaders[key]);
        });
        return headers;
    };
    FetchClient.prototype.getHeaderDict = function(headers) {
        var headerDict = {};
        headers.forEach(function(value, key) {
            headerDict[key] = value;
        });
        return headerDict;
    };
    return FetchClient;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This client implements the XMLHttpRequest class to send GET and POST requests.
 */ var $fbcadcb65899b409$export$4a5808801761cc05 = /** @class */ function() {
    function XhrClient() {}
    /**
     * XhrClient for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ XhrClient.prototype.sendGetRequestAsync = function(url, options) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendRequestAsync(url, (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).GET, options)
                ];
            });
        });
    };
    /**
     * XhrClient for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ XhrClient.prototype.sendPostRequestAsync = function(url, options) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendRequestAsync(url, (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).POST, options)
                ];
            });
        });
    };
    /**
     * Helper for XhrClient requests.
     * @param url
     * @param method
     * @param options
     */ XhrClient.prototype.sendRequestAsync = function(url, method, options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, /* async: */ true);
            _this.setXhrHeaders(xhr, options);
            xhr.onload = function() {
                if (xhr.status < 200 || xhr.status >= 300) {
                    if (method === (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).POST) reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPostRequestFailedError("Failed with status " + xhr.status, url));
                    else reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createGetRequestFailedError("Failed with status " + xhr.status, url));
                }
                try {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    var networkResponse = {
                        headers: _this.getHeaderDict(xhr),
                        body: jsonResponse,
                        status: xhr.status
                    };
                    resolve(networkResponse);
                } catch (e) {
                    reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url));
                }
            };
            xhr.onerror = function() {
                if (window.navigator.onLine) {
                    if (method === (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).POST) reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPostRequestFailedError("Failed with status " + xhr.status, url));
                    else reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createGetRequestFailedError("Failed with status " + xhr.status, url));
                } else reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoNetworkConnectivityError());
            };
            if (method === (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).POST && options && options.body) xhr.send(options.body);
            else if (method === (0, $0f344e7ceaf1df75$export$c774c31b4c31da8).GET) xhr.send();
            else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createHttpMethodNotImplementedError(method);
        });
    };
    /**
     * Helper to set XHR headers for request.
     * @param xhr
     * @param options
     */ XhrClient.prototype.setXhrHeaders = function(xhr, options) {
        if (options && options.headers) {
            var headers_1 = options.headers;
            Object.keys(headers_1).forEach(function(key) {
                xhr.setRequestHeader(key, headers_1[key]);
            });
        }
    };
    /**
     * Gets a string map of the headers received in the response.
     *
     * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
     * @param xhr
     */ XhrClient.prototype.getHeaderDict = function(xhr) {
        var headerString = xhr.getAllResponseHeaders();
        var headerArr = headerString.trim().split(/[\r\n]+/);
        var headerDict = {};
        headerArr.forEach(function(value) {
            var parts = value.split(": ");
            var headerName = parts.shift();
            var headerVal = parts.join(": ");
            if (headerName && headerVal) headerDict[headerName] = headerVal;
        });
        return headerDict;
    };
    return XhrClient;
}();




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class for browser specific functions
 */ var $d8bc297369c9228b$export$311899ae85124b2d = /** @class */ function() {
    function BrowserUtils() {}
    // #region Window Navigation and URL management
    /**
     * Clears hash from window url.
     */ BrowserUtils.clearHash = function(contentWindow) {
        // Office.js sets history.replaceState to null
        contentWindow.location.hash = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
        contentWindow.history.replaceState(null, (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, "" + contentWindow.location.origin + contentWindow.location.pathname + contentWindow.location.search);
    };
    /**
     * Replaces current hash with hash from provided url
     */ BrowserUtils.replaceHash = function(url) {
        var urlParts = url.split("#");
        urlParts.shift(); // Remove part before the hash
        window.location.hash = urlParts.length > 0 ? urlParts.join("#") : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Returns boolean of whether the current window is in an iframe or not.
     */ BrowserUtils.isInIframe = function() {
        return window.parent !== window;
    };
    /**
     * Returns boolean of whether or not the current window is a popup opened by msal
     */ BrowserUtils.isInPopup = function() {
        return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf((0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_NAME_PREFIX + ".") === 0;
    };
    // #endregion
    /**
     * Returns current window URL as redirect uri
     */ BrowserUtils.getCurrentUri = function() {
        return window.location.href.split("?")[0].split("#")[0];
    };
    /**
     * Gets the homepage url for the current window location.
     */ BrowserUtils.getHomepage = function() {
        var currentUrl = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(window.location.href);
        var urlComponents = currentUrl.getUrlComponents();
        return urlComponents.Protocol + "//" + urlComponents.HostNameAndPort + "/";
    };
    /**
     * Returns best compatible network client object.
     */ BrowserUtils.getBrowserNetworkClient = function() {
        if (window.fetch && window.Headers) return new (0, $9221eb50ca62ba28$export$4c206ef5be879972)();
        else return new (0, $fbcadcb65899b409$export$4a5808801761cc05)();
    };
    /**
     * Throws error if we have completed an auth and are
     * attempting another auth request inside an iframe.
     */ BrowserUtils.blockReloadInHiddenIframes = function() {
        var isResponseHash = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
        // return an error if called from the hidden iframe created by the msal js silent calls
        if (isResponseHash && BrowserUtils.isInIframe()) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createBlockReloadInHiddenIframeError();
    };
    /**
     * Block redirect operations in iframes unless explicitly allowed
     * @param interactionType Interaction type for the request
     * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
     */ BrowserUtils.blockRedirectInIframe = function(interactionType, allowRedirectInIframe) {
        var isIframedApp = BrowserUtils.isInIframe();
        if (interactionType === (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect && isIframedApp && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
        throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createRedirectInIframeError(isIframedApp);
    };
    /**
     * Block redirectUri loaded in popup from calling AcquireToken APIs
     */ BrowserUtils.blockAcquireTokenInPopups = function() {
        // Popups opened by msal popup APIs are given a name that starts with "msal."
        if (BrowserUtils.isInPopup()) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createBlockAcquireTokenInPopupsError();
    };
    /**
     * Throws error if token requests are made in non-browser environment
     * @param isBrowserEnvironment Flag indicating if environment is a browser.
     */ BrowserUtils.blockNonBrowserEnvironment = function(isBrowserEnvironment) {
        if (!isBrowserEnvironment) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNonBrowserEnvironmentError();
    };
    /**
     * Throws error if native brokering is enabled but initialize hasn't been called
     * @param allowNativeBroker
     * @param initialized
     */ BrowserUtils.blockNativeBrokerCalledBeforeInitialized = function(allowNativeBroker, initialized) {
        if (allowNativeBroker && !initialized) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeBrokerCalledBeforeInitialize();
    };
    /**
     * Returns boolean of whether current browser is an Internet Explorer or Edge browser.
     */ BrowserUtils.detectIEOrEdge = function() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var msie11 = ua.indexOf("Trident/");
        var msedge = ua.indexOf("Edge/");
        var isIE = msie > 0 || msie11 > 0;
        var isEdge = msedge > 0;
        return isIE || isEdge;
    };
    return BrowserUtils;
}();



/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $40f4ff622e5cf51c$export$d0d362a73d466c9b = /** @class */ function() {
    function NavigationClient() {}
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ NavigationClient.prototype.navigateInternal = function(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ NavigationClient.prototype.navigateExternal = function(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ NavigationClient.defaultNavigateWindow = function(url, options) {
        if (options.noHistory) window.location.replace(url);
        else window.location.assign(url);
        return new Promise(function(resolve) {
            setTimeout(function() {
                resolve(true);
            }, options.timeout);
        });
    };
    return NavigationClient;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
var $6d495cf6d7a6f942$export$a5835ee54399d410 = 60000;
var $6d495cf6d7a6f942$export$f3ffe700be354b19 = 6000;
var $6d495cf6d7a6f942$export$293647e7865520c6 = 30000;
var $6d495cf6d7a6f942$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $6d495cf6d7a6f942$export$f8352245bee68086(_a, isBrowserEnvironment) {
    var userInputAuth = _a.auth, userInputCache = _a.cache, userInputSystem = _a.system, userInputTelemetry = _a.telemetry;
    // Default auth options for browser
    var DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
        authority: "" + (0, $709b0e48f6b53a82$export$a002182e51710d39).DEFAULT_AUTHORITY,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
        postLogoutRedirectUri: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $03c18bc06fdce898$export$73a3e3dedd37150d).AAD,
        azureCloudOptions: {
            azureCloudInstance: (0, $c7d869c1a2513d67$export$4cda21933050d9ec).None,
            tenant: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false
    };
    // Default cache options for browser
    var DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $0f344e7ceaf1df75$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: true
    };
    // Default logger options for browser
    var DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: function() {
        // allow users to not set logger call back 
        },
        logLevel: (0, $5f18ed8a9f930396$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    var DEFAULT_BROWSER_SYSTEM_OPTIONS = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, (0, $e0e4999fede2ba19$export$f7a7dd6bfc156d75)), {
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? (0, $d8bc297369c9228b$export$311899ae85124b2d).getBrowserNetworkClient() : (0, $f835417272f1072c$export$6d95060a8ed7155a),
        navigationClient: new (0, $40f4ff622e5cf51c$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || $6d495cf6d7a6f942$export$a5835ee54399d410,
        iframeHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || $6d495cf6d7a6f942$export$f3ffe700be354b19,
        navigateFrameWait: isBrowserEnvironment && (0, $d8bc297369c9228b$export$311899ae85124b2d).detectIEOrEdge() ? 500 : 0,
        redirectNavigationTimeout: $6d495cf6d7a6f942$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowNativeBroker: false,
        nativeBrokerHandshakeTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.nativeBrokerHandshakeTimeout) || $6d495cf6d7a6f942$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS,
        cryptoOptions: {
            useMsrCrypto: false,
            entropy: undefined
        }
    });
    var providedSystemOptions = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, userInputSystem), {
        loggerOptions: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loggerOptions) || DEFAULT_LOGGER_OPTIONS
    });
    var DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
        }
    };
    var overlayedConfig = {
        auth: (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, DEFAULT_AUTH_OPTIONS), userInputAuth),
        cache: (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, DEFAULT_CACHE_OPTIONS), userInputCache),
        system: (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, DEFAULT_BROWSER_SYSTEM_OPTIONS), providedSystemOptions),
        telemetry: (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, DEFAULT_TELEMETRY_OPTIONS), userInputTelemetry)
    };
    return overlayedConfig;
}




/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/* eslint-disable header/header */ var $a90996ccbe5c3c78$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
var $a90996ccbe5c3c78$export$83d89fbfd8236492 = "2.38.3";


/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $bc14188b442b4f5f$export$3d7865934588d77e;
(function(EventType) {
    EventType["INITIALIZE_START"] = "msal:initializeStart";
    EventType["INITIALIZE_END"] = "msal:initializeEnd";
    EventType["ACCOUNT_ADDED"] = "msal:accountAdded";
    EventType["ACCOUNT_REMOVED"] = "msal:accountRemoved";
    EventType["LOGIN_START"] = "msal:loginStart";
    EventType["LOGIN_SUCCESS"] = "msal:loginSuccess";
    EventType["LOGIN_FAILURE"] = "msal:loginFailure";
    EventType["ACQUIRE_TOKEN_START"] = "msal:acquireTokenStart";
    EventType["ACQUIRE_TOKEN_SUCCESS"] = "msal:acquireTokenSuccess";
    EventType["ACQUIRE_TOKEN_FAILURE"] = "msal:acquireTokenFailure";
    EventType["ACQUIRE_TOKEN_NETWORK_START"] = "msal:acquireTokenFromNetworkStart";
    EventType["SSO_SILENT_START"] = "msal:ssoSilentStart";
    EventType["SSO_SILENT_SUCCESS"] = "msal:ssoSilentSuccess";
    EventType["SSO_SILENT_FAILURE"] = "msal:ssoSilentFailure";
    EventType["ACQUIRE_TOKEN_BY_CODE_START"] = "msal:acquireTokenByCodeStart";
    EventType["ACQUIRE_TOKEN_BY_CODE_SUCCESS"] = "msal:acquireTokenByCodeSuccess";
    EventType["ACQUIRE_TOKEN_BY_CODE_FAILURE"] = "msal:acquireTokenByCodeFailure";
    EventType["HANDLE_REDIRECT_START"] = "msal:handleRedirectStart";
    EventType["HANDLE_REDIRECT_END"] = "msal:handleRedirectEnd";
    EventType["POPUP_OPENED"] = "msal:popupOpened";
    EventType["LOGOUT_START"] = "msal:logoutStart";
    EventType["LOGOUT_SUCCESS"] = "msal:logoutSuccess";
    EventType["LOGOUT_FAILURE"] = "msal:logoutFailure";
    EventType["LOGOUT_END"] = "msal:logoutEnd";
    EventType["RESTORE_FROM_BFCACHE"] = "msal:restoreFromBFCache";
})($bc14188b442b4f5f$export$3d7865934588d77e || ($bc14188b442b4f5f$export$3d7865934588d77e = {}));



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $ceb2bc16a4ee1463$export$ce0ba2422a1c7815 = /** @class */ function() {
    function EventHandler(logger, browserCrypto) {
        this.eventCallbacks = new Map();
        this.logger = logger;
        this.browserCrypto = browserCrypto;
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ EventHandler.prototype.addEventCallback = function(callback) {
        if (typeof window !== "undefined") {
            var callbackId = this.browserCrypto.createNewGuid();
            this.eventCallbacks.set(callbackId, callback);
            this.logger.verbose("Event callback registered with id: " + callbackId);
            return callbackId;
        }
        return null;
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ EventHandler.prototype.removeEventCallback = function(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose("Event callback " + callbackId + " removed.");
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ EventHandler.prototype.enableAccountStorageEvents = function() {
        if (typeof window === "undefined") return;
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        } else this.logger.verbose("Account storage listener already registered.");
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ EventHandler.prototype.disableAccountStorageEvents = function() {
        if (typeof window === "undefined") return;
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        } else this.logger.verbose("No account storage listener registered.");
    };
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ EventHandler.prototype.emitEvent = function(eventType, interactionType, payload, error) {
        var _this = this;
        if (typeof window !== "undefined") {
            var message_1 = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.logger.info("Emitting event: " + eventType);
            this.eventCallbacks.forEach(function(callback, callbackId) {
                _this.logger.verbose("Emitting event to callback " + callbackId + ": " + eventType);
                callback.apply(null, [
                    message_1
                ]);
            });
        }
    };
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */ EventHandler.prototype.handleAccountCacheChange = function(e) {
        try {
            var cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) return;
            var parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !(0, $6ff18147f1afb887$export$680160523e6bfa6a).isAccountEntity(parsedValue)) return;
            var accountEntity = (0, $673bcd64dd27ec5e$export$996e3ea69314b5c6).toObject(new (0, $6ff18147f1afb887$export$680160523e6bfa6a)(), parsedValue);
            var accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, accountInfo);
            } else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, accountInfo);
            }
        } catch (e) {
            return;
        }
    };
    return EventHandler;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $44321a50b91f10d9$export$c060a619741dd765 = /** @class */ function() {
    function ThrottlingUtils() {}
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ ThrottlingUtils.generateThrottlingStorageKey = function(thumbprint) {
        return (0, $709b0e48f6b53a82$export$a2330d6808e6d893).THROTTLING_PREFIX + "." + JSON.stringify(thumbprint);
    };
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ ThrottlingUtils.preProcess = function(cacheManager, thumbprint) {
        var _a;
        var key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        var value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key);
                return;
            }
            throw new (0, $18269c32984fce6f$export$ea52035eac03daf0)(((_a = value.errorCodes) === null || _a === void 0 ? void 0 : _a.join(" ")) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    };
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ ThrottlingUtils.postProcess = function(cacheManager, thumbprint, response) {
        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
            var thumbprintValue = {
                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    };
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ ThrottlingUtils.checkResponseStatus = function(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    };
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ ThrottlingUtils.checkResponseForRetryAfter = function(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $709b0e48f6b53a82$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    };
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ ThrottlingUtils.calculateThrottleTime = function(throttleTime) {
        var time = throttleTime <= 0 ? 0 : throttleTime;
        var currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $709b0e48f6b53a82$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $709b0e48f6b53a82$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    };
    ThrottlingUtils.removeThrottle = function(cacheManager, clientId, request, homeAccountIdentifier) {
        var thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        var key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key);
    };
    return ThrottlingUtils;
}();


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $8fa165a3ef24612d$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}





/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $fa0d72c96a2a20d6$export$223f43dfec89cb87 = {
    "endpointMetadata": {
        "https://login.microsoftonline.com/common/": {
            "token_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/common/": {
            "token_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/common/": {
            "token_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        },
        "https://login.microsoftonline.com/consumers/": {
            "token_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/consumers/": {
            "token_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/consumers/": {
            "token_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        },
        "https://login.microsoftonline.com/organizations/": {
            "token_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/organizations/": {
            "token_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/organizations/": {
            "token_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        }
    },
    "instanceDiscoveryMetadata": {
        "https://login.microsoftonline.com/common/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/common/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/common/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.com/consumers/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/consumers/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/consumers/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.com/organizations/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/organizations/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/organizations/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        }
    }
};
var $fa0d72c96a2a20d6$export$f612854287391207 = $fa0d72c96a2a20d6$export$223f43dfec89cb87.endpointMetadata;
var $fa0d72c96a2a20d6$export$a21acafc3b6f5582 = $fa0d72c96a2a20d6$export$223f43dfec89cb87.instanceDiscoveryMetadata;






/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $29f7f44357970d25$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f7a875380deb1970$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $22d1db1ebcd19017$export$1afa9d0f261ebb47 = /** @class */ function() {
    function RegionDiscovery(networkInterface, performanceClient, correlationId) {
        this.networkInterface = networkInterface;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ RegionDiscovery.prototype.detectRegion = function(environmentRegion, regionDiscoveryMetadata) {
        var _a, _b, _c, _d;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var autodetectedRegionName, options, localIMDSVersionResponse, currentIMDSVersion, currentIMDSVersionResponse;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
                        autodetectedRegionName = environmentRegion;
                        if (!!autodetectedRegionName) return [
                            3 /*break*/ ,
                            8
                        ];
                        options = RegionDiscovery.IMDS_OPTIONS;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getRegionFromIMDS((0, $709b0e48f6b53a82$export$a002182e51710d39).IMDS_VERSION, options)
                        ];
                    case 2:
                        localIMDSVersionResponse = _e.sent();
                        if (localIMDSVersionResponse.status === (0, $709b0e48f6b53a82$export$20ba0879771a17be).httpSuccess) {
                            autodetectedRegionName = localIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).IMDS;
                        }
                        if (!(localIMDSVersionResponse.status === (0, $709b0e48f6b53a82$export$20ba0879771a17be).httpBadRequest)) return [
                            3 /*break*/ ,
                            5
                        ];
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getCurrentVersion(options)
                        ];
                    case 3:
                        currentIMDSVersion = _e.sent();
                        if (!currentIMDSVersion) {
                            regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getRegionFromIMDS(currentIMDSVersion, options)
                        ];
                    case 4:
                        currentIMDSVersionResponse = _e.sent();
                        if (currentIMDSVersionResponse.status === (0, $709b0e48f6b53a82$export$20ba0879771a17be).httpSuccess) {
                            autodetectedRegionName = currentIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).IMDS;
                        }
                        _e.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        _e.sent();
                        regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
                        _e.label = 9;
                    case 9:
                        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
                        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $709b0e48f6b53a82$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return [
                            2 /*return*/ ,
                            autodetectedRegionName || null
                        ];
                }
            });
        });
    };
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ RegionDiscovery.prototype.getRegionFromIMDS = function(version, options) {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                return [
                    2 /*return*/ ,
                    this.networkInterface.sendGetRequestAsync((0, $709b0e48f6b53a82$export$a002182e51710d39).IMDS_ENDPOINT + "?api-version=" + version + "&format=text", options, (0, $709b0e48f6b53a82$export$a002182e51710d39).IMDS_TIMEOUT)
                ];
            });
        });
    };
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ RegionDiscovery.prototype.getCurrentVersion = function(options) {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync((0, $709b0e48f6b53a82$export$a002182e51710d39).IMDS_ENDPOINT + "?format=json", options)
                        ];
                    case 2:
                        response = _b.sent();
                        // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
                        if (response.status === (0, $709b0e48f6b53a82$export$20ba0879771a17be).httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return [
                            2 /*return*/ ,
                            response.body["newest-versions"][0]
                        ];
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Options for the IMDS endpoint request
    RegionDiscovery.IMDS_OPTIONS = {
        headers: {
            Metadata: "true"
        }
    };
    return RegionDiscovery;
}();




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 */ var $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c = /** @class */ function() {
    function Authority(authority, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.regionDiscovery = new (0, $22d1db1ebcd19017$export$1afa9d0f261ebb47)(networkInterface, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ Authority.prototype.getAuthorityType = function(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $709b0e48f6b53a82$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Ciam;
        var pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $709b0e48f6b53a82$export$a002182e51710d39).ADFS:
                return (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Adfs;
            case (0, $709b0e48f6b53a82$export$a002182e51710d39).DSTS:
                return (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Dsts;
        }
        return (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Default;
    };
    Object.defineProperty(Authority.prototype, "authorityType", {
        // See above for AuthorityType
        get: function() {
            return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "protocolMode", {
        /**
         * ProtocolMode enum representing the way endpoints are constructed.
         */ get: function() {
            return this.authorityOptions.protocolMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "options", {
        /**
         * Returns authorityOptions which can be used to reinstantiate a new authority instance
         */ get: function() {
            return this.authorityOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthority", {
        /**
         * A URL that is the authority set by the developer
         */ get: function() {
            return this._canonicalAuthority.urlString;
        },
        /**
         * Sets canonical authority.
         */ set: function(url) {
            this._canonicalAuthority = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(url);
            this._canonicalAuthority.validateAsUri();
            this._canonicalAuthorityUrlComponents = null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthorityUrlComponents", {
        /**
         * Get authority components.
         */ get: function() {
            if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
            return this._canonicalAuthorityUrlComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "hostnameAndPort", {
        /**
         * Get hostname and port i.e. login.microsoftonline.com
         */ get: function() {
            return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tenant", {
        /**
         * Get tenant for authority.
         */ get: function() {
            return this.canonicalAuthorityUrlComponents.PathSegments[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "authorizationEndpoint", {
        /**
         * OAuth /authorize endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
            else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tokenEndpoint", {
        /**
         * OAuth /token endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
            else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "deviceCodeEndpoint", {
        get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
            else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "endSessionEndpoint", {
        /**
         * OAuth logout endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) {
                // ROPC policies may not have end_session_endpoint set
                if (!this.metadata.end_session_endpoint) throw (0, $859b00ae06117652$export$a839ff85a7957561).createLogoutNotSupportedError();
                return this.replacePath(this.metadata.end_session_endpoint);
            } else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "selfSignedJwtAudience", {
        /**
         * OAuth issuer for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
            else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "jwksUri", {
        /**
         * Jwks_uri for token signing keys
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
            else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ Authority.prototype.canReplaceTenant = function(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !Authority.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Default && this.protocolMode === (0, $03c18bc06fdce898$export$73a3e3dedd37150d).AAD;
    };
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ Authority.prototype.replaceTenant = function(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    };
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ Authority.prototype.replacePath = function(urlString) {
        var _this = this;
        var endpoint = urlString;
        var cachedAuthorityUrl = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        var cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        var cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        var currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach(function(currentPart, index) {
            var cachedPart = cachedAuthorityParts[index];
            if (index === 0 && _this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                var tenantId = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(_this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    _this.logger.verbose("Replacing tenant domain name " + cachedPart + " with id " + tenantId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace("/" + cachedPart + "/", "/" + currentPart + "/");
        });
        return this.replaceTenant(endpoint);
    };
    Object.defineProperty(Authority.prototype, "defaultOpenIdConfigurationEndpoint", {
        /**
         * The default open id configuration endpoint for any canonical authority.
         */ get: function() {
            if (this.authorityType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Adfs || this.authorityType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Dsts || this.protocolMode === (0, $03c18bc06fdce898$export$73a3e3dedd37150d).OIDC) return this.canonicalAuthority + ".well-known/openid-configuration";
            return this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Boolean that returns whethr or not tenant discovery has been completed.
     */ Authority.prototype.discoveryComplete = function() {
        return !!this.metadata;
    };
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ Authority.prototype.resolveEndpointsAsync = function() {
        var _a, _b, _c;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadataEntity, cloudDiscoverySource, endpointSource, cacheKey;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
                        metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
                        if (!metadataEntity) {
                            metadataEntity = new (0, $a0e50176ce139744$export$49e7dcb371a5f08e)();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateCloudDiscoveryMetadata(metadataEntity)
                        ];
                    case 1:
                        cloudDiscoverySource = _d.sent();
                        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateEndpointMetadata(metadataEntity)
                        ];
                    case 2:
                        endpointSource = _d.sent();
                        if (cloudDiscoverySource !== (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CACHE && endpointSource !== (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CACHE) {
                            // Reset the expiration time unless both values came from a successful cache lookup
                            metadataEntity.resetExpiresAt();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
                        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
                        this.metadata = metadataEntity;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ Authority.prototype.updateEndpointMetadata = function(metadataEntity) {
        var _a, _b, _c, _d, _e, _f;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadata, harcodedMetadata;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
                        metadata = this.getEndpointMetadataFromConfig();
                        if (metadata) {
                            metadataEntity.updateEndpointMetadata(metadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CONFIG
                            ];
                        }
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntity.isExpired()) // No need to update
                        return [
                            2 /*return*/ ,
                            (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CACHE
                        ];
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getEndpointMetadataFromNetwork()
                        ];
                    case 1:
                        metadata = _g.sent();
                        if (!metadata) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!((_c = this.authorityOptions.azureRegionConfiguration) === null || _c === void 0 ? void 0 : _c.azureRegion)) return [
                            3 /*break*/ ,
                            3
                        ];
                        (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateMetadataWithRegionalInformation(metadata)
                        ];
                    case 2:
                        metadata = _g.sent();
                        _g.label = 3;
                    case 3:
                        metadataEntity.updateEndpointMetadata(metadata, true);
                        return [
                            2 /*return*/ ,
                            (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).NETWORK
                        ];
                    case 4:
                        harcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
                        if (!(harcodedMetadata && !this.authorityOptions.skipAuthorityMetadataCache)) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!((_e = this.authorityOptions.azureRegionConfiguration) === null || _e === void 0 ? void 0 : _e.azureRegion)) return [
                            3 /*break*/ ,
                            6
                        ];
                        (_f = this.performanceClient) === null || _f === void 0 || _f.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateMetadataWithRegionalInformation(harcodedMetadata)
                        ];
                    case 5:
                        harcodedMetadata = _g.sent();
                        _g.label = 6;
                    case 6:
                        metadataEntity.updateEndpointMetadata(harcodedMetadata, false);
                        return [
                            2 /*return*/ ,
                            (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).HARDCODED_VALUES
                        ];
                    case 7:
                        throw (0, $859b00ae06117652$export$a839ff85a7957561).createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
                }
            });
        });
    };
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ Authority.prototype.isAuthoritySameType = function(metadataEntity) {
        var cachedAuthorityUrl = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        var cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    };
    /**
     * Parse authorityMetadata config option
     */ Authority.prototype.getEndpointMetadataFromConfig = function() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidAuthorityMetadataError();
        }
        return null;
    };
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ Authority.prototype.getEndpointMetadataFromNetwork = function() {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var options, response;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        options = {};
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint, options)
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            2 /*return*/ ,
                            (0, $8fa165a3ef24612d$export$aab44dc88900a3b)(response.body) ? response.body : null
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get OAuth endpoints for common authorities.
     */ Authority.prototype.getEndpointMetadataFromHardcodedValues = function() {
        if (this.canonicalAuthority in (0, $fa0d72c96a2a20d6$export$f612854287391207)) return (0, $fa0d72c96a2a20d6$export$f612854287391207)[this.canonicalAuthority];
        return null;
    };
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ Authority.prototype.updateMetadataWithRegionalInformation = function(metadata) {
        var _a, _b, _c, _d;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var userConfiguredAzureRegion, autodetectedRegionName;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        userConfiguredAzureRegion = (_b = this.authorityOptions.azureRegionConfiguration) === null || _b === void 0 ? void 0 : _b.azureRegion;
                        if (!userConfiguredAzureRegion) return [
                            3 /*break*/ ,
                            2
                        ];
                        if (userConfiguredAzureRegion !== (0, $709b0e48f6b53a82$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                            this.regionDiscoveryMetadata.region_outcome = (0, $709b0e48f6b53a82$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                            this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                            return [
                                2 /*return*/ ,
                                Authority.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion)
                            ];
                        }
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.regionDiscovery.detectRegion((_d = this.authorityOptions.azureRegionConfiguration) === null || _d === void 0 ? void 0 : _d.environmentRegion, this.regionDiscoveryMetadata)
                        ];
                    case 1:
                        autodetectedRegionName = _e.sent();
                        if (autodetectedRegionName) {
                            this.regionDiscoveryMetadata.region_outcome = (0, $709b0e48f6b53a82$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                            this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                            return [
                                2 /*return*/ ,
                                Authority.replaceWithRegionalInformation(metadata, autodetectedRegionName)
                            ];
                        }
                        this.regionDiscoveryMetadata.region_outcome = (0, $709b0e48f6b53a82$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
                        _e.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            metadata
                        ];
                }
            });
        });
    };
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ Authority.prototype.updateCloudDiscoveryMetadata = function(metadataEntity) {
        var _a, _b;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadata, metadataEntityExpired, harcodedMetadata;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        // attempt to read metadata from the config
                        this.logger.verbose("Attempting to get cloud discovery metadata in the config");
                        this.logger.verbosePii("Known Authorities: " + (this.authorityOptions.knownAuthorities || (0, $709b0e48f6b53a82$export$a002182e51710d39).NOT_APPLICABLE));
                        this.logger.verbosePii("Authority Metadata: " + (this.authorityOptions.authorityMetadata || (0, $709b0e48f6b53a82$export$a002182e51710d39).NOT_APPLICABLE));
                        this.logger.verbosePii("Canonical Authority: " + (metadataEntity.canonical_authority || (0, $709b0e48f6b53a82$export$a002182e51710d39).NOT_APPLICABLE));
                        metadata = this.getCloudDiscoveryMetadataFromConfig();
                        if (metadata) {
                            this.logger.verbose("Found cloud discovery metadata in the config.");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CONFIG
                            ];
                        }
                        // If the cached metadata came from config but that config was not passed to this instance, we must go to the network
                        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the cache.");
                        metadataEntityExpired = metadataEntity.isExpired();
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
                            this.logger.verbose("Found metadata in the cache.");
                            // No need to update
                            return [
                                2 /*return*/ ,
                                (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).CACHE
                            ];
                        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
                        this.logger.verbose("Did not find cloud discovery metadata in the cache... Attempting to get cloud discovery metadata from the network.");
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getCloudDiscoveryMetadataFromNetwork()
                        ];
                    case 1:
                        metadata = _c.sent();
                        if (metadata) {
                            this.logger.verbose("cloud discovery metadata was successfully returned from getCloudDiscoveryMetadataFromNetwork()");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, true);
                            return [
                                2 /*return*/ ,
                                (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).NETWORK
                            ];
                        }
                        this.logger.verbose("Did not find cloud discovery metadata from the network... Attempting to get cloud discovery metadata from hardcoded values.");
                        harcodedMetadata = this.getCloudDiscoveryMetadataFromHarcodedValues();
                        if (harcodedMetadata && !this.options.skipAuthorityMetadataCache) {
                            this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                            metadataEntity.updateCloudDiscoveryMetadata(harcodedMetadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $709b0e48f6b53a82$export$5d365d77acfcb55d).HARDCODED_VALUES
                            ];
                        }
                        // Metadata could not be obtained from the config, cache, network or hardcoded values
                        this.logger.error("Did not find cloud discovery metadata from hardcoded values... Metadata could not be obtained from config, cache, network or hardcoded values. Throwing Untrusted Authority Error.");
                        throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUntrustedAuthorityError();
                }
            });
        });
    };
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ Authority.prototype.getCloudDiscoveryMetadataFromConfig = function() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                var parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                var metadata = Authority.getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidCloudDiscoveryMetadataError();
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    };
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ Authority.prototype.getCloudDiscoveryMetadataFromNetwork = function() {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var instanceDiscoveryEndpoint, options, match, response, typedResponseBody, metadata, error_1, typedError;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        instanceDiscoveryEndpoint = "" + (0, $709b0e48f6b53a82$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize";
                        options = {};
                        match = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options)
                        ];
                    case 2:
                        response = _b.sent();
                        typedResponseBody = void 0;
                        metadata = void 0;
                        if ((0, $29f7f44357970d25$export$b288ea4a1e969e42)(response.body)) {
                            typedResponseBody = response.body;
                            metadata = typedResponseBody.metadata;
                            this.logger.verbosePii("tenant_discovery_endpoint is: " + typedResponseBody.tenant_discovery_endpoint);
                        } else if ((0, $f7a875380deb1970$export$6716273459d383f8)(response.body)) {
                            this.logger.warning("A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: " + response.status);
                            typedResponseBody = response.body;
                            if (typedResponseBody.error === (0, $709b0e48f6b53a82$export$a002182e51710d39).INVALID_INSTANCE) {
                                this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                                return [
                                    2 /*return*/ ,
                                    null
                                ];
                            }
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error is " + typedResponseBody.error);
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error description is " + typedResponseBody.error_description);
                            this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                            metadata = [];
                        } else {
                            this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
                        match = Authority.getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) this.logger.error("There was a network error while attempting to get the cloud discovery instance metadata.\nError: " + error_1.errorCode + "\nError Description: " + error_1.errorMessage);
                        else {
                            typedError = error_1;
                            this.logger.error("A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: " + typedError.name + "\nError Description: " + typedError.message);
                        }
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
                        if (!match) {
                            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
                            this.logger.verbose("Creating custom Authority for custom domain scenario.");
                            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
                        }
                        return [
                            2 /*return*/ ,
                            match
                        ];
                }
            });
        });
    };
    /**
     * Get cloud discovery metadata for common authorities
     */ Authority.prototype.getCloudDiscoveryMetadataFromHarcodedValues = function() {
        if (this.canonicalAuthority in (0, $fa0d72c96a2a20d6$export$a21acafc3b6f5582)) return (0, $fa0d72c96a2a20d6$export$a21acafc3b6f5582)[this.canonicalAuthority];
        return null;
    };
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ Authority.prototype.isInKnownAuthorities = function() {
        var _this = this;
        var matches = this.authorityOptions.knownAuthorities.filter(function(authority) {
            return (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === _this.hostnameAndPort;
        });
        return matches.length > 0;
    };
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ Authority.generateAuthority = function(authorityString, azureCloudOptions) {
        var authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $c7d869c1a2513d67$export$4cda21933050d9ec).None) {
            var tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $709b0e48f6b53a82$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = azureCloudOptions.azureCloudInstance + "/" + tenant + "/";
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    };
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ Authority.createCloudDiscoveryMetadataFromHost = function(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    };
    /**
     * Searches instance discovery network response for the entry that contains the host in the aliases list
     * @param response
     * @param authority
     */ Authority.getCloudDiscoveryMetadataFromNetworkResponse = function(response, authority) {
        for(var i = 0; i < response.length; i++){
            var metadata = response[i];
            if (metadata.aliases.indexOf(authority) > -1) return metadata;
        }
        return null;
    };
    /**
     * helper function to generate environment from authority object
     */ Authority.prototype.getPreferredCache = function() {
        if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
    };
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ Authority.prototype.isAlias = function(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    };
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ Authority.isPublicCloudAuthority = function(host) {
        return (0, $709b0e48f6b53a82$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    };
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ Authority.buildRegionalAuthorityString = function(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        var authorityUrlInstance = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        var authorityUrlParts = authorityUrlInstance.getUrlComponents();
        var hostNameAndPort = region + "." + authorityUrlParts.HostNameAndPort;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = region + "." + (0, $709b0e48f6b53a82$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX;
        // Include the query string portion of the url
        var url = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).constructAuthorityUriFromObject((0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, authorityUrlInstance.getUrlComponents()), {
            HostNameAndPort: hostNameAndPort
        })).urlString;
        // Add the query string if a query string was provided
        if (queryString) return url + "?" + queryString;
        return url;
    };
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ Authority.replaceWithRegionalInformation = function(metadata, azureRegion) {
        metadata.authorization_endpoint = Authority.buildRegionalAuthorityString(metadata.authorization_endpoint, azureRegion);
        // TODO: Enquire on whether we should leave the query string or remove it before releasing the feature
        metadata.token_endpoint = Authority.buildRegionalAuthorityString(metadata.token_endpoint, azureRegion, (0, $709b0e48f6b53a82$export$a002182e51710d39).REGIONAL_AUTH_NON_MSI_QUERY_STRING);
        if (metadata.end_session_endpoint) metadata.end_session_endpoint = Authority.buildRegionalAuthorityString(metadata.end_session_endpoint, azureRegion);
        return metadata;
    };
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ Authority.transformCIAMAuthority = function(authority) {
        var ciamAuthority = authority.endsWith((0, $709b0e48f6b53a82$export$a002182e51710d39).FORWARD_SLASH) ? authority : "" + authority + (0, $709b0e48f6b53a82$export$a002182e51710d39).FORWARD_SLASH;
        var authorityUrl = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(authority);
        var authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $709b0e48f6b53a82$export$a002182e51710d39).CIAM_AUTH_URL)) {
            var tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = "" + ciamAuthority + tenantIdOrDomain + (0, $709b0e48f6b53a82$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX;
        }
        return ciamAuthority;
    };
    // Reserved tenant domain names that will not be replaced with tenant id
    Authority.reservedTenantDomains = new Set([
        "{tenant}",
        "{tenantid}",
        (0, $709b0e48f6b53a82$export$e18ac120172ed505).COMMON,
        (0, $709b0e48f6b53a82$export$e18ac120172ed505).CONSUMERS,
        (0, $709b0e48f6b53a82$export$e18ac120172ed505).ORGANIZATIONS
    ]);
    return Authority;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $7caa661ac4a070a1$export$4b476259e3402a97 = /** @class */ function() {
    function AuthorityFactory() {}
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Also performs endpoint discovery.
     *
     * @param authorityUri
     * @param networkClient
     * @param protocolMode
     */ AuthorityFactory.createDiscoveredInstance = function(authorityUri, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authorityUriFinal, acquireTokenAuthority, e_1;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        performanceClient === null || performanceClient === void 0 || performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
                        authorityUriFinal = (0, $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c).transformCIAMAuthority(authorityUri);
                        acquireTokenAuthority = AuthorityFactory.createInstance(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        performanceClient === null || performanceClient === void 0 || performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, correlationId);
                        return [
                            4 /*yield*/ ,
                            acquireTokenAuthority.resolveEndpointsAsync()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            acquireTokenAuthority
                        ];
                    case 3:
                        e_1 = _a.sent();
                        throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError(e_1);
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Does not perform endpoint discovery.
     *
     * @param authorityUrl
     * @param networkInterface
     * @param protocolMode
     */ AuthorityFactory.createInstance = function(authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        // Throw error if authority url is empty
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(authorityUrl)) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createUrlEmptyError();
        return new (0, $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c)(authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId);
    };
    return AuthorityFactory;
}();

/*! @azure/msal-common v13.3.1 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 

/*! @azure/msal-common v13.3.1 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $e4ba46f97bce1eb3$export$c69de3e7a1e69077 = /** @class */ function() {
    function NetworkManager(networkClient, cacheManager) {
        this.networkClient = networkClient;
        this.cacheManager = cacheManager;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint
     * @param tokenEndpoint
     * @param options
     */ NetworkManager.prototype.sendPostRequest = function(thumbprint, tokenEndpoint, options) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response, e_1;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $44321a50b91f10d9$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkClient.sendPostRequestAsync(tokenEndpoint, options)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) throw e_1;
                        else throw (0, $859b00ae06117652$export$a839ff85a7957561).createNetworkError(tokenEndpoint, e_1);
                    case 4:
                        (0, $44321a50b91f10d9$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    return NetworkManager;
}();








/*! @azure/msal-common v13.3.1 2023-10-27 */ 



/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ var $2009002703090bc1$export$9800b929b6984365 = /** @class */ function() {
    function RequestValidator() {}
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ RequestValidator.validateRedirectUri = function(redirectUri) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(redirectUri)) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createRedirectUriEmptyError();
    };
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ RequestValidator.validatePrompt = function(prompt) {
        var promptValues = [];
        for(var value in 0, $709b0e48f6b53a82$export$49a06cbda5acaa5)promptValues.push((0, $709b0e48f6b53a82$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidPromptError(prompt);
    };
    RequestValidator.validateClaims = function(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidClaimsRequestError();
        }
    };
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ RequestValidator.validateCodeChallengeParams = function(codeChallenge, codeChallengeMethod) {
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(codeChallenge) || (0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(codeChallengeMethod)) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidCodeChallengeParamsError();
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    };
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ RequestValidator.validateCodeChallengeMethod = function(codeChallengeMethod) {
        if ([
            (0, $709b0e48f6b53a82$export$a1fe36237c1cc863).PLAIN,
            (0, $709b0e48f6b53a82$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidCodeChallengeMethodError();
    };
    /**
     * Removes unnecessary, duplicate, and empty string query parameters from extraQueryParameters
     * @param request
     */ RequestValidator.sanitizeEQParams = function(eQParams, queryParams) {
        if (!eQParams) return {};
        // Remove any query parameters already included in SSO params
        queryParams.forEach(function(value, key) {
            if (eQParams[key]) delete eQParams[key];
        });
        // remove empty string parameters
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return Object.fromEntries(Object.entries(eQParams).filter(function(_a) {
            var value = _a[1];
            return value !== "";
        }));
    };
    return RequestValidator;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $8f22594edfb44d21$export$882078dd8a9e0bfa = /** @class */ function() {
    function RequestParameterBuilder() {
        this.parameters = new Map();
    }
    /**
     * add response_type = code
     */ RequestParameterBuilder.prototype.addResponseTypeCode = function() {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).RESPONSE_TYPE, encodeURIComponent((0, $709b0e48f6b53a82$export$a002182e51710d39).CODE_RESPONSE_TYPE));
    };
    /**
     * add response_type = token id_token
     */ RequestParameterBuilder.prototype.addResponseTypeForTokenAndIdToken = function() {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).RESPONSE_TYPE, encodeURIComponent((0, $709b0e48f6b53a82$export$a002182e51710d39).TOKEN_RESPONSE_TYPE + " " + (0, $709b0e48f6b53a82$export$a002182e51710d39).ID_TOKEN_RESPONSE_TYPE));
    };
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */ RequestParameterBuilder.prototype.addResponseMode = function(responseMode) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).RESPONSE_MODE, encodeURIComponent(responseMode ? responseMode : (0, $709b0e48f6b53a82$export$f990a5bae1260b8c).QUERY));
    };
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */ RequestParameterBuilder.prototype.addNativeBroker = function() {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).NATIVE_BROKER, encodeURIComponent("1"));
    };
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */ RequestParameterBuilder.prototype.addScopes = function(scopes, addOidcScopes) {
        if (addOidcScopes === void 0) addOidcScopes = true;
        var requestScopes = addOidcScopes ? (0, $a296cc98de023397$export$6388937ca91ccae8)(scopes || [], (0, $709b0e48f6b53a82$export$893b1b5b686d84ef)) : scopes || [];
        var scopeSet = new (0, $57be63d7f846af92$export$b9b82b0f94ae1f99)(requestScopes);
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).SCOPE, encodeURIComponent(scopeSet.printScopes()));
    };
    /**
     * add clientId
     * @param clientId
     */ RequestParameterBuilder.prototype.addClientId = function(clientId) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLIENT_ID, encodeURIComponent(clientId));
    };
    /**
     * add redirect_uri
     * @param redirectUri
     */ RequestParameterBuilder.prototype.addRedirectUri = function(redirectUri) {
        (0, $2009002703090bc1$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).REDIRECT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add post logout redirectUri
     * @param redirectUri
     */ RequestParameterBuilder.prototype.addPostLogoutRedirectUri = function(redirectUri) {
        (0, $2009002703090bc1$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).POST_LOGOUT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */ RequestParameterBuilder.prototype.addIdTokenHint = function(idTokenHint) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).ID_TOKEN_HINT, encodeURIComponent(idTokenHint));
    };
    /**
     * add domain_hint
     * @param domainHint
     */ RequestParameterBuilder.prototype.addDomainHint = function(domainHint) {
        this.parameters.set((0, $709b0e48f6b53a82$export$7f68224783b2bd08).DOMAIN_HINT, encodeURIComponent(domainHint));
    };
    /**
     * add login_hint
     * @param loginHint
     */ RequestParameterBuilder.prototype.addLoginHint = function(loginHint) {
        this.parameters.set((0, $709b0e48f6b53a82$export$7f68224783b2bd08).LOGIN_HINT, encodeURIComponent(loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */ RequestParameterBuilder.prototype.addCcsUpn = function(loginHint) {
        this.parameters.set((0, $709b0e48f6b53a82$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent("UPN:" + loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */ RequestParameterBuilder.prototype.addCcsOid = function(clientInfo) {
        this.parameters.set((0, $709b0e48f6b53a82$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent("Oid:" + clientInfo.uid + "@" + clientInfo.utid));
    };
    /**
     * add sid
     * @param sid
     */ RequestParameterBuilder.prototype.addSid = function(sid) {
        this.parameters.set((0, $709b0e48f6b53a82$export$7f68224783b2bd08).SID, encodeURIComponent(sid));
    };
    /**
     * add claims
     * @param claims
     */ RequestParameterBuilder.prototype.addClaims = function(claims, clientCapabilities) {
        var mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        (0, $2009002703090bc1$export$9800b929b6984365).validateClaims(mergedClaims);
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLAIMS, encodeURIComponent(mergedClaims));
    };
    /**
     * add correlationId
     * @param correlationId
     */ RequestParameterBuilder.prototype.addCorrelationId = function(correlationId) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLIENT_REQUEST_ID, encodeURIComponent(correlationId));
    };
    /**
     * add library info query params
     * @param libraryInfo
     */ RequestParameterBuilder.prototype.addLibraryInfo = function(libraryInfo) {
        // Telemetry Info
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_SKU, libraryInfo.sku);
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_VER, libraryInfo.version);
        if (libraryInfo.os) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_OS, libraryInfo.os);
        if (libraryInfo.cpu) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_CPU, libraryInfo.cpu);
    };
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */ RequestParameterBuilder.prototype.addApplicationTelemetry = function(appTelemetry) {
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appName) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_APP_NAME, appTelemetry.appName);
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appVersion) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_APP_VER, appTelemetry.appVersion);
    };
    /**
     * add prompt
     * @param prompt
     */ RequestParameterBuilder.prototype.addPrompt = function(prompt) {
        (0, $2009002703090bc1$export$9800b929b6984365).validatePrompt(prompt);
        this.parameters.set("" + (0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).PROMPT, encodeURIComponent(prompt));
    };
    /**
     * add state
     * @param state
     */ RequestParameterBuilder.prototype.addState = function(state) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(state)) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).STATE, encodeURIComponent(state));
    };
    /**
     * add nonce
     * @param nonce
     */ RequestParameterBuilder.prototype.addNonce = function(nonce) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).NONCE, encodeURIComponent(nonce));
    };
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */ RequestParameterBuilder.prototype.addCodeChallengeParams = function(codeChallenge, codeChallengeMethod) {
        (0, $2009002703090bc1$export$9800b929b6984365).validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CODE_CHALLENGE, encodeURIComponent(codeChallenge));
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CODE_CHALLENGE_METHOD, encodeURIComponent(codeChallengeMethod));
        } else throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidCodeChallengeParamsError();
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ RequestParameterBuilder.prototype.addAuthorizationCode = function(code) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CODE, encodeURIComponent(code));
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ RequestParameterBuilder.prototype.addDeviceCode = function(code) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).DEVICE_CODE, encodeURIComponent(code));
    };
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */ RequestParameterBuilder.prototype.addRefreshToken = function(refreshToken) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).REFRESH_TOKEN, encodeURIComponent(refreshToken));
    };
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */ RequestParameterBuilder.prototype.addCodeVerifier = function(codeVerifier) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CODE_VERIFIER, encodeURIComponent(codeVerifier));
    };
    /**
     * add client_secret
     * @param clientSecret
     */ RequestParameterBuilder.prototype.addClientSecret = function(clientSecret) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLIENT_SECRET, encodeURIComponent(clientSecret));
    };
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */ RequestParameterBuilder.prototype.addClientAssertion = function(clientAssertion) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(clientAssertion)) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLIENT_ASSERTION, encodeURIComponent(clientAssertion));
    };
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */ RequestParameterBuilder.prototype.addClientAssertionType = function(clientAssertionType) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(clientAssertionType)) this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).CLIENT_ASSERTION_TYPE, encodeURIComponent(clientAssertionType));
    };
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */ RequestParameterBuilder.prototype.addOboAssertion = function(oboAssertion) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).OBO_ASSERTION, encodeURIComponent(oboAssertion));
    };
    /**
     * add grant type
     * @param grantType
     */ RequestParameterBuilder.prototype.addRequestTokenUse = function(tokenUse) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).REQUESTED_TOKEN_USE, encodeURIComponent(tokenUse));
    };
    /**
     * add grant type
     * @param grantType
     */ RequestParameterBuilder.prototype.addGrantType = function(grantType) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).GRANT_TYPE, encodeURIComponent(grantType));
    };
    /**
     * add client info
     *
     */ RequestParameterBuilder.prototype.addClientInfo = function() {
        this.parameters.set((0, $709b0e48f6b53a82$export$476989d62bcb4c85), "1");
    };
    /**
     * add extraQueryParams
     * @param eQParams
     */ RequestParameterBuilder.prototype.addExtraQueryParameters = function(eQParams) {
        var _this = this;
        var sanitizedEQParams = (0, $2009002703090bc1$export$9800b929b6984365).sanitizeEQParams(eQParams, this.parameters);
        Object.keys(sanitizedEQParams).forEach(function(key) {
            _this.parameters.set(key, eQParams[key]);
        });
    };
    RequestParameterBuilder.prototype.addClientCapabilitiesToClaims = function(claims, clientCapabilities) {
        var mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) mergedClaims = {};
        else try {
            mergedClaims = JSON.parse(claims);
        } catch (e) {
            throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createInvalidClaimsRequestError();
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty((0, $709b0e48f6b53a82$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
            mergedClaims[(0, $709b0e48f6b53a82$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[(0, $709b0e48f6b53a82$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $709b0e48f6b53a82$export$c125cda26c71ef54).XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    };
    /**
     * adds `username` for Password Grant flow
     * @param username
     */ RequestParameterBuilder.prototype.addUsername = function(username) {
        this.parameters.set((0, $709b0e48f6b53a82$export$fa8b29062cab1da).username, encodeURIComponent(username));
    };
    /**
     * adds `password` for Password Grant flow
     * @param password
     */ RequestParameterBuilder.prototype.addPassword = function(password) {
        this.parameters.set((0, $709b0e48f6b53a82$export$fa8b29062cab1da).password, encodeURIComponent(password));
    };
    /**
     * add pop_jwk to query params
     * @param cnfString
     */ RequestParameterBuilder.prototype.addPopToken = function(cnfString) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(cnfString)) {
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).TOKEN_TYPE, (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP);
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).REQ_CNF, encodeURIComponent(cnfString));
        }
    };
    /**
     * add SSH JWK and key ID to query params
     */ RequestParameterBuilder.prototype.addSshJwk = function(sshJwkString) {
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(sshJwkString)) {
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).TOKEN_TYPE, (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH);
            this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).REQ_CNF, encodeURIComponent(sshJwkString));
        }
    };
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */ RequestParameterBuilder.prototype.addServerTelemetry = function(serverTelemetryManager) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
    };
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */ RequestParameterBuilder.prototype.addThrottling = function() {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).X_MS_LIB_CAPABILITY, (0, $709b0e48f6b53a82$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
    };
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */ RequestParameterBuilder.prototype.addLogoutHint = function(logoutHint) {
        this.parameters.set((0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).LOGOUT_HINT, encodeURIComponent(logoutHint));
    };
    /**
     * Utility to create a URL from the params map
     */ RequestParameterBuilder.prototype.createQueryString = function() {
        var queryParameterArray = new Array();
        this.parameters.forEach(function(value, key) {
            queryParameterArray.push(key + "=" + value);
        });
        return queryParameterArray.join("&");
    };
    return RequestParameterBuilder;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 */ var $b425941540279b13$export$4f22f74eddb7716a = /** @class */ function() {
    function BaseClient(configuration, performanceClient) {
        // Set the configuration
        this.config = (0, $e0e4999fede2ba19$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $5f18ed8a9f930396$export$efa9a398d6368992)(this.config.loggerOptions, (0, $c148700c4e017537$export$a8ff84c12d48cfa6), (0, $c148700c4e017537$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set the NetworkManager
        this.networkManager = new (0, $e4ba46f97bce1eb3$export$c69de3e7a1e69077)(this.networkClient, this.cacheManager);
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ BaseClient.prototype.createTokenRequestHeaders = function(ccsCred) {
        var headers = {};
        headers[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $709b0e48f6b53a82$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    var clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).CCS_HEADER] = "Oid:" + clientInfo.uid + "@" + clientInfo.utid;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $531468341ade26af$export$17b7b3ac1abef49f).UPN:
                headers[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).CCS_HEADER] = "UPN: " + ccsCred.credential;
                break;
        }
        return headers;
    };
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ BaseClient.prototype.executePostToTokenEndpoint = function(tokenEndpoint, queryString, headers, thumbprint) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.networkManager.sendPostRequest(thumbprint, tokenEndpoint, {
                                body: queryString,
                                headers: headers
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
                        this.config.serverTelemetryManager.clearTelemetryCache();
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ BaseClient.prototype.updateAuthority = function(updatedAuthority) {
        if (!updatedAuthority.discoveryComplete()) throw (0, $859b00ae06117652$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
        this.authority = updatedAuthority;
    };
    /**
     * Creates query string for the /token request
     * @param request
     */ BaseClient.prototype.createTokenQueryParameters = function(request) {
        var parameterBuilder = new (0, $8f22594edfb44d21$export$882078dd8a9e0bfa)();
        if (request.tokenQueryParameters) parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        return parameterBuilder.createQueryString();
    };
    return BaseClient;
}();




/*! @azure/msal-common v13.3.1 2023-10-27 */ 












/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $5c9a0b8485eed0cc$export$5ee5669a32bdea66 = /** @class */ function() {
    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
        this.account = accountEntity || null;
        this.idToken = idTokenEntity || null;
        this.accessToken = accessTokenEntity || null;
        this.refreshToken = refreshTokenEntity || null;
        this.appMetadata = appMetadataEntity || null;
    }
    return CacheRecord;
}();




/*! @azure/msal-common v13.3.1 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $53c21a464cad5b47$var$KeyLocation;
(function(KeyLocation) {
    KeyLocation["SW"] = "sw";
    KeyLocation["UHW"] = "uhw";
})($53c21a464cad5b47$var$KeyLocation || ($53c21a464cad5b47$var$KeyLocation = {}));
var $53c21a464cad5b47$export$3dd8467151c83e3e = /** @class */ function() {
    function PopTokenGenerator(cryptoUtils, performanceClient) {
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.generateCnf = function(request) {
        var _a, _b;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var reqCnf, reqCnfString, _c;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.generateKid(request)
                        ];
                    case 1:
                        reqCnf = _d.sent();
                        reqCnfString = this.cryptoUtils.base64Encode(JSON.stringify(reqCnf));
                        _c = {
                            kid: reqCnf.kid,
                            reqCnfString: reqCnfString
                        };
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.hashString(reqCnfString)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            (_c.reqCnfHash = _d.sent(), _c)
                        ];
                }
            });
        });
    };
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.generateKid = function(request) {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var kidThumbprint;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.getPublicKeyThumbprint(request)
                        ];
                    case 1:
                        kidThumbprint = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                kid: kidThumbprint,
                                xms_ksl: $53c21a464cad5b47$var$KeyLocation.SW
                            }
                        ];
                }
            });
        });
    };
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.signPopToken = function(accessToken, keyId, request) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.signPayload(accessToken, keyId, request)
                ];
            });
        });
    };
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ PopTokenGenerator.prototype.signPayload = function(payload, keyId, request, claims) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var resourceRequestMethod, resourceRequestUri, shrClaims, shrNonce, resourceUrlString, resourceUrlComponents;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resourceRequestMethod = request.resourceRequestMethod, resourceRequestUri = request.resourceRequestUri, shrClaims = request.shrClaims, shrNonce = request.shrNonce;
                        resourceUrlString = resourceRequestUri ? new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
                        resourceUrlComponents = resourceUrlString === null || resourceUrlString === void 0 ? void 0 : resourceUrlString.getUrlComponents();
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.signJwt((0, $a296cc98de023397$export$18ce0697a983be9b)({
                                at: payload,
                                ts: (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds(),
                                m: resourceRequestMethod === null || resourceRequestMethod === void 0 ? void 0 : resourceRequestMethod.toUpperCase(),
                                u: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.HostNameAndPort,
                                nonce: shrNonce || this.cryptoUtils.createNewGuid(),
                                p: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.AbsolutePath,
                                q: (resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.QueryString) ? [
                                    [],
                                    resourceUrlComponents.QueryString
                                ] : undefined,
                                client_claims: shrClaims || undefined
                            }, claims), keyId, request.correlationId)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return PopTokenGenerator;
}();



/*! @azure/msal-common v13.3.1 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ var $a5f8a1c901e11079$export$500ab620f6bcc747 = /** @class */ function() {
    function TokenCacheContext(tokenCache, hasChanged) {
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
        /**
         * boolean which indicates the changes in cache
         */ get: function() {
            return this.hasChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
        /**
         * function to retrieve the token cache
         */ get: function() {
            return this.cache;
        },
        enumerable: false,
        configurable: true
    });
    return TokenCacheContext;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 */ var $7bceb18977467864$export$f456c9835cc63582 = /** @class */ function() {
    function ResponseHandler(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient) {
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param cachedState
     * @param cryptoObj
     */ ResponseHandler.prototype.validateServerAuthorizationCodeResponse = function(serverResponseHash, cachedState, cryptoObj) {
        if (!serverResponseHash.state || !cachedState) throw !serverResponseHash.state ? (0, $859b00ae06117652$export$a839ff85a7957561).createStateNotFoundError("Server State") : (0, $859b00ae06117652$export$a839ff85a7957561).createStateNotFoundError("Cached State");
        if (decodeURIComponent(serverResponseHash.state) !== decodeURIComponent(cachedState)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createStateMismatchError();
        // Check for error
        if (serverResponseHash.error || serverResponseHash.error_description || serverResponseHash.suberror) {
            if ((0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba).isInteractionRequiredError(serverResponseHash.error, serverResponseHash.error_description, serverResponseHash.suberror)) throw new (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba)(serverResponseHash.error || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror, serverResponseHash.timestamp || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.trace_id || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.correlation_id || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.claims || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
            throw new (0, $18269c32984fce6f$export$ea52035eac03daf0)(serverResponseHash.error || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
        }
        if (serverResponseHash.client_info) (0, $6fc13ebc332ded7c$export$575e1419cfbab7f8)(serverResponseHash.client_info, cryptoObj);
    };
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     */ ResponseHandler.prototype.validateTokenResponse = function(serverResponse) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            if ((0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba).isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
            var errString = serverResponse.error_codes + " - [" + serverResponse.timestamp + "]: " + serverResponse.error_description + " - Correlation ID: " + serverResponse.correlation_id + " - Trace ID: " + serverResponse.trace_id;
            throw new (0, $18269c32984fce6f$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror);
        }
    };
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ ResponseHandler.prototype.handleServerTokenResponse = function(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var idTokenObj, authTime, requestStateObj, cacheRecord, cacheContext, key, account;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
                        if (serverTokenResponse.id_token) {
                            idTokenObj = new (0, $557a50de248ab1f3$export$3a170961dab30083)(serverTokenResponse.id_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj);
                            // token nonce check (TODO: Add a warning if no nonce is given?)
                            if (authCodePayload && !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(authCodePayload.nonce)) {
                                if (idTokenObj.claims.nonce !== authCodePayload.nonce) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNonceMismatchError();
                            }
                            // token max_age check
                            if (request.maxAge || request.maxAge === 0) {
                                authTime = idTokenObj.claims.auth_time;
                                if (!authTime) throw (0, $859b00ae06117652$export$a839ff85a7957561).createAuthTimeNotFoundError();
                                (0, $557a50de248ab1f3$export$3a170961dab30083).checkMaxAge(authTime, request.maxAge);
                            }
                        }
                        // generate homeAccountId
                        this.homeAccountIdentifier = (0, $6ff18147f1afb887$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenObj);
                        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
                        // Add keyId from request to serverTokenResponse if defined
                        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
                        cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            5,
                            8
                        ]);
                        if (!(this.persistencePlugin && this.serializableCache)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                        cacheContext = new (0, $a5f8a1c901e11079$export$500ab620f6bcc747)(this.serializableCache, true);
                        return [
                            4 /*yield*/ ,
                            this.persistencePlugin.beforeCacheAccess(cacheContext)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        /*
                         * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
                         * If not present, we should return null, as it's the case that another application called removeAccount in between
                         * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
                         * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
                         */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                            key = cacheRecord.account.generateAccountKey();
                            account = this.cacheStorage.getAccount(key);
                            if (!account) {
                                this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                                return [
                                    2 /*return*/ ,
                                    ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, undefined, serverRequestId)
                                ];
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.cacheStorage.saveCacheRecord(cacheRecord)
                        ];
                    case 4:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 5:
                        if (!(this.persistencePlugin && this.serializableCache && cacheContext)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                        return [
                            4 /*yield*/ ,
                            this.persistencePlugin.afterCacheAccess(cacheContext)
                        ];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, serverTokenResponse, serverRequestId)
                        ];
                }
            });
        });
    };
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ ResponseHandler.prototype.generateCacheRecord = function(serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload) {
        var env = authority.getPreferredCache();
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(env)) throw (0, $859b00ae06117652$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        // IdToken: non AAD scenarios can have empty realm
        var cachedIdToken;
        var cachedAccount;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(serverTokenResponse.id_token) && !!idTokenObj) {
            cachedIdToken = (0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde).createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, this.clientId, idTokenObj.claims.tid || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
            cachedAccount = this.generateAccountEntity(serverTokenResponse, idTokenObj, authority, authCodePayload);
        }
        // AccessToken
        var cachedAccessToken = null;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(serverTokenResponse.access_token)) {
            // If scopes not returned in server response, use request scopes
            var responseScopes = serverTokenResponse.scope ? (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $57be63d7f846af92$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ var expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            var extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            var refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            var tokenExpirationSeconds = reqTimestamp + expiresIn;
            var extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            var refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $c2e674572252645d$export$6b7a8e14ec177765).createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, this.clientId, idTokenObj ? idTokenObj.claims.tid || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING : authority.tenant, responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        var cachedRefreshToken = null;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(serverTokenResponse.refresh_token)) cachedRefreshToken = (0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b).createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, this.clientId, serverTokenResponse.foci, userAssertionHash);
        // appMetadata
        var cachedAppMetadata = null;
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(serverTokenResponse.foci)) cachedAppMetadata = (0, $3fe60484fc3744c3$export$b939be19f91a34cc).createAppMetadataEntity(this.clientId, env, serverTokenResponse.foci);
        return new (0, $5c9a0b8485eed0cc$export$5ee5669a32bdea66)(cachedAccount, cachedIdToken, cachedAccessToken, cachedRefreshToken, cachedAppMetadata);
    };
    /**
     * Generate Account
     * @param serverTokenResponse
     * @param idToken
     * @param authority
     */ ResponseHandler.prototype.generateAccountEntity = function(serverTokenResponse, idToken, authority, authCodePayload) {
        var authorityType = authority.authorityType;
        var cloudGraphHostName = authCodePayload ? authCodePayload.cloud_graph_host_name : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var msGraphhost = authCodePayload ? authCodePayload.msgraph_host : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        // ADFS does not require client_info in the response
        if (authorityType === (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Adfs) {
            this.logger.verbose("Authority type is ADFS, creating ADFS account");
            return (0, $6ff18147f1afb887$export$680160523e6bfa6a).createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
        }
        // This fallback applies to B2C as well as they fall under an AAD account type.
        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(serverTokenResponse.client_info) && authority.protocolMode === "AAD") throw (0, $859b00ae06117652$export$a839ff85a7957561).createClientInfoEmptyError();
        return serverTokenResponse.client_info ? (0, $6ff18147f1afb887$export$680160523e6bfa6a).createAccount(serverTokenResponse.client_info, this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost) : (0, $6ff18147f1afb887$export$680160523e6bfa6a).createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
    };
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ ResponseHandler.generateAuthenticationResult = function(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenObj, requestState, serverTokenResponse, requestId) {
        var _a, _b, _c;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var accessToken, responseScopes, expiresOn, extExpiresOn, familyId, popTokenGenerator, _d, secret, keyId, uid, tid;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        accessToken = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        responseScopes = [];
                        expiresOn = null;
                        familyId = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        if (!cacheRecord.accessToken) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(cacheRecord.accessToken.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(cryptoObj);
                        _d = cacheRecord.accessToken, secret = _d.secret, keyId = _d.keyId;
                        if (!keyId) throw (0, $859b00ae06117652$export$a839ff85a7957561).createKeyIdMissingError();
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.signPopToken(secret, keyId, request)
                        ];
                    case 1:
                        accessToken = _e.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        accessToken = cacheRecord.accessToken.secret;
                        _e.label = 3;
                    case 3:
                        responseScopes = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
                        expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
                        extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
                        _e.label = 4;
                    case 4:
                        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $709b0e48f6b53a82$export$978fe7ab5e74b539) ? (0, $709b0e48f6b53a82$export$978fe7ab5e74b539) : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        // for hybrid + native bridge enablement, send back the native account Id
                        if ((serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid) && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid;
                        return [
                            2 /*return*/ ,
                            {
                                authority: authority.canonicalAuthority,
                                uniqueId: uid,
                                tenantId: tid,
                                scopes: responseScopes,
                                account: cacheRecord.account ? cacheRecord.account.getAccountInfo() : null,
                                idToken: idTokenObj ? idTokenObj.rawToken : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                idTokenClaims: idTokenObj ? idTokenObj.claims : {},
                                accessToken: accessToken,
                                fromCache: fromTokenCache,
                                expiresOn: expiresOn,
                                correlationId: request.correlationId,
                                requestId: requestId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                extExpiresOn: extExpiresOn,
                                familyId: familyId,
                                tokenType: ((_a = cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                state: requestState ? requestState.userRequestState : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                cloudGraphHostName: ((_b = cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                msGraphHost: ((_c = cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                code: serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_code,
                                fromNativeBroker: false
                            }
                        ];
                }
            });
        });
    };
    return ResponseHandler;
}();












"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 */ var $af51605ea36bf75c$export$8538731fd397fb90 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(AuthorizationCodeClient, _super);
    function AuthorizationCodeClient(configuration, performanceClient) {
        var _this = _super.call(this, configuration, performanceClient) || this;
        // Flag to indicate if client is for hybrid spa auth code redemption
        _this.includeRedirectUri = true;
        return _this;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */ AuthorizationCodeClient.prototype.getAuthCodeUrl = function(request) {
        var _a, _b;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var queryString;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).GetAuthCodeUrl, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientCreateQueryString, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeUrlQueryString(request)
                        ];
                    case 1:
                        queryString = _c.sent();
                        return [
                            2 /*return*/ ,
                            (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).appendQueryString(this.authority.authorizationEndpoint, queryString)
                        ];
                }
            });
        });
    };
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ AuthorizationCodeClient.prototype.acquireToken = function(request, authCodePayload) {
        var _a, _b, _c, _d, _e, _f;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, reqTimestamp, response, requestId, httpVerAuthority, responseHandler;
            var _this = this;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!request || !request.code) throw (0, $859b00ae06117652$export$a839ff85a7957561).createTokenRequestCannotBeMadeError();
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement("AuthCodeClientAcquireToken", request.correlationId);
                        this.logger.info("in acquireToken call in auth-code client");
                        reqTimestamp = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.executeTokenRequest(this.authority, request)
                        ];
                    case 1:
                        response = _g.sent();
                        requestId = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).X_MS_REQUEST_ID];
                        httpVerAuthority = (_e = response.headers) === null || _e === void 0 ? void 0 : _e[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).X_MS_HTTP_VERSION];
                        if (httpVerAuthority) atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            httpVerAuthority: httpVerAuthority
                        });
                        responseHandler = new (0, $7bceb18977467864$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response.body);
                        (_f = this.performanceClient) === null || _f === void 0 || _f.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleServerTokenResponse, request.correlationId);
                        return [
                            2 /*return*/ ,
                            responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId).then(function(result) {
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                _this.logger.verbose("Error in fetching token in ACC", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */ AuthorizationCodeClient.prototype.handleFragmentResponse = function(hashFragment, cachedState) {
        // Handle responses.
        var responseHandler = new (0, $7bceb18977467864$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Deserialize hash fragment response parameters.
        var hashUrlString = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(hashFragment);
        // Deserialize hash fragment response parameters.
        var serverParams = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(hashUrlString.getHash());
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState, this.cryptoUtils);
        // throw when there is no auth code in the response
        if (!serverParams.code) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAuthCodeInServerResponseError();
        return (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, serverParams), {
            // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
            code: serverParams.code
        });
    };
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ AuthorizationCodeClient.prototype.getLogoutUri = function(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createEmptyLogoutRequestError();
        var queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    };
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ AuthorizationCodeClient.prototype.executeTokenRequest = function(authority, request) {
        var _a, _b;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var queryParametersString, endpoint, requestBody, ccsCredential, clientInfo, headers, thumbprint;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [
                            4 /*yield*/ ,
                            this.createTokenRequestBody(request)
                        ];
                    case 1:
                        requestBody = _c.sent();
                        ccsCredential = undefined;
                        if (request.clientInfo) try {
                            clientInfo = (0, $6fc13ebc332ded7c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils);
                            ccsCredential = {
                                credential: "" + clientInfo.uid + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                type: (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                            };
                        } catch (e) {
                            this.logger.verbose("Could not parse client info for CCS Header: " + e);
                        }
                        headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [
                            2 /*return*/ ,
                            this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)
                        ];
                }
            });
        });
    };
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ AuthorizationCodeClient.prototype.createTokenRequestBody = function(request) {
        var _a, _b;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, correlationId, ccsCred, clientInfo, clientInfo;
            var _c;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
                        parameterBuilder = new (0, $8f22594edfb44d21$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        /*
                         * For hybrid spa flow, there will be a code but no verifier
                         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
                         */ if (!this.includeRedirectUri) // Just validate
                        (0, $2009002703090bc1$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
                        else // Validate and include redirect uri
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        // Add scope array, parameter builder will add default scopes and dedupe
                        parameterBuilder.addScopes(request.scopes);
                        // add code: user set, not validated
                        parameterBuilder.addAuthorizationCode(request.code);
                        // Add library metadata
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        // add code_verifier if passed
                        if (request.codeVerifier) parameterBuilder.addCodeVerifier(request.codeVerifier);
                        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        parameterBuilder.addGrantType((0, $709b0e48f6b53a82$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
                        parameterBuilder.addClientInfo();
                        if (!(request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH) {
                            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
                            else throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createMissingSshJwkError();
                        }
                        _d.label = 3;
                    case 3:
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        ccsCred = undefined;
                        if (request.clientInfo) try {
                            clientInfo = (0, $6fc13ebc332ded7c$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils);
                            ccsCred = {
                                credential: "" + clientInfo.uid + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                type: (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                            };
                        } catch (e) {
                            this.logger.verbose("Could not parse client info for CCS Header: " + e);
                        }
                        else ccsCred = request.ccsCredential;
                        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
                        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
                            case (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                                try {
                                    clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(ccsCred.credential);
                                    parameterBuilder.addCcsOid(clientInfo);
                                } catch (e) {
                                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                }
                                break;
                            case (0, $531468341ade26af$export$17b7b3ac1abef49f).UPN:
                                parameterBuilder.addCcsUpn(ccsCred.credential);
                                break;
                        }
                        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
                        // Add hybrid spa parameters if not already provided
                        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[(0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).RETURN_SPA_CODE])) parameterBuilder.addExtraQueryParameters((_c = {}, _c[(0, $709b0e48f6b53a82$export$cf7709e7db2ddf5d).RETURN_SPA_CODE] = "1", _c));
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */ AuthorizationCodeClient.prototype.createAuthCodeUrlQueryString = function(request) {
        var _a;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parameterBuilder, requestScopes, correlationId, accountSid, accountLoginHintClaim, clientInfo, clientInfo, clientInfo, popTokenGenerator, reqCnfData;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientCreateQueryString, request.correlationId);
                        parameterBuilder = new (0, $8f22594edfb44d21$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        requestScopes = (0, $a296cc98de023397$export$6388937ca91ccae8)(request.scopes || [], request.extraScopesToConsent || []);
                        parameterBuilder.addScopes(requestScopes);
                        // validate the redirectUri (to be a non null value)
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        // add response_mode. If not passed in it defaults to query.
                        parameterBuilder.addResponseMode(request.responseMode);
                        // add response_type = code
                        parameterBuilder.addResponseTypeCode();
                        // add library info parameters
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        // add client_info=1
                        parameterBuilder.addClientInfo();
                        if (request.codeChallenge && request.codeChallengeMethod) parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
                        if (request.prompt) parameterBuilder.addPrompt(request.prompt);
                        if (request.domainHint) parameterBuilder.addDomainHint(request.domainHint);
                        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
                        if (request.prompt !== (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
                            // AAD will throw if prompt=select_account is passed with an account hint
                            if (request.sid && request.prompt === (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE) {
                                // SessionID is only used in silent calls
                                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                                parameterBuilder.addSid(request.sid);
                            } else if (request.account) {
                                accountSid = this.extractAccountSid(request.account);
                                accountLoginHintClaim = this.extractLoginHint(request.account);
                                // If login_hint claim is present, use it over sid/username
                                if (accountLoginHintClaim) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                                    try {
                                        clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                } else if (accountSid && request.prompt === (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE) {
                                    /*
                                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                                     * SessionId is only used in silent calls
                                     */ this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                                    parameterBuilder.addSid(accountSid);
                                    try {
                                        clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                } else if (request.loginHint) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                                    parameterBuilder.addLoginHint(request.loginHint);
                                    parameterBuilder.addCcsUpn(request.loginHint);
                                } else if (request.account.username) {
                                    // Fallback to account username if provided
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                                    parameterBuilder.addLoginHint(request.account.username);
                                    try {
                                        clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                }
                            } else if (request.loginHint) {
                                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                                parameterBuilder.addLoginHint(request.loginHint);
                                parameterBuilder.addCcsUpn(request.loginHint);
                            }
                        } else this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
                        if (request.nonce) parameterBuilder.addNonce(request.nonce);
                        if (request.state) parameterBuilder.addState(request.state);
                        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
                        if (!request.nativeBroker) return [
                            3 /*break*/ ,
                            2
                        ];
                        // signal ests that this is a WAM call
                        parameterBuilder.addNativeBroker();
                        if (!(request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(this.cryptoUtils);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _b.sent();
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ AuthorizationCodeClient.prototype.createLogoutUrlQueryString = function(request) {
        var parameterBuilder = new (0, $8f22594edfb44d21$export$882078dd8a9e0bfa)();
        if (request.postLogoutRedirectUri) parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        if (request.correlationId) parameterBuilder.addCorrelationId(request.correlationId);
        if (request.idTokenHint) parameterBuilder.addIdTokenHint(request.idTokenHint);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.logoutHint) parameterBuilder.addLogoutHint(request.logoutHint);
        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        return parameterBuilder.createQueryString();
    };
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */ AuthorizationCodeClient.prototype.extractAccountSid = function(account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.sid) || null;
    };
    AuthorizationCodeClient.prototype.extractLoginHint = function(account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.login_hint) || null;
    };
    return AuthorizationCodeClient;
}((0, $b425941540279b13$export$4f22f74eddb7716a));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 
/*! @azure/msal-common v13.3.1 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $65a3f49cb6307125$export$bddbbc43a3ca9c53 = /** @class */ function() {
    function ServerTelemetryManager(telemetryRequest, cacheManager) {
        this.cacheOutcome = (0, $709b0e48f6b53a82$export$aa4af185ea049f6b).NO_CACHE_HIT;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $709b0e48f6b53a82$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ ServerTelemetryManager.prototype.generateCurrentRequestHeaderValue = function() {
        var request = "" + this.apiId + (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR + this.cacheOutcome;
        var platformFields = [
            this.wrapperSKU,
            this.wrapperVer
        ].join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var regionDiscoveryFields = this.getRegionDiscoveryFields();
        var requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    };
    /**
     * API to add MSER Telemetry for the last failed request
     */ ServerTelemetryManager.prototype.generateLastRequestHeaderValue = function() {
        var lastRequests = this.getLastRequests();
        var maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var errors = lastRequests.errors.slice(0, maxErrors).join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        var overflow = maxErrors < errorCount ? (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        var platformFields = [
            errorCount,
            overflow
        ].join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    };
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ ServerTelemetryManager.prototype.cacheFailedRequest = function(error) {
        var lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(error.subError)) lastRequests.errors.push(error.subError);
        else if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(error.errorCode)) lastRequests.errors.push(error.errorCode);
        else if (!!error && error.toString()) lastRequests.errors.push(error.toString());
        else lastRequests.errors.push((0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    };
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ ServerTelemetryManager.prototype.incrementCacheHits = function() {
        var lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    };
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ ServerTelemetryManager.prototype.getLastRequests = function() {
        var initialValue = new (0, $87bb5d62a25750b6$export$ff670b37c5e10296)();
        var lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    };
    /**
     * Remove server telemetry cache entry
     */ ServerTelemetryManager.prototype.clearTelemetryCache = function() {
        var lastRequests = this.getLastRequests();
        var numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            var serverTelemEntity = new (0, $87bb5d62a25750b6$export$ff670b37c5e10296)();
            serverTelemEntity.failedRequests = lastRequests.failedRequests.slice(numErrorsFlushed * 2); // failedRequests contains 2 items for each error
            serverTelemEntity.errors = lastRequests.errors.slice(numErrorsFlushed);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    };
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ ServerTelemetryManager.maxErrorsToSend = function(serverTelemetryEntity) {
        var i;
        var maxErrors = 0;
        var dataSize = 0;
        var errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            var apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            var correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            var errorCode = serverTelemetryEntity.errors[i] || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $709b0e48f6b53a82$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    };
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ ServerTelemetryManager.prototype.getRegionDiscoveryFields = function() {
        var regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    };
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ ServerTelemetryManager.prototype.updateRegionDiscoveryMetadata = function(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    };
    /**
     * Set cache outcome
     */ ServerTelemetryManager.prototype.setCacheOutcome = function(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    };
    return ServerTelemetryManager;
}();





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $fa3ce8107f1cdd19$export$d858565f81c03f1f = /** @class */ function() {
    function BaseInteractionClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) {
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || this.browserCrypto.createNewGuid();
        this.logger = logger.clone((0, $0f344e7ceaf1df75$export$a0a689e4294b9880).MSAL_SKU, (0, $a90996ccbe5c3c78$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    BaseInteractionClient.prototype.clearCacheOnLogout = function(account) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!account) return [
                            3 /*break*/ ,
                            5
                        ];
                        if ((0, $6ff18147f1afb887$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(), false)) {
                            this.logger.verbose("Setting active account to null");
                            this.browserStorage.setActiveAccount(null);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.browserStorage.removeAccount((0, $6ff18147f1afb887$export$680160523e6bfa6a).generateAccountCacheKey(account))
                        ];
                    case 2:
                        _a.sent();
                        this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a.sent();
                        this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
                        // Clear all accounts and tokens
                        return [
                            4 /*yield*/ ,
                            this.browserStorage.clear()
                        ];
                    case 6:
                        // Clear all accounts and tokens
                        _a.sent();
                        // Clear any stray keys from IndexedDB
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.clearKeystore()
                        ];
                    case 7:
                        // Clear any stray keys from IndexedDB
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        _a.sent();
                        this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initializer function for all request APIs
     * @param request
     */ BaseInteractionClient.prototype.initializeBaseRequest = function(request, account) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, scopes, validatedRequest, _a;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
                        this.logger.verbose("Initializing BaseAuthRequest");
                        authority = request.authority || this.config.auth.authority;
                        if (!account) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.validateRequestAuthority(authority, account)
                        ];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        scopes = (0, $87ab789688594f61$export$afc72e2116322959)(request && request.scopes || []);
                        validatedRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                            correlationId: this.correlationId,
                            authority: authority,
                            scopes: scopes
                        });
                        // Set authenticationScheme to BEARER if not explicitly set in the request
                        if (!validatedRequest.authenticationScheme) {
                            validatedRequest.authenticationScheme = (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER;
                            this.logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
                        } else {
                            if (validatedRequest.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH) {
                                if (!request.sshJwk) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createMissingSshJwkError();
                                if (!request.sshKid) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createMissingSshKidError();
                            }
                            this.logger.verbose('Authentication Scheme set to "' + validatedRequest.authenticationScheme + '" as configured in Auth request');
                        }
                        if (!(this.config.cache.claimsBasedCachingEnabled && request.claims && !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmptyObj(request.claims))) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = validatedRequest;
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.hashString(request.claims)
                        ];
                    case 3:
                        _a.requestedClaimsHash = _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ BaseInteractionClient.prototype.getRedirectUri = function(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        var redirectUri = requestRedirectUri || this.config.auth.redirectUri || (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri();
        return (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
    };
    /*
     * If authority provided in the request does not match environment/authority specified
     * in the account or MSAL config, we throw an error.
     */ BaseInteractionClient.prototype.validateRequestAuthority = function(authority, account) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var discoveredAuthority;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(authority)
                        ];
                    case 1:
                        discoveredAuthority = _a.sent();
                        if (!discoveredAuthority.isAlias(account.environment)) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createAuthorityMismatchError();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ BaseInteractionClient.prototype.initializeServerTelemetryManager = function(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        var telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $65a3f49cb6307125$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */ BaseInteractionClient.prototype.getDiscoveredAuthority = function(requestAuthority) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authorityOptions;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("getDiscoveredAuthority called");
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata
                        };
                        if (!requestAuthority) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.logger.verbose("Creating discovered authority with request authority");
                        return [
                            4 /*yield*/ ,
                            (0, $7caa661ac4a070a1$export$4b476259e3402a97).createDiscoveredInstance(requestAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        this.logger.verbose("Creating discovered authority with configured authority");
                        return [
                            4 /*yield*/ ,
                            (0, $7caa661ac4a070a1$export$4b476259e3402a97).createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return BaseInteractionClient;
}();







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ var $f8c29a15d1b0a83c$export$fa9179cade3eb05a = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(StandardInteractionClient, _super);
    function StandardInteractionClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */ StandardInteractionClient.prototype.initializeAuthorizationCodeRequest = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var generatedPkceParams, authCodeRequest;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.generatePkceCodes()
                        ];
                    case 1:
                        generatedPkceParams = _a.sent();
                        authCodeRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                            redirectUri: request.redirectUri,
                            code: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                            codeVerifier: generatedPkceParams.verifier
                        });
                        request.codeChallenge = generatedPkceParams.challenge;
                        request.codeChallengeMethod = (0, $709b0e48f6b53a82$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD;
                        return [
                            2 /*return*/ ,
                            authCodeRequest
                        ];
                }
            });
        });
    };
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ StandardInteractionClient.prototype.initializeLogoutRequest = function(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
        var validLogoutRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)({
            correlationId: this.correlationId || this.browserCrypto.createNewGuid()
        }, logoutRequest);
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    var logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl((0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri(), (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    };
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ StandardInteractionClient.prototype.getLogoutHintFromIdTokenClaims = function(account) {
        var idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    };
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ StandardInteractionClient.prototype.createAuthCodeClient = function(serverTelemetryManager, authorityUrl, requestAzureCloudOptions) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, requestAzureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $af51605ea36bf75c$export$8538731fd397fb90)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param serverTelemetryManager
     * @param requestAuthority
     * @param requestCorrelationId
     */ StandardInteractionClient.prototype.getClientConfiguration = function(serverTelemetryManager, requestAuthority, requestAzureCloudOptions) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var discoveredAuthority, logger;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        this.logger.verbose("getClientConfiguration called", this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(requestAuthority, requestAzureCloudOptions)
                        ];
                    case 1:
                        discoveredAuthority = _a.sent();
                        logger = this.config.system.loggerOptions;
                        return [
                            2 /*return*/ ,
                            {
                                authOptions: {
                                    clientId: this.config.auth.clientId,
                                    authority: discoveredAuthority,
                                    clientCapabilities: this.config.auth.clientCapabilities
                                },
                                systemOptions: {
                                    tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                                    preventCorsPreflight: true
                                },
                                loggerOptions: {
                                    loggerCallback: logger.loggerCallback,
                                    piiLoggingEnabled: logger.piiLoggingEnabled,
                                    logLevel: logger.logLevel,
                                    correlationId: this.correlationId
                                },
                                cacheOptions: {
                                    claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
                                },
                                cryptoInterface: this.browserCrypto,
                                networkInterface: this.networkClient,
                                storageInterface: this.browserStorage,
                                serverTelemetryManager: serverTelemetryManager,
                                libraryInfo: {
                                    sku: (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).MSAL_SKU,
                                    version: (0, $a90996ccbe5c3c78$export$83d89fbfd8236492),
                                    cpu: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                                    os: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING
                                },
                                telemetry: this.config.telemetry
                            }
                        ];
                }
            });
        });
    };
    /**
     * @param hash
     * @param interactionType
     */ StandardInteractionClient.prototype.validateAndExtractStateFromHash = function(serverParams, interactionType, requestCorrelationId) {
        this.logger.verbose("validateAndExtractStateFromHash called", requestCorrelationId);
        if (!serverParams.state) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createHashDoesNotContainStateError();
        var platformStateObj = (0, $e57b35ef8cb8f153$export$83c579d74a9d4ed7).extractBrowserRequestState(this.browserCrypto, serverParams.state);
        if (!platformStateObj) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToParseStateError();
        if (platformStateObj.interactionType !== interactionType) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createStateInteractionTypeMismatchError();
        this.logger.verbose("Returning state from hash", requestCorrelationId);
        return serverParams.state;
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */ StandardInteractionClient.prototype.getDiscoveredAuthority = function(requestAuthority, requestAzureCloudOptions) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var getAuthorityMeasurement, authorityOptions, userAuthority, builtAuthority;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        this.logger.verbose("getDiscoveredAuthority called", this.correlationId);
                        getAuthorityMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata,
                            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
                        };
                        userAuthority = requestAuthority ? requestAuthority : this.config.auth.authority;
                        builtAuthority = (0, $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, requestAzureCloudOptions || this.config.auth.azureCloudOptions);
                        this.logger.verbose("Creating discovered authority with configured authority", this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            (0, $7caa661ac4a070a1$export$4b476259e3402a97).createDiscoveredInstance(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.performanceClient, this.correlationId).then(function(result) {
                                getAuthorityMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                getAuthorityMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ StandardInteractionClient.prototype.initializeAuthorizationRequest = function(request, interactionType) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var redirectUri, browserState, state, validatedRequest, _a, account, legacyLoginHint;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", this.correlationId);
                        redirectUri = this.getRedirectUri(request.redirectUri);
                        browserState = {
                            interactionType: interactionType
                        };
                        state = (0, $d3c398c9af34ca18$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, browserState);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeBaseRequest, this.correlationId);
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request)
                        ];
                    case 1:
                        validatedRequest = (0, $87ab789688594f61$export$18ce0697a983be9b).apply(void 0, [
                            (0, $87ab789688594f61$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                _b.sent()
                            ])),
                            {
                                redirectUri: redirectUri,
                                state: state,
                                nonce: request.nonce || this.browserCrypto.createNewGuid(),
                                responseMode: (0, $709b0e48f6b53a82$export$f990a5bae1260b8c).FRAGMENT
                            }
                        ]);
                        account = request.account || this.browserStorage.getActiveAccount();
                        if (account) {
                            this.logger.verbose("Setting validated request account", this.correlationId);
                            this.logger.verbosePii("Setting validated request account: " + account.homeAccountId, this.correlationId);
                            validatedRequest.account = account;
                        }
                        // Check for ADAL/MSAL v1 SSO
                        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(validatedRequest.loginHint) && !account) {
                            legacyLoginHint = this.browserStorage.getLegacyLoginHint();
                            if (legacyLoginHint) validatedRequest.loginHint = legacyLoginHint;
                        }
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    return StandardInteractionClient;
}((0, $fa3ce8107f1cdd19$export$d858565f81c03f1f));





/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $5dffa83ecc9ed68e$export$6154327c09fa1b4d;
(function(NativeStatusCode) {
    NativeStatusCode["USER_INTERACTION_REQUIRED"] = "USER_INTERACTION_REQUIRED";
    NativeStatusCode["USER_CANCEL"] = "USER_CANCEL";
    NativeStatusCode["NO_NETWORK"] = "NO_NETWORK";
    NativeStatusCode["TRANSIENT_ERROR"] = "TRANSIENT_ERROR";
    NativeStatusCode["PERSISTENT_ERROR"] = "PERSISTENT_ERROR";
    NativeStatusCode["DISABLED"] = "DISABLED";
    NativeStatusCode["ACCOUNT_UNAVAILABLE"] = "ACCOUNT_UNAVAILABLE";
})($5dffa83ecc9ed68e$export$6154327c09fa1b4d || ($5dffa83ecc9ed68e$export$6154327c09fa1b4d = {}));
var $5dffa83ecc9ed68e$export$a91608f60d986622 = {
    extensionError: {
        code: "ContentError"
    },
    userSwitch: {
        code: "user_switch",
        desc: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
    },
    tokensNotFoundInCache: {
        code: "tokens_not_found_in_internal_memory_cache",
        desc: "Tokens not cached in MSAL JS internal memory, please make the WAM request"
    }
};
var $5dffa83ecc9ed68e$export$4b8a4f6256e840ab = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(NativeAuthError, _super);
    function NativeAuthError(errorCode, description, ext) {
        var _this = _super.call(this, errorCode, description) || this;
        Object.setPrototypeOf(_this, NativeAuthError.prototype);
        _this.name = "NativeAuthError";
        _this.ext = ext;
        return _this;
    }
    /**
     * These errors should result in a fallback to the 'standard' browser based auth flow.
     */ NativeAuthError.prototype.isFatal = function() {
        if (this.ext && this.ext.status && (this.ext.status === $5dffa83ecc9ed68e$export$6154327c09fa1b4d.PERSISTENT_ERROR || this.ext.status === $5dffa83ecc9ed68e$export$6154327c09fa1b4d.DISABLED)) return true;
        switch(this.errorCode){
            case $5dffa83ecc9ed68e$export$a91608f60d986622.extensionError.code:
                return true;
            default:
                return false;
        }
    };
    /**
     * Create the appropriate error object based on the WAM status code.
     * @param code
     * @param description
     * @param ext
     * @returns
     */ NativeAuthError.createError = function(code, description, ext) {
        if (ext && ext.status) switch(ext.status){
            case $5dffa83ecc9ed68e$export$6154327c09fa1b4d.ACCOUNT_UNAVAILABLE:
                return (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba).createNativeAccountUnavailableError();
            case $5dffa83ecc9ed68e$export$6154327c09fa1b4d.USER_INTERACTION_REQUIRED:
                return new (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba)(code, description);
            case $5dffa83ecc9ed68e$export$6154327c09fa1b4d.USER_CANCEL:
                return (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUserCancelledError();
            case $5dffa83ecc9ed68e$export$6154327c09fa1b4d.NO_NETWORK:
                return (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
        }
        return new NativeAuthError(code, description, ext);
    };
    /**
     * Creates user switch error when the user chooses a different account in the native broker prompt
     * @returns
     */ NativeAuthError.createUserSwitchError = function() {
        return new NativeAuthError($5dffa83ecc9ed68e$export$a91608f60d986622.userSwitch.code, $5dffa83ecc9ed68e$export$a91608f60d986622.userSwitch.desc);
    };
    /**
     * Creates a tokens not found error when the internal cache look up fails
     * @returns NativeAuthError: tokensNotFoundInCache
     */ NativeAuthError.createTokensNotFoundInCacheError = function() {
        return new NativeAuthError($5dffa83ecc9ed68e$export$a91608f60d986622.tokensNotFoundInCache.code, $5dffa83ecc9ed68e$export$a91608f60d986622.tokensNotFoundInCache.desc);
    };
    return NativeAuthError;
}((0, $a207a6b3d34d3093$export$145273558d58e0ac));



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

/*! @azure/msal-common v13.3.1 2023-10-27 */ 



/*! @azure/msal-common v13.3.1 2023-10-27 */ 















"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * OAuth2.0 refresh token client
 */ var $0f2f6f908b4eb8f2$export$9cb096b89b92d8a8 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(RefreshTokenClient, _super);
    function RefreshTokenClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    RefreshTokenClient.prototype.acquireToken = function(request) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, reqTimestamp, response, httpVerToken, requestId, responseHandler;
            var _this = this;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                        this.logger.verbose("RefreshTokenClientAcquireToken called", request.correlationId);
                        reqTimestamp = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.executeTokenRequest(request, this.authority)
                        ];
                    case 1:
                        response = _h.sent();
                        httpVerToken = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).X_MS_HTTP_VERSION];
                        atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            refreshTokenSize: ((_e = response.body.refresh_token) === null || _e === void 0 ? void 0 : _e.length) || 0
                        });
                        if (httpVerToken) atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            httpVerToken: httpVerToken
                        });
                        requestId = (_f = response.headers) === null || _f === void 0 ? void 0 : _f[(0, $709b0e48f6b53a82$export$28d77f87efed1d88).X_MS_REQUEST_ID];
                        responseHandler = new (0, $7bceb18977467864$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(response.body);
                        (_g = this.performanceClient) === null || _g === void 0 || _g.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleServerTokenResponse, request.correlationId);
                        return [
                            2 /*return*/ ,
                            responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId).then(function(result) {
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                _this.logger.verbose("Error in fetching refresh token", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ RefreshTokenClient.prototype.acquireTokenByRefreshToken = function(request) {
        var _a, _b, _c, _d;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var isFOCI, noFamilyRTInCache, clientMismatchErrorWithFamilyRT;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_e) {
                // Cannot renew token if no request object is given.
                if (!request) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createEmptyTokenRequestError();
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                if (!request.account) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAccountInSilentRequestError();
                isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
                // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
                if (isFOCI) try {
                    (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                    return [
                        2 /*return*/ ,
                        this.acquireTokenWithCachedRefreshToken(request, true)
                    ];
                } catch (e) {
                    noFamilyRTInCache = e instanceof (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba) && e.errorCode === (0, $2d9ea0d849f19272$export$d44d3b7b7a580eb6).noTokensFoundError.code;
                    clientMismatchErrorWithFamilyRT = e instanceof (0, $18269c32984fce6f$export$ea52035eac03daf0) && e.errorCode === (0, $709b0e48f6b53a82$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $709b0e48f6b53a82$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
                    // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
                    if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) {
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                        return [
                            2 /*return*/ ,
                            this.acquireTokenWithCachedRefreshToken(request, false)
                        ];
                    // throw in all other cases
                    } else throw e;
                }
                // fall back to application refresh token acquisition
                (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireTokenWithCachedRefreshToken(request, false)
                ];
            });
        });
    };
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ RefreshTokenClient.prototype.acquireTokenWithCachedRefreshToken = function(request, foci) {
        var _a, _b, _c;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, refreshToken, refreshTokenRequest;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                this.logger.verbose("RefreshTokenClientAcquireTokenWithCachedRefreshToken called", request.correlationId);
                refreshToken = this.cacheManager.getRefreshToken(request.account, foci);
                if (!refreshToken) {
                    atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.discardMeasurement();
                    throw (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba).createNoTokensFoundError();
                }
                // attach cached RT size to the current measurement
                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                    success: true
                });
                refreshTokenRequest = (0, $a296cc98de023397$export$18ce0697a983be9b)((0, $a296cc98de023397$export$18ce0697a983be9b)({}, request), {
                    refreshToken: refreshToken.secret,
                    authenticationScheme: request.authenticationScheme || (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER,
                    ccsCredential: {
                        credential: request.account.homeAccountId,
                        type: (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                    }
                });
                (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireToken(refreshTokenRequest)
                ];
            });
        });
    };
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ RefreshTokenClient.prototype.executeTokenRequest = function(request, authority) {
        var _a, _b, _c;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, queryParametersString, endpoint, requestBody, headers, thumbprint;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [
                            4 /*yield*/ ,
                            this.createTokenRequestBody(request)
                        ];
                    case 1:
                        requestBody = _d.sent();
                        headers = this.createTokenRequestHeaders(request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [
                            2 /*return*/ ,
                            this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint).then(function(result) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Helper function to create the token request body
     * @param request
     */ RefreshTokenClient.prototype.createTokenRequestBody = function(request) {
        var _a, _b, _c;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, acquireTokenMeasurement, parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, clientInfo;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        correlationId = request.correlationId;
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).BaseClientCreateTokenRequestHeaders, correlationId);
                        parameterBuilder = new (0, $8f22594edfb44d21$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        parameterBuilder.addScopes(request.scopes);
                        parameterBuilder.addGrantType((0, $709b0e48f6b53a82$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
                        parameterBuilder.addClientInfo();
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        parameterBuilder.addCorrelationId(correlationId);
                        parameterBuilder.addRefreshToken(request.refreshToken);
                        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        if (!(request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).SSH) {
                            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
                            else {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createMissingSshJwkError();
                            }
                        }
                        _d.label = 3;
                    case 3:
                        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
                            case (0, $531468341ade26af$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                                try {
                                    clientInfo = (0, $6fc13ebc332ded7c$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                                    parameterBuilder.addCcsOid(clientInfo);
                                } catch (e) {
                                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                }
                                break;
                            case (0, $531468341ade26af$export$17b7b3ac1abef49f).UPN:
                                parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                                break;
                        }
                        acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    return RefreshTokenClient;
}((0, $b425941540279b13$export$4f22f74eddb7716a));







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $b02dbd615fe6a054$export$e344f5b12c464597 = /** @class */ function(_super) {
    (0, $a296cc98de023397$export$a8ba968b8961cb8a)(SilentFlowClient, _super);
    function SilentFlowClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */ SilentFlowClient.prototype.acquireToken = function(request) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_1, refreshTokenClient;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.acquireCachedToken(request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $859b00ae06117652$export$a839ff85a7957561) && e_1.errorCode === (0, $859b00ae06117652$export$51eee17394e135b).tokenRefreshRequired.code) {
                            refreshTokenClient = new (0, $0f2f6f908b4eb8f2$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                            return [
                                2 /*return*/ ,
                                refreshTokenClient.acquireTokenByRefreshToken(request)
                            ];
                        } else throw e_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ SilentFlowClient.prototype.acquireCachedToken = function(request) {
        var _a, _b, _c, _d, _e;
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var environment, cacheRecord;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        // Cannot renew token if no request object is given.
                        if (!request) throw (0, $969cc688182846d2$export$ac9d9d20c2327339).createEmptyTokenRequestError();
                        if (request.forceRefresh) {
                            // Must refresh due to present force_refresh flag.
                            (_a = this.serverTelemetryManager) === null || _a === void 0 || _a.setCacheOutcome((0, $709b0e48f6b53a82$export$aa4af185ea049f6b).FORCE_REFRESH);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because forceRefresh is true.");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                        } else if (!this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmptyObj(request.claims)) {
                            // Must refresh due to presence of claims in request preventing cache lookup
                            (_b = this.serverTelemetryManager) === null || _b === void 0 || _b.setCacheOutcome((0, $709b0e48f6b53a82$export$aa4af185ea049f6b).CLAIMS_REQUESTED_CACHE_SKIPPED);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because claims-based caching is disabled and claims were requested.");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                        }
                        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                        if (!request.account) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAccountInSilentRequestError();
                        environment = request.authority || this.authority.getPreferredCache();
                        cacheRecord = this.cacheManager.readCacheRecord(request.account, request, environment);
                        if (!cacheRecord.accessToken) {
                            // Must refresh due to non-existent access_token.
                            (_c = this.serverTelemetryManager) === null || _c === void 0 || _c.setCacheOutcome((0, $709b0e48f6b53a82$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - No access token found in cache for the given properties.");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                        } else if ((0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).wasClockTurnedBack(cacheRecord.accessToken.cachedAt) || (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).isTokenExpired(cacheRecord.accessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
                            // Must refresh due to expired access_token.
                            (_d = this.serverTelemetryManager) === null || _d === void 0 || _d.setCacheOutcome((0, $709b0e48f6b53a82$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token is expired or will expire within " + this.config.systemOptions.tokenRenewalOffsetSeconds + " seconds.");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                        } else if (cacheRecord.accessToken.refreshOn && (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).isTokenExpired(cacheRecord.accessToken.refreshOn, 0)) {
                            // Must refresh due to the refresh_in value.
                            (_e = this.serverTelemetryManager) === null || _e === void 0 || _e.setCacheOutcome((0, $709b0e48f6b53a82$export$aa4af185ea049f6b).REFRESH_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'.");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                        }
                        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
                        return [
                            4 /*yield*/ ,
                            this.generateResultFromCacheRecord(cacheRecord, request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _f.sent()
                        ];
                }
            });
        });
    };
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ SilentFlowClient.prototype.generateResultFromCacheRecord = function(cacheRecord, request) {
        return (0, $a296cc98de023397$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var idTokenObj, authTime;
            return (0, $a296cc98de023397$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (cacheRecord.idToken) idTokenObj = new (0, $557a50de248ab1f3$export$3a170961dab30083)(cacheRecord.idToken.secret, this.config.cryptoInterface);
                        // token max_age check
                        if (request.maxAge || request.maxAge === 0) {
                            authTime = idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.auth_time;
                            if (!authTime) throw (0, $859b00ae06117652$export$a839ff85a7957561).createAuthTimeNotFoundError();
                            (0, $557a50de248ab1f3$export$3a170961dab30083).checkMaxAge(authTime, request.maxAge);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, $7bceb18977467864$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenObj)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return SilentFlowClient;
}((0, $b425941540279b13$export$4f22f74eddb7716a));




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $f61c4d0df2164694$export$59d4f873ee62d01e = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(SilentCacheClient, _super);
    function SilentCacheClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ SilentCacheClient.prototype.acquireToken = function(silentRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, serverTelemetryManager, silentAuthClient, cachedToken, error_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
                        return [
                            4 /*yield*/ ,
                            this.createSilentFlowClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 1:
                        silentAuthClient = _a.sent();
                        this.logger.verbose("Silent auth client created");
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            silentAuthClient.acquireCachedToken(silentRequest)
                        ];
                    case 3:
                        cachedToken = _a.sent();
                        acquireTokenMeasurement.endMeasurement({
                            success: true,
                            fromCache: true
                        });
                        return [
                            2 /*return*/ ,
                            cachedToken
                        ];
                    case 4:
                        error_1 = _a.sent();
                        if (error_1 instanceof (0, $52ceb16ced3151d8$export$f8eb6760ca13876a) && error_1.errorCode === (0, $52ceb16ced3151d8$export$6deffaef56f0bd5a).signingKeyNotFoundInStorage.code) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: error_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && error_1.errorCode || undefined,
                            subErrorCode: error_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && error_1.subError || undefined,
                            success: false
                        });
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentCacheClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Creates an Silent Flow Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ SilentCacheClient.prototype.createSilentFlowClient = function(serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $b02dbd615fe6a054$export$e344f5b12c464597)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    SilentCacheClient.prototype.initializeSilentRequest = function(request, account) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeSilentRequest, this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeBaseRequest, this.correlationId);
                        _a = [
                            (0, $87ab789688594f61$export$18ce0697a983be9b)({}, request)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request, account)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $87ab789688594f61$export$18ce0697a983be9b).apply(void 0, [
                                (0, $87ab789688594f61$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                    _b.sent()
                                ])),
                                {
                                    account: account,
                                    forceRefresh: request.forceRefresh || false
                                }
                            ])
                        ];
                }
            });
        });
    };
    return SilentCacheClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $c05e62c63828ff41$export$38af86d4cb90fd61 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(NativeInteractionClient, _super);
    function NativeInteractionClient(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId) {
        var _this = _super.call(this, config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId) || this;
        _this.apiId = apiId;
        _this.accountId = accountId;
        _this.nativeMessageHandler = provider;
        _this.nativeStorageManager = nativeStorageImpl;
        _this.silentCacheClient = new (0, $f61c4d0df2164694$export$59d4f873ee62d01e)(config, _this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        return _this;
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ NativeInteractionClient.prototype.acquireToken = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeATMeasurement, reqTimestamp, nativeRequest, result, messageBody, response, validatedResponse;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireToken called.");
                        nativeATMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
                        reqTimestamp = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
                        return [
                            4 /*yield*/ ,
                            this.initializeNativeRequest(request)
                        ];
                    case 1:
                        nativeRequest = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.acquireTokensFromCache(this.accountId, nativeRequest)
                        ];
                    case 3:
                        result = _a.sent();
                        nativeATMeasurement.endMeasurement({
                            success: true,
                            isNativeBroker: false,
                            fromCache: true
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        _a.sent();
                        // continue with a native call for any and all errors
                        this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        messageBody = {
                            method: (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).GetToken,
                            request: nativeRequest
                        };
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 6:
                        response = _a.sent();
                        validatedResponse = this.validateNativeResponse(response);
                        return [
                            2 /*return*/ ,
                            this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then(function(result) {
                                nativeATMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: true,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(error) {
                                nativeATMeasurement.endMeasurement({
                                    success: false,
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    isNativeBroker: true
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ NativeInteractionClient.prototype.createSilentCacheRequest = function(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    };
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ NativeInteractionClient.prototype.acquireTokensFromCache = function(nativeAccountId, request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var account, silentRequest, result, e_2;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!nativeAccountId) {
                            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
                            throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAccountFoundError();
                        }
                        account = this.browserStorage.getAccountInfoFilteredBy({
                            nativeAccountId: nativeAccountId
                        });
                        if (!account) throw (0, $859b00ae06117652$export$a839ff85a7957561).createNoAccountFoundError();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        silentRequest = this.createSilentCacheRequest(request, account);
                        return [
                            4 /*yield*/ ,
                            this.silentCacheClient.acquireToken(silentRequest)
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        e_2 = _a.sent();
                        throw e_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param request
     */ NativeInteractionClient.prototype.acquireTokenRedirect = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeRequest, messageBody, response, e_3, navigationOptions, redirectUri;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
                        return [
                            4 /*yield*/ ,
                            this.initializeNativeRequest(request)
                        ];
                    case 1:
                        nativeRequest = _a.sent();
                        messageBody = {
                            method: (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).GetToken,
                            request: nativeRequest
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 3:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_3 = _a.sent();
                        // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
                        if (e_3 instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e_3.isFatal()) throw e_3;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.browserStorage.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
                        navigationOptions = {
                            apiId: (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenRedirect,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(redirectUri, navigationOptions)
                        ];
                    case 6:
                        _a.sent(); // Need to treat this as external to ensure handleRedirectPromise is run again
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     */ NativeInteractionClient.prototype.handleRedirectPromise = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cachedRequest, prompt, request, messageBody, reqTimestamp, response, result, e_4;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        cachedRequest = this.browserStorage.getCachedNativeRequest();
                        if (!cachedRequest) {
                            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        prompt = cachedRequest.prompt, request = (0, $87ab789688594f61$export$3c9a16f847548506)(cachedRequest, [
                            "prompt"
                        ]);
                        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).NATIVE_REQUEST));
                        messageBody = {
                            method: (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).GetToken,
                            request: request
                        };
                        reqTimestamp = (0, $c4ca7dc1578a1e7a$export$3117a0de16ab2854).nowSeconds();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 2:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        result = this.handleNativeResponse(response, request, reqTimestamp);
                        this.browserStorage.setInteractionInProgress(false);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        e_4 = _a.sent();
                        this.browserStorage.setInteractionInProgress(false);
                        throw e_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Logout from native platform via browser extension
     * @param request
     */ NativeInteractionClient.prototype.logout = function() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    };
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ NativeInteractionClient.prototype.handleNativeResponse = function(response, request, reqTimestamp) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, authorityPreferredCache, idTokenObj, homeAccountIdentifier, accountEntity, result;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
                        if (response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
                        throw (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab).createUserSwitchError();
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(request.authority)
                        ];
                    case 1:
                        authority = _a.sent();
                        authorityPreferredCache = authority.getPreferredCache();
                        idTokenObj = this.createIdTokenObj(response);
                        homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenObj);
                        accountEntity = this.createAccountEntity(response, homeAccountIdentifier, idTokenObj, authorityPreferredCache);
                        return [
                            4 /*yield*/ ,
                            this.generateAuthenticationResult(response, request, idTokenObj, accountEntity, authority.canonicalAuthority, reqTimestamp)
                        ];
                    case 2:
                        result = _a.sent();
                        // cache accounts and tokens in the appropriate storage
                        this.cacheAccount(accountEntity);
                        this.cacheNativeTokens(response, request, homeAccountIdentifier, accountEntity, idTokenObj, result.accessToken, result.tenantId, reqTimestamp);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * Create an idToken Object (not entity)
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.createIdTokenObj = function(response) {
        return new (0, $557a50de248ab1f3$export$3a170961dab30083)(response.id_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, this.browserCrypto);
    };
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ NativeInteractionClient.prototype.createHomeAccountIdentifier = function(response, idTokenObj) {
        // Save account in browser storage
        var homeAccountIdentifier = (0, $6ff18147f1afb887$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, (0, $974d1aabbdaa4f9c$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenObj);
        return homeAccountIdentifier;
    };
    /**
     * Creates account entity
     * @param response
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param authority
     * @returns
     */ NativeInteractionClient.prototype.createAccountEntity = function(response, homeAccountIdentifier, idTokenObj, authority) {
        return (0, $6ff18147f1afb887$export$680160523e6bfa6a).createAccount(response.client_info, homeAccountIdentifier, idTokenObj, undefined, undefined, undefined, authority, response.account.id);
    };
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ NativeInteractionClient.prototype.generateScopes = function(response, request) {
        return response.scope ? (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(request.scope);
    };
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ NativeInteractionClient.prototype.generatePopAccessToken = function(response, request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var popTokenGenerator, shrParameters;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(request.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        /**
                         * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
                         * is still received, SHR is calculated locally
                         */ // Check if native layer returned an SHR token
                        if (response.shr) {
                            this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                            return [
                                2 /*return*/ ,
                                response.shr
                            ];
                        }
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(this.browserCrypto);
                        shrParameters = {
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        /**
                         * KeyID must be present in the native request from when the PoP key was generated in order for
                         * PopTokenGenerator to query the full key for signing
                         */ if (!request.keyId) throw (0, $859b00ae06117652$export$a839ff85a7957561).createKeyIdMissingError();
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.access_token
                        ];
                }
            });
        });
    };
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ NativeInteractionClient.prototype.generateAuthenticationResult = function(response, request, idTokenObj, accountEntity, authority, reqTimestamp) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mats, responseScopes, accountProperties, uid, tid, responseAccessToken, tokenType, result;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mats = this.addTelemetryFromNativeResponse(response);
                        responseScopes = response.scope ? (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(request.scope);
                        accountProperties = response.account.properties || {};
                        uid = accountProperties["UID"] || idTokenObj.claims.oid || idTokenObj.claims.sub || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        tid = accountProperties["TenantId"] || idTokenObj.claims.tid || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        return [
                            4 /*yield*/ ,
                            this.generatePopAccessToken(response, request)
                        ];
                    case 1:
                        responseAccessToken = _a.sent();
                        tokenType = request.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP ? (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP : (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER;
                        result = {
                            authority: authority,
                            uniqueId: uid,
                            tenantId: tid,
                            scopes: responseScopes.asArray(),
                            account: accountEntity.getAccountInfo(),
                            idToken: response.id_token,
                            idTokenClaims: idTokenObj.claims,
                            accessToken: responseAccessToken,
                            fromCache: mats ? this.isResponseFromCache(mats) : false,
                            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
                            tokenType: tokenType,
                            correlationId: this.correlationId,
                            state: response.state,
                            fromNativeBroker: true
                        };
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ NativeInteractionClient.prototype.cacheAccount = function(accountEntity) {
        var _this = this;
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity).catch(function(e) {
            _this.logger.error("Error occurred while removing account context from browser storage. " + e);
        });
    };
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ NativeInteractionClient.prototype.cacheNativeTokens = function(response, request, homeAccountIdentifier, accountEntity, idTokenObj, responseAccessToken, tenantId, reqTimestamp) {
        var cachedIdToken = (0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, request.clientId, idTokenObj.claims.tid || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING);
        // cache accessToken in inmemory storage
        var expiresIn = request.tokenType === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP ? (0, $709b0e48f6b53a82$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        var tokenExpirationSeconds = reqTimestamp + expiresIn;
        var responseScopes = this.generateScopes(response, request);
        var cachedAccessToken = (0, $c2e674572252645d$export$6b7a8e14ec177765).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenObj ? idTokenObj.claims.tid || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING : tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, this.browserCrypto);
        var nativeCacheRecord = new (0, $5c9a0b8485eed0cc$export$5ee5669a32bdea66)(accountEntity, cachedIdToken, cachedAccessToken);
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord);
    };
    NativeInteractionClient.prototype.addTelemetryFromNativeResponse = function(response) {
        var mats = this.getMATSFromResponse(response);
        if (!mats) return null;
        this.performanceClient.addStaticFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    };
    /**
     * Validates native platform response before processing
     * @param response
     */ NativeInteractionClient.prototype.validateNativeResponse = function(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab).createUnexpectedError("Response missing expected properties.");
    };
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.getMATSFromResponse = function(response) {
        if (response.properties.MATS) try {
            return JSON.parse(response.properties.MATS);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    };
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.isResponseFromCache = function(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    };
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ NativeInteractionClient.prototype.initializeNativeRequest = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, canonicalAuthority, scopes, remainingProperties, scopeSet, getPrompt, validatedRequest, shrParameters, popTokenGenerator, reqCnfData;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
                        authority = request.authority || this.config.auth.authority;
                        if (!request.account) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.validateRequestAuthority(authority, request.account)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        canonicalAuthority = new (0, $adf27a3fcf515e87$export$3abcdca7229e54f2)(authority);
                        canonicalAuthority.validateAsUri();
                        scopes = request.scopes, remainingProperties = (0, $87ab789688594f61$export$3c9a16f847548506)(request, [
                            "scopes"
                        ]);
                        scopeSet = new (0, $57be63d7f846af92$export$b9b82b0f94ae1f99)(scopes || []);
                        scopeSet.appendScopes((0, $709b0e48f6b53a82$export$893b1b5b686d84ef));
                        getPrompt = function() {
                            // If request is silent, prompt is always none
                            switch(_this.apiId){
                                case (0, $0f344e7ceaf1df75$export$192d74ad69b40705).ssoSilent:
                                case (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                                    _this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                                    return (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE;
                            }
                            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
                            if (!request.prompt) {
                                _this.logger.trace("initializeNativeRequest: prompt was not provided");
                                return undefined;
                            }
                            // If request is interactive, check if prompt provided is allowed to go directly to native broker
                            switch(request.prompt){
                                case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE:
                                case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).CONSENT:
                                case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).LOGIN:
                                    _this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                                    return request.prompt;
                                default:
                                    _this.logger.trace("initializeNativeRequest: prompt = " + request.prompt + " is not compatible with native flow");
                                    throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativePromptParameterNotSupportedError();
                            }
                        };
                        validatedRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, remainingProperties), {
                            accountId: this.accountId,
                            clientId: this.config.auth.clientId,
                            authority: canonicalAuthority.urlString,
                            scope: scopeSet.printScopes(),
                            redirectUri: this.getRedirectUri(request.redirectUri),
                            prompt: getPrompt(),
                            correlationId: this.correlationId,
                            tokenType: request.authenticationScheme,
                            windowTitleSubstring: document.title,
                            extraParameters: (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request.extraQueryParameters), request.tokenQueryParameters), {
                                telemetry: (0, $0f344e7ceaf1df75$export$fec113838800867f).MATS_TELEMETRY
                            }),
                            extendedExpiryToken: false // Make this configurable?
                        });
                        if (!(request.authenticationScheme === (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            4
                        ];
                        shrParameters = {
                            resourceRequestUri: request.resourceRequestUri,
                            resourceRequestMethod: request.resourceRequestMethod,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        popTokenGenerator = new (0, $53c21a464cad5b47$export$3dd8467151c83e3e)(this.browserCrypto);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(shrParameters)
                        ];
                    case 3:
                        reqCnfData = _a.sent();
                        // to reduce the URL length, it is recommended to send the short form of the req_cnf 
                        validatedRequest.reqCnf = reqCnfData.reqCnfString;
                        validatedRequest.keyId = reqCnfData.kid;
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    return NativeInteractionClient;
}((0, $fa3ce8107f1cdd19$export$d858565f81c03f1f));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $b905a9107139650f$export$c98888b8059e2702 = /** @class */ function() {
    function NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, extensionId) {
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.responseId = 0;
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */ NativeMessageHandler.prototype.sendMessage = function(body) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var req;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("NativeMessageHandler - sendMessage called.");
                req = {
                    channel: (0, $0f344e7ceaf1df75$export$fec113838800867f).CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: body
                };
                this.logger.trace("NativeMessageHandler - Sending request to browser extension");
                this.logger.tracePii("NativeMessageHandler - Sending request to browser extension: " + JSON.stringify(req));
                this.messageChannel.port1.postMessage(req);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        _this.resolvers.set(req.responseId, {
                            resolve: resolve,
                            reject: reject
                        });
                    })
                ];
            });
        });
    };
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     */ NativeMessageHandler.createProvider = function(logger, handshakeTimeoutMs, performanceClient) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var preferredProvider, backupProvider;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.trace("NativeMessageHandler - createProvider called.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        preferredProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, (0, $0f344e7ceaf1df75$export$fec113838800867f).PREFERRED_EXTENSION_ID);
                        return [
                            4 /*yield*/ ,
                            preferredProvider.sendHandshakeRequest()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            preferredProvider
                        ];
                    case 3:
                        _a.sent();
                        backupProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient);
                        return [
                            4 /*yield*/ ,
                            backupProvider.sendHandshakeRequest()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            backupProvider
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send handshake request helper.
     */ NativeMessageHandler.prototype.sendHandshakeRequest = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var req;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
                // Register this event listener before sending handshake
                window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
                req = {
                    channel: (0, $0f344e7ceaf1df75$export$fec113838800867f).CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: {
                        method: (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).HandshakeRequest
                    }
                };
                this.handshakeEvent.addStaticFields({
                    extensionId: this.extensionId,
                    extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
                });
                this.messageChannel.port1.onmessage = function(event) {
                    _this.onChannelMessage(event);
                };
                window.postMessage(req, window.origin, [
                    this.messageChannel.port2
                ]);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        _this.handshakeResolvers.set(req.responseId, {
                            resolve: resolve,
                            reject: reject
                        });
                        _this.timeoutId = window.setTimeout(function() {
                            /*
                             * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                             * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                             */ window.removeEventListener("message", _this.windowListener, false);
                            _this.messageChannel.port1.close();
                            _this.messageChannel.port2.close();
                            _this.handshakeEvent.endMeasurement({
                                extensionHandshakeTimedOut: true,
                                success: false
                            });
                            reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeHandshakeTimeoutError());
                            _this.handshakeResolvers.delete(req.responseId);
                        }, _this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
                    })
                ];
            });
        });
    };
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ NativeMessageHandler.prototype.onWindowMessage = function(event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        var request = event.data;
        if (!request.channel || request.channel !== (0, $0f344e7ceaf1df75$export$fec113838800867f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).HandshakeRequest) {
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? "Extension with id: " + request.extensionId + " not installed" : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            var handshakeResolver = this.handshakeResolvers.get(request.responseId);
            if (handshakeResolver) {
                this.handshakeEvent.endMeasurement({
                    success: false,
                    extensionInstalled: false
                });
                handshakeResolver.reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeExtensionNotInstalledError());
            }
        }
    };
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ NativeMessageHandler.prototype.onChannelMessage = function(event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        var request = event.data;
        var resolver = this.resolvers.get(request.responseId);
        var handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            var method = request.body.method;
            if (method === (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                var response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii("NativeMessageHandler - Received response from browser extension: " + JSON.stringify(response));
                if (response.status !== "Success") resolver.reject((0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab).createError(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab).createError(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $a207a6b3d34d3093$export$145273558d58e0ac).createUnexpectedError("Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $0f344e7ceaf1df75$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) return;
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose("NativeMessageHandler - Received HandshakeResponse from extension: " + this.extensionId);
                this.handshakeEvent.endMeasurement({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii("Error parsing response from WAM Extension: " + err.toString());
            this.logger.errorPii("Unable to parse " + event);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    };
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ NativeMessageHandler.prototype.getExtensionId = function() {
        return this.extensionId;
    };
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ NativeMessageHandler.prototype.getExtensionVersion = function() {
        return this.extensionVersion;
    };
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */ NativeMessageHandler.isNativeAvailable = function(config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) switch(authenticationScheme){
            case (0, $709b0e48f6b53a82$export$901491a717da2ba5).BEARER:
            case (0, $709b0e48f6b53a82$export$901491a717da2ba5).POP:
                logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                return true;
            default:
                logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                return false;
        }
        return true;
    };
    return NativeMessageHandler;
}();



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ var $5c31e93d4c132ad9$export$a30cd982b4e89bdb = /** @class */ function() {
    function InteractionHandler(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) {
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ InteractionHandler.prototype.handleCodeResponseFromHash = function(locationHash, state, authority, networkModule) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, authCodeResponse;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleCodeResponseFromHash, this.authCodeRequest.correlationId);
                this.logger.verbose("InteractionHandler.handleCodeResponse called");
                // Check that location hash isn't empty.
                if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(locationHash)) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyHashError(locationHash);
                stateKey = this.browserStorage.generateStateKey(state);
                requestState = this.browserStorage.getTemporaryCache(stateKey);
                if (!requestState) throw (0, $859b00ae06117652$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                try {
                    authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                } catch (e) {
                    if (e instanceof (0, $18269c32984fce6f$export$ea52035eac03daf0) && e.subError === (0, $52ceb16ced3151d8$export$6deffaef56f0bd5a).userCancelledError.code) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                    throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUserCancelledError();
                    else throw e;
                }
                this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                return [
                    2 /*return*/ ,
                    this.handleCodeResponseFromServer(authCodeResponse, state, authority, networkModule)
                ];
            });
        });
    };
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ InteractionHandler.prototype.handleCodeResponseFromServer = function(authCodeResponse, state, authority, networkModule, validateNonce) {
        if (validateNonce === void 0) validateNonce = true;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) throw (0, $859b00ae06117652$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
                        if (validateNonce) authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
                        }
                        // Acquire token with retrieved code.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AuthClientAcquireToken, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)
                        ];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    };
    /**
     * Updates authority based on cloudInstanceHostname
     * @param cloudInstanceHostname
     * @param authority
     * @param networkModule
     */ InteractionHandler.prototype.updateTokenEndpointAuthority = function(cloudInstanceHostname, authority, networkModule) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cloudInstanceAuthorityUri, cloudInstanceAuthority;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        cloudInstanceAuthorityUri = "https://" + cloudInstanceHostname + "/" + authority.tenant + "/";
                        return [
                            4 /*yield*/ ,
                            (0, $7caa661ac4a070a1$export$4b476259e3402a97).createDiscoveredInstance(cloudInstanceAuthorityUri, networkModule, this.browserStorage, authority.options, this.logger, this.performanceClient, this.authCodeRequest.correlationId)
                        ];
                    case 1:
                        cloudInstanceAuthority = _a.sent();
                        this.authModule.updateAuthority(cloudInstanceAuthority);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Looks up ccs creds in the cache
     */ InteractionHandler.prototype.checkCcsCredentials = function() {
        // Look up ccs credential in temp cache
        var cachedCcsCred = this.browserStorage.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CCS_CREDENTIAL, true);
        if (cachedCcsCred) try {
            return JSON.parse(cachedCcsCred);
        } catch (e) {
            this.authModule.logger.error("Cache credential could not be parsed");
            this.authModule.logger.errorPii("Cache credential could not be parsed: " + cachedCcsCred);
        }
        return null;
    };
    return InteractionHandler;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $ff8c21979a984477$export$43b0fce132d066f4 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(PopupClient, _super);
    function PopupClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        // Properly sets this reference for the unload event.
        _this.unloadWindow = _this.unloadWindow.bind(_this);
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */ PopupClient.prototype.acquireToken = function(request) {
        try {
            var popupName = this.generatePopupName(request.scopes || (0, $709b0e48f6b53a82$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            var popupWindowAttributes = request.popupWindowAttributes || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes, popup);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ PopupClient.prototype.logout = function(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            var validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            var popupName = this.generateLogoutPopupName(validLogoutRequest);
            var authority = logoutRequest && logoutRequest.authority;
            var mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            var popupWindowAttributes = (logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.popupWindowAttributes) || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, undefined, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, popup, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    };
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ PopupClient.prototype.acquireTokenPopupAsync = function(request, popupName, popupWindowAttributes, popup) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, validRequest, authCodeRequest, authClient, isNativeBroker, fetchNativeAccountIdMeasurement, navigateUrl, interactionHandler, popupParameters, popupWindow, hash, serverParams, state_1, nativeInteractionClient, userRequestState, result, e_1;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("acquireTokenPopupAsync called");
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenPopup);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup)
                        ];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, validRequest.account || null);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(validRequest)
                        ];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)
                        ];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        isNativeBroker = (0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
                        fetchNativeAccountIdMeasurement = void 0;
                        if (isNativeBroker) fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).FetchAccountIdWithNativeBroker, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, validRequest), {
                                nativeBroker: isNativeBroker
                            }))
                        ];
                    case 5:
                        navigateUrl = _a.sent();
                        interactionHandler = new (0, $5c31e93d4c132ad9$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
                        popupParameters = {
                            popup: popup,
                            popupName: popupName,
                            popupWindowAttributes: popupWindowAttributes
                        };
                        popupWindow = this.initiateAuthRequest(navigateUrl, popupParameters);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).POPUP_OPENED, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, {
                            popupWindow: popupWindow
                        }, null);
                        return [
                            4 /*yield*/ ,
                            this.monitorPopupForHash(popupWindow)
                        ];
                    case 6:
                        hash = _a.sent();
                        serverParams = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        state_1 = this.validateAndExtractStateFromHash(serverParams, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, validRequest.correlationId);
                        // Remove throttle if it exists
                        (0, $44321a50b91f10d9$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            // end measurement for server call with native brokering enabled
                            if (fetchNativeAccountIdMeasurement) fetchNativeAccountIdMeasurement.endMeasurement({
                                success: true,
                                isNativeBroker: true
                            });
                            if (!this.nativeMessageHandler) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                            userRequestState = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.browserCrypto, state_1).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, validRequest), {
                                    state: userRequestState,
                                    prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state_1);
                                })
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            interactionHandler.handleCodeResponseFromHash(hash, state_1, authClient.authority, this.networkClient)
                        ];
                    case 7:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 8:
                        e_1 = _a.sent();
                        if (popup) // Close the synchronous popup if an error is thrown before the window unload event is registered
                        popup.close();
                        if (e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ PopupClient.prototype.logoutPopupAsync = function(validRequest, popupName, popupWindowAttributes, requestAuthority, popup, mainWindowRedirectUri) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, authClient, logoutUri, popupWindow, navigationOptions, absoluteUrl, e_2;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("logoutPopupAsync called");
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, validRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).logoutPopup);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        // Clear cache on logout
                        return [
                            4 /*yield*/ ,
                            this.clearCacheOnLogout(validRequest.account)
                        ];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, validRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, requestAuthority)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validRequest);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, validRequest);
                        popupWindow = this.openPopup(logoutUri, {
                            popupName: popupName,
                            popupWindowAttributes: popupWindowAttributes,
                            popup: popup
                        });
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).POPUP_OPENED, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, {
                            popupWindow: popupWindow
                        }, null);
                        return [
                            4 /*yield*/ ,
                            this.waitForLogoutPopup(popupWindow)
                        ];
                    case 4:
                        _a.sent();
                        if (mainWindowRedirectUri) {
                            navigationOptions = {
                                apiId: (0, $0f344e7ceaf1df75$export$192d74ad69b40705).logoutPopup,
                                timeout: this.config.system.redirectNavigationTimeout,
                                noHistory: false
                            };
                            absoluteUrl = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
                            this.logger.verbose("Redirecting main window to url specified in the request");
                            this.logger.verbosePii("Redirecting main window to: " + absoluteUrl);
                            this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                        } else this.logger.verbose("No main window navigation requested");
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_2 = _a.sent();
                        if (popup) // Close the synchronous popup if an error is thrown before the window unload event is registered
                        popup.close();
                        if (e_2 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_2.setCorrelationId(this.correlationId);
                        this.browserStorage.setInteractionInProgress(false);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, null, e_2);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup);
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        throw e_2;
                    case 6:
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ PopupClient.prototype.initiateAuthRequest = function(requestUrl, params) {
        // Check that request url is not empty.
        if (!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(requestUrl)) {
            this.logger.infoPii("Navigate to: " + requestUrl);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyNavigationUriError();
        }
    };
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ PopupClient.prototype.monitorPopupForHash = function(popupWindow) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            /*
             * Polling for popups needs to be tick-based,
             * since a non-trivial amount of time can be spent on interaction (which should not count against the timeout).
             */ var maxTicks = _this.config.system.windowHashTimeout / _this.config.system.pollIntervalMilliseconds;
            var ticks = 0;
            _this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            var intervalId = setInterval(function() {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUserCancelledError());
                    return;
                }
                var href = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                var hash = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                    hash = popupWindow.location.hash;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(href) || href === "about:blank") return;
                _this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                /*
                 * Only run clock when we are on same domain for popups
                 * as popup operations can take a long time.
                 */ ticks++;
                if (hash) {
                    _this.logger.verbose("PopupHandler.monitorPopupForHash - found hash in url");
                    clearInterval(intervalId);
                    _this.cleanPopup(popupWindow);
                    if ((0, $adf27a3fcf515e87$export$3abcdca7229e54f2).hashContainsKnownProperties(hash)) {
                        _this.logger.verbose("PopupHandler.monitorPopupForHash - hash contains known properties, returning.");
                        resolve(hash);
                    } else {
                        _this.logger.error("PopupHandler.monitorPopupForHash - found hash in url but it does not contain known properties. Check that your router is not changing the hash prematurely.");
                        _this.logger.errorPii("PopupHandler.monitorPopupForHash - hash found: " + hash);
                        reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createHashDoesNotContainKnownPropertiesError());
                    }
                } else if (ticks > maxTicks) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - unable to find hash in url, timing out");
                    clearInterval(intervalId);
                    reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createMonitorPopupTimeoutError());
                }
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * Waits for user interaction in logout popup window
     * @param popupWindow
     * @returns
     */ PopupClient.prototype.waitForLogoutPopup = function(popupWindow) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.logger.verbose("PopupHandler.waitForLogoutPopup - polling started");
            var intervalId = setInterval(function() {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.waitForLogoutPopup - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    resolve();
                }
                var href = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(href) || href === "about:blank") return;
                _this.logger.verbose("PopupHandler.waitForLogoutPopup - popup window is on same origin as caller, closing.");
                clearInterval(intervalId);
                _this.cleanPopup(popupWindow);
                resolve();
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ PopupClient.prototype.openPopup = function(urlNavigate, popupParams) {
        try {
            var popupWindow = void 0;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii("Navigating popup window to: " + urlNavigate);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii("Opening popup window to: " + urlNavigate);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams.popupName, popupParams.popupWindowAttributes);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyWindowCreatedError();
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            window.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createPopupWindowError(e.toString());
        }
    };
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ PopupClient.prototype.openSizedPopup = function(urlNavigate, popupName, popupWindowAttributes) {
        var _a, _b, _c, _d;
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
        var winTop = window.screenTop ? window.screenTop : window.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var width = (_a = popupWindowAttributes.popupSize) === null || _a === void 0 ? void 0 : _a.width;
        var height = (_b = popupWindowAttributes.popupSize) === null || _b === void 0 ? void 0 : _b.height;
        var top = (_c = popupWindowAttributes.popupPosition) === null || _c === void 0 ? void 0 : _c.top;
        var left = (_d = popupWindowAttributes.popupPosition) === null || _d === void 0 ? void 0 : _d.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return window.open(urlNavigate, popupName, "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", scrollbars=yes");
    };
    /**
     * Event callback to unload main window.
     */ PopupClient.prototype.unloadWindow = function(e) {
        this.browserStorage.cleanRequestByInteractionType((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup);
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    };
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ PopupClient.prototype.cleanPopup = function(popupWindow) {
        if (popupWindow) // Close window.
        popupWindow.close();
        // Remove window unload function
        window.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    };
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ PopupClient.prototype.generatePopupName = function(scopes, authority) {
        return (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + scopes.join("-") + "." + authority + "." + this.correlationId;
    };
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ PopupClient.prototype.generateLogoutPopupName = function(request) {
        var homeAccountId = request.account && request.account.homeAccountId;
        return (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + homeAccountId + "." + this.correlationId;
    };
    return PopupClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $2ffc1dce4039d136$export$9af91951fcedc08c = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(RedirectHandler, _super);
    function RedirectHandler(authCodeModule, storageImpl, authCodeRequest, logger, browserCrypto, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.browserCrypto = browserCrypto;
        return _this;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */ RedirectHandler.prototype.initiateAuthRequest = function(requestUrl, params) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var navigationOptions, navigate;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
                        if (!!(0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(requestUrl)) return [
                            3 /*break*/ ,
                            7
                        ];
                        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
                        if (params.redirectStartPage) {
                            this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                            this.browserStorage.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).ORIGIN_URI, params.redirectStartPage, true);
                        }
                        // Set interaction status in the library.
                        this.browserStorage.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CORRELATION_ID, this.authCodeRequest.correlationId, true);
                        this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto);
                        this.logger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to: " + requestUrl);
                        navigationOptions = {
                            apiId: (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenRedirect,
                            timeout: params.redirectTimeout,
                            noHistory: false
                        };
                        if (!(typeof params.onRedirectNavigate === "function")) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                        navigate = params.onRedirectNavigate(requestUrl);
                        if (!(navigate !== false)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                        return [
                            4 /*yield*/ ,
                            params.navigationClient.navigateExternal(requestUrl, navigationOptions)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        // Navigate window to request URL
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                        return [
                            4 /*yield*/ ,
                            params.navigationClient.navigateExternal(requestUrl, navigationOptions)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        // Throw error if request URL is empty.
                        this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
                        throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyNavigationUriError();
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Handle authorization code response in the window.
     * @param hash
     */ RedirectHandler.prototype.handleCodeResponseFromHash = function(locationHash, state, authority, networkModule) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("RedirectHandler.handleCodeResponse called");
                        // Check that location hash isn't empty.
                        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(locationHash)) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyHashError(locationHash);
                        // Interaction is completed - remove interaction status.
                        this.browserStorage.setInteractionInProgress(false);
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) throw (0, $859b00ae06117652$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                        try {
                            authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                        } catch (e) {
                            if (e instanceof (0, $18269c32984fce6f$export$ea52035eac03daf0) && e.subError === (0, $52ceb16ced3151d8$export$6deffaef56f0bd5a).userCancelledError.code) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUserCancelledError();
                            else throw e;
                        }
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
                        }
                        return [
                            4 /*yield*/ ,
                            this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)
                        ];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    };
    return RedirectHandler;
}((0, $5c31e93d4c132ad9$export$a30cd982b4e89bdb));







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $b4f84405c017fdc8$export$a368977effbc1ed6 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(RedirectClient, _super);
    function RedirectClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ RedirectClient.prototype.acquireToken = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var validRequest, serverTelemetryManager, handleBackButton, authCodeRequest, authClient, interactionHandler, navigateUrl, redirectStartPage, e_1;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect)
                        ];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, validRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenRedirect);
                        handleBackButton = function(event) {
                            // Clear temporary cache if the back button is clicked during the redirect flow.
                            if (event.persisted) {
                                _this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                                _this.browserStorage.cleanRequestByState(validRequest.state);
                                _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            }
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(validRequest)
                        ];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)
                        ];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        interactionHandler = new (0, $2ffc1dce4039d136$export$9af91951fcedc08c)(authClient, this.browserStorage, authCodeRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, validRequest), {
                                nativeBroker: (0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme)
                            }))
                        ];
                    case 5:
                        navigateUrl = _a.sent();
                        redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
                        this.logger.verbosePii("Redirect start page: " + redirectStartPage);
                        // Clear temporary cache if the back button is clicked during the redirect flow.
                        window.addEventListener("pageshow", handleBackButton);
                        return [
                            4 /*yield*/ ,
                            interactionHandler.initiateAuthRequest(navigateUrl, {
                                navigationClient: this.navigationClient,
                                redirectTimeout: this.config.system.redirectNavigationTimeout,
                                redirectStartPage: redirectStartPage,
                                onRedirectNavigate: request.onRedirectNavigate
                            })
                        ];
                    case 6:
                        // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 7:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        window.removeEventListener("pageshow", handleBackButton);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash
     */ RedirectClient.prototype.handleRedirectPromise = function(hash) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, responseHash, state, serverParams, loginRequestUrl, loginRequestUrlNormalized, currentUrlNormalized, handleHashResult, navigationOptions, processHashOnRedirect, homepage, e_2;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).handleRedirectPromise);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        responseHash = this.getRedirectResponseHash(hash || window.location.hash);
                        if (!responseHash) {
                            // Not a recognized server response hash or hash not associated with a redirect request
                            this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache.");
                            this.browserStorage.cleanRequestByInteractionType((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        state = void 0;
                        try {
                            serverParams = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(responseHash);
                            state = this.validateAndExtractStateFromHash(serverParams, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            this.logger.verbose("State extracted from hash");
                        } catch (e) {
                            this.logger.info("handleRedirectPromise was unable to extract state due to: " + e);
                            this.browserStorage.cleanRequestByInteractionType((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        loginRequestUrl = this.browserStorage.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                        loginRequestUrlNormalized = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
                        currentUrlNormalized = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
                        if (!(loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // We are on the page we need to navigate to - handle hash
                        this.logger.verbose("Current page is loginRequestUrl, handling hash");
                        return [
                            4 /*yield*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                    case 2:
                        handleHashResult = _a.sent();
                        if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                        (0, $d8bc297369c9228b$export$311899ae85124b2d).replaceHash(loginRequestUrl);
                        return [
                            2 /*return*/ ,
                            handleHashResult
                        ];
                    case 3:
                        if (!!this.config.auth.navigateToLoginRequestUrl) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash");
                        return [
                            2 /*return*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                    case 4:
                        if (!(!(0, $d8bc297369c9228b$export$311899ae85124b2d).isInIframe() || this.config.system.allowRedirectInIframe)) return [
                            3 /*break*/ ,
                            9
                        ];
                        /*
                         * Returned from authority using redirect - need to perform navigation before processing response
                         * Cache the hash to be retrieved after the next redirect
                         */ this.browserStorage.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).URL_HASH, responseHash, true);
                        navigationOptions = {
                            apiId: (0, $0f344e7ceaf1df75$export$192d74ad69b40705).handleRedirectPromise,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: true
                        };
                        processHashOnRedirect = true;
                        if (!(!loginRequestUrl || loginRequestUrl === "null")) return [
                            3 /*break*/ ,
                            6
                        ];
                        homepage = (0, $d8bc297369c9228b$export$311899ae85124b2d).getHomepage();
                        // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                        this.browserStorage.setTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                        this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateInternal(homepage, navigationOptions)
                        ];
                    case 5:
                        processHashOnRedirect = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        // Navigate to page that initiated the redirect request
                        this.logger.verbose("Navigating to loginRequestUrl: " + loginRequestUrl);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions)
                        ];
                    case 7:
                        processHashOnRedirect = _a.sent();
                        _a.label = 8;
                    case 8:
                        // If navigateInternal implementation returns false, handle the hash now
                        if (!processHashOnRedirect) return [
                            2 /*return*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                        _a.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 10:
                        e_2 = _a.sent();
                        if (e_2 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_2.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        this.browserStorage.cleanRequestByInteractionType((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                        throw e_2;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ RedirectClient.prototype.getRedirectResponseHash = function(hash) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        var isResponseHash = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).hashContainsKnownProperties(hash);
        if (isResponseHash) {
            (0, $d8bc297369c9228b$export$311899ae85124b2d).clearHash(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return hash;
        }
        var cachedHash = this.browserStorage.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).URL_HASH));
        this.logger.verbose("Hash does not contain known properties, returning cached hash");
        return cachedHash;
    };
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ RedirectClient.prototype.handleHash = function(hash, state, serverTelemetryManager) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cachedRequest, serverParams, nativeInteractionClient, userRequestState, currentAuthority, authClient, interactionHandler;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        cachedRequest = this.browserStorage.getCachedRequest(state, this.browserCrypto);
                        this.logger.verbose("handleHash called, retrieved cached request");
                        serverParams = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
                            userRequestState = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.browserCrypto, state).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, cachedRequest), {
                                    state: userRequestState,
                                    prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state);
                                })
                            ];
                        }
                        currentAuthority = this.browserStorage.getCachedAuthority(state);
                        if (!currentAuthority) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoCachedAuthorityError();
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, cachedRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, currentAuthority)
                        ];
                    case 1:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        (0, $44321a50b91f10d9$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
                        interactionHandler = new (0, $2ffc1dce4039d136$export$9af91951fcedc08c)(authClient, this.browserStorage, cachedRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [
                            4 /*yield*/ ,
                            interactionHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ RedirectClient.prototype.logout = function(logoutRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var validLogoutRequest, serverTelemetryManager, navigationOptions, authClient, logoutUri, navigate, e_3;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("logoutRedirect called");
                        validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).logout);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, logoutRequest);
                        // Clear cache on logout
                        return [
                            4 /*yield*/ ,
                            this.clearCacheOnLogout(validLogoutRequest.account)
                        ];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        navigationOptions = {
                            apiId: (0, $0f344e7ceaf1df75$export$192d74ad69b40705).logout,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, validLogoutRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, logoutRequest && logoutRequest.authority)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validLogoutRequest);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                        if (!(logoutRequest && typeof logoutRequest.onRedirectNavigate === "function")) return [
                            3 /*break*/ ,
                            7
                        ];
                        navigate = logoutRequest.onRedirectNavigate(logoutUri);
                        if (!(navigate !== false)) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(logoutUri, navigationOptions)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        // Ensure interaction is not in progress
                        this.browserStorage.setInteractionInProgress(false);
                        this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(logoutUri, navigationOptions)
                        ];
                    case 8:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        e_3 = _a.sent();
                        if (e_3 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_3.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_3);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, null, e_3);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                        throw e_3;
                    case 11:
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGOUT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ RedirectClient.prototype.getRedirectStartPage = function(requestStartPage) {
        var redirectStartPage = requestStartPage || window.location.href;
        return (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $d8bc297369c9228b$export$311899ae85124b2d).getCurrentUri());
    };
    return RedirectClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 




/*! @azure/msal-browser v2.38.3 2023-10-27 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $53568c77e813b7f0$export$578d2d1abe796151 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(SilentHandler, _super);
    function SilentHandler(authCodeModule, storageImpl, authCodeRequest, logger, systemOptions, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.navigateFrameWait = systemOptions.navigateFrameWait;
        _this.pollIntervalMilliseconds = systemOptions.pollIntervalMilliseconds;
        return _this;
    }
    /**
     * Creates a hidden iframe to given URL using user-requested scopes as an id.
     * @param urlNavigate
     * @param userRequestScopes
     */ SilentHandler.prototype.initiateAuthRequest = function(requestUrl) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.authCodeRequest.correlationId);
                        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(requestUrl)) {
                            // Throw error if request URL is empty.
                            this.logger.info("Navigate url is empty");
                            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createEmptyNavigationUriError();
                        }
                        if (!this.navigateFrameWait) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.loadFrame(requestUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            this.loadFrameSync(requestUrl)
                        ];
                }
            });
        });
    };
    /**
     * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
     * @param iframe
     * @param timeout
     */ SilentHandler.prototype.monitorIframeForHash = function(iframe, timeout) {
        var _this = this;
        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.authCodeRequest.correlationId);
        return new Promise(function(resolve, reject) {
            if (timeout < (0, $6d495cf6d7a6f942$export$f3ffe700be354b19)) _this.logger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + timeout + "ms) than the default (" + (0, $6d495cf6d7a6f942$export$f3ffe700be354b19) + "ms). This may result in timeouts.");
            /*
             * Polling for iframes can be purely timing based,
             * since we don't need to account for interaction.
             */ var nowMark = window.performance.now();
            var timeoutMark = nowMark + timeout;
            var intervalId = setInterval(function() {
                if (window.performance.now() > timeoutMark) {
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createMonitorIframeTimeoutError());
                    return;
                }
                var href = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                var contentWindow = iframe.contentWindow;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = contentWindow ? contentWindow.location.href : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                } catch (e) {}
                if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(href)) return;
                var contentHash = contentWindow ? contentWindow.location.hash : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                if ((0, $adf27a3fcf515e87$export$3abcdca7229e54f2).hashContainsKnownProperties(contentHash)) {
                    // Success case
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    resolve(contentHash);
                    return;
                }
            }, _this.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     * Loads iframe with authorization endpoint URL
     * @ignore
     */ SilentHandler.prototype.loadFrame = function(urlNavigate) {
        var _this = this;
        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
        /*
         * This trick overcomes iframe navigation in IE
         * IE does not load the page consistently in iframe
         */ return new Promise(function(resolve, reject) {
            var frameHandle = _this.createHiddenIframe();
            setTimeout(function() {
                if (!frameHandle) {
                    reject("Unable to load iframe");
                    return;
                }
                frameHandle.src = urlNavigate;
                resolve(frameHandle);
            }, _this.navigateFrameWait);
        });
    };
    /**
     * @hidden
     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
     * @param urlNavigate
     * @param frameName
     * @param logger
     */ SilentHandler.prototype.loadFrameSync = function(urlNavigate) {
        var frameHandle = this.createHiddenIframe();
        frameHandle.src = urlNavigate;
        return frameHandle;
    };
    /**
     * @hidden
     * Creates a new hidden iframe or gets an existing one for silent token renewal.
     * @ignore
     */ SilentHandler.prototype.createHiddenIframe = function() {
        var authFrame = document.createElement("iframe");
        authFrame.style.visibility = "hidden";
        authFrame.style.position = "absolute";
        authFrame.style.width = authFrame.style.height = "0";
        authFrame.style.border = "0";
        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
        document.getElementsByTagName("body")[0].appendChild(authFrame);
        return authFrame;
    };
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */ SilentHandler.prototype.removeHiddenIframe = function(iframe) {
        if (document.body === iframe.parentNode) document.body.removeChild(iframe);
    };
    return SilentHandler;
}((0, $5c31e93d4c132ad9$export$a30cd982b4e89bdb));




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $d32ddae51fe097a9$export$e81c7938bccef977 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(SilentIframeClient, _super);
    function SilentIframeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ SilentIframeClient.prototype.acquireToken = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, silentRequest, serverTelemetryManager, authClient, e_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                        this.logger.verbose("acquireTokenByIframe called");
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                        // Check that we have some SSO data
                        if ((0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(request.loginHint) && (0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(request.sid) && (!request.account || (0, $33fadf35800e4b73$export$ecc754f99843e759).isEmpty(request.account.username))) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
                        // Check that prompt is set to none or no_session, throw error if it is set to anything else.
                        if (request.prompt && request.prompt !== (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE && request.prompt !== (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NO_SESSION) {
                            acquireTokenMeasurement.endMeasurement({
                                success: false
                            });
                            throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSilentPromptValueError(request.prompt);
                        }
                        // Create silent request
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                                prompt: request.prompt || (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE
                            }), (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent)
                        ];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.silentTokenHelper(authClient, silentRequest).then(function(result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: false,
                                    requestId: result.requestId
                                });
                                return result;
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 5:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && e_1.errorCode || undefined,
                            subErrorCode: e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && e_1.subError || undefined,
                            success: false
                        });
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentIframeClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ SilentIframeClient.prototype.silentTokenHelper = function(authClient, silentRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authCodeRequest, navigateUrl, silentHandler, msalFrame, hash, serverParams, state, nativeInteractionClient, userRequestState;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, silentRequest.correlationId);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(silentRequest)
                        ];
                    case 1:
                        authCodeRequest = _a.sent();
                        // Create authorize request url
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).GetAuthCodeUrl, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, silentRequest), {
                                nativeBroker: (0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme)
                            }))
                        ];
                    case 2:
                        navigateUrl = _a.sent();
                        silentHandler = new (0, $53568c77e813b7f0$export$578d2d1abe796151)(authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Get the frame handle for the silent request
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentHandler.initiateAuthRequest(navigateUrl)
                        ];
                    case 3:
                        msalFrame = _a.sent();
                        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentHandler.monitorIframeForHash(msalFrame, this.config.system.iframeHashTimeout)
                        ];
                    case 4:
                        hash = _a.sent();
                        serverParams = (0, $adf27a3fcf515e87$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        state = this.validateAndExtractStateFromHash(serverParams, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, authCodeRequest.correlationId);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, this.correlationId);
                            userRequestState = (0, $d3c398c9af34ca18$export$871e33217042c65e).parseRequestState(this.browserCrypto, state).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, silentRequest), {
                                    state: userRequestState,
                                    prompt: silentRequest.prompt || (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state);
                                })
                            ];
                        }
                        // Handle response from hash string
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).HandleCodeResponseFromHash, silentRequest.correlationId);
                        return [
                            2 /*return*/ ,
                            silentHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)
                        ];
                }
            });
        });
    };
    return SilentIframeClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $1b7fd6cba560cfbc$export$b4a36596822a5d2 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(SilentRefreshClient, _super);
    function SilentRefreshClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ SilentRefreshClient.prototype.acquireToken = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRequest, _a, acquireTokenMeasurement, serverTelemetryManager, refreshTokenClient;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
                        _a = [
                            (0, $87ab789688594f61$export$18ce0697a983be9b)({}, request)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request, request.account)
                        ];
                    case 1:
                        silentRequest = (0, $87ab789688594f61$export$18ce0697a983be9b).apply(void 0, _a.concat([
                            _b.sent()
                        ]));
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
                        return [
                            4 /*yield*/ ,
                            this.createRefreshTokenClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 2:
                        refreshTokenClient = _b.sent();
                        this.logger.verbose("Refresh token client created");
                        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                        return [
                            2 /*return*/ ,
                            refreshTokenClient.acquireTokenByRefreshToken(silentRequest).then(function(result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: result.fromCache,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(e) {
                                if (e instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e.setCorrelationId(_this.correlationId);
                                serverTelemetryManager.cacheFailedRequest(e);
                                acquireTokenMeasurement.endMeasurement({
                                    errorCode: e.errorCode,
                                    subErrorCode: e.subError,
                                    success: false
                                });
                                throw e;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentRefreshClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ SilentRefreshClient.prototype.createRefreshTokenClient = function(serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $0f2f6f908b4eb8f2$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    return SilentRefreshClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ var $9ae077a03ac23e9f$export$ed5d1a18907a1001 = /** @class */ function() {
    function TokenCache(configuration, storage, logger, cryptoObj) {
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ TokenCache.prototype.loadExternalTokens = function(request, response, options) {
        this.logger.info("TokenCache - loadExternalTokens called");
        if (!response.id_token) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please ensure server response includes id token.");
        var idToken = new (0, $557a50de248ab1f3$export$3a170961dab30083)(response.id_token, this.cryptoObj);
        var cacheRecord;
        var authority;
        if (request.account) {
            var cacheRecordAccount = this.loadAccount(idToken, request.account.environment, undefined, undefined, request.account.homeAccountId);
            cacheRecord = new (0, $5c9a0b8485eed0cc$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment));
        } else if (request.authority) {
            var authorityUrl = (0, $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions);
            var authorityOptions = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata,
                skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
            };
            authority = new (0, $aea8bfbe438b18c9$export$f1c6ec2e6d68c49c)(authorityUrl, this.config.system.networkClient, this.storage, authorityOptions, this.logger);
            // "clientInfo" from options takes precedence over "clientInfo" in response
            if (options.clientInfo) {
                this.logger.trace("TokenCache - homeAccountId from options");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, options.clientInfo, authority.authorityType);
                cacheRecord = new (0, $5c9a0b8485eed0cc$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            } else if (response.client_info) {
                this.logger.trace("TokenCache - homeAccountId from response");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, response.client_info, authority.authorityType);
                cacheRecord = new (0, $5c9a0b8485eed0cc$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide clientInfo in the response or options.");
        } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide a request with an account or a request with authority.");
        return this.generateAuthenticationResult(request, idToken, cacheRecord, authority);
    };
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ TokenCache.prototype.loadAccount = function(idToken, environment, clientInfo, authorityType, requestHomeAccountId) {
        var homeAccountId;
        if (requestHomeAccountId) homeAccountId = requestHomeAccountId;
        else if (authorityType !== undefined && clientInfo) homeAccountId = (0, $6ff18147f1afb887$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authorityType, this.logger, this.cryptoObj, idToken);
        if (!homeAccountId) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Unexpected missing homeAccountId");
        var accountEntity = clientInfo ? (0, $6ff18147f1afb887$export$680160523e6bfa6a).createAccount(clientInfo, homeAccountId, idToken, undefined, undefined, undefined, environment) : (0, $6ff18147f1afb887$export$680160523e6bfa6a).createGenericAccount(homeAccountId, idToken, undefined, undefined, undefined, environment);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading account");
            this.storage.setAccount(accountEntity);
            return accountEntity;
        } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ TokenCache.prototype.loadIdToken = function(idToken, homeAccountId, environment, tenantId) {
        var idTokenEntity = (0, $7ca7a2bf38aafdcd$export$49ed297fa7d02bde).createIdTokenEntity(homeAccountId, environment, idToken.rawToken, this.config.auth.clientId, tenantId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading id token");
            this.storage.setIdTokenCredential(idTokenEntity);
            return idTokenEntity;
        } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ TokenCache.prototype.loadAccessToken = function(request, response, homeAccountId, environment, tenantId, options) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - No access token provided for caching");
            return null;
        }
        if (!response.expires_in) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please ensure server response includes expires_in value.");
        if (!options.extendedExpiresOn) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide an extendedExpiresOn value in the options.");
        var scopes = new (0, $57be63d7f846af92$export$b9b82b0f94ae1f99)(request.scopes).printScopes();
        var expiresOn = options.expiresOn || response.expires_in + new Date().getTime() / 1000;
        var extendedExpiresOn = options.extendedExpiresOn;
        var accessTokenEntity = (0, $c2e674572252645d$export$6b7a8e14ec177765).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes, expiresOn, extendedExpiresOn, this.cryptoObj);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading access token");
            this.storage.setAccessTokenCredential(accessTokenEntity);
            return accessTokenEntity;
        } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ TokenCache.prototype.loadRefreshToken = function(request, response, homeAccountId, environment) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - No refresh token provided for caching");
            return null;
        }
        var refreshTokenEntity = (0, $ced2d4950dbd0255$export$2f7722c9adbc0a1b).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading refresh token");
            this.storage.setRefreshTokenCredential(refreshTokenEntity);
            return refreshTokenEntity;
        } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ TokenCache.prototype.generateAuthenticationResult = function(request, idTokenObj, cacheRecord, authority) {
        var _a, _b, _c;
        var accessToken = (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var responseScopes = [];
        var expiresOn = null;
        var extExpiresOn;
        if (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $57be63d7f846af92$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        var uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        var tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
        return {
            authority: authority ? authority.canonicalAuthority : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) ? cacheRecord.account.getAccountInfo() : null,
            idToken: idTokenObj ? idTokenObj.rawToken : (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            idTokenClaims: idTokenObj ? idTokenObj.claims : {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            requestId: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            extExpiresOn: extExpiresOn,
            familyId: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            tokenType: ((_a = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            state: (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: ((_b = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: ((_c = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
            code: undefined,
            fromNativeBroker: false
        };
    };
    return TokenCache;
}();






/*! @azure/msal-browser v2.38.3 2023-10-27 */ 





/*! @azure/msal-browser v2.38.3 2023-10-27 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $623d4c5789e83635$export$a2dbbd28e9bce542 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(HybridSpaAuthorizationCodeClient, _super);
    function HybridSpaAuthorizationCodeClient(config) {
        var _this = _super.call(this, config) || this;
        _this.includeRedirectUri = false;
        return _this;
    }
    return HybridSpaAuthorizationCodeClient;
}((0, $af51605ea36bf75c$export$8538731fd397fb90));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $fbaa7dd7a447d187$export$d7f5ef311b3e9fca = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(SilentAuthCodeClient, _super);
    function SilentAuthCodeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        return _this;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ SilentAuthCodeClient.prototype.acquireToken = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRequest, serverTelemetryManager, authCodeRequest, clientConfig, authClient, silentHandler, e_1;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("SilentAuthCodeClient.acquireToken called");
                        // Auth code payload is required
                        if (!request.code) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createAuthCodeRequiredError();
                        // Create silent request
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent)
                        ];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        authCodeRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, silentRequest), {
                            code: request.code
                        });
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, silentRequest.authority)
                        ];
                    case 3:
                        clientConfig = _a.sent();
                        authClient = new (0, $623d4c5789e83635$export$a2dbbd28e9bce542)(clientConfig);
                        this.logger.verbose("Auth code client created");
                        silentHandler = new (0, $53568c77e813b7f0$export$578d2d1abe796151)(authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Handle auth code parameters from request
                        return [
                            2 /*return*/ ,
                            silentHandler.handleCodeResponseFromServer({
                                code: request.code,
                                msgraph_host: request.msGraphHost,
                                cloud_graph_host_name: request.cloudGraphHostName,
                                cloud_instance_host_name: request.cloudInstanceHostName
                            }, silentRequest.state, authClient.authority, this.networkClient, false)
                        ];
                    case 4:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        throw e_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentAuthCodeClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    return SilentAuthCodeClient;
}((0, $f8c29a15d1b0a83c$export$fa9179cade3eb05a));



/*! @azure/msal-browser v2.38.3 2023-10-27 */ 



/*! @azure/msal-browser v2.38.3 2023-10-27 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $eab019420bc33cde$export$f97b8b5459a3aa4 = /** @class */ function() {
    function BrowserPerformanceMeasurement(name, correlationId) {
        this.correlationId = correlationId;
        this.measureName = BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    BrowserPerformanceMeasurement.makeMeasureName = function(name, correlationId) {
        return "msal.measure." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeStartMark = function(name, correlationId) {
        return "msal.start." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeEndMark = function(name, correlationId) {
        return "msal.end." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.supportsBrowserPerformance = function() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.mark === "function" && typeof window.performance.measure === "function" && typeof window.performance.clearMarks === "function" && typeof window.performance.clearMeasures === "function" && typeof window.performance.getEntriesByName === "function";
    };
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */ BrowserPerformanceMeasurement.flushMeasurements = function(correlationId, measurements) {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            measurements.forEach(function(measurement) {
                var measureName = BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                var entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    window.performance.clearMeasures(measureName);
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                }
            });
        } catch (e) {
        // Silently catch and return null
        }
    };
    BrowserPerformanceMeasurement.prototype.startMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.startMark);
        } catch (e) {
        // Silently catch
        }
    };
    BrowserPerformanceMeasurement.prototype.endMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.endMark);
            window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch (e) {
        // Silently catch
        }
    };
    BrowserPerformanceMeasurement.prototype.flushMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            var entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
            if (entriesForMeasurement.length > 0) {
                var durationMs = entriesForMeasurement[0].duration;
                window.performance.clearMeasures(this.measureName);
                window.performance.clearMarks(this.startMark);
                window.performance.clearMarks(this.endMark);
                return durationMs;
            }
        } catch (e) {
        // Silently catch and return null
        }
        return null;
    };
    return BrowserPerformanceMeasurement;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $5c18b130e8b89a2c$export$3714d85cfc8f4a02 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(BrowserPerformanceClient, _super);
    function BrowserPerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, cryptoOptions) {
        var _this = _super.call(this, clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) || this;
        _this.browserCrypto = new (0, $40b4b6b3e358a65d$export$bdaac271e902e541)(_this.logger, cryptoOptions);
        _this.guidGenerator = new (0, $ca5806521448c4be$export$62dc58eaf2cdc52)(_this.browserCrypto);
        return _this;
    }
    BrowserPerformanceClient.prototype.startPerformanceMeasuremeant = function(measureName, correlationId) {
        return new (0, $eab019420bc33cde$export$f97b8b5459a3aa4)(measureName, correlationId);
    };
    BrowserPerformanceClient.prototype.generateId = function() {
        return this.guidGenerator.generateGuid();
    };
    BrowserPerformanceClient.prototype.getPageVisibility = function() {
        var _a;
        return ((_a = document.visibilityState) === null || _a === void 0 ? void 0 : _a.toString()) || null;
    };
    BrowserPerformanceClient.prototype.deleteIncompleteSubMeasurements = function(inProgressEvent) {
        var rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
        var isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
        var incompleteMeasurements = [];
        if (isRootEvent && (rootEvent === null || rootEvent === void 0 ? void 0 : rootEvent.incompleteSubMeasurements)) rootEvent.incompleteSubMeasurements.forEach(function(subMeasurement) {
            incompleteMeasurements.push((0, $87ab789688594f61$export$18ce0697a983be9b)({}, subMeasurement));
        });
        // Clean up remaining marks for incomplete sub-measurements
        if (incompleteMeasurements.length > 0) (0, $eab019420bc33cde$export$f97b8b5459a3aa4).flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
    };
    BrowserPerformanceClient.prototype.supportsBrowserPerformanceNow = function() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.now === "function";
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */ BrowserPerformanceClient.prototype.startMeasurement = function(measureName, correlationId) {
        var _this = this;
        // Capture page visibilityState and then invoke start/end measurement
        var startPageVisibility = this.getPageVisibility();
        var inProgressEvent = _super.prototype.startMeasurement.call(this, measureName, correlationId);
        return (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, inProgressEvent), {
            endMeasurement: function(event) {
                var res = inProgressEvent.endMeasurement((0, $87ab789688594f61$export$18ce0697a983be9b)({
                    startPageVisibility: startPageVisibility,
                    endPageVisibility: _this.getPageVisibility()
                }, event));
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            },
            discardMeasurement: function() {
                inProgressEvent.discardMeasurement();
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                inProgressEvent.measurement.flushMeasurement();
            }
        });
    };
    /**
     * Adds pre-queue time to preQueueTimeByCorrelationId map.
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @returns
     */ BrowserPerformanceClient.prototype.setPreQueueTime = function(eventName, correlationId) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to set telemetry queue time for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to set telemetry queue time");
            return;
        }
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        /**
         * Manually complete queue measurement if there is an incomplete pre-queue event.
         * Incomplete pre-queue events are instrumentation bugs that should be fixed.
         */ if (preQueueEvent) {
            this.logger.trace("BrowserPerformanceClient: Incomplete pre-queue " + preQueueEvent.name + " found", correlationId);
            this.addQueueMeasurement(preQueueEvent.name, correlationId, undefined, true);
        }
        this.preQueueTimeByCorrelationId.set(correlationId, {
            name: eventName,
            time: window.performance.now()
        });
    };
    /**
     * Calculates and adds queue time measurement for given performance event.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */ BrowserPerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime, manuallyCompleted) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to add queue measurement for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to add queue measurement");
            return;
        }
        var preQueueTime = _super.prototype.getPreQueueTime.call(this, eventName, correlationId);
        if (!preQueueTime) return;
        var currentTime = window.performance.now();
        var resQueueTime = queueTime || _super.prototype.calculateQueuedTime.call(this, preQueueTime, currentTime);
        return _super.prototype.addQueueMeasurement.call(this, eventName, correlationId, resQueueTime, manuallyCompleted);
    };
    return BrowserPerformanceClient;
}((0, $aac62f65fee01d05$export$820526014323765f));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $0140421634b3b078$export$8d1a43f377c8df92 = /** @class */ function() {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ function ClientApplication(configuration) {
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.isBrowserEnvironment = typeof window !== "undefined";
        // Set the configuration.
        this.config = (0, $6d495cf6d7a6f942$export$f8352245bee68086)(configuration, this.isBrowserEnvironment);
        this.initialized = false;
        // Initialize logger
        this.logger = new (0, $5f18ed8a9f930396$export$efa9a398d6368992)(this.config.system.loggerOptions, (0, $a90996ccbe5c3c78$export$a8ff84c12d48cfa6), (0, $a90996ccbe5c3c78$export$83d89fbfd8236492));
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.isBrowserEnvironment ? new (0, $5c18b130e8b89a2c$export$3714d85cfc8f4a02)(this.config.auth.clientId, this.config.auth.authority, this.logger, (0, $a90996ccbe5c3c78$export$a8ff84c12d48cfa6), (0, $a90996ccbe5c3c78$export$83d89fbfd8236492), this.config.telemetry.application, this.config.system.cryptoOptions) : new (0, $3f63c095ec9831d5$export$c70f2989a65fda3e)(this.config.auth.clientId, this.config.auth.authority, this.logger, (0, $a90996ccbe5c3c78$export$a8ff84c12d48cfa6), (0, $a90996ccbe5c3c78$export$83d89fbfd8236492), this.config.telemetry.application);
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $13c91413da988abc$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, this.config.system.cryptoOptions) : (0, $1f27a522af777978$export$865f57d401606752);
        this.eventHandler = new (0, $ceb2bc16a4ee1463$export$ce0ba2422a1c7815)(this.logger, this.browserCrypto);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $d59662ac7a9a476c$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger) : (0, $d59662ac7a9a476c$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        var nativeCacheOptions = {
            cacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: true
        };
        this.nativeInternalStorage = new (0, $d59662ac7a9a476c$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger);
        // Initialize the token cache
        this.tokenCache = new (0, $9ae077a03ac23e9f$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     */ ClientApplication.prototype.initialize = function() {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allowNativeBroker, initMeasurement, _a, e_1, claimsTokensRemovalMeasurement;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.logger.trace("initialize called");
                        if (this.initialized) {
                            this.logger.info("initialize has already been called, exiting early.");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        allowNativeBroker = this.config.system.allowNativeBroker;
                        initMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeClientApplication);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).INITIALIZE_START);
                        if (!allowNativeBroker) return [
                            3 /*break*/ ,
                            4
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, $b905a9107139650f$export$c98888b8059e2702).createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient)
                        ];
                    case 2:
                        _a.nativeExtensionProvider = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        this.logger.verbose(e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (!!this.config.cache.claimsBasedCachingEnabled) return [
                            3 /*break*/ ,
                            6
                        ];
                        this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
                        claimsTokensRemovalMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims);
                        return [
                            4 /*yield*/ ,
                            this.browserStorage.clearTokensAndKeysWithClaims()
                        ];
                    case 5:
                        _b.sent();
                        claimsTokensRemovalMeasurement.endMeasurement({
                            success: true
                        });
                        _b.label = 6;
                    case 6:
                        this.initialized = true;
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).INITIALIZE_END);
                        initMeasurement.endMeasurement({
                            allowNativeBroker: allowNativeBroker,
                            success: true
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ ClientApplication.prototype.handleRedirectPromise = function(hash) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var loggedInAccounts, redirectResponseKey, response, request, redirectResponse, nativeClient, correlationId, redirectClient;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.verbose("handleRedirectPromise called");
                // Block token acquisition before initialize has been called if native brokering is enabled
                (0, $d8bc297369c9228b$export$311899ae85124b2d).blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
                loggedInAccounts = this.getAllAccounts();
                if (this.isBrowserEnvironment) {
                    redirectResponseKey = hash || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                    response = this.redirectResponse.get(redirectResponseKey);
                    if (typeof response === "undefined") {
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                        this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
                        request = this.browserStorage.getCachedNativeRequest();
                        redirectResponse = void 0;
                        if (request && (0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash) {
                            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                            nativeClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
                            redirectResponse = nativeClient.handleRedirectPromise();
                        } else {
                            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                            correlationId = this.browserStorage.getTemporaryCache((0, $0f344e7ceaf1df75$export$21d55bedf0d269fb).CORRELATION_ID, true) || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
                            redirectClient = this.createRedirectClient(correlationId);
                            redirectResponse = redirectClient.handleRedirectPromise(hash);
                        }
                        response = redirectResponse.then(function(result) {
                            if (result) {
                                // Emit login event if number of accounts change
                                var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
                                if (isLoggingIn) {
                                    _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, login success");
                                } else {
                                    _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                                }
                            }
                            _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            return result;
                        }).catch(function(e) {
                            // Emit login event if there is an account
                            if (loggedInAccounts.length > 0) _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, null, e);
                            else _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, null, e);
                            _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                            throw e;
                        });
                        this.redirectResponse.set(redirectResponseKey, response);
                    } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
                    return [
                        2 /*return*/ ,
                        response
                    ];
                }
                this.logger.verbose("handleRedirectPromise returns null, not browser environment");
                return [
                    2 /*return*/ ,
                    null
                ];
            });
        });
    };
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ ClientApplication.prototype.acquireTokenRedirect = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, isLoggedIn, result, nativeClient, redirectClient;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("acquireTokenRedirect called", correlationId);
                this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                isLoggedIn = this.getAllAccounts().length > 0;
                if (isLoggedIn) this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, request);
                else this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, request);
                if (this.nativeExtensionProvider && this.canUseNative(request)) {
                    nativeClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                    result = nativeClient.acquireTokenRedirect(request).catch(function(e) {
                        if (e instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e.isFatal()) {
                            _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        } else if (e instanceof (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba)) {
                            _this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        }
                        _this.browserStorage.setInteractionInProgress(false);
                        throw e;
                    });
                } else {
                    redirectClient = this.createRedirectClient(request.correlationId);
                    result = redirectClient.acquireToken(request);
                }
                return [
                    2 /*return*/ ,
                    result.catch(function(e) {
                        // If logged in, emit acquire token events
                        if (isLoggedIn) _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, null, e);
                        else _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect, null, e);
                        throw e;
                    })
                ];
            });
        });
    };
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.acquireTokenPopup = function(request) {
        var _this = this;
        var correlationId = this.getRequestCorrelationId(request);
        var atPopupMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        var loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, request);
        var result;
        if (this.canUseNative(request)) result = this.acquireTokenNative(request, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenPopup).then(function(response) {
            _this.browserStorage.setInteractionInProgress(false);
            atPopupMeasurement.endMeasurement({
                success: true,
                isNativeBroker: true,
                requestId: response.requestId
            });
            return response;
        }).catch(function(e) {
            if (e instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e.isFatal()) {
                _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                var popupClient = _this.createPopupClient(request.correlationId);
                return popupClient.acquireToken(request);
            } else if (e instanceof (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba)) {
                _this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                var popupClient = _this.createPopupClient(request.correlationId);
                return popupClient.acquireToken(request);
            }
            _this.browserStorage.setInteractionInProgress(false);
            throw e;
        });
        else {
            var popupClient = this.createPopupClient(request.correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then(function(result) {
            /*
             *  If logged in, emit acquire token events
             */ var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
            if (isLoggingIn) _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, result);
            else _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.addStaticFields({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.endMeasurement({
                success: true,
                requestId: result.requestId
            });
            return result;
        }).catch(function(e) {
            if (loggedInAccounts.length > 0) _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, null, e);
            else _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).LOGIN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.endMeasurement({
                errorCode: e.errorCode,
                subErrorCode: e.subError,
                success: false
            });
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    };
    ClientApplication.prototype.trackPageVisibilityWithMeasurement = function() {
        var measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    };
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.ssoSilent = function(request) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, validRequest, result, silentIframeClient;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                correlationId = this.getRequestCorrelationId(request);
                validRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                    // will be PromptValue.NONE or PromptValue.NO_SESSION
                    prompt: request.prompt,
                    correlationId: correlationId
                });
                this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent);
                this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SsoSilent, correlationId);
                (_a = this.ssoSilentMeasurement) === null || _a === void 0 || _a.increment({
                    visibilityChangeCount: 0
                });
                document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                this.logger.verbose("ssoSilent called", correlationId);
                this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).SSO_SILENT_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, validRequest);
                if (this.canUseNative(validRequest)) result = this.acquireTokenNative(validRequest, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).ssoSilent).catch(function(e) {
                    // If native token acquisition fails for availability reasons fallback to standard flow
                    if (e instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e.isFatal()) {
                        _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        var silentIframeClient = _this.createSilentIframeClient(validRequest.correlationId);
                        return silentIframeClient.acquireToken(validRequest);
                    }
                    throw e;
                });
                else {
                    silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    result = silentIframeClient.acquireToken(validRequest);
                }
                return [
                    2 /*return*/ ,
                    result.then(function(response) {
                        var _a, _b;
                        _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, response);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 || _a.addStaticFields({
                            accessTokenSize: response.accessToken.length,
                            idTokenSize: response.idToken.length
                        });
                        (_b = _this.ssoSilentMeasurement) === null || _b === void 0 || _b.endMeasurement({
                            success: true,
                            isNativeBroker: response.fromNativeBroker,
                            requestId: response.requestId
                        });
                        return response;
                    }).catch(function(e) {
                        var _a;
                        _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, null, e);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 || _a.endMeasurement({
                            errorCode: e.errorCode,
                            subErrorCode: e.subError,
                            success: false
                        });
                        throw e;
                    }).finally(function() {
                        document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                    })
                ];
            });
        });
    };
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.acquireTokenByCode = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, atbcMeasurement, hybridAuthCode_1, response;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent);
                this.logger.trace("acquireTokenByCode called", correlationId);
                this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, request);
                atbcMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenByCode, request.correlationId);
                try {
                    if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
                    throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createSpaCodeAndNativeAccountIdPresentError();
                    else if (request.code) {
                        hybridAuthCode_1 = request.code;
                        response = this.hybridAuthCodeResponses.get(hybridAuthCode_1);
                        if (!response) {
                            this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                            response = this.acquireTokenByCodeAsync((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                                correlationId: correlationId
                            })).then(function(result) {
                                _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, result);
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                atbcMeasurement.addStaticFields({
                                    accessTokenSize: result.accessToken.length,
                                    idTokenSize: result.idToken.length
                                });
                                atbcMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: result.fromNativeBroker,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(error) {
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, null, error);
                                atbcMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            });
                            this.hybridAuthCodeResponses.set(hybridAuthCode_1, response);
                        } else {
                            this.logger.verbose("Existing acquireTokenByCode request found", request.correlationId);
                            atbcMeasurement.discardMeasurement();
                        }
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    } else if (request.nativeAccountId) {
                        if (this.canUseNative(request, request.nativeAccountId)) return [
                            2 /*return*/ ,
                            this.acquireTokenNative(request, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch(function(e) {
                                // If native token acquisition fails for availability reasons fallback to standard flow
                                if (e instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e.isFatal()) _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                                throw e;
                            })
                        ];
                        else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createUnableToAcquireTokenFromNativePlatformError();
                    } else throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createAuthCodeOrNativeAccountIdRequiredError();
                } catch (e) {
                    this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, null, e);
                    atbcMeasurement.endMeasurement({
                        errorCode: e instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && e.errorCode || undefined,
                        subErrorCode: e instanceof (0, $a207a6b3d34d3093$export$145273558d58e0ac) && e.subError || undefined,
                        success: false
                    });
                    throw e;
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ ClientApplication.prototype.acquireTokenByCodeAsync = function(request) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentAuthCodeClient, silentTokenResult;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
                        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
                        (_a = this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                        silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentAuthCodeClient.acquireToken(request).then(function(response) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    success: true,
                                    fromCache: response.fromCache,
                                    isNativeBroker: response.fromNativeBroker,
                                    requestId: response.requestId
                                });
                                return response;
                            }).catch(function(tokenRenewalError) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    errorCode: tokenRenewalError.errorCode,
                                    subErrorCode: tokenRenewalError.subError,
                                    success: false
                                });
                                throw tokenRenewalError;
                            }).finally(function() {
                                document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                            })
                        ];
                    case 1:
                        silentTokenResult = _b.sent();
                        return [
                            2 /*return*/ ,
                            silentTokenResult
                        ];
                }
            });
        });
    };
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenFromCache = function(silentCacheClient, commonRequest, silentRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
                switch(silentRequest.cacheLookupPolicy){
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).Default:
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).AccessToken:
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                        return [
                            2 /*return*/ ,
                            silentCacheClient.acquireToken(commonRequest)
                        ];
                    default:
                        throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenByRefreshToken = function(commonRequest, silentRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRefreshClient;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
                switch(silentRequest.cacheLookupPolicy){
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).Default:
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).RefreshToken:
                    case (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                        silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, commonRequest.correlationId);
                        return [
                            2 /*return*/ ,
                            silentRefreshClient.acquireToken(commonRequest)
                        ];
                    default:
                        throw (0, $859b00ae06117652$export$a839ff85a7957561).createRefreshRequiredError();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenBySilentIframe = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentIframeClient;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
                silentIframeClient = this.createSilentIframeClient(request.correlationId);
                this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    silentIframeClient.acquireToken(request)
                ];
            });
        });
    };
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ ClientApplication.prototype.logout = function(logoutRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
                return [
                    2 /*return*/ ,
                    this.logoutRedirect((0, $87ab789688594f61$export$18ce0697a983be9b)({
                        correlationId: correlationId
                    }, logoutRequest))
                ];
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ ClientApplication.prototype.logoutRedirect = function(logoutRequest) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, redirectClient;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect);
                redirectClient = this.createRedirectClient(correlationId);
                return [
                    2 /*return*/ ,
                    redirectClient.logout(logoutRequest)
                ];
            });
        });
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ ClientApplication.prototype.logoutPopup = function(logoutRequest) {
        try {
            var correlationId = this.getRequestCorrelationId(logoutRequest);
            this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup);
            var popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    };
    // #endregion
    // #region Account APIs
    /**
     * Returns all accounts that MSAL currently has data for.
     * (the account object is created at the time of successful login)
     * or empty array when no accounts are found
     * @returns Array of account objects in cache
     */ ClientApplication.prototype.getAllAccounts = function() {
        this.logger.verbose("getAllAccounts called");
        return this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
    };
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByUsername = function(username) {
        this.logger.trace("getAccountByUsername called");
        if (!username) {
            this.logger.warning("getAccountByUsername: No username provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            username: username
        });
        if (account) {
            this.logger.verbose("getAccountByUsername: Account matching username found, returning");
            this.logger.verbosePii("getAccountByUsername: Returning signed-in accounts matching username: " + username);
            return account;
        } else {
            this.logger.verbose("getAccountByUsername: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByHomeId = function(homeAccountId) {
        this.logger.trace("getAccountByHomeId called");
        if (!homeAccountId) {
            this.logger.warning("getAccountByHomeId: No homeAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            homeAccountId: homeAccountId
        });
        if (account) {
            this.logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
            this.logger.verbosePii("getAccountByHomeId: Returning signed-in accounts matching homeAccountId: " + homeAccountId);
            return account;
        } else {
            this.logger.verbose("getAccountByHomeId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByLocalId = function(localAccountId) {
        this.logger.trace("getAccountByLocalId called");
        if (!localAccountId) {
            this.logger.warning("getAccountByLocalId: No localAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            localAccountId: localAccountId
        });
        if (account) {
            this.logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
            this.logger.verbosePii("getAccountByLocalId: Returning signed-in accounts matching localAccountId: " + localAccountId);
            return account;
        } else {
            this.logger.verbose("getAccountByLocalId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ ClientApplication.prototype.setActiveAccount = function(account) {
        this.browserStorage.setActiveAccount(account);
    };
    /**
     * Gets the currently active account
     */ ClientApplication.prototype.getActiveAccount = function() {
        return this.browserStorage.getActiveAccount();
    };
    // #endregion
    // #region Helpers
    /**
     * Helper to validate app environment before making an auth request
     *
     * @protected
     * @param {InteractionType} interactionType What kind of interaction is being used
     * @param {boolean} [setInteractionInProgress=true] Whether to set interaction in progress temp cache flag
     */ ClientApplication.prototype.preflightBrowserEnvironmentCheck = function(interactionType, setInteractionInProgress) {
        if (setInteractionInProgress === void 0) setInteractionInProgress = true;
        this.logger.verbose("preflightBrowserEnvironmentCheck started");
        // Block request if not in browser environment
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockNonBrowserEnvironment(this.isBrowserEnvironment);
        // Block redirects if in an iframe
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockRedirectInIframe(interactionType, this.config.system.allowRedirectInIframe);
        // Block auth requests inside a hidden iframe
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockReloadInHiddenIframes();
        // Block redirectUri opened in a popup from calling MSAL APIs
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockAcquireTokenInPopups();
        // Block token acquisition before initialize has been called if native brokering is enabled
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
        // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
        if (interactionType === (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect && this.config.cache.cacheLocation === (0, $0f344e7ceaf1df75$export$573384e47a12d835).MemoryStorage && !this.config.cache.storeAuthStateInCookie) throw (0, $320409a2968f9f12$export$2eb7a1dfdc4c5fba).createInMemoryRedirectUnavailableError();
        if (interactionType === (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Redirect || interactionType === (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Popup) this.preflightInteractiveRequest(setInteractionInProgress);
    };
    /**
     * Preflight check for interactive requests
     *
     * @protected
     * @param {boolean} setInteractionInProgress Whether to set interaction in progress temp cache flag
     */ ClientApplication.prototype.preflightInteractiveRequest = function(setInteractionInProgress) {
        this.logger.verbose("preflightInteractiveRequest called, validating app environment");
        // block the reload if it occurred inside a hidden iframe
        (0, $d8bc297369c9228b$export$311899ae85124b2d).blockReloadInHiddenIframes();
        // Set interaction in progress temporary cache or throw if alread set.
        if (setInteractionInProgress) this.browserStorage.setInteractionInProgress(true);
    };
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ ClientApplication.prototype.acquireTokenNative = function(request, apiId, accountId) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeClient;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("acquireTokenNative called");
                if (!this.nativeExtensionProvider) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                nativeClient = new (0, $c05e62c63828ff41$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                return [
                    2 /*return*/ ,
                    nativeClient.acquireToken(request)
                ];
            });
        });
    };
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */ ClientApplication.prototype.canUseNative = function(request, accountId) {
        this.logger.trace("canUseNative called");
        if (!(0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).NONE:
            case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).CONSENT:
            case (0, $709b0e48f6b53a82$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUseNative: prompt is compatible with native flow");
                break;
            default:
                this.logger.trace("canUseNative: prompt = " + request.prompt + " is not compatible with native flow, returning false");
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    };
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ ClientApplication.prototype.getNativeAccountId = function(request) {
        var account = request.account || this.browserStorage.getAccountInfoByHints(request.loginHint, request.sid) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    };
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createPopupClient = function(correlationId) {
        return new (0, $ff8c21979a984477$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createRedirectClient = function(correlationId) {
        return new (0, $b4f84405c017fdc8$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createSilentIframeClient = function(correlationId) {
        return new (0, $d32ddae51fe097a9$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ ClientApplication.prototype.createSilentCacheClient = function(correlationId) {
        return new (0, $f61c4d0df2164694$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ ClientApplication.prototype.createSilentRefreshClient = function(correlationId) {
        return new (0, $1b7fd6cba560cfbc$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ ClientApplication.prototype.createSilentAuthCodeClient = function(correlationId) {
        return new (0, $fbaa7dd7a447d187$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Adds event callbacks to array
     * @param callback
     */ ClientApplication.prototype.addEventCallback = function(callback) {
        return this.eventHandler.addEventCallback(callback);
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ ClientApplication.prototype.removeEventCallback = function(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    };
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ ClientApplication.prototype.addPerformanceCallback = function(callback) {
        return this.performanceClient.addPerformanceCallback(callback);
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ ClientApplication.prototype.removePerformanceCallback = function(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ ClientApplication.prototype.enableAccountStorageEvents = function() {
        this.eventHandler.enableAccountStorageEvents();
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ ClientApplication.prototype.disableAccountStorageEvents = function() {
        this.eventHandler.disableAccountStorageEvents();
    };
    /**
     * Gets the token cache for the application.
     */ ClientApplication.prototype.getTokenCache = function() {
        return this.tokenCache;
    };
    /**
     * Returns the logger instance
     */ ClientApplication.prototype.getLogger = function() {
        return this.logger;
    };
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ ClientApplication.prototype.setLogger = function(logger) {
        this.logger = logger;
    };
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ ClientApplication.prototype.initializeWrapperLibrary = function(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    };
    /**
     * Sets navigation client
     * @param navigationClient
     */ ClientApplication.prototype.setNavigationClient = function(navigationClient) {
        this.navigationClient = navigationClient;
    };
    /**
     * Returns the configuration object
     */ ClientApplication.prototype.getConfiguration = function() {
        return this.config;
    };
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ ClientApplication.prototype.getRequestCorrelationId = function(request) {
        if (request === null || request === void 0 ? void 0 : request.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return this.browserCrypto.createNewGuid();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING;
    };
    return ClientApplication;
}();







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ var $cc634fcd0c4f5425$export$89f4855ef88b7920 = /** @class */ function(_super) {
    (0, $87ab789688594f61$export$a8ba968b8961cb8a)(PublicClientApplication, _super);
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration object for the MSAL PublicClientApplication instance
     */ function PublicClientApplication(configuration) {
        var _this = _super.call(this, configuration) || this;
        _this.astsAsyncMeasurement = undefined;
        _this.activeSilentTokenRequests = new Map();
        // Register listener functions
        _this.trackPageVisibility = _this.trackPageVisibility.bind(_this);
        return _this;
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ PublicClientApplication.prototype.loginRedirect = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("loginRedirect called", correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireTokenRedirect((0, $87ab789688594f61$export$18ce0697a983be9b)({
                        correlationId: correlationId
                    }, request || (0, $0f344e7ceaf1df75$export$7e12949cd6884193)))
                ];
            });
        });
    };
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ PublicClientApplication.prototype.loginPopup = function(request) {
        var correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup((0, $87ab789688594f61$export$18ce0697a983be9b)({
            correlationId: correlationId
        }, request || (0, $0f344e7ceaf1df75$export$7e12949cd6884193)));
    };
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ PublicClientApplication.prototype.acquireTokenSilent = function(request) {
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, atsMeasurement, account, thumbprint, silentRequestKey, cachedResponse, response;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                atsMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
                atsMeasurement.addStaticFields({
                    cacheLookupPolicy: request.cacheLookupPolicy
                });
                this.preflightBrowserEnvironmentCheck((0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent);
                this.logger.verbose("acquireTokenSilent called", correlationId);
                account = request.account || this.getActiveAccount();
                if (!account) throw (0, $52ceb16ced3151d8$export$f8eb6760ca13876a).createNoAccountError();
                thumbprint = {
                    clientId: this.config.auth.clientId,
                    authority: request.authority || (0, $709b0e48f6b53a82$export$a002182e51710d39).EMPTY_STRING,
                    scopes: request.scopes,
                    homeAccountIdentifier: account.homeAccountId,
                    claims: request.claims,
                    authenticationScheme: request.authenticationScheme,
                    resourceRequestMethod: request.resourceRequestMethod,
                    resourceRequestUri: request.resourceRequestUri,
                    shrClaims: request.shrClaims,
                    sshKid: request.sshKid
                };
                silentRequestKey = JSON.stringify(thumbprint);
                cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
                if (typeof cachedResponse === "undefined") {
                    this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
                    this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenSilentAsync, correlationId);
                    response = this.acquireTokenSilentAsync((0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                        correlationId: correlationId
                    }), account).then(function(result) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.addStaticFields({
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        });
                        atsMeasurement.endMeasurement({
                            success: true,
                            fromCache: result.fromCache,
                            isNativeBroker: result.fromNativeBroker,
                            cacheLookupPolicy: request.cacheLookupPolicy,
                            requestId: result.requestId
                        });
                        return result;
                    }).catch(function(error) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.endMeasurement({
                            errorCode: error.errorCode,
                            subErrorCode: error.subError,
                            success: false
                        });
                        throw error;
                    });
                    this.activeSilentTokenRequests.set(silentRequestKey, response);
                    return [
                        2 /*return*/ ,
                        response
                    ];
                } else {
                    this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
                    // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
                    atsMeasurement.discardMeasurement();
                    return [
                        2 /*return*/ ,
                        cachedResponse
                    ];
                }
            });
        });
    };
    PublicClientApplication.prototype.trackPageVisibility = function() {
        if (!this.astsAsyncMeasurement) return;
        this.logger.info("Perf: Visibility change detected");
        this.astsAsyncMeasurement.increment({
            visibilityChangeCount: 1
        });
    };
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ PublicClientApplication.prototype.acquireTokenSilentAsync = function(request, account) {
        var _a;
        return (0, $87ab789688594f61$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var result, silentRequest, silentCacheClient, silentRequest_1, requestWithCLP_1;
            var _this = this;
            return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
                        this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, request);
                        this.astsAsyncMeasurement = this.performanceClient.startMeasurement((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
                        (_a = this.astsAsyncMeasurement) === null || _a === void 0 || _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibility);
                        if (!((0, $b905a9107139650f$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme) && account.nativeAccountId)) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
                        silentRequest = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                            account: account
                        });
                        result = this.acquireTokenNative(silentRequest, (0, $0f344e7ceaf1df75$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch(function(e) {
                            return (0, $87ab789688594f61$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                var silentIframeClient;
                                return (0, $87ab789688594f61$export$67ebef60e6f28a6)(this, function(_a) {
                                    // If native token acquisition fails for availability reasons fallback to web flow
                                    if (e instanceof (0, $5dffa83ecc9ed68e$export$4b8a4f6256e840ab) && e.isFatal()) {
                                        this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                                        this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                                        silentIframeClient = this.createSilentIframeClient(request.correlationId);
                                        return [
                                            2 /*return*/ ,
                                            silentIframeClient.acquireToken(request)
                                        ];
                                    }
                                    throw e;
                                });
                            });
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
                        silentCacheClient = this.createSilentCacheClient(request.correlationId);
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentCacheClient.initializeSilentRequest(request, account)
                        ];
                    case 2:
                        silentRequest_1 = _b.sent();
                        requestWithCLP_1 = (0, $87ab789688594f61$export$18ce0697a983be9b)((0, $87ab789688594f61$export$18ce0697a983be9b)({}, request), {
                            // set the request's CacheLookupPolicy to Default if it was not optionally passed in
                            cacheLookupPolicy: request.cacheLookupPolicy || (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).Default
                        });
                        this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenFromCache, silentRequest_1.correlationId);
                        result = this.acquireTokenFromCache(silentCacheClient, silentRequest_1, requestWithCLP_1).catch(function(cacheError) {
                            if (requestWithCLP_1.cacheLookupPolicy === (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).AccessToken) throw cacheError;
                            // block the reload if it occurred inside a hidden iframe
                            (0, $d8bc297369c9228b$export$311899ae85124b2d).blockReloadInHiddenIframes();
                            _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, silentRequest_1);
                            _this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, silentRequest_1.correlationId);
                            return _this.acquireTokenByRefreshToken(silentRequest_1, requestWithCLP_1).catch(function(refreshTokenError) {
                                var isServerError = refreshTokenError instanceof (0, $18269c32984fce6f$export$ea52035eac03daf0);
                                var isInteractionRequiredError = refreshTokenError instanceof (0, $2d9ea0d849f19272$export$6ba3e818c6bc76ba);
                                var rtNotFound = refreshTokenError.errorCode === (0, $2d9ea0d849f19272$export$d44d3b7b7a580eb6).noTokensFoundError.code;
                                var isInvalidGrantError = refreshTokenError.errorCode === (0, $0f344e7ceaf1df75$export$a0a689e4294b9880).INVALID_GRANT_ERROR;
                                if ((!isServerError || !isInvalidGrantError || isInteractionRequiredError || requestWithCLP_1.cacheLookupPolicy === (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).AccessTokenAndRefreshToken || requestWithCLP_1.cacheLookupPolicy === (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).RefreshToken) && requestWithCLP_1.cacheLookupPolicy !== (0, $0f344e7ceaf1df75$export$4394baa7e922d42d).Skip && !rtNotFound) throw refreshTokenError;
                                _this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", request.correlationId);
                                _this.performanceClient.setPreQueueTime((0, $c1ca1b67a2077729$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, silentRequest_1.correlationId);
                                return _this.acquireTokenBySilentIframe(silentRequest_1);
                            });
                        });
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            result.then(function(response) {
                                var _a;
                                _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, response);
                                (_a = _this.astsAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    success: true,
                                    fromCache: response.fromCache,
                                    isNativeBroker: response.fromNativeBroker,
                                    requestId: response.requestId
                                });
                                return response;
                            }).catch(function(tokenRenewalError) {
                                var _a;
                                _this.eventHandler.emitEvent((0, $bc14188b442b4f5f$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $0f344e7ceaf1df75$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
                                (_a = _this.astsAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    errorCode: tokenRenewalError.errorCode,
                                    subErrorCode: tokenRenewalError.subError,
                                    success: false
                                });
                                throw tokenRenewalError;
                            }).finally(function() {
                                document.removeEventListener("visibilitychange", _this.trackPageVisibility);
                            })
                        ];
                }
            });
        });
    };
    return PublicClientApplication;
}((0, $0140421634b3b078$export$8d1a43f377c8df92));


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $ae64e50e4b46da50$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-top-app-bar{background-color:#6200ee;background-color:var(--mdc-theme-primary, #6200ee);color:white;display:flex;position:fixed;flex-direction:column;justify-content:space-between;box-sizing:border-box;width:100%;z-index:4}.mdc-top-app-bar .mdc-top-app-bar__action-item,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon{color:#fff;color:var(--mdc-theme-on-primary, #fff)}.mdc-top-app-bar .mdc-top-app-bar__action-item::before,.mdc-top-app-bar .mdc-top-app-bar__action-item::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon::after{background-color:#fff;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-primary, #fff))}.mdc-top-app-bar .mdc-top-app-bar__action-item:hover::before,.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-surface--hover::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:hover::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-surface--hover::before{opacity:0.08;opacity:var(--mdc-ripple-hover-opacity, 0.08)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded--background-focused::before,.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):focus::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded--background-focused::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded)::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):active::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-top-app-bar__row{display:flex;position:relative;box-sizing:border-box;width:100%;height:64px}.mdc-top-app-bar__section{display:inline-flex;flex:1 1 auto;align-items:center;min-width:0;padding:8px 12px;z-index:1}.mdc-top-app-bar__section--align-start{justify-content:flex-start;order:-1}.mdc-top-app-bar__section--align-end{justify-content:flex-end;order:1}.mdc-top-app-bar__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-headline6-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size, 1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height, 2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight, 500);letter-spacing:0.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing, 0.0125em);text-decoration:inherit;text-decoration:var(--mdc-typography-headline6-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform, inherit);padding-left:20px;padding-right:0;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;z-index:1}[dir=rtl] .mdc-top-app-bar__title,.mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--short-collapsed{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:24px;border-bottom-left-radius:0}[dir=rtl] .mdc-top-app-bar--short-collapsed,.mdc-top-app-bar--short-collapsed[dir=rtl]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:24px}.mdc-top-app-bar--short{top:0;right:auto;left:0;width:100%;transition:width 250ms cubic-bezier(0.4, 0, 0.2, 1)}[dir=rtl] .mdc-top-app-bar--short,.mdc-top-app-bar--short[dir=rtl]{right:0;left:auto}.mdc-top-app-bar--short .mdc-top-app-bar__row{height:56px}.mdc-top-app-bar--short .mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short .mdc-top-app-bar__title{transition:opacity 200ms cubic-bezier(0.4, 0, 0.2, 1);opacity:1}.mdc-top-app-bar--short-collapsed{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12);width:56px;transition:width 300ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__title{display:none}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__action-item{transition:padding 150ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item{width:112px}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--dense .mdc-top-app-bar__row{height:48px}.mdc-top-app-bar--dense .mdc-top-app-bar__section{padding:0 4px}.mdc-top-app-bar--dense .mdc-top-app-bar__title{padding-left:12px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense .mdc-top-app-bar__title,.mdc-top-app-bar--dense .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:12px}.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:128px}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{align-self:flex-end;padding-bottom:2px}.mdc-top-app-bar--prominent .mdc-top-app-bar__action-item,.mdc-top-app-bar--prominent .mdc-top-app-bar__navigation-icon{align-self:flex-start}.mdc-top-app-bar--fixed{transition:box-shadow 200ms linear}.mdc-top-app-bar--fixed-scrolled{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12);transition:box-shadow 200ms linear}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:96px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section{padding:0 12px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-left:20px;padding-right:0;padding-bottom:9px}[dir=rtl] .mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title,.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--fixed-adjust{padding-top:64px}.mdc-top-app-bar--dense-fixed-adjust{padding-top:48px}.mdc-top-app-bar--short-fixed-adjust{padding-top:56px}.mdc-top-app-bar--prominent-fixed-adjust{padding-top:128px}.mdc-top-app-bar--dense-prominent-fixed-adjust{padding-top:96px}@media(max-width: 599px){.mdc-top-app-bar__row{height:56px}.mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short{transition:width 200ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed{transition:width 250ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:6px}.mdc-top-app-bar--fixed-adjust{padding-top:56px}}:host{display:block}.mdc-top-app-bar{color:#fff;color:var(--mdc-theme-on-primary, #fff);width:100%;width:var(--mdc-top-app-bar-width, 100%)}.mdc-top-app-bar--prominent #navigation ::slotted(*),.mdc-top-app-bar--prominent #actions ::slotted(*){align-self:flex-start}#navigation ::slotted(*),#actions ::slotted(*){--mdc-icon-button-ripple-opacity: 0.24}.mdc-top-app-bar--short-collapsed #actions ::slotted(*){transition:padding 150ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar__section--align-center{justify-content:center}.mdc-top-app-bar__section--align-center .mdc-top-app-bar__title{padding-left:0;padding-right:0}.center-title .mdc-top-app-bar__section--align-start,.center-title .mdc-top-app-bar__section--align-end{flex-basis:0}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section--align-center .mdc-top-app-bar__title{padding-left:0;padding-right:0}.mdc-top-app-bar--fixed-scrolled{box-shadow:var(--mdc-top-app-bar-fixed-box-shadow, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12))}`;


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $bba15d2fbc199e8d$export$c1c0562ec8379000 = {
    FIXED_CLASS: "mdc-top-app-bar--fixed",
    FIXED_SCROLLED_CLASS: "mdc-top-app-bar--fixed-scrolled",
    SHORT_CLASS: "mdc-top-app-bar--short",
    SHORT_COLLAPSED_CLASS: "mdc-top-app-bar--short-collapsed",
    SHORT_HAS_ACTION_ITEM_CLASS: "mdc-top-app-bar--short-has-action-item"
};
var $bba15d2fbc199e8d$export$1f6c9cc012ebacae = {
    DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
    MAX_TOP_APP_BAR_HEIGHT: 128
};
var $bba15d2fbc199e8d$export$21c51bc433c16634 = {
    ACTION_ITEM_SELECTOR: ".mdc-top-app-bar__action-item",
    NAVIGATION_EVENT: "MDCTopAppBar:nav",
    NAVIGATION_ICON_SELECTOR: ".mdc-top-app-bar__navigation-icon",
    ROOT_SELECTOR: ".mdc-top-app-bar",
    TITLE_SELECTOR: ".mdc-top-app-bar__title"
};


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $2d9a9fd56a64cb11$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$2d9a9fd56a64cb11$export$2e2bcd8739ae039 = $2d9a9fd56a64cb11$export$a81b11d69c993162;



var $5e1f4682f04023fa$export$8d607f703c13e7f1 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCTopAppBarBaseFoundation, _super);
    /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarBaseFoundation(adapter) {
        return _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCTopAppBarBaseFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCTopAppBarBaseFoundation, "strings", {
        get: function() {
            return 0, $bba15d2fbc199e8d$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "cssClasses", {
        get: function() {
            return 0, $bba15d2fbc199e8d$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "numbers", {
        get: function() {
            return 0, $bba15d2fbc199e8d$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "defaultAdapter", {
        /**
         * See {@link MDCTopAppBarAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                setStyle: function() {
                    return undefined;
                },
                getTopAppBarHeight: function() {
                    return 0;
                },
                notifyNavigationIconClicked: function() {
                    return undefined;
                },
                getViewportScrollY: function() {
                    return 0;
                },
                getTotalActionItems: function() {
                    return 0;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleTargetScroll = function() {}; // tslint:disable-line:no-empty
    /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleWindowResize = function() {}; // tslint:disable-line:no-empty
    MDCTopAppBarBaseFoundation.prototype.handleNavigationClick = function() {
        this.adapter.notifyNavigationIconClicked();
    };
    return MDCTopAppBarBaseFoundation;
}((0, $2d9a9fd56a64cb11$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$5e1f4682f04023fa$export$2e2bcd8739ae039 = $5e1f4682f04023fa$export$8d607f703c13e7f1;


var $a93cebe9a5505a12$var$INITIAL_VALUE = 0;
var $a93cebe9a5505a12$export$fb8cee90da48470f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCTopAppBarFoundation, _super);
    /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarFoundation(adapter) {
        var _this = _super.call(this, adapter) || this;
        /**
         * Indicates if the top app bar was docked in the previous scroll handler iteration.
         */ _this.wasDocked = true;
        /**
         * Indicates if the top app bar is docked in the fully shown position.
         */ _this.isDockedShowing = true;
        /**
         * Variable for current scroll position of the top app bar
         */ _this.currentAppBarOffsetTop = 0;
        /**
         * Used to prevent the top app bar from being scrolled out of view during resize events
         */ _this.isCurrentlyBeingResized = false;
        /**
         * The timeout that's used to throttle the resize events
         */ _this.resizeThrottleId = $a93cebe9a5505a12$var$INITIAL_VALUE;
        /**
         * The timeout that's used to debounce toggling the isCurrentlyBeingResized
         * variable after a resize
         */ _this.resizeDebounceId = $a93cebe9a5505a12$var$INITIAL_VALUE;
        _this.lastScrollPosition = _this.adapter.getViewportScrollY();
        _this.topAppBarHeight = _this.adapter.getTopAppBarHeight();
        return _this;
    }
    MDCTopAppBarFoundation.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.adapter.setStyle("top", "");
    };
    /**
     * Scroll handler for the default scroll behavior of the top app bar.
     */ MDCTopAppBarFoundation.prototype.handleTargetScroll = function() {
        var currentScrollPosition = Math.max(this.adapter.getViewportScrollY(), 0);
        var diff = currentScrollPosition - this.lastScrollPosition;
        this.lastScrollPosition = currentScrollPosition;
        // If the window is being resized the lastScrollPosition needs to be updated
        // but the current scroll of the top app bar should stay in the same
        // position.
        if (!this.isCurrentlyBeingResized) {
            this.currentAppBarOffsetTop -= diff;
            if (this.currentAppBarOffsetTop > 0) this.currentAppBarOffsetTop = 0;
            else if (Math.abs(this.currentAppBarOffsetTop) > this.topAppBarHeight) this.currentAppBarOffsetTop = -this.topAppBarHeight;
            this.moveTopAppBar();
        }
    };
    /**
     * Top app bar resize handler that throttle/debounce functions that execute updates.
     */ MDCTopAppBarFoundation.prototype.handleWindowResize = function() {
        var _this = this;
        // Throttle resize events 10 p/s
        if (!this.resizeThrottleId) this.resizeThrottleId = setTimeout(function() {
            _this.resizeThrottleId = $a93cebe9a5505a12$var$INITIAL_VALUE;
            _this.throttledResizeHandler();
        }, (0, $bba15d2fbc199e8d$export$1f6c9cc012ebacae).DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
        this.isCurrentlyBeingResized = true;
        if (this.resizeDebounceId) clearTimeout(this.resizeDebounceId);
        this.resizeDebounceId = setTimeout(function() {
            _this.handleTargetScroll();
            _this.isCurrentlyBeingResized = false;
            _this.resizeDebounceId = $a93cebe9a5505a12$var$INITIAL_VALUE;
        }, (0, $bba15d2fbc199e8d$export$1f6c9cc012ebacae).DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
    };
    /**
     * Function to determine if the DOM needs to update.
     */ MDCTopAppBarFoundation.prototype.checkForUpdate = function() {
        var offscreenBoundaryTop = -this.topAppBarHeight;
        var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop < 0;
        var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop > offscreenBoundaryTop;
        var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
        // If it's partially showing, it can't be docked.
        if (partiallyShowing) this.wasDocked = false;
        else {
            // Not previously docked and not partially showing, it's now docked.
            if (!this.wasDocked) {
                this.wasDocked = true;
                return true;
            } else if (this.isDockedShowing !== hasAnyPixelsOnscreen) {
                this.isDockedShowing = hasAnyPixelsOnscreen;
                return true;
            }
        }
        return partiallyShowing;
    };
    /**
     * Function to move the top app bar if needed.
     */ MDCTopAppBarFoundation.prototype.moveTopAppBar = function() {
        if (this.checkForUpdate()) {
            // Once the top app bar is fully hidden we use the max potential top app bar height as our offset
            // so the top app bar doesn't show if the window resizes and the new height > the old height.
            var offset = this.currentAppBarOffsetTop;
            if (Math.abs(offset) >= this.topAppBarHeight) offset = -(0, $bba15d2fbc199e8d$export$1f6c9cc012ebacae).MAX_TOP_APP_BAR_HEIGHT;
            this.adapter.setStyle("top", offset + "px");
        }
    };
    /**
     * Throttled function that updates the top app bar scrolled values if the
     * top app bar height changes.
     */ MDCTopAppBarFoundation.prototype.throttledResizeHandler = function() {
        var currentHeight = this.adapter.getTopAppBarHeight();
        if (this.topAppBarHeight !== currentHeight) {
            this.wasDocked = false;
            // Since the top app bar has a different height depending on the screen width, this
            // will ensure that the top app bar remains in the correct location if
            // completely hidden and a resize makes the top app bar a different height.
            this.currentAppBarOffsetTop -= this.topAppBarHeight - currentHeight;
            this.topAppBarHeight = currentHeight;
        }
        this.handleTargetScroll();
    };
    return MDCTopAppBarFoundation;
}((0, $5e1f4682f04023fa$export$8d607f703c13e7f1));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$a93cebe9a5505a12$export$2e2bcd8739ae039 = $a93cebe9a5505a12$export$fb8cee90da48470f;



/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * Determines whether a node is an element.
 *
 * @param node Node to check
 */ const $748a8e1d68854803$export$c86dc70db5dbb27d = (node)=>{
    return node.nodeType === Node.ELEMENT_NODE;
};
function $748a8e1d68854803$export$122d35ad43dccfa3(element) {
    return {
        addClass: (className)=>{
            element.classList.add(className);
        },
        removeClass: (className)=>{
            element.classList.remove(className);
        },
        hasClass: (className)=>element.classList.contains(className)
    };
}
let $748a8e1d68854803$var$supportsPassive = false;
const $748a8e1d68854803$var$fn = ()=>{};
const $748a8e1d68854803$var$optionsBlock = {
    get passive () {
        $748a8e1d68854803$var$supportsPassive = true;
        return false;
    }
};
document.addEventListener("x", $748a8e1d68854803$var$fn, $748a8e1d68854803$var$optionsBlock);
document.removeEventListener("x", $748a8e1d68854803$var$fn);
const $748a8e1d68854803$export$dd8b371dc4bf436e = $748a8e1d68854803$var$supportsPassive;
const $748a8e1d68854803$export$8b6ad084041b2343 = (doc = window.document)=>{
    let activeElement = doc.activeElement;
    const path = [];
    if (!activeElement) return path;
    while(activeElement){
        path.push(activeElement);
        if (activeElement.shadowRoot) activeElement = activeElement.shadowRoot.activeElement;
        else break;
    }
    return path;
};
const $748a8e1d68854803$export$597abdf7826dd64a = (element)=>{
    const activePath = $748a8e1d68854803$export$8b6ad084041b2343();
    if (!activePath.length) return false;
    const deepActiveElement = activePath[activePath.length - 1];
    const focusEv = new Event("check-if-focused", {
        bubbles: true,
        composed: true
    });
    let composedPath = [];
    const listener = (ev)=>{
        composedPath = ev.composedPath();
    };
    document.body.addEventListener("check-if-focused", listener);
    deepActiveElement.dispatchEvent(focusEv);
    document.body.removeEventListener("check-if-focused", listener);
    return composedPath.indexOf(element) !== -1;
};


class $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    click() {
        if (this.mdcRoot) {
            this.mdcRoot.focus();
            this.mdcRoot.click();
            return;
        }
        super.click();
    }
    /**
     * Create and attach the MDC Foundation to the instance
     */ createFoundation() {
        if (this.mdcFoundation !== undefined) this.mdcFoundation.destroy();
        if (this.mdcFoundationClass) {
            this.mdcFoundation = new this.mdcFoundationClass(this.createAdapter());
            this.mdcFoundation.init();
        }
    }
    firstUpdated() {
        this.createFoundation();
    }
}







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e5c059fc79abe53$export$56cc687933817664 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});




const $44f69d15fd49a6cd$export$f7426bc6d3d50eba = (0, $748a8e1d68854803$export$dd8b371dc4bf436e) ? {
    passive: true
} : undefined;
class $44f69d15fd49a6cd$export$d372b7d973f22f7c extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.centerTitle = false;
        this.handleTargetScroll = ()=>{
            this.mdcFoundation.handleTargetScroll();
        };
        this.handleNavigationClick = ()=>{
            this.mdcFoundation.handleNavigationClick();
        };
    }
    get scrollTarget() {
        return this._scrollTarget || window;
    }
    set scrollTarget(value) {
        this.unregisterScrollListener();
        const old = this.scrollTarget;
        this._scrollTarget = value;
        this.updateRootPosition();
        this.requestUpdate("scrollTarget", old);
        this.registerScrollListener();
    }
    updateRootPosition() {
        if (this.mdcRoot) {
            const windowScroller = this.scrollTarget === window;
            // we add support for top-app-bar's tied to an element scroller.
            this.mdcRoot.style.position = windowScroller ? "" : "absolute";
        }
    }
    render() {
        // clang-format off
        let title = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="mdc-top-app-bar__title"><slot name="title"></slot></span>`;
        if (this.centerTitle) title = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-center">${title}</section>`;
        // clang-format on
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <header class="mdc-top-app-bar ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.barClasses())}">
      <div class="mdc-top-app-bar__row">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start" id="navigation">
          <slot name="navigationIcon"
            @click=${this.handleNavigationClick}></slot>
          ${this.centerTitle ? null : title}
        </section>
        ${this.centerTitle ? title : null}
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" id="actions" role="toolbar">
          <slot name="actionItems"></slot>
        </section>
      </div>
    </header>
    <div class="${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.contentClasses())}">
      <slot></slot>
    </div>
    `;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot)), {
            setStyle: (property, value)=>this.mdcRoot.style.setProperty(property, value),
            getTopAppBarHeight: ()=>this.mdcRoot.clientHeight,
            notifyNavigationIconClicked: ()=>{
                this.dispatchEvent(new Event((0, $bba15d2fbc199e8d$export$21c51bc433c16634).NAVIGATION_EVENT, {
                    bubbles: true,
                    cancelable: true
                }));
            },
            getViewportScrollY: ()=>this.scrollTarget instanceof Window ? this.scrollTarget.pageYOffset : this.scrollTarget.scrollTop,
            getTotalActionItems: ()=>this._actionItemsSlot.assignedNodes({
                    flatten: true
                }).length
        });
    }
    registerListeners() {
        this.registerScrollListener();
    }
    unregisterListeners() {
        this.unregisterScrollListener();
    }
    registerScrollListener() {
        this.scrollTarget.addEventListener("scroll", this.handleTargetScroll, $44f69d15fd49a6cd$export$f7426bc6d3d50eba);
    }
    unregisterScrollListener() {
        this.scrollTarget.removeEventListener("scroll", this.handleTargetScroll);
    }
    firstUpdated() {
        super.firstUpdated();
        this.updateRootPosition();
        this.registerListeners();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unregisterListeners();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-top-app-bar")
], $44f69d15fd49a6cd$export$d372b7d973f22f7c.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)('slot[name="actionItems"]')
], $44f69d15fd49a6cd$export$d372b7d973f22f7c.prototype, "_actionItemsSlot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $44f69d15fd49a6cd$export$d372b7d973f22f7c.prototype, "centerTitle", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $44f69d15fd49a6cd$export$d372b7d973f22f7c.prototype, "scrollTarget", null);


class $c8e7de81eafd0fd3$export$7d83700306637ce9 extends (0, $44f69d15fd49a6cd$export$d372b7d973f22f7c) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $a93cebe9a5505a12$export$2e2bcd8739ae039);
        this.prominent = false;
        this.dense = false;
        this.handleResize = ()=>{
            this.mdcFoundation.handleWindowResize();
        };
    }
    barClasses() {
        return {
            "mdc-top-app-bar--dense": this.dense,
            "mdc-top-app-bar--prominent": this.prominent,
            "center-title": this.centerTitle
        };
    }
    contentClasses() {
        return {
            "mdc-top-app-bar--fixed-adjust": !this.dense && !this.prominent,
            "mdc-top-app-bar--dense-fixed-adjust": this.dense && !this.prominent,
            "mdc-top-app-bar--prominent-fixed-adjust": !this.dense && this.prominent,
            "mdc-top-app-bar--dense-prominent-fixed-adjust": this.dense && this.prominent
        };
    }
    registerListeners() {
        super.registerListeners();
        window.addEventListener("resize", this.handleResize, (0, $44f69d15fd49a6cd$export$f7426bc6d3d50eba));
    }
    unregisterListeners() {
        super.unregisterListeners();
        window.removeEventListener("resize", this.handleResize);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c8e7de81eafd0fd3$export$7d83700306637ce9.prototype, "prominent", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c8e7de81eafd0fd3$export$7d83700306637ce9.prototype, "dense", void 0);



/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 


var $abede66799c089e8$export$7ab4745f9177da15 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCFixedTopAppBarFoundation, _super);
    function MDCFixedTopAppBarFoundation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * State variable for the previous scroll iteration top app bar state
         */ _this.wasScrolled = false;
        return _this;
    }
    /**
     * Scroll handler for applying/removing the modifier class on the fixed top app bar.
     */ MDCFixedTopAppBarFoundation.prototype.handleTargetScroll = function() {
        var currentScroll = this.adapter.getViewportScrollY();
        if (currentScroll <= 0) {
            if (this.wasScrolled) {
                this.adapter.removeClass((0, $bba15d2fbc199e8d$export$c1c0562ec8379000).FIXED_SCROLLED_CLASS);
                this.wasScrolled = false;
            }
        } else if (!this.wasScrolled) {
            this.adapter.addClass((0, $bba15d2fbc199e8d$export$c1c0562ec8379000).FIXED_SCROLLED_CLASS);
            this.wasScrolled = true;
        }
    };
    return MDCFixedTopAppBarFoundation;
}((0, $a93cebe9a5505a12$export$fb8cee90da48470f));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$abede66799c089e8$export$2e2bcd8739ae039 = $abede66799c089e8$export$7ab4745f9177da15;


class $6aace0dfb59efa07$export$f10dd04d0b60147a extends (0, $c8e7de81eafd0fd3$export$7d83700306637ce9) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $abede66799c089e8$export$2e2bcd8739ae039);
    }
    barClasses() {
        return Object.assign(Object.assign({}, super.barClasses()), {
            "mdc-top-app-bar--fixed": true
        });
    }
    registerListeners() {
        this.scrollTarget.addEventListener("scroll", this.handleTargetScroll, (0, $44f69d15fd49a6cd$export$f7426bc6d3d50eba));
    }
    unregisterListeners() {
        this.scrollTarget.removeEventListener("scroll", this.handleTargetScroll);
    }
}


let $ad5b06ea70e39842$export$61a1599c2ddf7de3 = class TopAppBarFixed extends (0, $6aace0dfb59efa07$export$f10dd04d0b60147a) {
};
$ad5b06ea70e39842$export$61a1599c2ddf7de3.styles = [
    (0, $ae64e50e4b46da50$export$9dd6ff9ea0189349)
];
$ad5b06ea70e39842$export$61a1599c2ddf7de3 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-top-app-bar-fixed")
], $ad5b06ea70e39842$export$61a1599c2ddf7de3);


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ffa41f8048ee22db$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$ffa41f8048ee22db$export$2e2bcd8739ae039 = $ffa41f8048ee22db$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $802a9ddebd4ead60$export$21c51bc433c16634 = {
    NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
};
var $802a9ddebd4ead60$export$1f6c9cc012ebacae = {
    // This should stay in sync with $mdc-notched-outline-padding * 2.
    NOTCH_ELEMENT_PADDING: 8
};
var $802a9ddebd4ead60$export$c1c0562ec8379000 = {
    NO_LABEL: "mdc-notched-outline--no-label",
    OUTLINE_NOTCHED: "mdc-notched-outline--notched",
    OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
};


var $fbdf0eb004738ce0$export$1416251f3c23f76c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCNotchedOutlineFoundation, _super);
    function MDCNotchedOutlineFoundation(adapter) {
        return _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCNotchedOutlineFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCNotchedOutlineFoundation, "strings", {
        get: function() {
            return 0, $802a9ddebd4ead60$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "cssClasses", {
        get: function() {
            return 0, $802a9ddebd4ead60$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "numbers", {
        get: function() {
            return 0, $802a9ddebd4ead60$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "defaultAdapter", {
        /**
         * See {@link MDCNotchedOutlineAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                setNotchWidthProperty: function() {
                    return undefined;
                },
                removeNotchWidthProperty: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds the outline notched selector and updates the notch width calculated based off of notchWidth.
     */ MDCNotchedOutlineFoundation.prototype.notch = function(notchWidth) {
        var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
        if (notchWidth > 0) notchWidth += (0, $802a9ddebd4ead60$export$1f6c9cc012ebacae).NOTCH_ELEMENT_PADDING; // Add padding from left/right.
        this.adapter.setNotchWidthProperty(notchWidth);
        this.adapter.addClass(OUTLINE_NOTCHED);
    };
    /**
     * Removes notched outline selector to close the notch in the outline.
     */ MDCNotchedOutlineFoundation.prototype.closeNotch = function() {
        var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
        this.adapter.removeClass(OUTLINE_NOTCHED);
        this.adapter.removeNotchWidthProperty();
    };
    return MDCNotchedOutlineFoundation;
}((0, $ffa41f8048ee22db$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$fbdf0eb004738ce0$export$2e2bcd8739ae039 = $fbdf0eb004738ce0$export$1416251f3c23f76c;





class $d7c1f14d7c35e490$export$81f8fe999345ef19 extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $fbdf0eb004738ce0$export$1416251f3c23f76c);
        this.width = 0;
        this.open = false;
        this.lastOpen = this.open;
    }
    createAdapter() {
        return {
            addClass: (className)=>this.mdcRoot.classList.add(className),
            removeClass: (className)=>this.mdcRoot.classList.remove(className),
            setNotchWidthProperty: (width)=>this.notchElement.style.setProperty("width", `${width}px`),
            removeNotchWidthProperty: ()=>this.notchElement.style.removeProperty("width")
        };
    }
    openOrClose(shouldOpen, width) {
        if (!this.mdcFoundation) return;
        if (shouldOpen && width !== undefined) this.mdcFoundation.notch(width);
        else this.mdcFoundation.closeNotch();
    }
    render() {
        this.openOrClose(this.open, this.width);
        const classes = (0, $0e5c059fc79abe53$export$56cc687933817664)({
            "mdc-notched-outline--notched": this.open
        });
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-notched-outline ${classes}">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <slot></slot>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>`;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-notched-outline")
], $d7c1f14d7c35e490$export$81f8fe999345ef19.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $d7c1f14d7c35e490$export$81f8fe999345ef19.prototype, "width", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d7c1f14d7c35e490$export$81f8fe999345ef19.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-notched-outline__notch")
], $d7c1f14d7c35e490$export$81f8fe999345ef19.prototype, "notchElement", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $4f6ca75d41c6f049$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-notched-outline{display:flex;position:absolute;top:0;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;height:100%;border-top:1px solid;border-bottom:1px solid;pointer-events:none}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:0 0 auto;width:auto;max-width:calc(100% - 12px * 2)}.mdc-notched-outline .mdc-floating-label{display:inline-block;position:relative;max-width:100%}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:calc(100% / 0.75)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-left:0;padding-right:8px;border-top:none}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}:host{display:block;position:absolute;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] :host,:host([dir=rtl]){text-align:right}::slotted(.mdc-floating-label){display:inline-block;position:relative;top:17px;bottom:auto;max-width:100%}::slotted(.mdc-floating-label--float-above){text-overflow:clip}.mdc-notched-outline--upgraded ::slotted(.mdc-floating-label--float-above){max-width:calc(100% / 0.75)}.mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}[dir=rtl] .mdc-notched-outline .mdc-notched-outline__leading,.mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}@supports(top: max(0%)){.mdc-notched-outline .mdc-notched-outline__leading{width:max(12px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px, var(--mdc-shape-small, 4px)) * 2)}}.mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}[dir=rtl] .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{border-color:var(--mdc-notched-outline-border-color, var(--mdc-theme-primary, #6200ee));border-width:1px;border-width:var(--mdc-notched-outline-stroke-width, 1px)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0;padding-top:var(--mdc-notched-outline-notch-offset, 0)}`;


let $321a2275a95c5ad5$export$3058494686005c96 = class NotchedOutline extends (0, $d7c1f14d7c35e490$export$81f8fe999345ef19) {
};
$321a2275a95c5ad5$export$3058494686005c96.styles = [
    (0, $4f6ca75d41c6f049$export$9dd6ff9ea0189349)
];
$321a2275a95c5ad5$export$3058494686005c96 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-notched-outline")
], $321a2275a95c5ad5$export$3058494686005c96);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


var $362ad72c8b1dae7b$var$_a, $362ad72c8b1dae7b$var$_b;
// ShadyDOM should submit <input> elements in component internals
const $362ad72c8b1dae7b$var$USING_SHADY_DOM = ($362ad72c8b1dae7b$var$_b = ($362ad72c8b1dae7b$var$_a = window.ShadyDOM) === null || $362ad72c8b1dae7b$var$_a === void 0 ? void 0 : $362ad72c8b1dae7b$var$_a.inUse) !== null && $362ad72c8b1dae7b$var$_b !== void 0 ? $362ad72c8b1dae7b$var$_b : false;
class $362ad72c8b1dae7b$export$fcc7a416e8ecbf7a extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        /**
         * Disabled state for the component. When `disabled` is set to `true`, the
         * component will not be added to form submission.
         */ this.disabled = false;
        /**
         * Form element that contains this element
         */ this.containingForm = null;
        this.formDataListener = (ev)=>{
            if (!this.disabled) this.setFormData(ev.formData);
        };
    }
    findFormElement() {
        // If the component internals are not in Shadow DOM, subscribing to form
        // data events could lead to duplicated data, which may not work correctly
        // on the server side.
        if (!this.shadowRoot || $362ad72c8b1dae7b$var$USING_SHADY_DOM) return null;
        const root = this.getRootNode();
        const forms = root.querySelectorAll("form");
        for (const form of Array.from(forms)){
            if (form.contains(this)) return form;
        }
        return null;
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.containingForm = this.findFormElement();
        (_a = this.containingForm) === null || _a === void 0 || _a.addEventListener("formdata", this.formDataListener);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.containingForm) === null || _a === void 0 || _a.removeEventListener("formdata", this.formDataListener);
        this.containingForm = null;
    }
    click() {
        if (this.formElement && !this.disabled) {
            this.formElement.focus();
            this.formElement.click();
        }
    }
    firstUpdated() {
        super.firstUpdated();
        if (this.shadowRoot) this.mdcRoot.addEventListener("change", (e)=>{
            this.dispatchEvent(new Event("change", e));
        });
    }
}
$362ad72c8b1dae7b$export$fcc7a416e8ecbf7a.shadowRootOptions = {
    mode: "open",
    delegatesFocus: true
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $362ad72c8b1dae7b$export$fcc7a416e8ecbf7a.prototype, "disabled", void 0);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Specifies an observer callback that is run when the decorated property
 * changes. The observer receives the current and old value as arguments.
 */ const $7087db5d0615d2d8$export$b6ae1bc530f4c149 = (observer)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (proto, propName)=>{
        // if we haven't wrapped `updated` in this class, do so
        if (!proto.constructor._observers) {
            proto.constructor._observers = new Map();
            const userUpdated = proto.updated;
            proto.updated = function(changedProperties) {
                userUpdated.call(this, changedProperties);
                changedProperties.forEach((v, k)=>{
                    const observers = this.constructor._observers;
                    const observer = observers.get(k);
                    if (observer !== undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    observer.call(this, this[k], v);
                });
            };
        // clone any existing observers (superclasses)
        // eslint-disable-next-line no-prototype-builtins
        } else if (!proto.constructor.hasOwnProperty("_observers")) {
            const observers = proto.constructor._observers;
            proto.constructor._observers = new Map();
            observers.forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (v, k)=>proto.constructor._observers.set(k, v));
        }
        // set this method
        proto.constructor._observers.set(propName, observer);
    };


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $fe5eceb240bc255f$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$fe5eceb240bc255f$export$2e2bcd8739ae039 = $fe5eceb240bc255f$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $0198436963a5b88b$export$c1c0562ec8379000 = {
    LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
    LABEL_REQUIRED: "mdc-floating-label--required",
    LABEL_SHAKE: "mdc-floating-label--shake",
    ROOT: "mdc-floating-label"
};


var $d9a78196fa9ce9f0$export$c260f97a6b4add0a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCFloatingLabelFoundation, _super);
    function MDCFloatingLabelFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCFloatingLabelFoundation.defaultAdapter), adapter)) || this;
        _this.shakeAnimationEndHandler = function() {
            _this.handleShakeAnimationEnd();
        };
        return _this;
    }
    Object.defineProperty(MDCFloatingLabelFoundation, "cssClasses", {
        get: function() {
            return 0, $0198436963a5b88b$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFloatingLabelFoundation, "defaultAdapter", {
        /**
         * See {@link MDCFloatingLabelAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                getWidth: function() {
                    return 0;
                },
                registerInteractionHandler: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCFloatingLabelFoundation.prototype.init = function() {
        this.adapter.registerInteractionHandler("animationend", this.shakeAnimationEndHandler);
    };
    MDCFloatingLabelFoundation.prototype.destroy = function() {
        this.adapter.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler);
    };
    /**
     * Returns the width of the label element.
     */ MDCFloatingLabelFoundation.prototype.getWidth = function() {
        return this.adapter.getWidth();
    };
    /**
     * Styles the label to produce a shake animation to indicate an error.
     * @param shouldShake If true, adds the shake CSS class; otherwise, removes shake class.
     */ MDCFloatingLabelFoundation.prototype.shake = function(shouldShake) {
        var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
        if (shouldShake) this.adapter.addClass(LABEL_SHAKE);
        else this.adapter.removeClass(LABEL_SHAKE);
    };
    /**
     * Styles the label to float or dock.
     * @param shouldFloat If true, adds the float CSS class; otherwise, removes float and shake classes to dock the label.
     */ MDCFloatingLabelFoundation.prototype.float = function(shouldFloat) {
        var _a = MDCFloatingLabelFoundation.cssClasses, LABEL_FLOAT_ABOVE = _a.LABEL_FLOAT_ABOVE, LABEL_SHAKE = _a.LABEL_SHAKE;
        if (shouldFloat) this.adapter.addClass(LABEL_FLOAT_ABOVE);
        else {
            this.adapter.removeClass(LABEL_FLOAT_ABOVE);
            this.adapter.removeClass(LABEL_SHAKE);
        }
    };
    /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabelFoundation.prototype.setRequired = function(isRequired) {
        var LABEL_REQUIRED = MDCFloatingLabelFoundation.cssClasses.LABEL_REQUIRED;
        if (isRequired) this.adapter.addClass(LABEL_REQUIRED);
        else this.adapter.removeClass(LABEL_REQUIRED);
    };
    MDCFloatingLabelFoundation.prototype.handleShakeAnimationEnd = function() {
        var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
        this.adapter.removeClass(LABEL_SHAKE);
    };
    return MDCFloatingLabelFoundation;
}((0, $fe5eceb240bc255f$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d9a78196fa9ce9f0$export$2e2bcd8739ae039 = $d9a78196fa9ce9f0$export$c260f97a6b4add0a;





const $08d6fdf9123f1e40$var$createAdapter = (labelElement)=>{
    return {
        addClass: (className)=>labelElement.classList.add(className),
        removeClass: (className)=>labelElement.classList.remove(className),
        getWidth: ()=>labelElement.scrollWidth,
        registerInteractionHandler: (evtType, handler)=>{
            labelElement.addEventListener(evtType, handler);
        },
        deregisterInteractionHandler: (evtType, handler)=>{
            labelElement.removeEventListener(evtType, handler);
        }
    };
};
class $08d6fdf9123f1e40$var$FloatingLabelDirective extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(partInfo){
        super(partInfo);
        this.foundation = null;
        this.previousPart = null;
        switch(partInfo.type){
            // Only allow Attribute and Part bindings
            case (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE:
            case (0, $3baabda811939da5$export$9ba3b3f20a85bfa).PROPERTY:
                break;
            default:
                throw new Error("FloatingLabel directive only support attribute and property parts");
        }
    }
    /**
     * There is no PropertyPart in Lit 2 so far. For more info see:
     * https://github.com/lit/lit/issues/1863
     */ update(part, [label]) {
        if (part !== this.previousPart) {
            if (this.foundation) this.foundation.destroy();
            this.previousPart = part;
            const labelElement = part.element;
            labelElement.classList.add("mdc-floating-label");
            const adapter = $08d6fdf9123f1e40$var$createAdapter(labelElement);
            this.foundation = new (0, $d9a78196fa9ce9f0$export$c260f97a6b4add0a)(adapter);
            this.foundation.init();
        }
        return this.render(label);
    }
    render(_label) {
        return this.foundation;
    }
}
const $08d6fdf9123f1e40$export$a5e5b5e75cfc3b36 = (0, $3baabda811939da5$export$99b43ad1ed32e735)($08d6fdf9123f1e40$var$FloatingLabelDirective);


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ee77fed5a04fb235$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$ee77fed5a04fb235$export$2e2bcd8739ae039 = $ee77fed5a04fb235$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $b09af44d345c4f3c$export$c1c0562ec8379000 = {
    LINE_RIPPLE_ACTIVE: "mdc-line-ripple--active",
    LINE_RIPPLE_DEACTIVATING: "mdc-line-ripple--deactivating"
};


var $db6e958d709020b2$export$305b613fbe54f455 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCLineRippleFoundation, _super);
    function MDCLineRippleFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCLineRippleFoundation.defaultAdapter), adapter)) || this;
        _this.transitionEndHandler = function(evt) {
            _this.handleTransitionEnd(evt);
        };
        return _this;
    }
    Object.defineProperty(MDCLineRippleFoundation, "cssClasses", {
        get: function() {
            return 0, $b09af44d345c4f3c$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLineRippleFoundation, "defaultAdapter", {
        /**
         * See {@link MDCLineRippleAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                setStyle: function() {
                    return undefined;
                },
                registerEventHandler: function() {
                    return undefined;
                },
                deregisterEventHandler: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCLineRippleFoundation.prototype.init = function() {
        this.adapter.registerEventHandler("transitionend", this.transitionEndHandler);
    };
    MDCLineRippleFoundation.prototype.destroy = function() {
        this.adapter.deregisterEventHandler("transitionend", this.transitionEndHandler);
    };
    MDCLineRippleFoundation.prototype.activate = function() {
        this.adapter.removeClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_DEACTIVATING);
        this.adapter.addClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_ACTIVE);
    };
    MDCLineRippleFoundation.prototype.setRippleCenter = function(xCoordinate) {
        this.adapter.setStyle("transform-origin", xCoordinate + "px center");
    };
    MDCLineRippleFoundation.prototype.deactivate = function() {
        this.adapter.addClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_DEACTIVATING);
    };
    MDCLineRippleFoundation.prototype.handleTransitionEnd = function(evt) {
        // Wait for the line ripple to be either transparent or opaque
        // before emitting the animation end event
        var isDeactivating = this.adapter.hasClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_DEACTIVATING);
        if (evt.propertyName === "opacity") {
            if (isDeactivating) {
                this.adapter.removeClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_ACTIVE);
                this.adapter.removeClass((0, $b09af44d345c4f3c$export$c1c0562ec8379000).LINE_RIPPLE_DEACTIVATING);
            }
        }
    };
    return MDCLineRippleFoundation;
}((0, $ee77fed5a04fb235$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$db6e958d709020b2$export$2e2bcd8739ae039 = $db6e958d709020b2$export$305b613fbe54f455;



const $26dc552073ed1864$var$createAdapter = (lineElement)=>{
    return {
        addClass: (className)=>lineElement.classList.add(className),
        removeClass: (className)=>lineElement.classList.remove(className),
        hasClass: (className)=>lineElement.classList.contains(className),
        setStyle: (propertyName, value)=>lineElement.style.setProperty(propertyName, value),
        registerEventHandler: (evtType, handler)=>{
            lineElement.addEventListener(evtType, handler);
        },
        deregisterEventHandler: (evtType, handler)=>{
            lineElement.removeEventListener(evtType, handler);
        }
    };
};
class $26dc552073ed1864$export$9acada7bd0657fb9 extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(partInfo){
        super(partInfo);
        this.previousPart = null;
        this.foundation = null;
        switch(partInfo.type){
            case (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE:
            case (0, $3baabda811939da5$export$9ba3b3f20a85bfa).PROPERTY:
                return;
            default:
                throw new Error("LineRipple only support attribute and property parts.");
        }
    }
    /**
     * There is no PropertyPart in Lit 2 so far. For more info see:
     * https://github.com/lit/lit/issues/1863
     */ update(part, _params) {
        if (this.previousPart !== part) {
            if (this.foundation) this.foundation.destroy();
            this.previousPart = part;
            const lineElement = part.element;
            lineElement.classList.add("mdc-line-ripple");
            const adapter = $26dc552073ed1864$var$createAdapter(lineElement);
            this.foundation = new (0, $db6e958d709020b2$export$305b613fbe54f455)(adapter);
            this.foundation.init();
        }
        return this.render();
    }
    render() {
        return this.foundation;
    }
}
const $26dc552073ed1864$export$4e67d44fb59b80f2 = (0, $3baabda811939da5$export$99b43ad1ed32e735)($26dc552073ed1864$export$9acada7bd0657fb9);


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a9cf765391686086$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$a9cf765391686086$export$2e2bcd8739ae039 = $a9cf765391686086$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $eb3ae9611cb273fa$export$21c51bc433c16634 = {
    ARIA_CONTROLS: "aria-controls",
    ARIA_DESCRIBEDBY: "aria-describedby",
    INPUT_SELECTOR: ".mdc-text-field__input",
    LABEL_SELECTOR: ".mdc-floating-label",
    LEADING_ICON_SELECTOR: ".mdc-text-field__icon--leading",
    LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
    OUTLINE_SELECTOR: ".mdc-notched-outline",
    PREFIX_SELECTOR: ".mdc-text-field__affix--prefix",
    SUFFIX_SELECTOR: ".mdc-text-field__affix--suffix",
    TRAILING_ICON_SELECTOR: ".mdc-text-field__icon--trailing"
};
var $eb3ae9611cb273fa$export$c1c0562ec8379000 = {
    DISABLED: "mdc-text-field--disabled",
    FOCUSED: "mdc-text-field--focused",
    HELPER_LINE: "mdc-text-field-helper-line",
    INVALID: "mdc-text-field--invalid",
    LABEL_FLOATING: "mdc-text-field--label-floating",
    NO_LABEL: "mdc-text-field--no-label",
    OUTLINED: "mdc-text-field--outlined",
    ROOT: "mdc-text-field",
    TEXTAREA: "mdc-text-field--textarea",
    WITH_LEADING_ICON: "mdc-text-field--with-leading-icon",
    WITH_TRAILING_ICON: "mdc-text-field--with-trailing-icon",
    WITH_INTERNAL_COUNTER: "mdc-text-field--with-internal-counter"
};
var $eb3ae9611cb273fa$export$1f6c9cc012ebacae = {
    LABEL_SCALE: 0.75
};
/**
 * Whitelist based off of
 * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
 * under the "Validation-related attributes" section.
 */ var $eb3ae9611cb273fa$export$b45590aaec0cdbc6 = [
    "pattern",
    "min",
    "max",
    "required",
    "step",
    "minlength",
    "maxlength"
];
/**
 * Label should always float for these types as they show some UI even if value
 * is empty.
 */ var $eb3ae9611cb273fa$export$51a97178494bc025 = [
    "color",
    "date",
    "datetime-local",
    "month",
    "range",
    "time",
    "week"
];


var $ac2a49a094ff9847$var$POINTERDOWN_EVENTS = [
    "mousedown",
    "touchstart"
];
var $ac2a49a094ff9847$var$INTERACTION_EVENTS = [
    "click",
    "keydown"
];
var $ac2a49a094ff9847$export$e62c196cd9ca6c2c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCTextFieldFoundation, _super);
    /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCTextFieldFoundation(adapter, foundationMap) {
        if (foundationMap === void 0) foundationMap = {};
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCTextFieldFoundation.defaultAdapter), adapter)) || this;
        _this.isFocused = false;
        _this.receivedUserInput = false;
        _this.valid = true;
        _this.useNativeValidation = true;
        _this.validateOnValueChange = true;
        _this.helperText = foundationMap.helperText;
        _this.characterCounter = foundationMap.characterCounter;
        _this.leadingIcon = foundationMap.leadingIcon;
        _this.trailingIcon = foundationMap.trailingIcon;
        _this.inputFocusHandler = function() {
            _this.activateFocus();
        };
        _this.inputBlurHandler = function() {
            _this.deactivateFocus();
        };
        _this.inputInputHandler = function() {
            _this.handleInput();
        };
        _this.setPointerXOffset = function(evt) {
            _this.setTransformOrigin(evt);
        };
        _this.textFieldInteractionHandler = function() {
            _this.handleTextFieldInteraction();
        };
        _this.validationAttributeChangeHandler = function(attributesList) {
            _this.handleValidationAttributeChange(attributesList);
        };
        return _this;
    }
    Object.defineProperty(MDCTextFieldFoundation, "cssClasses", {
        get: function() {
            return 0, $eb3ae9611cb273fa$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "strings", {
        get: function() {
            return 0, $eb3ae9611cb273fa$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "numbers", {
        get: function() {
            return 0, $eb3ae9611cb273fa$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldAlwaysFloat", {
        get: function() {
            var type = this.getNativeInput().type;
            return (0, $eb3ae9611cb273fa$export$51a97178494bc025).indexOf(type) >= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldFloat", {
        get: function() {
            return this.shouldAlwaysFloat || this.isFocused || !!this.getValue() || this.isBadInput();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldShake", {
        get: function() {
            return !this.isFocused && !this.isValid() && !!this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "defaultAdapter", {
        /**
         * See {@link MDCTextFieldAdapter} for typing information on parameters and
         * return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return true;
                },
                setInputAttr: function() {
                    return undefined;
                },
                removeInputAttr: function() {
                    return undefined;
                },
                registerTextFieldInteractionHandler: function() {
                    return undefined;
                },
                deregisterTextFieldInteractionHandler: function() {
                    return undefined;
                },
                registerInputInteractionHandler: function() {
                    return undefined;
                },
                deregisterInputInteractionHandler: function() {
                    return undefined;
                },
                registerValidationAttributeChangeHandler: function() {
                    return new MutationObserver(function() {
                        return undefined;
                    });
                },
                deregisterValidationAttributeChangeHandler: function() {
                    return undefined;
                },
                getNativeInput: function() {
                    return null;
                },
                isFocused: function() {
                    return false;
                },
                activateLineRipple: function() {
                    return undefined;
                },
                deactivateLineRipple: function() {
                    return undefined;
                },
                setLineRippleTransformOrigin: function() {
                    return undefined;
                },
                shakeLabel: function() {
                    return undefined;
                },
                floatLabel: function() {
                    return undefined;
                },
                setLabelRequired: function() {
                    return undefined;
                },
                hasLabel: function() {
                    return false;
                },
                getLabelWidth: function() {
                    return 0;
                },
                hasOutline: function() {
                    return false;
                },
                notchOutline: function() {
                    return undefined;
                },
                closeOutline: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCTextFieldFoundation.prototype.init = function() {
        var e_1, _a, e_2, _b;
        if (this.adapter.hasLabel() && this.getNativeInput().required) this.adapter.setLabelRequired(true);
        if (this.adapter.isFocused()) this.inputFocusHandler();
        else if (this.adapter.hasLabel() && this.shouldFloat) {
            this.notchOutline(true);
            this.adapter.floatLabel(true);
            this.styleFloating(true);
        }
        this.adapter.registerInputInteractionHandler("focus", this.inputFocusHandler);
        this.adapter.registerInputInteractionHandler("blur", this.inputBlurHandler);
        this.adapter.registerInputInteractionHandler("input", this.inputInputHandler);
        try {
            for(var POINTERDOWN_EVENTS_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($ac2a49a094ff9847$var$POINTERDOWN_EVENTS), POINTERDOWN_EVENTS_1_1 = POINTERDOWN_EVENTS_1.next(); !POINTERDOWN_EVENTS_1_1.done; POINTERDOWN_EVENTS_1_1 = POINTERDOWN_EVENTS_1.next()){
                var evtType = POINTERDOWN_EVENTS_1_1.value;
                this.adapter.registerInputInteractionHandler(evtType, this.setPointerXOffset);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (POINTERDOWN_EVENTS_1_1 && !POINTERDOWN_EVENTS_1_1.done && (_a = POINTERDOWN_EVENTS_1.return)) _a.call(POINTERDOWN_EVENTS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var INTERACTION_EVENTS_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($ac2a49a094ff9847$var$INTERACTION_EVENTS), INTERACTION_EVENTS_1_1 = INTERACTION_EVENTS_1.next(); !INTERACTION_EVENTS_1_1.done; INTERACTION_EVENTS_1_1 = INTERACTION_EVENTS_1.next()){
                var evtType = INTERACTION_EVENTS_1_1.value;
                this.adapter.registerTextFieldInteractionHandler(evtType, this.textFieldInteractionHandler);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (INTERACTION_EVENTS_1_1 && !INTERACTION_EVENTS_1_1.done && (_b = INTERACTION_EVENTS_1.return)) _b.call(INTERACTION_EVENTS_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        this.validationObserver = this.adapter.registerValidationAttributeChangeHandler(this.validationAttributeChangeHandler);
        this.setcharacterCounter(this.getValue().length);
    };
    MDCTextFieldFoundation.prototype.destroy = function() {
        var e_3, _a, e_4, _b;
        this.adapter.deregisterInputInteractionHandler("focus", this.inputFocusHandler);
        this.adapter.deregisterInputInteractionHandler("blur", this.inputBlurHandler);
        this.adapter.deregisterInputInteractionHandler("input", this.inputInputHandler);
        try {
            for(var POINTERDOWN_EVENTS_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($ac2a49a094ff9847$var$POINTERDOWN_EVENTS), POINTERDOWN_EVENTS_2_1 = POINTERDOWN_EVENTS_2.next(); !POINTERDOWN_EVENTS_2_1.done; POINTERDOWN_EVENTS_2_1 = POINTERDOWN_EVENTS_2.next()){
                var evtType = POINTERDOWN_EVENTS_2_1.value;
                this.adapter.deregisterInputInteractionHandler(evtType, this.setPointerXOffset);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (POINTERDOWN_EVENTS_2_1 && !POINTERDOWN_EVENTS_2_1.done && (_a = POINTERDOWN_EVENTS_2.return)) _a.call(POINTERDOWN_EVENTS_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var INTERACTION_EVENTS_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($ac2a49a094ff9847$var$INTERACTION_EVENTS), INTERACTION_EVENTS_2_1 = INTERACTION_EVENTS_2.next(); !INTERACTION_EVENTS_2_1.done; INTERACTION_EVENTS_2_1 = INTERACTION_EVENTS_2.next()){
                var evtType = INTERACTION_EVENTS_2_1.value;
                this.adapter.deregisterTextFieldInteractionHandler(evtType, this.textFieldInteractionHandler);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (INTERACTION_EVENTS_2_1 && !INTERACTION_EVENTS_2_1.done && (_b = INTERACTION_EVENTS_2.return)) _b.call(INTERACTION_EVENTS_2);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.adapter.deregisterValidationAttributeChangeHandler(this.validationObserver);
    };
    /**
     * Handles user interactions with the Text Field.
     */ MDCTextFieldFoundation.prototype.handleTextFieldInteraction = function() {
        var nativeInput = this.adapter.getNativeInput();
        if (nativeInput && nativeInput.disabled) return;
        this.receivedUserInput = true;
    };
    /**
     * Handles validation attribute changes
     */ MDCTextFieldFoundation.prototype.handleValidationAttributeChange = function(attributesList) {
        var _this = this;
        attributesList.some(function(attributeName) {
            if ((0, $eb3ae9611cb273fa$export$b45590aaec0cdbc6).indexOf(attributeName) > -1) {
                _this.styleValidity(true);
                _this.adapter.setLabelRequired(_this.getNativeInput().required);
                return true;
            }
            return false;
        });
        if (attributesList.indexOf("maxlength") > -1) this.setcharacterCounter(this.getValue().length);
    };
    /**
     * Opens/closes the notched outline.
     */ MDCTextFieldFoundation.prototype.notchOutline = function(openNotch) {
        if (!this.adapter.hasOutline() || !this.adapter.hasLabel()) return;
        if (openNotch) {
            var labelWidth = this.adapter.getLabelWidth() * (0, $eb3ae9611cb273fa$export$1f6c9cc012ebacae).LABEL_SCALE;
            this.adapter.notchOutline(labelWidth);
        } else this.adapter.closeOutline();
    };
    /**
     * Activates the text field focus state.
     */ MDCTextFieldFoundation.prototype.activateFocus = function() {
        this.isFocused = true;
        this.styleFocused(this.isFocused);
        this.adapter.activateLineRipple();
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            this.adapter.shakeLabel(this.shouldShake);
        }
        if (this.helperText && (this.helperText.isPersistent() || !this.helperText.isValidation() || !this.valid)) this.helperText.showToScreenReader();
    };
    /**
     * Sets the line ripple's transform origin, so that the line ripple activate
     * animation will animate out from the user's click location.
     */ MDCTextFieldFoundation.prototype.setTransformOrigin = function(evt) {
        if (this.isDisabled() || this.adapter.hasOutline()) return;
        var touches = evt.touches;
        var targetEvent = touches ? touches[0] : evt;
        var targetClientRect = targetEvent.target.getBoundingClientRect();
        var normalizedX = targetEvent.clientX - targetClientRect.left;
        this.adapter.setLineRippleTransformOrigin(normalizedX);
    };
    /**
     * Handles input change of text input and text area.
     */ MDCTextFieldFoundation.prototype.handleInput = function() {
        this.autoCompleteFocus();
        this.setcharacterCounter(this.getValue().length);
    };
    /**
     * Activates the Text Field's focus state in cases when the input value
     * changes without user input (e.g. programmatically).
     */ MDCTextFieldFoundation.prototype.autoCompleteFocus = function() {
        if (!this.receivedUserInput) this.activateFocus();
    };
    /**
     * Deactivates the Text Field's focus state.
     */ MDCTextFieldFoundation.prototype.deactivateFocus = function() {
        this.isFocused = false;
        this.adapter.deactivateLineRipple();
        var isValid = this.isValid();
        this.styleValidity(isValid);
        this.styleFocused(this.isFocused);
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            this.adapter.shakeLabel(this.shouldShake);
        }
        if (!this.shouldFloat) this.receivedUserInput = false;
    };
    MDCTextFieldFoundation.prototype.getValue = function() {
        return this.getNativeInput().value;
    };
    /**
     * @param value The value to set on the input Element.
     */ MDCTextFieldFoundation.prototype.setValue = function(value) {
        // Prevent Safari from moving the caret to the end of the input when the
        // value has not changed.
        if (this.getValue() !== value) this.getNativeInput().value = value;
        this.setcharacterCounter(value.length);
        if (this.validateOnValueChange) {
            var isValid = this.isValid();
            this.styleValidity(isValid);
        }
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            if (this.validateOnValueChange) this.adapter.shakeLabel(this.shouldShake);
        }
    };
    /**
     * @return The custom validity state, if set; otherwise, the result of a
     *     native validity check.
     */ MDCTextFieldFoundation.prototype.isValid = function() {
        return this.useNativeValidation ? this.isNativeInputValid() : this.valid;
    };
    /**
     * @param isValid Sets the custom validity state of the Text Field.
     */ MDCTextFieldFoundation.prototype.setValid = function(isValid) {
        this.valid = isValid;
        this.styleValidity(isValid);
        var shouldShake = !isValid && !this.isFocused && !!this.getValue();
        if (this.adapter.hasLabel()) this.adapter.shakeLabel(shouldShake);
    };
    /**
     * @param shouldValidate Whether or not validity should be updated on
     *     value change.
     */ MDCTextFieldFoundation.prototype.setValidateOnValueChange = function(shouldValidate) {
        this.validateOnValueChange = shouldValidate;
    };
    /**
     * @return Whether or not validity should be updated on value change. `true`
     *     by default.
     */ MDCTextFieldFoundation.prototype.getValidateOnValueChange = function() {
        return this.validateOnValueChange;
    };
    /**
     * Enables or disables the use of native validation. Use this for custom
     * validation.
     * @param useNativeValidation Set this to false to ignore native input
     *     validation.
     */ MDCTextFieldFoundation.prototype.setUseNativeValidation = function(useNativeValidation) {
        this.useNativeValidation = useNativeValidation;
    };
    MDCTextFieldFoundation.prototype.isDisabled = function() {
        return this.getNativeInput().disabled;
    };
    /**
     * @param disabled Sets the text-field disabled or enabled.
     */ MDCTextFieldFoundation.prototype.setDisabled = function(disabled) {
        this.getNativeInput().disabled = disabled;
        this.styleDisabled(disabled);
    };
    /**
     * @param content Sets the content of the helper text.
     */ MDCTextFieldFoundation.prototype.setHelperTextContent = function(content) {
        if (this.helperText) this.helperText.setContent(content);
    };
    /**
     * Sets the aria label of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconAriaLabel = function(label) {
        if (this.leadingIcon) this.leadingIcon.setAriaLabel(label);
    };
    /**
     * Sets the text content of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconContent = function(content) {
        if (this.leadingIcon) this.leadingIcon.setContent(content);
    };
    /**
     * Sets the aria label of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconAriaLabel = function(label) {
        if (this.trailingIcon) this.trailingIcon.setAriaLabel(label);
    };
    /**
     * Sets the text content of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconContent = function(content) {
        if (this.trailingIcon) this.trailingIcon.setContent(content);
    };
    /**
     * Sets character counter values that shows characters used and the total
     * character limit.
     */ MDCTextFieldFoundation.prototype.setcharacterCounter = function(currentLength) {
        if (!this.characterCounter) return;
        var maxLength = this.getNativeInput().maxLength;
        if (maxLength === -1) throw new Error("MDCTextFieldFoundation: Expected maxlength html property on text input or textarea.");
        this.characterCounter.setCounterValue(currentLength, maxLength);
    };
    /**
     * @return True if the Text Field input fails in converting the user-supplied
     *     value.
     */ MDCTextFieldFoundation.prototype.isBadInput = function() {
        // The badInput property is not supported in IE 11 💩.
        return this.getNativeInput().validity.badInput || false;
    };
    /**
     * @return The result of native validity checking (ValidityState.valid).
     */ MDCTextFieldFoundation.prototype.isNativeInputValid = function() {
        return this.getNativeInput().validity.valid;
    };
    /**
     * Styles the component based on the validity state.
     */ MDCTextFieldFoundation.prototype.styleValidity = function(isValid) {
        var INVALID = MDCTextFieldFoundation.cssClasses.INVALID;
        if (isValid) this.adapter.removeClass(INVALID);
        else this.adapter.addClass(INVALID);
        if (this.helperText) {
            this.helperText.setValidity(isValid);
            // We dynamically set or unset aria-describedby for validation helper text
            // only, based on whether the field is valid
            var helperTextValidation = this.helperText.isValidation();
            if (!helperTextValidation) return;
            var helperTextVisible = this.helperText.isVisible();
            var helperTextId = this.helperText.getId();
            if (helperTextVisible && helperTextId) this.adapter.setInputAttr((0, $eb3ae9611cb273fa$export$21c51bc433c16634).ARIA_DESCRIBEDBY, helperTextId);
            else this.adapter.removeInputAttr((0, $eb3ae9611cb273fa$export$21c51bc433c16634).ARIA_DESCRIBEDBY);
        }
    };
    /**
     * Styles the component based on the focused state.
     */ MDCTextFieldFoundation.prototype.styleFocused = function(isFocused) {
        var FOCUSED = MDCTextFieldFoundation.cssClasses.FOCUSED;
        if (isFocused) this.adapter.addClass(FOCUSED);
        else this.adapter.removeClass(FOCUSED);
    };
    /**
     * Styles the component based on the disabled state.
     */ MDCTextFieldFoundation.prototype.styleDisabled = function(isDisabled) {
        var _a = MDCTextFieldFoundation.cssClasses, DISABLED = _a.DISABLED, INVALID = _a.INVALID;
        if (isDisabled) {
            this.adapter.addClass(DISABLED);
            this.adapter.removeClass(INVALID);
        } else this.adapter.removeClass(DISABLED);
        if (this.leadingIcon) this.leadingIcon.setDisabled(isDisabled);
        if (this.trailingIcon) this.trailingIcon.setDisabled(isDisabled);
    };
    /**
     * Styles the component based on the label floating state.
     */ MDCTextFieldFoundation.prototype.styleFloating = function(isFloating) {
        var LABEL_FLOATING = MDCTextFieldFoundation.cssClasses.LABEL_FLOATING;
        if (isFloating) this.adapter.addClass(LABEL_FLOATING);
        else this.adapter.removeClass(LABEL_FLOATING);
    };
    /**
     * @return The native text input element from the host environment, or an
     *     object with the same shape for unit tests.
     */ MDCTextFieldFoundation.prototype.getNativeInput = function() {
        // this.adapter may be undefined in foundation unit tests. This happens when
        // testdouble is creating a mock object and invokes the
        // shouldShake/shouldFloat getters (which in turn call getValue(), which
        // calls this method) before init() has been called from the MDCTextField
        // constructor. To work around that issue, we return a dummy object.
        var nativeInput = this.adapter ? this.adapter.getNativeInput() : null;
        return nativeInput || {
            disabled: false,
            maxLength: -1,
            required: false,
            type: "input",
            validity: {
                badInput: false,
                valid: true
            },
            value: ""
        };
    };
    return MDCTextFieldFoundation;
}((0, $a9cf765391686086$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$ac2a49a094ff9847$export$2e2bcd8739ae039 = $ac2a49a094ff9847$export$e62c196cd9ca6c2c;






/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4b98a879c21ea1bd$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $e5ed8027d647799b$export$45b790e32b2810ee);







/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $ead5767561d7cbc1$var$l } = (0, $e5ed8027d647799b$export$8613d1ca9052b22e), $ead5767561d7cbc1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $ead5767561d7cbc1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $ead5767561d7cbc1$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $ead5767561d7cbc1$export$6a0e8de894d2fcca = (o)=>{
    var l;
    return null != (null === (l = null == o ? void 0 : o._$litType$) || void 0 === l ? void 0 : l.h);
}, $ead5767561d7cbc1$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $ead5767561d7cbc1$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $ead5767561d7cbc1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $ead5767561d7cbc1$var$r = ()=>document.createComment(""), $ead5767561d7cbc1$export$291b2338ad9b0b30 = (o, i, n)=>{
    var t;
    const v = o._$AA.parentNode, d = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = v.insertBefore($ead5767561d7cbc1$var$r(), d), t = v.insertBefore($ead5767561d7cbc1$var$r(), d);
        n = new $ead5767561d7cbc1$var$l(i, t, o, o.options);
    } else {
        const l = n._$AB.nextSibling, i = n._$AM, u = i !== o;
        if (u) {
            let l;
            null === (t = n._$AQ) || void 0 === t || t.call(n, o), n._$AM = o, void 0 !== n._$AP && (l = o._$AU) !== i._$AU && n._$AP(l);
        }
        if (l !== d || u) {
            let o = n._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                v.insertBefore(o, d), o = l;
            }
        }
    }
    return n;
}, $ead5767561d7cbc1$export$cb8bf9562088e9f4 = (o, l, i = o)=>(o._$AI(l, i), o), $ead5767561d7cbc1$var$s = {}, $ead5767561d7cbc1$export$ea70d9dd5965b1c8 = (o, l = $ead5767561d7cbc1$var$s)=>o._$AH = l, $ead5767561d7cbc1$export$59e9bce518cde500 = (o)=>o._$AH, $ead5767561d7cbc1$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let i = o._$AA;
    const n = o._$AB.nextSibling;
    for(; i !== n;){
        const o = i.nextSibling;
        i.remove(), i = o;
    }
}, $ead5767561d7cbc1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6bc1ca53c26af3e9$export$28cf49ad70f82d12 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $ead5767561d7cbc1$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $e5ed8027d647799b$export$9c068ae9cc5db4e8) || t === (0, $e5ed8027d647799b$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $3baabda811939da5$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $3baabda811939da5$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
        return (0, $ead5767561d7cbc1$export$ea70d9dd5965b1c8)(i), t;
    }
});




const $8eebe2980d3069f9$var$passiveEvents = [
    "touchstart",
    "touchmove",
    "scroll",
    "mousewheel"
];
const $8eebe2980d3069f9$var$createValidityObj = (customValidity = {})=>{
    /*
     * We need to make ValidityState an object because it is readonly and
     * we cannot use the spread operator. Also, we don't export
     * `CustomValidityState` because it is a leaky implementation and the user
     * already has access to `ValidityState` in lib.dom.ts. Also an interface
     * {a: Type} can be casted to {readonly a: Type} so passing any object
     * should be fine.
     */ const objectifiedCustomValidity = {};
    // eslint-disable-next-line guard-for-in
    for(const propName in customValidity)/*
         * Casting is needed because ValidityState's props are all readonly and
         * thus cannot be set on `onjectifiedCustomValidity`. In the end, the
         * interface is the same as ValidityState (but not readonly), but the
         * function signature casts the output to ValidityState (thus readonly).
         */ objectifiedCustomValidity[propName] = customValidity[propName];
    return Object.assign({
        badInput: false,
        customError: false,
        patternMismatch: false,
        rangeOverflow: false,
        rangeUnderflow: false,
        stepMismatch: false,
        tooLong: false,
        tooShort: false,
        typeMismatch: false,
        valid: true,
        valueMissing: false
    }, objectifiedCustomValidity);
};
class $8eebe2980d3069f9$export$d22444a338b6e3c2 extends (0, $362ad72c8b1dae7b$export$fcc7a416e8ecbf7a) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $ac2a49a094ff9847$export$2e2bcd8739ae039);
        this.value = "";
        this.type = "text";
        this.placeholder = "";
        this.label = "";
        this.icon = "";
        this.iconTrailing = "";
        this.disabled = false;
        this.required = false;
        this.minLength = -1;
        this.maxLength = -1;
        this.outlined = false;
        this.helper = "";
        this.validateOnInitialRender = false;
        this.validationMessage = "";
        this.autoValidate = false;
        this.pattern = "";
        this.min = "";
        this.max = "";
        /**
         * step can be a number or the keyword "any".
         *
         * Use `String` typing to pass down the value as a string and let the native
         * input cast internally as needed.
         */ this.step = null;
        this.size = null;
        this.helperPersistent = false;
        this.charCounter = false;
        this.endAligned = false;
        this.prefix = "";
        this.suffix = "";
        this.name = "";
        this.readOnly = false;
        this.autocapitalize = "";
        this.outlineOpen = false;
        this.outlineWidth = 0;
        this.isUiValid = true;
        this.focused = false;
        this._validity = $8eebe2980d3069f9$var$createValidityObj();
        this.validityTransform = null;
    }
    get validity() {
        this._checkValidity(this.value);
        return this._validity;
    }
    get willValidate() {
        return this.formElement.willValidate;
    }
    get selectionStart() {
        return this.formElement.selectionStart;
    }
    get selectionEnd() {
        return this.formElement.selectionEnd;
    }
    focus() {
        const focusEvt = new CustomEvent("focus");
        this.formElement.dispatchEvent(focusEvt);
        this.formElement.focus();
    }
    blur() {
        const blurEvt = new CustomEvent("blur");
        this.formElement.dispatchEvent(blurEvt);
        this.formElement.blur();
    }
    select() {
        this.formElement.select();
    }
    setSelectionRange(selectionStart, selectionEnd, selectionDirection) {
        this.formElement.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    update(changedProperties) {
        if (changedProperties.has("autoValidate") && this.mdcFoundation) this.mdcFoundation.setValidateOnValueChange(this.autoValidate);
        if (changedProperties.has("value") && typeof this.value !== "string") this.value = `${this.value}`;
        super.update(changedProperties);
    }
    setFormData(formData) {
        if (this.name) formData.append(this.name, this.value);
    }
    /** @soyTemplate */ render() {
        const shouldRenderCharCounter = this.charCounter && this.maxLength !== -1;
        const shouldRenderHelperText = !!this.helper || !!this.validationMessage || shouldRenderCharCounter;
        /** @classMap */ const classes = {
            "mdc-text-field--disabled": this.disabled,
            "mdc-text-field--no-label": !this.label,
            "mdc-text-field--filled": !this.outlined,
            "mdc-text-field--outlined": this.outlined,
            "mdc-text-field--with-leading-icon": this.icon,
            "mdc-text-field--with-trailing-icon": this.iconTrailing,
            "mdc-text-field--end-aligned": this.endAligned
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <label class="mdc-text-field ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        ${this.renderRipple()}
        ${this.outlined ? this.renderOutline() : this.renderLabel()}
        ${this.renderLeadingIcon()}
        ${this.renderPrefix()}
        ${this.renderInput(shouldRenderHelperText)}
        ${this.renderSuffix()}
        ${this.renderTrailingIcon()}
        ${this.renderLineRipple()}
      </label>
      ${this.renderHelperText(shouldRenderHelperText, shouldRenderCharCounter)}
    `;
    }
    updated(changedProperties) {
        if (changedProperties.has("value") && changedProperties.get("value") !== undefined) {
            this.mdcFoundation.setValue(this.value);
            if (this.autoValidate) this.reportValidity();
        }
    }
    /** @soyTemplate */ renderRipple() {
        return this.outlined ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-text-field__ripple"></span>
    `;
    }
    /** @soyTemplate */ renderOutline() {
        return !this.outlined ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-notched-outline
          .width=${this.outlineWidth}
          .open=${this.outlineOpen}
          class="mdc-notched-outline">
        ${this.renderLabel()}
      </mwc-notched-outline>`;
    }
    /** @soyTemplate */ renderLabel() {
        return !this.label ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span
          .floatingLabelFoundation=${(0, $08d6fdf9123f1e40$export$a5e5b5e75cfc3b36)(this.label)}
          id="label">${this.label}</span>
    `;
    }
    /** @soyTemplate */ renderLeadingIcon() {
        return this.icon ? this.renderIcon(this.icon) : "";
    }
    /** @soyTemplate */ renderTrailingIcon() {
        return this.iconTrailing ? this.renderIcon(this.iconTrailing, true) : "";
    }
    /** @soyTemplate */ renderIcon(icon, isTrailingIcon = false) {
        /** @classMap */ const classes = {
            "mdc-text-field__icon--leading": !isTrailingIcon,
            "mdc-text-field__icon--trailing": isTrailingIcon
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<i class="material-icons mdc-text-field__icon ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">${icon}</i>`;
    }
    /** @soyTemplate */ renderPrefix() {
        return this.prefix ? this.renderAffix(this.prefix) : "";
    }
    /** @soyTemplate */ renderSuffix() {
        return this.suffix ? this.renderAffix(this.suffix, true) : "";
    }
    /** @soyTemplate */ renderAffix(content, isSuffix = false) {
        /** @classMap */ const classes = {
            "mdc-text-field__affix--prefix": !isSuffix,
            "mdc-text-field__affix--suffix": isSuffix
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="mdc-text-field__affix ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        ${content}</span>`;
    }
    /** @soyTemplate */ renderInput(shouldRenderHelperText) {
        const minOrUndef = this.minLength === -1 ? undefined : this.minLength;
        const maxOrUndef = this.maxLength === -1 ? undefined : this.maxLength;
        const autocapitalizeOrUndef = this.autocapitalize ? this.autocapitalize : undefined;
        const showValidationMessage = this.validationMessage && !this.isUiValid;
        const ariaLabelledbyOrUndef = !!this.label ? "label" : undefined;
        const ariaControlsOrUndef = shouldRenderHelperText ? "helper-text" : undefined;
        const ariaDescribedbyOrUndef = this.focused || this.helperPersistent || showValidationMessage ? "helper-text" : undefined;
        // TODO: live() directive needs casting for lit-analyzer
        // https://github.com/runem/lit-analyzer/pull/91/files
        // TODO: lit-analyzer labels min/max as (number|string) instead of string
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <input
          aria-labelledby=${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaLabelledbyOrUndef)}
          aria-controls="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaControlsOrUndef)}"
          aria-describedby="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaDescribedbyOrUndef)}"
          class="mdc-text-field__input"
          type="${this.type}"
          .value="${(0, $6bc1ca53c26af3e9$export$28cf49ad70f82d12)(this.value)}"
          ?disabled="${this.disabled}"
          placeholder="${this.placeholder}"
          ?required="${this.required}"
          ?readonly="${this.readOnly}"
          minlength="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(minOrUndef)}"
          maxlength="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(maxOrUndef)}"
          pattern="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.pattern ? this.pattern : undefined)}"
          min="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.min === "" ? undefined : this.min)}"
          max="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.max === "" ? undefined : this.max)}"
          step="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.step === null ? undefined : this.step)}"
          size="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.size === null ? undefined : this.size)}"
          name="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.name === "" ? undefined : this.name)}"
          inputmode="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.inputMode)}"
          autocapitalize="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(autocapitalizeOrUndef)}"
          @input="${this.handleInputChange}"
          @focus="${this.onInputFocus}"
          @blur="${this.onInputBlur}">`;
    }
    /** @soyTemplate */ renderLineRipple() {
        return this.outlined ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span .lineRippleFoundation=${(0, $26dc552073ed1864$export$4e67d44fb59b80f2)()}></span>
    `;
    }
    /** @soyTemplate */ renderHelperText(shouldRenderHelperText, shouldRenderCharCounter) {
        const showValidationMessage = this.validationMessage && !this.isUiValid;
        /** @classMap */ const classes = {
            "mdc-text-field-helper-text--persistent": this.helperPersistent,
            "mdc-text-field-helper-text--validation-msg": showValidationMessage
        };
        const ariaHiddenOrUndef = this.focused || this.helperPersistent || showValidationMessage ? undefined : "true";
        const helperText = showValidationMessage ? this.validationMessage : this.helper;
        return !shouldRenderHelperText ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-text-field-helper-line">
        <div id="helper-text"
             aria-hidden="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaHiddenOrUndef)}"
             class="mdc-text-field-helper-text ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
             >${helperText}</div>
        ${this.renderCharCounter(shouldRenderCharCounter)}
      </div>`;
    }
    /** @soyTemplate */ renderCharCounter(shouldRenderCharCounter) {
        const length = Math.min(this.value.length, this.maxLength);
        return !shouldRenderCharCounter ? "" : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-text-field-character-counter"
            >${length} / ${this.maxLength}</span>`;
    }
    onInputFocus() {
        this.focused = true;
    }
    onInputBlur() {
        this.focused = false;
        this.reportValidity();
    }
    checkValidity() {
        const isValid = this._checkValidity(this.value);
        if (!isValid) {
            const invalidEvent = new Event("invalid", {
                bubbles: false,
                cancelable: true
            });
            this.dispatchEvent(invalidEvent);
        }
        return isValid;
    }
    reportValidity() {
        const isValid = this.checkValidity();
        this.mdcFoundation.setValid(isValid);
        this.isUiValid = isValid;
        return isValid;
    }
    _checkValidity(value) {
        const nativeValidity = this.formElement.validity;
        let validity = $8eebe2980d3069f9$var$createValidityObj(nativeValidity);
        if (this.validityTransform) {
            const customValidity = this.validityTransform(value, validity);
            validity = Object.assign(Object.assign({}, validity), customValidity);
            this.mdcFoundation.setUseNativeValidation(false);
        } else this.mdcFoundation.setUseNativeValidation(true);
        this._validity = validity;
        return this._validity.valid;
    }
    setCustomValidity(message) {
        this.validationMessage = message;
        this.formElement.setCustomValidity(message);
    }
    handleInputChange() {
        this.value = this.formElement.value;
    }
    createAdapter() {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.getRootAdapterMethods()), this.getInputAdapterMethods()), this.getLabelAdapterMethods()), this.getLineRippleAdapterMethods()), this.getOutlineAdapterMethods());
    }
    getRootAdapterMethods() {
        return Object.assign({
            registerTextFieldInteractionHandler: (evtType, handler)=>this.addEventListener(evtType, handler),
            deregisterTextFieldInteractionHandler: (evtType, handler)=>this.removeEventListener(evtType, handler),
            registerValidationAttributeChangeHandler: (handler)=>{
                const getAttributesList = (mutationsList)=>{
                    return mutationsList.map((mutation)=>mutation.attributeName).filter((attributeName)=>attributeName);
                };
                const observer = new MutationObserver((mutationsList)=>{
                    handler(getAttributesList(mutationsList));
                });
                const config = {
                    attributes: true
                };
                observer.observe(this.formElement, config);
                return observer;
            },
            deregisterValidationAttributeChangeHandler: (observer)=>observer.disconnect()
        }, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot));
    }
    getInputAdapterMethods() {
        return {
            getNativeInput: ()=>this.formElement,
            // since HelperTextFoundation is not used, aria-describedby a11y logic
            // is implemented in render method instead of these adapter methods
            setInputAttr: ()=>undefined,
            removeInputAttr: ()=>undefined,
            isFocused: ()=>this.shadowRoot ? this.shadowRoot.activeElement === this.formElement : false,
            registerInputInteractionHandler: (evtType, handler)=>this.formElement.addEventListener(evtType, handler, {
                    passive: evtType in $8eebe2980d3069f9$var$passiveEvents
                }),
            deregisterInputInteractionHandler: (evtType, handler)=>this.formElement.removeEventListener(evtType, handler)
        };
    }
    getLabelAdapterMethods() {
        return {
            floatLabel: (shouldFloat)=>this.labelElement && this.labelElement.floatingLabelFoundation.float(shouldFloat),
            getLabelWidth: ()=>{
                return this.labelElement ? this.labelElement.floatingLabelFoundation.getWidth() : 0;
            },
            hasLabel: ()=>Boolean(this.labelElement),
            shakeLabel: (shouldShake)=>this.labelElement && this.labelElement.floatingLabelFoundation.shake(shouldShake),
            setLabelRequired: (isRequired)=>{
                if (this.labelElement) this.labelElement.floatingLabelFoundation.setRequired(isRequired);
            }
        };
    }
    getLineRippleAdapterMethods() {
        return {
            activateLineRipple: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.activate();
            },
            deactivateLineRipple: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.deactivate();
            },
            setLineRippleTransformOrigin: (normalizedX)=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.setRippleCenter(normalizedX);
            }
        };
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        var _a;
        // @ts-ignore
        const result = await super.getUpdateComplete();
        await ((_a = this.outlineElement) === null || _a === void 0 ? void 0 : _a.updateComplete);
        return result;
    }
    // tslint:enable:ban-ts-ignore
    firstUpdated() {
        var _a;
        super.firstUpdated();
        this.mdcFoundation.setValidateOnValueChange(this.autoValidate);
        if (this.validateOnInitialRender) this.reportValidity();
        // wait for the outline element to render to update the notch width
        (_a = this.outlineElement) === null || _a === void 0 || _a.updateComplete.then(()=>{
            var _a;
            // `foundation.notchOutline()` assumes the label isn't floating and
            // multiplies by a constant, but the label is already is floating at this
            // stage, therefore directly set the outline width to the label width
            this.outlineWidth = ((_a = this.labelElement) === null || _a === void 0 ? void 0 : _a.floatingLabelFoundation.getWidth()) || 0;
        });
    }
    getOutlineAdapterMethods() {
        return {
            closeOutline: ()=>this.outlineElement && (this.outlineOpen = false),
            hasOutline: ()=>Boolean(this.outlineElement),
            notchOutline: (labelWidth)=>{
                const outlineElement = this.outlineElement;
                if (outlineElement && !this.outlineOpen) {
                    this.outlineWidth = labelWidth;
                    this.outlineOpen = true;
                }
            }
        };
    }
    async layout() {
        await this.updateComplete;
        const labelElement = this.labelElement;
        if (!labelElement) {
            this.outlineOpen = false;
            return;
        }
        const shouldFloat = !!this.label && !!this.value;
        labelElement.floatingLabelFoundation.float(shouldFloat);
        if (!this.outlined) return;
        this.outlineOpen = shouldFloat;
        await this.updateComplete;
        /* When the textfield automatically notches due to a value and label
         * being defined, the textfield may be set to `display: none` by the user.
         * this means that the notch is of size 0px. We provide this function so
         * that the user may manually resize the notch to the floated label's
         * width.
         */ const labelWidth = labelElement.floatingLabelFoundation.getWidth();
        if (this.outlineOpen) {
            this.outlineWidth = labelWidth;
            await this.updateComplete;
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-text-field")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("input")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "formElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-floating-label")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "labelElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-line-ripple")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "lineRippleElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("mwc-notched-outline")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "outlineElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-notched-outline__notch")
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "notchElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "placeholder", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.label !== oldVal) this.layout();
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "icon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "iconTrailing", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "minLength", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "maxLength", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.outlined !== oldVal) this.layout();
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "outlined", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "helper", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "validateOnInitialRender", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "validationMessage", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "autoValidate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "pattern", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "min", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "max", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "step", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "size", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "helperPersistent", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "charCounter", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "endAligned", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "prefix", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "suffix", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "name", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "inputMode", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "readOnly", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "autocapitalize", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "outlineOpen", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "outlineWidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "isUiValid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "focused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        passive: true
    })
], $8eebe2980d3069f9$export$d22444a338b6e3c2.prototype, "handleInputChange", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $844c87dc56c5a86a$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-floating-label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);position:absolute;left:0;-webkit-transform-origin:left top;transform-origin:left top;line-height:1.15rem;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;will-change:transform;transition:transform 150ms cubic-bezier(0.4, 0, 0.2, 1),color 150ms cubic-bezier(0.4, 0, 0.2, 1)}[dir=rtl] .mdc-floating-label,.mdc-floating-label[dir=rtl]{right:0;left:auto;-webkit-transform-origin:right top;transform-origin:right top;text-align:right}.mdc-floating-label--float-above{cursor:auto}.mdc-floating-label--required::after{margin-left:1px;margin-right:0px;content:"*"}[dir=rtl] .mdc-floating-label--required::after,.mdc-floating-label--required[dir=rtl]::after{margin-left:0;margin-right:1px}.mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-standard 250ms 1}@keyframes mdc-floating-label-shake-float-above-standard{0%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-106%) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-106%) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}}.mdc-line-ripple::before,.mdc-line-ripple::after{position:absolute;bottom:0;left:0;width:100%;border-bottom-style:solid;content:""}.mdc-line-ripple::before{border-bottom-width:1px}.mdc-line-ripple::before{z-index:1}.mdc-line-ripple::after{transform:scaleX(0);border-bottom-width:2px;opacity:0;z-index:2}.mdc-line-ripple::after{transition:transform 180ms cubic-bezier(0.4, 0, 0.2, 1),opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-line-ripple--active::after{transform:scaleX(1);opacity:1}.mdc-line-ripple--deactivating::after{opacity:0}.mdc-notched-outline{display:flex;position:absolute;top:0;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;height:100%;border-top:1px solid;border-bottom:1px solid;pointer-events:none}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:0 0 auto;width:auto;max-width:calc(100% - 12px * 2)}.mdc-notched-outline .mdc-floating-label{display:inline-block;position:relative;max-width:100%}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:calc(100% / 0.75)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-left:0;padding-right:8px;border-top:none}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}.mdc-text-field--filled{--mdc-ripple-fg-size: 0;--mdc-ripple-left: 0;--mdc-ripple-top: 0;--mdc-ripple-fg-scale: 1;--mdc-ripple-fg-translate-end: 0;--mdc-ripple-fg-translate-start: 0;-webkit-tap-highlight-color:rgba(0,0,0,0);will-change:transform,opacity}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{position:absolute;border-radius:50%;opacity:0;pointer-events:none;content:""}.mdc-text-field--filled .mdc-text-field__ripple::before{transition:opacity 15ms linear,background-color 15ms linear;z-index:1;z-index:var(--mdc-ripple-z-index, 1)}.mdc-text-field--filled .mdc-text-field__ripple::after{z-index:0;z-index:var(--mdc-ripple-z-index, 0)}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::before{transform:scale(var(--mdc-ripple-fg-scale, 1))}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::after{top:0;left:0;transform:scale(0);transform-origin:center center}.mdc-text-field--filled.mdc-ripple-upgraded--unbounded .mdc-text-field__ripple::after{top:var(--mdc-ripple-top, 0);left:var(--mdc-ripple-left, 0)}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-activation .mdc-text-field__ripple::after{animation:mdc-ripple-fg-radius-in 225ms forwards,mdc-ripple-fg-opacity-in 75ms forwards}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-deactivation .mdc-text-field__ripple::after{animation:mdc-ripple-fg-opacity-out 150ms;transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{top:calc(50% - 100%);left:calc(50% - 100%);width:200%;height:200%}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-text-field__ripple{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.mdc-text-field{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:0;border-bottom-left-radius:0;display:inline-flex;align-items:baseline;padding:0 16px;position:relative;box-sizing:border-box;overflow:hidden;will-change:opacity,transform,color}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:rgba(0, 0, 0, 0.87)}@media all{.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input::placeholder{color:rgba(0, 0, 0, 0.54)}}@media all{.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input:-ms-input-placeholder{color:rgba(0, 0, 0, 0.54)}}.mdc-text-field .mdc-text-field__input{caret-color:#6200ee;caret-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field-character-counter,.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--leading{color:rgba(0, 0, 0, 0.54)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:rgba(0, 0, 0, 0.54)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--prefix{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--suffix{color:rgba(0, 0, 0, 0.6)}.mdc-text-field .mdc-floating-label{top:50%;transform:translateY(-50%);pointer-events:none}.mdc-text-field__input{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);height:28px;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);width:100%;min-width:0;border:none;border-radius:0;background:none;appearance:none;padding:0}.mdc-text-field__input::-ms-clear{display:none}.mdc-text-field__input::-webkit-calendar-picker-indicator{display:none}.mdc-text-field__input:focus{outline:none}.mdc-text-field__input:invalid{box-shadow:none}@media all{.mdc-text-field__input::placeholder{transition:opacity 67ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}}@media all{.mdc-text-field__input:-ms-input-placeholder{transition:opacity 67ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}}@media all{.mdc-text-field--no-label .mdc-text-field__input::placeholder,.mdc-text-field--focused .mdc-text-field__input::placeholder{transition-delay:40ms;transition-duration:110ms;opacity:1}}@media all{.mdc-text-field--no-label .mdc-text-field__input:-ms-input-placeholder,.mdc-text-field--focused .mdc-text-field__input:-ms-input-placeholder{transition-delay:40ms;transition-duration:110ms;opacity:1}}.mdc-text-field__affix{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);height:28px;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0;white-space:nowrap}.mdc-text-field--label-floating .mdc-text-field__affix,.mdc-text-field--no-label .mdc-text-field__affix{opacity:1}@supports(-webkit-hyphens: none){.mdc-text-field--outlined .mdc-text-field__affix{align-items:center;align-self:center;display:inline-flex;height:100%}}.mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field__affix--prefix,.mdc-text-field__affix--prefix[dir=rtl]{padding-left:2px;padding-right:0}.mdc-text-field--end-aligned .mdc-text-field__affix--prefix{padding-left:0;padding-right:12px}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--end-aligned .mdc-text-field__affix--prefix[dir=rtl]{padding-left:12px;padding-right:0}.mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field__affix--suffix,.mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:12px}.mdc-text-field--end-aligned .mdc-text-field__affix--suffix{padding-left:2px;padding-right:0}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--end-aligned .mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:2px}.mdc-text-field--filled{height:56px}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-text-field--filled:hover .mdc-text-field__ripple::before,.mdc-text-field--filled.mdc-ripple-surface--hover .mdc-text-field__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-text-field--filled.mdc-ripple-upgraded--background-focused .mdc-text-field__ripple::before,.mdc-text-field--filled:not(.mdc-ripple-upgraded):focus .mdc-text-field__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-text-field--filled::before{display:inline-block;width:0;height:40px;content:"";vertical-align:0}.mdc-text-field--filled:not(.mdc-text-field--disabled){background-color:whitesmoke}.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42)}.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87)}.mdc-text-field--filled .mdc-line-ripple::after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-text-field--filled .mdc-floating-label,.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{height:100%}.mdc-text-field--filled.mdc-text-field--no-label .mdc-floating-label{display:none}.mdc-text-field--filled.mdc-text-field--no-label::before{display:none}@supports(-webkit-hyphens: none){.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__affix{align-items:center;align-self:center;display:inline-flex;height:100%}}.mdc-text-field--outlined{height:56px;overflow:visible}.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px) scale(1)}.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) scale(0.75)}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined{0%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}}.mdc-text-field--outlined .mdc-text-field__input{height:100%}.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.38)}.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.87)}.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#6200ee;border-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}@supports(top: max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px, var(--mdc-shape-small, 4px)) * 2)}}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}@supports(top: max(0%)){.mdc-text-field--outlined{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined{padding-right:max(16px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-right:max(16px, var(--mdc-shape-small, 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-left:0}@supports(top: max(0%)){.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-right:max(16px, var(--mdc-shape-small, 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-right:0}@supports(top: max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:max(16px, var(--mdc-shape-small, 4px))}}.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-right:0}@supports(top: max(0%)){.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0}@supports(top: max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-right:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-text-field--outlined .mdc-text-field__ripple::before,.mdc-text-field--outlined .mdc-text-field__ripple::after{background-color:transparent;background-color:var(--mdc-ripple-color, transparent)}.mdc-text-field--outlined .mdc-floating-label{left:4px;right:initial}[dir=rtl] .mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-text-field--outlined .mdc-text-field__input{display:flex;border:none !important;background-color:transparent}.mdc-text-field--outlined .mdc-notched-outline{z-index:1}.mdc-text-field--textarea{flex-direction:column;align-items:center;width:auto;height:auto;padding:0;transition:none}.mdc-text-field--textarea .mdc-floating-label{top:19px}.mdc-text-field--textarea .mdc-floating-label:not(.mdc-floating-label--float-above){transform:none}.mdc-text-field--textarea .mdc-text-field__input{flex-grow:1;height:auto;min-height:1.5rem;overflow-x:hidden;overflow-y:auto;box-sizing:border-box;resize:none;padding:0 16px;line-height:1.5rem}.mdc-text-field--textarea.mdc-text-field--filled::before{display:none}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-10.25px) scale(0.75)}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-textarea-filled 250ms 1}@keyframes mdc-floating-label-shake-float-above-textarea-filled{0%{transform:translateX(calc(0 - 0%)) translateY(-10.25px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-10.25px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-10.25px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-10.25px) scale(0.75)}}.mdc-text-field--textarea.mdc-text-field--filled .mdc-text-field__input{margin-top:23px;margin-bottom:9px}.mdc-text-field--textarea.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-textarea-outlined 250ms 1}@keyframes mdc-floating-label-shake-float-above-textarea-outlined{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label{top:18px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field__input{margin-bottom:2px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter{align-self:flex-end;padding:0 16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter::after{display:inline-block;width:0;height:16px;content:"";vertical-align:-16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter::before{display:none}.mdc-text-field__resizer{align-self:stretch;display:inline-flex;flex-direction:column;flex-grow:1;max-height:100%;max-width:100%;min-height:56px;min-width:fit-content;min-width:-moz-available;min-width:-webkit-fill-available;overflow:hidden;resize:both}.mdc-text-field--filled .mdc-text-field__resizer{transform:translateY(-1px)}.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateY(1px)}.mdc-text-field--outlined .mdc-text-field__resizer{transform:translateX(-1px) translateY(-1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer,.mdc-text-field--outlined .mdc-text-field__resizer[dir=rtl]{transform:translateX(1px) translateY(-1px)}.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateX(1px) translateY(1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input[dir=rtl],.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter[dir=rtl]{transform:translateX(-1px) translateY(1px)}.mdc-text-field--with-leading-icon{padding-left:0;padding-right:16px}[dir=rtl] .mdc-text-field--with-leading-icon,.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:16px;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 48px);left:48px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 64px / 0.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-text-field--with-leading-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px) translateX(-32px) scale(1)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px) translateX(32px) scale(1)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) translateX(-32px) scale(0.75)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px) translateX(32px) scale(0.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined-leading-icon 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon{0%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake,.mdc-text-field--with-leading-icon.mdc-text-field--outlined[dir=rtl] .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined-leading-icon 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon-rtl{0%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - -32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - -32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}}.mdc-text-field--with-trailing-icon{padding-left:16px;padding-right:0}[dir=rtl] .mdc-text-field--with-trailing-icon,.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 64px / 0.75)}.mdc-text-field--with-trailing-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 96px / 0.75)}.mdc-text-field-helper-line{display:flex;justify-content:space-between;box-sizing:border-box}.mdc-text-field+.mdc-text-field-helper-line{padding-right:16px;padding-left:16px}.mdc-form-field>.mdc-text-field+label{align-self:flex-start}.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:rgba(98, 0, 238, 0.87)}.mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--focused .mdc-notched-outline__trailing{border-width:2px}.mdc-text-field--focused+.mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg){opacity:1}.mdc-text-field--focused.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-text-field--focused.mdc-text-field--outlined.mdc-text-field--textarea .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid .mdc-text-field__input{caret-color:#b00020;caret-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1}.mdc-text-field--disabled{pointer-events:none}.mdc-text-field--disabled .mdc-text-field__input{color:rgba(0, 0, 0, 0.38)}@media all{.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:rgba(0, 0, 0, 0.38)}}@media all{.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:rgba(0, 0, 0, 0.38)}}.mdc-text-field--disabled .mdc-floating-label{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field__icon--leading{color:rgba(0, 0, 0, 0.3)}.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:rgba(0, 0, 0, 0.3)}.mdc-text-field--disabled .mdc-text-field__affix--prefix{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.06)}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.06)}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-floating-label{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__icon--leading{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__affix--prefix{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:GrayText}}@media screen and (forced-colors: active){.mdc-text-field--disabled .mdc-text-field__input{background-color:Window}.mdc-text-field--disabled .mdc-floating-label{z-index:1}}.mdc-text-field--disabled .mdc-floating-label{cursor:default}.mdc-text-field--disabled.mdc-text-field--filled{background-color:#fafafa}.mdc-text-field--disabled.mdc-text-field--filled .mdc-text-field__ripple{display:none}.mdc-text-field--disabled .mdc-text-field__input{pointer-events:auto}.mdc-text-field--end-aligned .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--end-aligned .mdc-text-field__input[dir=rtl]{text-align:left}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix{direction:ltr}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--leading,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--leading{order:1}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{order:2}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input{order:3}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{order:4}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--trailing,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--trailing{order:5}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--prefix{padding-right:12px}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--suffix{padding-left:2px}.mdc-text-field-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin:0;opacity:0;will-change:opacity;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-text-field-helper-text::before{display:inline-block;width:0;height:16px;content:"";vertical-align:0}.mdc-text-field-helper-text--persistent{transition:none;opacity:1;will-change:initial}.mdc-text-field-character-counter{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin-left:auto;margin-right:0;padding-left:16px;padding-right:0;white-space:nowrap}.mdc-text-field-character-counter::before{display:inline-block;width:0;height:16px;content:"";vertical-align:0}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{margin-left:0;margin-right:auto}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field__icon{align-self:center;cursor:pointer}.mdc-text-field__icon:not([tabindex]),.mdc-text-field__icon[tabindex="-1"]{cursor:default;pointer-events:none}.mdc-text-field__icon svg{display:block}.mdc-text-field__icon--leading{margin-left:16px;margin-right:8px}[dir=rtl] .mdc-text-field__icon--leading,.mdc-text-field__icon--leading[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-text-field__icon--trailing{padding:12px;margin-left:0px;margin-right:0px}[dir=rtl] .mdc-text-field__icon--trailing,.mdc-text-field__icon--trailing[dir=rtl]{margin-left:0px;margin-right:0px}.material-icons{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}:host{display:inline-flex;flex-direction:column;outline:none}.mdc-text-field{width:100%}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42);border-bottom-color:var(--mdc-text-field-idle-line-color, rgba(0, 0, 0, 0.42))}.mdc-text-field:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87);border-bottom-color:var(--mdc-text-field-hover-line-color, rgba(0, 0, 0, 0.87))}.mdc-text-field.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.06);border-bottom-color:var(--mdc-text-field-disabled-line-color, rgba(0, 0, 0, 0.06))}.mdc-text-field.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field__input{direction:inherit}mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-idle-border-color, rgba(0, 0, 0, 0.38) )}:host(:not([disabled]):hover) :not(.mdc-text-field--invalid):not(.mdc-text-field--focused) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-hover-border-color, rgba(0, 0, 0, 0.87) )}:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--outlined){background-color:var(--mdc-text-field-fill-color, whitesmoke)}:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-error-color, var(--mdc-theme-error, #b00020) )}:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-character-counter,:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid .mdc-text-field__icon{color:var(--mdc-text-field-error-color, var(--mdc-theme-error, #b00020))}:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label,:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label::after{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused mwc-notched-outline{--mdc-notched-outline-stroke-width: 2px}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused:not(.mdc-text-field--invalid) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-focused-label-color, var(--mdc-theme-primary, rgba(98, 0, 238, 0.87)) )}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused:not(.mdc-text-field--invalid) .mdc-floating-label{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host(:not([disabled])) .mdc-text-field .mdc-text-field__input{color:var(--mdc-text-field-ink-color, rgba(0, 0, 0, 0.87))}:host(:not([disabled])) .mdc-text-field .mdc-text-field__input::placeholder{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host(:not([disabled])) .mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg),:host(:not([disabled])) .mdc-text-field-helper-line:not(.mdc-text-field--invalid) .mdc-text-field-character-counter{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host([disabled]) .mdc-text-field:not(.mdc-text-field--outlined){background-color:var(--mdc-text-field-disabled-fill-color, #fafafa)}:host([disabled]) .mdc-text-field.mdc-text-field--outlined mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-disabled-border-color, rgba(0, 0, 0, 0.06) )}:host([disabled]) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label,:host([disabled]) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label::after{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-text-field .mdc-text-field__input,:host([disabled]) .mdc-text-field .mdc-text-field__input::placeholder{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-text-field-helper-line .mdc-text-field-helper-text,:host([disabled]) .mdc-text-field-helper-line .mdc-text-field-character-counter{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}`;


/** @soyCompatible */ let $4ea12a03d79db760$export$2c73285ae9390cec = class TextField extends (0, $8eebe2980d3069f9$export$d22444a338b6e3c2) {
};
$4ea12a03d79db760$export$2c73285ae9390cec.styles = [
    (0, $844c87dc56c5a86a$export$9dd6ff9ea0189349)
];
$4ea12a03d79db760$export$2c73285ae9390cec = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-textfield")
], $4ea12a03d79db760$export$2c73285ae9390cec);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $341147c7793799e5$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}`;


/** @soyCompatible */ let $4fecd6bb6c52b1cf$export$f04a61298a47a40f = class Icon extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    /** @soyTemplate */ render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span><slot></slot></span>`;
    }
};
$4fecd6bb6c52b1cf$export$f04a61298a47a40f.styles = [
    (0, $341147c7793799e5$export$9dd6ff9ea0189349)
];
$4fecd6bb6c52b1cf$export$f04a61298a47a40f = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-icon")
], $4fecd6bb6c52b1cf$export$f04a61298a47a40f);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function $09b12e35f3b142e5$export$ff7f7c97cdce86e(element, selector) {
    if (element.closest) return element.closest(selector);
    var el = element;
    while(el){
        if ($09b12e35f3b142e5$export$de994efd351b291c(el, selector)) return el;
        el = el.parentElement;
    }
    return null;
}
function $09b12e35f3b142e5$export$de994efd351b291c(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
}
function $09b12e35f3b142e5$export$30f5493effae393e(element) {
    // Check the offsetParent. If the element inherits display: none from any
    // parent, the offsetParent property will be null (see
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
    // This check ensures we only clone the node when necessary.
    var htmlEl = element;
    if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
    var clone = htmlEl.cloneNode(true);
    clone.style.setProperty("position", "absolute");
    clone.style.setProperty("transform", "translate(-9999px, -9999px)");
    document.documentElement.appendChild(clone);
    var scrollWidth = clone.scrollWidth;
    document.documentElement.removeChild(clone);
    return scrollWidth;
}



/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $b5b299dc1af8fe16$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$b5b299dc1af8fe16$export$2e2bcd8739ae039 = $b5b299dc1af8fe16$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $20ea23f247cc2de7$export$c1c0562ec8379000 = {
    // Ripple is a special case where the "root" component is really a "mixin" of sorts,
    // given that it's an 'upgrade' to an existing component. That being said it is the root
    // CSS class that all other CSS classes derive from.
    BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
    FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
    FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
    ROOT: "mdc-ripple-upgraded",
    UNBOUNDED: "mdc-ripple-upgraded--unbounded"
};
var $20ea23f247cc2de7$export$21c51bc433c16634 = {
    VAR_FG_SCALE: "--mdc-ripple-fg-scale",
    VAR_FG_SIZE: "--mdc-ripple-fg-size",
    VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
    VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
    VAR_LEFT: "--mdc-ripple-left",
    VAR_TOP: "--mdc-ripple-top"
};
var $20ea23f247cc2de7$export$1f6c9cc012ebacae = {
    DEACTIVATION_TIMEOUT_MS: 225,
    FG_DEACTIVATION_MS: 150,
    INITIAL_ORIGIN_SCALE: 0.6,
    PADDING: 10,
    TAP_DELAY_MS: 300
};


/**
 * Stores result from supportsCssVariables to avoid redundant processing to
 * detect CSS custom variable support.
 */ var $ccc9c1108f34c0cf$var$supportsCssVariables_;
function $ccc9c1108f34c0cf$export$599ecc0c8c1caa3e(windowObj, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    var CSS = windowObj.CSS;
    var supportsCssVars = $ccc9c1108f34c0cf$var$supportsCssVariables_;
    if (typeof $ccc9c1108f34c0cf$var$supportsCssVariables_ === "boolean" && !forceRefresh) return $ccc9c1108f34c0cf$var$supportsCssVariables_;
    var supportsFunctionPresent = CSS && typeof CSS.supports === "function";
    if (!supportsFunctionPresent) return false;
    var explicitlySupportsCssVars = CSS.supports("--css-vars", "yes");
    // See: https://bugs.webkit.org/show_bug.cgi?id=154669
    // See: README section on Safari
    var weAreFeatureDetectingSafari10plus = CSS.supports("(--css-vars: yes)") && CSS.supports("color", "#00000000");
    supportsCssVars = explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
    if (!forceRefresh) $ccc9c1108f34c0cf$var$supportsCssVariables_ = supportsCssVars;
    return supportsCssVars;
}
function $ccc9c1108f34c0cf$export$82f3563636a128ae(evt, pageOffset, clientRect) {
    if (!evt) return {
        x: 0,
        y: 0
    };
    var x = pageOffset.x, y = pageOffset.y;
    var documentX = x + clientRect.left;
    var documentY = y + clientRect.top;
    var normalizedX;
    var normalizedY;
    // Determine touch point relative to the ripple container.
    if (evt.type === "touchstart") {
        var touchEvent = evt;
        normalizedX = touchEvent.changedTouches[0].pageX - documentX;
        normalizedY = touchEvent.changedTouches[0].pageY - documentY;
    } else {
        var mouseEvent = evt;
        normalizedX = mouseEvent.pageX - documentX;
        normalizedY = mouseEvent.pageY - documentY;
    }
    return {
        x: normalizedX,
        y: normalizedY
    };
}


// Activation events registered on the root element of each instance for activation
var $7f8c91387bb64e48$var$ACTIVATION_EVENT_TYPES = [
    "touchstart",
    "pointerdown",
    "mousedown",
    "keydown"
];
// Deactivation events registered on documentElement when a pointer-related down event occurs
var $7f8c91387bb64e48$var$POINTER_DEACTIVATION_EVENT_TYPES = [
    "touchend",
    "pointerup",
    "mouseup",
    "contextmenu"
];
// simultaneous nested activations
var $7f8c91387bb64e48$var$activatedTargets = [];
var $7f8c91387bb64e48$export$fb5f028029d92ef5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCRippleFoundation, _super);
    function MDCRippleFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
        _this.activationAnimationHasEnded = false;
        _this.activationTimer = 0;
        _this.fgDeactivationRemovalTimer = 0;
        _this.fgScale = "0";
        _this.frame = {
            width: 0,
            height: 0
        };
        _this.initialSize = 0;
        _this.layoutFrame = 0;
        _this.maxRadius = 0;
        _this.unboundedCoords = {
            left: 0,
            top: 0
        };
        _this.activationState = _this.defaultActivationState();
        _this.activationTimerCallback = function() {
            _this.activationAnimationHasEnded = true;
            _this.runDeactivationUXLogicIfReady();
        };
        _this.activateHandler = function(e) {
            _this.activateImpl(e);
        };
        _this.deactivateHandler = function() {
            _this.deactivateImpl();
        };
        _this.focusHandler = function() {
            _this.handleFocus();
        };
        _this.blurHandler = function() {
            _this.handleBlur();
        };
        _this.resizeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCRippleFoundation, "cssClasses", {
        get: function() {
            return 0, $20ea23f247cc2de7$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "strings", {
        get: function() {
            return 0, $20ea23f247cc2de7$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "numbers", {
        get: function() {
            return 0, $20ea23f247cc2de7$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                browserSupportsCssVars: function() {
                    return true;
                },
                computeBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                containsEventTarget: function() {
                    return true;
                },
                deregisterDocumentInteractionHandler: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                },
                deregisterResizeHandler: function() {
                    return undefined;
                },
                getWindowPageOffset: function() {
                    return {
                        x: 0,
                        y: 0
                    };
                },
                isSurfaceActive: function() {
                    return true;
                },
                isSurfaceDisabled: function() {
                    return true;
                },
                isUnbounded: function() {
                    return true;
                },
                registerDocumentInteractionHandler: function() {
                    return undefined;
                },
                registerInteractionHandler: function() {
                    return undefined;
                },
                registerResizeHandler: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                updateCssVariable: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCRippleFoundation.prototype.init = function() {
        var _this = this;
        var supportsPressRipple = this.supportsPressRipple();
        this.registerRootHandlers(supportsPressRipple);
        if (supportsPressRipple) {
            var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.addClass(ROOT_1);
                if (_this.adapter.isUnbounded()) {
                    _this.adapter.addClass(UNBOUNDED_1);
                    // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                    _this.layoutInternal();
                }
            });
        }
    };
    MDCRippleFoundation.prototype.destroy = function() {
        var _this = this;
        if (this.supportsPressRipple()) {
            if (this.activationTimer) {
                clearTimeout(this.activationTimer);
                this.activationTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
            }
            if (this.fgDeactivationRemovalTimer) {
                clearTimeout(this.fgDeactivationRemovalTimer);
                this.fgDeactivationRemovalTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
            }
            var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.removeClass(ROOT_2);
                _this.adapter.removeClass(UNBOUNDED_2);
                _this.removeCssVars();
            });
        }
        this.deregisterRootHandlers();
        this.deregisterDeactivationHandlers();
    };
    /**
     * @param evt Optional event containing position information.
     */ MDCRippleFoundation.prototype.activate = function(evt) {
        this.activateImpl(evt);
    };
    MDCRippleFoundation.prototype.deactivate = function() {
        this.deactivateImpl();
    };
    MDCRippleFoundation.prototype.layout = function() {
        var _this = this;
        if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(function() {
            _this.layoutInternal();
            _this.layoutFrame = 0;
        });
    };
    MDCRippleFoundation.prototype.setUnbounded = function(unbounded) {
        var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
        if (unbounded) this.adapter.addClass(UNBOUNDED);
        else this.adapter.removeClass(UNBOUNDED);
    };
    MDCRippleFoundation.prototype.handleFocus = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    MDCRippleFoundation.prototype.handleBlur = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     */ MDCRippleFoundation.prototype.supportsPressRipple = function() {
        return this.adapter.browserSupportsCssVars();
    };
    MDCRippleFoundation.prototype.defaultActivationState = function() {
        return {
            activationEvent: undefined,
            hasDeactivationUXRun: false,
            isActivated: false,
            isProgrammatic: false,
            wasActivatedByPointer: false,
            wasElementMadeActive: false
        };
    };
    /**
     * supportsPressRipple Passed from init to save a redundant function call
     */ MDCRippleFoundation.prototype.registerRootHandlers = function(supportsPressRipple) {
        var e_1, _a;
        if (supportsPressRipple) {
            try {
                for(var ACTIVATION_EVENT_TYPES_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7f8c91387bb64e48$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next(); !ACTIVATION_EVENT_TYPES_1_1.done; ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next()){
                    var evtType = ACTIVATION_EVENT_TYPES_1_1.value;
                    this.adapter.registerInteractionHandler(evtType, this.activateHandler);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (ACTIVATION_EVENT_TYPES_1_1 && !ACTIVATION_EVENT_TYPES_1_1.done && (_a = ACTIVATION_EVENT_TYPES_1.return)) _a.call(ACTIVATION_EVENT_TYPES_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (this.adapter.isUnbounded()) this.adapter.registerResizeHandler(this.resizeHandler);
        }
        this.adapter.registerInteractionHandler("focus", this.focusHandler);
        this.adapter.registerInteractionHandler("blur", this.blurHandler);
    };
    MDCRippleFoundation.prototype.registerDeactivationHandlers = function(evt) {
        var e_2, _a;
        if (evt.type === "keydown") this.adapter.registerInteractionHandler("keyup", this.deactivateHandler);
        else try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7f8c91387bb64e48$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next(); !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done; POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_1_1.value;
                this.adapter.registerDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_1_1 && !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_1.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MDCRippleFoundation.prototype.deregisterRootHandlers = function() {
        var e_3, _a;
        try {
            for(var ACTIVATION_EVENT_TYPES_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7f8c91387bb64e48$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next(); !ACTIVATION_EVENT_TYPES_2_1.done; ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next()){
                var evtType = ACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterInteractionHandler(evtType, this.activateHandler);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (ACTIVATION_EVENT_TYPES_2_1 && !ACTIVATION_EVENT_TYPES_2_1.done && (_a = ACTIVATION_EVENT_TYPES_2.return)) _a.call(ACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        this.adapter.deregisterInteractionHandler("focus", this.focusHandler);
        this.adapter.deregisterInteractionHandler("blur", this.blurHandler);
        if (this.adapter.isUnbounded()) this.adapter.deregisterResizeHandler(this.resizeHandler);
    };
    MDCRippleFoundation.prototype.deregisterDeactivationHandlers = function() {
        var e_4, _a;
        this.adapter.deregisterInteractionHandler("keyup", this.deactivateHandler);
        try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7f8c91387bb64e48$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next(); !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done; POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_2_1 && !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_2.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
    };
    MDCRippleFoundation.prototype.removeCssVars = function() {
        var _this = this;
        var rippleStrings = MDCRippleFoundation.strings;
        var keys = Object.keys(rippleStrings);
        keys.forEach(function(key) {
            if (key.indexOf("VAR_") === 0) _this.adapter.updateCssVariable(rippleStrings[key], null);
        });
    };
    MDCRippleFoundation.prototype.activateImpl = function(evt) {
        var _this = this;
        if (this.adapter.isSurfaceDisabled()) return;
        var activationState = this.activationState;
        if (activationState.isActivated) return;
        // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
        var previousActivationEvent = this.previousActivationEvent;
        var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
        if (isSameInteraction) return;
        activationState.isActivated = true;
        activationState.isProgrammatic = evt === undefined;
        activationState.activationEvent = evt;
        activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === "mousedown" || evt.type === "touchstart" || evt.type === "pointerdown");
        var hasActivatedChild = evt !== undefined && $7f8c91387bb64e48$var$activatedTargets.length > 0 && $7f8c91387bb64e48$var$activatedTargets.some(function(target) {
            return _this.adapter.containsEventTarget(target);
        });
        if (hasActivatedChild) {
            // Immediately reset activation state, while preserving logic that prevents touch follow-on events
            this.resetActivationState();
            return;
        }
        if (evt !== undefined) {
            $7f8c91387bb64e48$var$activatedTargets.push(evt.target);
            this.registerDeactivationHandlers(evt);
        }
        activationState.wasElementMadeActive = this.checkElementMadeActive(evt);
        if (activationState.wasElementMadeActive) this.animateActivation();
        requestAnimationFrame(function() {
            // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
            $7f8c91387bb64e48$var$activatedTargets = [];
            if (!activationState.wasElementMadeActive && evt !== undefined && (evt.key === " " || evt.keyCode === 32)) {
                // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                // active states inconsistently when they're called within event handling code:
                // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                // variable is set within a rAF callback for a submit button interaction (#2241).
                activationState.wasElementMadeActive = _this.checkElementMadeActive(evt);
                if (activationState.wasElementMadeActive) _this.animateActivation();
            }
            if (!activationState.wasElementMadeActive) // Reset activation state immediately if element was not made active.
            _this.activationState = _this.defaultActivationState();
        });
    };
    MDCRippleFoundation.prototype.checkElementMadeActive = function(evt) {
        return evt !== undefined && evt.type === "keydown" ? this.adapter.isSurfaceActive() : true;
    };
    MDCRippleFoundation.prototype.animateActivation = function() {
        var _this = this;
        var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
        var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
        var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
        this.layoutInternal();
        var translateStart = "";
        var translateEnd = "";
        if (!this.adapter.isUnbounded()) {
            var _c = this.getFgTranslationCoordinates(), startPoint = _c.startPoint, endPoint = _c.endPoint;
            translateStart = startPoint.x + "px, " + startPoint.y + "px";
            translateEnd = endPoint.x + "px, " + endPoint.y + "px";
        }
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
        // Cancel any ongoing activation/deactivation animations
        clearTimeout(this.activationTimer);
        clearTimeout(this.fgDeactivationRemovalTimer);
        this.rmBoundedActivationClasses();
        this.adapter.removeClass(FG_DEACTIVATION);
        // Force layout in order to re-trigger the animation.
        this.adapter.computeBoundingRect();
        this.adapter.addClass(FG_ACTIVATION);
        this.activationTimer = setTimeout(function() {
            _this.activationTimerCallback();
        }, DEACTIVATION_TIMEOUT_MS);
    };
    MDCRippleFoundation.prototype.getFgTranslationCoordinates = function() {
        var _a = this.activationState, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
        var startPoint;
        if (wasActivatedByPointer) startPoint = (0, $ccc9c1108f34c0cf$export$82f3563636a128ae)(activationEvent, this.adapter.getWindowPageOffset(), this.adapter.computeBoundingRect());
        else startPoint = {
            x: this.frame.width / 2,
            y: this.frame.height / 2
        };
        // Center the element around the start point.
        startPoint = {
            x: startPoint.x - this.initialSize / 2,
            y: startPoint.y - this.initialSize / 2
        };
        var endPoint = {
            x: this.frame.width / 2 - this.initialSize / 2,
            y: this.frame.height / 2 - this.initialSize / 2
        };
        return {
            startPoint: startPoint,
            endPoint: endPoint
        };
    };
    MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady = function() {
        var _this = this;
        // This method is called both when a pointing device is released, and when the activation animation ends.
        // The deactivation animation should only run after both of those occur.
        var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
        var _a = this.activationState, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
        var activationHasEnded = hasDeactivationUXRun || !isActivated;
        if (activationHasEnded && this.activationAnimationHasEnded) {
            this.rmBoundedActivationClasses();
            this.adapter.addClass(FG_DEACTIVATION);
            this.fgDeactivationRemovalTimer = setTimeout(function() {
                _this.adapter.removeClass(FG_DEACTIVATION);
            }, (0, $20ea23f247cc2de7$export$1f6c9cc012ebacae).FG_DEACTIVATION_MS);
        }
    };
    MDCRippleFoundation.prototype.rmBoundedActivationClasses = function() {
        var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
        this.adapter.removeClass(FG_ACTIVATION);
        this.activationAnimationHasEnded = false;
        this.adapter.computeBoundingRect();
    };
    MDCRippleFoundation.prototype.resetActivationState = function() {
        var _this = this;
        this.previousActivationEvent = this.activationState.activationEvent;
        this.activationState = this.defaultActivationState();
        // Touch devices may fire additional events for the same interaction within a short time.
        // Store the previous event until it's safe to assume that subsequent events are for new interactions.
        setTimeout(function() {
            return _this.previousActivationEvent = undefined;
        }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
    };
    MDCRippleFoundation.prototype.deactivateImpl = function() {
        var _this = this;
        var activationState = this.activationState;
        // This can happen in scenarios such as when you have a keyup event that blurs the element.
        if (!activationState.isActivated) return;
        var state = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, activationState);
        if (activationState.isProgrammatic) {
            requestAnimationFrame(function() {
                _this.animateDeactivation(state);
            });
            this.resetActivationState();
        } else {
            this.deregisterDeactivationHandlers();
            requestAnimationFrame(function() {
                _this.activationState.hasDeactivationUXRun = true;
                _this.animateDeactivation(state);
                _this.resetActivationState();
            });
        }
    };
    MDCRippleFoundation.prototype.animateDeactivation = function(_a) {
        var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
        if (wasActivatedByPointer || wasElementMadeActive) this.runDeactivationUXLogicIfReady();
    };
    MDCRippleFoundation.prototype.layoutInternal = function() {
        var _this = this;
        this.frame = this.adapter.computeBoundingRect();
        var maxDim = Math.max(this.frame.height, this.frame.width);
        // Surface diameter is treated differently for unbounded vs. bounded ripples.
        // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
        // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
        // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
        // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
        // `overflow: hidden`.
        var getBoundedRadius = function() {
            var hypotenuse = Math.sqrt(Math.pow(_this.frame.width, 2) + Math.pow(_this.frame.height, 2));
            return hypotenuse + MDCRippleFoundation.numbers.PADDING;
        };
        this.maxRadius = this.adapter.isUnbounded() ? maxDim : getBoundedRadius();
        // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
        var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
        // Unbounded ripple size should always be even number to equally center align.
        if (this.adapter.isUnbounded() && initialSize % 2 !== 0) this.initialSize = initialSize - 1;
        else this.initialSize = initialSize;
        this.fgScale = "" + this.maxRadius / this.initialSize;
        this.updateLayoutCssVars();
    };
    MDCRippleFoundation.prototype.updateLayoutCssVars = function() {
        var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
        this.adapter.updateCssVariable(VAR_FG_SIZE, this.initialSize + "px");
        this.adapter.updateCssVariable(VAR_FG_SCALE, this.fgScale);
        if (this.adapter.isUnbounded()) {
            this.unboundedCoords = {
                left: Math.round(this.frame.width / 2 - this.initialSize / 2),
                top: Math.round(this.frame.height / 2 - this.initialSize / 2)
            };
            this.adapter.updateCssVariable(VAR_LEFT, this.unboundedCoords.left + "px");
            this.adapter.updateCssVariable(VAR_TOP, this.unboundedCoords.top + "px");
        }
    };
    return MDCRippleFoundation;
}((0, $b5b299dc1af8fe16$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$7f8c91387bb64e48$export$2e2bcd8739ae039 = $7f8c91387bb64e48$export$fb5f028029d92ef5;







/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $74d80410d825d70d$var$i = "important", $74d80410d825d70d$var$n = " !" + $74d80410d825d70d$var$i, $74d80410d825d70d$export$1e5b4ce2fa884e6a = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($74d80410d825d70d$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $74d80410d825d70d$var$i : "") : s[t] = e;
            }
        }
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});




class $d0797a952a533013$export$6ecc905fed2eeb50 extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.primary = false;
        this.accent = false;
        this.unbounded = false;
        this.disabled = false;
        this.activated = false;
        this.selected = false;
        this.internalUseStateLayerCustomProperties = false;
        this.hovering = false;
        this.bgFocused = false;
        this.fgActivation = false;
        this.fgDeactivation = false;
        this.fgScale = "";
        this.fgSize = "";
        this.translateStart = "";
        this.translateEnd = "";
        this.leftPos = "";
        this.topPos = "";
        this.mdcFoundationClass = (0, $7f8c91387bb64e48$export$2e2bcd8739ae039);
    }
    get isActive() {
        return (0, $09b12e35f3b142e5$export$de994efd351b291c)(this.parentElement || this, ":active");
    }
    createAdapter() {
        return {
            browserSupportsCssVars: ()=>true,
            isUnbounded: ()=>this.unbounded,
            isSurfaceActive: ()=>this.isActive,
            isSurfaceDisabled: ()=>this.disabled,
            addClass: (className)=>{
                switch(className){
                    case "mdc-ripple-upgraded--background-focused":
                        this.bgFocused = true;
                        break;
                    case "mdc-ripple-upgraded--foreground-activation":
                        this.fgActivation = true;
                        break;
                    case "mdc-ripple-upgraded--foreground-deactivation":
                        this.fgDeactivation = true;
                        break;
                    default:
                        break;
                }
            },
            removeClass: (className)=>{
                switch(className){
                    case "mdc-ripple-upgraded--background-focused":
                        this.bgFocused = false;
                        break;
                    case "mdc-ripple-upgraded--foreground-activation":
                        this.fgActivation = false;
                        break;
                    case "mdc-ripple-upgraded--foreground-deactivation":
                        this.fgDeactivation = false;
                        break;
                    default:
                        break;
                }
            },
            containsEventTarget: ()=>true,
            registerInteractionHandler: ()=>undefined,
            deregisterInteractionHandler: ()=>undefined,
            registerDocumentInteractionHandler: ()=>undefined,
            deregisterDocumentInteractionHandler: ()=>undefined,
            registerResizeHandler: ()=>undefined,
            deregisterResizeHandler: ()=>undefined,
            updateCssVariable: (varName, value)=>{
                switch(varName){
                    case "--mdc-ripple-fg-scale":
                        this.fgScale = value;
                        break;
                    case "--mdc-ripple-fg-size":
                        this.fgSize = value;
                        break;
                    case "--mdc-ripple-fg-translate-end":
                        this.translateEnd = value;
                        break;
                    case "--mdc-ripple-fg-translate-start":
                        this.translateStart = value;
                        break;
                    case "--mdc-ripple-left":
                        this.leftPos = value;
                        break;
                    case "--mdc-ripple-top":
                        this.topPos = value;
                        break;
                    default:
                        break;
                }
            },
            computeBoundingRect: ()=>(this.parentElement || this).getBoundingClientRect(),
            getWindowPageOffset: ()=>({
                    x: window.pageXOffset,
                    y: window.pageYOffset
                })
        };
    }
    startPress(ev) {
        this.waitForFoundation(()=>{
            this.mdcFoundation.activate(ev);
        });
    }
    endPress() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.deactivate();
        });
    }
    startFocus() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.handleFocus();
        });
    }
    endFocus() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.handleBlur();
        });
    }
    startHover() {
        this.hovering = true;
    }
    endHover() {
        this.hovering = false;
    }
    /**
     * Wait for the MDCFoundation to be created by `firstUpdated`
     */ waitForFoundation(fn) {
        if (this.mdcFoundation) fn();
        else this.updateComplete.then(fn);
    }
    update(changedProperties) {
        if (changedProperties.has("disabled")) // stop hovering when ripple is disabled to prevent a stuck "hover" state
        // When re-enabled, the outer component will get a `mouseenter` event on
        // the first movement, which will call `startHover()`
        {
            if (this.disabled) this.endHover();
        }
        super.update(changedProperties);
    }
    /** @soyTemplate */ render() {
        const shouldActivateInPrimary = this.activated && (this.primary || !this.accent);
        const shouldSelectInPrimary = this.selected && (this.primary || !this.accent);
        /** @classMap */ const classes = {
            "mdc-ripple-surface--accent": this.accent,
            "mdc-ripple-surface--primary--activated": shouldActivateInPrimary,
            "mdc-ripple-surface--accent--activated": this.accent && this.activated,
            "mdc-ripple-surface--primary--selected": shouldSelectInPrimary,
            "mdc-ripple-surface--accent--selected": this.accent && this.selected,
            "mdc-ripple-surface--disabled": this.disabled,
            "mdc-ripple-surface--hover": this.hovering,
            "mdc-ripple-surface--primary": this.primary,
            "mdc-ripple-surface--selected": this.selected,
            "mdc-ripple-upgraded--background-focused": this.bgFocused,
            "mdc-ripple-upgraded--foreground-activation": this.fgActivation,
            "mdc-ripple-upgraded--foreground-deactivation": this.fgDeactivation,
            "mdc-ripple-upgraded--unbounded": this.unbounded,
            "mdc-ripple-surface--internal-use-state-layer-custom-properties": this.internalUseStateLayerCustomProperties
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div class="mdc-ripple-surface mdc-ripple-upgraded ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
          style="${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)({
            "--mdc-ripple-fg-scale": this.fgScale,
            "--mdc-ripple-fg-size": this.fgSize,
            "--mdc-ripple-fg-translate-end": this.translateEnd,
            "--mdc-ripple-fg-translate-start": this.translateStart,
            "--mdc-ripple-left": this.leftPos,
            "--mdc-ripple-top": this.topPos
        })}"></div>`;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-ripple-surface")
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "primary", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "accent", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "unbounded", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "activated", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "selected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "internalUseStateLayerCustomProperties", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "hovering", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "bgFocused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "fgActivation", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "fgDeactivation", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "fgScale", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "fgSize", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "translateStart", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "translateEnd", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "leftPos", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $d0797a952a533013$export$6ecc905fed2eeb50.prototype, "topPos", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $8eea194def297266$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-ripple-surface{--mdc-ripple-fg-size: 0;--mdc-ripple-left: 0;--mdc-ripple-top: 0;--mdc-ripple-fg-scale: 1;--mdc-ripple-fg-translate-end: 0;--mdc-ripple-fg-translate-start: 0;-webkit-tap-highlight-color:rgba(0,0,0,0);will-change:transform,opacity;position:relative;outline:none;overflow:hidden}.mdc-ripple-surface::before,.mdc-ripple-surface::after{position:absolute;border-radius:50%;opacity:0;pointer-events:none;content:""}.mdc-ripple-surface::before{transition:opacity 15ms linear,background-color 15ms linear;z-index:1;z-index:var(--mdc-ripple-z-index, 1)}.mdc-ripple-surface::after{z-index:0;z-index:var(--mdc-ripple-z-index, 0)}.mdc-ripple-surface.mdc-ripple-upgraded::before{transform:scale(var(--mdc-ripple-fg-scale, 1))}.mdc-ripple-surface.mdc-ripple-upgraded::after{top:0;left:0;transform:scale(0);transform-origin:center center}.mdc-ripple-surface.mdc-ripple-upgraded--unbounded::after{top:var(--mdc-ripple-top, 0);left:var(--mdc-ripple-left, 0)}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-activation::after{animation:mdc-ripple-fg-radius-in 225ms forwards,mdc-ripple-fg-opacity-in 75ms forwards}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-deactivation::after{animation:mdc-ripple-fg-opacity-out 150ms;transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}.mdc-ripple-surface::before,.mdc-ripple-surface::after{top:calc(50% - 100%);left:calc(50% - 100%);width:200%;height:200%}.mdc-ripple-surface.mdc-ripple-upgraded::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded],.mdc-ripple-upgraded--unbounded{overflow:visible}.mdc-ripple-surface[data-mdc-ripple-is-unbounded]::before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded]::after,.mdc-ripple-upgraded--unbounded::before,.mdc-ripple-upgraded--unbounded::after{top:calc(50% - 50%);left:calc(50% - 50%);width:100%;height:100%}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::before,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::after{top:var(--mdc-ripple-top, calc(50% - 50%));left:var(--mdc-ripple-left, calc(50% - 50%));width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface::before,.mdc-ripple-surface::after{background-color:#000;background-color:var(--mdc-ripple-color, #000)}.mdc-ripple-surface:hover::before,.mdc-ripple-surface.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}:host{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;display:block}:host .mdc-ripple-surface{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;will-change:unset}.mdc-ripple-surface--primary::before,.mdc-ripple-surface--primary::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary:hover::before,.mdc-ripple-surface--primary.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface--primary.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--primary.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--primary--activated::before{opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12)}.mdc-ripple-surface--primary--activated::before,.mdc-ripple-surface--primary--activated::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary--activated:hover::before,.mdc-ripple-surface--primary--activated.mdc-ripple-surface--hover::before{opacity:0.16;opacity:var(--mdc-ripple-hover-opacity, 0.16)}.mdc-ripple-surface--primary--activated.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--primary--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--primary--selected::before{opacity:0.08;opacity:var(--mdc-ripple-selected-opacity, 0.08)}.mdc-ripple-surface--primary--selected::before,.mdc-ripple-surface--primary--selected::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary--selected:hover::before,.mdc-ripple-surface--primary--selected.mdc-ripple-surface--hover::before{opacity:0.12;opacity:var(--mdc-ripple-hover-opacity, 0.12)}.mdc-ripple-surface--primary--selected.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-focus-opacity, 0.2)}.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--primary--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--accent::before,.mdc-ripple-surface--accent::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent:hover::before,.mdc-ripple-surface--accent.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface--accent.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--accent.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--accent--activated::before{opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12)}.mdc-ripple-surface--accent--activated::before,.mdc-ripple-surface--accent--activated::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent--activated:hover::before,.mdc-ripple-surface--accent--activated.mdc-ripple-surface--hover::before{opacity:0.16;opacity:var(--mdc-ripple-hover-opacity, 0.16)}.mdc-ripple-surface--accent--activated.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--accent--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--accent--selected::before{opacity:0.08;opacity:var(--mdc-ripple-selected-opacity, 0.08)}.mdc-ripple-surface--accent--selected::before,.mdc-ripple-surface--accent--selected::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent--selected:hover::before,.mdc-ripple-surface--accent--selected.mdc-ripple-surface--hover::before{opacity:0.12;opacity:var(--mdc-ripple-hover-opacity, 0.12)}.mdc-ripple-surface--accent--selected.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-focus-opacity, 0.2)}.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--accent--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--disabled{opacity:0}.mdc-ripple-surface--internal-use-state-layer-custom-properties::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties::after{background-color:#000;background-color:var(--mdc-ripple-hover-state-layer-color, #000)}.mdc-ripple-surface--internal-use-state-layer-custom-properties:hover::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-state-layer-opacity, 0.04)}.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-state-layer-opacity, 0.12)}.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-pressed-state-layer-opacity, 0.12)}.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-pressed-state-layer-opacity, 0.12)}`;


/** @soyCompatible */ let $5b7f00440e6cbcdc$export$9e9146f7e027fdaa = class Ripple extends (0, $d0797a952a533013$export$6ecc905fed2eeb50) {
};
$5b7f00440e6cbcdc$export$9e9146f7e027fdaa.styles = [
    (0, $8eea194def297266$export$9dd6ff9ea0189349)
];
$5b7f00440e6cbcdc$export$9e9146f7e027fdaa = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-ripple")
], $5b7f00440e6cbcdc$export$9e9146f7e027fdaa);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * TypeScript version of the decorator
 * @see https://www.typescriptlang.org/docs/handbook/decorators.html#property-decorators
 */ function $e35ac34f4dd92dd0$var$tsDecorator(prototype, name, descriptor) {
    const constructor = prototype.constructor;
    if (!descriptor) {
        /**
         * lit uses internal properties with two leading underscores to
         * provide storage for accessors
         */ const litInternalPropertyKey = `__${name}`;
        descriptor = constructor.getPropertyDescriptor(name, litInternalPropertyKey);
        if (!descriptor) throw new Error("@ariaProperty must be used after a @property decorator");
    }
    // descriptor must exist at this point, reassign so typescript understands
    const propDescriptor = descriptor;
    let attribute = "";
    if (!propDescriptor.set) throw new Error(`@ariaProperty requires a setter for ${name}`);
    // TODO(b/202853219): Remove this check when internal tooling is
    // compatible
    // tslint:disable-next-line:no-any bail if applied to internal generated class
    if (prototype.dispatchWizEvent) return descriptor;
    const wrappedDescriptor = {
        configurable: true,
        enumerable: true,
        set (value) {
            if (attribute === "") {
                const options = constructor.getPropertyOptions(name);
                // if attribute is not a string, use `name` instead
                attribute = typeof options.attribute === "string" ? options.attribute : name;
            }
            if (this.hasAttribute(attribute)) this.removeAttribute(attribute);
            propDescriptor.set.call(this, value);
        }
    };
    if (propDescriptor.get) wrappedDescriptor.get = function() {
        return propDescriptor.get.call(this);
    };
    return wrappedDescriptor;
}
function $e35ac34f4dd92dd0$export$ae33cbacf67da030(protoOrDescriptor, name, // tslint:disable-next-line:no-any any is required as a return type from decorators
descriptor) {
    if (name !== undefined) return $e35ac34f4dd92dd0$var$tsDecorator(protoOrDescriptor, name, descriptor);
    else throw new Error("@ariaProperty only supports TypeScript Decorators");
}


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Class that encapsulates the events handlers for `mwc-ripple`
 *
 *
 * Example:
 * ```
 * class XFoo extends LitElement {
 *   async getRipple() {
 *     this.renderRipple = true;
 *     await this.updateComplete;
 *     return this.renderRoot.querySelector('mwc-ripple');
 *   }
 *   rippleHandlers = new RippleHandlers(() => this.getRipple());
 *
 *   render() {
 *     return html`
 *       <div @mousedown=${this.rippleHandlers.startPress}></div>
 *       ${this.renderRipple ? html`<mwc-ripple></mwc-ripple>` : ''}
 *     `;
 *   }
 * }
 * ```
 */ class $e65e334fb304280d$export$9a192fb0d53f68ea {
    constructor(/** Function that returns a `mwc-ripple` */ rippleFn){
        this.startPress = (ev)=>{
            rippleFn().then((r)=>{
                r && r.startPress(ev);
            });
        };
        this.endPress = ()=>{
            rippleFn().then((r)=>{
                r && r.endPress();
            });
        };
        this.startFocus = ()=>{
            rippleFn().then((r)=>{
                r && r.startFocus();
            });
        };
        this.endFocus = ()=>{
            rippleFn().then((r)=>{
                r && r.endFocus();
            });
        };
        this.startHover = ()=>{
            rippleFn().then((r)=>{
                r && r.startHover();
            });
        };
        this.endHover = ()=>{
            rippleFn().then((r)=>{
                r && r.endHover();
            });
        };
    }
}






class $0752feea941d01c6$export$b0bb876e969289cd extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.raised = false;
        this.unelevated = false;
        this.outlined = false;
        this.dense = false;
        this.disabled = false;
        this.trailingIcon = false;
        this.fullwidth = false;
        this.icon = "";
        this.label = "";
        this.expandContent = false;
        this.shouldRenderRipple = false;
        this.rippleHandlers = new (0, $e65e334fb304280d$export$9a192fb0d53f68ea)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
    }
    /** @soyTemplate */ renderOverlay() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
    }
    /** @soyTemplate */ renderRipple() {
        const filled = this.raised || this.unelevated;
        return this.shouldRenderRipple ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-ripple class="ripple" .primary="${!filled}" .disabled="${this.disabled}"></mwc-ripple>` : "";
    }
    focus() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.startFocus();
            buttonElement.focus();
        }
    }
    blur() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.endFocus();
            buttonElement.blur();
        }
    }
    /** @soyTemplate */ getRenderClasses() {
        return {
            "mdc-button--raised": this.raised,
            "mdc-button--unelevated": this.unelevated,
            "mdc-button--outlined": this.outlined,
            "mdc-button--dense": this.dense
        };
    }
    /**
     * @soyTemplate
     * @soyAttributes buttonAttributes: #button
     * @soyClasses buttonClasses: #button
     */ render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <button
          id="button"
          class="mdc-button ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getRenderClasses())}"
          ?disabled="${this.disabled}"
          aria-label="${this.label || this.icon}"
          aria-haspopup="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaHasPopup)}"
          @focus="${this.handleRippleFocus}"
          @blur="${this.handleRippleBlur}"
          @mousedown="${this.handleRippleActivate}"
          @mouseenter="${this.handleRippleMouseEnter}"
          @mouseleave="${this.handleRippleMouseLeave}"
          @touchstart="${this.handleRippleActivate}"
          @touchend="${this.handleRippleDeactivate}"
          @touchcancel="${this.handleRippleDeactivate}">
        ${this.renderOverlay()}
        ${this.renderRipple()}
        <span class="leading-icon">
          <slot name="icon">
            ${this.icon && !this.trailingIcon ? this.renderIcon() : ""}
          </slot>
        </span>
        <span class="mdc-button__label">${this.label}</span>
        <span class="slot-container ${(0, $0e5c059fc79abe53$export$56cc687933817664)({
            flex: this.expandContent
        })}">
          <slot></slot>
        </span>
        <span class="trailing-icon">
          <slot name="trailingIcon">
            ${this.icon && this.trailingIcon ? this.renderIcon() : ""}
          </slot>
        </span>
      </button>`;
    }
    /** @soyTemplate */ renderIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <mwc-icon class="mdc-button__icon">
      ${this.icon}
    </mwc-icon>`;
    }
    handleRippleActivate(evt) {
        const onUp = ()=>{
            window.removeEventListener("mouseup", onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener("mouseup", onUp);
        this.rippleHandlers.startPress(evt);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
}
$0752feea941d01c6$export$b0bb876e969289cd.shadowRootOptions = {
    mode: "open",
    delegatesFocus: true
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-haspopup"
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "ariaHasPopup", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "raised", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "unelevated", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "outlined", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "dense", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "trailingicon"
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "trailingIcon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "fullwidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "icon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "expandContent", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("#button")
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "buttonElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $1f45ba04a1effcd1$export$163dfc35cc43f240)("mwc-ripple")
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "ripple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "shouldRenderRipple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        passive: true
    })
], $0752feea941d01c6$export$b0bb876e969289cd.prototype, "handleRippleActivate", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $7abbdb4451b0257a$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-button-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-button-font-size, 0.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height, 2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight, 500);letter-spacing:0.0892857143em;letter-spacing:var(--mdc-typography-button-letter-spacing, 0.0892857143em);text-decoration:none;text-decoration:var(--mdc-typography-button-text-decoration, none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform, uppercase)}.mdc-touch-target-wrapper{display:inline}.mdc-elevation-overlay{position:absolute;border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity, 0);transition:opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:#fff;background-color:var(--mdc-elevation-overlay-color, #fff)}.mdc-button{position:relative;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-width:64px;border:none;outline:none;line-height:inherit;user-select:none;-webkit-appearance:none;overflow:visible;vertical-align:middle;background:transparent}.mdc-button .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-button::-moz-focus-inner{padding:0;border:0}.mdc-button:active{outline:none}.mdc-button:hover{cursor:pointer}.mdc-button:disabled{cursor:default;pointer-events:none}.mdc-button .mdc-button__icon{margin-left:0;margin-right:8px;display:inline-block;position:relative;vertical-align:top}[dir=rtl] .mdc-button .mdc-button__icon,.mdc-button .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.mdc-button .mdc-button__label{position:relative}.mdc-button .mdc-button__focus-ring{display:none}@media screen and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc( 100% + 4px );width:calc( 100% + 4px );display:block}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring::after,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring::after,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring::after{border-color:CanvasText}}.mdc-button .mdc-button__touch{position:absolute;top:50%;height:48px;left:0;right:0;transform:translateY(-50%)}.mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .mdc-button__label+.mdc-button__icon,.mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}svg.mdc-button__icon{fill:currentColor}.mdc-button--touch{margin-top:6px;margin-bottom:6px}.mdc-button{padding:0 8px 0 8px}.mdc-button--unelevated{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);padding:0 16px 0 16px}.mdc-button--unelevated.mdc-button--icon-trailing{padding:0 12px 0 16px}.mdc-button--unelevated.mdc-button--icon-leading{padding:0 16px 0 12px}.mdc-button--raised{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);padding:0 16px 0 16px}.mdc-button--raised.mdc-button--icon-trailing{padding:0 12px 0 16px}.mdc-button--raised.mdc-button--icon-leading{padding:0 16px 0 12px}.mdc-button--outlined{border-style:solid;transition:border 280ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-button--outlined .mdc-button__ripple{border-style:solid;border-color:transparent}.mdc-button{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button:not(:disabled){color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}.mdc-button:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--raised,.mdc-button--unelevated{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--raised:not(:disabled),.mdc-button--unelevated:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary, #6200ee)}.mdc-button--raised:disabled,.mdc-button--unelevated:disabled{background-color:rgba(0, 0, 0, 0.12)}.mdc-button--raised:not(:disabled),.mdc-button--unelevated:not(:disabled){color:#fff;color:var(--mdc-theme-on-primary, #fff)}.mdc-button--raised:disabled,.mdc-button--unelevated:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button--raised .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button--raised .mdc-button__ripple,.mdc-button--unelevated .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--outlined{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px);padding:0 15px 0 15px;border-width:1px}.mdc-button--outlined:not(:disabled){color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}.mdc-button--outlined:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button--outlined .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button--outlined .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--outlined:not(:disabled){border-color:rgba(0, 0, 0, 0.12)}.mdc-button--outlined:disabled{border-color:rgba(0, 0, 0, 0.12)}.mdc-button--outlined.mdc-button--icon-trailing{padding:0 11px 0 15px}.mdc-button--outlined.mdc-button--icon-leading{padding:0 15px 0 11px}.mdc-button--outlined .mdc-button__ripple{top:-1px;left:-1px;bottom:-1px;right:-1px;border-width:1px}.mdc-button--outlined .mdc-button__touch{left:calc(-1 * 1px);width:calc(100% + 2 * 1px)}.mdc-button--raised{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 1px 5px 0px rgba(0,0,0,.12);transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-button--raised:hover,.mdc-button--raised:focus{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12)}.mdc-button--raised:active{box-shadow:0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0,0,0,.12)}.mdc-button--raised:disabled{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.2),0px 0px 0px 0px rgba(0, 0, 0, 0.14),0px 0px 0px 0px rgba(0,0,0,.12)}:host{display:inline-flex;outline:none;-webkit-tap-highlight-color:transparent;vertical-align:top}:host([fullwidth]){width:100%}:host([raised]),:host([unelevated]){--mdc-ripple-color:#fff;--mdc-ripple-focus-opacity:0.24;--mdc-ripple-hover-opacity:0.08;--mdc-ripple-press-opacity:0.24}.trailing-icon ::slotted(*),.trailing-icon .mdc-button__icon,.leading-icon ::slotted(*),.leading-icon .mdc-button__icon{margin-left:0;margin-right:8px;display:inline-block;position:relative;vertical-align:top;font-size:1.125rem;height:1.125rem;width:1.125rem}[dir=rtl] .trailing-icon ::slotted(*),[dir=rtl] .trailing-icon .mdc-button__icon,[dir=rtl] .leading-icon ::slotted(*),[dir=rtl] .leading-icon .mdc-button__icon,.trailing-icon ::slotted(*[dir=rtl]),.trailing-icon .mdc-button__icon[dir=rtl],.leading-icon ::slotted(*[dir=rtl]),.leading-icon .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.trailing-icon ::slotted(*),.trailing-icon .mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .trailing-icon ::slotted(*),[dir=rtl] .trailing-icon .mdc-button__icon,.trailing-icon ::slotted(*[dir=rtl]),.trailing-icon .mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}.slot-container{display:inline-flex;align-items:center;justify-content:center}.slot-container.flex{flex:auto}.mdc-button{flex:auto;overflow:hidden;padding-left:8px;padding-left:var(--mdc-button-horizontal-padding, 8px);padding-right:8px;padding-right:var(--mdc-button-horizontal-padding, 8px)}.mdc-button--raised{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow, 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised:focus{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-focus, var(--mdc-button-raised-box-shadow-hover, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)))}.mdc-button--raised:hover{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-hover, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised:active{box-shadow:0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-active, 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12))}.mdc-button--raised:disabled{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-disabled, 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised,.mdc-button--unelevated{padding-left:16px;padding-left:var(--mdc-button-horizontal-padding, 16px);padding-right:16px;padding-right:var(--mdc-button-horizontal-padding, 16px)}.mdc-button--outlined{border-width:1px;border-width:var(--mdc-button-outline-width, 1px);padding-left:calc(16px - 1px);padding-left:calc(var(--mdc-button-horizontal-padding, 16px) - var(--mdc-button-outline-width, 1px));padding-right:calc(16px - 1px);padding-right:calc(var(--mdc-button-horizontal-padding, 16px) - var(--mdc-button-outline-width, 1px))}.mdc-button--outlined:not(:disabled){border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-button-outline-color, rgba(0, 0, 0, 0.12))}.mdc-button--outlined .ripple{top:calc(-1 * 1px);top:calc(-1 * var(--mdc-button-outline-width, 1px));left:calc(-1 * 1px);left:calc(-1 * var(--mdc-button-outline-width, 1px));right:initial;right:initial;border-width:1px;border-width:var(--mdc-button-outline-width, 1px);border-style:solid;border-color:transparent}[dir=rtl] .mdc-button--outlined .ripple,.mdc-button--outlined .ripple[dir=rtl]{left:initial;left:initial;right:calc(-1 * 1px);right:calc(-1 * var(--mdc-button-outline-width, 1px))}.mdc-button--dense{height:28px;margin-top:0;margin-bottom:0}.mdc-button--dense .mdc-button__touch{height:100%}:host([disabled]){pointer-events:none}:host([disabled]) .mdc-button{color:rgba(0, 0, 0, 0.38);color:var(--mdc-button-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-button--raised,:host([disabled]) .mdc-button--unelevated{background-color:rgba(0, 0, 0, 0.12);background-color:var(--mdc-button-disabled-fill-color, rgba(0, 0, 0, 0.12))}:host([disabled]) .mdc-button--outlined{border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-button-disabled-outline-color, rgba(0, 0, 0, 0.12))}`;


/** @soyCompatible */ let $ab9f63b7adf0f22b$export$353f5b6fc5456de1 = class Button extends (0, $0752feea941d01c6$export$b0bb876e969289cd) {
};
$ab9f63b7adf0f22b$export$353f5b6fc5456de1.styles = [
    (0, $7abbdb4451b0257a$export$9dd6ff9ea0189349)
];
$ab9f63b7adf0f22b$export$353f5b6fc5456de1 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-button")
], $ab9f63b7adf0f22b$export$353f5b6fc5456de1);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 






class $c1d2799c84730917$export$50065871be0e3c7e extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.icon = "";
        this.shouldRenderRipple = false;
        this.rippleHandlers = new (0, $e65e334fb304280d$export$9a192fb0d53f68ea)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
    }
    /** @soyTemplate */ renderRipple() {
        return this.shouldRenderRipple ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <mwc-ripple
                .disabled="${this.disabled}"
                unbounded>
            </mwc-ripple>` : "";
    }
    focus() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.startFocus();
            buttonElement.focus();
        }
    }
    blur() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.endFocus();
            buttonElement.blur();
        }
    }
    /** @soyTemplate */ render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<button
        class="mdc-icon-button mdc-icon-button--display-flex"
        aria-label="${this.ariaLabel || this.icon}"
        aria-haspopup="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaHasPopup)}"
        ?disabled="${this.disabled}"
        @focus="${this.handleRippleFocus}"
        @blur="${this.handleRippleBlur}"
        @mousedown="${this.handleRippleMouseDown}"
        @mouseenter="${this.handleRippleMouseEnter}"
        @mouseleave="${this.handleRippleMouseLeave}"
        @touchstart="${this.handleRippleTouchStart}"
        @touchend="${this.handleRippleDeactivate}"
        @touchcancel="${this.handleRippleDeactivate}"
    >${this.renderRipple()}
    ${this.icon ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<i class="material-icons">${this.icon}</i>` : ""}
    <span
      ><slot></slot
    ></span>
  </button>`;
    }
    handleRippleMouseDown(event) {
        const onUp = ()=>{
            window.removeEventListener("mouseup", onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener("mouseup", onUp);
        this.rippleHandlers.startPress(event);
    }
    handleRippleTouchStart(event) {
        this.rippleHandlers.startPress(event);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "icon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-label"
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "ariaLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-haspopup"
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "ariaHasPopup", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("button")
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "buttonElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $1f45ba04a1effcd1$export$163dfc35cc43f240)("mwc-ripple")
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "ripple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "shouldRenderRipple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        passive: true
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "handleRippleMouseDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        passive: true
    })
], $c1d2799c84730917$export$50065871be0e3c7e.prototype, "handleRippleTouchStart", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $64df279497bf8eba$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.material-icons{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}.mdc-icon-button{font-size:24px;width:48px;height:48px;padding:12px}.mdc-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:48px;max-width:48px}@media screen and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:40px;height:40px;margin-top:4px;margin-bottom:4px;margin-right:4px;margin-left:4px}.mdc-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:40px;max-width:40px}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-disabled-on-light, rgba(0, 0, 0, 0.38))}.mdc-icon-button svg,.mdc-icon-button img{width:24px;height:24px}.mdc-icon-button{display:inline-block;position:relative;box-sizing:border-box;border:none;outline:none;background-color:transparent;fill:currentColor;color:inherit;text-decoration:none;cursor:pointer;user-select:none;z-index:0;overflow:visible}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{cursor:default;pointer-events:none}.mdc-icon-button--display-flex{align-items:center;display:inline-flex;justify-content:center}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on{display:none}.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button__link{height:100%;left:0;outline:none;position:absolute;top:0;width:100%}.mdc-icon-button{display:inline-block;position:relative;box-sizing:border-box;border:none;outline:none;background-color:transparent;fill:currentColor;color:inherit;text-decoration:none;cursor:pointer;user-select:none;z-index:0;overflow:visible}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{cursor:default;pointer-events:none}.mdc-icon-button--display-flex{align-items:center;display:inline-flex;justify-content:center}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on{display:none}.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button__link{height:100%;left:0;outline:none;position:absolute;top:0;width:100%}:host{display:inline-block;outline:none}:host([disabled]){pointer-events:none}.mdc-icon-button i,.mdc-icon-button svg,.mdc-icon-button img,.mdc-icon-button ::slotted(*){display:block}:host{--mdc-ripple-color: currentcolor;-webkit-tap-highlight-color:transparent}:host,.mdc-icon-button{vertical-align:top}.mdc-icon-button{width:var(--mdc-icon-button-size, 48px);height:var(--mdc-icon-button-size, 48px);padding:calc( (var(--mdc-icon-button-size, 48px) - var(--mdc-icon-size, 24px)) / 2 )}.mdc-icon-button i,.mdc-icon-button svg,.mdc-icon-button img,.mdc-icon-button ::slotted(*){display:block;width:var(--mdc-icon-size, 24px);height:var(--mdc-icon-size, 24px)}`;


/** @soyCompatible */ let $cd0163d88fabdeed$export$c25acd513dcc8062 = class IconButton extends (0, $c1d2799c84730917$export$50065871be0e3c7e) {
};
$cd0163d88fabdeed$export$c25acd513dcc8062.styles = [
    (0, $64df279497bf8eba$export$9dd6ff9ea0189349)
];
$cd0163d88fabdeed$export$c25acd513dcc8062 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-icon-button")
], $cd0163d88fabdeed$export$c25acd513dcc8062);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (()=>{
    var _a, _b, _c;
    /* Symbols for private properties */ const _blockingElements = Symbol();
    const _alreadyInertElements = Symbol();
    const _topElParents = Symbol();
    const _siblingsToRestore = Symbol();
    const _parentMO = Symbol();
    /* Symbols for private static methods */ const _topChanged = Symbol();
    const _swapInertedSibling = Symbol();
    const _inertSiblings = Symbol();
    const _restoreInertedSiblings = Symbol();
    const _getParents = Symbol();
    const _getDistributedChildren = Symbol();
    const _isInertable = Symbol();
    const _handleMutations = Symbol();
    class BlockingElementsImpl {
        constructor(){
            /**
             * The blocking elements.
             */ this[_a] = [];
            /**
             * Used to keep track of the parents of the top element, from the element
             * itself up to body. When top changes, the old top might have been removed
             * from the document, so we need to memoize the inerted parents' siblings
             * in order to restore their inerteness when top changes.
             */ this[_b] = [];
            /**
             * Elements that are already inert before the first blocking element is
             * pushed.
             */ this[_c] = new Set();
        }
        destructor() {
            // Restore original inertness.
            this[_restoreInertedSiblings](this[_topElParents]);
            // Note we don't want to make these properties nullable on the class,
            // since then we'd need non-null casts in many places. Calling a method on
            // a BlockingElements instance after calling destructor will result in an
            // exception.
            const nullable = this;
            nullable[_blockingElements] = null;
            nullable[_topElParents] = null;
            nullable[_alreadyInertElements] = null;
        }
        get top() {
            const elems = this[_blockingElements];
            return elems[elems.length - 1] || null;
        }
        push(element) {
            if (!element || element === this.top) return;
            // Remove it from the stack, we'll bring it to the top.
            this.remove(element);
            this[_topChanged](element);
            this[_blockingElements].push(element);
        }
        remove(element) {
            const i = this[_blockingElements].indexOf(element);
            if (i === -1) return false;
            this[_blockingElements].splice(i, 1);
            // Top changed only if the removed element was the top element.
            if (i === this[_blockingElements].length) this[_topChanged](this.top);
            return true;
        }
        pop() {
            const top = this.top;
            top && this.remove(top);
            return top;
        }
        has(element) {
            return this[_blockingElements].indexOf(element) !== -1;
        }
        /**
         * Sets `inert` to all document elements except the new top element, its
         * parents, and its distributed content.
         */ [(_a = _blockingElements, _b = _topElParents, _c = _alreadyInertElements, _topChanged)](newTop) {
            const toKeepInert = this[_alreadyInertElements];
            const oldParents = this[_topElParents];
            // No new top, reset old top if any.
            if (!newTop) {
                this[_restoreInertedSiblings](oldParents);
                toKeepInert.clear();
                this[_topElParents] = [];
                return;
            }
            const newParents = this[_getParents](newTop);
            // New top is not contained in the main document!
            if (newParents[newParents.length - 1].parentNode !== document.body) throw Error("Non-connected element cannot be a blocking element");
            // Cast here because we know we'll call _inertSiblings on newParents
            // below.
            this[_topElParents] = newParents;
            const toSkip = this[_getDistributedChildren](newTop);
            // No previous top element.
            if (!oldParents.length) {
                this[_inertSiblings](newParents, toSkip, toKeepInert);
                return;
            }
            let i = oldParents.length - 1;
            let j = newParents.length - 1;
            // Find common parent. Index 0 is the element itself (so stop before it).
            while(i > 0 && j > 0 && oldParents[i] === newParents[j]){
                i--;
                j--;
            }
            // If up the parents tree there are 2 elements that are siblings, swap
            // the inerted sibling.
            if (oldParents[i] !== newParents[j]) this[_swapInertedSibling](oldParents[i], newParents[j]);
            // Restore old parents siblings inertness.
            i > 0 && this[_restoreInertedSiblings](oldParents.slice(0, i));
            // Make new parents siblings inert.
            j > 0 && this[_inertSiblings](newParents.slice(0, j), toSkip, null);
        }
        /**
         * Swaps inertness between two sibling elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_swapInertedSibling](oldInert, newInert) {
            const siblingsToRestore = oldInert[_siblingsToRestore];
            // oldInert is not contained in siblings to restore, so we have to check
            // if it's inertable and if already inert.
            if (this[_isInertable](oldInert) && !oldInert.inert) {
                oldInert.inert = true;
                siblingsToRestore.add(oldInert);
            }
            // If newInert was already between the siblings to restore, it means it is
            // inertable and must be restored.
            if (siblingsToRestore.has(newInert)) {
                newInert.inert = false;
                siblingsToRestore.delete(newInert);
            }
            newInert[_parentMO] = oldInert[_parentMO];
            newInert[_siblingsToRestore] = siblingsToRestore;
            oldInert[_parentMO] = undefined;
            oldInert[_siblingsToRestore] = undefined;
        }
        /**
         * Restores original inertness to the siblings of the elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_restoreInertedSiblings](elements) {
            for (const element of elements){
                const mo = element[_parentMO];
                mo.disconnect();
                element[_parentMO] = undefined;
                const siblings = element[_siblingsToRestore];
                for (const sibling of siblings)sibling.inert = false;
                element[_siblingsToRestore] = undefined;
            }
        }
        /**
         * Inerts the siblings of the elements except the elements to skip. Stores
         * the inerted siblings into the element's symbol `_siblingsToRestore`.
         * Pass `toKeepInert` to collect the already inert elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_inertSiblings](elements, toSkip, toKeepInert) {
            for (const element of elements){
                // Assume element is not a Document, so it must have a parentNode.
                const parent = element.parentNode;
                const children = parent.children;
                const inertedSiblings = new Set();
                for(let j = 0; j < children.length; j++){
                    const sibling = children[j];
                    // Skip the input element, if not inertable or to be skipped.
                    if (sibling === element || !this[_isInertable](sibling) || toSkip && toSkip.has(sibling)) continue;
                    // Should be collected since already inerted.
                    if (toKeepInert && sibling.inert) toKeepInert.add(sibling);
                    else {
                        sibling.inert = true;
                        inertedSiblings.add(sibling);
                    }
                }
                // Store the siblings that were inerted.
                element[_siblingsToRestore] = inertedSiblings;
                // Observe only immediate children mutations on the parent.
                const mo = new MutationObserver(this[_handleMutations].bind(this));
                element[_parentMO] = mo;
                let parentToObserve = parent;
                // If we're using the ShadyDOM polyfill, then our parent could be a
                // shady root, which is an object that acts like a ShadowRoot, but isn't
                // actually a node in the real DOM. Observe the real DOM parent instead.
                const maybeShadyRoot = parentToObserve;
                if (maybeShadyRoot.__shady && maybeShadyRoot.host) parentToObserve = maybeShadyRoot.host;
                mo.observe(parentToObserve, {
                    childList: true
                });
            }
        }
        /**
         * Handles newly added/removed nodes by toggling their inertness.
         * It also checks if the current top Blocking Element has been removed,
         * notifying and removing it.
         */ [_handleMutations](mutations) {
            const parents = this[_topElParents];
            const toKeepInert = this[_alreadyInertElements];
            for (const mutation of mutations){
                // If the target is a shadowRoot, get its host as we skip shadowRoots when
                // computing _topElParents.
                const target = mutation.target.host || mutation.target;
                const idx = target === document.body ? parents.length : parents.indexOf(target);
                const inertedChild = parents[idx - 1];
                const inertedSiblings = inertedChild[_siblingsToRestore];
                // To restore.
                for(let i = 0; i < mutation.removedNodes.length; i++){
                    const sibling = mutation.removedNodes[i];
                    if (sibling === inertedChild) {
                        console.info("Detected removal of the top Blocking Element.");
                        this.pop();
                        return;
                    }
                    if (inertedSiblings.has(sibling)) {
                        sibling.inert = false;
                        inertedSiblings.delete(sibling);
                    }
                }
                // To inert.
                for(let i = 0; i < mutation.addedNodes.length; i++){
                    const sibling = mutation.addedNodes[i];
                    if (!this[_isInertable](sibling)) continue;
                    if (toKeepInert && sibling.inert) toKeepInert.add(sibling);
                    else {
                        sibling.inert = true;
                        inertedSiblings.add(sibling);
                    }
                }
            }
        }
        /**
         * Returns if the element is inertable.
         */ [_isInertable](element) {
            return false === /^(style|template|script)$/.test(element.localName);
        }
        /**
         * Returns the list of newParents of an element, starting from element
         * (included) up to `document.body` (excluded).
         */ [_getParents](element) {
            const parents = [];
            let current = element;
            // Stop to body.
            while(current && current !== document.body){
                // Skip shadow roots.
                if (current.nodeType === Node.ELEMENT_NODE) parents.push(current);
                // ShadowDom v1
                if (current.assignedSlot) {
                    // Collect slots from deepest slot to top.
                    while(current = current.assignedSlot)parents.push(current);
                    // Continue the search on the top slot.
                    current = parents.pop();
                    continue;
                }
                current = current.parentNode || current.host;
            }
            return parents;
        }
        /**
         * Returns the distributed children of the element's shadow root.
         * Returns null if the element doesn't have a shadow root.
         */ [_getDistributedChildren](element) {
            const shadowRoot = element.shadowRoot;
            if (!shadowRoot) return null;
            const result = new Set();
            let i;
            let j;
            let nodes;
            const slots = shadowRoot.querySelectorAll("slot");
            if (slots.length && slots[0].assignedNodes) for(i = 0; i < slots.length; i++){
                nodes = slots[i].assignedNodes({
                    flatten: true
                });
                for(j = 0; j < nodes.length; j++)if (nodes[j].nodeType === Node.ELEMENT_NODE) result.add(nodes[j]);
            }
            return result;
        }
    }
    document.$blockingElements = new BlockingElementsImpl();
})();


var $b278282c6b3a7f26$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $b278282c6b3a7f26$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */ (function() {
    // Return early if we're not running inside of the browser.
    if (typeof window === "undefined") return;
    // Convenience function for converting NodeLists.
    /** @type {typeof Array.prototype.slice} */ var slice = Array.prototype.slice;
    /**
   * IE has a non-standard name for "matches".
   * @type {typeof Element.prototype.matches}
   */ var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    /** @type {string} */ var _focusableElementsString = [
        "a[href]",
        "area[href]",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "details",
        "summary",
        "iframe",
        "object",
        "embed",
        "[contenteditable]"
    ].join(",");
    /**
   * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
   * attribute.
   *
   * Its main functions are:
   *
   * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
   *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
   *   each focusable node in the subtree with the singleton `InertManager` which manages all known
   *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
   *   instance exists for each focusable node which has at least one inert root as an ancestor.
   *
   * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
   *   attribute is removed from the root node). This is handled in the destructor, which calls the
   *   `deregister` method on `InertManager` for each managed inert node.
   */ var InertRoot = function() {
        /**
     * @param {!HTMLElement} rootElement The HTMLElement at the root of the inert subtree.
     * @param {!InertManager} inertManager The global singleton InertManager object.
     */ function InertRoot(rootElement, inertManager) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertRoot);
            /** @type {!InertManager} */ this._inertManager = inertManager;
            /** @type {!HTMLElement} */ this._rootElement = rootElement;
            /**
       * @type {!Set<!InertNode>}
       * All managed focusable nodes in this InertRoot's subtree.
       */ this._managedNodes = new Set();
            // Make the subtree hidden from assistive technology
            if (this._rootElement.hasAttribute("aria-hidden")) /** @type {?string} */ this._savedAriaHidden = this._rootElement.getAttribute("aria-hidden");
            else this._savedAriaHidden = null;
            this._rootElement.setAttribute("aria-hidden", "true");
            // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
            this._makeSubtreeUnfocusable(this._rootElement);
            // Watch for:
            // - any additions in the subtree: make them unfocusable too
            // - any removals from the subtree: remove them from this inert root's managed nodes
            // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
            //   element, make that node a managed node.
            this._observer = new MutationObserver(this._onMutation.bind(this));
            this._observer.observe(this._rootElement, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        /**
     * Call this whenever this object is about to become obsolete.  This unwinds all of the state
     * stored in this object and updates the state of all of the managed nodes.
     */ $b278282c6b3a7f26$var$_createClass(InertRoot, [
            {
                key: "destructor",
                value: function destructor() {
                    this._observer.disconnect();
                    if (this._rootElement) {
                        if (this._savedAriaHidden !== null) this._rootElement.setAttribute("aria-hidden", this._savedAriaHidden);
                        else this._rootElement.removeAttribute("aria-hidden");
                    }
                    this._managedNodes.forEach(function(inertNode) {
                        this._unmanageNode(inertNode.node);
                    }, this);
                    // Note we cast the nulls to the ANY type here because:
                    // 1) We want the class properties to be declared as non-null, or else we
                    //    need even more casts throughout this code. All bets are off if an
                    //    instance has been destroyed and a method is called.
                    // 2) We don't want to cast "this", because we want type-aware optimizations
                    //    to know which properties we're setting.
                    this._observer = /** @type {?} */ null;
                    this._rootElement = /** @type {?} */ null;
                    this._managedNodes = /** @type {?} */ null;
                    this._inertManager = /** @type {?} */ null;
                }
            },
            {
                key: "_makeSubtreeUnfocusable",
                /**
       * @param {!Node} startNode
       */ value: function _makeSubtreeUnfocusable(startNode) {
                    var _this2 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this2._visitNode(node);
                    });
                    var activeElement = document.activeElement;
                    if (!document.body.contains(startNode)) {
                        // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                        var node = startNode;
                        /** @type {!ShadowRoot|undefined} */ var root = undefined;
                        while(node){
                            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                root = /** @type {!ShadowRoot} */ node;
                                break;
                            }
                            node = node.parentNode;
                        }
                        if (root) activeElement = root.activeElement;
                    }
                    if (startNode.contains(activeElement)) {
                        activeElement.blur();
                        // In IE11, if an element is already focused, and then set to tabindex=-1
                        // calling blur() will not actually move the focus.
                        // To work around this we call focus() on the body instead.
                        if (activeElement === document.activeElement) document.body.focus();
                    }
                }
            },
            {
                key: "_visitNode",
                value: function _visitNode(node) {
                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ node;
                    // If a descendant inert root becomes un-inert, its descendants will still be inert because of
                    // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
                    if (element !== this._rootElement && element.hasAttribute("inert")) this._adoptInertRoot(element);
                    if (matches.call(element, _focusableElementsString) || element.hasAttribute("tabindex")) this._manageNode(element);
                }
            },
            {
                key: "_manageNode",
                value: function _manageNode(node) {
                    var inertNode = this._inertManager.register(node, this);
                    this._managedNodes.add(inertNode);
                }
            },
            {
                key: "_unmanageNode",
                value: function _unmanageNode(node) {
                    var inertNode = this._inertManager.deregister(node, this);
                    if (inertNode) this._managedNodes["delete"](inertNode);
                }
            },
            {
                key: "_unmanageSubtree",
                value: function _unmanageSubtree(startNode) {
                    var _this3 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this3._unmanageNode(node);
                    });
                }
            },
            {
                key: "_adoptInertRoot",
                value: function _adoptInertRoot(node) {
                    var inertSubroot = this._inertManager.getInertRoot(node);
                    // During initialisation this inert root may not have been registered yet,
                    // so register it now if need be.
                    if (!inertSubroot) {
                        this._inertManager.setInert(node, true);
                        inertSubroot = this._inertManager.getInertRoot(node);
                    }
                    inertSubroot.managedNodes.forEach(function(savedInertNode) {
                        this._manageNode(savedInertNode.node);
                    }, this);
                }
            },
            {
                key: "_onMutation",
                value: function _onMutation(records, self) {
                    records.forEach(function(record) {
                        var target = /** @type {!HTMLElement} */ record.target;
                        if (record.type === "childList") {
                            // Manage added nodes
                            slice.call(record.addedNodes).forEach(function(node) {
                                this._makeSubtreeUnfocusable(node);
                            }, this);
                            // Un-manage removed nodes
                            slice.call(record.removedNodes).forEach(function(node) {
                                this._unmanageSubtree(node);
                            }, this);
                        } else if (record.type === "attributes") {
                            if (record.attributeName === "tabindex") // Re-initialise inert node if tabindex changes
                            this._manageNode(target);
                            else if (target !== this._rootElement && record.attributeName === "inert" && target.hasAttribute("inert")) {
                                // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                                // already managed nodes from this inert subroot.
                                this._adoptInertRoot(target);
                                var inertSubroot = this._inertManager.getInertRoot(target);
                                this._managedNodes.forEach(function(managedNode) {
                                    if (target.contains(managedNode.node)) inertSubroot._manageNode(managedNode.node);
                                });
                            }
                        }
                    }, this);
                }
            },
            {
                key: "managedNodes",
                get: function get() {
                    return new Set(this._managedNodes);
                }
            },
            {
                key: "hasSavedAriaHidden",
                get: function get() {
                    return this._savedAriaHidden !== null;
                }
            },
            {
                key: "savedAriaHidden",
                set: function set(ariaHidden) {
                    this._savedAriaHidden = ariaHidden;
                },
                get: function get() {
                    return this._savedAriaHidden;
                }
            }
        ]);
        return InertRoot;
    }();
    /**
   * `InertNode` initialises and manages a single inert node.
   * A node is inert if it is a descendant of one or more inert root elements.
   *
   * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
   * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
   * is intrinsically focusable or not.
   *
   * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
   * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
   * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
   * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
   * or removes the `tabindex` attribute if the element is intrinsically focusable.
   */ var InertNode = function() {
        /**
     * @param {!Node} node A focusable element to be made inert.
     * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
     */ function InertNode(node, inertRoot) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertNode);
            /** @type {!Node} */ this._node = node;
            /** @type {boolean} */ this._overrodeFocusMethod = false;
            /**
       * @type {!Set<!InertRoot>} The set of descendant inert roots.
       *    If and only if this set becomes empty, this node is no longer inert.
       */ this._inertRoots = new Set([
                inertRoot
            ]);
            /** @type {?number} */ this._savedTabIndex = null;
            /** @type {boolean} */ this._destroyed = false;
            // Save any prior tabindex info and make this node untabbable
            this.ensureUntabbable();
        }
        /**
     * Call this whenever this object is about to become obsolete.
     * This makes the managed node focusable again and deletes all of the previously stored state.
     */ $b278282c6b3a7f26$var$_createClass(InertNode, [
            {
                key: "destructor",
                value: function destructor() {
                    this._throwIfDestroyed();
                    if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                        var element = /** @type {!HTMLElement} */ this._node;
                        if (this._savedTabIndex !== null) element.setAttribute("tabindex", this._savedTabIndex);
                        else element.removeAttribute("tabindex");
                        // Use `delete` to restore native focus method.
                        if (this._overrodeFocusMethod) delete element.focus;
                    }
                    // See note in InertRoot.destructor for why we cast these nulls to ANY.
                    this._node = /** @type {?} */ null;
                    this._inertRoots = /** @type {?} */ null;
                    this._destroyed = true;
                }
            },
            {
                key: "_throwIfDestroyed",
                /**
       * Throw if user tries to access destroyed InertNode.
       */ value: function _throwIfDestroyed() {
                    if (this.destroyed) throw new Error("Trying to access destroyed InertNode");
                }
            },
            {
                key: "ensureUntabbable",
                /** Save the existing tabindex value and make the node untabbable and unfocusable */ value: function ensureUntabbable() {
                    if (this.node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ this.node;
                    if (matches.call(element, _focusableElementsString)) {
                        if (/** @type {!HTMLElement} */ element.tabIndex === -1 && this.hasSavedTabIndex) return;
                        if (element.hasAttribute("tabindex")) this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.setAttribute("tabindex", "-1");
                        if (element.nodeType === Node.ELEMENT_NODE) {
                            element.focus = function() {};
                            this._overrodeFocusMethod = true;
                        }
                    } else if (element.hasAttribute("tabindex")) {
                        this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.removeAttribute("tabindex");
                    }
                }
            },
            {
                key: "addInertRoot",
                value: function addInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots.add(inertRoot);
                }
            },
            {
                key: "removeInertRoot",
                value: function removeInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots["delete"](inertRoot);
                    if (this._inertRoots.size === 0) this.destructor();
                }
            },
            {
                key: "destroyed",
                get: function get() {
                    return /** @type {!InertNode} */ this._destroyed;
                }
            },
            {
                key: "hasSavedTabIndex",
                get: function get() {
                    return this._savedTabIndex !== null;
                }
            },
            {
                key: "node",
                get: function get() {
                    this._throwIfDestroyed();
                    return this._node;
                }
            },
            {
                key: "savedTabIndex",
                set: function set(tabIndex) {
                    this._throwIfDestroyed();
                    this._savedTabIndex = tabIndex;
                },
                get: function get() {
                    this._throwIfDestroyed();
                    return this._savedTabIndex;
                }
            }
        ]);
        return InertNode;
    }();
    /**
   * InertManager is a per-document singleton object which manages all inert roots and nodes.
   *
   * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
   * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
   * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
   * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
   * is created for each such node, via the `_managedNodes` map.
   */ var InertManager = function() {
        /**
     * @param {!Document} document
     */ function InertManager(document1) {
            $b278282c6b3a7f26$var$_classCallCheck(this, InertManager);
            if (!document1) throw new Error("Missing required argument; InertManager needs to wrap a document.");
            /** @type {!Document} */ this._document = document1;
            /**
       * All managed nodes known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertNode>}
       */ this._managedNodes = new Map();
            /**
       * All inert roots known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertRoot>}
       */ this._inertRoots = new Map();
            /**
       * Observer for mutations on `document.body`.
       * @type {!MutationObserver}
       */ this._observer = new MutationObserver(this._watchForInert.bind(this));
            // Add inert style.
            addInertStyle(document1.head || document1.body || document1.documentElement);
            // Wait for document to be loaded.
            if (document1.readyState === "loading") document1.addEventListener("DOMContentLoaded", this._onDocumentLoaded.bind(this));
            else this._onDocumentLoaded();
        }
        /**
     * Set whether the given element should be an inert root or not.
     * @param {!HTMLElement} root
     * @param {boolean} inert
     */ $b278282c6b3a7f26$var$_createClass(InertManager, [
            {
                key: "setInert",
                value: function setInert(root, inert) {
                    if (inert) {
                        if (this._inertRoots.has(root)) // element is already inert
                        return;
                        var inertRoot = new InertRoot(root, this);
                        root.setAttribute("inert", "");
                        this._inertRoots.set(root, inertRoot);
                        // If not contained in the document, it must be in a shadowRoot.
                        // Ensure inert styles are added there.
                        if (!this._document.body.contains(root)) {
                            var parent = root.parentNode;
                            while(parent){
                                if (parent.nodeType === 11) addInertStyle(parent);
                                parent = parent.parentNode;
                            }
                        }
                    } else {
                        if (!this._inertRoots.has(root)) // element is already non-inert
                        return;
                        var _inertRoot = this._inertRoots.get(root);
                        _inertRoot.destructor();
                        this._inertRoots["delete"](root);
                        root.removeAttribute("inert");
                    }
                }
            },
            {
                key: "getInertRoot",
                value: function getInertRoot(element) {
                    return this._inertRoots.get(element);
                }
            },
            {
                key: "register",
                value: function register(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (inertNode !== undefined) // node was already in an inert subtree
                    inertNode.addInertRoot(inertRoot);
                    else inertNode = new InertNode(node, inertRoot);
                    this._managedNodes.set(node, inertNode);
                    return inertNode;
                }
            },
            {
                key: "deregister",
                value: function deregister(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (!inertNode) return null;
                    inertNode.removeInertRoot(inertRoot);
                    if (inertNode.destroyed) this._managedNodes["delete"](node);
                    return inertNode;
                }
            },
            {
                key: "_onDocumentLoaded",
                value: function _onDocumentLoaded() {
                    // Find all inert roots in document and make them actually inert.
                    var inertElements = slice.call(this._document.querySelectorAll("[inert]"));
                    inertElements.forEach(function(inertElement) {
                        this.setInert(inertElement, true);
                    }, this);
                    // Comment this out to use programmatic API only.
                    this._observer.observe(this._document.body || this._document.documentElement, {
                        attributes: true,
                        subtree: true,
                        childList: true
                    });
                }
            },
            {
                key: "_watchForInert",
                value: function _watchForInert(records, self) {
                    var _this = this;
                    records.forEach(function(record) {
                        switch(record.type){
                            case "childList":
                                slice.call(record.addedNodes).forEach(function(node) {
                                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                                    var inertElements = slice.call(node.querySelectorAll("[inert]"));
                                    if (matches.call(node, "[inert]")) inertElements.unshift(node);
                                    inertElements.forEach(function(inertElement) {
                                        this.setInert(inertElement, true);
                                    }, _this);
                                }, _this);
                                break;
                            case "attributes":
                                if (record.attributeName !== "inert") return;
                                var target = /** @type {!HTMLElement} */ record.target;
                                var inert = target.hasAttribute("inert");
                                _this.setInert(target, inert);
                                break;
                        }
                    }, this);
                }
            }
        ]);
        return InertManager;
    }();
    /**
   * Recursively walk the composed tree from |node|.
   * @param {!Node} node
   * @param {(function (!HTMLElement))=} callback Callback to be called for each element traversed,
   *     before descending into child nodes.
   * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
   */ function composedTreeWalk(node, callback, shadowRootAncestor) {
        if (node.nodeType == Node.ELEMENT_NODE) {
            var element = /** @type {!HTMLElement} */ node;
            if (callback) callback(element);
            // Descend into node:
            // If it has a ShadowRoot, ignore all child elements - these will be picked
            // up by the <content> or <shadow> elements. Descend straight into the
            // ShadowRoot.
            var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
            if (shadowRoot) {
                composedTreeWalk(shadowRoot, callback, shadowRoot);
                return;
            }
            // If it is a <content> element, descend into distributed elements - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == "content") {
                var content = /** @type {!HTMLContentElement} */ element;
                // Verifies if ShadowDom v0 is supported.
                var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
                for(var i = 0; i < distributedNodes.length; i++)composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
                return;
            }
            // If it is a <slot> element, descend into assigned nodes - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == "slot") {
                var slot = /** @type {!HTMLSlotElement} */ element;
                // Verify if ShadowDom v1 is supported.
                var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({
                    flatten: true
                }) : [];
                for(var _i = 0; _i < _distributedNodes.length; _i++)composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
                return;
            }
        }
        // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
        // element, nor a <shadow> element recurse normally.
        var child = node.firstChild;
        while(child != null){
            composedTreeWalk(child, callback, shadowRootAncestor);
            child = child.nextSibling;
        }
    }
    /**
   * Adds a style element to the node containing the inert specific styles
   * @param {!Node} node
   */ function addInertStyle(node) {
        if (node.querySelector("style#inert-style, link#inert-style")) return;
        var style = document.createElement("style");
        style.setAttribute("id", "inert-style");
        style.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n";
        node.appendChild(style);
    }
    if (!HTMLElement.prototype.hasOwnProperty("inert")) {
        /** @type {!InertManager} */ var inertManager = new InertManager(document);
        Object.defineProperty(HTMLElement.prototype, "inert", {
            enumerable: true,
            /** @this {!HTMLElement} */ get: function get() {
                return this.hasAttribute("inert");
            },
            /** @this {!HTMLElement} */ set: function set(inert) {
                inertManager.setInert(this, inert);
            }
        });
    }
})();


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $6446574c4c071af5$export$c1c0562ec8379000 = {
    ANIMATE: "mdc-drawer--animate",
    CLOSING: "mdc-drawer--closing",
    DISMISSIBLE: "mdc-drawer--dismissible",
    MODAL: "mdc-drawer--modal",
    OPEN: "mdc-drawer--open",
    OPENING: "mdc-drawer--opening",
    ROOT: "mdc-drawer"
};
var $6446574c4c071af5$export$21c51bc433c16634 = {
    APP_CONTENT_SELECTOR: ".mdc-drawer-app-content",
    CLOSE_EVENT: "MDCDrawer:closed",
    OPEN_EVENT: "MDCDrawer:opened",
    SCRIM_SELECTOR: ".mdc-drawer-scrim",
    LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
    LIST_ITEM_ACTIVATED_SELECTOR: ".mdc-list-item--activated,.mdc-deprecated-list-item--activated"
};


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $083166a0be1a9650$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$083166a0be1a9650$export$2e2bcd8739ae039 = $083166a0be1a9650$export$a81b11d69c993162;



var $2d921ba4c89209e7$export$2853b38756d93afb = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDismissibleDrawerFoundation, _super);
    function MDCDismissibleDrawerFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCDismissibleDrawerFoundation.defaultAdapter), adapter)) || this;
        _this.animationFrame = 0;
        _this.animationTimer = 0;
        return _this;
    }
    Object.defineProperty(MDCDismissibleDrawerFoundation, "strings", {
        get: function() {
            return 0, $6446574c4c071af5$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDismissibleDrawerFoundation, "cssClasses", {
        get: function() {
            return 0, $6446574c4c071af5$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDismissibleDrawerFoundation, "defaultAdapter", {
        get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                elementHasClass: function() {
                    return false;
                },
                notifyClose: function() {
                    return undefined;
                },
                notifyOpen: function() {
                    return undefined;
                },
                saveFocus: function() {
                    return undefined;
                },
                restoreFocus: function() {
                    return undefined;
                },
                focusActiveNavigationItem: function() {
                    return undefined;
                },
                trapFocus: function() {
                    return undefined;
                },
                releaseFocus: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCDismissibleDrawerFoundation.prototype.destroy = function() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        if (this.animationTimer) clearTimeout(this.animationTimer);
    };
    /**
     * Opens the drawer from the closed state.
     */ MDCDismissibleDrawerFoundation.prototype.open = function() {
        var _this = this;
        if (this.isOpen() || this.isOpening() || this.isClosing()) return;
        this.adapter.addClass((0, $6446574c4c071af5$export$c1c0562ec8379000).OPEN);
        this.adapter.addClass((0, $6446574c4c071af5$export$c1c0562ec8379000).ANIMATE);
        // Wait a frame once display is no longer "none", to establish basis for animation
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $6446574c4c071af5$export$c1c0562ec8379000).OPENING);
        });
        this.adapter.saveFocus();
    };
    /**
     * Closes the drawer from the open state.
     */ MDCDismissibleDrawerFoundation.prototype.close = function() {
        if (!this.isOpen() || this.isOpening() || this.isClosing()) return;
        this.adapter.addClass((0, $6446574c4c071af5$export$c1c0562ec8379000).CLOSING);
    };
    /**
     * Returns true if the drawer is in the open position.
     * @return true if drawer is in open state.
     */ MDCDismissibleDrawerFoundation.prototype.isOpen = function() {
        return this.adapter.hasClass((0, $6446574c4c071af5$export$c1c0562ec8379000).OPEN);
    };
    /**
     * Returns true if the drawer is animating open.
     * @return true if drawer is animating open.
     */ MDCDismissibleDrawerFoundation.prototype.isOpening = function() {
        return this.adapter.hasClass((0, $6446574c4c071af5$export$c1c0562ec8379000).OPENING) || this.adapter.hasClass((0, $6446574c4c071af5$export$c1c0562ec8379000).ANIMATE);
    };
    /**
     * Returns true if the drawer is animating closed.
     * @return true if drawer is animating closed.
     */ MDCDismissibleDrawerFoundation.prototype.isClosing = function() {
        return this.adapter.hasClass((0, $6446574c4c071af5$export$c1c0562ec8379000).CLOSING);
    };
    /**
     * Keydown handler to close drawer when key is escape.
     */ MDCDismissibleDrawerFoundation.prototype.handleKeydown = function(evt) {
        var keyCode = evt.keyCode, key = evt.key;
        var isEscape = key === "Escape" || keyCode === 27;
        if (isEscape) this.close();
    };
    /**
     * Handles the `transitionend` event when the drawer finishes opening/closing.
     */ MDCDismissibleDrawerFoundation.prototype.handleTransitionEnd = function(evt) {
        var OPENING = (0, $6446574c4c071af5$export$c1c0562ec8379000).OPENING, CLOSING = (0, $6446574c4c071af5$export$c1c0562ec8379000).CLOSING, OPEN = (0, $6446574c4c071af5$export$c1c0562ec8379000).OPEN, ANIMATE = (0, $6446574c4c071af5$export$c1c0562ec8379000).ANIMATE, ROOT = (0, $6446574c4c071af5$export$c1c0562ec8379000).ROOT;
        // In Edge, transitionend on ripple pseudo-elements yields a target without classList, so check for Element first.
        var isRootElement = this.isElement(evt.target) && this.adapter.elementHasClass(evt.target, ROOT);
        if (!isRootElement) return;
        if (this.isClosing()) {
            this.adapter.removeClass(OPEN);
            this.closed();
            this.adapter.restoreFocus();
            this.adapter.notifyClose();
        } else {
            this.adapter.focusActiveNavigationItem();
            this.opened();
            this.adapter.notifyOpen();
        }
        this.adapter.removeClass(ANIMATE);
        this.adapter.removeClass(OPENING);
        this.adapter.removeClass(CLOSING);
    };
    /**
     * Extension point for when drawer finishes open animation.
     */ MDCDismissibleDrawerFoundation.prototype.opened = function() {}; // tslint:disable-line:no-empty
    /**
     * Extension point for when drawer finishes close animation.
     */ MDCDismissibleDrawerFoundation.prototype.closed = function() {}; // tslint:disable-line:no-empty
    /**
     * Runs the given logic on the next animation frame, using setTimeout to factor in Firefox reflow behavior.
     */ MDCDismissibleDrawerFoundation.prototype.runNextAnimationFrame = function(callback) {
        var _this = this;
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = requestAnimationFrame(function() {
            _this.animationFrame = 0;
            clearTimeout(_this.animationTimer);
            _this.animationTimer = setTimeout(callback, 0);
        });
    };
    MDCDismissibleDrawerFoundation.prototype.isElement = function(element) {
        // In Edge, transitionend on ripple pseudo-elements yields a target without classList.
        return Boolean(element.classList);
    };
    return MDCDismissibleDrawerFoundation;
}((0, $083166a0be1a9650$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$2d921ba4c89209e7$export$2e2bcd8739ae039 = $2d921ba4c89209e7$export$2853b38756d93afb;


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/* istanbul ignore next: subclass is not a branch statement */ var $57cc8ef58b8a1396$export$8441a583ee26171 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCModalDrawerFoundation, _super);
    function MDCModalDrawerFoundation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Handles click event on scrim.
     */ MDCModalDrawerFoundation.prototype.handleScrimClick = function() {
        this.close();
    };
    /**
     * Called when drawer finishes open animation.
     */ MDCModalDrawerFoundation.prototype.opened = function() {
        this.adapter.trapFocus();
    };
    /**
     * Called when drawer finishes close animation.
     */ MDCModalDrawerFoundation.prototype.closed = function() {
        this.adapter.releaseFocus();
    };
    return MDCModalDrawerFoundation;
}((0, $2d921ba4c89209e7$export$2853b38756d93afb));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$57cc8ef58b8a1396$export$2e2bcd8739ae039 = $57cc8ef58b8a1396$export$8441a583ee26171;







const $2451c29d355f65a8$var$blockingElements = document.$blockingElements;
class $2451c29d355f65a8$export$b66bc6457778cdcb extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this._previousFocus = null;
        this.open = false;
        this.hasHeader = false;
        this.type = "";
    }
    get mdcFoundationClass() {
        return this.type === "modal" ? (0, $57cc8ef58b8a1396$export$2e2bcd8739ae039) : (0, $2d921ba4c89209e7$export$2e2bcd8739ae039);
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot)), {
            elementHasClass: (element, className)=>element.classList.contains(className),
            saveFocus: ()=>{
                // Note, casting to avoid cumbersome runtime check.
                this._previousFocus = this.getRootNode().activeElement;
            },
            restoreFocus: ()=>{
                const previousFocus = this._previousFocus && this._previousFocus.focus;
                if (previousFocus) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this._previousFocus.focus();
            },
            notifyClose: ()=>{
                this.open = false;
                this.dispatchEvent(new Event((0, $6446574c4c071af5$export$21c51bc433c16634).CLOSE_EVENT, {
                    bubbles: true,
                    cancelable: true
                }));
            },
            notifyOpen: ()=>{
                this.open = true;
                this.dispatchEvent(new Event((0, $6446574c4c071af5$export$21c51bc433c16634).OPEN_EVENT, {
                    bubbles: true,
                    cancelable: true
                }));
            },
            focusActiveNavigationItem: ()=>{},
            trapFocus: ()=>{
                $2451c29d355f65a8$var$blockingElements.push(this);
                this.appContent.inert = true;
            },
            releaseFocus: ()=>{
                $2451c29d355f65a8$var$blockingElements.remove(this);
                this.appContent.inert = false;
            }
        });
    }
    _handleScrimClick() {
        if (this.mdcFoundation instanceof (0, $57cc8ef58b8a1396$export$2e2bcd8739ae039)) this.mdcFoundation.handleScrimClick();
    }
    render() {
        const dismissible = this.type === "dismissible" || this.type === "modal";
        const modal = this.type === "modal";
        const header = this.hasHeader ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-drawer__header">
        <h3 class="mdc-drawer__title"><slot name="title"></slot></h3>
        <h6 class="mdc-drawer__subtitle"><slot name="subtitle"></slot></h6>
        <slot name="header"></slot>
      </div>
      ` : "";
        const classes = {
            "mdc-drawer--dismissible": dismissible,
            "mdc-drawer--modal": modal
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <aside class="mdc-drawer ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        ${header}
        <div class="mdc-drawer__content"><slot></slot></div>
      </aside>
      ${modal ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div class="mdc-drawer-scrim"
                          @click="${this._handleScrimClick}"></div>` : ""}
      <div class="mdc-drawer-app-content">
        <slot name="appContent"></slot>
      </div>
      `;
    }
    // note, we avoid calling `super.firstUpdated()` to control when
    // `createFoundation()` is called.
    firstUpdated() {
        this.mdcRoot.addEventListener("keydown", (e)=>this.mdcFoundation.handleKeydown(e));
        this.mdcRoot.addEventListener("transitionend", (e)=>this.mdcFoundation.handleTransitionEnd(e));
    }
    updated(changedProperties) {
        if (changedProperties.has("type")) this.createFoundation();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-drawer")
], $2451c29d355f65a8$export$b66bc6457778cdcb.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-drawer-app-content")
], $2451c29d355f65a8$export$b66bc6457778cdcb.prototype, "appContent", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.type === "") return;
        if (value) this.mdcFoundation.open();
        else this.mdcFoundation.close();
    }),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $2451c29d355f65a8$export$b66bc6457778cdcb.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $2451c29d355f65a8$export$b66bc6457778cdcb.prototype, "hasHeader", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        reflect: true
    })
], $2451c29d355f65a8$export$b66bc6457778cdcb.prototype, "type", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $7225a19fef2c4b85$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-drawer{border-color:rgba(0, 0, 0, 0.12);background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-top-left-radius:0;border-top-right-radius:0;border-top-right-radius:var(--mdc-shape-large, 0);border-bottom-right-radius:0;border-bottom-right-radius:var(--mdc-shape-large, 0);border-bottom-left-radius:0;z-index:6;width:256px;display:flex;flex-direction:column;flex-shrink:0;box-sizing:border-box;height:100%;border-right-width:1px;border-right-style:solid;overflow:hidden;transition-property:transform;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}.mdc-drawer .mdc-drawer__title{color:rgba(0, 0, 0, 0.87)}.mdc-drawer .mdc-deprecated-list-group__subheader{color:rgba(0, 0, 0, 0.6)}.mdc-drawer .mdc-drawer__subtitle{color:rgba(0, 0, 0, 0.6)}.mdc-drawer .mdc-deprecated-list-item__graphic{color:rgba(0, 0, 0, 0.6)}.mdc-drawer .mdc-deprecated-list-item{color:rgba(0, 0, 0, 0.87)}.mdc-drawer .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:#6200ee}.mdc-drawer .mdc-deprecated-list-item--activated{color:rgba(98, 0, 238, 0.87)}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-top-left-radius:0;border-top-left-radius:var(--mdc-shape-large, 0);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-bottom-left-radius:var(--mdc-shape-large, 0)}.mdc-drawer .mdc-deprecated-list-item{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content{margin-left:256px;margin-right:0}[dir=rtl] .mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content,.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:256px}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-right-width:0;border-left-width:1px;border-right-style:none;border-left-style:solid}.mdc-drawer .mdc-deprecated-list-item{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);height:calc(48px - 2 * 4px);margin:8px 8px;padding:0 8px}.mdc-drawer .mdc-deprecated-list-item:nth-child(1){margin-top:2px}.mdc-drawer .mdc-deprecated-list-item:nth-last-child(1){margin-bottom:0}.mdc-drawer .mdc-deprecated-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin:0;padding:0 16px}.mdc-drawer .mdc-deprecated-list-group__subheader::before{display:inline-block;width:0;height:24px;content:"";vertical-align:0}.mdc-drawer .mdc-deprecated-list-divider{margin:3px 0 4px}.mdc-drawer .mdc-deprecated-list-item__text,.mdc-drawer .mdc-deprecated-list-item__graphic{pointer-events:none}.mdc-drawer--animate{transform:translateX(-100%)}[dir=rtl] .mdc-drawer--animate,.mdc-drawer--animate[dir=rtl]{transform:translateX(100%)}.mdc-drawer--opening{transform:translateX(0);transition-duration:250ms}[dir=rtl] .mdc-drawer--opening,.mdc-drawer--opening[dir=rtl]{transform:translateX(0)}.mdc-drawer--closing{transform:translateX(-100%);transition-duration:200ms}[dir=rtl] .mdc-drawer--closing,.mdc-drawer--closing[dir=rtl]{transform:translateX(100%)}.mdc-drawer__header{flex-shrink:0;box-sizing:border-box;min-height:64px;padding:0 16px 4px}.mdc-drawer__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-headline6-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size, 1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height, 2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight, 500);letter-spacing:0.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing, 0.0125em);text-decoration:inherit;text-decoration:var(--mdc-typography-headline6-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin-bottom:-20px}.mdc-drawer__title::before{display:inline-block;width:0;height:36px;content:"";vertical-align:0}.mdc-drawer__title::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}.mdc-drawer__subtitle{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin-bottom:0}.mdc-drawer__subtitle::before{display:inline-block;width:0;height:20px;content:"";vertical-align:0}.mdc-drawer__content{height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch}.mdc-drawer--dismissible{left:0;right:initial;display:none;position:absolute}[dir=rtl] .mdc-drawer--dismissible,.mdc-drawer--dismissible[dir=rtl]{left:initial;right:0}.mdc-drawer--dismissible.mdc-drawer--open{display:flex}.mdc-drawer-app-content{margin-left:0;margin-right:0;position:relative}[dir=rtl] .mdc-drawer-app-content,.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:0}.mdc-drawer--modal{box-shadow:0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0,0,0,.12);left:0;right:initial;display:none;position:fixed}.mdc-drawer--modal+.mdc-drawer-scrim{background-color:rgba(0, 0, 0, 0.32)}[dir=rtl] .mdc-drawer--modal,.mdc-drawer--modal[dir=rtl]{left:initial;right:0}.mdc-drawer--modal.mdc-drawer--open{display:flex}.mdc-drawer-scrim{display:none;position:fixed;top:0;left:0;width:100%;height:100%;z-index:5;transition-property:opacity;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}.mdc-drawer--open+.mdc-drawer-scrim{display:block}.mdc-drawer--animate+.mdc-drawer-scrim{opacity:0}.mdc-drawer--opening+.mdc-drawer-scrim{transition-duration:250ms;opacity:1}.mdc-drawer--closing+.mdc-drawer-scrim{transition-duration:200ms;opacity:0}.mdc-drawer-app-content{overflow:auto;flex:1}:host{display:flex;height:100%}.mdc-drawer{width:256px;width:var(--mdc-drawer-width, 256px)}.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content{margin-left:256px;margin-left:var(--mdc-drawer-width, 256px);margin-right:0}[dir=rtl] .mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content,.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:256px;margin-right:var(--mdc-drawer-width, 256px)}`;


let $d69217873ed80d92$export$4071300121a182f5 = class Drawer extends (0, $2451c29d355f65a8$export$b66bc6457778cdcb) {
};
$d69217873ed80d92$export$4071300121a182f5.styles = [
    (0, $7225a19fef2c4b85$export$9dd6ff9ea0189349)
];
$d69217873ed80d92$export$4071300121a182f5 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-drawer")
], $d69217873ed80d92$export$4071300121a182f5);


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 






class $6f5fb6998a067962$export$a2e32775fe3b6225 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.value = "";
        this.group = null;
        this.tabindex = -1;
        this.disabled = false;
        this.twoline = false;
        this.activated = false;
        this.graphic = null;
        this.multipleGraphics = false;
        this.hasMeta = false;
        this.noninteractive = false;
        this.selected = false;
        this.shouldRenderRipple = false;
        this._managingList = null;
        this.boundOnClick = this.onClick.bind(this);
        this._firstChanged = true;
        this._skipPropRequest = false;
        this.rippleHandlers = new (0, $e65e334fb304280d$export$9a192fb0d53f68ea)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
        this.listeners = [
            {
                target: this,
                eventNames: [
                    "click"
                ],
                cb: ()=>{
                    this.onClick();
                }
            },
            {
                target: this,
                eventNames: [
                    "mouseenter"
                ],
                cb: this.rippleHandlers.startHover
            },
            {
                target: this,
                eventNames: [
                    "mouseleave"
                ],
                cb: this.rippleHandlers.endHover
            },
            {
                target: this,
                eventNames: [
                    "focus"
                ],
                cb: this.rippleHandlers.startFocus
            },
            {
                target: this,
                eventNames: [
                    "blur"
                ],
                cb: this.rippleHandlers.endFocus
            },
            {
                target: this,
                eventNames: [
                    "mousedown",
                    "touchstart"
                ],
                cb: (e)=>{
                    const name = e.type;
                    this.onDown(name === "mousedown" ? "mouseup" : "touchend", e);
                }
            }
        ];
    }
    get text() {
        const textContent = this.textContent;
        return textContent ? textContent.trim() : "";
    }
    render() {
        const text = this.renderText();
        const graphic = this.graphic ? this.renderGraphic() : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
        const meta = this.hasMeta ? this.renderMeta() : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      ${this.renderRipple()}
      ${graphic}
      ${text}
      ${meta}`;
    }
    renderRipple() {
        if (this.shouldRenderRipple) return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-ripple
        .activated=${this.activated}>
      </mwc-ripple>`;
        else if (this.activated) return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div class="fake-activated-ripple"></div>`;
        else return "";
    }
    renderGraphic() {
        const graphicClasses = {
            multi: this.multipleGraphics
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__graphic material-icons ${(0, $0e5c059fc79abe53$export$56cc687933817664)(graphicClasses)}">
        <slot name="graphic"></slot>
      </span>`;
    }
    renderMeta() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__meta material-icons">
        <slot name="meta"></slot>
      </span>`;
    }
    renderText() {
        const inner = this.twoline ? this.renderTwoline() : this.renderSingleLine();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__text">
        ${inner}
      </span>`;
    }
    renderSingleLine() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    renderTwoline() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__primary-text">
        <slot></slot>
      </span>
      <span class="mdc-deprecated-list-item__secondary-text">
        <slot name="secondary"></slot>
      </span>
    `;
    }
    onClick() {
        this.fireRequestSelected(!this.selected, "interaction");
    }
    onDown(upName, evt) {
        const onUp = ()=>{
            window.removeEventListener(upName, onUp);
            this.rippleHandlers.endPress();
        };
        window.addEventListener(upName, onUp);
        this.rippleHandlers.startPress(evt);
    }
    fireRequestSelected(selected, source) {
        if (this.noninteractive) return;
        const customEv = new CustomEvent("request-selected", {
            bubbles: true,
            composed: true,
            detail: {
                source: source,
                selected: selected
            }
        });
        this.dispatchEvent(customEv);
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.noninteractive) this.setAttribute("mwc-list-item", "");
        for (const listener of this.listeners)for (const eventName of listener.eventNames)listener.target.addEventListener(eventName, listener.cb, {
            passive: true
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        for (const listener of this.listeners)for (const eventName of listener.eventNames)listener.target.removeEventListener(eventName, listener.cb);
        if (this._managingList) this._managingList.debouncedLayout ? this._managingList.debouncedLayout(true) : this._managingList.layout(true);
    }
    // composed flag, event fire through shadow root and up through composed tree
    firstUpdated() {
        const ev = new Event("list-item-rendered", {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(ev);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "slotElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $1f45ba04a1effcd1$export$163dfc35cc43f240)("mwc-ripple")
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "ripple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "group", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "tabindex", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (value) this.setAttribute("aria-disabled", "true");
        else this.setAttribute("aria-disabled", "false");
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "twoline", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "activated", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "graphic", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "multipleGraphics", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "hasMeta", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (value) {
            this.removeAttribute("aria-checked");
            this.removeAttribute("mwc-list-item");
            this.selected = false;
            this.activated = false;
            this.tabIndex = -1;
        } else this.setAttribute("mwc-list-item", "");
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "noninteractive", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        const role = this.getAttribute("role");
        const isAriaSelectable = role === "gridcell" || role === "option" || role === "row" || role === "tab";
        if (isAriaSelectable && value) this.setAttribute("aria-selected", "true");
        else if (isAriaSelectable) this.setAttribute("aria-selected", "false");
        if (this._firstChanged) {
            this._firstChanged = false;
            return;
        }
        if (this._skipPropRequest) return;
        this.fireRequestSelected(value, "property");
    })
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "selected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "shouldRenderRipple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $6f5fb6998a067962$export$a2e32775fe3b6225.prototype, "_managingList", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $eb4a1979bab14d1a$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;height:48px;display:flex;position:relative;align-items:center;justify-content:flex-start;overflow:hidden;padding:0;padding-left:var(--mdc-list-side-padding, 16px);padding-right:var(--mdc-list-side-padding, 16px);outline:none;height:48px;color:rgba(0,0,0,.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87))}:host:focus{outline:none}:host([activated]){color:#6200ee;color:var(--mdc-theme-primary, #6200ee);--mdc-ripple-color: var( --mdc-theme-primary, #6200ee )}:host([activated]) .mdc-deprecated-list-item__graphic{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host([activated]) .fake-activated-ripple::before{position:absolute;display:block;top:0;bottom:0;left:0;right:0;width:100%;height:100%;pointer-events:none;z-index:1;content:"";opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12);background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-deprecated-list-item__graphic{flex-shrink:0;align-items:center;justify-content:center;fill:currentColor;display:inline-flex}.mdc-deprecated-list-item__graphic ::slotted(*){flex-shrink:0;align-items:center;justify-content:center;fill:currentColor;width:100%;height:100%;text-align:center}.mdc-deprecated-list-item__meta{width:var(--mdc-list-item-meta-size, 24px);height:var(--mdc-list-item-meta-size, 24px);margin-left:auto;margin-right:0;color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-hint-on-background, rgba(0, 0, 0, 0.38))}.mdc-deprecated-list-item__meta.multi{width:auto}.mdc-deprecated-list-item__meta ::slotted(*){width:var(--mdc-list-item-meta-size, 24px);line-height:var(--mdc-list-item-meta-size, 24px)}.mdc-deprecated-list-item__meta ::slotted(.material-icons),.mdc-deprecated-list-item__meta ::slotted(mwc-icon){line-height:var(--mdc-list-item-meta-size, 24px) !important}.mdc-deprecated-list-item__meta ::slotted(:not(.material-icons):not(mwc-icon)){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit)}[dir=rtl] .mdc-deprecated-list-item__meta,.mdc-deprecated-list-item__meta[dir=rtl]{margin-left:0;margin-right:auto}.mdc-deprecated-list-item__meta ::slotted(*){width:100%;height:100%}.mdc-deprecated-list-item__text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-deprecated-list-item__text ::slotted([for]),.mdc-deprecated-list-item__text[for]{pointer-events:none}.mdc-deprecated-list-item__primary-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:block;margin-top:0;line-height:normal;margin-bottom:-20px;display:block}.mdc-deprecated-list-item__primary-text::before{display:inline-block;width:0;height:32px;content:"";vertical-align:0}.mdc-deprecated-list-item__primary-text::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}.mdc-deprecated-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:block;margin-top:0;line-height:normal;display:block}.mdc-deprecated-list-item__secondary-text::before{display:inline-block;width:0;height:20px;content:"";vertical-align:0}.mdc-deprecated-list--dense .mdc-deprecated-list-item__secondary-text{font-size:inherit}* ::slotted(a),a{color:inherit;text-decoration:none}:host([twoline]){height:72px}:host([twoline]) .mdc-deprecated-list-item__text{align-self:flex-start}:host([disabled]),:host([noninteractive]){cursor:default;pointer-events:none}:host([disabled]) .mdc-deprecated-list-item__text ::slotted(*){opacity:.38}:host([disabled]) .mdc-deprecated-list-item__text ::slotted(*),:host([disabled]) .mdc-deprecated-list-item__primary-text ::slotted(*),:host([disabled]) .mdc-deprecated-list-item__secondary-text ::slotted(*){color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-deprecated-list-item__secondary-text ::slotted(*){color:rgba(0, 0, 0, 0.54);color:var(--mdc-theme-text-secondary-on-background, rgba(0, 0, 0, 0.54))}.mdc-deprecated-list-item__graphic ::slotted(*){background-color:transparent;color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-icon-on-background, rgba(0, 0, 0, 0.38))}.mdc-deprecated-list-group__subheader ::slotted(*){color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87))}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 40px);height:var(--mdc-list-item-graphic-size, 40px)}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 40px);line-height:var(--mdc-list-item-graphic-size, 40px)}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 40px) !important}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(*){border-radius:50%}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic,:host([graphic=medium]) .mdc-deprecated-list-item__graphic,:host([graphic=large]) .mdc-deprecated-list-item__graphic,:host([graphic=control]) .mdc-deprecated-list-item__graphic{margin-left:0;margin-right:var(--mdc-list-item-graphic-margin, 16px)}[dir=rtl] :host([graphic=avatar]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=medium]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=large]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=control]) .mdc-deprecated-list-item__graphic,:host([graphic=avatar]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=medium]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=large]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=control]) .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:var(--mdc-list-item-graphic-margin, 16px);margin-right:0}:host([graphic=icon]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 24px);height:var(--mdc-list-item-graphic-size, 24px);margin-left:0;margin-right:var(--mdc-list-item-graphic-margin, 32px)}:host([graphic=icon]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 24px);line-height:var(--mdc-list-item-graphic-size, 24px)}:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 24px) !important}[dir=rtl] :host([graphic=icon]) .mdc-deprecated-list-item__graphic,:host([graphic=icon]) .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:var(--mdc-list-item-graphic-margin, 32px);margin-right:0}:host([graphic=avatar]:not([twoLine])),:host([graphic=icon]:not([twoLine])){height:56px}:host([graphic=medium]:not([twoLine])),:host([graphic=large]:not([twoLine])){height:72px}:host([graphic=medium]) .mdc-deprecated-list-item__graphic,:host([graphic=large]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 56px);height:var(--mdc-list-item-graphic-size, 56px)}:host([graphic=medium]) .mdc-deprecated-list-item__graphic.multi,:host([graphic=large]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(*),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 56px);line-height:var(--mdc-list-item-graphic-size, 56px)}:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 56px) !important}:host([graphic=large]){padding-left:0px}`;


let $577605d449f97a72$export$a7b06bfba60a8a78 = class ListItem extends (0, $6f5fb6998a067962$export$a2e32775fe3b6225) {
};
$577605d449f97a72$export$a7b06bfba60a8a78.styles = [
    (0, $eb4a1979bab14d1a$export$9dd6ff9ea0189349)
];
$577605d449f97a72$export$a7b06bfba60a8a78 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-list-item")
], $577605d449f97a72$export$a7b06bfba60a8a78);








/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $649c763732d5342f$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$649c763732d5342f$export$2e2bcd8739ae039 = $649c763732d5342f$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * KEY provides normalized string values for keys.
 */ var $e28d68f07698296e$export$7167c830cefcb6b5 = {
    UNKNOWN: "Unknown",
    BACKSPACE: "Backspace",
    ENTER: "Enter",
    SPACEBAR: "Spacebar",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    END: "End",
    HOME: "Home",
    ARROW_LEFT: "ArrowLeft",
    ARROW_UP: "ArrowUp",
    ARROW_RIGHT: "ArrowRight",
    ARROW_DOWN: "ArrowDown",
    DELETE: "Delete",
    ESCAPE: "Escape",
    TAB: "Tab"
};
var $e28d68f07698296e$var$normalizedKeys = new Set();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.BACKSPACE);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ENTER);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.SPACEBAR);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.PAGE_UP);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.PAGE_DOWN);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.END);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.HOME);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_LEFT);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_UP);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_RIGHT);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_DOWN);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.DELETE);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ESCAPE);
$e28d68f07698296e$var$normalizedKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.TAB);
var $e28d68f07698296e$var$KEY_CODE = {
    BACKSPACE: 8,
    ENTER: 13,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ESCAPE: 27,
    TAB: 9
};
var $e28d68f07698296e$var$mappedKeyCodes = new Map();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.BACKSPACE, $e28d68f07698296e$export$7167c830cefcb6b5.BACKSPACE);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ENTER, $e28d68f07698296e$export$7167c830cefcb6b5.ENTER);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.SPACEBAR, $e28d68f07698296e$export$7167c830cefcb6b5.SPACEBAR);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.PAGE_UP, $e28d68f07698296e$export$7167c830cefcb6b5.PAGE_UP);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.PAGE_DOWN, $e28d68f07698296e$export$7167c830cefcb6b5.PAGE_DOWN);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.END, $e28d68f07698296e$export$7167c830cefcb6b5.END);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.HOME, $e28d68f07698296e$export$7167c830cefcb6b5.HOME);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ARROW_LEFT, $e28d68f07698296e$export$7167c830cefcb6b5.ARROW_LEFT);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ARROW_UP, $e28d68f07698296e$export$7167c830cefcb6b5.ARROW_UP);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ARROW_RIGHT, $e28d68f07698296e$export$7167c830cefcb6b5.ARROW_RIGHT);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ARROW_DOWN, $e28d68f07698296e$export$7167c830cefcb6b5.ARROW_DOWN);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.DELETE, $e28d68f07698296e$export$7167c830cefcb6b5.DELETE);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.ESCAPE, $e28d68f07698296e$export$7167c830cefcb6b5.ESCAPE);
$e28d68f07698296e$var$mappedKeyCodes.set($e28d68f07698296e$var$KEY_CODE.TAB, $e28d68f07698296e$export$7167c830cefcb6b5.TAB);
var $e28d68f07698296e$var$navigationKeys = new Set();
// IE11 has no support for new Set with iterable so we need to initialize this
// by hand.
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.PAGE_UP);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.PAGE_DOWN);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.END);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.HOME);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_LEFT);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_UP);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_RIGHT);
$e28d68f07698296e$var$navigationKeys.add($e28d68f07698296e$export$7167c830cefcb6b5.ARROW_DOWN);
function $e28d68f07698296e$export$e0c709538cb8ae18(evt) {
    var key = evt.key;
    // If the event already has a normalized key, return it
    if ($e28d68f07698296e$var$normalizedKeys.has(key)) return key;
    // tslint:disable-next-line:deprecation
    var mappedKey = $e28d68f07698296e$var$mappedKeyCodes.get(evt.keyCode);
    if (mappedKey) return mappedKey;
    return $e28d68f07698296e$export$7167c830cefcb6b5.UNKNOWN;
}
function $e28d68f07698296e$export$15e092e359be91e2(evt) {
    return $e28d68f07698296e$var$navigationKeys.has($e28d68f07698296e$export$e0c709538cb8ae18(evt));
}


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $7be74a7ef277def2$var$_a, $7be74a7ef277def2$var$_b;
var $7be74a7ef277def2$export$c1c0562ec8379000 = {
    LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
    LIST_ITEM_CLASS: "mdc-list-item",
    LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
    LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
    LIST_ITEM_TEXT_CLASS: "mdc-list-item__text",
    LIST_ITEM_PRIMARY_TEXT_CLASS: "mdc-list-item__primary-text",
    ROOT: "mdc-list"
};
var $7be74a7ef277def2$export$4e3f9f206c48734b = ($7be74a7ef277def2$var$_a = {}, $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-list-item--activated", $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-list-item", $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-list-item--disabled", $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-list-item--selected", $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-list-item__primary-text", $7be74a7ef277def2$var$_a["" + $7be74a7ef277def2$export$c1c0562ec8379000.ROOT] = "mdc-list", $7be74a7ef277def2$var$_a);
var $7be74a7ef277def2$export$58c7601cd6e42ae1 = ($7be74a7ef277def2$var$_b = {}, $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-deprecated-list-item--activated", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-deprecated-list-item", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-deprecated-list-item--disabled", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-deprecated-list-item--selected", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_TEXT_CLASS] = "mdc-deprecated-list-item__text", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-deprecated-list-item__primary-text", $7be74a7ef277def2$var$_b["" + $7be74a7ef277def2$export$c1c0562ec8379000.ROOT] = "mdc-deprecated-list", $7be74a7ef277def2$var$_b);
var $7be74a7ef277def2$export$21c51bc433c16634 = {
    ACTION_EVENT: "MDCList:action",
    SELECTION_CHANGE_EVENT: "MDCList:selectionChange",
    ARIA_CHECKED: "aria-checked",
    ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
    ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
    ARIA_CURRENT: "aria-current",
    ARIA_DISABLED: "aria-disabled",
    ARIA_ORIENTATION: "aria-orientation",
    ARIA_ORIENTATION_HORIZONTAL: "horizontal",
    ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
    ARIA_SELECTED: "aria-selected",
    ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
    ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
    CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
    CHECKBOX_SELECTOR: 'input[type="checkbox"]',
    CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a\n  ",
    DEPRECATED_SELECTOR: ".mdc-deprecated-list",
    FOCUSABLE_CHILD_ELEMENTS: "\n    ." + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + $7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled),\n    .' + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a,\n    ." + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="radio"]:not(:disabled),\n    .' + $7be74a7ef277def2$export$58c7601cd6e42ae1[$7be74a7ef277def2$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="checkbox"]:not(:disabled)\n  ',
    RADIO_SELECTOR: 'input[type="radio"]',
    SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
};
var $7be74a7ef277def2$export$1f6c9cc012ebacae = {
    UNSET_INDEX: -1,
    TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
};
var $7be74a7ef277def2$export$37a660f6ba30d8b = "evolution";


const $d1828ec65f014f9c$var$integerSort = (a, b)=>{
    return a - b;
};
const $d1828ec65f014f9c$var$findIndexDiff = (oldSet, newSet)=>{
    const oldArr = Array.from(oldSet);
    const newArr = Array.from(newSet);
    const diff = {
        added: [],
        removed: []
    };
    const oldSorted = oldArr.sort($d1828ec65f014f9c$var$integerSort);
    const newSorted = newArr.sort($d1828ec65f014f9c$var$integerSort);
    let i = 0;
    let j = 0;
    while(i < oldSorted.length || j < newSorted.length){
        const oldVal = oldSorted[i];
        const newVal = newSorted[j];
        if (oldVal === newVal) {
            i++;
            j++;
            continue;
        }
        if (oldVal !== undefined && (newVal === undefined || oldVal < newVal)) {
            diff.removed.push(oldVal);
            i++;
            continue;
        }
        if (newVal !== undefined && (oldVal === undefined || newVal < oldVal)) {
            diff.added.push(newVal);
            j++;
            continue;
        }
    }
    return diff;
};
const $d1828ec65f014f9c$var$ELEMENTS_KEY_ALLOWED_IN = [
    "input",
    "button",
    "textarea",
    "select"
];
function $d1828ec65f014f9c$export$859dd8be312c112(selectedIndex) {
    return selectedIndex instanceof Set;
}
function $d1828ec65f014f9c$export$edc86bddb6888d05(evt) {
    return $d1828ec65f014f9c$export$859dd8be312c112(evt.detail.index);
}
const $d1828ec65f014f9c$export$cb327cf74b9b3806 = (index)=>{
    const entry = index === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX ? new Set() : index;
    return $d1828ec65f014f9c$export$859dd8be312c112(entry) ? new Set(entry) : new Set([
        entry
    ]);
};
class $d1828ec65f014f9c$export$7a84b4bb1a2b9eb9 extends (0, $649c763732d5342f$export$a81b11d69c993162) {
    constructor(adapter){
        super(Object.assign(Object.assign({}, $d1828ec65f014f9c$export$7a84b4bb1a2b9eb9.defaultAdapter), adapter));
        this.isMulti_ = false;
        this.wrapFocus_ = false;
        this.isVertical_ = true;
        this.selectedIndex_ = (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX;
        this.focusedItemIndex_ = (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX;
        this.useActivatedClass_ = false;
        this.ariaCurrentAttrValue_ = null;
    }
    static get strings() {
        return 0, $7be74a7ef277def2$export$21c51bc433c16634;
    }
    static get numbers() {
        return 0, $7be74a7ef277def2$export$1f6c9cc012ebacae;
    }
    static get defaultAdapter() {
        return {
            focusItemAtIndex: ()=>undefined,
            getFocusedElementIndex: ()=>0,
            getListItemCount: ()=>0,
            isFocusInsideList: ()=>false,
            isRootFocused: ()=>false,
            notifyAction: ()=>undefined,
            notifySelected: ()=>undefined,
            getSelectedStateForElementIndex: ()=>false,
            setDisabledStateForElementIndex: ()=>undefined,
            getDisabledStateForElementIndex: ()=>false,
            setSelectedStateForElementIndex: ()=>undefined,
            setActivatedStateForElementIndex: ()=>undefined,
            setTabIndexForElementIndex: ()=>undefined,
            setAttributeForElementIndex: ()=>undefined,
            getAttributeForElementIndex: ()=>null
        };
    }
    /**
     * Sets the private wrapFocus_ variable.
     */ setWrapFocus(value) {
        this.wrapFocus_ = value;
    }
    /**
     * Sets the private wrapFocus_ variable.
     */ setMulti(value) {
        this.isMulti_ = value;
        const currentIndex = this.selectedIndex_;
        if (value) // number to set
        {
            if (!$d1828ec65f014f9c$export$859dd8be312c112(currentIndex)) {
                const isUnset = currentIndex === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX;
                this.selectedIndex_ = isUnset ? new Set() : new Set([
                    currentIndex
                ]);
            }
        } else // set to first sorted number in set
        if ($d1828ec65f014f9c$export$859dd8be312c112(currentIndex)) {
            if (currentIndex.size) {
                const vals = Array.from(currentIndex).sort($d1828ec65f014f9c$var$integerSort);
                this.selectedIndex_ = vals[0];
            } else this.selectedIndex_ = (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX;
        }
    }
    /**
     * Sets the isVertical_ private variable.
     */ setVerticalOrientation(value) {
        this.isVertical_ = value;
    }
    /**
     * Sets the useActivatedClass_ private variable.
     */ setUseActivatedClass(useActivated) {
        this.useActivatedClass_ = useActivated;
    }
    getSelectedIndex() {
        return this.selectedIndex_;
    }
    setSelectedIndex(index) {
        if (!this.isIndexValid_(index)) return;
        if (this.isMulti_) this.setMultiSelectionAtIndex_($d1828ec65f014f9c$export$cb327cf74b9b3806(index));
        else this.setSingleSelectionAtIndex_(index);
    }
    /**
     * Focus in handler for the list items.
     */ handleFocusIn(_, listItemIndex) {
        if (listItemIndex >= 0) this.adapter.setTabIndexForElementIndex(listItemIndex, 0);
    }
    /**
     * Focus out handler for the list items.
     */ handleFocusOut(_, listItemIndex) {
        if (listItemIndex >= 0) this.adapter.setTabIndexForElementIndex(listItemIndex, -1);
        /**
         * Between Focusout & Focusin some browsers do not have focus on any
         * element. Setting a delay to wait till the focus is moved to next element.
         */ setTimeout(()=>{
            if (!this.adapter.isFocusInsideList()) this.setTabindexToFirstSelectedItem_();
        }, 0);
    }
    /**
     * Key handler for the list.
     */ handleKeydown(event, isRootListItem, listItemIndex) {
        const isArrowLeft = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "ArrowLeft";
        const isArrowUp = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "ArrowUp";
        const isArrowRight = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "ArrowRight";
        const isArrowDown = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "ArrowDown";
        const isHome = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "Home";
        const isEnd = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "End";
        const isEnter = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "Enter";
        const isSpace = (0, $e28d68f07698296e$export$e0c709538cb8ae18)(event) === "Spacebar";
        if (this.adapter.isRootFocused()) {
            if (isArrowUp || isEnd) {
                event.preventDefault();
                this.focusLastElement();
            } else if (isArrowDown || isHome) {
                event.preventDefault();
                this.focusFirstElement();
            }
            return;
        }
        let currentIndex = this.adapter.getFocusedElementIndex();
        if (currentIndex === -1) {
            currentIndex = listItemIndex;
            if (currentIndex < 0) // If this event doesn't have a mdc-deprecated-list-item ancestor from
            // the current list (not from a sublist), return early.
            return;
        }
        let nextIndex;
        if (this.isVertical_ && isArrowDown || !this.isVertical_ && isArrowRight) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusNextElement(currentIndex);
        } else if (this.isVertical_ && isArrowUp || !this.isVertical_ && isArrowLeft) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusPrevElement(currentIndex);
        } else if (isHome) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusFirstElement();
        } else if (isEnd) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusLastElement();
        } else if (isEnter || isSpace) {
            if (isRootListItem) {
                // Return early if enter key is pressed on anchor element which triggers
                // synthetic MouseEvent event.
                const target = event.target;
                if (target && target.tagName === "A" && isEnter) return;
                this.preventDefaultEvent(event);
                this.setSelectedIndexOnAction_(currentIndex, true);
            }
        }
        this.focusedItemIndex_ = currentIndex;
        if (nextIndex !== undefined) {
            this.setTabindexAtIndex_(nextIndex);
            this.focusedItemIndex_ = nextIndex;
        }
    }
    /**
     * Click handler for the list.
     */ handleSingleSelection(index, isInteraction, force) {
        if (index === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX) return;
        this.setSelectedIndexOnAction_(index, isInteraction, force);
        this.setTabindexAtIndex_(index);
        this.focusedItemIndex_ = index;
    }
    /**
     * Focuses the next element on the list.
     */ focusNextElement(index) {
        const count = this.adapter.getListItemCount();
        let nextIndex = index + 1;
        if (nextIndex >= count) {
            if (this.wrapFocus_) nextIndex = 0;
            else // Return early because last item is already focused.
            return index;
        }
        this.adapter.focusItemAtIndex(nextIndex);
        return nextIndex;
    }
    /**
     * Focuses the previous element on the list.
     */ focusPrevElement(index) {
        let prevIndex = index - 1;
        if (prevIndex < 0) {
            if (this.wrapFocus_) prevIndex = this.adapter.getListItemCount() - 1;
            else // Return early because first item is already focused.
            return index;
        }
        this.adapter.focusItemAtIndex(prevIndex);
        return prevIndex;
    }
    focusFirstElement() {
        this.adapter.focusItemAtIndex(0);
        return 0;
    }
    focusLastElement() {
        const lastIndex = this.adapter.getListItemCount() - 1;
        this.adapter.focusItemAtIndex(lastIndex);
        return lastIndex;
    }
    /**
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ setEnabled(itemIndex, isEnabled) {
        if (!this.isIndexValid_(itemIndex)) return;
        this.adapter.setDisabledStateForElementIndex(itemIndex, !isEnabled);
    }
    /**
     * Ensures that preventDefault is only called if the containing element
     * doesn't consume the event, and it will cause an unintended scroll.
     */ preventDefaultEvent(evt) {
        const target = evt.target;
        const tagName = `${target.tagName}`.toLowerCase();
        if ($d1828ec65f014f9c$var$ELEMENTS_KEY_ALLOWED_IN.indexOf(tagName) === -1) evt.preventDefault();
    }
    setSingleSelectionAtIndex_(index, isInteraction = true) {
        if (this.selectedIndex_ === index) return;
        // unset previous
        if (this.selectedIndex_ !== (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX) {
            this.adapter.setSelectedStateForElementIndex(this.selectedIndex_, false);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(this.selectedIndex_, false);
        }
        // set new
        if (isInteraction) this.adapter.setSelectedStateForElementIndex(index, true);
        if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(index, true);
        this.setAriaForSingleSelectionAtIndex_(index);
        this.selectedIndex_ = index;
        this.adapter.notifySelected(index);
    }
    setMultiSelectionAtIndex_(newIndex, isInteraction = true) {
        const oldIndex = $d1828ec65f014f9c$export$cb327cf74b9b3806(this.selectedIndex_);
        const diff = $d1828ec65f014f9c$var$findIndexDiff(oldIndex, newIndex);
        if (!diff.removed.length && !diff.added.length) return;
        for (const removed of diff.removed){
            if (isInteraction) this.adapter.setSelectedStateForElementIndex(removed, false);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(removed, false);
        }
        for (const added of diff.added){
            if (isInteraction) this.adapter.setSelectedStateForElementIndex(added, true);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(added, true);
        }
        this.selectedIndex_ = newIndex;
        this.adapter.notifySelected(newIndex, diff);
    }
    /**
     * Sets aria attribute for single selection at given index.
     */ setAriaForSingleSelectionAtIndex_(index) {
        // Detect the presence of aria-current and get the value only during list
        // initialization when it is in unset state.
        if (this.selectedIndex_ === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX) this.ariaCurrentAttrValue_ = this.adapter.getAttributeForElementIndex(index, (0, $7be74a7ef277def2$export$21c51bc433c16634).ARIA_CURRENT);
        const isAriaCurrent = this.ariaCurrentAttrValue_ !== null;
        const ariaAttribute = isAriaCurrent ? (0, $7be74a7ef277def2$export$21c51bc433c16634).ARIA_CURRENT : (0, $7be74a7ef277def2$export$21c51bc433c16634).ARIA_SELECTED;
        if (this.selectedIndex_ !== (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX) this.adapter.setAttributeForElementIndex(this.selectedIndex_, ariaAttribute, "false");
        const ariaAttributeValue = isAriaCurrent ? this.ariaCurrentAttrValue_ : "true";
        this.adapter.setAttributeForElementIndex(index, ariaAttribute, ariaAttributeValue);
    }
    setTabindexAtIndex_(index) {
        if (this.focusedItemIndex_ === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX && index !== 0) // If no list item was selected set first list item's tabindex to -1.
        // Generally, tabindex is set to 0 on first list item of list that has no
        // preselected items.
        this.adapter.setTabIndexForElementIndex(0, -1);
        else if (this.focusedItemIndex_ >= 0 && this.focusedItemIndex_ !== index) this.adapter.setTabIndexForElementIndex(this.focusedItemIndex_, -1);
        this.adapter.setTabIndexForElementIndex(index, 0);
    }
    setTabindexToFirstSelectedItem_() {
        let targetIndex = 0;
        if (typeof this.selectedIndex_ === "number" && this.selectedIndex_ !== (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX) targetIndex = this.selectedIndex_;
        else if ($d1828ec65f014f9c$export$859dd8be312c112(this.selectedIndex_) && this.selectedIndex_.size > 0) targetIndex = Math.min(...this.selectedIndex_);
        this.setTabindexAtIndex_(targetIndex);
    }
    isIndexValid_(index) {
        if (index instanceof Set) {
            if (!this.isMulti_) throw new Error("MDCListFoundation: Array of index is only supported for checkbox based list");
            if (index.size === 0) return true;
            else {
                let isOneInRange = false;
                for (const entry of index){
                    isOneInRange = this.isIndexInRange_(entry);
                    if (isOneInRange) break;
                }
                return isOneInRange;
            }
        } else if (typeof index === "number") {
            if (this.isMulti_) throw new Error("MDCListFoundation: Expected array of index for checkbox based list but got number: " + index);
            return index === (0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX || this.isIndexInRange_(index);
        } else return false;
    }
    isIndexInRange_(index) {
        const listSize = this.adapter.getListItemCount();
        return index >= 0 && index < listSize;
    }
    /**
     * Sets selected index on user action, toggles checkbox / radio based on
     * toggleCheckbox value. User interaction should not toggle list item(s) when
     * disabled.
     */ setSelectedIndexOnAction_(index, isInteraction, force) {
        if (this.adapter.getDisabledStateForElementIndex(index)) return;
        let checkedIndex = index;
        if (this.isMulti_) checkedIndex = new Set([
            index
        ]);
        if (!this.isIndexValid_(checkedIndex)) return;
        if (this.isMulti_) this.toggleMultiAtIndex(index, force, isInteraction);
        else if (isInteraction || force) this.setSingleSelectionAtIndex_(index, isInteraction);
        else {
            const isDeselection = this.selectedIndex_ === index;
            if (isDeselection) this.setSingleSelectionAtIndex_((0, $7be74a7ef277def2$export$1f6c9cc012ebacae).UNSET_INDEX);
        }
        if (isInteraction) this.adapter.notifyAction(index);
    }
    toggleMultiAtIndex(index, force, isInteraction = true) {
        let newSelectionValue = false;
        if (force === undefined) newSelectionValue = !this.adapter.getSelectedStateForElementIndex(index);
        else newSelectionValue = force;
        const newSet = $d1828ec65f014f9c$export$cb327cf74b9b3806(this.selectedIndex_);
        if (newSelectionValue) newSet.add(index);
        else newSet.delete(index);
        this.setMultiSelectionAtIndex_(newSet, isInteraction);
    }
}
var // tslint:disable-next-line:no-default-export Needed for backward compatibility
// with MDC Web v0.44.0 and earlier.
$d1828ec65f014f9c$export$2e2bcd8739ae039 = $d1828ec65f014f9c$export$7a84b4bb1a2b9eb9;


function $efa3bb9ab8d1fa2f$var$debounceLayout(callback, waitInMS = 50) {
    let timeoutId;
    // tslint:disable-next-line
    return function(updateItems = true) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            callback(updateItems);
        }, waitInMS);
    };
}
const $efa3bb9ab8d1fa2f$var$isListItem = (element)=>{
    return element.hasAttribute("mwc-list-item");
};
function $efa3bb9ab8d1fa2f$var$clearAndCreateItemsReadyPromise() {
    const oldResolver = this.itemsReadyResolver;
    this.itemsReady = new Promise((res)=>{
        // TODO(b/175626389): Type '(value: never[] | PromiseLike<never[]>) => void'
        // is not assignable to type '(value?: never[] | PromiseLike<never[]> |
        // undefined) => void'.
        return this.itemsReadyResolver = res;
    });
    oldResolver();
}
class $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super();
        this.mdcAdapter = null;
        this.mdcFoundationClass = (0, $d1828ec65f014f9c$export$2e2bcd8739ae039);
        this.activatable = false;
        this.multi = false;
        this.wrapFocus = false;
        this.itemRoles = null;
        this.innerRole = null;
        this.innerAriaLabel = null;
        this.rootTabbable = false;
        this.previousTabindex = null;
        this.noninteractive = false;
        this.itemsReadyResolver = ()=>{
        //
        };
        this.itemsReady = Promise.resolve([]);
        // tslint:enable:ban-ts-ignore
        this.items_ = [];
        const debouncedFunction = $efa3bb9ab8d1fa2f$var$debounceLayout(this.layout.bind(this));
        this.debouncedLayout = (updateItems = true)=>{
            $efa3bb9ab8d1fa2f$var$clearAndCreateItemsReadyPromise.call(this);
            debouncedFunction(updateItems);
        };
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        // @ts-ignore
        const result = await super.getUpdateComplete();
        await this.itemsReady;
        return result;
    }
    get items() {
        return this.items_;
    }
    updateItems() {
        var _a;
        const nodes = (_a = this.assignedElements) !== null && _a !== void 0 ? _a : [];
        const listItems = [];
        for (const node of nodes){
            if ($efa3bb9ab8d1fa2f$var$isListItem(node)) {
                listItems.push(node);
                node._managingList = this;
            }
            if (node.hasAttribute("divider") && !node.hasAttribute("role")) node.setAttribute("role", "separator");
        }
        this.items_ = listItems;
        const selectedIndices = new Set();
        this.items_.forEach((item, index)=>{
            if (this.itemRoles) item.setAttribute("role", this.itemRoles);
            else item.removeAttribute("role");
            if (item.selected) selectedIndices.add(index);
        });
        if (this.multi) this.select(selectedIndices);
        else {
            const index = selectedIndices.size ? selectedIndices.entries().next().value[1] : -1;
            this.select(index);
        }
        const itemsUpdatedEv = new Event("items-updated", {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(itemsUpdatedEv);
    }
    get selected() {
        const index = this.index;
        if (!(0, $d1828ec65f014f9c$export$859dd8be312c112)(index)) {
            if (index === -1) return null;
            return this.items[index];
        }
        const selected = [];
        for (const entry of index)selected.push(this.items[entry]);
        return selected;
    }
    get index() {
        if (this.mdcFoundation) return this.mdcFoundation.getSelectedIndex();
        return -1;
    }
    render() {
        const role = this.innerRole === null ? undefined : this.innerRole;
        const ariaLabel = this.innerAriaLabel === null ? undefined : this.innerAriaLabel;
        const tabindex = this.rootTabbable ? "0" : "-1";
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <!-- @ts-ignore -->
      <ul
          tabindex=${tabindex}
          role="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(role)}"
          aria-label="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaLabel)}"
          class="mdc-deprecated-list"
          @keydown=${this.onKeydown}
          @focusin=${this.onFocusIn}
          @focusout=${this.onFocusOut}
          @request-selected=${this.onRequestSelected}
          @list-item-rendered=${this.onListItemConnected}>
        <slot></slot>
        ${this.renderPlaceholder()}
      </ul>
    `;
    }
    renderPlaceholder() {
        var _a;
        const nodes = (_a = this.assignedElements) !== null && _a !== void 0 ? _a : [];
        if (this.emptyMessage !== undefined && nodes.length === 0) return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <mwc-list-item noninteractive>${this.emptyMessage}</mwc-list-item>
      `;
        return null;
    }
    firstUpdated() {
        super.firstUpdated();
        if (!this.items.length) {
            // required because this is called before observers
            this.mdcFoundation.setMulti(this.multi);
            // for when children upgrade before list
            this.layout();
        }
    }
    onFocusIn(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            this.mdcFoundation.handleFocusIn(evt, index);
        }
    }
    onFocusOut(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            this.mdcFoundation.handleFocusOut(evt, index);
        }
    }
    onKeydown(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            const target = evt.target;
            const isRootListItem = $efa3bb9ab8d1fa2f$var$isListItem(target);
            this.mdcFoundation.handleKeydown(evt, isRootListItem, index);
        }
    }
    onRequestSelected(evt) {
        if (this.mdcFoundation) {
            let index = this.getIndexOfTarget(evt);
            // might happen in shady dom slowness. Recalc children
            if (index === -1) {
                this.layout();
                index = this.getIndexOfTarget(evt);
                // still not found; may not be mwc-list-item. Unsupported case.
                if (index === -1) return;
            }
            const element = this.items[index];
            if (element.disabled) return;
            const selected = evt.detail.selected;
            const source = evt.detail.source;
            this.mdcFoundation.handleSingleSelection(index, source === "interaction", selected);
            evt.stopPropagation();
        }
    }
    getIndexOfTarget(evt) {
        const elements = this.items;
        const path = evt.composedPath();
        for (const pathItem of path){
            let index = -1;
            if ((0, $748a8e1d68854803$export$c86dc70db5dbb27d)(pathItem) && $efa3bb9ab8d1fa2f$var$isListItem(pathItem)) index = elements.indexOf(pathItem);
            if (index !== -1) return index;
        }
        return -1;
    }
    createAdapter() {
        this.mdcAdapter = {
            getListItemCount: ()=>{
                if (this.mdcRoot) return this.items.length;
                return 0;
            },
            getFocusedElementIndex: this.getFocusedItemIndex,
            getAttributeForElementIndex: (index, attr)=>{
                const listElement = this.mdcRoot;
                if (!listElement) return "";
                const element = this.items[index];
                return element ? element.getAttribute(attr) : "";
            },
            setAttributeForElementIndex: (index, attr, val)=>{
                if (!this.mdcRoot) return;
                const element = this.items[index];
                if (element) element.setAttribute(attr, val);
            },
            focusItemAtIndex: (index)=>{
                const element = this.items[index];
                if (element) element.focus();
            },
            setTabIndexForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (item) item.tabindex = value;
            },
            notifyAction: (index)=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                init.detail = {
                    index: index
                };
                const ev = new CustomEvent("action", init);
                this.dispatchEvent(ev);
            },
            notifySelected: (index, diff)=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                init.detail = {
                    index: index,
                    diff: diff
                };
                const ev = new CustomEvent("selected", init);
                this.dispatchEvent(ev);
            },
            isFocusInsideList: ()=>{
                return (0, $748a8e1d68854803$export$597abdf7826dd64a)(this);
            },
            isRootFocused: ()=>{
                const mdcRoot = this.mdcRoot;
                const root = mdcRoot.getRootNode();
                return root.activeElement === mdcRoot;
            },
            setDisabledStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.disabled = value;
            },
            getDisabledStateForElementIndex: (index)=>{
                const item = this.items[index];
                if (!item) return false;
                return item.disabled;
            },
            setSelectedStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.selected = value;
            },
            getSelectedStateForElementIndex: (index)=>{
                const item = this.items[index];
                if (!item) return false;
                return item.selected;
            },
            setActivatedStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.activated = value;
            }
        };
        return this.mdcAdapter;
    }
    selectUi(index, activate = false) {
        const item = this.items[index];
        if (item) {
            item.selected = true;
            item.activated = activate;
        }
    }
    deselectUi(index) {
        const item = this.items[index];
        if (item) {
            item.selected = false;
            item.activated = false;
        }
    }
    select(index) {
        if (!this.mdcFoundation) return;
        this.mdcFoundation.setSelectedIndex(index);
    }
    toggle(index, force) {
        if (this.multi) this.mdcFoundation.toggleMultiAtIndex(index, force);
    }
    onListItemConnected(e) {
        const target = e.target;
        this.layout(this.items.indexOf(target) === -1);
    }
    layout(updateItems = true) {
        if (updateItems) this.updateItems();
        const first = this.items[0];
        for (const item of this.items)item.tabindex = -1;
        if (first) {
            if (this.noninteractive) {
                if (!this.previousTabindex) this.previousTabindex = first;
            } else first.tabindex = 0;
        }
        this.itemsReadyResolver();
    }
    getFocusedItemIndex() {
        if (!this.mdcRoot) return -1;
        if (!this.items.length) return -1;
        const activeElementPath = (0, $748a8e1d68854803$export$8b6ad084041b2343)();
        if (!activeElementPath.length) return -1;
        for(let i = activeElementPath.length - 1; i >= 0; i--){
            const activeItem = activeElementPath[i];
            if ($efa3bb9ab8d1fa2f$var$isListItem(activeItem)) return this.items.indexOf(activeItem);
        }
        return -1;
    }
    focusItemAtIndex(index) {
        for (const item of this.items)if (item.tabindex === 0) {
            item.tabindex = -1;
            break;
        }
        this.items[index].tabindex = 0;
        this.items[index].focus();
    }
    focus() {
        const root = this.mdcRoot;
        if (root) root.focus();
    }
    blur() {
        const root = this.mdcRoot;
        if (root) root.blur();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "emptyMessage", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-deprecated-list")
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $965e44d5bf066bc5$export$1bdbe53f9df1b8)("", true, "*")
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "assignedElements", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $965e44d5bf066bc5$export$1bdbe53f9df1b8)("", true, '[tabindex="0"]')
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "tabbableElements", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setUseActivatedClass(value);
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "activatable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(newValue, oldValue) {
        if (this.mdcFoundation) this.mdcFoundation.setMulti(newValue);
        if (oldValue !== undefined) this.layout();
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "multi", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setWrapFocus(value);
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "wrapFocus", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(_newValue, oldValue) {
        if (oldValue !== undefined) this.updateItems();
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "itemRoles", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "innerRole", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "innerAriaLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "rootTabbable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        var _a, _b;
        if (value) {
            const tabbable = (_b = (_a = this.tabbableElements) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
            this.previousTabindex = tabbable;
            if (tabbable) tabbable.setAttribute("tabindex", "-1");
        } else if (!value && this.previousTabindex) {
            this.previousTabindex.setAttribute("tabindex", "0");
            this.previousTabindex = null;
        }
    })
], $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df.prototype, "noninteractive", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $4688dbbc8b488111$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}:host{display:block}.mdc-deprecated-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height, 1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);line-height:1.5rem;margin:0;padding:8px 0;list-style-type:none;color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87));padding:var(--mdc-list-vertical-padding, 8px) 0}.mdc-deprecated-list:focus{outline:none}.mdc-deprecated-list-item{height:48px}.mdc-deprecated-list--dense{padding-top:4px;padding-bottom:4px;font-size:.812rem}.mdc-deprecated-list ::slotted([divider]){height:0;margin:0;border:none;border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:rgba(0, 0, 0, 0.12)}.mdc-deprecated-list ::slotted([divider][padded]){margin:0 var(--mdc-list-side-padding, 16px)}.mdc-deprecated-list ::slotted([divider][inset]){margin-left:var(--mdc-list-inset-margin, 72px);margin-right:0;width:calc( 100% - var(--mdc-list-inset-margin, 72px) )}[dir=rtl] .mdc-deprecated-list ::slotted([divider][inset]),.mdc-deprecated-list ::slotted([divider][inset][dir=rtl]){margin-left:0;margin-right:var(--mdc-list-inset-margin, 72px)}.mdc-deprecated-list ::slotted([divider][inset][padded]){width:calc( 100% - var(--mdc-list-inset-margin, 72px) - var(--mdc-list-side-padding, 16px) )}.mdc-deprecated-list--dense ::slotted([mwc-list-item]){height:40px}.mdc-deprecated-list--dense ::slotted([mwc-list]){--mdc-list-item-graphic-size: 20px}.mdc-deprecated-list--two-line.mdc-deprecated-list--dense ::slotted([mwc-list-item]),.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense ::slotted([mwc-list-item]){height:60px}.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense ::slotted([mwc-list]){--mdc-list-item-graphic-size: 36px}:host([noninteractive]){pointer-events:none;cursor:default}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text){display:block;margin-top:0;line-height:normal;margin-bottom:-20px}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text)::before{display:inline-block;width:0;height:24px;content:"";vertical-align:0}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text)::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}`;



let $c514954de1c1bc44$export$54c2e3dc7acea9f5 = class List extends (0, $efa3bb9ab8d1fa2f$export$8f4a37dcf1e373df) {
};
$c514954de1c1bc44$export$54c2e3dc7acea9f5.styles = [
    (0, $4688dbbc8b488111$export$9dd6ff9ea0189349)
];
$c514954de1c1bc44$export$54c2e3dc7acea9f5 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-list")
], $c514954de1c1bc44$export$54c2e3dc7acea9f5);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 








class $b304fb3943e5f95c$export$f56e96de55837300 extends (0, $362ad72c8b1dae7b$export$fcc7a416e8ecbf7a) {
    constructor(){
        super(...arguments);
        this.checked = false;
        this.indeterminate = false;
        this.disabled = false;
        this.name = "";
        this.value = "on";
        /**
         * Touch target extends beyond visual boundary of a component by default.
         * Set to `true` to remove touch target added to the component.
         * @see https://material.io/design/usability/accessibility.html
         */ this.reducedTouchTarget = false;
        this.animationClass = "";
        this.shouldRenderRipple = false;
        this.focused = false;
        // MDC Foundation is unused
        this.mdcFoundationClass = undefined;
        this.mdcFoundation = undefined;
        this.rippleElement = null;
        this.rippleHandlers = new (0, $e65e334fb304280d$export$9a192fb0d53f68ea)(()=>{
            this.shouldRenderRipple = true;
            this.ripple.then((v)=>this.rippleElement = v);
            return this.ripple;
        });
    }
    createAdapter() {
        return {};
    }
    update(changedProperties) {
        const oldIndeterminate = changedProperties.get("indeterminate");
        const oldChecked = changedProperties.get("checked");
        const oldDisabled = changedProperties.get("disabled");
        if (oldIndeterminate !== undefined || oldChecked !== undefined || oldDisabled !== undefined) {
            const oldState = this.calculateAnimationStateName(!!oldChecked, !!oldIndeterminate, !!oldDisabled);
            const newState = this.calculateAnimationStateName(this.checked, this.indeterminate, this.disabled);
            this.animationClass = `${oldState}-${newState}`;
        }
        super.update(changedProperties);
    }
    calculateAnimationStateName(checked, indeterminate, disabled) {
        if (disabled) return "disabled";
        else if (indeterminate) return "indeterminate";
        else if (checked) return "checked";
        else return "unchecked";
    }
    // TODO(dfreedm): Make this use selected as a param after Polymer/internal#739
    /** @soyTemplate */ renderRipple() {
        return this.shouldRenderRipple ? this.renderRippleTemplate() : "";
    }
    /** @soyTemplate */ renderRippleTemplate() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-ripple
        .disabled="${this.disabled}"
        unbounded></mwc-ripple>`;
    }
    /**
     * @soyTemplate
     * @soyAttributes checkboxAttributes: input
     * @soyClasses checkboxClasses: .mdc-checkbox
     */ render() {
        const selected = this.indeterminate || this.checked;
        /* eslint-disable eqeqeq */ // tslint:disable:triple-equals
        /** @classMap */ const classes = {
            "mdc-checkbox--disabled": this.disabled,
            "mdc-checkbox--selected": selected,
            "mdc-checkbox--touch": !this.reducedTouchTarget,
            "mdc-ripple-upgraded--background-focused": this.focused,
            // transition animiation classes
            "mdc-checkbox--anim-checked-indeterminate": this.animationClass == "checked-indeterminate",
            "mdc-checkbox--anim-checked-unchecked": this.animationClass == "checked-unchecked",
            "mdc-checkbox--anim-indeterminate-checked": this.animationClass == "indeterminate-checked",
            "mdc-checkbox--anim-indeterminate-unchecked": this.animationClass == "indeterminate-unchecked",
            "mdc-checkbox--anim-unchecked-checked": this.animationClass == "unchecked-checked",
            "mdc-checkbox--anim-unchecked-indeterminate": this.animationClass == "unchecked-indeterminate"
        };
        // tslint:enable:triple-equals
        /* eslint-enable eqeqeq */ const ariaChecked = this.indeterminate ? "mixed" : undefined;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-checkbox mdc-checkbox--upgraded ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        <input type="checkbox"
              class="mdc-checkbox__native-control"
              name="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.name)}"
              aria-checked="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(ariaChecked)}"
              aria-label="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaLabel)}"
              aria-labelledby="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaLabelledBy)}"
              aria-describedby="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaDescribedBy)}"
              data-indeterminate="${this.indeterminate ? "true" : "false"}"
              ?disabled="${this.disabled}"
              .indeterminate="${this.indeterminate}"
              .checked="${this.checked}"
              .value="${this.value}"
              @change="${this.handleChange}"
              @focus="${this.handleFocus}"
              @blur="${this.handleBlur}"
              @mousedown="${this.handleRippleMouseDown}"
              @mouseenter="${this.handleRippleMouseEnter}"
              @mouseleave="${this.handleRippleMouseLeave}"
              @touchstart="${this.handleRippleTouchStart}"
              @touchend="${this.handleRippleDeactivate}"
              @touchcancel="${this.handleRippleDeactivate}">
        <div class="mdc-checkbox__background"
          @animationend="${this.resetAnimationClass}">
          <svg class="mdc-checkbox__checkmark"
              viewBox="0 0 24 24">
            <path class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
          </svg>
          <div class="mdc-checkbox__mixedmark"></div>
        </div>
        ${this.renderRipple()}
      </div>`;
    }
    setFormData(formData) {
        if (this.name && this.checked) formData.append(this.name, this.value);
    }
    handleFocus() {
        this.focused = true;
        this.handleRippleFocus();
    }
    handleBlur() {
        this.focused = false;
        this.handleRippleBlur();
    }
    handleRippleMouseDown(event) {
        const onUp = ()=>{
            window.removeEventListener("mouseup", onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener("mouseup", onUp);
        this.rippleHandlers.startPress(event);
    }
    handleRippleTouchStart(event) {
        this.rippleHandlers.startPress(event);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
    handleChange() {
        this.checked = this.formElement.checked;
        this.indeterminate = this.formElement.indeterminate;
    }
    resetAnimationClass() {
        this.animationClass = "";
    }
    get isRippleActive() {
        var _a;
        return ((_a = this.rippleElement) === null || _a === void 0 ? void 0 : _a.isActive) || false;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-checkbox")
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("input")
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "formElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "checked", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "indeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "name", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-label"
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "ariaLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-labelledby"
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "ariaLabelledBy", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-describedby"
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "ariaDescribedBy", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "reducedTouchTarget", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "animationClass", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "shouldRenderRipple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "focused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $1f45ba04a1effcd1$export$163dfc35cc43f240)("mwc-ripple")
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "ripple", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        passive: true
    })
], $b304fb3943e5f95c$export$f56e96de55837300.prototype, "handleRippleTouchStart", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $78c24aded7ceb697$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-checkbox{padding:calc((40px - 18px) / 2);padding:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2);margin:calc((40px - 40px) / 2);margin:calc((var(--mdc-checkbox-touch-target-size, 40px) - 40px) / 2)}.mdc-checkbox .mdc-checkbox__ripple::before,.mdc-checkbox .mdc-checkbox__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, #000)}.mdc-checkbox:hover .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-checkbox:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-checkbox:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-checkbox .mdc-checkbox__background{top:calc((40px - 18px) / 2);top:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2);left:calc((40px - 18px) / 2);left:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2)}.mdc-checkbox .mdc-checkbox__native-control{top:calc((40px - 40px) / 2);top:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);right:calc((40px - 40px) / 2);right:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);left:calc((40px - 40px) / 2);left:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);width:40px;width:var(--mdc-checkbox-touch-target-size, 40px);height:40px;height:var(--mdc-checkbox-touch-target-size, 40px)}.mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}@keyframes mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786{0%,80%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786}.mdc-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786}.mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.38);border-color:var(--mdc-checkbox-disabled-color, rgba(0, 0, 0, 0.38));background-color:transparent}.mdc-checkbox .mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{border-color:transparent;background-color:rgba(0, 0, 0, 0.38);background-color:var(--mdc-checkbox-disabled-color, rgba(0, 0, 0, 0.38))}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:#fff;color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:#fff;color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color, #fff)}.mdc-touch-target-wrapper{display:inline}@keyframes mdc-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:29.7833385}50%{animation-timing-function:cubic-bezier(0, 0, 0.2, 1)}100%{stroke-dashoffset:0}}@keyframes mdc-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0, 0, 0, 1)}100%{transform:scaleX(1)}}@keyframes mdc-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(0.4, 0, 1, 1);opacity:1;stroke-dashoffset:0}to{opacity:0;stroke-dashoffset:-29.7833385}}@keyframes mdc-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 1);transform:rotate(0deg);opacity:1}to{transform:rotate(45deg);opacity:0}}@keyframes mdc-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);transform:rotate(45deg);opacity:0}to{transform:rotate(360deg);opacity:1}}@keyframes mdc-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:mdc-animation-deceleration-curve-timing-function;transform:rotate(-45deg);opacity:0}to{transform:rotate(0deg);opacity:1}}@keyframes mdc-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);transform:rotate(0deg);opacity:1}to{transform:rotate(315deg);opacity:0}}@keyframes mdc-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;transform:scaleX(1);opacity:1}32.8%,100%{transform:scaleX(0);opacity:0}}.mdc-checkbox{display:inline-block;position:relative;flex:0 0 18px;box-sizing:content-box;width:18px;height:18px;line-height:0;white-space:nowrap;cursor:pointer;vertical-align:bottom}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}@media screen and (forced-colors: active){.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring{border-color:CanvasText}}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring::after,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}@media screen and (forced-colors: active){.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring::after,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring::after{border-color:CanvasText}}@media all and (-ms-high-contrast: none){.mdc-checkbox .mdc-checkbox__focus-ring{display:none}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-checkbox__mixedmark{margin:0 1px}}.mdc-checkbox--disabled{cursor:default;pointer-events:none}.mdc-checkbox__background{display:inline-flex;position:absolute;align-items:center;justify-content:center;box-sizing:border-box;width:18px;height:18px;border:2px solid currentColor;border-radius:2px;background-color:transparent;pointer-events:none;will-change:background-color,border-color;transition:background-color 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),border-color 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox__checkmark{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;opacity:0;transition:opacity 180ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox--upgraded .mdc-checkbox__checkmark{opacity:1}.mdc-checkbox__checkmark-path{transition:stroke-dashoffset 180ms 0ms cubic-bezier(0.4, 0, 0.6, 1);stroke:currentColor;stroke-width:3.12px;stroke-dashoffset:29.7833385;stroke-dasharray:29.7833385}.mdc-checkbox__mixedmark{width:100%;height:0;transform:scaleX(0) rotate(0deg);border-width:1px;border-style:solid;opacity:0;transition:opacity 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),transform 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__background,.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__background,.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__background,.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__background{animation-duration:180ms;animation-timing-function:linear}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__checkmark-path{animation:mdc-checkbox-unchecked-checked-checkmark-path 180ms linear 0s;transition:none}.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__mixedmark{animation:mdc-checkbox-unchecked-indeterminate-mixedmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__checkmark-path{animation:mdc-checkbox-checked-unchecked-checkmark-path 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__checkmark{animation:mdc-checkbox-checked-indeterminate-checkmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__mixedmark{animation:mdc-checkbox-checked-indeterminate-mixedmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__checkmark{animation:mdc-checkbox-indeterminate-checked-checkmark 500ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__mixedmark{animation:mdc-checkbox-indeterminate-checked-mixedmark 500ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__mixedmark{animation:mdc-checkbox-indeterminate-unchecked-mixedmark 300ms linear 0s;transition:none}.mdc-checkbox__native-control:checked~.mdc-checkbox__background,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background{transition:border-color 90ms 0ms cubic-bezier(0, 0, 0.2, 1),background-color 90ms 0ms cubic-bezier(0, 0, 0.2, 1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark-path{stroke-dashoffset:0}.mdc-checkbox__native-control{position:absolute;margin:0;padding:0;opacity:0;cursor:inherit}.mdc-checkbox__native-control:disabled{cursor:default;pointer-events:none}.mdc-checkbox--touch{margin:calc((48px - 40px) / 2);margin:calc((var(--mdc-checkbox-state-layer-size, 48px) - var(--mdc-checkbox-state-layer-size, 40px)) / 2)}.mdc-checkbox--touch .mdc-checkbox__native-control{top:calc((40px - 48px) / 2);top:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);right:calc((40px - 48px) / 2);right:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);left:calc((40px - 48px) / 2);left:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);width:48px;width:var(--mdc-checkbox-state-layer-size, 48px);height:48px;height:var(--mdc-checkbox-state-layer-size, 48px)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark{transition:opacity 180ms 0ms cubic-bezier(0, 0, 0.2, 1),transform 180ms 0ms cubic-bezier(0, 0, 0.2, 1);opacity:1}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1) rotate(-45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark{transform:rotate(45deg);opacity:0;transition:opacity 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),transform 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__mixedmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1) rotate(0deg);opacity:1}.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark-path,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__mixedmark{transition:none}:host{outline:none;display:inline-flex;-webkit-tap-highlight-color:transparent}:host([checked]),:host([indeterminate]){--mdc-ripple-color:var(--mdc-theme-secondary, #018786)}.mdc-checkbox .mdc-checkbox__background::before{content:none}`;


/** @soyCompatible */ let $4d8edf579d5f53dd$export$48513f6b9f8ce62d = class Checkbox extends (0, $b304fb3943e5f95c$export$f56e96de55837300) {
};
$4d8edf579d5f53dd$export$48513f6b9f8ce62d.styles = [
    (0, $78c24aded7ceb697$export$9dd6ff9ea0189349)
];
$4d8edf579d5f53dd$export$48513f6b9f8ce62d = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-checkbox")
], $4d8edf579d5f53dd$export$48513f6b9f8ce62d);






class $88eefc1251d3588d$export$267ddefd750c5221 extends (0, $6f5fb6998a067962$export$a2e32775fe3b6225) {
    constructor(){
        super(...arguments);
        this.left = false;
        this.graphic = "control";
    }
    render() {
        const checkboxClasses = {
            "mdc-deprecated-list-item__graphic": this.left,
            "mdc-deprecated-list-item__meta": !this.left
        };
        const text = this.renderText();
        const graphic = this.graphic && this.graphic !== "control" && !this.left ? this.renderGraphic() : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
        const meta = this.hasMeta && this.left ? this.renderMeta() : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
        const ripple = this.renderRipple();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      ${ripple}
      ${graphic}
      ${this.left ? "" : text}
      <span class=${(0, $0e5c059fc79abe53$export$56cc687933817664)(checkboxClasses)}>
        <mwc-checkbox
            reducedTouchTarget
            tabindex=${this.tabindex}
            .checked=${this.selected}
            ?disabled=${this.disabled}
            @change=${this.onChange}>
        </mwc-checkbox>
      </span>
      ${this.left ? text : ""}
      ${meta}`;
    }
    async onChange(evt) {
        const checkbox = evt.target;
        const changeFromProp = this.selected === checkbox.checked;
        if (!changeFromProp) {
            this._skipPropRequest = true;
            this.selected = checkbox.checked;
            await this.updateComplete;
            this._skipPropRequest = false;
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $88eefc1251d3588d$export$267ddefd750c5221.prototype, "slotElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("mwc-checkbox")
], $88eefc1251d3588d$export$267ddefd750c5221.prototype, "checkboxElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $88eefc1251d3588d$export$267ddefd750c5221.prototype, "left", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $88eefc1251d3588d$export$267ddefd750c5221.prototype, "graphic", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $2e3b51b11f757098$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host(:not([twoline])){height:56px}:host(:not([left])) .mdc-deprecated-list-item__meta{height:40px;width:40px}`;



let $7047225c41a181df$export$bb65c59ac63c6f50 = class CheckListItem extends (0, $88eefc1251d3588d$export$267ddefd750c5221) {
};
$7047225c41a181df$export$bb65c59ac63c6f50.styles = [
    (0, $eb4a1979bab14d1a$export$9dd6ff9ea0189349),
    (0, $2e3b51b11f757098$export$9dd6ff9ea0189349)
];
$7047225c41a181df$export$bb65c59ac63c6f50 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-check-list-item")
], $7047225c41a181df$export$bb65c59ac63c6f50);




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 






class $344acc0e1ef7db2f$export$ea3f39fd9cd4234f extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.indeterminate = false;
        this.progress = 0;
        this.buffer = 1;
        this.reverse = false;
        this.closed = false;
        this.stylePrimaryHalf = "";
        this.stylePrimaryFull = "";
        this.styleSecondaryQuarter = "";
        this.styleSecondaryHalf = "";
        this.styleSecondaryFull = "";
        this.animationReady = true;
        this.closedAnimationOff = false;
        this.resizeObserver = null;
    }
    connectedCallback() {
        super.connectedCallback();
        // if detached and reattached
        if (this.rootEl) this.attachResizeObserver();
    }
    /**
     * @soyTemplate
     */ render() {
        /** @classMap */ const classes = {
            "mdc-linear-progress--closed": this.closed,
            "mdc-linear-progress--closed-animation-off": this.closedAnimationOff,
            "mdc-linear-progress--indeterminate": this.indeterminate,
            // needed for controller-less render
            "mdc-linear-progress--animation-ready": this.animationReady
        };
        /** @styleMap */ const rootStyles = {
            "--mdc-linear-progress-primary-half": this.stylePrimaryHalf,
            "--mdc-linear-progress-primary-half-neg": this.stylePrimaryHalf !== "" ? `-${this.stylePrimaryHalf}` : "",
            "--mdc-linear-progress-primary-full": this.stylePrimaryFull,
            "--mdc-linear-progress-primary-full-neg": this.stylePrimaryFull !== "" ? `-${this.stylePrimaryFull}` : "",
            "--mdc-linear-progress-secondary-quarter": this.styleSecondaryQuarter,
            "--mdc-linear-progress-secondary-quarter-neg": this.styleSecondaryQuarter !== "" ? `-${this.styleSecondaryQuarter}` : "",
            "--mdc-linear-progress-secondary-half": this.styleSecondaryHalf,
            "--mdc-linear-progress-secondary-half-neg": this.styleSecondaryHalf !== "" ? `-${this.styleSecondaryHalf}` : "",
            "--mdc-linear-progress-secondary-full": this.styleSecondaryFull,
            "--mdc-linear-progress-secondary-full-neg": this.styleSecondaryFull !== "" ? `-${this.styleSecondaryFull}` : ""
        };
        /** @styleMap */ const bufferBarStyles = {
            "flex-basis": this.indeterminate ? "100%" : `${this.buffer * 100}%`
        };
        /** @styleMap */ const primaryBarStyles = {
            transform: this.indeterminate ? "scaleX(1)" : `scaleX(${this.progress})`
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div
          role="progressbar"
          class="mdc-linear-progress ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
          style="${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(rootStyles)}"
          dir="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.reverse ? "rtl" : undefined)}"
          aria-label="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaLabel)}"
          aria-valuemin="0"
          aria-valuemax="1"
          aria-valuenow="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.indeterminate ? undefined : this.progress)}"
        @transitionend="${this.syncClosedState}">
        <div class="mdc-linear-progress__buffer">
          <div
            class="mdc-linear-progress__buffer-bar"
            style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(bufferBarStyles)}>
          </div>
          <div class="mdc-linear-progress__buffer-dots"></div>
        </div>
        <div
            class="mdc-linear-progress__bar mdc-linear-progress__primary-bar"
            style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(primaryBarStyles)}>
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
        <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
      </div>`;
    }
    update(changedProperties) {
        // - When showing the indicator, enable animations immediately.
        // - On first render, disable the animation immediately.
        // - For normal calls to hide the component, let transitionend event trigger
        //   disabling of animations instead (see render method), so that animation
        //   does not jump in the middle of fade out.
        if (changedProperties.has("closed") && (!this.closed || changedProperties.get("closed") === undefined)) this.syncClosedState();
        super.update(changedProperties);
    }
    async firstUpdated(changed) {
        super.firstUpdated(changed);
        this.attachResizeObserver();
    }
    syncClosedState() {
        this.closedAnimationOff = this.closed;
    }
    updated(changed) {
        // restart animation for timing if reverse changed and is indeterminate.
        // don't restart here if indeterminate has changed as well because we don't
        // want to incur an extra style recalculation
        if (!changed.has("indeterminate") && changed.has("reverse") && this.indeterminate) this.restartAnimation();
        // Recaclulate the animation css custom props and restart the calculation
        // if this is not the first render cycle, otherwise, resize observer init
        // will already handle this and prevent unnecessary rerender + style recalc
        // but resize observer will not update animation vals while determinate
        if (changed.has("indeterminate") && changed.get("indeterminate") !== undefined && this.indeterminate && window.ResizeObserver) this.calculateAndSetAnimationDimensions(this.rootEl.offsetWidth);
        super.updated(changed);
    }
    disconnectedCallback() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        super.disconnectedCallback();
    }
    attachResizeObserver() {
        if (window.ResizeObserver) {
            this.resizeObserver = new window.ResizeObserver((entries)=>{
                if (!this.indeterminate) return;
                for (const entry of entries)if (entry.contentRect) {
                    const width = entry.contentRect.width;
                    this.calculateAndSetAnimationDimensions(width);
                }
            });
            this.resizeObserver.observe(this.rootEl);
            return;
        }
        this.resizeObserver = null;
    }
    calculateAndSetAnimationDimensions(width) {
        const primaryHalf = width * 0.8367142;
        const primaryFull = width * 2.00611057;
        const secondaryQuarter = width * 0.37651913;
        const secondaryHalf = width * 0.84386165;
        const secondaryFull = width * 1.60277782;
        this.stylePrimaryHalf = `${primaryHalf}px`;
        this.stylePrimaryFull = `${primaryFull}px`;
        this.styleSecondaryQuarter = `${secondaryQuarter}px`;
        this.styleSecondaryHalf = `${secondaryHalf}px`;
        this.styleSecondaryFull = `${secondaryFull}px`;
        // need to restart animation for custom props to apply to keyframes
        this.restartAnimation();
    }
    async restartAnimation() {
        this.animationReady = false;
        await this.updateComplete;
        await new Promise(requestAnimationFrame);
        this.animationReady = true;
        await this.updateComplete;
    }
    open() {
        this.closed = false;
    }
    close() {
        this.closed = true;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-linear-progress")
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "rootEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "indeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "progress", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "buffer", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "reverse", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "closed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "aria-label"
    })
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "ariaLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "stylePrimaryHalf", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "stylePrimaryFull", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "styleSecondaryQuarter", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "styleSecondaryHalf", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "styleSecondaryFull", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "animationReady", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $344acc0e1ef7db2f$export$ea3f39fd9cd4234f.prototype, "closedAnimationOff", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $11d8bb8656bd3379$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@keyframes mdc-linear-progress-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(83.67142%);transform:translateX(var(--mdc-linear-progress-primary-half, 83.67142%))}100%{transform:translateX(200.611057%);transform:translateX(var(--mdc-linear-progress-primary-full, 200.611057%))}}@keyframes mdc-linear-progress-primary-indeterminate-scale{0%{transform:scaleX(0.08)}36.65%{animation-timing-function:cubic-bezier(0.334731, 0.12482, 0.785844, 1);transform:scaleX(0.08)}69.15%{animation-timing-function:cubic-bezier(0.06, 0.11, 0.6, 1);transform:scaleX(0.661479)}100%{transform:scaleX(0.08)}}@keyframes mdc-linear-progress-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(0.15, 0, 0.515058, 0.409685);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);transform:translateX(37.651913%);transform:translateX(var(--mdc-linear-progress-secondary-quarter, 37.651913%))}48.35%{animation-timing-function:cubic-bezier(0.4, 0.627035, 0.6, 0.902026);transform:translateX(84.386165%);transform:translateX(var(--mdc-linear-progress-secondary-half, 84.386165%))}100%{transform:translateX(160.277782%);transform:translateX(var(--mdc-linear-progress-secondary-full, 160.277782%))}}@keyframes mdc-linear-progress-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(0.205028, 0.057051, 0.57661, 0.453971);transform:scaleX(0.08)}19.15%{animation-timing-function:cubic-bezier(0.152313, 0.196432, 0.648374, 1.004315);transform:scaleX(0.457104)}44.15%{animation-timing-function:cubic-bezier(0.257759, -0.003163, 0.211762, 1.38179);transform:scaleX(0.72796)}100%{transform:scaleX(0.08)}}@keyframes mdc-linear-progress-buffering{from{transform:rotate(180deg) translateX(-10px)}}@keyframes mdc-linear-progress-primary-indeterminate-translate-reverse{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(-83.67142%);transform:translateX(var(--mdc-linear-progress-primary-half-neg, -83.67142%))}100%{transform:translateX(-200.611057%);transform:translateX(var(--mdc-linear-progress-primary-full-neg, -200.611057%))}}@keyframes mdc-linear-progress-secondary-indeterminate-translate-reverse{0%{animation-timing-function:cubic-bezier(0.15, 0, 0.515058, 0.409685);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);transform:translateX(-37.651913%);transform:translateX(var(--mdc-linear-progress-secondary-quarter-neg, -37.651913%))}48.35%{animation-timing-function:cubic-bezier(0.4, 0.627035, 0.6, 0.902026);transform:translateX(-84.386165%);transform:translateX(var(--mdc-linear-progress-secondary-half-neg, -84.386165%))}100%{transform:translateX(-160.277782%);transform:translateX(var(--mdc-linear-progress-secondary-full-neg, -160.277782%))}}@keyframes mdc-linear-progress-buffering-reverse{from{transform:translateX(-10px)}}.mdc-linear-progress{position:relative;width:100%;transform:translateZ(0);outline:1px solid transparent;overflow:hidden;transition:opacity 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}@media screen and (forced-colors: active){.mdc-linear-progress{outline-color:CanvasText}}.mdc-linear-progress__bar{position:absolute;width:100%;height:100%;animation:none;transform-origin:top left;transition:transform 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-linear-progress__bar-inner{display:inline-block;position:absolute;width:100%;animation:none;border-top-style:solid}.mdc-linear-progress__buffer{display:flex;position:absolute;width:100%;height:100%}.mdc-linear-progress__buffer-dots{background-repeat:repeat-x;flex:auto;transform:rotate(180deg);animation:mdc-linear-progress-buffering 250ms infinite linear}.mdc-linear-progress__buffer-bar{flex:0 1 100%;transition:flex-basis 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-linear-progress__primary-bar{transform:scaleX(0)}.mdc-linear-progress__secondary-bar{display:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__bar{transition:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:-145.166611%}.mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{left:-54.888891%;display:block}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation:mdc-linear-progress-primary-indeterminate-translate 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar>.mdc-linear-progress__bar-inner{animation:mdc-linear-progress-primary-indeterminate-scale 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation:mdc-linear-progress-secondary-indeterminate-translate 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar>.mdc-linear-progress__bar-inner{animation:mdc-linear-progress-secondary-indeterminate-scale 2s infinite linear}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__bar{right:0;-webkit-transform-origin:center right;transform-origin:center right}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation-name:mdc-linear-progress-primary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation-name:mdc-linear-progress-secondary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__buffer-dots,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__buffer-dots{animation:mdc-linear-progress-buffering-reverse 250ms infinite linear;transform:rotate(0)}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{right:-145.166611%;left:auto}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{right:-54.888891%;left:auto}.mdc-linear-progress--closed{opacity:0}.mdc-linear-progress--closed-animation-off .mdc-linear-progress__buffer-dots{animation:none}.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar .mdc-linear-progress__bar-inner{animation:none}.mdc-linear-progress__bar-inner{border-color:#6200ee;border-color:var(--mdc-theme-primary, #6200ee)}.mdc-linear-progress__buffer-dots{background-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E")}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6}.mdc-linear-progress{height:4px}.mdc-linear-progress__bar-inner{border-top-width:4px}.mdc-linear-progress__buffer-dots{background-size:10px 4px}:host{display:block}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6;background-color:var(--mdc-linear-progress-buffer-color, #e6e6e6)}.mdc-linear-progress__buffer-dots{background-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E");background-image:var(--mdc-linear-progress-buffering-dots-image, url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E"))}`;


/** @soyCompatible */ let $54e4e4584892cbc3$export$11f983dff6f48944 = class LinearProgress extends (0, $344acc0e1ef7db2f$export$ea3f39fd9cd4234f) {
};
$54e4e4584892cbc3$export$11f983dff6f48944.styles = [
    (0, $11d8bb8656bd3379$export$9dd6ff9ea0189349)
];
$54e4e4584892cbc3$export$11f983dff6f48944 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-linear-progress")
], $54e4e4584892cbc3$export$11f983dff6f48944);


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $8dd1543f4d1ccaad$export$c1c0562ec8379000 = {
    ANCHOR: "mdc-menu-surface--anchor",
    ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
    ANIMATING_OPEN: "mdc-menu-surface--animating-open",
    FIXED: "mdc-menu-surface--fixed",
    IS_OPEN_BELOW: "mdc-menu-surface--is-open-below",
    OPEN: "mdc-menu-surface--open",
    ROOT: "mdc-menu-surface"
};
// tslint:disable:object-literal-sort-keys
var $8dd1543f4d1ccaad$export$21c51bc433c16634 = {
    CLOSED_EVENT: "MDCMenuSurface:closed",
    CLOSING_EVENT: "MDCMenuSurface:closing",
    OPENED_EVENT: "MDCMenuSurface:opened",
    OPENING_EVENT: "MDCMenuSurface:opening",
    FOCUSABLE_ELEMENTS: [
        "button:not(:disabled)",
        '[href]:not([aria-disabled="true"])',
        "input:not(:disabled)",
        "select:not(:disabled)",
        "textarea:not(:disabled)",
        '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'
    ].join(", ")
};
// tslint:enable:object-literal-sort-keys
var $8dd1543f4d1ccaad$export$1f6c9cc012ebacae = {
    /** Total duration of menu-surface open animation. */ TRANSITION_OPEN_DURATION: 120,
    /** Total duration of menu-surface close animation. */ TRANSITION_CLOSE_DURATION: 75,
    /**
     * Margin left to the edge of the viewport when menu-surface is at maximum
     * possible height. Also used as a viewport margin.
     */ MARGIN_TO_EDGE: 32,
    /**
     * Ratio of anchor width to menu-surface width for switching from corner
     * positioning to center positioning.
     */ ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: 0.67,
    /**
     * Amount of time to wait before restoring focus when closing the menu
     * surface. This is important because if a touch event triggered the menu
     * close, and the subsequent mouse event occurs after focus is restored, then
     * the restored focus would be lost.
     */ TOUCH_EVENT_WAIT_MS: 30
};
/**
 * Enum for bits in the {@see Corner) bitmap.
 */ var $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d;
(function(CornerBit) {
    CornerBit[CornerBit["BOTTOM"] = 1] = "BOTTOM";
    CornerBit[CornerBit["CENTER"] = 2] = "CENTER";
    CornerBit[CornerBit["RIGHT"] = 4] = "RIGHT";
    CornerBit[CornerBit["FLIP_RTL"] = 8] = "FLIP_RTL";
})($8dd1543f4d1ccaad$export$b1bff1cc6d391c8d || ($8dd1543f4d1ccaad$export$b1bff1cc6d391c8d = {}));
/**
 * Enum for representing an element corner for positioning the menu-surface.
 *
 * The START constants map to LEFT if element directionality is left
 * to right and RIGHT if the directionality is right to left.
 * Likewise END maps to RIGHT or LEFT depending on the directionality.
 */ var $8dd1543f4d1ccaad$export$ac61190d9fc311a9;
(function(Corner) {
    Corner[Corner["TOP_LEFT"] = 0] = "TOP_LEFT";
    Corner[Corner["TOP_RIGHT"] = 4] = "TOP_RIGHT";
    Corner[Corner["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
    Corner[Corner["BOTTOM_RIGHT"] = 5] = "BOTTOM_RIGHT";
    Corner[Corner["TOP_START"] = 8] = "TOP_START";
    Corner[Corner["TOP_END"] = 12] = "TOP_END";
    Corner[Corner["BOTTOM_START"] = 9] = "BOTTOM_START";
    Corner[Corner["BOTTOM_END"] = 13] = "BOTTOM_END";
})($8dd1543f4d1ccaad$export$ac61190d9fc311a9 || ($8dd1543f4d1ccaad$export$ac61190d9fc311a9 = {}));


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $92d658dd1ebe399e$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$92d658dd1ebe399e$export$2e2bcd8739ae039 = $92d658dd1ebe399e$export$a81b11d69c993162;



var $06a7b8effd41668f$export$b10e494702f92a1d = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCMenuSurfaceFoundation, _super);
    function MDCMenuSurfaceFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCMenuSurfaceFoundation.defaultAdapter), adapter)) || this;
        _this.isSurfaceOpen = false;
        _this.isQuickOpen = false;
        _this.isHoistedElement = false;
        _this.isFixedPosition = false;
        _this.isHorizontallyCenteredOnViewport = false;
        _this.maxHeight = 0;
        _this.openBottomBias = 0;
        _this.openAnimationEndTimerId = 0;
        _this.closeAnimationEndTimerId = 0;
        _this.animationRequestId = 0;
        _this.anchorCorner = (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_START;
        /**
         * Corner of the menu surface to which menu surface is attached to anchor.
         *
         *  Anchor corner --->+----------+
         *                    |  ANCHOR  |
         *                    +----------+
         *  Origin corner --->+--------------+
         *                    |              |
         *                    |              |
         *                    | MENU SURFACE |
         *                    |              |
         *                    |              |
         *                    +--------------+
         */ _this.originCorner = (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_START;
        _this.anchorMargin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        _this.position = {
            x: 0,
            y: 0
        };
        return _this;
    }
    Object.defineProperty(MDCMenuSurfaceFoundation, "cssClasses", {
        get: function() {
            return 0, $8dd1543f4d1ccaad$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuSurfaceFoundation, "strings", {
        get: function() {
            return 0, $8dd1543f4d1ccaad$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuSurfaceFoundation, "numbers", {
        get: function() {
            return 0, $8dd1543f4d1ccaad$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuSurfaceFoundation, "Corner", {
        get: function() {
            return 0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuSurfaceFoundation, "defaultAdapter", {
        /**
         * @see {@link MDCMenuSurfaceAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                hasAnchor: function() {
                    return false;
                },
                isElementInContainer: function() {
                    return false;
                },
                isFocused: function() {
                    return false;
                },
                isRtl: function() {
                    return false;
                },
                getInnerDimensions: function() {
                    return {
                        height: 0,
                        width: 0
                    };
                },
                getAnchorDimensions: function() {
                    return null;
                },
                getWindowDimensions: function() {
                    return {
                        height: 0,
                        width: 0
                    };
                },
                getBodyDimensions: function() {
                    return {
                        height: 0,
                        width: 0
                    };
                },
                getWindowScroll: function() {
                    return {
                        x: 0,
                        y: 0
                    };
                },
                setPosition: function() {
                    return undefined;
                },
                setMaxHeight: function() {
                    return undefined;
                },
                setTransformOrigin: function() {
                    return undefined;
                },
                saveFocus: function() {
                    return undefined;
                },
                restoreFocus: function() {
                    return undefined;
                },
                notifyClose: function() {
                    return undefined;
                },
                notifyClosing: function() {
                    return undefined;
                },
                notifyOpen: function() {
                    return undefined;
                },
                notifyOpening: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCMenuSurfaceFoundation.prototype.init = function() {
        var _a = MDCMenuSurfaceFoundation.cssClasses, ROOT = _a.ROOT, OPEN = _a.OPEN;
        if (!this.adapter.hasClass(ROOT)) throw new Error(ROOT + " class required in root element.");
        if (this.adapter.hasClass(OPEN)) this.isSurfaceOpen = true;
    };
    MDCMenuSurfaceFoundation.prototype.destroy = function() {
        clearTimeout(this.openAnimationEndTimerId);
        clearTimeout(this.closeAnimationEndTimerId);
        // Cancel any currently running animations.
        cancelAnimationFrame(this.animationRequestId);
    };
    /**
     * @param corner Default anchor corner alignment of top-left menu surface
     *     corner.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorCorner = function(corner) {
        this.anchorCorner = corner;
    };
    /**
     * Flip menu corner horizontally.
     */ MDCMenuSurfaceFoundation.prototype.flipCornerHorizontally = function() {
        this.originCorner = this.originCorner ^ (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT;
    };
    /**
     * @param margin Set of margin values from anchor.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorMargin = function(margin) {
        this.anchorMargin.top = margin.top || 0;
        this.anchorMargin.right = margin.right || 0;
        this.anchorMargin.bottom = margin.bottom || 0;
        this.anchorMargin.left = margin.left || 0;
    };
    /** Used to indicate if the menu-surface is hoisted to the body. */ MDCMenuSurfaceFoundation.prototype.setIsHoisted = function(isHoisted) {
        this.isHoistedElement = isHoisted;
    };
    /**
     * Used to set the menu-surface calculations based on a fixed position menu.
     */ MDCMenuSurfaceFoundation.prototype.setFixedPosition = function(isFixedPosition) {
        this.isFixedPosition = isFixedPosition;
    };
    /**
     * @return Returns true if menu is in fixed (`position: fixed`) position.
     */ MDCMenuSurfaceFoundation.prototype.isFixed = function() {
        return this.isFixedPosition;
    };
    /** Sets the menu-surface position on the page. */ MDCMenuSurfaceFoundation.prototype.setAbsolutePosition = function(x, y) {
        this.position.x = this.isFinite(x) ? x : 0;
        this.position.y = this.isFinite(y) ? y : 0;
    };
    /** Sets whether menu-surface should be horizontally centered to viewport. */ MDCMenuSurfaceFoundation.prototype.setIsHorizontallyCenteredOnViewport = function(isCentered) {
        this.isHorizontallyCenteredOnViewport = isCentered;
    };
    MDCMenuSurfaceFoundation.prototype.setQuickOpen = function(quickOpen) {
        this.isQuickOpen = quickOpen;
    };
    /**
     * Sets maximum menu-surface height on open.
     * @param maxHeight The desired max-height. Set to 0 (default) to
     *     automatically calculate max height based on available viewport space.
     */ MDCMenuSurfaceFoundation.prototype.setMaxHeight = function(maxHeight) {
        this.maxHeight = maxHeight;
    };
    /**
     * Set to a positive integer to influence the menu to preferentially open
     * below the anchor instead of above.
     * @param bias A value of `x` simulates an extra `x` pixels of available space
     *     below the menu during positioning calculations.
     */ MDCMenuSurfaceFoundation.prototype.setOpenBottomBias = function(bias) {
        this.openBottomBias = bias;
    };
    MDCMenuSurfaceFoundation.prototype.isOpen = function() {
        return this.isSurfaceOpen;
    };
    /**
     * Open the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.open = function() {
        var _this = this;
        if (this.isSurfaceOpen) return;
        this.adapter.notifyOpening();
        this.adapter.saveFocus();
        if (this.isQuickOpen) {
            this.isSurfaceOpen = true;
            this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
            this.dimensions = this.adapter.getInnerDimensions();
            this.autoposition();
            this.adapter.notifyOpen();
        } else {
            this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
            this.animationRequestId = requestAnimationFrame(function() {
                _this.dimensions = _this.adapter.getInnerDimensions();
                _this.autoposition();
                _this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                _this.openAnimationEndTimerId = setTimeout(function() {
                    _this.openAnimationEndTimerId = 0;
                    _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
                    _this.adapter.notifyOpen();
                }, (0, $8dd1543f4d1ccaad$export$1f6c9cc012ebacae).TRANSITION_OPEN_DURATION);
            });
            this.isSurfaceOpen = true;
        }
    };
    /**
     * Closes the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.close = function(skipRestoreFocus) {
        var _this = this;
        if (skipRestoreFocus === void 0) skipRestoreFocus = false;
        if (!this.isSurfaceOpen) return;
        this.adapter.notifyClosing();
        if (this.isQuickOpen) {
            this.isSurfaceOpen = false;
            if (!skipRestoreFocus) this.maybeRestoreFocus();
            this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
            this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
            this.adapter.notifyClose();
            return;
        }
        this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
        requestAnimationFrame(function() {
            _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
            _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
            _this.closeAnimationEndTimerId = setTimeout(function() {
                _this.closeAnimationEndTimerId = 0;
                _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
                _this.adapter.notifyClose();
            }, (0, $8dd1543f4d1ccaad$export$1f6c9cc012ebacae).TRANSITION_CLOSE_DURATION);
        });
        this.isSurfaceOpen = false;
        if (!skipRestoreFocus) this.maybeRestoreFocus();
    };
    /** Handle clicks and close if not within menu-surface element. */ MDCMenuSurfaceFoundation.prototype.handleBodyClick = function(evt) {
        var el = evt.target;
        if (this.adapter.isElementInContainer(el)) return;
        this.close();
    };
    /** Handle keys that close the surface. */ MDCMenuSurfaceFoundation.prototype.handleKeydown = function(evt) {
        var keyCode = evt.keyCode, key = evt.key;
        var isEscape = key === "Escape" || keyCode === 27;
        if (isEscape) this.close();
    };
    MDCMenuSurfaceFoundation.prototype.autoposition = function() {
        var _a;
        // Compute measurements for autoposition methods reuse.
        this.measurements = this.getAutoLayoutmeasurements();
        var corner = this.getoriginCorner();
        var maxMenuSurfaceHeight = this.getMenuSurfaceMaxHeight(corner);
        var verticalAlignment = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM) ? "bottom" : "top";
        var horizontalAlignment = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT) ? "right" : "left";
        var horizontalOffset = this.getHorizontalOriginOffset(corner);
        var verticalOffset = this.getVerticalOriginOffset(corner);
        var _b = this.measurements, anchorSize = _b.anchorSize, surfaceSize = _b.surfaceSize;
        var position = (_a = {}, _a[horizontalAlignment] = horizontalOffset, _a[verticalAlignment] = verticalOffset, _a);
        // Center align when anchor width is comparable or greater than menu
        // surface, otherwise keep corner.
        if (anchorSize.width / surfaceSize.width > (0, $8dd1543f4d1ccaad$export$1f6c9cc012ebacae).ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO) horizontalAlignment = "center";
        // If the menu-surface has been hoisted to the body, it's no longer relative
        // to the anchor element
        if (this.isHoistedElement || this.isFixedPosition) this.adjustPositionForHoistedElement(position);
        this.adapter.setTransformOrigin(horizontalAlignment + " " + verticalAlignment);
        this.adapter.setPosition(position);
        this.adapter.setMaxHeight(maxMenuSurfaceHeight ? maxMenuSurfaceHeight + "px" : "");
        // If it is opened from the top then add is-open-below class
        if (!this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM)) this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
    };
    /**
     * @return Measurements used to position menu surface popup.
     */ MDCMenuSurfaceFoundation.prototype.getAutoLayoutmeasurements = function() {
        var anchorRect = this.adapter.getAnchorDimensions();
        var bodySize = this.adapter.getBodyDimensions();
        var viewportSize = this.adapter.getWindowDimensions();
        var windowScroll = this.adapter.getWindowScroll();
        if (!anchorRect) // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
        anchorRect = {
            top: this.position.y,
            right: this.position.x,
            bottom: this.position.y,
            left: this.position.x,
            width: 0,
            height: 0
        };
        return {
            anchorSize: anchorRect,
            bodySize: bodySize,
            surfaceSize: this.dimensions,
            viewportDistance: {
                // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
                top: anchorRect.top,
                right: viewportSize.width - anchorRect.right,
                bottom: viewportSize.height - anchorRect.bottom,
                left: anchorRect.left
            },
            viewportSize: viewportSize,
            windowScroll: windowScroll
        };
    };
    /**
     * Computes the corner of the anchor from which to animate and position the
     * menu surface.
     *
     * Only LEFT or RIGHT bit is used to position the menu surface ignoring RTL
     * context. E.g., menu surface will be positioned from right side on TOP_END.
     */ MDCMenuSurfaceFoundation.prototype.getoriginCorner = function() {
        var corner = this.originCorner;
        var _a = this.measurements, viewportDistance = _a.viewportDistance, anchorSize = _a.anchorSize, surfaceSize = _a.surfaceSize;
        var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
        var isAnchoredToBottom = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var availableTop;
        var availableBottom;
        if (isAnchoredToBottom) {
            availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.bottom;
            availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE - this.anchorMargin.bottom;
        } else {
            availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.top;
            availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE + anchorSize.height - this.anchorMargin.top;
        }
        var isAvailableBottom = availableBottom - surfaceSize.height > 0;
        if (!isAvailableBottom && availableTop > availableBottom + this.openBottomBias) // Attach bottom side of surface to the anchor.
        corner = this.setBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var isRtl = this.adapter.isRtl();
        var isFlipRtl = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).FLIP_RTL);
        var hasRightBit = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT) || this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        // Whether surface attached to right side of anchor element.
        var isAnchoredToRight = false;
        // Anchored to start
        if (isRtl && isFlipRtl) isAnchoredToRight = !hasRightBit;
        else // Anchored to right
        isAnchoredToRight = hasRightBit;
        var availableLeft;
        var availableRight;
        if (isAnchoredToRight) {
            availableLeft = viewportDistance.left + anchorSize.width + this.anchorMargin.right;
            availableRight = viewportDistance.right - this.anchorMargin.right;
        } else {
            availableLeft = viewportDistance.left + this.anchorMargin.left;
            availableRight = viewportDistance.right + anchorSize.width - this.anchorMargin.left;
        }
        var isAvailableLeft = availableLeft - surfaceSize.width > 0;
        var isAvailableRight = availableRight - surfaceSize.width > 0;
        var isOriginCornerAlignedToEnd = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).FLIP_RTL) && this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        if (isAvailableRight && isOriginCornerAlignedToEnd && isRtl || !isAvailableLeft && isOriginCornerAlignedToEnd) // Attach left side of surface to the anchor.
        corner = this.unsetBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        else if (isAvailableLeft && isAnchoredToRight && isRtl || isAvailableLeft && !isAnchoredToRight && hasRightBit || !isAvailableRight && availableLeft >= availableRight) // Attach right side of surface to the anchor.
        corner = this.setBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        return corner;
    };
    /**
     * @param corner Origin corner of the menu surface.
     * @return Maximum height of the menu surface, based on available space. 0
     *     indicates should not be set.
     */ MDCMenuSurfaceFoundation.prototype.getMenuSurfaceMaxHeight = function(corner) {
        if (this.maxHeight > 0) return this.maxHeight;
        var viewportDistance = this.measurements.viewportDistance;
        var maxHeight = 0;
        var isBottomAligned = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var isBottomAnchored = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
        // When maximum height is not specified, it is handled from CSS.
        if (isBottomAligned) {
            maxHeight = viewportDistance.top + this.anchorMargin.top - MARGIN_TO_EDGE;
            if (!isBottomAnchored) maxHeight += this.measurements.anchorSize.height;
        } else {
            maxHeight = viewportDistance.bottom - this.anchorMargin.bottom + this.measurements.anchorSize.height - MARGIN_TO_EDGE;
            if (isBottomAnchored) maxHeight -= this.measurements.anchorSize.height;
        }
        return maxHeight;
    };
    /**
     * @param corner Origin corner of the menu surface.
     * @return Horizontal offset of menu surface origin corner from corresponding
     *     anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getHorizontalOriginOffset = function(corner) {
        var anchorSize = this.measurements.anchorSize;
        // isRightAligned corresponds to using the 'right' property on the surface.
        var isRightAligned = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        var avoidHorizontalOverlap = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT);
        if (isRightAligned) {
            var rightOffset = avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.left : this.anchorMargin.right;
            // For hoisted or fixed elements, adjust the offset by the difference
            // between viewport width and body width so when we calculate the right
            // value (`adjustPositionForHoistedElement`) based on the element
            // position, the right property is correct.
            if (this.isHoistedElement || this.isFixedPosition) return rightOffset - (this.measurements.viewportSize.width - this.measurements.bodySize.width);
            return rightOffset;
        }
        return avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.right : this.anchorMargin.left;
    };
    /**
     * @param corner Origin corner of the menu surface.
     * @return Vertical offset of menu surface origin corner from corresponding
     *     anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getVerticalOriginOffset = function(corner) {
        var anchorSize = this.measurements.anchorSize;
        var isBottomAligned = this.hasBit(corner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var avoidVerticalOverlap = this.hasBit(this.anchorCorner, (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).BOTTOM);
        var y = 0;
        if (isBottomAligned) y = avoidVerticalOverlap ? anchorSize.height - this.anchorMargin.top : -this.anchorMargin.bottom;
        else y = avoidVerticalOverlap ? anchorSize.height + this.anchorMargin.bottom : this.anchorMargin.top;
        return y;
    };
    /**
     * Calculates the offsets for positioning the menu-surface when the
     * menu-surface has been hoisted to the body.
     */ MDCMenuSurfaceFoundation.prototype.adjustPositionForHoistedElement = function(position) {
        var e_1, _a;
        var _b = this.measurements, windowScroll = _b.windowScroll, viewportDistance = _b.viewportDistance, surfaceSize = _b.surfaceSize, viewportSize = _b.viewportSize;
        var props = Object.keys(position);
        try {
            for(var props_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                var value = position[prop] || 0;
                if (this.isHorizontallyCenteredOnViewport && (prop === "left" || prop === "right")) {
                    position[prop] = (viewportSize.width - surfaceSize.width) / 2;
                    continue;
                }
                // Hoisted surfaces need to have the anchor elements location on the page
                // added to the position properties for proper alignment on the body.
                value += viewportDistance[prop];
                // Surfaces that are absolutely positioned need to have additional
                // calculations for scroll and bottom positioning.
                if (!this.isFixedPosition) {
                    if (prop === "top") value += windowScroll.y;
                    else if (prop === "bottom") value -= windowScroll.y;
                    else if (prop === "left") value += windowScroll.x;
                    else value -= windowScroll.x;
                }
                position[prop] = value;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * The last focused element when the menu surface was opened should regain
     * focus, if the user is focused on or within the menu surface when it is
     * closed.
     */ MDCMenuSurfaceFoundation.prototype.maybeRestoreFocus = function() {
        var _this = this;
        var isRootFocused = this.adapter.isFocused();
        var ownerDocument = this.adapter.getOwnerDocument ? this.adapter.getOwnerDocument() : document;
        var childHasFocus = ownerDocument.activeElement && this.adapter.isElementInContainer(ownerDocument.activeElement);
        if (isRootFocused || childHasFocus) // Wait before restoring focus when closing the menu surface. This is
        // important because if a touch event triggered the menu close, and the
        // subsequent mouse event occurs after focus is restored, then the
        // restored focus would be lost.
        setTimeout(function() {
            _this.adapter.restoreFocus();
        }, (0, $8dd1543f4d1ccaad$export$1f6c9cc012ebacae).TOUCH_EVENT_WAIT_MS);
    };
    MDCMenuSurfaceFoundation.prototype.hasBit = function(corner, bit) {
        return Boolean(corner & bit); // tslint:disable-line:no-bitwise
    };
    MDCMenuSurfaceFoundation.prototype.setBit = function(corner, bit) {
        return corner | bit; // tslint:disable-line:no-bitwise
    };
    MDCMenuSurfaceFoundation.prototype.unsetBit = function(corner, bit) {
        return corner ^ bit;
    };
    /**
     * isFinite that doesn't force conversion to number type.
     * Equivalent to Number.isFinite in ES2015, which is not supported in IE.
     */ MDCMenuSurfaceFoundation.prototype.isFinite = function(num) {
        return typeof num === "number" && isFinite(num);
    };
    return MDCMenuSurfaceFoundation;
}((0, $92d658dd1ebe399e$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$06a7b8effd41668f$export$2e2bcd8739ae039 = $06a7b8effd41668f$export$b10e494702f92a1d;









// tslint:disable:no-bitwise
// required for closure compiler
const $fe994f194f27be35$var$stringToCorner = {
    "TOP_LEFT": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_LEFT,
    "TOP_RIGHT": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_RIGHT,
    "BOTTOM_LEFT": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).BOTTOM_LEFT,
    "BOTTOM_RIGHT": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).BOTTOM_RIGHT,
    "TOP_START": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_START,
    "TOP_END": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_END,
    "BOTTOM_START": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).BOTTOM_START,
    "BOTTOM_END": (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).BOTTOM_END
};
class $fe994f194f27be35$export$cd5a6978e143035f extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $06a7b8effd41668f$export$2e2bcd8739ae039);
        this.absolute = false;
        this.fullwidth = false;
        this.fixed = false;
        this.x = null;
        this.y = null;
        // must be defined before open or else race condition in foundation occurs.
        this.quick = false;
        this.open = false;
        this.stayOpenOnBodyClick = false;
        this.bitwiseCorner = (0, $8dd1543f4d1ccaad$export$ac61190d9fc311a9).TOP_START;
        this.previousMenuCorner = null;
        // must be defined before observer of anchor corner for initialization
        this.menuCorner = "START";
        this.corner = "TOP_START";
        this.styleTop = "";
        this.styleLeft = "";
        this.styleRight = "";
        this.styleBottom = "";
        this.styleMaxHeight = "";
        this.styleTransformOrigin = "";
        this.anchor = null;
        this.previouslyFocused = null;
        this.previousAnchor = null;
        this.onBodyClickBound = ()=>undefined;
    }
    render() {
        return this.renderSurface();
    }
    renderSurface() {
        const classes = this.getRootClasses();
        const styles = this.getRootStyles();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div
          class=${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}
          style="${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(styles)}"
          @keydown=${this.onKeydown}
          @opened=${this.registerBodyClick}
          @closed=${this.deregisterBodyClick}>
        ${this.renderContent()}
      </div>`;
    }
    getRootClasses() {
        return {
            "mdc-menu-surface": true,
            "mdc-menu-surface--fixed": this.fixed,
            "mdc-menu-surface--fullwidth": this.fullwidth
        };
    }
    getRootStyles() {
        return {
            "top": this.styleTop,
            "left": this.styleLeft,
            "right": this.styleRight,
            "bottom": this.styleBottom,
            "max-height": this.styleMaxHeight,
            "transform-origin": this.styleTransformOrigin
        };
    }
    renderContent() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot)), {
            hasAnchor: ()=>{
                return !!this.anchor;
            },
            notifyClose: ()=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                const ev = new CustomEvent("closed", init);
                this.open = false;
                this.mdcRoot.dispatchEvent(ev);
            },
            notifyClosing: ()=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                const ev = new CustomEvent("closing", init);
                this.mdcRoot.dispatchEvent(ev);
            },
            notifyOpen: ()=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                const ev = new CustomEvent("opened", init);
                this.open = true;
                this.mdcRoot.dispatchEvent(ev);
            },
            notifyOpening: ()=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                const ev = new CustomEvent("opening", init);
                this.mdcRoot.dispatchEvent(ev);
            },
            isElementInContainer: ()=>false,
            isRtl: ()=>{
                if (this.mdcRoot) return getComputedStyle(this.mdcRoot).direction === "rtl";
                return false;
            },
            setTransformOrigin: (origin)=>{
                const root = this.mdcRoot;
                if (!root) return;
                this.styleTransformOrigin = origin;
            },
            isFocused: ()=>{
                return (0, $748a8e1d68854803$export$597abdf7826dd64a)(this);
            },
            saveFocus: ()=>{
                const activeElementPath = (0, $748a8e1d68854803$export$8b6ad084041b2343)();
                const pathLength = activeElementPath.length;
                if (!pathLength) this.previouslyFocused = null;
                this.previouslyFocused = activeElementPath[pathLength - 1];
            },
            restoreFocus: ()=>{
                if (!this.previouslyFocused) return;
                if ("focus" in this.previouslyFocused) this.previouslyFocused.focus();
            },
            getInnerDimensions: ()=>{
                const mdcRoot = this.mdcRoot;
                if (!mdcRoot) return {
                    width: 0,
                    height: 0
                };
                return {
                    width: mdcRoot.offsetWidth,
                    height: mdcRoot.offsetHeight
                };
            },
            getAnchorDimensions: ()=>{
                const anchorElement = this.anchor;
                return anchorElement ? anchorElement.getBoundingClientRect() : null;
            },
            getBodyDimensions: ()=>{
                return {
                    width: document.body.clientWidth,
                    height: document.body.clientHeight
                };
            },
            getWindowDimensions: ()=>{
                return {
                    width: window.innerWidth,
                    height: window.innerHeight
                };
            },
            getWindowScroll: ()=>{
                return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                };
            },
            setPosition: (position)=>{
                const mdcRoot = this.mdcRoot;
                if (!mdcRoot) return;
                this.styleLeft = "left" in position ? `${position.left}px` : "";
                this.styleRight = "right" in position ? `${position.right}px` : "";
                this.styleTop = "top" in position ? `${position.top}px` : "";
                this.styleBottom = "bottom" in position ? `${position.bottom}px` : "";
            },
            setMaxHeight: async (height)=>{
                const mdcRoot = this.mdcRoot;
                if (!mdcRoot) return;
                // must set both for IE support as IE will not set a var
                this.styleMaxHeight = height;
                await this.updateComplete;
                this.styleMaxHeight = `var(--mdc-menu-max-height, ${height})`;
            }
        });
    }
    onKeydown(evt) {
        if (this.mdcFoundation) this.mdcFoundation.handleKeydown(evt);
    }
    onBodyClick(evt) {
        if (this.stayOpenOnBodyClick) return;
        const path = evt.composedPath();
        if (path.indexOf(this) === -1) this.close();
    }
    registerBodyClick() {
        this.onBodyClickBound = this.onBodyClick.bind(this);
        // capture otherwise listener closes menu after quick menu opens
        document.body.addEventListener("click", this.onBodyClickBound, {
            passive: true,
            capture: true
        });
    }
    deregisterBodyClick() {
        document.body.removeEventListener("click", this.onBodyClickBound, {
            capture: true
        });
    }
    onOpenChanged(isOpen, wasOpen) {
        if (this.mdcFoundation) {
            if (isOpen) this.mdcFoundation.open();
            else if (wasOpen !== undefined) this.mdcFoundation.close();
        }
    }
    close() {
        this.open = false;
    }
    show() {
        this.open = true;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-menu-surface")
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "slotElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(isAbsolute) {
        if (this.mdcFoundation && !this.fixed) this.mdcFoundation.setIsHoisted(isAbsolute);
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "absolute", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "fullwidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(isFixed) {
        if (this.mdcFoundation && !this.absolute) this.mdcFoundation.setFixedPosition(isFixed);
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "fixed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation && this.y !== null && value !== null) {
            this.mdcFoundation.setAbsolutePosition(value, this.y);
            this.mdcFoundation.setAnchorMargin({
                left: value,
                top: this.y,
                right: -value,
                bottom: this.y
            });
        }
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "x", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation && this.x !== null && value !== null) {
            this.mdcFoundation.setAbsolutePosition(this.x, value);
            this.mdcFoundation.setAnchorMargin({
                left: this.x,
                top: value,
                right: -this.x,
                bottom: value
            });
        }
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "y", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setQuickOpen(value);
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "quick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(isOpen, wasOpen) {
        this.onOpenChanged(isOpen, wasOpen);
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "stayOpenOnBodyClick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)(),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) {
            if (value) this.mdcFoundation.setAnchorCorner(value);
            else this.mdcFoundation.setAnchorCorner(value);
        }
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "bitwiseCorner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) {
            const isValidValue = value === "START" || value === "END";
            const isFirstTimeSet = this.previousMenuCorner === null;
            const cornerChanged = !isFirstTimeSet && value !== this.previousMenuCorner;
            const initiallySetToEnd = isFirstTimeSet && value === "END";
            if (isValidValue && (cornerChanged || initiallySetToEnd)) {
                this.bitwiseCorner = this.bitwiseCorner ^ (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT;
                this.mdcFoundation.flipCornerHorizontally();
                this.previousMenuCorner = value;
            }
        }
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "menuCorner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) {
            if (value) {
                let newCorner = $fe994f194f27be35$var$stringToCorner[value];
                if (this.menuCorner === "END") newCorner = newCorner ^ (0, $8dd1543f4d1ccaad$export$b1bff1cc6d391c8d).RIGHT;
                this.bitwiseCorner = newCorner;
            }
        }
    })
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "corner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleTop", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleLeft", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleRight", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleBottom", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleMaxHeight", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $fe994f194f27be35$export$cd5a6978e143035f.prototype, "styleTransformOrigin", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $aab7a6cbe29d7dcf$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-menu-surface{display:none;position:absolute;box-sizing:border-box;max-width:calc(100vw - 32px);max-width:var(--mdc-menu-max-width, calc(100vw - 32px));max-height:calc(100vh - 32px);max-height:var(--mdc-menu-max-height, calc(100vh - 32px));margin:0;padding:0;transform:scale(1);transform-origin:top left;opacity:0;overflow:auto;will-change:transform,opacity;z-index:8;transition:opacity .03s linear,transform .12s cubic-bezier(0, 0, 0.2, 1),height 250ms cubic-bezier(0, 0, 0.2, 1);box-shadow:0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0,0,0,.12);background-color:#fff;background-color:var(--mdc-theme-surface, #fff);color:#000;color:var(--mdc-theme-on-surface, #000);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);transform-origin-left:top left;transform-origin-right:top right}.mdc-menu-surface:focus{outline:none}.mdc-menu-surface--animating-open{display:inline-block;transform:scale(0.8);opacity:0}.mdc-menu-surface--open{display:inline-block;transform:scale(1);opacity:1}.mdc-menu-surface--animating-closed{display:inline-block;opacity:0;transition:opacity .075s linear}[dir=rtl] .mdc-menu-surface,.mdc-menu-surface[dir=rtl]{transform-origin-left:top right;transform-origin-right:top left}.mdc-menu-surface--anchor{position:relative;overflow:visible}.mdc-menu-surface--fixed{position:fixed}.mdc-menu-surface--fullwidth{width:100%}:host(:not([open])){display:none}.mdc-menu-surface{z-index:8;z-index:var(--mdc-menu-z-index, 8);min-width:112px;min-width:var(--mdc-menu-min-width, 112px)}`;


let $41200c640cca3d2d$export$f1cca1917c79e102 = class MenuSurface extends (0, $fe994f194f27be35$export$cd5a6978e143035f) {
};
$41200c640cca3d2d$export$f1cca1917c79e102.styles = [
    (0, $aab7a6cbe29d7dcf$export$9dd6ff9ea0189349)
];
$41200c640cca3d2d$export$f1cca1917c79e102 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-menu-surface")
], $41200c640cca3d2d$export$f1cca1917c79e102);


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $7fbf8a66f01dac58$export$c1c0562ec8379000 = {
    MENU_SELECTED_LIST_ITEM: "mdc-menu-item--selected",
    MENU_SELECTION_GROUP: "mdc-menu__selection-group",
    ROOT: "mdc-menu"
};
var $7fbf8a66f01dac58$export$21c51bc433c16634 = {
    ARIA_CHECKED_ATTR: "aria-checked",
    ARIA_DISABLED_ATTR: "aria-disabled",
    CHECKBOX_SELECTOR: 'input[type="checkbox"]',
    LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
    SELECTED_EVENT: "MDCMenu:selected",
    SKIP_RESTORE_FOCUS: "data-menu-item-skip-restore-focus"
};
var $7fbf8a66f01dac58$export$1f6c9cc012ebacae = {
    FOCUS_ROOT_INDEX: -1
};
var $7fbf8a66f01dac58$export$f735d3ca68514f3;
(function(DefaultFocusState) {
    DefaultFocusState[DefaultFocusState["NONE"] = 0] = "NONE";
    DefaultFocusState[DefaultFocusState["LIST_ROOT"] = 1] = "LIST_ROOT";
    DefaultFocusState[DefaultFocusState["FIRST_ITEM"] = 2] = "FIRST_ITEM";
    DefaultFocusState[DefaultFocusState["LAST_ITEM"] = 3] = "LAST_ITEM";
})($7fbf8a66f01dac58$export$f735d3ca68514f3 || ($7fbf8a66f01dac58$export$f735d3ca68514f3 = {}));


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $4a8b2691420d6de6$var$_a, $4a8b2691420d6de6$var$_b;
var $4a8b2691420d6de6$export$c1c0562ec8379000 = {
    LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
    LIST_ITEM_CLASS: "mdc-list-item",
    LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
    LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
    LIST_ITEM_TEXT_CLASS: "mdc-list-item__text",
    LIST_ITEM_PRIMARY_TEXT_CLASS: "mdc-list-item__primary-text",
    ROOT: "mdc-list"
};
var $4a8b2691420d6de6$export$4e3f9f206c48734b = ($4a8b2691420d6de6$var$_a = {}, $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-list-item--activated", $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-list-item", $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-list-item--disabled", $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-list-item--selected", $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-list-item__primary-text", $4a8b2691420d6de6$var$_a["" + $4a8b2691420d6de6$export$c1c0562ec8379000.ROOT] = "mdc-list", $4a8b2691420d6de6$var$_a);
var $4a8b2691420d6de6$export$58c7601cd6e42ae1 = ($4a8b2691420d6de6$var$_b = {}, $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-deprecated-list-item--activated", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-deprecated-list-item", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-deprecated-list-item--disabled", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-deprecated-list-item--selected", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_TEXT_CLASS] = "mdc-deprecated-list-item__text", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-deprecated-list-item__primary-text", $4a8b2691420d6de6$var$_b["" + $4a8b2691420d6de6$export$c1c0562ec8379000.ROOT] = "mdc-deprecated-list", $4a8b2691420d6de6$var$_b);
var $4a8b2691420d6de6$export$21c51bc433c16634 = {
    ACTION_EVENT: "MDCList:action",
    SELECTION_CHANGE_EVENT: "MDCList:selectionChange",
    ARIA_CHECKED: "aria-checked",
    ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
    ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
    ARIA_CURRENT: "aria-current",
    ARIA_DISABLED: "aria-disabled",
    ARIA_ORIENTATION: "aria-orientation",
    ARIA_ORIENTATION_HORIZONTAL: "horizontal",
    ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
    ARIA_SELECTED: "aria-selected",
    ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
    ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
    CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
    CHECKBOX_SELECTOR: 'input[type="checkbox"]',
    CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a\n  ",
    DEPRECATED_SELECTOR: ".mdc-deprecated-list",
    FOCUSABLE_CHILD_ELEMENTS: "\n    ." + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + $4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled),\n    .' + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a,\n    ." + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="radio"]:not(:disabled),\n    .' + $4a8b2691420d6de6$export$58c7601cd6e42ae1[$4a8b2691420d6de6$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="checkbox"]:not(:disabled)\n  ',
    RADIO_SELECTOR: 'input[type="radio"]',
    SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
};
var $4a8b2691420d6de6$export$1f6c9cc012ebacae = {
    UNSET_INDEX: -1,
    TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
};
var $4a8b2691420d6de6$export$37a660f6ba30d8b = "evolution";




var $462e6540d42e6b62$export$c5254fe5bc1f63dc = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCMenuFoundation, _super);
    function MDCMenuFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCMenuFoundation.defaultAdapter), adapter)) || this;
        _this.closeAnimationEndTimerId = 0;
        _this.defaultFocusState = (0, $7fbf8a66f01dac58$export$f735d3ca68514f3).LIST_ROOT;
        _this.selectedIndex = -1;
        return _this;
    }
    Object.defineProperty(MDCMenuFoundation, "cssClasses", {
        get: function() {
            return 0, $7fbf8a66f01dac58$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuFoundation, "strings", {
        get: function() {
            return 0, $7fbf8a66f01dac58$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuFoundation, "numbers", {
        get: function() {
            return 0, $7fbf8a66f01dac58$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCMenuFoundation, "defaultAdapter", {
        /**
         * @see {@link MDCMenuAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClassToElementAtIndex: function() {
                    return undefined;
                },
                removeClassFromElementAtIndex: function() {
                    return undefined;
                },
                addAttributeToElementAtIndex: function() {
                    return undefined;
                },
                removeAttributeFromElementAtIndex: function() {
                    return undefined;
                },
                getAttributeFromElementAtIndex: function() {
                    return null;
                },
                elementContainsClass: function() {
                    return false;
                },
                closeSurface: function() {
                    return undefined;
                },
                getElementIndex: function() {
                    return -1;
                },
                notifySelected: function() {
                    return undefined;
                },
                getMenuItemCount: function() {
                    return 0;
                },
                focusItemAtIndex: function() {
                    return undefined;
                },
                focusListRoot: function() {
                    return undefined;
                },
                getSelectedSiblingOfItemAtIndex: function() {
                    return -1;
                },
                isSelectableItemAtIndex: function() {
                    return false;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCMenuFoundation.prototype.destroy = function() {
        if (this.closeAnimationEndTimerId) clearTimeout(this.closeAnimationEndTimerId);
        this.adapter.closeSurface();
    };
    MDCMenuFoundation.prototype.handleKeydown = function(evt) {
        var key = evt.key, keyCode = evt.keyCode;
        var isTab = key === "Tab" || keyCode === 9;
        if (isTab) this.adapter.closeSurface(/** skipRestoreFocus */ true);
    };
    MDCMenuFoundation.prototype.handleItemAction = function(listItem) {
        var _this = this;
        var index = this.adapter.getElementIndex(listItem);
        if (index < 0) return;
        this.adapter.notifySelected({
            index: index
        });
        var skipRestoreFocus = this.adapter.getAttributeFromElementAtIndex(index, (0, $7fbf8a66f01dac58$export$21c51bc433c16634).SKIP_RESTORE_FOCUS) === "true";
        this.adapter.closeSurface(skipRestoreFocus);
        // Wait for the menu to close before adding/removing classes that affect styles.
        this.closeAnimationEndTimerId = setTimeout(function() {
            // Recompute the index in case the menu contents have changed.
            var recomputedIndex = _this.adapter.getElementIndex(listItem);
            if (recomputedIndex >= 0 && _this.adapter.isSelectableItemAtIndex(recomputedIndex)) _this.setSelectedIndex(recomputedIndex);
        }, (0, $06a7b8effd41668f$export$b10e494702f92a1d).numbers.TRANSITION_CLOSE_DURATION);
    };
    MDCMenuFoundation.prototype.handleMenuSurfaceOpened = function() {
        switch(this.defaultFocusState){
            case (0, $7fbf8a66f01dac58$export$f735d3ca68514f3).FIRST_ITEM:
                this.adapter.focusItemAtIndex(0);
                break;
            case (0, $7fbf8a66f01dac58$export$f735d3ca68514f3).LAST_ITEM:
                this.adapter.focusItemAtIndex(this.adapter.getMenuItemCount() - 1);
                break;
            case (0, $7fbf8a66f01dac58$export$f735d3ca68514f3).NONE:
                break;
            default:
                this.adapter.focusListRoot();
                break;
        }
    };
    /**
     * Sets default focus state where the menu should focus every time when menu
     * is opened. Focuses the list root (`DefaultFocusState.LIST_ROOT`) element by
     * default.
     */ MDCMenuFoundation.prototype.setDefaultFocusState = function(focusState) {
        this.defaultFocusState = focusState;
    };
    /** @return Index of the currently selected list item within the menu. */ MDCMenuFoundation.prototype.getSelectedIndex = function() {
        return this.selectedIndex;
    };
    /**
     * Selects the list item at `index` within the menu.
     * @param index Index of list item within the menu.
     */ MDCMenuFoundation.prototype.setSelectedIndex = function(index) {
        this.validatedIndex(index);
        if (!this.adapter.isSelectableItemAtIndex(index)) throw new Error("MDCMenuFoundation: No selection group at specified index.");
        var prevSelectedIndex = this.adapter.getSelectedSiblingOfItemAtIndex(index);
        if (prevSelectedIndex >= 0) {
            this.adapter.removeAttributeFromElementAtIndex(prevSelectedIndex, (0, $7fbf8a66f01dac58$export$21c51bc433c16634).ARIA_CHECKED_ATTR);
            this.adapter.removeClassFromElementAtIndex(prevSelectedIndex, (0, $7fbf8a66f01dac58$export$c1c0562ec8379000).MENU_SELECTED_LIST_ITEM);
        }
        this.adapter.addClassToElementAtIndex(index, (0, $7fbf8a66f01dac58$export$c1c0562ec8379000).MENU_SELECTED_LIST_ITEM);
        this.adapter.addAttributeToElementAtIndex(index, (0, $7fbf8a66f01dac58$export$21c51bc433c16634).ARIA_CHECKED_ATTR, "true");
        this.selectedIndex = index;
    };
    /**
     * Sets the enabled state to isEnabled for the menu item at the given index.
     * @param index Index of the menu item
     * @param isEnabled The desired enabled state of the menu item.
     */ MDCMenuFoundation.prototype.setEnabled = function(index, isEnabled) {
        this.validatedIndex(index);
        if (isEnabled) {
            this.adapter.removeClassFromElementAtIndex(index, (0, $4a8b2691420d6de6$export$c1c0562ec8379000).LIST_ITEM_DISABLED_CLASS);
            this.adapter.addAttributeToElementAtIndex(index, (0, $7fbf8a66f01dac58$export$21c51bc433c16634).ARIA_DISABLED_ATTR, "false");
        } else {
            this.adapter.addClassToElementAtIndex(index, (0, $4a8b2691420d6de6$export$c1c0562ec8379000).LIST_ITEM_DISABLED_CLASS);
            this.adapter.addAttributeToElementAtIndex(index, (0, $7fbf8a66f01dac58$export$21c51bc433c16634).ARIA_DISABLED_ATTR, "true");
        }
    };
    MDCMenuFoundation.prototype.validatedIndex = function(index) {
        var menuSize = this.adapter.getMenuItemCount();
        var isIndexInRange = index >= 0 && index < menuSize;
        if (!isIndexInRange) throw new Error("MDCMenuFoundation: No list item at specified index.");
    };
    return MDCMenuFoundation;
}((0, $92d658dd1ebe399e$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$462e6540d42e6b62$export$2e2bcd8739ae039 = $462e6540d42e6b62$export$c5254fe5bc1f63dc;








class $cd78f286f89190e2$export$5118460d8209bf35 extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $462e6540d42e6b62$export$2e2bcd8739ae039);
        this.listElement_ = null;
        this.anchor = null;
        this.open = false;
        this.quick = false;
        this.wrapFocus = false;
        this.innerRole = "menu";
        this.innerAriaLabel = null;
        this.corner = "TOP_START";
        this.x = null;
        this.y = null;
        this.absolute = false;
        this.multi = false;
        this.activatable = false;
        this.fixed = false;
        this.forceGroupSelection = false;
        this.fullwidth = false;
        this.menuCorner = "START";
        this.stayOpenOnBodyClick = false;
        this.defaultFocus = "LIST_ROOT";
        this._listUpdateComplete = null;
    }
    get listElement() {
        if (!this.listElement_) {
            this.listElement_ = this.renderRoot.querySelector("mwc-list");
            return this.listElement_;
        }
        return this.listElement_;
    }
    get items() {
        const listElement = this.listElement;
        if (listElement) return listElement.items;
        return [];
    }
    get index() {
        const listElement = this.listElement;
        if (listElement) return listElement.index;
        return -1;
    }
    get selected() {
        const listElement = this.listElement;
        if (listElement) return listElement.selected;
        return null;
    }
    render() {
        return this.renderSurface();
    }
    renderSurface() {
        const classes = this.getSurfaceClasses();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-menu-surface
        ?hidden=${!this.open}
        .anchor=${this.anchor}
        .open=${this.open}
        .quick=${this.quick}
        .corner=${this.corner}
        .x=${this.x}
        .y=${this.y}
        .absolute=${this.absolute}
        .fixed=${this.fixed}
        .fullwidth=${this.fullwidth}
        .menuCorner=${this.menuCorner}
        ?stayOpenOnBodyClick=${this.stayOpenOnBodyClick}
        class=${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}
        @closed=${this.onClosed}
        @opened=${this.onOpened}
        @keydown=${this.onKeydown}>
      ${this.renderList()}
    </mwc-menu-surface>`;
    }
    getSurfaceClasses() {
        return {
            "mdc-menu": true,
            "mdc-menu-surface": true
        };
    }
    renderList() {
        const itemRoles = this.innerRole === "menu" ? "menuitem" : "option";
        const classes = this.renderListClasses();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-list
          rootTabbable
          .innerAriaLabel=${this.innerAriaLabel}
          .innerRole=${this.innerRole}
          .multi=${this.multi}
          class=${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}
          .itemRoles=${itemRoles}
          .wrapFocus=${this.wrapFocus}
          .activatable=${this.activatable}
          @action=${this.onAction}>
        <slot></slot>
      </mwc-list>`;
    }
    renderListClasses() {
        return {
            "mdc-deprecated-list": true
        };
    }
    createAdapter() {
        return {
            addClassToElementAtIndex: (index, className)=>{
                const listElement = this.listElement;
                if (!listElement) return;
                const element = listElement.items[index];
                if (!element) return;
                if (className === "mdc-menu-item--selected") {
                    if (this.forceGroupSelection && !element.selected) listElement.toggle(index, true);
                } else element.classList.add(className);
            },
            removeClassFromElementAtIndex: (index, className)=>{
                const listElement = this.listElement;
                if (!listElement) return;
                const element = listElement.items[index];
                if (!element) return;
                if (className === "mdc-menu-item--selected") {
                    if (element.selected) listElement.toggle(index, false);
                } else element.classList.remove(className);
            },
            addAttributeToElementAtIndex: (index, attr, value)=>{
                const listElement = this.listElement;
                if (!listElement) return;
                const element = listElement.items[index];
                if (!element) return;
                element.setAttribute(attr, value);
            },
            removeAttributeFromElementAtIndex: (index, attr)=>{
                const listElement = this.listElement;
                if (!listElement) return;
                const element = listElement.items[index];
                if (!element) return;
                element.removeAttribute(attr);
            },
            getAttributeFromElementAtIndex: (index, attr)=>{
                const listElement = this.listElement;
                if (!listElement) return null;
                const element = listElement.items[index];
                if (!element) return null;
                return element.getAttribute(attr);
            },
            elementContainsClass: (element, className)=>element.classList.contains(className),
            closeSurface: ()=>{
                this.open = false;
            },
            getElementIndex: (element)=>{
                const listElement = this.listElement;
                if (listElement) return listElement.items.indexOf(element);
                return -1;
            },
            notifySelected: ()=>{},
            getMenuItemCount: ()=>{
                const listElement = this.listElement;
                if (!listElement) return 0;
                return listElement.items.length;
            },
            focusItemAtIndex: (index)=>{
                const listElement = this.listElement;
                if (!listElement) return;
                const element = listElement.items[index];
                if (element) element.focus();
            },
            focusListRoot: ()=>{
                if (this.listElement) this.listElement.focus();
            },
            getSelectedSiblingOfItemAtIndex: (index)=>{
                const listElement = this.listElement;
                if (!listElement) return -1;
                const elementAtIndex = listElement.items[index];
                if (!elementAtIndex || !elementAtIndex.group) return -1;
                for(let i = 0; i < listElement.items.length; i++){
                    if (i === index) continue;
                    const current = listElement.items[i];
                    if (current.selected && current.group === elementAtIndex.group) return i;
                }
                return -1;
            },
            isSelectableItemAtIndex: (index)=>{
                const listElement = this.listElement;
                if (!listElement) return false;
                const elementAtIndex = listElement.items[index];
                if (!elementAtIndex) return false;
                return elementAtIndex.hasAttribute("group");
            }
        };
    }
    onKeydown(evt) {
        if (this.mdcFoundation) this.mdcFoundation.handleKeydown(evt);
    }
    onAction(evt) {
        const listElement = this.listElement;
        if (this.mdcFoundation && listElement) {
            const index = evt.detail.index;
            const el = listElement.items[index];
            if (el) this.mdcFoundation.handleItemAction(el);
        }
    }
    onOpened() {
        this.open = true;
        if (this.mdcFoundation) this.mdcFoundation.handleMenuSurfaceOpened();
    }
    onClosed() {
        this.open = false;
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        await this._listUpdateComplete;
        // @ts-ignore
        const result = await super.getUpdateComplete();
        return result;
    }
    // tslint:enable:ban-ts-ignore
    async firstUpdated() {
        super.firstUpdated();
        const listElement = this.listElement;
        if (listElement) {
            this._listUpdateComplete = listElement.updateComplete;
            await this._listUpdateComplete;
        }
    }
    select(index) {
        const listElement = this.listElement;
        if (listElement) listElement.select(index);
    }
    close() {
        this.open = false;
    }
    show() {
        this.open = true;
    }
    getFocusedItemIndex() {
        const listElement = this.listElement;
        if (listElement) return listElement.getFocusedItemIndex();
        return -1;
    }
    focusItemAtIndex(index) {
        const listElement = this.listElement;
        if (listElement) listElement.focusItemAtIndex(index);
    }
    layout(updateItems = true) {
        const listElement = this.listElement;
        if (listElement) listElement.layout(updateItems);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-menu")
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "slotElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "anchor", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "quick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "wrapFocus", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "innerRole", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "innerAriaLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "corner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "x", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "y", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "absolute", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "multi", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "activatable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "fixed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "forceGroupSelection", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "fullwidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "menuCorner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "stayOpenOnBodyClick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setDefaultFocusState((0, $7fbf8a66f01dac58$export$f735d3ca68514f3)[value]);
    })
], $cd78f286f89190e2$export$5118460d8209bf35.prototype, "defaultFocus", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $89bbb5b10253a982$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`mwc-list ::slotted([mwc-list-item]:not([twoline])),mwc-list ::slotted([noninteractive]:not([twoline])){height:var(--mdc-menu-item-height, 48px)}`;



let $851db52b59888486$export$d9b273488cd8ce6f = class Menu extends (0, $cd78f286f89190e2$export$5118460d8209bf35) {
};
$851db52b59888486$export$d9b273488cd8ce6f.styles = [
    (0, $89bbb5b10253a982$export$9dd6ff9ea0189349)
];
$851db52b59888486$export$d9b273488cd8ce6f = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-menu")
], $851db52b59888486$export$d9b273488cd8ce6f);



/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * KEY provides normalized string values for keys.
 */ var $08db7a261b1f13aa$export$7167c830cefcb6b5 = {
    UNKNOWN: "Unknown",
    BACKSPACE: "Backspace",
    ENTER: "Enter",
    SPACEBAR: "Spacebar",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    END: "End",
    HOME: "Home",
    ARROW_LEFT: "ArrowLeft",
    ARROW_UP: "ArrowUp",
    ARROW_RIGHT: "ArrowRight",
    ARROW_DOWN: "ArrowDown",
    DELETE: "Delete",
    ESCAPE: "Escape",
    TAB: "Tab"
};
var $08db7a261b1f13aa$var$normalizedKeys = new Set();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.BACKSPACE);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ENTER);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.SPACEBAR);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_UP);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_DOWN);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.END);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.HOME);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_LEFT);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_UP);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_RIGHT);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_DOWN);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.DELETE);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ESCAPE);
$08db7a261b1f13aa$var$normalizedKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.TAB);
var $08db7a261b1f13aa$var$KEY_CODE = {
    BACKSPACE: 8,
    ENTER: 13,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ESCAPE: 27,
    TAB: 9
};
var $08db7a261b1f13aa$var$mappedKeyCodes = new Map();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.BACKSPACE, $08db7a261b1f13aa$export$7167c830cefcb6b5.BACKSPACE);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ENTER, $08db7a261b1f13aa$export$7167c830cefcb6b5.ENTER);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.SPACEBAR, $08db7a261b1f13aa$export$7167c830cefcb6b5.SPACEBAR);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.PAGE_UP, $08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_UP);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.PAGE_DOWN, $08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_DOWN);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.END, $08db7a261b1f13aa$export$7167c830cefcb6b5.END);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.HOME, $08db7a261b1f13aa$export$7167c830cefcb6b5.HOME);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ARROW_LEFT, $08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_LEFT);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ARROW_UP, $08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_UP);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ARROW_RIGHT, $08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_RIGHT);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ARROW_DOWN, $08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_DOWN);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.DELETE, $08db7a261b1f13aa$export$7167c830cefcb6b5.DELETE);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.ESCAPE, $08db7a261b1f13aa$export$7167c830cefcb6b5.ESCAPE);
$08db7a261b1f13aa$var$mappedKeyCodes.set($08db7a261b1f13aa$var$KEY_CODE.TAB, $08db7a261b1f13aa$export$7167c830cefcb6b5.TAB);
var $08db7a261b1f13aa$var$navigationKeys = new Set();
// IE11 has no support for new Set with iterable so we need to initialize this
// by hand.
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_UP);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.PAGE_DOWN);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.END);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.HOME);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_LEFT);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_UP);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_RIGHT);
$08db7a261b1f13aa$var$navigationKeys.add($08db7a261b1f13aa$export$7167c830cefcb6b5.ARROW_DOWN);
function $08db7a261b1f13aa$export$e0c709538cb8ae18(evt) {
    var key = evt.key;
    // If the event already has a normalized key, return it
    if ($08db7a261b1f13aa$var$normalizedKeys.has(key)) return key;
    // tslint:disable-next-line:deprecation
    var mappedKey = $08db7a261b1f13aa$var$mappedKeyCodes.get(evt.keyCode);
    if (mappedKey) return mappedKey;
    return $08db7a261b1f13aa$export$7167c830cefcb6b5.UNKNOWN;
}
function $08db7a261b1f13aa$export$15e092e359be91e2(evt) {
    return $08db7a261b1f13aa$var$navigationKeys.has($08db7a261b1f13aa$export$e0c709538cb8ae18(evt));
}


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $60a7b6c5311703e7$var$_a, $60a7b6c5311703e7$var$_b;
var $60a7b6c5311703e7$export$c1c0562ec8379000 = {
    LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
    LIST_ITEM_CLASS: "mdc-list-item",
    LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
    LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
    LIST_ITEM_TEXT_CLASS: "mdc-list-item__text",
    LIST_ITEM_PRIMARY_TEXT_CLASS: "mdc-list-item__primary-text",
    ROOT: "mdc-list"
};
var $60a7b6c5311703e7$export$4e3f9f206c48734b = ($60a7b6c5311703e7$var$_a = {}, $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-list-item--activated", $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-list-item", $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-list-item--disabled", $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-list-item--selected", $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-list-item__primary-text", $60a7b6c5311703e7$var$_a["" + $60a7b6c5311703e7$export$c1c0562ec8379000.ROOT] = "mdc-list", $60a7b6c5311703e7$var$_a);
var $60a7b6c5311703e7$export$58c7601cd6e42ae1 = ($60a7b6c5311703e7$var$_b = {}, $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = "mdc-deprecated-list-item--activated", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] = "mdc-deprecated-list-item", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = "mdc-deprecated-list-item--disabled", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = "mdc-deprecated-list-item--selected", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_TEXT_CLASS] = "mdc-deprecated-list-item__text", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-deprecated-list-item__primary-text", $60a7b6c5311703e7$var$_b["" + $60a7b6c5311703e7$export$c1c0562ec8379000.ROOT] = "mdc-deprecated-list", $60a7b6c5311703e7$var$_b);
var $60a7b6c5311703e7$export$21c51bc433c16634 = {
    ACTION_EVENT: "MDCList:action",
    SELECTION_CHANGE_EVENT: "MDCList:selectionChange",
    ARIA_CHECKED: "aria-checked",
    ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
    ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
    ARIA_CURRENT: "aria-current",
    ARIA_DISABLED: "aria-disabled",
    ARIA_ORIENTATION: "aria-orientation",
    ARIA_ORIENTATION_HORIZONTAL: "horizontal",
    ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
    ARIA_SELECTED: "aria-selected",
    ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
    ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
    CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
    CHECKBOX_SELECTOR: 'input[type="checkbox"]',
    CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a\n  ",
    DEPRECATED_SELECTOR: ".mdc-deprecated-list",
    FOCUSABLE_CHILD_ELEMENTS: "\n    ." + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + $60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled),\n    .' + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a,\n    ." + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="radio"]:not(:disabled),\n    .' + $60a7b6c5311703e7$export$58c7601cd6e42ae1[$60a7b6c5311703e7$export$c1c0562ec8379000.LIST_ITEM_CLASS] + ' input[type="checkbox"]:not(:disabled)\n  ',
    RADIO_SELECTOR: 'input[type="radio"]',
    SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
};
var $60a7b6c5311703e7$export$1f6c9cc012ebacae = {
    UNSET_INDEX: -1,
    TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
};
var $60a7b6c5311703e7$export$37a660f6ba30d8b = "evolution";


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $d924d7e9d20d0e46$var$ELEMENTS_KEY_ALLOWED_IN = [
    "input",
    "button",
    "textarea",
    "select"
];
var $d924d7e9d20d0e46$export$2bfdb8b2d5208a6b = function(evt) {
    var target = evt.target;
    if (!target) return;
    var tagName = ("" + target.tagName).toLowerCase();
    if ($d924d7e9d20d0e46$var$ELEMENTS_KEY_ALLOWED_IN.indexOf(tagName) === -1) evt.preventDefault();
};


function $87447cf003343840$export$f6196a6c6bb539b4() {
    var state = {
        bufferClearTimeout: 0,
        currentFirstChar: "",
        sortedIndexCursor: 0,
        typeaheadBuffer: ""
    };
    return state;
}
function $87447cf003343840$export$a58b3686f50ca14c(listItemCount, getPrimaryTextByItemIndex) {
    var sortedIndexByFirstChar = new Map();
    // Aggregate item text to index mapping
    for(var i = 0; i < listItemCount; i++){
        var primaryText = getPrimaryTextByItemIndex(i).trim();
        if (!primaryText) continue;
        var firstChar = primaryText[0].toLowerCase();
        if (!sortedIndexByFirstChar.has(firstChar)) sortedIndexByFirstChar.set(firstChar, []);
        sortedIndexByFirstChar.get(firstChar).push({
            text: primaryText.toLowerCase(),
            index: i
        });
    }
    // Sort the mapping
    // TODO(b/157162694): Investigate replacing forEach with Map.values()
    sortedIndexByFirstChar.forEach(function(values) {
        values.sort(function(first, second) {
            return first.index - second.index;
        });
    });
    return sortedIndexByFirstChar;
}
function $87447cf003343840$export$4e7a864bb9287da7(opts, state) {
    var nextChar = opts.nextChar, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, focusedItemIndex = opts.focusedItemIndex, skipFocus = opts.skipFocus, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
    clearTimeout(state.bufferClearTimeout);
    state.bufferClearTimeout = setTimeout(function() {
        $87447cf003343840$export$abb0b37bc9255c0e(state);
    }, (0, $60a7b6c5311703e7$export$1f6c9cc012ebacae).TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS);
    state.typeaheadBuffer = state.typeaheadBuffer + nextChar;
    var index;
    if (state.typeaheadBuffer.length === 1) index = $87447cf003343840$var$matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state);
    else index = $87447cf003343840$var$matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state);
    if (index !== -1 && !skipFocus) focusItemAtIndex(index);
    return index;
}
/**
 * Matches the user's single input character in the buffer to the
 * next option that begins with such character. Wraps around if at
 * end of options. Returns -1 if no match is found.
 */ function $87447cf003343840$var$matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state) {
    var firstChar = state.typeaheadBuffer[0];
    var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
    if (!itemsMatchingFirstChar) return -1;
    // Has the same firstChar been recently matched?
    // Also, did starting index remain the same between key presses?
    // If both hold true, simply increment index.
    if (firstChar === state.currentFirstChar && itemsMatchingFirstChar[state.sortedIndexCursor].index === focusedItemIndex) {
        state.sortedIndexCursor = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
        var newIndex = itemsMatchingFirstChar[state.sortedIndexCursor].index;
        if (!isItemAtIndexDisabled(newIndex)) return newIndex;
    }
    // If we're here, it means one of the following happened:
    // - either firstChar or startingIndex has changed, invalidating the
    // cursor.
    // - The next item of typeahead is disabled, so we have to look further.
    state.currentFirstChar = firstChar;
    var newCursorPosition = -1;
    var cursorPosition;
    // Find the first non-disabled item as a fallback.
    for(cursorPosition = 0; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (!isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
        newCursorPosition = cursorPosition;
        break;
    }
    // Advance cursor to first item matching the firstChar that is positioned
    // after starting item. Cursor is unchanged from fallback if there's no
    // such item.
    for(; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (itemsMatchingFirstChar[cursorPosition].index > focusedItemIndex && !isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
        newCursorPosition = cursorPosition;
        break;
    }
    if (newCursorPosition !== -1) {
        state.sortedIndexCursor = newCursorPosition;
        return itemsMatchingFirstChar[state.sortedIndexCursor].index;
    }
    return -1;
}
/**
 * Attempts to find the next item that matches all of the typeahead buffer.
 * Wraps around if at end of options. Returns -1 if no match is found.
 */ function $87447cf003343840$var$matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state) {
    var firstChar = state.typeaheadBuffer[0];
    var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
    if (!itemsMatchingFirstChar) return -1;
    // Do nothing if text already matches
    var startingItem = itemsMatchingFirstChar[state.sortedIndexCursor];
    if (startingItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0 && !isItemAtIndexDisabled(startingItem.index)) return startingItem.index;
    // Find next item that matches completely; if no match, we'll eventually
    // loop around to same position
    var cursorPosition = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
    var nextCursorPosition = -1;
    while(cursorPosition !== state.sortedIndexCursor){
        var currentItem = itemsMatchingFirstChar[cursorPosition];
        var matches = currentItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0;
        var isEnabled = !isItemAtIndexDisabled(currentItem.index);
        if (matches && isEnabled) {
            nextCursorPosition = cursorPosition;
            break;
        }
        cursorPosition = (cursorPosition + 1) % itemsMatchingFirstChar.length;
    }
    if (nextCursorPosition !== -1) {
        state.sortedIndexCursor = nextCursorPosition;
        return itemsMatchingFirstChar[state.sortedIndexCursor].index;
    }
    return -1;
}
function $87447cf003343840$export$43c8479e57424c9e(state) {
    return state.typeaheadBuffer.length > 0;
}
function $87447cf003343840$export$abb0b37bc9255c0e(state) {
    state.typeaheadBuffer = "";
}
function $87447cf003343840$export$b70eff784f2f99b(opts, state) {
    var event = opts.event, isTargetListItem = opts.isTargetListItem, focusedItemIndex = opts.focusedItemIndex, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
    var isArrowLeft = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "ArrowLeft";
    var isArrowUp = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "ArrowUp";
    var isArrowRight = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "ArrowRight";
    var isArrowDown = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "ArrowDown";
    var isHome = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "Home";
    var isEnd = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "End";
    var isEnter = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "Enter";
    var isSpace = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === "Spacebar";
    if (event.altKey || event.ctrlKey || event.metaKey || isArrowLeft || isArrowUp || isArrowRight || isArrowDown || isHome || isEnd || isEnter) return -1;
    var isCharacterKey = !isSpace && event.key.length === 1;
    if (isCharacterKey) {
        (0, $d924d7e9d20d0e46$export$2bfdb8b2d5208a6b)(event);
        var matchItemOpts = {
            focusItemAtIndex: focusItemAtIndex,
            focusedItemIndex: focusedItemIndex,
            nextChar: event.key.toLowerCase(),
            sortedIndexByFirstChar: sortedIndexByFirstChar,
            skipFocus: false,
            isItemAtIndexDisabled: isItemAtIndexDisabled
        };
        return $87447cf003343840$export$4e7a864bb9287da7(matchItemOpts, state);
    }
    if (!isSpace) return -1;
    if (isTargetListItem) (0, $d924d7e9d20d0e46$export$2bfdb8b2d5208a6b)(event);
    var typeaheadOnListItem = isTargetListItem && $87447cf003343840$export$43c8479e57424c9e(state);
    if (typeaheadOnListItem) {
        var matchItemOpts = {
            focusItemAtIndex: focusItemAtIndex,
            focusedItemIndex: focusedItemIndex,
            nextChar: " ",
            sortedIndexByFirstChar: sortedIndexByFirstChar,
            skipFocus: false,
            isItemAtIndexDisabled: isItemAtIndexDisabled
        };
        // space participates in typeahead matching if in rapid typing mode
        return $87447cf003343840$export$4e7a864bb9287da7(matchItemOpts, state);
    }
    return -1;
}







/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $92b602978af3f119$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$92b602978af3f119$export$2e2bcd8739ae039 = $92b602978af3f119$export$a81b11d69c993162;



/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $74e275a846ea0ab0$export$c1c0562ec8379000 = {
    ANCHOR: "mdc-menu-surface--anchor",
    ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
    ANIMATING_OPEN: "mdc-menu-surface--animating-open",
    FIXED: "mdc-menu-surface--fixed",
    IS_OPEN_BELOW: "mdc-menu-surface--is-open-below",
    OPEN: "mdc-menu-surface--open",
    ROOT: "mdc-menu-surface"
};
// tslint:disable:object-literal-sort-keys
var $74e275a846ea0ab0$export$21c51bc433c16634 = {
    CLOSED_EVENT: "MDCMenuSurface:closed",
    CLOSING_EVENT: "MDCMenuSurface:closing",
    OPENED_EVENT: "MDCMenuSurface:opened",
    OPENING_EVENT: "MDCMenuSurface:opening",
    FOCUSABLE_ELEMENTS: [
        "button:not(:disabled)",
        '[href]:not([aria-disabled="true"])',
        "input:not(:disabled)",
        "select:not(:disabled)",
        "textarea:not(:disabled)",
        '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'
    ].join(", ")
};
// tslint:enable:object-literal-sort-keys
var $74e275a846ea0ab0$export$1f6c9cc012ebacae = {
    /** Total duration of menu-surface open animation. */ TRANSITION_OPEN_DURATION: 120,
    /** Total duration of menu-surface close animation. */ TRANSITION_CLOSE_DURATION: 75,
    /**
     * Margin left to the edge of the viewport when menu-surface is at maximum
     * possible height. Also used as a viewport margin.
     */ MARGIN_TO_EDGE: 32,
    /**
     * Ratio of anchor width to menu-surface width for switching from corner
     * positioning to center positioning.
     */ ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: 0.67,
    /**
     * Amount of time to wait before restoring focus when closing the menu
     * surface. This is important because if a touch event triggered the menu
     * close, and the subsequent mouse event occurs after focus is restored, then
     * the restored focus would be lost.
     */ TOUCH_EVENT_WAIT_MS: 30
};
/**
 * Enum for bits in the {@see Corner) bitmap.
 */ var $74e275a846ea0ab0$export$b1bff1cc6d391c8d;
(function(CornerBit) {
    CornerBit[CornerBit["BOTTOM"] = 1] = "BOTTOM";
    CornerBit[CornerBit["CENTER"] = 2] = "CENTER";
    CornerBit[CornerBit["RIGHT"] = 4] = "RIGHT";
    CornerBit[CornerBit["FLIP_RTL"] = 8] = "FLIP_RTL";
})($74e275a846ea0ab0$export$b1bff1cc6d391c8d || ($74e275a846ea0ab0$export$b1bff1cc6d391c8d = {}));
/**
 * Enum for representing an element corner for positioning the menu-surface.
 *
 * The START constants map to LEFT if element directionality is left
 * to right and RIGHT if the directionality is right to left.
 * Likewise END maps to RIGHT or LEFT depending on the directionality.
 */ var $74e275a846ea0ab0$export$ac61190d9fc311a9;
(function(Corner) {
    Corner[Corner["TOP_LEFT"] = 0] = "TOP_LEFT";
    Corner[Corner["TOP_RIGHT"] = 4] = "TOP_RIGHT";
    Corner[Corner["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
    Corner[Corner["BOTTOM_RIGHT"] = 5] = "BOTTOM_RIGHT";
    Corner[Corner["TOP_START"] = 8] = "TOP_START";
    Corner[Corner["TOP_END"] = 12] = "TOP_END";
    Corner[Corner["BOTTOM_START"] = 9] = "BOTTOM_START";
    Corner[Corner["BOTTOM_END"] = 13] = "BOTTOM_END";
})($74e275a846ea0ab0$export$ac61190d9fc311a9 || ($74e275a846ea0ab0$export$ac61190d9fc311a9 = {}));


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $c84fa93fc8537b33$export$c1c0562ec8379000 = {
    ACTIVATED: "mdc-select--activated",
    DISABLED: "mdc-select--disabled",
    FOCUSED: "mdc-select--focused",
    INVALID: "mdc-select--invalid",
    MENU_INVALID: "mdc-select__menu--invalid",
    OUTLINED: "mdc-select--outlined",
    REQUIRED: "mdc-select--required",
    ROOT: "mdc-select",
    WITH_LEADING_ICON: "mdc-select--with-leading-icon"
};
var $c84fa93fc8537b33$export$21c51bc433c16634 = {
    ARIA_CONTROLS: "aria-controls",
    ARIA_DESCRIBEDBY: "aria-describedby",
    ARIA_SELECTED_ATTR: "aria-selected",
    CHANGE_EVENT: "MDCSelect:change",
    HIDDEN_INPUT_SELECTOR: 'input[type="hidden"]',
    LABEL_SELECTOR: ".mdc-floating-label",
    LEADING_ICON_SELECTOR: ".mdc-select__icon",
    LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
    MENU_SELECTOR: ".mdc-select__menu",
    OUTLINE_SELECTOR: ".mdc-notched-outline",
    SELECTED_TEXT_SELECTOR: ".mdc-select__selected-text",
    SELECT_ANCHOR_SELECTOR: ".mdc-select__anchor",
    VALUE_ATTR: "data-value"
};
var $c84fa93fc8537b33$export$1f6c9cc012ebacae = {
    LABEL_SCALE: 0.75,
    UNSET_INDEX: -1,
    CLICK_DEBOUNCE_TIMEOUT_MS: 330
};


var $31a248de0c81ca86$export$97932d04812723e2 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCSelectFoundation, _super);
    /* istanbul ignore next: optional argument is not a branch statement */ /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCSelectFoundation(adapter, foundationMap) {
        if (foundationMap === void 0) foundationMap = {};
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCSelectFoundation.defaultAdapter), adapter)) || this;
        // Disabled state
        _this.disabled = false;
        // isMenuOpen is used to track the state of the menu by listening to the
        // MDCMenuSurface:closed event For reference, menu.open will return false if
        // the menu is still closing, but isMenuOpen returns false only after the menu
        // has closed
        _this.isMenuOpen = false;
        // By default, select is invalid if it is required but no value is selected.
        _this.useDefaultValidation = true;
        _this.customValidity = true;
        _this.lastSelectedIndex = (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).UNSET_INDEX;
        _this.clickDebounceTimeout = 0;
        _this.recentlyClicked = false;
        _this.leadingIcon = foundationMap.leadingIcon;
        _this.helperText = foundationMap.helperText;
        return _this;
    }
    Object.defineProperty(MDCSelectFoundation, "cssClasses", {
        get: function() {
            return 0, $c84fa93fc8537b33$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCSelectFoundation, "numbers", {
        get: function() {
            return 0, $c84fa93fc8537b33$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCSelectFoundation, "strings", {
        get: function() {
            return 0, $c84fa93fc8537b33$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCSelectFoundation, "defaultAdapter", {
        /**
         * See {@link MDCSelectAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                activateBottomLine: function() {
                    return undefined;
                },
                deactivateBottomLine: function() {
                    return undefined;
                },
                getSelectedIndex: function() {
                    return -1;
                },
                setSelectedIndex: function() {
                    return undefined;
                },
                hasLabel: function() {
                    return false;
                },
                floatLabel: function() {
                    return undefined;
                },
                getLabelWidth: function() {
                    return 0;
                },
                setLabelRequired: function() {
                    return undefined;
                },
                hasOutline: function() {
                    return false;
                },
                notchOutline: function() {
                    return undefined;
                },
                closeOutline: function() {
                    return undefined;
                },
                setRippleCenter: function() {
                    return undefined;
                },
                notifyChange: function() {
                    return undefined;
                },
                setSelectedText: function() {
                    return undefined;
                },
                isSelectAnchorFocused: function() {
                    return false;
                },
                getSelectAnchorAttr: function() {
                    return "";
                },
                setSelectAnchorAttr: function() {
                    return undefined;
                },
                removeSelectAnchorAttr: function() {
                    return undefined;
                },
                addMenuClass: function() {
                    return undefined;
                },
                removeMenuClass: function() {
                    return undefined;
                },
                openMenu: function() {
                    return undefined;
                },
                closeMenu: function() {
                    return undefined;
                },
                getAnchorElement: function() {
                    return null;
                },
                setMenuAnchorElement: function() {
                    return undefined;
                },
                setMenuAnchorCorner: function() {
                    return undefined;
                },
                setMenuWrapFocus: function() {
                    return undefined;
                },
                focusMenuItemAtIndex: function() {
                    return undefined;
                },
                getMenuItemCount: function() {
                    return 0;
                },
                getMenuItemValues: function() {
                    return [];
                },
                getMenuItemTextAtIndex: function() {
                    return "";
                },
                isTypeaheadInProgress: function() {
                    return false;
                },
                typeaheadMatchItem: function() {
                    return -1;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    /** Returns the index of the currently selected menu item, or -1 if none. */ MDCSelectFoundation.prototype.getSelectedIndex = function() {
        return this.adapter.getSelectedIndex();
    };
    MDCSelectFoundation.prototype.setSelectedIndex = function(index, closeMenu, skipNotify) {
        if (closeMenu === void 0) closeMenu = false;
        if (skipNotify === void 0) skipNotify = false;
        if (index >= this.adapter.getMenuItemCount()) return;
        if (index === (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).UNSET_INDEX) this.adapter.setSelectedText("");
        else this.adapter.setSelectedText(this.adapter.getMenuItemTextAtIndex(index).trim());
        this.adapter.setSelectedIndex(index);
        if (closeMenu) this.adapter.closeMenu();
        if (!skipNotify && this.lastSelectedIndex !== index) this.handleChange();
        this.lastSelectedIndex = index;
    };
    MDCSelectFoundation.prototype.setValue = function(value, skipNotify) {
        if (skipNotify === void 0) skipNotify = false;
        var index = this.adapter.getMenuItemValues().indexOf(value);
        this.setSelectedIndex(index, /** closeMenu */ false, skipNotify);
    };
    MDCSelectFoundation.prototype.getValue = function() {
        var index = this.adapter.getSelectedIndex();
        var menuItemValues = this.adapter.getMenuItemValues();
        return index !== (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).UNSET_INDEX ? menuItemValues[index] : "";
    };
    MDCSelectFoundation.prototype.getDisabled = function() {
        return this.disabled;
    };
    MDCSelectFoundation.prototype.setDisabled = function(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.adapter.addClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).DISABLED);
            this.adapter.closeMenu();
        } else this.adapter.removeClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).DISABLED);
        if (this.leadingIcon) this.leadingIcon.setDisabled(this.disabled);
        if (this.disabled) // Prevent click events from focusing select. Simply pointer-events: none
        // is not enough since screenreader clicks may bypass this.
        this.adapter.removeSelectAnchorAttr("tabindex");
        else this.adapter.setSelectAnchorAttr("tabindex", "0");
        this.adapter.setSelectAnchorAttr("aria-disabled", this.disabled.toString());
    };
    /** Opens the menu. */ MDCSelectFoundation.prototype.openMenu = function() {
        this.adapter.addClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).ACTIVATED);
        this.adapter.openMenu();
        this.isMenuOpen = true;
        this.adapter.setSelectAnchorAttr("aria-expanded", "true");
    };
    /**
     * @param content Sets the content of the helper text.
     */ MDCSelectFoundation.prototype.setHelperTextContent = function(content) {
        if (this.helperText) this.helperText.setContent(content);
    };
    /**
     * Re-calculates if the notched outline should be notched and if the label
     * should float.
     */ MDCSelectFoundation.prototype.layout = function() {
        if (this.adapter.hasLabel()) {
            var optionHasValue = this.getValue().length > 0;
            var isFocused = this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).FOCUSED);
            var shouldFloatAndNotch = optionHasValue || isFocused;
            var isRequired = this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED);
            this.notchOutline(shouldFloatAndNotch);
            this.adapter.floatLabel(shouldFloatAndNotch);
            this.adapter.setLabelRequired(isRequired);
        }
    };
    /**
     * Synchronizes the list of options with the state of the foundation. Call
     * this whenever menu options are dynamically updated.
     */ MDCSelectFoundation.prototype.layoutOptions = function() {
        var menuItemValues = this.adapter.getMenuItemValues();
        var selectedIndex = menuItemValues.indexOf(this.getValue());
        this.setSelectedIndex(selectedIndex, /** closeMenu */ false, /** skipNotify */ true);
    };
    MDCSelectFoundation.prototype.handleMenuOpened = function() {
        if (this.adapter.getMenuItemValues().length === 0) return;
        // Menu should open to the last selected element, should open to first menu item otherwise.
        var selectedIndex = this.getSelectedIndex();
        var focusItemIndex = selectedIndex >= 0 ? selectedIndex : 0;
        this.adapter.focusMenuItemAtIndex(focusItemIndex);
    };
    MDCSelectFoundation.prototype.handleMenuClosing = function() {
        this.adapter.setSelectAnchorAttr("aria-expanded", "false");
    };
    MDCSelectFoundation.prototype.handleMenuClosed = function() {
        this.adapter.removeClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).ACTIVATED);
        this.isMenuOpen = false;
        // Unfocus the select if menu is closed without a selection
        if (!this.adapter.isSelectAnchorFocused()) this.blur();
    };
    /**
     * Handles value changes, via change event or programmatic updates.
     */ MDCSelectFoundation.prototype.handleChange = function() {
        this.layout();
        this.adapter.notifyChange(this.getValue());
        var isRequired = this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED);
        if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
    };
    MDCSelectFoundation.prototype.handleMenuItemAction = function(index) {
        this.setSelectedIndex(index, /** closeMenu */ true);
    };
    /**
     * Handles focus events from select element.
     */ MDCSelectFoundation.prototype.handleFocus = function() {
        this.adapter.addClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).FOCUSED);
        this.layout();
        this.adapter.activateBottomLine();
    };
    /**
     * Handles blur events from select element.
     */ MDCSelectFoundation.prototype.handleBlur = function() {
        if (this.isMenuOpen) return;
        this.blur();
    };
    MDCSelectFoundation.prototype.handleClick = function(normalizedX) {
        if (this.disabled || this.recentlyClicked) return;
        this.setClickDebounceTimeout();
        if (this.isMenuOpen) {
            this.adapter.closeMenu();
            return;
        }
        this.adapter.setRippleCenter(normalizedX);
        this.openMenu();
    };
    /**
     * Handles keydown events on select element. Depending on the type of
     * character typed, does typeahead matching or opens menu.
     */ MDCSelectFoundation.prototype.handleKeydown = function(event) {
        if (this.isMenuOpen || !this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).FOCUSED)) return;
        var isEnter = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).ENTER;
        var isSpace = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).SPACEBAR;
        var arrowUp = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).ARROW_UP;
        var arrowDown = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(event) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).ARROW_DOWN;
        var isModifier = event.ctrlKey || event.metaKey;
        // Typeahead
        if (!isModifier && (!isSpace && event.key && event.key.length === 1 || isSpace && this.adapter.isTypeaheadInProgress())) {
            var key = isSpace ? " " : event.key;
            var typeaheadNextIndex = this.adapter.typeaheadMatchItem(key, this.getSelectedIndex());
            if (typeaheadNextIndex >= 0) this.setSelectedIndex(typeaheadNextIndex);
            event.preventDefault();
            return;
        }
        if (!isEnter && !isSpace && !arrowUp && !arrowDown) return;
        this.openMenu();
        event.preventDefault();
    };
    /**
     * Opens/closes the notched outline.
     */ MDCSelectFoundation.prototype.notchOutline = function(openNotch) {
        if (!this.adapter.hasOutline()) return;
        var isFocused = this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).FOCUSED);
        if (openNotch) {
            var labelScale = (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).LABEL_SCALE;
            var labelWidth = this.adapter.getLabelWidth() * labelScale;
            this.adapter.notchOutline(labelWidth);
        } else if (!isFocused) this.adapter.closeOutline();
    };
    /**
     * Sets the aria label of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconAriaLabel = function(label) {
        if (this.leadingIcon) this.leadingIcon.setAriaLabel(label);
    };
    /**
     * Sets the text content of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconContent = function(content) {
        if (this.leadingIcon) this.leadingIcon.setContent(content);
    };
    MDCSelectFoundation.prototype.getUseDefaultValidation = function() {
        return this.useDefaultValidation;
    };
    MDCSelectFoundation.prototype.setUseDefaultValidation = function(useDefaultValidation) {
        this.useDefaultValidation = useDefaultValidation;
    };
    MDCSelectFoundation.prototype.setValid = function(isValid) {
        if (!this.useDefaultValidation) this.customValidity = isValid;
        this.adapter.setSelectAnchorAttr("aria-invalid", (!isValid).toString());
        if (isValid) {
            this.adapter.removeClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).INVALID);
            this.adapter.removeMenuClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).MENU_INVALID);
        } else {
            this.adapter.addClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).INVALID);
            this.adapter.addMenuClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).MENU_INVALID);
        }
        this.syncHelperTextValidity(isValid);
    };
    MDCSelectFoundation.prototype.isValid = function() {
        if (this.useDefaultValidation && this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED) && !this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).DISABLED)) // See notes for required attribute under https://www.w3.org/TR/html52/sec-forms.html#the-select-element
        // TL;DR: Invalid if no index is selected, or if the first index is selected and has an empty value.
        return this.getSelectedIndex() !== (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).UNSET_INDEX && (this.getSelectedIndex() !== 0 || Boolean(this.getValue()));
        return this.customValidity;
    };
    MDCSelectFoundation.prototype.setRequired = function(isRequired) {
        if (isRequired) this.adapter.addClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED);
        else this.adapter.removeClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED);
        this.adapter.setSelectAnchorAttr("aria-required", isRequired.toString());
        this.adapter.setLabelRequired(isRequired);
    };
    MDCSelectFoundation.prototype.getRequired = function() {
        return this.adapter.getSelectAnchorAttr("aria-required") === "true";
    };
    MDCSelectFoundation.prototype.init = function() {
        var anchorEl = this.adapter.getAnchorElement();
        if (anchorEl) {
            this.adapter.setMenuAnchorElement(anchorEl);
            this.adapter.setMenuAnchorCorner((0, $74e275a846ea0ab0$export$ac61190d9fc311a9).BOTTOM_START);
        }
        this.adapter.setMenuWrapFocus(false);
        this.setDisabled(this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).DISABLED));
        this.syncHelperTextValidity(!this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).INVALID));
        this.layout();
        this.layoutOptions();
    };
    /**
     * Unfocuses the select component.
     */ MDCSelectFoundation.prototype.blur = function() {
        this.adapter.removeClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).FOCUSED);
        this.layout();
        this.adapter.deactivateBottomLine();
        var isRequired = this.adapter.hasClass((0, $c84fa93fc8537b33$export$c1c0562ec8379000).REQUIRED);
        if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
    };
    MDCSelectFoundation.prototype.syncHelperTextValidity = function(isValid) {
        if (!this.helperText) return;
        this.helperText.setValidity(isValid);
        var helperTextVisible = this.helperText.isVisible();
        var helperTextId = this.helperText.getId();
        if (helperTextVisible && helperTextId) this.adapter.setSelectAnchorAttr((0, $c84fa93fc8537b33$export$21c51bc433c16634).ARIA_DESCRIBEDBY, helperTextId);
        else // Needed because screenreaders will read labels pointed to by
        // `aria-describedby` even if they are `aria-hidden`.
        this.adapter.removeSelectAnchorAttr((0, $c84fa93fc8537b33$export$21c51bc433c16634).ARIA_DESCRIBEDBY);
    };
    MDCSelectFoundation.prototype.setClickDebounceTimeout = function() {
        var _this = this;
        clearTimeout(this.clickDebounceTimeout);
        this.clickDebounceTimeout = setTimeout(function() {
            _this.recentlyClicked = false;
        }, (0, $c84fa93fc8537b33$export$1f6c9cc012ebacae).CLICK_DEBOUNCE_TIMEOUT_MS);
        this.recentlyClicked = true;
    };
    return MDCSelectFoundation;
}((0, $92b602978af3f119$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$31a248de0c81ca86$export$2e2bcd8739ae039 = $31a248de0c81ca86$export$97932d04812723e2;






const $5a2d90439b27d6f4$var$createValidityObj = (customValidity = {})=>{
    /*
     * We need to make ValidityState an object because it is readonly and
     * we cannot use the spread operator. Also, we don't export
     * `CustomValidityState` because it is a leaky implementation and the user
     * already has access to `ValidityState` in lib.dom.ts. Also an interface
     * {a: Type} can be casted to {readonly a: Type} so passing any object
     * should be fine.
     */ const objectifiedCustomValidity = {};
    // eslint-disable-next-line guard-for-in
    for(const propName in customValidity)/*
         * Casting is needed because ValidityState's props are all readonly and
         * thus cannot be set on `onjectifiedCustomValidity`. In the end, the
         * interface is the same as ValidityState (but not readonly), but the
         * function signature casts the output to ValidityState (thus readonly).
         */ objectifiedCustomValidity[propName] = customValidity[propName];
    return Object.assign({
        badInput: false,
        customError: false,
        patternMismatch: false,
        rangeOverflow: false,
        rangeUnderflow: false,
        stepMismatch: false,
        tooLong: false,
        tooShort: false,
        typeMismatch: false,
        valid: true,
        valueMissing: false
    }, objectifiedCustomValidity);
};
class $5a2d90439b27d6f4$export$6b437c5bf6e35b26 extends (0, $362ad72c8b1dae7b$export$fcc7a416e8ecbf7a) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $31a248de0c81ca86$export$2e2bcd8739ae039);
        this.disabled = false;
        this.outlined = false;
        this.label = "";
        this.outlineOpen = false;
        this.outlineWidth = 0;
        this.value = "";
        this.name = "";
        this.selectedText = "";
        this.icon = "";
        this.menuOpen = false;
        this.helper = "";
        this.validateOnInitialRender = false;
        this.validationMessage = "";
        this.required = false;
        this.naturalMenuWidth = false;
        this.isUiValid = true;
        this.fixedMenuPosition = false;
        // Transiently holds current typeahead prefix from user.
        this.typeaheadState = $87447cf003343840$export$f6196a6c6bb539b4();
        this.sortedIndexByFirstChar = new Map();
        this.menuElement_ = null;
        this.listeners = [];
        this.onBodyClickBound = ()=>undefined;
        this._menuUpdateComplete = null;
        this.valueSetDirectly = false;
        this.validityTransform = null;
        this._validity = $5a2d90439b27d6f4$var$createValidityObj();
    }
    get items() {
        // memoize menuElement to prevent unnecessary querySelector calls.
        if (!this.menuElement_) this.menuElement_ = this.menuElement;
        if (this.menuElement_) return this.menuElement_.items;
        return [];
    }
    get selected() {
        const menuElement = this.menuElement;
        if (menuElement) return menuElement.selected;
        return null;
    }
    get index() {
        const menuElement = this.menuElement;
        if (menuElement) return menuElement.index;
        return -1;
    }
    get shouldRenderHelperText() {
        return !!this.helper || !!this.validationMessage;
    }
    get validity() {
        this._checkValidity(this.value);
        return this._validity;
    }
    render() {
        const classes = {
            "mdc-select--disabled": this.disabled,
            "mdc-select--no-label": !this.label,
            "mdc-select--filled": !this.outlined,
            "mdc-select--outlined": this.outlined,
            "mdc-select--with-leading-icon": !!this.icon,
            "mdc-select--required": this.required,
            "mdc-select--invalid": !this.isUiValid
        };
        const labelledby = !!this.label ? "label" : undefined;
        const describedby = this.shouldRenderHelperText ? "helper-text" : undefined;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div
          class="mdc-select ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        <input
            class="formElement"
            name="${this.name}"
            .value="${this.value}"
            hidden
            ?disabled="${this.disabled}"
            ?required=${this.required}>
        <!-- @ts-ignore -->
        <div class="mdc-select__anchor"
            aria-autocomplete="none"
            role="combobox"
            aria-expanded=${this.menuOpen}
            aria-invalid=${!this.isUiValid}
            aria-haspopup="listbox"
            aria-labelledby=${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(labelledby)}
            aria-required=${this.required}
            aria-describedby=${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(describedby)}
            @click=${this.onClick}
            @focus=${this.onFocus}
            @blur=${this.onBlur}
            @keydown=${this.onKeydown}>
          ${this.renderRipple()}
          ${this.outlined ? this.renderOutline() : this.renderLabel()}
          ${this.renderLeadingIcon()}
          <span class="mdc-select__selected-text-container">
            <span class="mdc-select__selected-text">${this.selectedText}</span>
          </span>
          <span class="mdc-select__dropdown-icon">
            <svg
                class="mdc-select__dropdown-icon-graphic"
                viewBox="7 10 10 5"
                focusable="false">
              <polygon
                  class="mdc-select__dropdown-icon-inactive"
                  stroke="none"
                  fill-rule="evenodd"
                  points="7 10 12 15 17 10">
              </polygon>
              <polygon
                  class="mdc-select__dropdown-icon-active"
                  stroke="none"
                  fill-rule="evenodd"
                  points="7 15 12 10 17 15">
              </polygon>
            </svg>
          </span>
          ${this.renderLineRipple()}
        </div>
        ${this.renderMenu()}
      </div>
      ${this.renderHelperText()}`;
    }
    renderMenu() {
        const classes = this.getMenuClasses();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-menu
        innerRole="listbox"
        wrapFocus
        class=" ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
        activatable
        .fullwidth=${this.fixedMenuPosition ? false : !this.naturalMenuWidth}
        .open=${this.menuOpen}
        .anchor=${this.anchorElement}
        .fixed=${this.fixedMenuPosition}
        @selected=${this.onSelected}
        @opened=${this.onOpened}
        @closed=${this.onClosed}
        @items-updated=${this.onItemsUpdated}
        @keydown=${this.handleTypeahead}>
      ${this.renderMenuContent()}
    </mwc-menu>`;
    }
    getMenuClasses() {
        return {
            "mdc-select__menu": true,
            "mdc-menu": true,
            "mdc-menu-surface": true,
            "mdc-select__menu--invalid": !this.isUiValid
        };
    }
    renderMenuContent() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    renderRipple() {
        if (this.outlined) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="mdc-select__ripple"></span>
    `;
    }
    renderOutline() {
        if (!this.outlined) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-notched-outline
          .width=${this.outlineWidth}
          .open=${this.outlineOpen}
          class="mdc-notched-outline">
        ${this.renderLabel()}
      </mwc-notched-outline>`;
    }
    renderLabel() {
        if (!this.label) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span
          .floatingLabelFoundation=${(0, $08d6fdf9123f1e40$export$a5e5b5e75cfc3b36)(this.label)}
          id="label">${this.label}</span>
    `;
    }
    renderLeadingIcon() {
        if (!this.icon) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-icon class="mdc-select__icon"><div>${this.icon}</div></mwc-icon>`;
    }
    renderLineRipple() {
        if (this.outlined) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span .lineRippleFoundation=${(0, $26dc552073ed1864$export$4e67d44fb59b80f2)()}></span>
    `;
    }
    renderHelperText() {
        if (!this.shouldRenderHelperText) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        const showValidationMessage = this.validationMessage && !this.isUiValid;
        const classes = {
            "mdc-select-helper-text--validation-msg": showValidationMessage
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <p
          class="mdc-select-helper-text ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
          id="helper-text">${showValidationMessage ? this.validationMessage : this.helper}</p>`;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot)), {
            activateBottomLine: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.activate();
            },
            deactivateBottomLine: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.deactivate();
            },
            hasLabel: ()=>{
                return !!this.label;
            },
            floatLabel: (shouldFloat)=>{
                if (this.labelElement) this.labelElement.floatingLabelFoundation.float(shouldFloat);
            },
            getLabelWidth: ()=>{
                if (this.labelElement) return this.labelElement.floatingLabelFoundation.getWidth();
                return 0;
            },
            setLabelRequired: (isRequired)=>{
                if (this.labelElement) this.labelElement.floatingLabelFoundation.setRequired(isRequired);
            },
            hasOutline: ()=>this.outlined,
            notchOutline: (labelWidth)=>{
                const outlineElement = this.outlineElement;
                if (outlineElement && !this.outlineOpen) {
                    this.outlineWidth = labelWidth;
                    this.outlineOpen = true;
                }
            },
            closeOutline: ()=>{
                if (this.outlineElement) this.outlineOpen = false;
            },
            setRippleCenter: (normalizedX)=>{
                if (this.lineRippleElement) {
                    const foundation = this.lineRippleElement.lineRippleFoundation;
                    foundation.setRippleCenter(normalizedX);
                }
            },
            notifyChange: async (value)=>{
                if (!this.valueSetDirectly && value === this.value) return;
                this.valueSetDirectly = false;
                this.value = value;
                await this.updateComplete;
                const ev = new Event("change", {
                    bubbles: true
                });
                this.dispatchEvent(ev);
            },
            setSelectedText: (value)=>this.selectedText = value,
            isSelectAnchorFocused: ()=>{
                const selectAnchorElement = this.anchorElement;
                if (!selectAnchorElement) return false;
                const rootNode = selectAnchorElement.getRootNode();
                return rootNode.activeElement === selectAnchorElement;
            },
            getSelectAnchorAttr: (attr)=>{
                const selectAnchorElement = this.anchorElement;
                if (!selectAnchorElement) return null;
                return selectAnchorElement.getAttribute(attr);
            },
            setSelectAnchorAttr: (attr, value)=>{
                const selectAnchorElement = this.anchorElement;
                if (!selectAnchorElement) return;
                selectAnchorElement.setAttribute(attr, value);
            },
            removeSelectAnchorAttr: (attr)=>{
                const selectAnchorElement = this.anchorElement;
                if (!selectAnchorElement) return;
                selectAnchorElement.removeAttribute(attr);
            },
            openMenu: ()=>{
                this.menuOpen = true;
            },
            closeMenu: ()=>{
                this.menuOpen = false;
            },
            addMenuClass: ()=>undefined,
            removeMenuClass: ()=>undefined,
            getAnchorElement: ()=>this.anchorElement,
            setMenuAnchorElement: ()=>{
            /* Handled by anchor directive */ },
            setMenuAnchorCorner: ()=>{
                const menuElement = this.menuElement;
                if (menuElement) menuElement.corner = "BOTTOM_START";
            },
            setMenuWrapFocus: (wrapFocus)=>{
                const menuElement = this.menuElement;
                if (menuElement) menuElement.wrapFocus = wrapFocus;
            },
            focusMenuItemAtIndex: (index)=>{
                const menuElement = this.menuElement;
                if (!menuElement) return;
                const element = menuElement.items[index];
                if (!element) return;
                element.focus();
            },
            getMenuItemCount: ()=>{
                const menuElement = this.menuElement;
                if (menuElement) return menuElement.items.length;
                return 0;
            },
            getMenuItemValues: ()=>{
                const menuElement = this.menuElement;
                if (!menuElement) return [];
                const items = menuElement.items;
                return items.map((item)=>item.value);
            },
            getMenuItemTextAtIndex: (index)=>{
                const menuElement = this.menuElement;
                if (!menuElement) return "";
                const element = menuElement.items[index];
                if (!element) return "";
                return element.text;
            },
            getSelectedIndex: ()=>this.index,
            setSelectedIndex: ()=>undefined,
            isTypeaheadInProgress: ()=>$87447cf003343840$export$43c8479e57424c9e(this.typeaheadState),
            typeaheadMatchItem: (nextChar, startingIndex)=>{
                if (!this.menuElement) return -1;
                const opts = {
                    focusItemAtIndex: (index)=>{
                        this.menuElement.focusItemAtIndex(index);
                    },
                    focusedItemIndex: startingIndex ? startingIndex : this.menuElement.getFocusedItemIndex(),
                    nextChar: nextChar,
                    sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                    skipFocus: false,
                    isItemAtIndexDisabled: (index)=>this.items[index].disabled
                };
                const index = $87447cf003343840$export$4e7a864bb9287da7(opts, this.typeaheadState);
                if (index !== -1) this.select(index);
                return index;
            }
        });
    }
    checkValidity() {
        const isValid = this._checkValidity(this.value);
        if (!isValid) {
            const invalidEvent = new Event("invalid", {
                bubbles: false,
                cancelable: true
            });
            this.dispatchEvent(invalidEvent);
        }
        return isValid;
    }
    reportValidity() {
        const isValid = this.checkValidity();
        this.isUiValid = isValid;
        return isValid;
    }
    _checkValidity(value) {
        const nativeValidity = this.formElement.validity;
        let validity = $5a2d90439b27d6f4$var$createValidityObj(nativeValidity);
        if (this.validityTransform) {
            const customValidity = this.validityTransform(value, validity);
            validity = Object.assign(Object.assign({}, validity), customValidity);
        }
        this._validity = validity;
        return this._validity.valid;
    }
    setCustomValidity(message) {
        this.validationMessage = message;
        this.formElement.setCustomValidity(message);
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        await this._menuUpdateComplete;
        // @ts-ignore
        const result = await super.getUpdateComplete();
        return result;
    }
    // tslint:enable:ban-ts-ignore
    async firstUpdated() {
        const menuElement = this.menuElement;
        if (menuElement) {
            this._menuUpdateComplete = menuElement.updateComplete;
            await this._menuUpdateComplete;
        }
        super.firstUpdated();
        this.mdcFoundation.isValid = ()=>true;
        this.mdcFoundation.setValid = ()=>undefined;
        this.mdcFoundation.setDisabled(this.disabled);
        if (this.validateOnInitialRender) this.reportValidity();
        // Select an option based on init value
        if (!this.selected) {
            if (!this.items.length && this.slotElement && this.slotElement.assignedNodes({
                flatten: true
            }).length) {
                // Shady DOM initial render fix
                await new Promise((res)=>requestAnimationFrame(res));
                await this.layout();
            }
            const hasEmptyFirstOption = this.items.length && this.items[0].value === "";
            if (!this.value && hasEmptyFirstOption) {
                this.select(0);
                return;
            }
            this.selectByValue(this.value);
        }
        this.sortedIndexByFirstChar = $87447cf003343840$export$a58b3686f50ca14c(this.items.length, (index)=>this.items[index].text);
    }
    onItemsUpdated() {
        this.sortedIndexByFirstChar = $87447cf003343840$export$a58b3686f50ca14c(this.items.length, (index)=>this.items[index].text);
    }
    select(index) {
        const menuElement = this.menuElement;
        if (menuElement) menuElement.select(index);
    }
    selectByValue(value) {
        let indexToSelect = -1;
        for(let i = 0; i < this.items.length; i++){
            const item = this.items[i];
            if (item.value === value) {
                indexToSelect = i;
                break;
            }
        }
        this.valueSetDirectly = true;
        this.select(indexToSelect);
        this.mdcFoundation.handleChange();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        for (const listener of this.listeners)listener.target.removeEventListener(listener.name, listener.cb);
    }
    focus() {
        const focusEvt = new CustomEvent("focus");
        const selectAnchorElement = this.anchorElement;
        if (selectAnchorElement) {
            selectAnchorElement.dispatchEvent(focusEvt);
            selectAnchorElement.focus();
        }
    }
    blur() {
        const focusEvt = new CustomEvent("blur");
        const selectAnchorElement = this.anchorElement;
        if (selectAnchorElement) {
            selectAnchorElement.dispatchEvent(focusEvt);
            selectAnchorElement.blur();
        }
    }
    onFocus() {
        if (this.mdcFoundation) this.mdcFoundation.handleFocus();
    }
    onBlur() {
        if (this.mdcFoundation) this.mdcFoundation.handleBlur();
        const menuElement = this.menuElement;
        if (menuElement && !menuElement.open) this.reportValidity();
    }
    onClick(evt) {
        if (this.mdcFoundation) {
            this.focus();
            const targetClientRect = evt.target.getBoundingClientRect();
            let xCoord = 0;
            if ("touches" in evt) xCoord = evt.touches[0].clientX;
            else xCoord = evt.clientX;
            const normalizedX = xCoord - targetClientRect.left;
            this.mdcFoundation.handleClick(normalizedX);
        }
    }
    onKeydown(evt) {
        const arrowUp = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(evt) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).ARROW_UP;
        const arrowDown = (0, $08db7a261b1f13aa$export$e0c709538cb8ae18)(evt) === (0, $08db7a261b1f13aa$export$7167c830cefcb6b5).ARROW_DOWN;
        if (arrowDown || arrowUp) {
            const shouldSelectNextItem = arrowUp && this.index > 0;
            const shouldSelectPrevItem = arrowDown && this.index < this.items.length - 1;
            if (shouldSelectNextItem) this.select(this.index - 1);
            else if (shouldSelectPrevItem) this.select(this.index + 1);
            evt.preventDefault();
            this.mdcFoundation.openMenu();
            return;
        }
        this.mdcFoundation.handleKeydown(evt);
    }
    // must capture to run before list foundation captures event
    handleTypeahead(event) {
        if (!this.menuElement) return;
        const focusedItemIndex = this.menuElement.getFocusedItemIndex();
        const target = (0, $748a8e1d68854803$export$c86dc70db5dbb27d)(event.target) ? event.target : null;
        const isTargetListItem = target ? target.hasAttribute("mwc-list-item") : false;
        const opts = {
            event: event,
            focusItemAtIndex: (index)=>{
                this.menuElement.focusItemAtIndex(index);
            },
            focusedItemIndex: focusedItemIndex,
            isTargetListItem: isTargetListItem,
            sortedIndexByFirstChar: this.sortedIndexByFirstChar,
            isItemAtIndexDisabled: (index)=>this.items[index].disabled
        };
        $87447cf003343840$export$b70eff784f2f99b(opts, this.typeaheadState);
    }
    async onSelected(event) {
        if (!this.mdcFoundation) await this.updateComplete;
        this.mdcFoundation.handleMenuItemAction(event.detail.index);
        const item = this.items[event.detail.index];
        if (item) this.value = item.value;
    }
    onOpened() {
        if (this.mdcFoundation) {
            this.menuOpen = true;
            this.mdcFoundation.handleMenuOpened();
        }
    }
    onClosed() {
        if (this.mdcFoundation) {
            this.menuOpen = false;
            this.mdcFoundation.handleMenuClosed();
        }
    }
    setFormData(formData) {
        if (this.name && this.selected !== null) formData.append(this.name, this.value);
    }
    async layout(updateItems = true) {
        if (this.mdcFoundation) this.mdcFoundation.layout();
        await this.updateComplete;
        const menuElement = this.menuElement;
        if (menuElement) menuElement.layout(updateItems);
        const labelElement = this.labelElement;
        if (!labelElement) {
            this.outlineOpen = false;
            return;
        }
        const shouldFloat = !!this.label && !!this.value;
        labelElement.floatingLabelFoundation.float(shouldFloat);
        if (!this.outlined) return;
        this.outlineOpen = shouldFloat;
        await this.updateComplete;
        /* When the textfield automatically notches due to a value and label
         * being defined, the textfield may be set to `display: none` by the user.
         * this means that the notch is of size 0px. We provide this function so
         * that the user may manually resize the notch to the floated label's
         * width.
         */ const labelWidth = labelElement.floatingLabelFoundation.getWidth();
        if (this.outlineOpen) this.outlineWidth = labelWidth;
    }
    async layoutOptions() {
        if (!this.mdcFoundation) return;
        this.mdcFoundation.layoutOptions();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-select")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".formElement")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "formElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "slotElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("select")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "nativeSelectElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("input")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "nativeInputElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-line-ripple")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "lineRippleElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-floating-label")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "labelElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("mwc-notched-outline")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "outlineElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-menu")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "menuElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-select__anchor")
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "anchorElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "disabled",
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setDisabled(value);
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.outlined !== oldVal) this.layout(false);
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "outlined", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.label !== oldVal) this.layout(false);
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "outlineOpen", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "outlineWidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(value) {
        if (this.mdcFoundation) {
            const initialization = this.selected === null && !!value;
            const valueSetByUser = this.selected && this.selected.value !== value;
            if (initialization || valueSetByUser) this.selectByValue(value);
            this.reportValidity();
        }
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "name", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "selectedText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "icon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "menuOpen", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "helper", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "validateOnInitialRender", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "validationMessage", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "naturalMenuWidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "isUiValid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "fixedMenuPosition", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e5c3d47edfef3b02$export$b2b799818fbabcf3)({
        capture: true
    })
], $5a2d90439b27d6f4$export$6b437c5bf6e35b26.prototype, "handleTypeahead", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $999091bb23061ddb$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-floating-label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);position:absolute;left:0;-webkit-transform-origin:left top;transform-origin:left top;line-height:1.15rem;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;will-change:transform;transition:transform 150ms cubic-bezier(0.4, 0, 0.2, 1),color 150ms cubic-bezier(0.4, 0, 0.2, 1)}[dir=rtl] .mdc-floating-label,.mdc-floating-label[dir=rtl]{right:0;left:auto;-webkit-transform-origin:right top;transform-origin:right top;text-align:right}.mdc-floating-label--float-above{cursor:auto}.mdc-floating-label--required::after{margin-left:1px;margin-right:0px;content:"*"}[dir=rtl] .mdc-floating-label--required::after,.mdc-floating-label--required[dir=rtl]::after{margin-left:0;margin-right:1px}.mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-standard 250ms 1}@keyframes mdc-floating-label-shake-float-above-standard{0%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-106%) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-106%) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}}@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}.mdc-line-ripple::before,.mdc-line-ripple::after{position:absolute;bottom:0;left:0;width:100%;border-bottom-style:solid;content:""}.mdc-line-ripple::before{border-bottom-width:1px}.mdc-line-ripple::before{z-index:1}.mdc-line-ripple::after{transform:scaleX(0);border-bottom-width:2px;opacity:0;z-index:2}.mdc-line-ripple::after{transition:transform 180ms cubic-bezier(0.4, 0, 0.2, 1),opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-line-ripple--active::after{transform:scaleX(1);opacity:1}.mdc-line-ripple--deactivating::after{opacity:0}.mdc-notched-outline{display:flex;position:absolute;top:0;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;height:100%;border-top:1px solid;border-bottom:1px solid;pointer-events:none}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:0 0 auto;width:auto;max-width:calc(100% - 12px * 2)}.mdc-notched-outline .mdc-floating-label{display:inline-block;position:relative;max-width:100%}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:calc(100% / 0.75)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-left:0;padding-right:8px;border-top:none}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}.mdc-select{display:inline-flex;position:relative}.mdc-select:not(.mdc-select--disabled) .mdc-select__selected-text{color:rgba(0, 0, 0, 0.87)}.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:rgba(0, 0, 0, 0.38)}.mdc-select:not(.mdc-select--disabled) .mdc-floating-label{color:rgba(0, 0, 0, 0.6)}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label{color:rgba(98, 0, 238, 0.87)}.mdc-select.mdc-select--disabled .mdc-floating-label{color:rgba(0, 0, 0, 0.38)}.mdc-select:not(.mdc-select--disabled) .mdc-select__dropdown-icon{fill:rgba(0, 0, 0, 0.54)}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:#6200ee;fill:var(--mdc-theme-primary, #6200ee)}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:rgba(0, 0, 0, 0.38)}.mdc-select:not(.mdc-select--disabled)+.mdc-select-helper-text{color:rgba(0, 0, 0, 0.6)}.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:rgba(0, 0, 0, 0.38)}.mdc-select:not(.mdc-select--disabled) .mdc-select__icon{color:rgba(0, 0, 0, 0.54)}.mdc-select.mdc-select--disabled .mdc-select__icon{color:rgba(0, 0, 0, 0.38)}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:GrayText}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:red}.mdc-select.mdc-select--disabled .mdc-floating-label{color:GrayText}.mdc-select.mdc-select--disabled .mdc-line-ripple::before{border-bottom-color:GrayText}.mdc-select.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select.mdc-select--disabled .mdc-notched-outline__trailing{border-color:GrayText}.mdc-select.mdc-select--disabled .mdc-select__icon{color:GrayText}.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:GrayText}}.mdc-select .mdc-floating-label{top:50%;transform:translateY(-50%);pointer-events:none}.mdc-select .mdc-select__anchor{padding-left:16px;padding-right:0}[dir=rtl] .mdc-select .mdc-select__anchor,.mdc-select .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:16px}.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor{padding-left:0;padding-right:0}[dir=rtl] .mdc-select.mdc-select--with-leading-icon .mdc-select__anchor,.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:0}.mdc-select .mdc-select__icon{width:24px;height:24px;font-size:24px}.mdc-select .mdc-select__dropdown-icon{width:24px;height:24px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item{padding-left:16px;padding-right:16px}[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item,.mdc-select .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic{margin-left:0;margin-right:12px}[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic,.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:12px;margin-right:0}.mdc-select__dropdown-icon{margin-left:12px;margin-right:12px;display:inline-flex;position:relative;align-self:center;align-items:center;justify-content:center;flex-shrink:0;pointer-events:none}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active,.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{position:absolute;top:0;left:0}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-graphic{width:41.6666666667%;height:20.8333333333%}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:1;transition:opacity 75ms linear 75ms}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:0;transition:opacity 75ms linear}[dir=rtl] .mdc-select__dropdown-icon,.mdc-select__dropdown-icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:0;transition:opacity 49.5ms linear}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:1;transition:opacity 100.5ms linear 49.5ms}.mdc-select__anchor{width:200px;min-width:0;flex:1 1 auto;position:relative;box-sizing:border-box;overflow:hidden;outline:none;cursor:pointer}.mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-select__selected-text-container{display:flex;appearance:none;pointer-events:none;box-sizing:border-box;width:auto;min-width:0;flex-grow:1;height:28px;border:none;outline:none;padding:0;background-color:transparent;color:inherit}.mdc-select__selected-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height, 1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:block;width:100%;text-align:left}[dir=rtl] .mdc-select__selected-text,.mdc-select__selected-text[dir=rtl]{text-align:right}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-floating-label{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--invalid+.mdc-select-helper-text--validation-msg{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-select__dropdown-icon{fill:#b00020;fill:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:#b00020;fill:var(--mdc-theme-error, #b00020)}.mdc-select--disabled{cursor:default;pointer-events:none}.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item{padding-left:12px;padding-right:12px}[dir=rtl] .mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item,.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:12px;padding-right:12px}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-select__menu::before{position:absolute;box-sizing:border-box;width:100%;height:100%;top:0;left:0;border:1px solid transparent;border-radius:inherit;content:"";pointer-events:none}}@media screen and (forced-colors: active)and (forced-colors: active),screen and (-ms-high-contrast: active)and (forced-colors: active){.mdc-select__menu::before{border-color:CanvasText}}.mdc-select__menu .mdc-deprecated-list .mdc-select__icon,.mdc-select__menu .mdc-list .mdc-select__icon{margin-left:0;margin-right:0}[dir=rtl] .mdc-select__menu .mdc-deprecated-list .mdc-select__icon,[dir=rtl] .mdc-select__menu .mdc-list .mdc-select__icon,.mdc-select__menu .mdc-deprecated-list .mdc-select__icon[dir=rtl],.mdc-select__menu .mdc-list .mdc-select__icon[dir=rtl]{margin-left:0;margin-right:0}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated,.mdc-select__menu .mdc-list .mdc-deprecated-list-item--selected,.mdc-select__menu .mdc-list .mdc-deprecated-list-item--activated{color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic,.mdc-select__menu .mdc-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-select__menu .mdc-list .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-select__menu .mdc-list-item__start{display:inline-flex;align-items:center}.mdc-select__option{padding-left:16px;padding-right:16px}[dir=rtl] .mdc-select__option,.mdc-select__option[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-select__one-line-option.mdc-list-item--with-one-line{height:48px}.mdc-select__two-line-option.mdc-list-item--with-two-lines{height:64px}.mdc-select__two-line-option.mdc-list-item--with-two-lines .mdc-list-item__start{margin-top:20px}.mdc-select__two-line-option.mdc-list-item--with-two-lines .mdc-list-item__primary-text{display:block;margin-top:0;line-height:normal;margin-bottom:-20px}.mdc-select__two-line-option.mdc-list-item--with-two-lines .mdc-list-item__primary-text::before{display:inline-block;width:0;height:28px;content:"";vertical-align:0}.mdc-select__two-line-option.mdc-list-item--with-two-lines .mdc-list-item__primary-text::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}.mdc-select__two-line-option.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{display:block;margin-top:0;line-height:normal}.mdc-select__two-line-option.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end::before{display:inline-block;width:0;height:36px;content:"";vertical-align:0}.mdc-select__option-with-leading-content{padding-left:0;padding-right:12px}.mdc-select__option-with-leading-content.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-select__option-with-leading-content.mdc-list-item,.mdc-select__option-with-leading-content.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-select__option-with-leading-content .mdc-list-item__start{margin-left:12px;margin-right:0}[dir=rtl] .mdc-select__option-with-leading-content .mdc-list-item__start,.mdc-select__option-with-leading-content .mdc-list-item__start[dir=rtl]{margin-left:0;margin-right:12px}.mdc-select__option-with-leading-content .mdc-list-item__start{width:36px;height:24px}[dir=rtl] .mdc-select__option-with-leading-content,.mdc-select__option-with-leading-content[dir=rtl]{padding-left:12px;padding-right:0}.mdc-select__option-with-meta.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-select__option-with-meta.mdc-list-item,.mdc-select__option-with-meta.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-select__option-with-meta .mdc-list-item__end{margin-left:12px;margin-right:12px}[dir=rtl] .mdc-select__option-with-meta .mdc-list-item__end,.mdc-select__option-with-meta .mdc-list-item__end[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select--filled .mdc-select__anchor{height:56px;display:flex;align-items:baseline}.mdc-select--filled .mdc-select__anchor::before{display:inline-block;width:0;height:40px;content:"";vertical-align:0}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text::before{content:"​"}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text-container{height:100%;display:inline-flex;align-items:center}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor::before{display:none}.mdc-select--filled .mdc-select__anchor{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:0;border-bottom-left-radius:0}.mdc-select--filled:not(.mdc-select--disabled) .mdc-select__anchor{background-color:whitesmoke}.mdc-select--filled.mdc-select--disabled .mdc-select__anchor{background-color:#fafafa}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42)}.mdc-select--filled:not(.mdc-select--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87)}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple::after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary, #6200ee)}.mdc-select--filled.mdc-select--disabled .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.06)}.mdc-select--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-select--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 64px / 0.75)}.mdc-select--filled .mdc-menu-surface--is-open-below{border-top-left-radius:0px;border-top-right-radius:0px}.mdc-select--filled.mdc-select--focused.mdc-line-ripple::after{transform:scale(1, 2);opacity:1}.mdc-select--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-select--filled .mdc-floating-label,.mdc-select--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{left:48px;right:initial}[dir=rtl] .mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 96px / 0.75)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled):hover .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple::after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-select--outlined{border:none}.mdc-select--outlined .mdc-select__anchor{height:56px}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-37.25px) scale(1)}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) scale(0.75)}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-56px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-56px{0%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}@supports(top: max(0%)){.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px, var(--mdc-shape-small, 4px)) * 2)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}@supports(top: max(0%)){.mdc-select--outlined .mdc-select__anchor{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-left:0}@supports(top: max(0%)){[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-right:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}@supports(top: max(0%)){.mdc-select--outlined+.mdc-select-helper-text{margin-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-left:0}@supports(top: max(0%)){[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-right:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-select__anchor{background-color:transparent}.mdc-select--outlined.mdc-select--disabled .mdc-select__anchor{background-color:transparent}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.38)}.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.87)}.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px}.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#6200ee;border-color:var(--mdc-theme-primary, #6200ee)}.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.06)}.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-select--outlined .mdc-select__anchor{display:flex;align-items:baseline;overflow:visible}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined 250ms 1}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-37.25px) scale(1)}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) scale(0.75)}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text::before{content:"​"}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text-container{height:100%;display:inline-flex;align-items:center}.mdc-select--outlined .mdc-select__anchor::before{display:none}.mdc-select--outlined .mdc-select__selected-text-container{display:flex;border:none;z-index:1;background-color:transparent}.mdc-select--outlined .mdc-select__icon{z-index:2}.mdc-select--outlined .mdc-floating-label{line-height:1.15rem;left:4px;right:initial}[dir=rtl] .mdc-select--outlined .mdc-floating-label,.mdc-select--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-select--outlined.mdc-select--focused .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{transform:translateY(-37.25px) translateX(-32px) scale(1)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px) translateX(32px) scale(1)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{font-size:.75rem}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) translateX(-32px) scale(0.75)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px) translateX(32px) scale(0.75)}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px{0%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake,.mdc-select--outlined.mdc-select--with-leading-icon[dir=rtl] .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px-rtl{0%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - -32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - -32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 96px)}.mdc-select--outlined .mdc-menu-surface{margin-bottom:8px}.mdc-select--outlined.mdc-select--no-label .mdc-menu-surface,.mdc-select--outlined .mdc-menu-surface--is-open-below{margin-bottom:0}.mdc-select__anchor{--mdc-ripple-fg-size: 0;--mdc-ripple-left: 0;--mdc-ripple-top: 0;--mdc-ripple-fg-scale: 1;--mdc-ripple-fg-translate-end: 0;--mdc-ripple-fg-translate-start: 0;-webkit-tap-highlight-color:rgba(0,0,0,0);will-change:transform,opacity}.mdc-select__anchor .mdc-select__ripple::before,.mdc-select__anchor .mdc-select__ripple::after{position:absolute;border-radius:50%;opacity:0;pointer-events:none;content:""}.mdc-select__anchor .mdc-select__ripple::before{transition:opacity 15ms linear,background-color 15ms linear;z-index:1;z-index:var(--mdc-ripple-z-index, 1)}.mdc-select__anchor .mdc-select__ripple::after{z-index:0;z-index:var(--mdc-ripple-z-index, 0)}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple::before{transform:scale(var(--mdc-ripple-fg-scale, 1))}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple::after{top:0;left:0;transform:scale(0);transform-origin:center center}.mdc-select__anchor.mdc-ripple-upgraded--unbounded .mdc-select__ripple::after{top:var(--mdc-ripple-top, 0);left:var(--mdc-ripple-left, 0)}.mdc-select__anchor.mdc-ripple-upgraded--foreground-activation .mdc-select__ripple::after{animation:mdc-ripple-fg-radius-in 225ms forwards,mdc-ripple-fg-opacity-in 75ms forwards}.mdc-select__anchor.mdc-ripple-upgraded--foreground-deactivation .mdc-select__ripple::after{animation:mdc-ripple-fg-opacity-out 150ms;transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}.mdc-select__anchor .mdc-select__ripple::before,.mdc-select__anchor .mdc-select__ripple::after{top:calc(50% - 100%);left:calc(50% - 100%);width:200%;height:200%}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-select__anchor .mdc-select__ripple::before,.mdc-select__anchor .mdc-select__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-select__anchor:hover .mdc-select__ripple::before,.mdc-select__anchor.mdc-ripple-surface--hover .mdc-select__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-select__anchor.mdc-ripple-upgraded--background-focused .mdc-select__ripple::before,.mdc-select__anchor:not(.mdc-ripple-upgraded):focus .mdc-select__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-select__anchor .mdc-select__ripple{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-surface, #000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-deprecated-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple::after{transition:opacity 150ms linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-surface, #000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple::before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple::after{transition:opacity 150ms linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-select-helper-text{margin:0;margin-left:16px;margin-right:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit);display:block;margin-top:0;line-height:normal}[dir=rtl] .mdc-select-helper-text,.mdc-select-helper-text[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-select-helper-text::before{display:inline-block;width:0;height:16px;content:"";vertical-align:0}.mdc-select-helper-text--validation-msg{opacity:0;transition:opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-select--invalid+.mdc-select-helper-text--validation-msg,.mdc-select-helper-text--validation-msg-persistent{opacity:1}.mdc-select--with-leading-icon .mdc-select__icon{display:inline-block;box-sizing:border-box;border:none;text-decoration:none;cursor:pointer;user-select:none;flex-shrink:0;align-self:center;background-color:transparent;fill:currentColor}.mdc-select--with-leading-icon .mdc-select__icon{margin-left:12px;margin-right:12px}[dir=rtl] .mdc-select--with-leading-icon .mdc-select__icon,.mdc-select--with-leading-icon .mdc-select__icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select__icon:not([tabindex]),.mdc-select__icon[tabindex="-1"]{cursor:default;pointer-events:none}.material-icons{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}:host{display:inline-block;vertical-align:top;outline:none}.mdc-select{width:100%}[hidden]{display:none}.mdc-select__icon{z-index:2}.mdc-select--with-leading-icon{--mdc-list-item-graphic-margin: calc( 48px - var(--mdc-list-item-graphic-size, 24px) - var(--mdc-list-side-padding, 16px) )}.mdc-select .mdc-select__anchor .mdc-select__selected-text{overflow:hidden}.mdc-select .mdc-select__anchor *{display:inline-flex}.mdc-select .mdc-select__anchor .mdc-floating-label{display:inline-block}mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-select-outlined-idle-border-color, rgba(0, 0, 0, 0.38) );--mdc-notched-outline-notch-offset: 1px}:host(:not([disabled]):hover) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-select-outlined-hover-border-color, rgba(0, 0, 0, 0.87) )}:host(:not([disabled])) .mdc-select:not(.mdc-select--disabled) .mdc-select__selected-text{color:rgba(0, 0, 0, 0.87);color:var(--mdc-select-ink-color, rgba(0, 0, 0, 0.87))}:host(:not([disabled])) .mdc-select:not(.mdc-select--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42);border-bottom-color:var(--mdc-select-idle-line-color, rgba(0, 0, 0, 0.42))}:host(:not([disabled])) .mdc-select:not(.mdc-select--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87);border-bottom-color:var(--mdc-select-hover-line-color, rgba(0, 0, 0, 0.87))}:host(:not([disabled])) .mdc-select:not(.mdc-select--outlined):not(.mdc-select--disabled) .mdc-select__anchor{background-color:whitesmoke;background-color:var(--mdc-select-fill-color, whitesmoke)}:host(:not([disabled])) .mdc-select.mdc-select--invalid .mdc-select__dropdown-icon{fill:var(--mdc-select-error-dropdown-icon-color, var(--mdc-select-error-color, var(--mdc-theme-error, #b00020)))}:host(:not([disabled])) .mdc-select.mdc-select--invalid .mdc-floating-label,:host(:not([disabled])) .mdc-select.mdc-select--invalid .mdc-floating-label::after{color:var(--mdc-select-error-color, var(--mdc-theme-error, #b00020))}:host(:not([disabled])) .mdc-select.mdc-select--invalid mwc-notched-outline{--mdc-notched-outline-border-color: var(--mdc-select-error-color, var(--mdc-theme-error, #b00020))}.mdc-select__menu--invalid{--mdc-theme-primary: var(--mdc-select-error-color, var(--mdc-theme-error, #b00020))}:host(:not([disabled])) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) .mdc-floating-label,:host(:not([disabled])) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) .mdc-floating-label::after{color:rgba(0, 0, 0, 0.6);color:var(--mdc-select-label-ink-color, rgba(0, 0, 0, 0.6))}:host(:not([disabled])) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) .mdc-select__dropdown-icon{fill:rgba(0, 0, 0, 0.54);fill:var(--mdc-select-dropdown-icon-color, rgba(0, 0, 0, 0.54))}:host(:not([disabled])) .mdc-select.mdc-select--focused mwc-notched-outline{--mdc-notched-outline-stroke-width: 2px;--mdc-notched-outline-notch-offset: 2px}:host(:not([disabled])) .mdc-select.mdc-select--focused:not(.mdc-select--invalid) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-select-focused-label-color, var(--mdc-theme-primary, rgba(98, 0, 238, 0.87)) )}:host(:not([disabled])) .mdc-select.mdc-select--focused:not(.mdc-select--invalid) .mdc-select__dropdown-icon{fill:rgba(98,0,238,.87);fill:var(--mdc-select-focused-dropdown-icon-color, var(--mdc-theme-primary, rgba(98, 0, 238, 0.87)))}:host(:not([disabled])) .mdc-select.mdc-select--focused:not(.mdc-select--invalid) .mdc-floating-label{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host(:not([disabled])) .mdc-select.mdc-select--focused:not(.mdc-select--invalid) .mdc-floating-label::after{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host(:not([disabled])) .mdc-select-helper-text:not(.mdc-select-helper-text--validation-msg){color:var(--mdc-select-label-ink-color, rgba(0, 0, 0, 0.6))}:host([disabled]){pointer-events:none}:host([disabled]) .mdc-select:not(.mdc-select--outlined).mdc-select--disabled .mdc-select__anchor{background-color:#fafafa;background-color:var(--mdc-select-disabled-fill-color, #fafafa)}:host([disabled]) .mdc-select.mdc-select--outlined mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-select-outlined-disabled-border-color, rgba(0, 0, 0, 0.06) )}:host([disabled]) .mdc-select .mdc-select__dropdown-icon{fill:rgba(0, 0, 0, 0.38);fill:var(--mdc-select-disabled-dropdown-icon-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) .mdc-floating-label,:host([disabled]) .mdc-select:not(.mdc-select--invalid):not(.mdc-select--focused) .mdc-floating-label::after{color:rgba(0, 0, 0, 0.38);color:var(--mdc-select-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-select-helper-text{color:rgba(0, 0, 0, 0.38);color:var(--mdc-select-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-select__selected-text{color:rgba(0, 0, 0, 0.38);color:var(--mdc-select-disabled-ink-color, rgba(0, 0, 0, 0.38))}`;


let $86e64bfc691ed273$export$ef9b1a59e592288f = class Select extends (0, $5a2d90439b27d6f4$export$6b437c5bf6e35b26) {
};
$86e64bfc691ed273$export$ef9b1a59e592288f.styles = [
    (0, $999091bb23061ddb$export$9dd6ff9ea0189349)
];
$86e64bfc691ed273$export$ef9b1a59e592288f = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-select")
], $86e64bfc691ed273$export$ef9b1a59e592288f);




/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ class $4b442ec5a0972f6e$export$386caa7e7ce11190 {
    /**
     * @constructor
     * @param {bigint} consultantID - The ID of the consultant.
     * @param {string} name - The name of the consultant. 
     */ constructor(consultantID, name){
        this.consultantID = consultantID;
        this.name = name;
    }
    /**
     * @async
     * @function save - Saves the new consultant
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute SQL statement in the database 
     */ async save(database, accessToken) {
        const sql = `INSERT INTO Consultant (consultantID, name) VALUES (${this.consultantID},'${this.name}')`;
        database.readWrite(accessToken, sql);
    }
    /**
     * 
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute SQL statement in the database 
     * @returns 
     */ static async list(database, accessToken) {
        const consultants = [];
        if (database) {
            const sql = "SELECT * FROM Consultant;";
            const rows = await database.read(accessToken, sql);
            rows.forEach((row)=>{
                const consultant = new $4b442ec5a0972f6e$export$386caa7e7ce11190(BigInt(row.consultantID), row.name);
                consultants.push(consultant);
            });
        }
        return consultants;
    }
    /**
     * @async
     * @function updateConsultant
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute SQL statement in the database 
     */ async updateConsultant(database, accessToken) {
        const sql = `UPDATE Consultant SET name='${this.name}' WHERE consultantID = ${this.consultantID}`;
        database.readWrite(accessToken, sql);
    }
    /**
     * @async
     * @function deleteConsultant - Deletes the single selected consultant
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute SQL statement in the database 
     */ async deleteConsultant(database, accessToken) {
        const sql = `DELETE FROM Consultant WHERE consultantID = ${this.consultantID}`;
        database.readWrite(accessToken, sql);
    }
    /**
     * @static
     * @async
     * @function deleteConsultants - Delete all selected consultants
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute SQL statement in the database 
     * @param consultantIds 
     */ static async deleteConsultants(database, accessToken, consultantIds) {
        const sql = `DELETE FROM Consultant WHERE consultantID in (${consultantIds.join(",")})`;
        database.readWrite(accessToken, sql);
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ class $f31384e0b0aee8c7$export$1f2bb630327ac4b6 {
    /**
     * @constructor
     * @param {bigint} clientID - The ID of the client.
     * @param {string} name - The name of the client.
     */ constructor(clientID, name){
        this.clientID = clientID;
        this.name = name;
    }
    /**
     * Saves the new client to the database.
     * @async
     * @function save
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     * @return {Promise<void>} - A promise indicating the completion of the save operation.
     */ async save(database, accessToken) {
        const sql = `INSERT INTO Client (clientID, name) VALUES (${this.clientID},'${this.name}')`;
        await database.readWrite(accessToken, sql);
    }
    /**
     * Lists all clients from the database.
     * @static
     * @async
     * @function list
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     * @return {Promise<Client[]>} - A promise that resolves to an array of Client objects.
     */ static async list(database, accessToken) {
        const clients = [];
        if (database) {
            const sql = "SELECT * FROM Client;";
            const rows = await database.read(accessToken, sql);
            rows.forEach((row)=>{
                const client = new $f31384e0b0aee8c7$export$1f2bb630327ac4b6(BigInt(row.clientID), row.name);
                clients.push(client);
            });
        }
        return clients;
    }
    /**
     * Updates the name of the current client in the database.
     * @async
     * @function updateClient
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     */ async updateClient(database, accessToken) {
        const sql = `UPDATE Client SET name='${this.name}' WHERE clientID = ${this.clientID}`;
        await database.readWrite(accessToken, sql);
    }
    /**
     * Deletes the current client from the database.
     * @async
     * @function deleteClient
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     */ async deleteClient(database, accessToken) {
        const sql = `DELETE FROM Client WHERE clientID = ${this.clientID}`;
        await database.readWrite(accessToken, sql);
    }
    /**
     * Deletes multiple clients from the database based on their IDs.
     * @static
     * @async
     * @function deleteClients
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     * @param {Array<bigint>} selectedClientIDs - An array of client IDs to delete.
     */ static async deleteClients(database, accessToken, selectedClientIDs) {
        const sql = `DELETE FROM Client WHERE clientID IN(${selectedClientIDs.join(",")})`;
        await database.readWrite(accessToken, sql);
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


class $c92cdd4fda4c057c$export$8f6e358395896ae9 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    /**
   * 
   * @param refresh 
   * @param scope 
   * @param cache 
   * @returns 
   */ async getAccessToken(refresh = false, scope = "https://www.googleapis.com/auth/cloud-platform email profile", cache = true) {
        const accessToken = await new Promise((resolve, reject)=>{
            const getAccessToken = new CustomEvent("get-access-token", {
                bubbles: true,
                detail: {
                    refresh: refresh,
                    scope: scope,
                    cache: cache,
                    resolve: resolve,
                    reject: reject
                }
            });
            this.dispatchEvent(getAccessToken);
        });
        return accessToken;
    }
    constructor(...args){
        super(...args);
        /**
   * Variable to manage users
   */ this.users = [];
        /**
   * Variable to manage clients
   */ this.clients = [];
        /**
   * Variable to manage consultants
   */ this.consultants = [];
        /**
   * Variable to manage consultant-client connection
   */ this.consultantClients = [];
        /**
   * Variable to manage review-requests
   */ this.reviewRequests = [];
        /**
   * Variable to reduce review-request update
   */ this.tempReviewRequests = [];
        /**
   * Variable to store the list of clients
   */ this.filterClients = [];
        /**
   * Variable to store list of consultants
   */ this.filterConsultants = [];
        /**
   * Current userID
   */ this.userID = "";
        /**
   * Returns promise for accessToken either by using an existing token or by requesting a new token
   * @param e 
   */ this.getAccessTokenEvent = async (e)=>{
            let resolve = e.detail.resolve;
            let reject = e.detail.reject;
            try {
                const accessToken = await this.getAccessToken(e.detail.refresh, e.detail.scope, e.detail.cache);
                resolve(accessToken);
            } catch (error) {
                reject(error);
            }
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "database", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "users", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "clients", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "consultants", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "consultantClients", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "reviewRequests", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "dialog", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $c92cdd4fda4c057c$export$8f6e358395896ae9.prototype, "userID", void 0);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ class $4945805059647a0f$export$dfdc0de57fad5ba8 {
    /**
     * @constructor
     * @param consultantID 
     * @param clientID 
     */ constructor(consultantID, clientID){
        this.consultantID = consultantID;
        this.clientID = clientID;
    }
    /**
     * @async
     * @function save - Saves the new consultant-client connection
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     */ async save(database, accessToken) {
        const sql = `INSERT INTO ConsultantClient (clientID, consultantID) VALUES (${this.clientID},${this.consultantID})`;
        console.log(sql);
        await database.readWrite(accessToken, sql);
    }
    /**
     * @static
     * @async
     * @function list - List all consultant-client connections
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @returns {Promise<ConsultantClient[]>} Returns a consultant-client array after complete the database process
     */ static async list(database, accessToken) {
        const consultantClients = [];
        if (database) {
            const sql = "SELECT * FROM ConsultantClient";
            const rows = await database.read(accessToken, sql);
            rows.forEach((row)=>{
                consultantClients.push(new $4945805059647a0f$export$dfdc0de57fad5ba8(row.consultantID, row.clientID));
            });
        }
        return consultantClients;
    }
    /**
     * 
     * @static
     * @async
     * @function delete
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @param {bigint} clientID - The client id which connection with consultant will deleted
     */ static async delete(database, accessToken, clientID) {
        const sql = `DELETE FROM ConsultantClient WHERE clientID=${clientID};`;
        await database.readWrite(accessToken, sql);
    }
    /**
     * @static
     * @async
     * @function deleteConsultantClients
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @param {Array<bigint>} selectedClientIDs - The selected ids which have to be removed
     */ static async deleteConsultantClients(database, accessToken, selectedClientIDs) {
        const sql = `DELETE FROM ConsultantClient WHERE clientID IN (${selectedClientIDs.join(",")})`;
        await database.readWrite(accessToken, sql);
    }
}


let $084d37af95ee76da$export$48ea9aaf7fe7651c = class HitlUpload extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    a {
      color: #369;
    }
    
    .mdc-select {
      width: 300%;
      min-width: fit-content;
    }

    .mdc-select--filled .mdc-select__anchor {
      width: fit-content;
    }

    mdc-menu-surface
      mdc-menu-surface--fullwidth
      mdc-menu-surface--is-open-below
      mdc-menu-surface--open {
      width: fit-content;
    }

    #drop-area {
      border: 2px dashed #ccc;
      border-radius: 20px;
      width: 80vw;
      height: 40vh;
      margin: 50px auto;
      padding: 20px;
    }

    #drop-area.highlight {
      border-color: white;
      background-color: rgb(36,76,140);
    }

    p {
      margin-top: 0;
    }

    .my-form {
      margin-bottom: 10px;
    }

    .button {
      font-size: 1.2em;
      display: inline-block;
      padding: 10px;
      background: #ccc;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid #ccc;
    }

    #fileElem {
      display: none;
    }

    #progress-bar {
      width: 100%;
      height: 5vh;
    }

    progress[value] {
        --color: rgb(36, 76, 140); 
        --background: #cccccc;
      
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: none;
        width: 200px;
        margin: 0 10px;
        border-radius: 10em;
        background: var(--background);
      }

      progress[value]::-webkit-progress-bar {
        border-radius: 10em;
        background: var(--background);
      }

      progress[value]::-webkit-progress-value {
        border-radius: 10em;
        background: var(--color);
      }

      progress[value]::-moz-progress-bar {
        border-radius: 10em;
        background: var(--color);
      }

      form {
        margin-top: 50px;
        margin-left: 10%;
      }

      span {
        width: 200px;
        display: inline-block;
      }

      input[type=button]:label {
          background-color: rgb(36,76,140);
      }

      .button {
          color: #ffffff;
          background-color: rgb(36,76,140);
      }
  `;
    /**
   * @constructor
   */ constructor(){
        super();
        /**
   * client server id
   */ this.clientId = "628593642649-uh1hldisk6jaikjs984sf2ql2j60fd85.apps.googleusercontent.com";
        /**
   * Upload bucket
   */ this.upload_bucket = "dornbach13b-uploads";
        /**
   * Processorname
   */ this.processorName = "projects/dornbach13b/locations/eu/processors/6074500e39f8fa86";
        /**
   * Processortype
   */ this.processorType = "CUSTOM_SPLITTING_PROCESSOR";
        /**
   * Files
   */ this.files = [];
        /**
   * dialog text
   */ this.dialogText = document.createElement("p");
        /**
   * Footer button ok
   */ this.footerButtonOk = document.createElement("mwc-button");
        /**
   * Data transfer
   */ this.dt = null;
        /**
   * Button to upload documents
   */ this.uploadButton = null;
        /**
   * upload progress
   */ this.uploadProgress = [];
        /**
   * progressbar
   */ this.progressBar = null;
        /**
   * Filter consultant list based on the searchtextfield for consultants
   * @param e 
   */ this.filterSelectOptionsConsultant = async (e)=>{
            this.preventDefaults(e);
            //Dropdown items
            const selectedConsultant = this.renderRoot.querySelector("#consultantId");
            const selectedClient = this.renderRoot.querySelector("#clientId");
            //Dropdown values
            let clientSelectValue = selectedClient.value;
            let consultantSelectValue = selectedConsultant.value;
            let currentCase = "";
            this.assignConsultantsBySearch();
            //If client and consultant are both not selected
            if (!(clientSelectValue && consultantSelectValue)) {
                this.assignClientsBySearch();
                currentCase = "Case 1";
            //If client and consultant are selected
            } else {
                //Resets consultant value in dropdown
                consultantSelectValue = "";
                if (clientSelectValue) {
                    const consultantIDsForClient = this.consultantClients.filter((consultantClient)=>BigInt(consultantClient.clientID) === BigInt(clientSelectValue)).map((consultantClient)=>consultantClient.consultantID);
                    this.filterConsultants = this.filterConsultants.filter((consultant)=>consultantIDsForClient.includes(consultant.consultantID));
                    this.assignClientsBySearch();
                }
                currentCase = "Case 2";
            }
            this.requestUpdate();
            console.log("Filter consultants: ", currentCase);
        };
        /**
   * Filter client list based on the searchtextfield for clients
   * @param _ 
   */ this.filterSelectOptionsClient = async (_)=>{
            console.log("FilterSelectOptionsClient got triggered");
            //Dropdowns
            const selectedConsultant = this.renderRoot.querySelector("#consultantId");
            const selectedClient = this.renderRoot.querySelector("#clientId");
            //Dropdown values
            let clientSelectValue = selectedClient.value;
            let consultantSelectValue = selectedConsultant.value;
            let currentCase = "";
            this.assignClientsBySearch();
            //If consultant and client are both not selected
            if (!(consultantSelectValue && clientSelectValue)) {
                this.filterClients = this.clients.filter((client)=>this.consultantClients.find((consultantClient)=>consultantClient.clientID == client.clientID && BigInt(selectedConsultant.value) == consultantClient.consultantID));
                this.assignClientsBySearch();
                currentCase = "Case 1";
            //If client and consultant are selected 
            } else {
                clientSelectValue = "";
                //If consultant value is selected
                if (consultantSelectValue) {
                    /**
               * Client ids for consultants
               */ const clientIDsForConsultant = this.consultantClients.filter((consultantClient)=>BigInt(consultantClient.consultantID) === BigInt(consultantSelectValue)).map((consultantClient)=>consultantClient.clientID);
                    this.filterClients = this.filterClients.filter((client)=>clientIDsForConsultant.includes(client.clientID));
                    this.assignConsultantsBySearch();
                    currentCase = "Case 2";
                }
            }
            this.requestUpdate();
            console.log("Filter clients: ", currentCase);
        };
        /**
   * Change the value list of the clients based on the consultant-client connection
   * @param _ 
   */ this.changeConsultValue = async (_)=>{
            console.log("changeConsultantValue got triggered");
            const selectedConsultant = this.renderRoot.querySelector("#consultantId");
            const selectedClient = this.renderRoot.querySelector("#clientId");
            const initialSelectedClient = selectedClient.value;
            if (selectedConsultant.value && selectedClient.value) {
                this.filterConsultants = this.consultants.filter((consultant)=>this.consultantClients.find((cclients)=>BigInt(cclients.clientID) === BigInt(selectedClient.value) && BigInt(cclients.consultantID) === BigInt(consultant.consultantID)));
                console.log(this.filterConsultants);
            //If consultant is selected but no client
            } else if (selectedConsultant.value && !selectedClient.value) {
                this.filterClients = this.clients.filter((client)=>this.consultantClients.find((cclients)=>BigInt(cclients.consultantID) == BigInt(selectedConsultant.value))?.clientID == client.clientID);
                console.log(this.filterClients);
            }
            if (selectedClient.value !== "") this.renderRoot.querySelector("#clientId").value = initialSelectedClient;
            this.requestUpdate();
        };
        /**
   * Change the value list of the consultants based on the consultant-client connection
   * @param _ 
   */ this.changeClientValue = async (_)=>{
            console.log("changeClientValue got triggered");
            const selectedConsultant = this.renderRoot.querySelector("#consultantId");
            const selectedClient = this.renderRoot.querySelector("#clientId");
            const initialSelectedConsultant = selectedConsultant.value;
            if (selectedConsultant.value && selectedClient.value) {
                this.filterClients = this.clients.filter((client)=>this.consultantClients.find((cclients)=>BigInt(cclients.consultantID) === BigInt(selectedConsultant.value) && BigInt(cclients.clientID) === BigInt(client.clientID)));
                console.log(this.filterClients);
                console.log(this.filterConsultants);
            //If no consultant is selected but client is selected
            } else if (!selectedConsultant.value && selectedClient.value) {
                this.filterConsultants = this.consultants.filter((consultant)=>this.consultantClients.find((cconsultants)=>BigInt(cconsultants.clientID) == BigInt(selectedClient.value))?.consultantID == consultant.consultantID);
                console.log(this.filterConsultants);
            }
            if (selectedConsultant.value !== "") this.renderRoot.querySelector("#consultantId").value = initialSelectedConsultant;
            this.requestUpdate();
        };
        this.gisLoadPromise = new Promise((resolve, reject)=>{
            this.gisLoadOkay = resolve;
            this.gisLoadFail = reject;
            this.handleDrop = this.handleDrop.bind(this);
        });
    }
    async firstUpdated() {
        this.dropArea = this.shadowRoot?.getElementById("drop-area");
        this.dialog.addEventListener("click", (event)=>{
            const rect = this.dialog.getBoundingClientRect();
            const isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
            if (!isInDialog) this.dialog.open = false;
        });
        //Initialization for consultants, clients, filterclients, filterconsultants
        if (this.database) {
            const accessToken = await this.getAccessToken();
            this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
            this.filterConsultants = this.consultants;
            this.clients = await (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).list(this.database, accessToken);
            this.filterClients = this.clients;
            console.log("Initialization: ", this.filterClients);
            this.consultantClients = await (0, $4945805059647a0f$export$dfdc0de57fad5ba8).list(this.database, accessToken);
        }
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.gisLoadPromise;
    }
    async disconnectedCallback() {
        super.disconnectedCallback();
    }
    render() {
        const template = [];
        console.log("Render filter clients", this.filterClients);
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div>
        <form>
          <label for="consultantId">
            <span><b>Berater:</b></span>
            <mwc-textfield 
                outlined
                label="Suche Berater.." TextFieldType="search" id="searchfieldConsultant" @input=${this.filterSelectOptionsConsultant}></mwc-textfield>
            <mwc-select 
            outlined
            label="Berater"
            id="consultantId" style="width:30%;" @change=${this.changeConsultValue}>    
              ${this.filterConsultants.map((consultant)=>{
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                  <mwc-list-item
                    value="${consultant.consultantID}"
                    style="width:fit-content;">
                    ${consultant.consultantID} - ${consultant.name}
                  </mwc-list-item>
                `;
        })}
            </mwc-select>
          </label>
          <br />
          <label for="clientId">
            <span><b>Mandant:</b></span>
            <mwc-textfield 
                outlined
                label="Suche Mandanten.." TextFieldType="search" id="searchfieldClient" @input=${this.filterSelectOptionsClient}></mwc-textfield>
            <mwc-select
              outlined
              label="Mandant"
              id="clientId" style="width:30%;" @change=${this.changeClientValue}>
              ${this.filterClients.map((client)=>{
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                  <mwc-list-item
                    value="${client.clientID}"
                    style="width:fit-content;">
                    ${client.clientID} - ${client.name}
                  </mwc-list-item>
                `;
        })}
            </mwc-select>
          </label>
          <br />
        </form>
      </div>
      <div id="drop-area" 
        @dragenter=${(this.preventDefaults, this.highlight)} 
        @dragover=${(this.preventDefaults, this.highlight)} 
        @dragleave=${(this.preventDefaults, this.unhighlight)} 
        @dragend=${(this.preventDefaults, this.unhighlight)} 
        @drop=${(this.preventDefaults, this.unhighlight, this.handleDrop)}>
        <form class="my-form" @submit="${(e)=>e.preventDefault()}">
          <p>
            W&auml;hlen Sie PDF-Dokument(e) mit dem Dateidialog aus oder indem
            Sie Dokumente per Drag & Drop auf den gestrichelten Bereich ziehen
          </p>
          <input
            type="file"
            id="fileElem"
            multiple
            accept=".pdf,application/pdf"
            @change="${this.handleFiles}" />
          <label class="button" for="fileElem">Datei(en) ausw&auml;hlen</label>
          <button
            class="button"
            id="uploadButton"
            @click="${this.uploadFiles}"
            style="visibility: hidden">
            Dokument(e) hochladen
          </button>
        </form>
        <progress id="progress-bar" max="100" value="0"></progress>
      </div>
    `);
        return template;
    }
    /**
   * Uploading process for the files
   * @returns 
   */ uploadFiles() {
        let clientId = this.shadowRoot?.getElementById("clientId").value;
        let consultantId = this.shadowRoot?.getElementById("consultantId").value;
        this.dialogInit();
        //Shows dialog if consultant or client are not selected
        if (consultantId === "") {
            this.dialogText.innerHTML = "Tragen Sie bitte eine Beraternummer ein";
            this.dialog.appendChild(this.dialogText);
            this.dialog.appendChild(this.footerButtonOk);
            this.dialog.open = true;
            return;
        } else if (clientId === "") {
            this.dialogText.innerHTML = "Tragen Sie bitte eine Mandantennummer ein";
            this.dialog.appendChild(this.dialogText);
            this.dialog.appendChild(this.footerButtonOk);
            this.dialog.open = true;
            return;
        }
        if (this.consultantClients.find((consultantClient)=>consultantClient.clientID == BigInt(clientId) && consultantClient.consultantID == BigInt(consultantId))) {
            this.initializeProgress(this.files.length);
            this.getAccessToken(true).then((accessToken)=>{
                let file;
                let url;
                let filename;
                for(let i = 0, numFiles = this.files.length; i < numFiles; i++){
                    file = this.files[i];
                    filename = "B" + consultantId + "_M" + clientId + "_" + file.name;
                    url = "https://" + this.upload_bucket + ".storage.googleapis.com/" + encodeURIComponent(crypto.randomUUID());
                    //Opening xhr request
                    const xhr = new XMLHttpRequest();
                    var formData = new FormData();
                    xhr.open("PUT", url, true);
                    xhr.setRequestHeader("Authorization", "Bearer " + accessToken);
                    xhr.setRequestHeader("Content-Type", "application/pdf");
                    xhr.setRequestHeader("X-Goog-Meta-originalFileName", filename || "");
                    xhr.setRequestHeader("X-Goog-Meta-databaseName", this.database?.databaseName || "");
                    xhr.setRequestHeader("X-Goog-Meta-processorName", this.processorName || "");
                    xhr.setRequestHeader("X-Goog-Meta-processorType", this.processorType || "");
                    xhr.setRequestHeader("X-Goog-Meta-userID", this.userID);
                    xhr.setRequestHeader("X-Goog-Meta-clientID", clientId);
                    xhr.setRequestHeader("X-Goog-Meta-consultantID", consultantId);
                    // Update progress (can be used to show progress indicator)
                    xhr.upload.addEventListener("progress", (e)=>{
                        this.updateProgress(i, e.loaded * 100.0 / e.total || 100);
                    });
                    xhr.addEventListener("readystatechange", ()=>{
                        if (xhr.readyState == 4 && xhr.status == 200) {
                            this.updateProgress(i, 100);
                            if (this.dialog) {
                                this.dialogInit();
                                this.dialogText.innerHTML = "Dokument ist hochgeladen.";
                                this.dialog.appendChild(this.dialogText);
                                this.dialog.appendChild(this.footerButtonOk);
                                this.dialog.classList.add("dialog-style");
                                this.dialog.addEventListener("closed", ()=>{
                                    const clientSearchText = this.renderRoot.querySelector("#searchfieldClient");
                                    const consultantSearchText = this.renderRoot.querySelector("#searchfieldConsultant");
                                    if (this.dialog.open == false) {
                                        if (this.dialog.children.length > 1) this.dialog.removeChild(this.dialog.children[1]);
                                        if (this.progressBar && this.progressBar.value == 100) this.progressBar.value = 0;
                                        if (this.uploadButton) {
                                            const buttonFileElem = this.renderRoot.querySelector("#fileElem");
                                            buttonFileElem.value = "";
                                            this.uploadButton.style.visibility = "hidden";
                                        }
                                        this.dialog.innerHTML = "";
                                        clientSearchText.value = "";
                                        consultantSearchText.value = "";
                                    }
                                });
                                this.dialog.open = true;
                            }
                            //Values of consultant, client, filterclients and filterconsultants dropdown will reset
                            const selectionListConsultant = this.renderRoot.querySelector("#consultantId");
                            const selectionListClient = this.renderRoot.querySelector("#clientId");
                            selectionListConsultant.value = "";
                            selectionListClient.value = "";
                            this.filterClients = this.clients;
                            this.filterConsultants = this.consultants;
                            console.log(this.filterClients);
                        //Error handling if Upload did not work
                        } else if (xhr.readyState == 4 && xhr.status != 200) {
                            this.dialogInit();
                            this.dialogText.innerHTML = "Hochladen fehlgeschlagen.";
                            this.dialog.appendChild(this.dialogText);
                            this.dialog.appendChild(this.footerButtonOk);
                            this.dialog.classList.add("dialog-style");
                            this.dialog.open = true;
                        }
                    });
                    formData.append("file", file);
                    //sending xhr request
                    xhr.send(formData);
                }
            }).catch((error)=>console.log(error));
        //In case that Client doesnt has the selected Consultant
        } else {
            this.dialogInit();
            this.dialogText.innerHTML = "Der ausgew\xe4hlte Mandant ist nicht dem Berater zugeordnet!";
            this.dialog.appendChild(this.dialogText);
            this.dialog.appendChild(this.footerButtonOk);
            this.dialog.classList.add("dialog-style");
            this.dialog.open = true;
        }
    }
    /**
   * Event method to handle dropped documents
   * @param {DragEvent} e 
   */ handleDrop(e) {
        this.preventDefaults(e);
        const dt = e.dataTransfer;
        this.uploadButton = this.shadowRoot?.getElementById("uploadButton");
        if (dt) {
            const files = dt.files;
            if (files.length > 0) this.handleFiles(e);
            this.uploadButton.innerHTML = `${this.files.length} `;
            //Check if the amount of files is one or more
            if (this.files.length === 1) this.uploadButton.innerHTML += "Dokument hochladen";
            else this.uploadButton.innerHTML += "Dokumente hochladen";
            this.uploadButton.style.visibility = "visible";
        }
        //Solves unhighlight issue
        this.unhighlight(e);
    }
    /**
   * Initialize progress of progressbar
   * @param numFiles 
   */ initializeProgress(numFiles) {
        if (this.progressBar) this.progressBar.value = 0;
        this.uploadProgress = Array(numFiles).fill(0);
    }
    /**
   * Updates progressbar value based on uploaded documents
   * @param fileNumber 
   * @param percent 
   */ updateProgress(fileNumber, percent) {
        this.uploadProgress[fileNumber] = percent;
        let total = this.uploadProgress.reduce((total, curr)=>total + curr, 0) / this.uploadProgress.length;
        this.progressBar = this.shadowRoot?.getElementById("progress-bar");
        this.progressBar.value = total;
    }
    /**
   * Prevents events to execute at false time
   * @param e 
   */ preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    /**
   * Event to highlight droparea
   * @param e 
   */ highlight(e) {
        e.preventDefault();
        this.dropArea.classList.add("highlight");
    }
    /**
   * Event to unhighlight drop area
   * @param e 
   */ unhighlight(e) {
        e.preventDefault();
        this.dropArea.classList.remove("highlight");
    }
    /**
   * Event to handle files. The handle of the files depends on uploaded per Button click or per drag and drop
   * @param e 
   */ handleFiles(e) {
        this.preventDefaults(e);
        if (e instanceof DragEvent) this.files = [
            ...e.dataTransfer.files || []
        ]; //If Files are added per drag & drop
        else this.files = [
            ...e.target.files || []
        ]; //If files are added per button
        this.progressBar = document.getElementById("progress-bar");
        //Set value to progress bar based on files length
        if (this.progressBar) this.progressBar.value = this.files.length;
        this.uploadButton = this.shadowRoot?.getElementById("uploadButton");
        if (this.uploadButton) {
            this.uploadButton.innerHTML = `${this.files.length} `;
            if (this.files.length === 1) this.uploadButton.innerHTML += "Dokument hochladen";
            else this.uploadButton.innerHTML += "Dokumente hochladen";
            this.uploadButton.style.visibility = "visible";
        }
    }
    /**
   * Assign consultants which consultant id or consultant name matches with the input of the search field
   */ assignConsultantsBySearch() {
        //Search field for consultant
        const searchInputConsultant = this.renderRoot.querySelector("#searchfieldConsultant").value;
        this.filterConsultants = this.consultants.filter((consultant)=>consultant.name.toLowerCase().indexOf(searchInputConsultant.toLowerCase()) !== -1 || consultant.consultantID.toString().indexOf(searchInputConsultant) !== -1);
    }
    /**
   * Assign clients which client id or client name matches with the input of the search field
   */ assignClientsBySearch() {
        //Search field for client
        const searchInputClient = this.renderRoot.querySelector("#searchfieldClient").value;
        this.filterClients = this.filterClients.filter((client)=>client.name.toLowerCase().indexOf(searchInputClient.toLowerCase()) !== -1 || client.clientID.toString().indexOf(searchInputClient) !== -1);
    }
    /**
   * Initialize dialog
   */ dialogInit() {
        this.dialog.innerHTML = "";
        this.footerButtonOk.innerHTML = "";
        this.footerButtonOk.setAttribute("slot", "primaryAction");
        this.footerButtonOk.setAttribute("dialogAction", "ok");
        this.footerButtonOk.innerText = "Ok";
        this.footerButtonOk.classList.add("raised");
        this.dialogText.style.padding = "0px 20%";
        this.dialog.setAttribute("style", "border-color: #000000; border-width: 1px; color: #000000; font-size: 1.1em;");
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $084d37af95ee76da$export$48ea9aaf7fe7651c.prototype, "tokenClient", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $084d37af95ee76da$export$48ea9aaf7fe7651c.prototype, "uploadButton", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $084d37af95ee76da$export$48ea9aaf7fe7651c.prototype, "progressBar", void 0);
$084d37af95ee76da$export$48ea9aaf7fe7651c = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-upload")
], $084d37af95ee76da$export$48ea9aaf7fe7651c);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 * Component which shows all review requests in the page with all 
 */ 




/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $6fd981ce4a184af5$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_container-shape: var(--md-data-table-container-shape, 4px);--_footer-container-color: var(--md-data-table-footer-container-color, var(--md-sys-color-surface, #fef7ff));--_footer-container-height: var(--md-data-table-footer-container-height, 52px);--_footer-supporting-text-color: var(--md-data-table-footer-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_footer-supporting-text-font: var(--md-data-table-footer-supporting-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));--_footer-supporting-text-line-height: var(--md-data-table-footer-supporting-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));--_footer-supporting-text-size: var(--md-data-table-footer-supporting-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));--_footer-supporting-text-tracking: var(--md-data-table-footer-supporting-text-tracking, );--_footer-supporting-text-weight: var(--md-data-table-footer-supporting-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)));--_header-container-color: var(--md-data-table-header-container-color, var(--md-sys-color-surface, #fef7ff));--_header-container-height: var(--md-data-table-header-container-height, 56px);--_header-headline-color: var(--md-data-table-header-headline-color, var(--md-sys-color-on-surface-variant, #49454f));--_header-headline-font: var(--md-data-table-header-headline-font, var(--md-sys-typescale-title-small-font, var(--md-ref-typeface-plain, Roboto)));--_header-headline-line-height: var(--md-data-table-header-headline-line-height, var(--md-sys-typescale-title-small-line-height, 1.25rem));--_header-headline-size: var(--md-data-table-header-headline-size, var(--md-sys-typescale-title-small-size, 0.875rem));--_header-headline-tracking: var(--md-data-table-header-headline-tracking, );--_header-headline-weight: var(--md-data-table-header-headline-weight, var(--md-sys-typescale-title-small-weight, var(--md-ref-typeface-weight-medium, 500)));--_header-hover-headline-color: var(--md-data-table-header-hover-headline-color, var(--md-sys-color-on-surface, #1d1b20));--_header-hover-sorting-icon-button-color: var(--md-data-table-header-hover-sorting-icon-button-color, var(--md-sys-color-on-surface, #1d1b20));--_outline-color: var(--md-data-table-outline-color, var(--md-sys-color-outline-variant, #cac4d0));--_outline-width: var(--md-data-table-outline-width, 1px);--_row-item-container-height: var(--md-data-table-row-item-container-height, 52px);--_row-item-disabled-label-text-color: var(--md-data-table-row-item-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_row-item-disabled-label-text-opacity: var(--md-data-table-row-item-disabled-label-text-opacity, 0.38);--_row-item-label-text-color: var(--md-data-table-row-item-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_row-item-label-text-font: var(--md-data-table-row-item-label-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));--_row-item-label-text-line-height: var(--md-data-table-row-item-label-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));--_row-item-label-text-size: var(--md-data-table-row-item-label-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));--_row-item-label-text-tracking: var(--md-data-table-row-item-label-text-tracking, );--_row-item-label-text-weight: var(--md-data-table-row-item-label-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)));--_row-item-outline-color: var(--md-data-table-row-item-outline-color, var(--md-sys-color-outline-variant, #cac4d0));--_row-item-outline-width: var(--md-data-table-row-item-outline-width, 1px);--_row-item-selected-container-color: var(--md-data-table-row-item-selected-container-color, var(--md-sys-color-surface-container-highest, #e6e0e9));--_row-item-selected-hover-state-layer-color: var(--md-data-table-row-item-selected-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--_row-item-selected-hover-state-layer-opacity: var(--md-data-table-row-item-selected-hover-state-layer-opacity, 0.08);--_row-item-unselected-container-color: var(--md-data-table-row-item-unselected-container-color, var(--md-sys-color-surface, #fef7ff));--_row-item-unselected-hover-state-layer-color: var(--md-data-table-row-item-unselected-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--_row-item-unselected-hover-state-layer-opacity: var(--md-data-table-row-item-unselected-hover-state-layer-opacity, 0.08);--_pagination-outlined-select-field-top-space: var(--md-data-table-pagination-outlined-select-field-top-space, 6px);--_pagination-outlined-select-field-bottom-space: var(--md-data-table-pagination-outlined-select-field-bottom-space, 6px)}.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);border-width:1px;border-style:solid;border-color:rgba(0,0,0,.12);-webkit-overflow-scrolling:touch;display:inline-flex;flex-direction:column;box-sizing:border-box;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px);border-top-right-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child[dir=rtl]{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px);border-bottom-left-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child[dir=rtl]{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px);border-bottom-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-data-table__row--selected{background-color:rgba(98, 0, 238, 0.04)}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-color:rgba(0,0,0,.12)}.mdc-data-table__pagination{border-top-color:rgba(0,0,0,.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-width:1px;border-bottom-style:solid}.mdc-data-table__pagination{border-top-width:1px;border-top-style:solid}.mdc-data-table__row:last-child .mdc-data-table__cell{border-bottom:none}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:rgba(0, 0, 0, 0.04)}.mdc-data-table__header-cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__row{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-row{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell{padding:0 16px 0 16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;overflow-x:auto;width:100%}.mdc-data-table__table{min-width:100%;border:0;white-space:nowrap;border-spacing:0;table-layout:fixed}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;overflow:hidden;text-align:left;text-overflow:ellipsis}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl]{text-align:right}.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;outline:none;text-align:left}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{width:28px;height:28px;padding:2px;transform:rotate(0.0001deg);margin-left:4px;margin-right:0;transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}.mdc-data-table__sort-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:28px;max-width:28px}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid rgba(0,0,0,0);border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid rgba(0,0,0,0);border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:28px;height:28px;margin-top:0px;margin-bottom:0px;margin-right:0px;margin-left:0px}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:28px;max-width:28px}.mdc-data-table__sort-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:28px;left:50%;width:28px;transform:translate(-50%, -50%)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{align-items:center;display:inline-flex;vertical-align:middle}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.mdc-data-table--sticky-header .mdc-data-table__header-cell{position:sticky;top:0;z-index:1}.mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.6)}.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.6);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.6))}.mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__progress-indicator{display:none;position:absolute;width:100%}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);height:100%;opacity:.32;position:absolute;top:0;width:100%}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;display:flex;justify-content:flex-end}.mdc-data-table__pagination-trailing{margin-left:4px;margin-right:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-end}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{margin-left:14px;margin-right:36px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{margin-left:0;margin-right:22px;align-items:center;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{margin-left:0;margin-right:12px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:80px;min-width:var(--mdc-menu-min-width, 80px);margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-36px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-list-item.mdc-list-item--with-one-line{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.2),0px 0px 0px 0px rgba(0, 0, 0, 0.14),0px 0px 0px 0px rgba(0,0,0,.12);--md-elevation-level: var(--_container-elevation);--md-elevation-shadow-color: var(--_container-shadow-color);background-color:rgba(0,0,0,0);border-radius:var(--_container-shape);border:var(--_outline-width) solid var(--_outline-color)}.mdc-data-table .mdc-data-table__table{display:table;width:var(--mdc-data-table-width);height:var(--mdc-data-table-height)}.mdc-data-table .mdc-data-table__head{display:table-header-group;vertical-align:middle;border-color:inherit}.mdc-data-table .mdc-data-table__header-row{display:table-row;vertical-align:inherit;border-color:inherit}.mdc-data-table .mdc-data-table__content{display:table-row-group;vertical-align:middle;border-color:inherit}.mdc-data-table slot{vertical-align:inherit}.mdc-data-table .mdc-data-table__pagination-trailing{margin:0}.mdc-data-table .mdc-data-table__pagination-rows-per-page-select{--md-outlined-field-top-space: var(--_pagination-outlined-select-field-top-space);--md-outlined-field-bottom-space: var(--_pagination-outlined-select-field-bottom-space)}.mdc-data-table .mdc-data-table__pagination-total,.mdc-data-table .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table .mdc-data-table__cell{font:var(--_footer-supporting-text-font);line-height:var(--_footer-supporting-text-line-height);font-size:var(--_footer-supporting-text-size);font-weight:var(--_footer-supporting-text-weight);color:var(--_footer-supporting-text-color)}.mdc-data-table .mdc-data-table__linear-progress{width:100%}.mdc-data-table__pagination{min-height:48px}.mdc-data-table__pagination{min-height:44px}.mdc-data-table__pagination{min-height:40px}.mdc-data-table__pagination{min-height:36px}:host([density=tight]) .mdc-data-table__header-row{height:52px}:host([density=comfortable]) .mdc-data-table__header-row{height:48px}:host([density=dense]) .mdc-data-table__header-row{height:44px}:host([density=compact]) .mdc-data-table__header-row{height:40px}/*# sourceMappingURL=data-table.css.map */
`;



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
const $e29022299c408217$export$b847756624854347 = [
    "ariaAtomic",
    "ariaAutoComplete",
    "ariaBusy",
    "ariaChecked",
    "ariaColCount",
    "ariaColIndex",
    "ariaColSpan",
    "ariaCurrent",
    "ariaDisabled",
    "ariaExpanded",
    "ariaHasPopup",
    "ariaHidden",
    "ariaInvalid",
    "ariaKeyShortcuts",
    "ariaLabel",
    "ariaLevel",
    "ariaLive",
    "ariaModal",
    "ariaMultiLine",
    "ariaMultiSelectable",
    "ariaOrientation",
    "ariaPlaceholder",
    "ariaPosInSet",
    "ariaPressed",
    "ariaReadOnly",
    "ariaRequired",
    "ariaRoleDescription",
    "ariaRowCount",
    "ariaRowIndex",
    "ariaRowSpan",
    "ariaSelected",
    "ariaSetSize",
    "ariaSort",
    "ariaValueMax",
    "ariaValueMin",
    "ariaValueNow",
    "ariaValueText"
];
const $e29022299c408217$export$579275e1129a0456 = $e29022299c408217$export$b847756624854347.map($e29022299c408217$export$8e94727558d343ee);
function $e29022299c408217$export$dfd479c27d88151c(attribute) {
    return attribute.startsWith("aria-");
}
function $e29022299c408217$export$8e94727558d343ee(property) {
    return property.replace("aria", "aria-")// IDREF attributes also include an "Element" or "Elements" suffix
    .replace(/Elements?/g, "").toLowerCase();
}
function $e29022299c408217$export$132d69587a22c09(ctor, { focusable: focusable } = {}) {
    if (focusable !== false) ctor.addInitializer((host)=>{
        host.addController({
            hostConnected () {
                if (host.hasAttribute("tabindex")) return;
                host.tabIndex = 0;
            }
        });
    });
    if ((0, $650ed036964a13b8$export$6acf61af03e62db) || "role" in Element.prototype) return;
    // Polyfill reflective aria properties for Firefox
    for (const ariaProperty of $e29022299c408217$export$b847756624854347)ctor.createProperty(ariaProperty, {
        attribute: $e29022299c408217$export$8e94727558d343ee(ariaProperty),
        reflect: true
    });
    ctor.createProperty("role", {
        reflect: true
    });
}
function $e29022299c408217$export$401bb396a24299b8(host, internals) {
    if ($e29022299c408217$var$checkIfElementInternalsSupportsAria(internals)) return internals;
    if (!("role" in host)) throw new Error("Missing setupHostAria()");
    let firstConnectedCallbacks = [];
    let hasBeenConnected = false;
    // Add support for Firefox, which has not yet implement ElementInternals aria
    for (const ariaProperty of $e29022299c408217$export$b847756624854347){
        let internalAriaValue = null;
        Object.defineProperty(internals, ariaProperty, {
            enumerable: true,
            configurable: true,
            get () {
                return internalAriaValue;
            },
            set (value) {
                const setValue = ()=>{
                    internalAriaValue = value;
                    if (!hasBeenConnected) {
                        firstConnectedCallbacks.push({
                            property: ariaProperty,
                            callback: setValue
                        });
                        return;
                    }
                    // Dynamic lookup rather than hardcoding all properties.
                    // tslint:disable-next-line:no-dict-access-on-struct-type
                    host[ariaProperty] = value;
                };
                setValue();
            }
        });
    }
    let internalRoleValue = null;
    Object.defineProperty(internals, "role", {
        enumerable: true,
        configurable: true,
        get () {
            return internalRoleValue;
        },
        set (value) {
            const setRole = ()=>{
                internalRoleValue = value;
                if (!hasBeenConnected) {
                    firstConnectedCallbacks.push({
                        property: "role",
                        callback: setRole
                    });
                    return;
                }
                if (value === null) host.removeAttribute("role");
                else host.setAttribute("role", value);
            };
            setRole();
        }
    });
    host.addController({
        hostConnected () {
            if (hasBeenConnected) return;
            hasBeenConnected = true;
            const propertiesSetByUser = new Set();
            // See which properties were set by the user on host before we apply
            // internals values as attributes to host. Needs to be done in another
            // for loop because the callbacks set these attributes on host.
            for (const { property: property } of firstConnectedCallbacks){
                const wasSetByUser = host.getAttribute($e29022299c408217$export$8e94727558d343ee(property)) !== null || // Dynamic lookup rather than hardcoding all properties.
                // tslint:disable-next-line:no-dict-access-on-struct-type
                host[property] !== undefined;
                if (wasSetByUser) propertiesSetByUser.add(property);
            }
            for (const { property: property, callback: callback } of firstConnectedCallbacks){
                // If the user has set the attribute or property, do not override the
                // user's value
                if (propertiesSetByUser.has(property)) continue;
                callback();
            }
            // Remove strong callback references
            firstConnectedCallbacks = [];
        }
    });
    return internals;
}
// Separate function so that typescript doesn't complain about internals being
// "never".
function $e29022299c408217$var$checkIfElementInternalsSupportsAria(internals) {
    return "role" in internals;
}


function $0b7ed02cda79c042$export$889c2c63f7feb341(ctor) {
    for (const ariaProperty of (0, $e29022299c408217$export$b847756624854347))ctor.createProperty(ariaProperty, {
        attribute: (0, $e29022299c408217$export$8e94727558d343ee)(ariaProperty),
        reflect: true
    });
    ctor.addInitializer((element)=>{
        const controller = {
            hostConnected () {
                element.setAttribute("role", "presentation");
            }
        };
        element.addController(controller);
    });
}


class $2ce71c556903781f$export$b25a304ec7d746bb extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Progress to display, a fraction between 0 and `max`.
         */ this.value = 0;
        /**
         * Maximum progress to display, defaults to 1.
         */ this.max = 1;
        /**
         * Whether or not to display indeterminate progress, which gives no indication
         * to how long an activity will take.
         */ this.indeterminate = false;
        /**
         * Whether or not to render indeterminate mode using 4 colors instead of one.
         */ this.fourColor = false;
    }
    render() {
        // Needed for closure conformance
        const { ariaLabel: ariaLabel } = this;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="progress ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getRenderClasses())}"
        role="progressbar"
        aria-label="${ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
        aria-valuemin="0"
        aria-valuemax=${this.max}
        aria-valuenow=${this.indeterminate ? (0, $e5ed8027d647799b$export$45b790e32b2810ee) : this.value}
      >${this.renderIndicator()}</div>
    `;
    }
    getRenderClasses() {
        return {
            "indeterminate": this.indeterminate,
            "four-color": this.fourColor
        };
    }
}
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($2ce71c556903781f$export$b25a304ec7d746bb);
})();
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $2ce71c556903781f$export$b25a304ec7d746bb.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $2ce71c556903781f$export$b25a304ec7d746bb.prototype, "max", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $2ce71c556903781f$export$b25a304ec7d746bb.prototype, "indeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "four-color"
    })
], $2ce71c556903781f$export$b25a304ec7d746bb.prototype, "fourColor", void 0);


class $b9463b3e203c11fd$export$11f983dff6f48944 extends (0, $2ce71c556903781f$export$b25a304ec7d746bb) {
    constructor(){
        super(...arguments);
        /**
         * Buffer amount to display, a fraction between 0 and 1.
         */ this.buffer = 1;
    }
    // Note, the indeterminate animation is rendered with transform %'s
    // Previously, this was optimized to use px calculated with the resizeObserver
    // due to a now fixed Chrome bug: crbug.com/389359.
    renderIndicator() {
        const progressStyles = {
            transform: `scaleX(${(this.indeterminate ? 1 : this.value / this.max) * 100}%)`
        };
        const dotStyles = {
            transform: `scaleX(${(this.indeterminate ? 1 : this.buffer / this.max) * 100}%)`
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="dots"></div>
      <div class="inactive-track" style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(dotStyles)}></div>
      <div class="bar primary-bar" style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(progressStyles)}>
        <div class="bar-inner"></div>
      </div>
      <div class="bar secondary-bar">
        <div class="bar-inner"></div>
      </div>
    `;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $b9463b3e203c11fd$export$11f983dff6f48944.prototype, "buffer", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $346bb4d8abe09c45$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_active-indicator-color: var(--md-linear-progress-active-indicator-color, var(--md-sys-color-primary, #6750a4));--_active-indicator-height: var(--md-linear-progress-active-indicator-height, 4px);--_four-color-active-indicator-four-color: var(--md-linear-progress-four-color-active-indicator-four-color, var(--md-sys-color-tertiary-container, #ffd8e4));--_four-color-active-indicator-one-color: var(--md-linear-progress-four-color-active-indicator-one-color, var(--md-sys-color-primary, #6750a4));--_four-color-active-indicator-three-color: var(--md-linear-progress-four-color-active-indicator-three-color, var(--md-sys-color-tertiary, #7d5260));--_four-color-active-indicator-two-color: var(--md-linear-progress-four-color-active-indicator-two-color, var(--md-sys-color-primary-container, #eaddff));--_track-color: var(--md-linear-progress-track-color, var(--md-sys-color-surface-container-highest, #e6e0e9));--_track-height: var(--md-linear-progress-track-height, 4px);--_track-shape: var(--md-linear-progress-track-shape, 0px);border-radius:var(--_track-shape);display:flex;position:relative;width:80px;height:var(--_track-height);content-visibility:auto;contain:strict}.progress,.dots,.inactive-track,.bar,.bar-inner{position:absolute}.progress{direction:ltr;inset:0;border-radius:inherit;overflow:hidden;display:flex;align-items:center}.bar{animation:none;width:100%;height:var(--_active-indicator-height);transform-origin:left center;transition:transform 250ms cubic-bezier(0.4, 0, 0.6, 1)}.secondary-bar{display:none}.bar-inner{inset:0;animation:none;background:var(--_active-indicator-color)}.inactive-track{background:var(--_track-color);inset:0;transition:transform 250ms cubic-bezier(0.4, 0, 0.6, 1);transform-origin:left center}.dots{inset:0;animation:linear infinite 250ms;animation-name:buffering;background-color:var(--_track-color);background-repeat:repeat-x;-webkit-mask-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 2' preserveAspectRatio='xMinYMin slice'%3E%3Ccircle cx='1' cy='1' r='1'/%3E%3C/svg%3E");mask-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 2' preserveAspectRatio='xMinYMin slice'%3E%3Ccircle cx='1' cy='1' r='1'/%3E%3C/svg%3E");z-index:-1}.indeterminate .bar{transition:none}.indeterminate .primary-bar{inset-inline-start:-145.167%}.indeterminate .secondary-bar{inset-inline-start:-54.8889%;display:block}.indeterminate .dots{display:none}.indeterminate .primary-bar{animation:linear infinite 2s;animation-name:primary-indeterminate-translate}.indeterminate .primary-bar>.bar-inner{animation:linear infinite 2s primary-indeterminate-scale}.indeterminate.four-color .primary-bar>.bar-inner{animation-name:primary-indeterminate-scale,four-color;animation-duration:2s,4s}.indeterminate .secondary-bar{animation:linear infinite 2s;animation-name:secondary-indeterminate-translate}.indeterminate .secondary-bar>.bar-inner{animation:linear infinite 2s secondary-indeterminate-scale}.indeterminate.four-color .secondary-bar>.bar-inner{animation-name:secondary-indeterminate-scale,four-color;animation-duration:2s,4s}:host-context([dir=rtl]),:host([dir=rtl]){transform:scale(-1)}:host(:dir(rtl)){transform:scale(-1)}@keyframes primary-indeterminate-scale{0%{transform:scaleX(0.08)}36.65%{animation-timing-function:cubic-bezier(0.334731, 0.12482, 0.785844, 1);transform:scaleX(0.08)}69.15%{animation-timing-function:cubic-bezier(0.06, 0.11, 0.6, 1);transform:scaleX(0.661479)}100%{transform:scaleX(0.08)}}@keyframes secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(0.205028, 0.057051, 0.57661, 0.453971);transform:scaleX(0.08)}19.15%{animation-timing-function:cubic-bezier(0.152313, 0.196432, 0.648374, 1.00432);transform:scaleX(0.457104)}44.15%{animation-timing-function:cubic-bezier(0.257759, -0.003163, 0.211762, 1.38179);transform:scaleX(0.72796)}100%{transform:scaleX(0.08)}}@keyframes buffering{0%{transform:translateX(calc(var(--_track-height) / 2 * 5))}}@keyframes primary-indeterminate-translate{0%{transform:translateX(0px)}20%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(0px)}59.15%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(83.6714%)}100%{transform:translateX(200.611%)}}@keyframes secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(0.15, 0, 0.515058, 0.409685);transform:translateX(0px)}25%{animation-timing-function:cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);transform:translateX(37.6519%)}48.35%{animation-timing-function:cubic-bezier(0.4, 0.627035, 0.6, 0.902026);transform:translateX(84.3862%)}100%{transform:translateX(160.278%)}}@keyframes four-color{0%{background:var(--_four-color-active-indicator-one-color)}15%{background:var(--_four-color-active-indicator-one-color)}25%{background:var(--_four-color-active-indicator-two-color)}40%{background:var(--_four-color-active-indicator-two-color)}50%{background:var(--_four-color-active-indicator-three-color)}65%{background:var(--_four-color-active-indicator-three-color)}75%{background:var(--_four-color-active-indicator-four-color)}90%{background:var(--_four-color-active-indicator-four-color)}100%{background:var(--_four-color-active-indicator-one-color)}}@media(forced-colors: active){:host{outline:1px solid CanvasText}.bar-inner,.dots{background-color:CanvasText}}/*# sourceMappingURL=linear-progress-styles.css.map */
`;


let $56d64e855e7fd3ef$export$1d1299e4054103ca = class MdLinearProgress extends (0, $b9463b3e203c11fd$export$11f983dff6f48944) {
};
$56d64e855e7fd3ef$export$1d1299e4054103ca.styles = [
    (0, $346bb4d8abe09c45$export$9dd6ff9ea0189349)
];
$56d64e855e7fd3ef$export$1d1299e4054103ca = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-linear-progress")
], $56d64e855e7fd3ef$export$1d1299e4054103ca);


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $1c28216c24519ada$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_container-color: var(--md-filled-icon-button-container-color, var(--md-sys-color-primary, #6750a4));--_container-height: var(--md-filled-icon-button-container-height, 40px);--_container-shape: var(--md-filled-icon-button-container-shape, 9999px);--_container-width: var(--md-filled-icon-button-container-width, 40px);--_disabled-container-color: var(--md-filled-icon-button-disabled-container-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-container-opacity: var(--md-filled-icon-button-disabled-container-opacity, 0.12);--_disabled-icon-color: var(--md-filled-icon-button-disabled-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-icon-opacity: var(--md-filled-icon-button-disabled-icon-opacity, 0.38);--_focus-icon-color: var(--md-filled-icon-button-focus-icon-color, var(--md-sys-color-on-primary, #fff));--_hover-icon-color: var(--md-filled-icon-button-hover-icon-color, var(--md-sys-color-on-primary, #fff));--_hover-state-layer-color: var(--md-filled-icon-button-hover-state-layer-color, var(--md-sys-color-on-primary, #fff));--_hover-state-layer-opacity: var(--md-filled-icon-button-hover-state-layer-opacity, 0.08);--_icon-color: var(--md-filled-icon-button-icon-color, var(--md-sys-color-on-primary, #fff));--_icon-size: var(--md-filled-icon-button-icon-size, 24px);--_pressed-icon-color: var(--md-filled-icon-button-pressed-icon-color, var(--md-sys-color-on-primary, #fff));--_pressed-state-layer-color: var(--md-filled-icon-button-pressed-state-layer-color, var(--md-sys-color-on-primary, #fff));--_pressed-state-layer-opacity: var(--md-filled-icon-button-pressed-state-layer-opacity, 0.12);--_selected-container-color: var(--md-filled-icon-button-selected-container-color, var(--md-sys-color-primary, #6750a4));--_toggle-selected-focus-icon-color: var(--md-filled-icon-button-toggle-selected-focus-icon-color, var(--md-sys-color-on-primary, #fff));--_toggle-selected-hover-icon-color: var(--md-filled-icon-button-toggle-selected-hover-icon-color, var(--md-sys-color-on-primary, #fff));--_toggle-selected-hover-state-layer-color: var(--md-filled-icon-button-toggle-selected-hover-state-layer-color, var(--md-sys-color-on-primary, #fff));--_toggle-selected-icon-color: var(--md-filled-icon-button-toggle-selected-icon-color, var(--md-sys-color-on-primary, #fff));--_toggle-selected-pressed-icon-color: var(--md-filled-icon-button-toggle-selected-pressed-icon-color, var(--md-sys-color-on-primary, #fff));--_toggle-selected-pressed-state-layer-color: var(--md-filled-icon-button-toggle-selected-pressed-state-layer-color, var(--md-sys-color-on-primary, #fff));--_unselected-container-color: var(--md-filled-icon-button-unselected-container-color, var(--md-sys-color-surface-container-highest, #e6e0e9));--_toggle-focus-icon-color: var(--md-filled-icon-button-toggle-focus-icon-color, var(--md-sys-color-primary, #6750a4));--_toggle-hover-icon-color: var(--md-filled-icon-button-toggle-hover-icon-color, var(--md-sys-color-primary, #6750a4));--_toggle-hover-state-layer-color: var(--md-filled-icon-button-toggle-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--_toggle-icon-color: var(--md-filled-icon-button-toggle-icon-color, var(--md-sys-color-primary, #6750a4));--_toggle-pressed-icon-color: var(--md-filled-icon-button-toggle-pressed-icon-color, var(--md-sys-color-primary, #6750a4));--_toggle-pressed-state-layer-color: var(--md-filled-icon-button-toggle-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--_container-shape-start-start: var( --md-filled-icon-button-container-shape-start-start, var(--_container-shape) );--_container-shape-start-end: var( --md-filled-icon-button-container-shape-start-end, var(--_container-shape) );--_container-shape-end-end: var( --md-filled-icon-button-container-shape-end-end, var(--_container-shape) );--_container-shape-end-start: var( --md-filled-icon-button-container-shape-end-start, var(--_container-shape) )}.icon-button{color:var(--_icon-color);--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}.icon-button:hover{color:var(--_hover-icon-color)}.icon-button:focus{color:var(--_focus-icon-color)}.icon-button:active{color:var(--_pressed-icon-color)}.icon-button:disabled{color:var(--_disabled-icon-color)}.icon-button::before{background-color:var(--_container-color);border-radius:inherit;content:"";inset:0;position:absolute;z-index:-1}.icon-button:disabled::before{background-color:var(--_disabled-container-color);opacity:var(--_disabled-container-opacity)}.icon-button:disabled .icon{opacity:var(--_disabled-icon-opacity)}.toggle-filled{--md-ripple-hover-color: var(--_toggle-hover-state-layer-color);--md-ripple-pressed-color: var(--_toggle-pressed-state-layer-color)}.toggle-filled:not(:disabled){color:var(--_toggle-icon-color)}.toggle-filled:not(:disabled):hover{color:var(--_toggle-hover-icon-color)}.toggle-filled:not(:disabled):focus{color:var(--_toggle-focus-icon-color)}.toggle-filled:not(:disabled):active{color:var(--_toggle-pressed-icon-color)}.toggle-filled:not(:disabled)::before{background-color:var(--_unselected-container-color)}.selected{--md-ripple-hover-color: var(--_toggle-selected-hover-state-layer-color);--md-ripple-pressed-color: var(--_toggle-selected-pressed-state-layer-color)}.selected:not(:disabled){color:var(--_toggle-selected-icon-color)}.selected:not(:disabled):hover{color:var(--_toggle-selected-hover-icon-color)}.selected:not(:disabled):focus{color:var(--_toggle-selected-focus-icon-color)}.selected:not(:disabled):active{color:var(--_toggle-selected-pressed-icon-color)}.selected:not(:disabled)::before{background-color:var(--_selected-container-color)}/*# sourceMappingURL=filled-styles.css.map */
`;


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * A key to retrieve an `Attachable` element's `AttachableController` from a
 * global `MutationObserver`.
 */ const $decf24133958b333$var$ATTACHABLE_CONTROLLER = Symbol("attachableController");
let $decf24133958b333$var$FOR_ATTRIBUTE_OBSERVER;
if (!(0, $650ed036964a13b8$export$6acf61af03e62db)) /**
     * A global `MutationObserver` that reacts to `for` attribute changes on
     * `Attachable` elements. If the `for` attribute changes, the controller will
     * re-attach to the new referenced element.
     */ $decf24133958b333$var$FOR_ATTRIBUTE_OBSERVER = new MutationObserver((records)=>{
    for (const record of records)// When a control's `for` attribute changes, inform its
    // `AttachableController` to update to a new control.
    record.target[$decf24133958b333$var$ATTACHABLE_CONTROLLER]?.hostConnected();
});
class $decf24133958b333$export$805bfb00874b30a5 {
    get htmlFor() {
        return this.host.getAttribute("for");
    }
    set htmlFor(htmlFor) {
        if (htmlFor === null) this.host.removeAttribute("for");
        else this.host.setAttribute("for", htmlFor);
    }
    get control() {
        if (this.host.hasAttribute("for")) {
            if (!this.htmlFor || !this.host.isConnected) return null;
            return this.host.getRootNode().querySelector(`#${this.htmlFor}`);
        }
        return this.currentControl || this.host.parentElement;
    }
    set control(control) {
        if (control) this.attach(control);
        else this.detach();
    }
    /**
     * Creates a new controller for an `Attachable` element.
     *
     * @param host The `Attachable` element.
     * @param onControlChange A callback with two parameters for the previous and
     *     next control. An `Attachable` element may perform setup or teardown
     *     logic whenever the control changes.
     */ constructor(host, onControlChange){
        this.host = host;
        this.onControlChange = onControlChange;
        this.currentControl = null;
        host.addController(this);
        host[$decf24133958b333$var$ATTACHABLE_CONTROLLER] = this;
        $decf24133958b333$var$FOR_ATTRIBUTE_OBSERVER?.observe(host, {
            attributeFilter: [
                "for"
            ]
        });
    }
    attach(control) {
        if (control === this.currentControl) return;
        this.setCurrentControl(control);
        // When imperatively attaching, remove the `for` attribute so
        // that the attached control is used instead of a referenced one.
        this.host.removeAttribute("for");
    }
    detach() {
        this.setCurrentControl(null);
        // When imperatively detaching, add an empty `for=""` attribute. This will
        // ensure the control is `null` rather than the `parentElement`.
        this.host.setAttribute("for", "");
    }
    /** @private */ hostConnected() {
        this.setCurrentControl(this.control);
    }
    /** @private */ hostDisconnected() {
        this.setCurrentControl(null);
    }
    setCurrentControl(control) {
        this.onControlChange(this.currentControl, control);
        this.currentControl = control;
    }
}


/**
 * Events that the focus ring listens to.
 *
 * @fires visibility-changed Fired whenever `visible` changes.
 */ const $3b66716ce5d73bcb$var$EVENTS = [
    "focusin",
    "focusout",
    "pointerdown"
];
class $3b66716ce5d73bcb$export$1a38b4ad7f578e1d extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Makes the focus ring visible.
         */ this.visible = false;
        /**
         * Makes the focus ring animate inwards instead of outwards.
         */ this.inward = false;
        this.attachableController = new (0, $decf24133958b333$export$805bfb00874b30a5)(this, this.onControlChange.bind(this));
    }
    get htmlFor() {
        return this.attachableController.htmlFor;
    }
    set htmlFor(htmlFor) {
        this.attachableController.htmlFor = htmlFor;
    }
    get control() {
        return this.attachableController.control;
    }
    set control(control) {
        this.attachableController.control = control;
    }
    attach(control) {
        this.attachableController.attach(control);
    }
    detach() {
        this.attachableController.detach();
    }
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute("aria-hidden", "true");
    }
    /** @private */ handleEvent(event) {
        if (event[$3b66716ce5d73bcb$var$HANDLED_BY_FOCUS_RING]) // This ensures the focus ring does not activate when multiple focus rings
        // are used within a single component.
        return;
        switch(event.type){
            default:
                return;
            case "focusin":
                this.visible = this.control?.matches(":focus-visible") ?? false;
                break;
            case "focusout":
            case "pointerdown":
                this.visible = false;
                break;
        }
        event[$3b66716ce5d73bcb$var$HANDLED_BY_FOCUS_RING] = true;
    }
    onControlChange(prev, next) {
        if (0, $650ed036964a13b8$export$6acf61af03e62db) return;
        for (const event of $3b66716ce5d73bcb$var$EVENTS){
            prev?.removeEventListener(event, this);
            next?.addEventListener(event, this);
        }
    }
    update(changed) {
        if (changed.has("visible")) // This logic can be removed once the `:has` selector has been introduced
        // to Firefox. This is necessary to allow correct submenu styles.
        this.dispatchEvent(new Event("visibility-changed"));
        super.update(changed);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $3b66716ce5d73bcb$export$1a38b4ad7f578e1d.prototype, "visible", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $3b66716ce5d73bcb$export$1a38b4ad7f578e1d.prototype, "inward", void 0);
const $3b66716ce5d73bcb$var$HANDLED_BY_FOCUS_RING = Symbol("handledByFocusRing");


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $ea6fe57d1093d606$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{animation-delay:0s,calc(var(--md-focus-ring-duration, 600ms)*.25);animation-duration:calc(var(--md-focus-ring-duration, 600ms)*.25),calc(var(--md-focus-ring-duration, 600ms)*.75);animation-timing-function:cubic-bezier(0.2, 0, 0, 1);box-sizing:border-box;color:var(--md-focus-ring-color, var(--md-sys-color-secondary, #625b71));display:none;pointer-events:none;position:absolute}:host([visible]){display:flex}:host(:not([inward])){animation-name:outward-grow,outward-shrink;border-end-end-radius:calc(var(--md-focus-ring-shape-end-end, var(--md-focus-ring-shape, 9999px)) + var(--md-focus-ring-outward-offset, 2px));border-end-start-radius:calc(var(--md-focus-ring-shape-end-start, var(--md-focus-ring-shape, 9999px)) + var(--md-focus-ring-outward-offset, 2px));border-start-end-radius:calc(var(--md-focus-ring-shape-start-end, var(--md-focus-ring-shape, 9999px)) + var(--md-focus-ring-outward-offset, 2px));border-start-start-radius:calc(var(--md-focus-ring-shape-start-start, var(--md-focus-ring-shape, 9999px)) + var(--md-focus-ring-outward-offset, 2px));inset:calc(-1*var(--md-focus-ring-outward-offset, 2px));outline:var(--md-focus-ring-width, 3px) solid currentColor}:host([inward]){animation-name:inward-grow,inward-shrink;border-end-end-radius:calc(var(--md-focus-ring-shape-end-end, var(--md-focus-ring-shape, 9999px)) - var(--md-focus-ring-inward-offset, 0px));border-end-start-radius:calc(var(--md-focus-ring-shape-end-start, var(--md-focus-ring-shape, 9999px)) - var(--md-focus-ring-inward-offset, 0px));border-start-end-radius:calc(var(--md-focus-ring-shape-start-end, var(--md-focus-ring-shape, 9999px)) - var(--md-focus-ring-inward-offset, 0px));border-start-start-radius:calc(var(--md-focus-ring-shape-start-start, var(--md-focus-ring-shape, 9999px)) - var(--md-focus-ring-inward-offset, 0px));border:var(--md-focus-ring-width, 3px) solid currentColor;inset:var(--md-focus-ring-inward-offset, 0px)}@keyframes outward-grow{from{outline-width:0}to{outline-width:var(--md-focus-ring-active-width, 8px)}}@keyframes outward-shrink{from{outline-width:var(--md-focus-ring-active-width, 8px)}}@keyframes inward-grow{from{border-width:0}to{border-width:var(--md-focus-ring-active-width, 8px)}}@keyframes inward-shrink{from{border-width:var(--md-focus-ring-active-width, 8px)}}@media(prefers-reduced-motion){:host{animation:none}}/*# sourceMappingURL=focus-ring-styles.css.map */
`;


let $e7fc452d7891f078$export$bf070ac80053661c = class MdFocusRing extends (0, $3b66716ce5d73bcb$export$1a38b4ad7f578e1d) {
};
$e7fc452d7891f078$export$bf070ac80053661c.styles = [
    (0, $ea6fe57d1093d606$export$9dd6ff9ea0189349)
];
$e7fc452d7891f078$export$bf070ac80053661c = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-focus-ring")
], $e7fc452d7891f078$export$bf070ac80053661c);


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 




/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Easing functions to use for web animations.
 *
 * **NOTE:** `EASING.EMPHASIZED` is approximated with unknown accuracy.
 *
 * TODO(b/241113345): replace with tokens
 */ const $87a41e77ca765bfa$export$c74aac628de95ab5 = {
    STANDARD: "cubic-bezier(0.2, 0, 0, 1)",
    STANDARD_ACCELERATE: "cubic-bezier(.3,0,1,1)",
    STANDARD_DECELERATE: "cubic-bezier(0,0,0,1)",
    EMPHASIZED: "cubic-bezier(.3,0,0,1)",
    EMPHASIZED_ACCELERATE: "cubic-bezier(.3,0,.8,.15)",
    EMPHASIZED_DECELERATE: "cubic-bezier(.05,.7,.1,1)"
};
function $87a41e77ca765bfa$export$d3ca5f3874d77ca7() {
    // The current animation's AbortController
    let animationAbortController = null;
    return {
        start () {
            // Tell the previous animation to cancel.
            animationAbortController?.abort();
            // Set up a new AbortController for the current animation.
            animationAbortController = new AbortController();
            // Provide the AbortSignal so that the caller can check aborted status
            // and add listeners.
            return animationAbortController.signal;
        },
        finish () {
            animationAbortController = null;
        }
    };
}
function $87a41e77ca765bfa$export$3673365b85de6f9a() {
    const stack = new Set();
    return async (key = "", cb, timeout = async ()=>{
        await new Promise(requestAnimationFrame);
    })=>{
        if (!stack.has(key)) {
            stack.add(key);
            await timeout();
            if (stack.has(key)) {
                stack.delete(key);
                cb();
            }
        }
    };
}
function $87a41e77ca765bfa$export$2aa617cd8a3dcf89(value) {
    const match = value.trim().match(/([\d.]+)(\s*s$)?/);
    const time = match?.[1];
    const seconds = match?.[2];
    return Number(time ?? 0) * (seconds ? 1000 : 1);
}


const $37a89812c3737937$var$PRESS_GROW_MS = 450;
const $37a89812c3737937$var$MINIMUM_PRESS_MS = 225;
const $37a89812c3737937$var$INITIAL_ORIGIN_SCALE = 0.2;
const $37a89812c3737937$var$PADDING = 10;
const $37a89812c3737937$var$SOFT_EDGE_MINIMUM_SIZE = 75;
const $37a89812c3737937$var$SOFT_EDGE_CONTAINER_RATIO = 0.35;
const $37a89812c3737937$var$PRESS_PSEUDO = "::after";
const $37a89812c3737937$var$ANIMATION_FILL = "forwards";
/**
 * Interaction states for the ripple.
 *
 * On Touch:
 *  - `INACTIVE -> TOUCH_DELAY -> WAITING_FOR_CLICK -> INACTIVE`
 *  - `INACTIVE -> TOUCH_DELAY -> HOLDING -> WAITING_FOR_CLICK -> INACTIVE`
 *
 * On Mouse or Pen:
 *   - `INACTIVE -> WAITING_FOR_CLICK -> INACTIVE`
 */ var $37a89812c3737937$var$State;
(function(State) {
    /**
     * Initial state of the control, no touch in progress.
     *
     * Transitions:
     *   - on touch down: transition to `TOUCH_DELAY`.
     *   - on mouse down: transition to `WAITING_FOR_CLICK`.
     */ State[State["INACTIVE"] = 0] = "INACTIVE";
    /**
     * Touch down has been received, waiting to determine if it's a swipe or
     * scroll.
     *
     * Transitions:
     *   - on touch up: begin press; transition to `WAITING_FOR_CLICK`.
     *   - on cancel: transition to `INACTIVE`.
     *   - after `TOUCH_DELAY_MS`: begin press; transition to `HOLDING`.
     */ State[State["TOUCH_DELAY"] = 1] = "TOUCH_DELAY";
    /**
     * A touch has been deemed to be a press
     *
     * Transitions:
     *  - on up: transition to `WAITING_FOR_CLICK`.
     */ State[State["HOLDING"] = 2] = "HOLDING";
    /**
     * The user touch has finished, transition into rest state.
     *
     * Transitions:
     *   - on click end press; transition to `INACTIVE`.
     */ State[State["WAITING_FOR_CLICK"] = 3] = "WAITING_FOR_CLICK";
})($37a89812c3737937$var$State || ($37a89812c3737937$var$State = {}));
/**
 * Events that the ripple listens to.
 */ const $37a89812c3737937$var$EVENTS = [
    "click",
    "contextmenu",
    "pointercancel",
    "pointerdown",
    "pointerenter",
    "pointerleave",
    "pointerup"
];
/**
 * Delay reacting to touch so that we do not show the ripple for a swipe or
 * scroll interaction.
 */ const $37a89812c3737937$var$TOUCH_DELAY_MS = 150;
class $37a89812c3737937$export$9e9146f7e027fdaa extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Disables the ripple.
         */ this.disabled = false;
        this.hovered = false;
        this.pressed = false;
        this.rippleSize = "";
        this.rippleScale = "";
        this.initialSize = 0;
        this.state = $37a89812c3737937$var$State.INACTIVE;
        this.checkBoundsAfterContextMenu = false;
        this.attachableController = new (0, $decf24133958b333$export$805bfb00874b30a5)(this, this.onControlChange.bind(this));
    }
    get htmlFor() {
        return this.attachableController.htmlFor;
    }
    set htmlFor(htmlFor) {
        this.attachableController.htmlFor = htmlFor;
    }
    get control() {
        return this.attachableController.control;
    }
    set control(control) {
        this.attachableController.control = control;
    }
    attach(control) {
        this.attachableController.attach(control);
    }
    detach() {
        this.attachableController.detach();
    }
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute("aria-hidden", "true");
    }
    render() {
        const classes = {
            "hovered": this.hovered,
            "pressed": this.pressed
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div class="surface ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"></div>`;
    }
    update(changedProps) {
        if (changedProps.has("disabled") && this.disabled) {
            this.hovered = false;
            this.pressed = false;
        }
        super.update(changedProps);
    }
    /**
     * TODO(b/269799771): make private
     * @private only public for slider
     */ handlePointerenter(event) {
        if (!this.shouldReactToEvent(event)) return;
        this.hovered = true;
    }
    /**
     * TODO(b/269799771): make private
     * @private only public for slider
     */ handlePointerleave(event) {
        if (!this.shouldReactToEvent(event)) return;
        this.hovered = false;
        // release a held mouse or pen press that moves outside the element
        if (this.state !== $37a89812c3737937$var$State.INACTIVE) this.endPressAnimation();
    }
    handlePointerup(event) {
        if (!this.shouldReactToEvent(event)) return;
        if (this.state === $37a89812c3737937$var$State.HOLDING) {
            this.state = $37a89812c3737937$var$State.WAITING_FOR_CLICK;
            return;
        }
        if (this.state === $37a89812c3737937$var$State.TOUCH_DELAY) {
            this.state = $37a89812c3737937$var$State.WAITING_FOR_CLICK;
            this.startPressAnimation(this.rippleStartEvent);
            return;
        }
    }
    async handlePointerdown(event) {
        if (!this.shouldReactToEvent(event)) return;
        this.rippleStartEvent = event;
        if (!this.isTouch(event)) {
            this.state = $37a89812c3737937$var$State.WAITING_FOR_CLICK;
            this.startPressAnimation(event);
            return;
        }
        // after a longpress contextmenu event, an extra `pointerdown` can be
        // dispatched to the pressed element. Check that the down is within
        // bounds of the element in this case.
        if (this.checkBoundsAfterContextMenu && !this.inBounds(event)) return;
        this.checkBoundsAfterContextMenu = false;
        // Wait for a hold after touch delay
        this.state = $37a89812c3737937$var$State.TOUCH_DELAY;
        await new Promise((resolve)=>{
            setTimeout(resolve, $37a89812c3737937$var$TOUCH_DELAY_MS);
        });
        if (this.state !== $37a89812c3737937$var$State.TOUCH_DELAY) return;
        this.state = $37a89812c3737937$var$State.HOLDING;
        this.startPressAnimation(event);
    }
    handleClick() {
        // Click is a MouseEvent in Firefox and Safari, so we cannot use
        // `shouldReactToEvent`
        if (this.disabled) return;
        if (this.state === $37a89812c3737937$var$State.WAITING_FOR_CLICK) {
            this.endPressAnimation();
            return;
        }
        if (this.state === $37a89812c3737937$var$State.INACTIVE) {
            // keyboard synthesized click event
            this.startPressAnimation();
            this.endPressAnimation();
        }
    }
    handlePointercancel(event) {
        if (!this.shouldReactToEvent(event)) return;
        this.endPressAnimation();
    }
    handleContextmenu() {
        if (this.disabled) return;
        this.checkBoundsAfterContextMenu = true;
        this.endPressAnimation();
    }
    determineRippleSize() {
        const { height: height, width: width } = this.getBoundingClientRect();
        const maxDim = Math.max(height, width);
        const softEdgeSize = Math.max($37a89812c3737937$var$SOFT_EDGE_CONTAINER_RATIO * maxDim, $37a89812c3737937$var$SOFT_EDGE_MINIMUM_SIZE);
        const initialSize = Math.floor(maxDim * $37a89812c3737937$var$INITIAL_ORIGIN_SCALE);
        const hypotenuse = Math.sqrt(width ** 2 + height ** 2);
        const maxRadius = hypotenuse + $37a89812c3737937$var$PADDING;
        this.initialSize = initialSize;
        this.rippleScale = `${(maxRadius + softEdgeSize) / initialSize}`;
        this.rippleSize = `${initialSize}px`;
    }
    getNormalizedPointerEventCoords(pointerEvent) {
        const { scrollX: scrollX, scrollY: scrollY } = window;
        const { left: left, top: top } = this.getBoundingClientRect();
        const documentX = scrollX + left;
        const documentY = scrollY + top;
        const { pageX: pageX, pageY: pageY } = pointerEvent;
        return {
            x: pageX - documentX,
            y: pageY - documentY
        };
    }
    getTranslationCoordinates(positionEvent) {
        const { height: height, width: width } = this.getBoundingClientRect();
        // end in the center
        const endPoint = {
            x: (width - this.initialSize) / 2,
            y: (height - this.initialSize) / 2
        };
        let startPoint;
        if (positionEvent instanceof PointerEvent) startPoint = this.getNormalizedPointerEventCoords(positionEvent);
        else startPoint = {
            x: width / 2,
            y: height / 2
        };
        // center around start point
        startPoint = {
            x: startPoint.x - this.initialSize / 2,
            y: startPoint.y - this.initialSize / 2
        };
        return {
            startPoint: startPoint,
            endPoint: endPoint
        };
    }
    startPressAnimation(positionEvent) {
        if (!this.mdRoot) return;
        this.pressed = true;
        this.growAnimation?.cancel();
        this.determineRippleSize();
        const { startPoint: startPoint, endPoint: endPoint } = this.getTranslationCoordinates(positionEvent);
        const translateStart = `${startPoint.x}px, ${startPoint.y}px`;
        const translateEnd = `${endPoint.x}px, ${endPoint.y}px`;
        this.growAnimation = this.mdRoot.animate({
            top: [
                0,
                0
            ],
            left: [
                0,
                0
            ],
            height: [
                this.rippleSize,
                this.rippleSize
            ],
            width: [
                this.rippleSize,
                this.rippleSize
            ],
            transform: [
                `translate(${translateStart}) scale(1)`,
                `translate(${translateEnd}) scale(${this.rippleScale})`
            ]
        }, {
            pseudoElement: $37a89812c3737937$var$PRESS_PSEUDO,
            duration: $37a89812c3737937$var$PRESS_GROW_MS,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).STANDARD,
            fill: $37a89812c3737937$var$ANIMATION_FILL
        });
    }
    async endPressAnimation() {
        this.state = $37a89812c3737937$var$State.INACTIVE;
        const animation = this.growAnimation;
        const pressAnimationPlayState = animation?.currentTime ?? Infinity;
        // TODO: go/ts51upgrade - Auto-added to unblock TS5.1 migration.
        //   TS2365: Operator '>=' cannot be applied to types 'CSSNumberish' and
        //   'number'.
        // @ts-ignore
        if (pressAnimationPlayState >= $37a89812c3737937$var$MINIMUM_PRESS_MS) {
            this.pressed = false;
            return;
        }
        await new Promise((resolve)=>{
            // TODO: go/ts51upgrade - Auto-added to unblock TS5.1 migration.
            //   TS2363: The right-hand side of an arithmetic operation must be of
            //   type 'any', 'number', 'bigint' or an enum type.
            // @ts-ignore
            setTimeout(resolve, $37a89812c3737937$var$MINIMUM_PRESS_MS - pressAnimationPlayState);
        });
        if (this.growAnimation !== animation) // A new press animation was started. The old animation was canceled and
        // should not finish the pressed state.
        return;
        this.pressed = false;
    }
    /**
     * Returns `true` if
     *  - the ripple element is enabled
     *  - the pointer is primary for the input type
     *  - the pointer is the pointer that started the interaction, or will start
     * the interaction
     *  - the pointer is a touch, or the pointer state has the primary button
     * held, or the pointer is hovering
     */ shouldReactToEvent(event) {
        if (this.disabled || !event.isPrimary) return false;
        if (this.rippleStartEvent && this.rippleStartEvent.pointerId !== event.pointerId) return false;
        if (event.type === "pointerenter" || event.type === "pointerleave") return !this.isTouch(event);
        const isPrimaryButton = event.buttons === 1;
        return this.isTouch(event) || isPrimaryButton;
    }
    /**
     * Check if the event is within the bounds of the element.
     *
     * This is only needed for the "stuck" contextmenu longpress on Chrome.
     */ inBounds({ x: x, y: y }) {
        const { top: top, left: left, bottom: bottom, right: right } = this.getBoundingClientRect();
        return x >= left && x <= right && y >= top && y <= bottom;
    }
    isTouch({ pointerType: pointerType }) {
        return pointerType === "touch";
    }
    /** @private */ async handleEvent(event) {
        switch(event.type){
            case "click":
                this.handleClick();
                break;
            case "contextmenu":
                this.handleContextmenu();
                break;
            case "pointercancel":
                this.handlePointercancel(event);
                break;
            case "pointerdown":
                await this.handlePointerdown(event);
                break;
            case "pointerenter":
                this.handlePointerenter(event);
                break;
            case "pointerleave":
                this.handlePointerleave(event);
                break;
            case "pointerup":
                this.handlePointerup(event);
                break;
            default:
                break;
        }
    }
    onControlChange(prev, next) {
        if (0, $650ed036964a13b8$export$6acf61af03e62db) return;
        for (const event of $37a89812c3737937$var$EVENTS){
            prev?.removeEventListener(event, this);
            next?.addEventListener(event, this);
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $37a89812c3737937$export$9e9146f7e027fdaa.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $37a89812c3737937$export$9e9146f7e027fdaa.prototype, "hovered", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $37a89812c3737937$export$9e9146f7e027fdaa.prototype, "pressed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".surface")
], $37a89812c3737937$export$9e9146f7e027fdaa.prototype, "mdRoot", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $b4b16ff67eacea38$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_hover-color: var(--md-ripple-hover-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-opacity: var(--md-ripple-hover-opacity, 0.08);--_pressed-color: var(--md-ripple-pressed-color, var(--md-sys-color-on-surface, #1d1b20));--_pressed-opacity: var(--md-ripple-pressed-opacity, 0.12);display:flex;margin:auto;pointer-events:none}:host([disabled]){display:none}@media(forced-colors: active){:host{display:none}}:host,.surface{border-radius:inherit;position:absolute;inset:0;overflow:hidden}.surface{-webkit-tap-highlight-color:rgba(0,0,0,0)}.surface::before,.surface::after{content:"";opacity:0;position:absolute}.surface::before{background-color:var(--_hover-color);inset:0;transition:opacity 15ms linear,background-color 15ms linear}.surface::after{background:radial-gradient(closest-side, var(--_pressed-color) max(100% - 70px, 65%), transparent 100%);transform-origin:center center;transition:opacity 375ms linear}.hovered::before{background-color:var(--_hover-color);opacity:var(--_hover-opacity)}.pressed::after{opacity:var(--_pressed-opacity);transition-duration:105ms}/*# sourceMappingURL=ripple-styles.css.map */
`;


let $bd52fb38d9dc80f0$export$b868d5c2ec612e9e = class MdRipple extends (0, $37a89812c3737937$export$9e9146f7e027fdaa) {
};
$bd52fb38d9dc80f0$export$b868d5c2ec612e9e.styles = [
    (0, $b4b16ff67eacea38$export$9dd6ff9ea0189349)
];
$bd52fb38d9dc80f0$export$b868d5c2ec612e9e = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-ripple")
], $bd52fb38d9dc80f0$export$b868d5c2ec612e9e);






/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $54f4e21f80f6eaaa$var$e = Symbol.for(""), $54f4e21f80f6eaaa$var$l = (t)=>{
    if ((null == t ? void 0 : t.r) === $54f4e21f80f6eaaa$var$e) return null == t ? void 0 : t._$litStatic$;
}, $54f4e21f80f6eaaa$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $54f4e21f80f6eaaa$var$e
    }), $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, l)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[l + 1], t[0]),
        r: $54f4e21f80f6eaaa$var$e
    }), $54f4e21f80f6eaaa$var$s = new Map, $54f4e21f80f6eaaa$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const o = e.length;
        let i, a;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < o;){
            for(c = r[$]; $ < o && void 0 !== (a = e[$], i = $54f4e21f80f6eaaa$var$l(a));)c += i + r[++$], f = !0;
            $ !== o && u.push(a), n.push(c), $++;
        }
        if ($ === o && n.push(r[o]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $54f4e21f80f6eaaa$var$s.get(t)) && (n.raw = n, $54f4e21f80f6eaaa$var$s.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $54f4e21f80f6eaaa$export$c0bb0b647f701bb5 = $54f4e21f80f6eaaa$export$878791788f808fc0((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)), $54f4e21f80f6eaaa$export$7ed1367e7fa1ad68 = $54f4e21f80f6eaaa$export$878791788f808fc0((0, $e5ed8027d647799b$export$7ed1367e7fa1ad68));





/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A unique symbol used for protected access to an instance's
 * `ElementInternals`.
 *
 * @example
 * ```ts
 * class MyElement extends LitElement {
 *   static formAssociated = true;
 *
 *   [internals] = this.attachInternals();
 * }
 *
 * function getForm(element: MyElement) {
 *   return element[internals].form;
 * }
 * ```
 */ const $365ee66853b0efd1$export$e368aba7747330f2 = Symbol("internals");


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

function $0a6e6f5f26c9e338$export$984066728db00204(ctor) {
    if (0, $650ed036964a13b8$export$6acf61af03e62db) return;
    ctor.addInitializer((instance)=>{
        const submitter = instance;
        submitter.addEventListener("click", async (event)=>{
            const { type: type, [(0, $365ee66853b0efd1$export$e368aba7747330f2)]: elementInternals } = submitter;
            const { form: form } = elementInternals;
            if (!form || type === "button") return;
            // Wait a microtask for event bubbling to complete.
            await new Promise((resolve)=>{
                resolve();
            });
            if (event.defaultPrevented) return;
            if (type === "reset") {
                form.reset();
                return;
            }
            // form.requestSubmit(submitter) does not work with form associated custom
            // elements. This patches the dispatched submit event to add the correct
            // `submitter`.
            // See https://github.com/WICG/webcomponents/issues/814
            form.addEventListener("submit", (submitEvent)=>{
                Object.defineProperty(submitEvent, "submitter", {
                    configurable: true,
                    enumerable: true,
                    get: ()=>submitter
                });
            }, {
                capture: true,
                once: true
            });
            elementInternals.setFormValue(submitter.value);
            form.requestSubmit();
        });
    });
}


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns `true` if the given element is in a right-to-left direction.
 *
 * @param el Element to determine direction from
 * @param shouldCheck Optional. If `false`, return `false` without checking
 *     direction. Determining the direction of `el` is somewhat expensive, so
 *     this parameter can be used as a conditional guard. Defaults to `true`.
 */ function $ac9a8077e076d07f$export$573af94e896e1f5c(el, shouldCheck = true) {
    return shouldCheck && getComputedStyle(el).getPropertyValue("direction").trim() === "rtl";
}


var $cd79e67b408544c7$var$_a;
class $cd79e67b408544c7$export$c25acd513dcc8062 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Disables the icon button and makes it non-interactive.
         */ this.disabled = false;
        /**
         * Flips the icon if it is in an RTL context at startup.
         */ this.flipIconInRtl = false;
        /**
         * Sets the underlying `HTMLAnchorElement`'s `href` resource attribute.
         */ this.href = "";
        /**
         * Sets the underlying `HTMLAnchorElement`'s `target` attribute.
         */ this.target = "";
        /**
         * The `aria-label` of the button when the button is toggleable and selected.
         */ this.ariaLabelSelected = "";
        /**
         * When true, the button will toggle between selected and unselected
         * states
         */ this.toggle = false;
        /**
         * Sets the selected state. When false, displays the default icon. When true,
         * displays the selected icon, or the default icon If no `slot="selected"`
         * icon is provided.
         */ this.selected = false;
        this.type = "submit";
        this.value = "";
        this.flipIcon = (0, $ac9a8077e076d07f$export$573af94e896e1f5c)(this, this.flipIconInRtl);
        /** @private */ this[$cd79e67b408544c7$var$_a] = this/* needed for closure */ .attachInternals();
    }
    get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    /**
     * The associated form element with which this element's value will submit.
     */ get form() {
        return this[0, $365ee66853b0efd1$export$e368aba7747330f2].form;
    }
    /**
     * The labels this element is associated with.
     */ get labels() {
        return this[0, $365ee66853b0efd1$export$e368aba7747330f2].labels;
    }
    /**
     * Link buttons cannot be disabled.
     */ willUpdate() {
        if (this.href) this.disabled = false;
    }
    render() {
        const tag = this.href ? (0, $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0)`div` : (0, $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0)`button`;
        // Needed for closure conformance
        const { ariaLabel: ariaLabel, ariaHasPopup: ariaHasPopup, ariaExpanded: ariaExpanded } = this;
        const hasToggledAriaLabel = ariaLabel && this.ariaLabelSelected;
        const ariaPressedValue = !this.toggle ? (0, $e5ed8027d647799b$export$45b790e32b2810ee) : this.selected;
        let ariaLabelValue = (0, $e5ed8027d647799b$export$45b790e32b2810ee);
        if (!this.href) ariaLabelValue = hasToggledAriaLabel && this.selected ? this.ariaLabelSelected : ariaLabel;
        return (0, $54f4e21f80f6eaaa$export$c0bb0b647f701bb5)`<${tag}
        class="icon-button ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getRenderClasses())}"
        id="button"
        aria-label="${ariaLabelValue || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
        aria-haspopup="${!this.href && ariaHasPopup || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
        aria-expanded="${!this.href && ariaExpanded || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
        aria-pressed="${ariaPressedValue}"
        ?disabled="${!this.href && this.disabled}"
        @click="${this.handleClick}">
        ${this.renderFocusRing()}
        ${this.renderRipple()}
        ${!this.selected ? this.renderIcon() : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        ${this.selected ? this.renderSelectedIcon() : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        ${this.renderTouchTarget()}
        ${this.href && this.renderLink()}
  </${tag}>`;
    }
    renderLink() {
        // Needed for closure conformance
        const { ariaLabel: ariaLabel } = this;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <a class="link"
        id="link"
        href="${this.href}"
        target="${this.target || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
        aria-label="${ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}"
      ></a>
    `;
    }
    getRenderClasses() {
        return {
            "flip-icon": this.flipIcon,
            "selected": this.toggle && this.selected
        };
    }
    renderIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="icon"><slot></slot></span>`;
    }
    renderSelectedIcon() {
        // Use default slot as fallback to not require specifying multiple icons
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="icon icon--selected"><slot name="selected"><slot></slot></slot></span>`;
    }
    renderTouchTarget() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="touch"></span>`;
    }
    renderFocusRing() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-focus-ring part="focus-ring" for=${this.href ? "link" : "button"}></md-focus-ring>`;
    }
    renderRipple() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-ripple
      for=${this.href ? "link" : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
      ?disabled="${!this.href && this.disabled}"
    ></md-ripple>`;
    }
    connectedCallback() {
        this.flipIcon = (0, $ac9a8077e076d07f$export$573af94e896e1f5c)(this, this.flipIconInRtl);
        super.connectedCallback();
    }
    async handleClick(event) {
        // Allow the event to propagate
        await 0;
        if (!this.toggle || this.disabled || event.defaultPrevented) return;
        this.selected = !this.selected;
        this.dispatchEvent(new InputEvent("input", {
            bubbles: true,
            composed: true
        }));
        // Bubbles but does not compose to mimic native browser <input> & <select>
        // Additionally, native change event is not an InputEvent.
        this.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
}
$cd79e67b408544c7$var$_a = (0, $365ee66853b0efd1$export$e368aba7747330f2);
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($cd79e67b408544c7$export$c25acd513dcc8062);
    (0, $0a6e6f5f26c9e338$export$984066728db00204)($cd79e67b408544c7$export$c25acd513dcc8062);
})();
/** @nocollapse */ $cd79e67b408544c7$export$c25acd513dcc8062.formAssociated = true;
/** @nocollapse */ $cd79e67b408544c7$export$c25acd513dcc8062.shadowRootOptions = {
    mode: "open",
    delegatesFocus: true
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "flip-icon-in-rtl"
    })
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "flipIconInRtl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "href", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "target", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "aria-label-selected"
    })
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "ariaLabelSelected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "toggle", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "selected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $cd79e67b408544c7$export$c25acd513dcc8062.prototype, "flipIcon", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $6c97ea26c9205f1f$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{display:inline-flex;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0);height:var(--_container-height);width:var(--_container-width);justify-content:center}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_container-height))/2) max(0px,(48px - var(--_container-width))/2)}md-focus-ring{--md-focus-ring-shape-start-start: var(--_container-shape-start-start);--md-focus-ring-shape-start-end: var(--_container-shape-start-end);--md-focus-ring-shape-end-end: var(--_container-shape-end-end);--md-focus-ring-shape-end-start: var(--_container-shape-end-start)}:host([disabled]){pointer-events:none}.icon-button{place-items:center;background:none;border:none;box-sizing:border-box;cursor:pointer;display:flex;place-content:center;outline:none;padding:0;position:relative;text-decoration:none;user-select:none;z-index:0;flex:1;border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end)}.icon ::slotted(*){font-size:var(--_icon-size);height:var(--_icon-size);width:var(--_icon-size);font-weight:inherit}md-ripple{z-index:-1;border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-start-radius:var(--_container-shape-end-start);border-end-end-radius:var(--_container-shape-end-end)}.flip-icon .icon{transform:scaleX(-1)}.icon{display:inline-flex}.link{height:100%;outline:none;position:absolute;width:100%}.touch{position:absolute;height:max(48px,100%);width:max(48px,100%)}:host([touch-target=none]) .touch{display:none}@media(forced-colors: active){:host([disabled]){--_disabled-icon-opacity: 1}}/*# sourceMappingURL=shared-styles.css.map */
`;


let $25d5a52af2521454$export$5241acc51c95c821 = class MdFilledIconButton extends (0, $cd79e67b408544c7$export$c25acd513dcc8062) {
    getRenderClasses() {
        return {
            ...super.getRenderClasses(),
            "filled": true,
            "toggle-filled": this.toggle
        };
    }
};
$25d5a52af2521454$export$5241acc51c95c821.styles = [
    (0, $6c97ea26c9205f1f$export$9dd6ff9ea0189349),
    (0, $1c28216c24519ada$export$9dd6ff9ea0189349)
];
$25d5a52af2521454$export$5241acc51c95c821 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-filled-icon-button")
], $25d5a52af2521454$export$5241acc51c95c821);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $654189bfba73b792$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@media(forced-colors: active){:host{--md-outlined-select-text-field-disabled-input-text-color: GrayText;--md-outlined-select-text-field-disabled-input-text-opacity: 1;--md-outlined-select-text-field-disabled-label-text-color: GrayText;--md-outlined-select-text-field-disabled-label-text-opacity: 1;--md-outlined-select-text-field-disabled-leading-icon-color: GrayText;--md-outlined-select-text-field-disabled-leading-icon-opacity: 1;--md-outlined-select-text-field-disabled-outline-color: GrayText;--md-outlined-select-text-field-disabled-outline-opacity: 1;--md-outlined-select-text-field-disabled-supporting-text-color: GrayText;--md-outlined-select-text-field-disabled-supporting-text-opacity: 1;--md-outlined-select-text-field-disabled-trailing-icon-color: GrayText;--md-outlined-select-text-field-disabled-trailing-icon-opacity: 1}}/*# sourceMappingURL=outlined-forced-colors-styles.css.map */
`;


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 




class $648ee3d9d8a600e0$export$a455218a85c89869 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.error = false;
        this.focused = false;
        this.label = "";
        this.populated = false;
        this.required = false;
        this.resizable = false;
        this.supportingText = "";
        this.errorText = "";
        this.count = -1;
        this.max = -1;
        /**
         * Whether or not the field has leading content.
         */ this.hasStart = false;
        /**
         * Whether or not the field has trailing content.
         */ this.hasEnd = false;
        this.isAnimating = false;
        /**
         * When set to true, the error text's `role="alert"` will be removed, then
         * re-added after an animation frame. This will re-announce an error message
         * to screen readers.
         */ this.refreshErrorAlert = false;
        this.disableTransitions = false;
    }
    get counterText() {
        if (this.count < 0 || this.max < 0) return "";
        return `${this.count} / ${this.max}`;
    }
    get supportingOrErrorText() {
        return this.error && this.errorText ? this.errorText : this.supportingText;
    }
    /**
     * Re-announces the field's error supporting text to screen readers.
     *
     * Error text announces to screen readers anytime it is visible and changes.
     * Use the method to re-announce the message when the text has not changed,
     * but announcement is still needed (such as for `reportValidity()`).
     */ reannounceError() {
        this.refreshErrorAlert = true;
    }
    update(props) {
        // Client-side property updates
        const isDisabledChanging = props.has("disabled") && props.get("disabled") !== undefined;
        if (isDisabledChanging) this.disableTransitions = true;
        // When disabling, remove focus styles if focused.
        if (this.disabled && this.focused) {
            props.set("focused", true);
            this.focused = false;
        }
        // Animate if focused or populated change.
        this.animateLabelIfNeeded({
            wasFocused: props.get("focused"),
            wasPopulated: props.get("populated")
        });
        super.update(props);
    }
    render() {
        const floatingLabel = this.renderLabel(/*isFloating*/ true);
        const restingLabel = this.renderLabel(/*isFloating*/ false);
        const outline = this.renderOutline?.(floatingLabel);
        const classes = {
            "disabled": this.disabled,
            "disable-transitions": this.disableTransitions,
            "error": this.error && !this.disabled,
            "focused": this.focused,
            "with-start": this.hasStart,
            "with-end": this.hasEnd,
            "populated": this.populated,
            "resizable": this.resizable,
            "required": this.required,
            "no-label": !this.label
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="field ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
        <div class="container-overflow">
          ${this.renderBackground?.()}
          ${this.renderIndicator?.()}
          ${outline}
          <div class="container">
            <div class="start">
              <slot name="start"></slot>
            </div>
            <div class="middle">
              <div class="label-wrapper">
                ${restingLabel}
                ${outline ? (0, $e5ed8027d647799b$export$45b790e32b2810ee) : floatingLabel}
              </div>
              <div class="content">
                <slot></slot>
              </div>
            </div>
            <div class="end">
              <slot name="end"></slot>
            </div>
          </div>
        </div>
        ${this.renderSupportingText()}
      </div>
    `;
    }
    updated(changed) {
        if (changed.has("supportingText") || changed.has("errorText") || changed.has("count") || changed.has("max")) this.updateSlottedAriaDescribedBy();
        if (this.refreshErrorAlert) // The past render cycle removed the role="alert" from the error message.
        // Re-add it after an animation frame to re-announce the error.
        requestAnimationFrame(()=>{
            this.refreshErrorAlert = false;
        });
        if (this.disableTransitions) requestAnimationFrame(()=>{
            this.disableTransitions = false;
        });
    }
    renderSupportingText() {
        const { supportingOrErrorText: supportingOrErrorText, counterText: counterText } = this;
        if (!supportingOrErrorText && !counterText) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        // Always render the supporting text span so that our `space-around`
        // container puts the counter at the end.
        const start = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span>${supportingOrErrorText}</span>`;
        // Conditionally render counter so we don't render the extra `gap`.
        // TODO(b/244473435): add aria-label and announcements
        const end = counterText ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="counter">${counterText}</span>` : (0, $e5ed8027d647799b$export$45b790e32b2810ee);
        // Announce if there is an error and error text visible.
        // If refreshErrorAlert is true, do not announce. This will remove the
        // role="alert" attribute. Another render cycle will happen after an
        // animation frame to re-add the role.
        const shouldErrorAnnounce = this.error && this.errorText && !this.refreshErrorAlert;
        const role = shouldErrorAnnounce ? "alert" : (0, $e5ed8027d647799b$export$45b790e32b2810ee);
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="supporting-text" role=${role}>${start}${end}</div>
      <slot name="aria-describedby" @slotchange=${this.updateSlottedAriaDescribedBy}></slot>
    `;
    }
    updateSlottedAriaDescribedBy() {
        for (const element of this.slottedAriaDescribedBy){
            (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`${this.supportingOrErrorText} ${this.counterText}`, element);
            element.setAttribute("hidden", "");
        }
    }
    renderLabel(isFloating) {
        if (!this.label) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        let visible;
        if (isFloating) // Floating label is visible when focused/populated or when animating.
        visible = this.focused || this.populated || this.isAnimating;
        else // Resting label is visible when unfocused. It is never visible while
        // animating.
        visible = !this.focused && !this.populated && !this.isAnimating;
        const classes = {
            "hidden": !visible,
            "floating": isFloating,
            "resting": !isFloating
        };
        // Add '*' if a label is present and the field is required
        const labelText = `${this.label}${this.required ? "*" : ""}`;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="label ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
        aria-hidden=${!visible}
      >${labelText}</span>
    `;
    }
    animateLabelIfNeeded({ wasFocused: wasFocused, wasPopulated: wasPopulated }) {
        if (!this.label) return;
        wasFocused ?? (wasFocused = this.focused);
        wasPopulated ?? (wasPopulated = this.populated);
        const wasFloating = wasFocused || wasPopulated;
        const shouldBeFloating = this.focused || this.populated;
        if (wasFloating === shouldBeFloating) return;
        this.isAnimating = true;
        this.labelAnimation?.cancel();
        // Only one label is visible at a time for clearer text rendering.
        // The floating label is visible and used during animation. At the end of
        // the animation, it will either remain visible (if floating) or hide and
        // the resting label will be shown.
        //
        // We don't use forward filling because if the dimensions of the text field
        // change (leading icon removed, density changes, etc), then the animation
        // will be inaccurate.
        //
        // Re-calculating the animation each time will prevent any visual glitches
        // from appearing.
        // TODO(b/241113345): use animation tokens
        this.labelAnimation = this.floatingLabelEl?.animate(this.getLabelKeyframes(), {
            duration: 150,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).STANDARD
        });
        this.labelAnimation?.addEventListener("finish", ()=>{
            // At the end of the animation, update the visible label.
            this.isAnimating = false;
        });
    }
    getLabelKeyframes() {
        const { floatingLabelEl: floatingLabelEl, restingLabelEl: restingLabelEl } = this;
        if (!floatingLabelEl || !restingLabelEl) return [];
        const { x: floatingX, y: floatingY, height: floatingHeight } = floatingLabelEl.getBoundingClientRect();
        const { x: restingX, y: restingY, height: restingHeight } = restingLabelEl.getBoundingClientRect();
        const floatingScrollWidth = floatingLabelEl.scrollWidth;
        const restingScrollWidth = restingLabelEl.scrollWidth;
        // Scale by width ratio instead of font size since letter-spacing will scale
        // incorrectly. Using the width we can better approximate the adjusted
        // scale and compensate for tracking and overflow.
        // (use scrollWidth instead of width to account for clipped labels)
        const scale = restingScrollWidth / floatingScrollWidth;
        const xDelta = restingX - floatingX;
        // The line-height of the resting and floating label are different. When
        // we move the floating label down to the resting label's position, it won't
        // exactly match because of this. We need to adjust by half of what the
        // final scaled floating label's height will be.
        const yDelta = restingY - floatingY + Math.round((restingHeight - floatingHeight * scale) / 2);
        // Create the two transforms: floating to resting (using the calculations
        // above), and resting to floating (re-setting the transform to initial
        // values).
        const restTransform = `translateX(${xDelta}px) translateY(${yDelta}px) scale(${scale})`;
        const floatTransform = `translateX(0) translateY(0) scale(1)`;
        // Constrain the floating labels width to a scaled percentage of the
        // resting label's width. This will prevent long clipped labels from
        // overflowing the container.
        const restingClientWidth = restingLabelEl.clientWidth;
        const isRestingClipped = restingScrollWidth > restingClientWidth;
        const width = isRestingClipped ? `${restingClientWidth / scale}px` : "";
        if (this.focused || this.populated) return [
            {
                transform: restTransform,
                width: width
            },
            {
                transform: floatTransform,
                width: width
            }
        ];
        return [
            {
                transform: floatTransform,
                width: width
            },
            {
                transform: restTransform,
                width: width
            }
        ];
    }
    getSurfacePositionClientRect() {
        return this.containerEl.getBoundingClientRect();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "error", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "focused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "populated", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "resizable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "supporting-text"
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "supportingText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "error-text"
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "errorText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "count", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "max", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-start"
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "hasStart", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-end"
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "hasEnd", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "aria-describedby"
    })
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "slottedAriaDescribedBy", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "isAnimating", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "refreshErrorAlert", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "disableTransitions", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".label.floating")
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "floatingLabelEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".label.resting")
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "restingLabelEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".container")
], $648ee3d9d8a600e0$export$a455218a85c89869.prototype, "containerEl", void 0);


class $fc3887771a91df2d$export$54dfcc442762ea48 extends (0, $648ee3d9d8a600e0$export$a455218a85c89869) {
    renderOutline(floatingLabel) {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="outline">
        <div class="outline-start"></div>
        <div class="outline-notch">
          <div class="outline-panel-inactive"></div>
          <div class="outline-panel-active"></div>
          <div class="outline-label">${floatingLabel}</div>
        </div>
        <div class="outline-end"></div>
      </div>
    `;
    }
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $aad0f88fd8fb0a3f$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_bottom-space: var(--md-outlined-field-bottom-space, 16px);--_container-shape: var(--md-outlined-field-container-shape, 4px);--_content-color: var(--md-outlined-field-content-color, var(--md-sys-color-on-surface, #1d1b20));--_content-font: var(--md-outlined-field-content-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_content-line-height: var(--md-outlined-field-content-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_content-size: var(--md-outlined-field-content-size, var(--md-sys-typescale-body-large-size, 1rem));--_content-weight: var(--md-outlined-field-content-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_disabled-content-color: var(--md-outlined-field-disabled-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-content-opacity: var(--md-outlined-field-disabled-content-opacity, 0.38);--_disabled-label-text-color: var(--md-outlined-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-outlined-field-disabled-label-text-opacity, 0.38);--_disabled-leading-content-color: var(--md-outlined-field-disabled-leading-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-content-opacity: var(--md-outlined-field-disabled-leading-content-opacity, 0.38);--_disabled-outline-color: var(--md-outlined-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-outlined-field-disabled-outline-opacity, 0.12);--_disabled-outline-width: var(--md-outlined-field-disabled-outline-width, 1px);--_disabled-supporting-text-color: var(--md-outlined-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-supporting-text-opacity: var(--md-outlined-field-disabled-supporting-text-opacity, 0.38);--_disabled-trailing-content-color: var(--md-outlined-field-disabled-trailing-content-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-content-opacity: var(--md-outlined-field-disabled-trailing-content-opacity, 0.38);--_error-content-color: var(--md-outlined-field-error-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-content-color: var(--md-outlined-field-error-focus-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-label-text-color: var(--md-outlined-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-leading-content-color: var(--md-outlined-field-error-focus-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-focus-outline-color: var(--md-outlined-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_error-focus-supporting-text-color: var(--md-outlined-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-trailing-content-color: var(--md-outlined-field-error-focus-trailing-content-color, var(--md-sys-color-error, #b3261e));--_error-hover-content-color: var(--md-outlined-field-error-hover-content-color, var(--md-sys-color-on-surface, #1d1b20));--_error-hover-label-text-color: var(--md-outlined-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-leading-content-color: var(--md-outlined-field-error-hover-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-hover-outline-color: var(--md-outlined-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-supporting-text-color: var(--md-outlined-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-hover-trailing-content-color: var(--md-outlined-field-error-hover-trailing-content-color, var(--md-sys-color-on-error-container, #410e0b));--_error-label-text-color: var(--md-outlined-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_error-leading-content-color: var(--md-outlined-field-error-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-outline-color: var(--md-outlined-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_error-supporting-text-color: var(--md-outlined-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-trailing-content-color: var(--md-outlined-field-error-trailing-content-color, var(--md-sys-color-error, #b3261e));--_focus-content-color: var(--md-outlined-field-focus-content-color, var(--md-sys-color-on-surface, #1d1b20));--_focus-label-text-color: var(--md-outlined-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_focus-leading-content-color: var(--md-outlined-field-focus-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-outline-color: var(--md-outlined-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_focus-outline-width: var(--md-outlined-field-focus-outline-width, 3px);--_focus-supporting-text-color: var(--md-outlined-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-trailing-content-color: var(--md-outlined-field-focus-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-content-color: var(--md-outlined-field-hover-content-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-label-text-color: var(--md-outlined-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-leading-content-color: var(--md-outlined-field-hover-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-outline-color: var(--md-outlined-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-outline-width: var(--md-outlined-field-hover-outline-width, 1px);--_hover-supporting-text-color: var(--md-outlined-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-content-color: var(--md-outlined-field-hover-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-color: var(--md-outlined-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-font: var(--md-outlined-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-outlined-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_label-text-padding-bottom: var(--md-outlined-field-label-text-padding-bottom, 8px);--_label-text-populated-line-height: var(--md-outlined-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_label-text-populated-size: var(--md-outlined-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_label-text-size: var(--md-outlined-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_label-text-weight: var(--md-outlined-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_leading-content-color: var(--md-outlined-field-leading-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_leading-space: var(--md-outlined-field-leading-space, 16px);--_outline-color: var(--md-outlined-field-outline-color, var(--md-sys-color-outline, #79747e));--_outline-label-padding: var(--md-outlined-field-outline-label-padding, 4px);--_outline-width: var(--md-outlined-field-outline-width, 1px);--_supporting-text-color: var(--md-outlined-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_supporting-text-font: var(--md-outlined-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_supporting-text-leading-space: var(--md-outlined-field-supporting-text-leading-space, 16px);--_supporting-text-line-height: var(--md-outlined-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_supporting-text-size: var(--md-outlined-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_supporting-text-top-space: var(--md-outlined-field-supporting-text-top-space, 4px);--_supporting-text-trailing-space: var(--md-outlined-field-supporting-text-trailing-space, 16px);--_supporting-text-weight: var(--md-outlined-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_top-space: var(--md-outlined-field-top-space, 16px);--_trailing-content-color: var(--md-outlined-field-trailing-content-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-space: var(--md-outlined-field-trailing-space, 16px);--_container-shape-start-start: var( --md-outlined-field-container-shape-start-start, var(--_container-shape) );--_container-shape-start-end: var( --md-outlined-field-container-shape-start-end, var(--_container-shape) );--_container-shape-end-end: var( --md-outlined-field-container-shape-end-end, var(--_container-shape) );--_container-shape-end-start: var( --md-outlined-field-container-shape-end-start, var(--_container-shape) )}.outline{border-color:var(--_outline-color);border-radius:inherit;color:var(--_outline-color);display:flex;pointer-events:none;height:100%;position:absolute;width:100%}.outline-start::before,.outline-start::after,.outline-panel-inactive::before,.outline-panel-inactive::after,.outline-panel-active::before,.outline-panel-active::after,.outline-end::before,.outline-end::after{border:inherit;content:"";inset:0;position:absolute}.outline-start,.outline-end{border:inherit;border-radius:inherit;box-sizing:border-box;position:relative}.outline-start::before,.outline-start::after,.outline-end::before,.outline-end::after{border-bottom-style:solid;border-top-style:solid}.outline-start::after,.outline-end::after{opacity:0;transition:opacity 150ms cubic-bezier(0.2, 0, 0, 1)}.focused .outline-start::after,.focused .outline-end::after{opacity:1}.outline-start::before,.outline-start::after{border-inline-start-style:solid;border-inline-end-style:none;border-start-start-radius:inherit;border-start-end-radius:0;border-end-start-radius:inherit;border-end-end-radius:0;margin-inline-end:var(--_outline-label-padding)}.outline-end{flex-grow:1;margin-inline-start:calc(-1*var(--_outline-label-padding))}.outline-end::before,.outline-end::after{border-inline-start-style:none;border-inline-end-style:solid;border-start-start-radius:0;border-start-end-radius:inherit;border-end-start-radius:0;border-end-end-radius:inherit}.outline-notch{align-items:flex-start;border:inherit;display:flex;margin-inline-start:calc(-1*var(--_outline-label-padding));margin-inline-end:var(--_outline-label-padding);max-width:calc(100% - var(--_leading-space) - var(--_trailing-space));padding:0 var(--_outline-label-padding);position:relative}.no-label .outline-notch{display:none}.outline-panel-inactive,.outline-panel-active{border:inherit;border-bottom-style:solid;inset:0;position:absolute}.outline-panel-inactive::before,.outline-panel-inactive::after,.outline-panel-active::before,.outline-panel-active::after{border-top-style:solid;border-bottom:none;bottom:auto;transform:scaleX(1);transition:transform 150ms cubic-bezier(0.2, 0, 0, 1)}.outline-panel-inactive::before,.outline-panel-active::before{right:50%;transform-origin:top left}.outline-panel-inactive::after,.outline-panel-active::after{left:50%;transform-origin:top right}.populated .outline-panel-inactive::before,.populated .outline-panel-inactive::after,.populated .outline-panel-active::before,.populated .outline-panel-active::after,.focused .outline-panel-inactive::before,.focused .outline-panel-inactive::after,.focused .outline-panel-active::before,.focused .outline-panel-active::after{transform:scaleX(0)}.outline-panel-active{opacity:0;transition:opacity 150ms cubic-bezier(0.2, 0, 0, 1)}.focused .outline-panel-active{opacity:1}.outline-label{display:flex;max-width:100%;transform:translateY(calc(-100% + var(--_label-text-padding-bottom)))}.outline-start,.field:not(.with-start) .content ::slotted(*){padding-inline-start:max(var(--_leading-space),max(var(--_container-shape-start-start),var(--_container-shape-end-start)) + var(--_outline-label-padding))}.field:not(.with-start) .label-wrapper{margin-inline-start:max(var(--_leading-space),max(var(--_container-shape-start-start),var(--_container-shape-end-start)) + var(--_outline-label-padding))}.field:not(.with-end) .content ::slotted(*){padding-inline-end:max(var(--_trailing-space),max(var(--_container-shape-start-end),var(--_container-shape-end-end)))}.field:not(.with-end) .label-wrapper{margin-inline-end:max(var(--_trailing-space),max(var(--_container-shape-start-end),var(--_container-shape-end-end)))}.outline-start::before,.outline-end::before,.outline-panel-inactive,.outline-panel-inactive::before,.outline-panel-inactive::after{border-width:var(--_outline-width)}:hover .outline{border-color:var(--_hover-outline-color);color:var(--_hover-outline-color)}:hover .outline-start::before,:hover .outline-end::before,:hover .outline-panel-inactive,:hover .outline-panel-inactive::before,:hover .outline-panel-inactive::after{border-width:var(--_hover-outline-width)}.focused .outline{border-color:var(--_focus-outline-color);color:var(--_focus-outline-color)}.outline-start::after,.outline-end::after,.outline-panel-active,.outline-panel-active::before,.outline-panel-active::after{border-width:var(--_focus-outline-width)}.disabled .outline{border-color:var(--_disabled-outline-color);color:var(--_disabled-outline-color)}.disabled .outline-start,.disabled .outline-end,.disabled .outline-panel-inactive{opacity:var(--_disabled-outline-opacity)}.disabled .outline-start::before,.disabled .outline-end::before,.disabled .outline-panel-inactive,.disabled .outline-panel-inactive::before,.disabled .outline-panel-inactive::after{border-width:var(--_disabled-outline-width)}.error .outline{border-color:var(--_error-outline-color);color:var(--_error-outline-color)}.error:hover .outline{border-color:var(--_error-hover-outline-color);color:var(--_error-hover-outline-color)}.error.focused .outline{border-color:var(--_error-focus-outline-color);color:var(--_error-focus-outline-color)}.resizable .container{bottom:var(--_focus-outline-width);inset-inline-end:var(--_focus-outline-width);clip-path:inset(var(--_focus-outline-width) 0 0 var(--_focus-outline-width))}.resizable .container>*{top:var(--_focus-outline-width);inset-inline-start:var(--_focus-outline-width)}:host-context([dir=rtl]) .resizable .container,:host([dir=rtl]) .resizable .container{clip-path:inset(var(--_focus-outline-width) var(--_focus-outline-width) 0 0)}.resizable .container:dir(rtl){clip-path:inset(var(--_focus-outline-width) var(--_focus-outline-width) 0 0)}/*# sourceMappingURL=outlined-styles.css.map */
`;


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $c237db31ac758830$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{display:inline-flex;resize:both}.field{display:flex;flex:1;flex-direction:column;writing-mode:horizontal-tb;max-width:100%}.container-overflow{border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-end-radius:var(--_container-shape-end-end);border-end-start-radius:var(--_container-shape-end-start);display:flex;height:100%;position:relative}.container{align-items:center;border-radius:inherit;display:flex;flex:1;max-height:100%;min-height:100%;min-width:min-content;position:relative}.field,.container-overflow{resize:inherit}.resizable:not(.disabled) .container{resize:inherit;overflow:hidden}.disabled{pointer-events:none}.start,.middle,.end{display:flex;box-sizing:border-box;height:100%;position:relative}.start{color:var(--_leading-content-color)}.end{color:var(--_trailing-content-color)}.start,.end{align-items:center;justify-content:center}.with-start .start,.with-end .end{min-width:48px}.with-start .start{margin-inline-end:4px}.with-end .end{margin-inline-start:4px}.middle{align-items:stretch;align-self:baseline;flex:1}.content{color:var(--_content-color);display:flex;flex:1;opacity:0;transition:opacity 83ms cubic-bezier(0.2, 0, 0, 1)}.no-label .content,.focused .content,.populated .content{opacity:1;transition-delay:67ms}:is(.disabled,.disable-transitions) .content{transition:none}.content ::slotted(*){all:unset;color:currentColor;font-family:var(--_content-font);font-size:var(--_content-size);line-height:var(--_content-line-height);font-weight:var(--_content-weight);width:100%;white-space:pre-wrap}.content ::slotted(:not(textarea)){padding-top:var(--_top-space);padding-bottom:var(--_bottom-space)}.content ::slotted(textarea){margin-top:var(--_top-space);margin-bottom:var(--_bottom-space)}:hover .content{color:var(--_hover-content-color)}:hover .start{color:var(--_hover-leading-content-color)}:hover .end{color:var(--_hover-trailing-content-color)}.focused .content{color:var(--_focus-content-color)}.focused .start{color:var(--_focus-leading-content-color)}.focused .end{color:var(--_focus-trailing-content-color)}.disabled .content{color:var(--_disabled-content-color)}.disabled.no-label .content,.disabled.focused .content,.disabled.populated .content{opacity:var(--_disabled-content-opacity)}.disabled .start{color:var(--_disabled-leading-content-color);opacity:var(--_disabled-leading-content-opacity)}.disabled .end{color:var(--_disabled-trailing-content-color);opacity:var(--_disabled-trailing-content-opacity)}.error .content{color:var(--_error-content-color)}.error .start{color:var(--_error-leading-content-color)}.error .end{color:var(--_error-trailing-content-color)}.error:hover .content{color:var(--_error-hover-content-color)}.error:hover .start{color:var(--_error-hover-leading-content-color)}.error:hover .end{color:var(--_error-hover-trailing-content-color)}.error.focused .content{color:var(--_error-focus-content-color)}.error.focused .start{color:var(--_error-focus-leading-content-color)}.error.focused .end{color:var(--_error-focus-trailing-content-color)}.label{box-sizing:border-box;color:var(--_label-text-color);overflow:hidden;max-width:100%;text-overflow:ellipsis;white-space:nowrap;z-index:1;font-family:var(--_label-text-font);font-size:var(--_label-text-size);line-height:var(--_label-text-line-height);font-weight:var(--_label-text-weight);width:min-content}.label-wrapper{inset:0;pointer-events:none;position:absolute}.label.resting{position:absolute;top:var(--_top-space)}.label.floating{font-size:var(--_label-text-populated-size);line-height:var(--_label-text-populated-line-height);transform-origin:top left}.label.hidden{opacity:0}.no-label .label{display:none}.label-wrapper{inset:0;position:absolute;text-align:initial}:hover .label{color:var(--_hover-label-text-color)}.focused .label{color:var(--_focus-label-text-color)}.disabled .label{color:var(--_disabled-label-text-color)}.disabled .label:not(.hidden){opacity:var(--_disabled-label-text-opacity)}.error .label{color:var(--_error-label-text-color)}.error:hover .label{color:var(--_error-hover-label-text-color)}.error.focused .label{color:var(--_error-focus-label-text-color)}.supporting-text{color:var(--_supporting-text-color);display:flex;font-family:var(--_supporting-text-font);font-size:var(--_supporting-text-size);line-height:var(--_supporting-text-line-height);font-weight:var(--_supporting-text-weight);gap:16px;justify-content:space-between;padding-inline-start:var(--_supporting-text-leading-space);padding-inline-end:var(--_supporting-text-trailing-space);padding-top:var(--_supporting-text-top-space)}.supporting-text :nth-child(2){flex-shrink:0}:hover .supporting-text{color:var(--_hover-supporting-text-color)}.focus .supporting-text{color:var(--_focus-supporting-text-color)}.disabled .supporting-text{color:var(--_disabled-supporting-text-color);opacity:var(--_disabled-supporting-text-opacity)}.error .supporting-text{color:var(--_error-supporting-text-color)}.error:hover .supporting-text{color:var(--_error-hover-supporting-text-color)}.error.focus .supporting-text{color:var(--_error-focus-supporting-text-color)}/*# sourceMappingURL=shared-styles.css.map */
`;


let $d2cf1e816f200120$export$505a3bf2bf2f4ad2 = class MdOutlinedField extends (0, $fc3887771a91df2d$export$54dfcc442762ea48) {
};
$d2cf1e816f200120$export$505a3bf2bf2f4ad2.styles = [
    (0, $c237db31ac758830$export$9dd6ff9ea0189349),
    (0, $aad0f88fd8fb0a3f$export$9dd6ff9ea0189349)
];
$d2cf1e816f200120$export$505a3bf2bf2f4ad2 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-outlined-field")
], $d2cf1e816f200120$export$505a3bf2bf2f4ad2);



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $ccb0b591ce994444$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@media(forced-colors: active){.menu{border-style:solid;border-color:CanvasText;border-width:1px}}/*# sourceMappingURL=forced-colors-styles.css.map */
`;


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $d09a6760ddf01b3f$export$58bfb4f6ec5aa58d extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    connectedCallback() {
        super.connectedCallback();
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute("aria-hidden", "true");
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="shadow"></span>`;
    }
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $0e15e1acb528e7d8$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_level: var(--md-elevation-level, 0);--_shadow-color: var(--md-elevation-shadow-color, var(--md-sys-color-shadow, #000));display:flex;pointer-events:none}:host,.shadow,.shadow::before,.shadow::after{border-radius:inherit;inset:0;position:absolute;transition-duration:inherit;transition-property:inherit;transition-timing-function:inherit}.shadow::before,.shadow::after{content:"";transition-property:box-shadow,opacity}.shadow::before{box-shadow:0px calc(1px*(clamp(0,var(--_level),1) + clamp(0,var(--_level) - 3,1) + 2*clamp(0,var(--_level) - 4,1))) calc(1px*(2*clamp(0,var(--_level),1) + clamp(0,var(--_level) - 2,1) + clamp(0,var(--_level) - 4,1))) 0px var(--_shadow-color);opacity:.3}.shadow::after{box-shadow:0px calc(1px*(clamp(0,var(--_level),1) + clamp(0,var(--_level) - 1,1) + 2*clamp(0,var(--_level) - 2,3))) calc(1px*(3*clamp(0,var(--_level),2) + 2*clamp(0,var(--_level) - 2,3))) calc(1px*(clamp(0,var(--_level),4) + 2*clamp(0,var(--_level) - 4,1))) var(--_shadow-color);opacity:.15}/*# sourceMappingURL=elevation-styles.css.map */
`;


let $f71f2b5af32b0fc5$export$4ff057366f07c9c6 = class MdElevation extends (0, $d09a6760ddf01b3f$export$58bfb4f6ec5aa58d) {
};
$f71f2b5af32b0fc5$export$4ff057366f07c9c6.styles = [
    (0, $0e15e1acb528e7d8$export$9dd6ff9ea0189349)
];
$f71f2b5af32b0fc5$export$4ff057366f07c9c6 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-elevation")
], $f71f2b5af32b0fc5$export$4ff057366f07c9c6);








/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Activates the first non-disabled item of a given array of items.
 *
 * @param items {Array<ListItem>} The items from which to activate the
 *     first item.
 * @param isActivatable Function to determine if an item can be  activated.
 *     Defaults to non-disabled items.
 */ function $41813816dad5514e$export$5bc05a849430cdf4(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    // NOTE: These selector functions are static and not on the instance such
    // that multiple operations can be chained and we do not have to re-query
    // the DOM
    const firstItem = $41813816dad5514e$export$58eb32408bbaf737(items, isActivatable);
    if (firstItem) {
        firstItem.tabIndex = 0;
        firstItem.focus();
    }
    return firstItem;
}
function $41813816dad5514e$export$dd2063227d8e2bfc(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    const lastItem = $41813816dad5514e$export$1a51146bbde9eca2(items, isActivatable);
    if (lastItem) {
        lastItem.tabIndex = 0;
        lastItem.focus();
    }
    return lastItem;
}
function $41813816dad5514e$export$9539e0952ea62f58(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    const activeItem = $41813816dad5514e$export$f0f14253205ef68f(items, isActivatable);
    if (activeItem) activeItem.item.tabIndex = -1;
    return activeItem;
}
function $41813816dad5514e$export$f0f14253205ef68f(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (item.tabIndex === 0 && isActivatable(item)) return {
            item: item,
            index: i
        };
    }
    return null;
}
function $41813816dad5514e$export$58eb32408bbaf737(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    for (const item of items){
        if (isActivatable(item)) return item;
    }
    return null;
}
function $41813816dad5514e$export$1a51146bbde9eca2(items, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    for(let i = items.length - 1; i >= 0; i--){
        const item = items[i];
        if (isActivatable(item)) return item;
    }
    return null;
}
function $41813816dad5514e$export$ecba5da5485e4ec5(items, index, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    for(let i = 1; i < items.length; i++){
        const nextIndex = (i + index) % items.length;
        const item = items[nextIndex];
        if (isActivatable(item)) return item;
    }
    return items[index] ? items[index] : null;
}
function $41813816dad5514e$export$a971dda06d2756f3(items, index, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    for(let i = 1; i < items.length; i++){
        const prevIndex = (index - i + items.length) % items.length;
        const item = items[prevIndex];
        if (isActivatable(item)) return item;
    }
    return items[index] ? items[index] : null;
}
function $41813816dad5514e$export$1c573b5641eb2b20(items, activeItemRecord, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    if (activeItemRecord) {
        const next = $41813816dad5514e$export$ecba5da5485e4ec5(items, activeItemRecord.index, isActivatable);
        if (next) {
            next.tabIndex = 0;
            next.focus();
        }
        return next;
    } else return $41813816dad5514e$export$5bc05a849430cdf4(items, isActivatable);
}
function $41813816dad5514e$export$862337c06aae3f64(items, activeItemRecord, isActivatable = $41813816dad5514e$var$isItemNotDisabled) {
    if (activeItemRecord) {
        const prev = $41813816dad5514e$export$a971dda06d2756f3(items, activeItemRecord.index, isActivatable);
        if (prev) {
            prev.tabIndex = 0;
            prev.focus();
        }
        return prev;
    } else return $41813816dad5514e$export$dd2063227d8e2bfc(items, isActivatable);
}
function $41813816dad5514e$export$1995e8a07f0718a8() {
    return new Event("deactivate-items", {
        bubbles: true,
        composed: true
    });
}
function $41813816dad5514e$export$ef2fd5e7b482ae5d() {
    return new Event("request-activation", {
        bubbles: true,
        composed: true
    });
}
/**
 * The default `isActivatable` function, which checks if an item is not
 * disabled.
 *
 * @param item The item to check.
 * @return true if `item.disabled` is `false.
 */ function $41813816dad5514e$var$isItemNotDisabled(item) {
    return !item.disabled;
}


const $8b797e238ab43300$export$71075aa407ffb4a1 = {
    ArrowDown: "ArrowDown",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowRight: "ArrowRight",
    Home: "Home",
    End: "End"
};
class $8b797e238ab43300$export$201a9369da1d21c5 {
    constructor(config){
        /**
         * Handles keyboard navigation. Should be bound to the node that will act as
         * the List.
         */ this.handleKeydown = (event)=>{
            const key = event.key;
            if (event.defaultPrevented || !this.isNavigableKey(key)) return;
            // do not use this.items directly in upcoming calculations so we don't
            // re-query the DOM unnecessarily
            const items = this.items;
            if (!items.length) return;
            const activeItemRecord = (0, $41813816dad5514e$export$f0f14253205ef68f)(items, this.isActivatable);
            if (activeItemRecord) activeItemRecord.item.tabIndex = -1;
            event.preventDefault();
            const isRtl = this.isRtl();
            const inlinePrevious = isRtl ? $8b797e238ab43300$export$71075aa407ffb4a1.ArrowRight : $8b797e238ab43300$export$71075aa407ffb4a1.ArrowLeft;
            const inlineNext = isRtl ? $8b797e238ab43300$export$71075aa407ffb4a1.ArrowLeft : $8b797e238ab43300$export$71075aa407ffb4a1.ArrowRight;
            switch(key){
                // Activate the next item
                case $8b797e238ab43300$export$71075aa407ffb4a1.ArrowDown:
                case inlineNext:
                    (0, $41813816dad5514e$export$1c573b5641eb2b20)(items, activeItemRecord, this.isActivatable);
                    break;
                // Activate the previous item
                case $8b797e238ab43300$export$71075aa407ffb4a1.ArrowUp:
                case inlinePrevious:
                    (0, $41813816dad5514e$export$862337c06aae3f64)(items, activeItemRecord, this.isActivatable);
                    break;
                // Activate the first item
                case $8b797e238ab43300$export$71075aa407ffb4a1.Home:
                    (0, $41813816dad5514e$export$5bc05a849430cdf4)(items, this.isActivatable);
                    break;
                // Activate the last item
                case $8b797e238ab43300$export$71075aa407ffb4a1.End:
                    (0, $41813816dad5514e$export$dd2063227d8e2bfc)(items, this.isActivatable);
                    break;
                default:
                    break;
            }
        };
        /**
         * Listener to be bound to the `deactivate-items` item event.
         */ this.onDeactivateItems = ()=>{
            const items = this.items;
            for (const item of items)this.deactivateItem(item);
        };
        /**
         * Listener to be bound to the `request-activation` item event..
         */ this.onRequestActivation = (event)=>{
            this.onDeactivateItems();
            const target = event.target;
            this.activateItem(target);
            target.focus();
        };
        /**
         * Listener to be bound to the `slotchange` event for the slot that renders
         * the items.
         */ this.onSlotchange = ()=>{
            const items = this.items;
            // Whether we have encountered an item that has been activated
            let encounteredActivated = false;
            for (const item of items){
                const isActivated = !item.disabled && item.tabIndex > -1;
                if (isActivated && !encounteredActivated) {
                    encounteredActivated = true;
                    item.tabIndex = 0;
                    continue;
                }
                // Deactivate the rest including disabled
                item.tabIndex = -1;
            }
            if (encounteredActivated) return;
            const firstActivatableItem = (0, $41813816dad5514e$export$58eb32408bbaf737)(items, this.isActivatable);
            if (!firstActivatableItem) return;
            firstActivatableItem.tabIndex = 0;
        };
        const { isItem: isItem, getPossibleItems: getPossibleItems, isRtl: isRtl, deactivateItem: deactivateItem, activateItem: activateItem, isNavigableKey: isNavigableKey, isActivatable: isActivatable } = config;
        this.isItem = isItem;
        this.getPossibleItems = getPossibleItems;
        this.isRtl = isRtl;
        this.deactivateItem = deactivateItem;
        this.activateItem = activateItem;
        this.isNavigableKey = isNavigableKey;
        this.isActivatable = isActivatable;
    }
    /**
     * The items being managed by the list. Additionally, attempts to see if the
     * object has a sub-item in the `.item` property.
     */ get items() {
        const maybeItems = this.getPossibleItems();
        const items = [];
        for (const itemOrParent of maybeItems){
            const isItem = this.isItem(itemOrParent);
            // if the item is a list item, add it to the list of items
            if (isItem) {
                items.push(itemOrParent);
                continue;
            }
            // If the item exposes an `item` property check if it is a list item.
            const subItem = itemOrParent.item;
            if (subItem && this.isItem(subItem)) items.push(subItem);
        }
        return items;
    }
    /**
     * Activates the next item in the list. If at the end of the list, the first
     * item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */ activateNextItem() {
        const items = this.items;
        const activeItemRecord = (0, $41813816dad5514e$export$f0f14253205ef68f)(items, this.isActivatable);
        if (activeItemRecord) activeItemRecord.item.tabIndex = -1;
        return (0, $41813816dad5514e$export$1c573b5641eb2b20)(items, activeItemRecord, this.isActivatable);
    }
    /**
     * Activates the previous item in the list. If at the start of the list, the
     * last item will be activated.
     *
     * @return The activated list item or `null` if there are no items.
     */ activatePreviousItem() {
        const items = this.items;
        const activeItemRecord = (0, $41813816dad5514e$export$f0f14253205ef68f)(items, this.isActivatable);
        if (activeItemRecord) activeItemRecord.item.tabIndex = -1;
        return (0, $41813816dad5514e$export$862337c06aae3f64)(items, activeItemRecord, this.isActivatable);
    }
}



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Creates an event that closes any parent menus.
 */ function $d0f19546418686ff$export$87d50bccf3b316f3(initiator, reason) {
    return new CustomEvent("close-menu", {
        bubbles: true,
        composed: true,
        detail: {
            initiator: initiator,
            reason: reason,
            itemPath: [
                initiator
            ]
        }
    });
}
function $d0f19546418686ff$export$3b5ef1b373a92bc5() {
    return new Event("stay-open-on-focusout", {
        bubbles: true,
        composed: true
    });
}
function $d0f19546418686ff$export$93fe1df5e5f56eaf() {
    return new Event("close-on-focusout", {
        bubbles: true,
        composed: true
    });
}
const $d0f19546418686ff$export$64a1f6bff471c972 = $d0f19546418686ff$export$87d50bccf3b316f3;
function $d0f19546418686ff$export$6de1c4857a4429a0() {
    return new Event("deactivate-typeahead", {
        bubbles: true,
        composed: true
    });
}
function $d0f19546418686ff$export$8d9e50371776d27f() {
    return new Event("activate-typeahead", {
        bubbles: true,
        composed: true
    });
}
const $d0f19546418686ff$export$a4364c6994b8f593 = {
    UP: "ArrowUp",
    DOWN: "ArrowDown",
    RIGHT: "ArrowRight",
    LEFT: "ArrowLeft"
};
const $d0f19546418686ff$export$1d0c6fd7ca008f5b = {
    SPACE: "Space",
    ENTER: "Enter"
};
const $d0f19546418686ff$export$8fd8df51a9b835e6 = {
    CLICK_SELECTION: "click-selection",
    KEYDOWN: "keydown"
};
const $d0f19546418686ff$export$f491e56242d44032 = {
    ESCAPE: "Escape",
    SPACE: $d0f19546418686ff$export$1d0c6fd7ca008f5b.SPACE,
    ENTER: $d0f19546418686ff$export$1d0c6fd7ca008f5b.ENTER
};
function $d0f19546418686ff$export$40a976dcaba41fe1(code) {
    return Object.values($d0f19546418686ff$export$f491e56242d44032).some((value)=>value === code);
}
function $d0f19546418686ff$export$d75ca3510c3a838b(code) {
    return Object.values($d0f19546418686ff$export$1d0c6fd7ca008f5b).some((value)=>value === code);
}
function $d0f19546418686ff$export$1353780e346ae2e(target, container) {
    // Dispatch a composed, bubbling event to check its path to see if the
    // newly-focused element is contained in container's subtree
    const focusEv = new Event("md-contains", {
        bubbles: true,
        composed: true
    });
    let composedPath = [];
    const listener = (ev)=>{
        composedPath = ev.composedPath();
    };
    container.addEventListener("md-contains", listener);
    target.dispatchEvent(focusEv);
    container.removeEventListener("md-contains", listener);
    const isContained = composedPath.length > 0;
    return isContained;
}
const $d0f19546418686ff$export$867fb3ce62c0391d = {
    NONE: "none",
    LIST_ROOT: "list-root",
    FIRST_ITEM: "first-item",
    LAST_ITEM: "last-item"
};


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * An enum of supported Menu corners
 */ // tslint:disable-next-line:enforce-name-casing We are mimicking enum style
const $b75158ca57cc5df0$export$ac61190d9fc311a9 = {
    END_START: "end-start",
    END_END: "end-end",
    START_START: "start-start",
    START_END: "start-end"
};
class $b75158ca57cc5df0$export$cf618d61ab331abd {
    /**
     * @param host The host to connect the controller to.
     * @param getProperties A function that returns the properties for the
     * controller.
     */ constructor(host, getProperties){
        this.host = host;
        this.getProperties = getProperties;
        // The current styles to apply to the surface.
        this.surfaceStylesInternal = {
            "display": "none"
        };
        // Previous values stored for change detection. Open change detection is
        // calculated separately so initialize it here.
        this.lastValues = {
            isOpen: false
        };
        this.host.addController(this);
    }
    /**
     * The StyleInfo map to apply to the surface via Lit's stylemap
     */ get surfaceStyles() {
        return this.surfaceStylesInternal;
    }
    /**
     * Calculates the surface's new position required so that the surface's
     * `surfaceCorner` aligns to the anchor's `anchorCorner` while keeping the
     * surface inside the window viewport. This positioning also respects RTL by
     * checking `getComputedStyle()` on the surface element.
     */ async position() {
        const { surfaceEl: surfaceEl, anchorEl: anchorEl, anchorCorner: anchorCornerRaw, surfaceCorner: surfaceCornerRaw, positioning: positioning, xOffset: xOffset, yOffset: yOffset, repositionStrategy: repositionStrategy } = this.getProperties();
        const anchorCorner = anchorCornerRaw.toLowerCase().trim();
        const surfaceCorner = surfaceCornerRaw.toLowerCase().trim();
        if (!surfaceEl || !anchorEl) return;
        // Paint the surface transparently so that we can get the position and the
        // rect info of the surface.
        this.surfaceStylesInternal = {
            "display": "block",
            "opacity": "0"
        };
        // Wait for it to be visible.
        this.host.requestUpdate();
        await this.host.updateComplete;
        const surfaceRect = surfaceEl.getSurfacePositionClientRect ? surfaceEl.getSurfacePositionClientRect() : surfaceEl.getBoundingClientRect();
        const anchorRect = anchorEl.getSurfacePositionClientRect ? anchorEl.getSurfacePositionClientRect() : anchorEl.getBoundingClientRect();
        const [surfaceBlock, surfaceInline] = surfaceCorner.split("-");
        const [anchorBlock, anchorInline] = anchorCorner.split("-");
        // LTR depends on the direction of the SURFACE not the anchor.
        const isLTR = getComputedStyle(surfaceEl).direction === "ltr";
        /*
         * A diagram that helps describe some of the variables used in the following
         * calculations.
         *
         * ┌───── inline/blockTopLayerOffset
         * │       │
         * │     ┌─▼───┐                  Window
         * │    ┌┼─────┴────────────────────────┐
         * │    ││                              │
         * └──► ││  ┌──inline/blockAnchorOffset │
         *      ││  │     │                     │
         *      └┤  │  ┌──▼───┐                 │
         *       │  │ ┌┼──────┤                 │
         *       │  └─►│Anchor│                 │
         *       │    └┴──────┘                 │
         *       │                              │
         *       │     ┌────────────────────────┼────┐
         *       │     │ Surface                │    │
         *       │     │                        │    │
         *       │     │                        │    │
         *       │     │                        │    │
         *       │     │                        │    │
         *       │     │                        │    │
         *       └─────┼────────────────────────┘    ├┐
         *             │ inline/blockOOBCorrection   ││
         *             │                         │   ││
         *             │                         ├──►││
         *             │                         │   ││
         *             └────────────────────────┐▼───┼┘
         *                                      └────┘
         */ // Calculate the block positioning properties
        let { blockInset: blockInset, blockOutOfBoundsCorrection: blockOutOfBoundsCorrection, surfaceBlockProperty: surfaceBlockProperty } = this.calculateBlock({
            surfaceRect: surfaceRect,
            anchorRect: anchorRect,
            anchorBlock: anchorBlock,
            surfaceBlock: surfaceBlock,
            yOffset: yOffset,
            positioning: positioning
        });
        // If the surface should be out of bounds in the block direction, flip the
        // surface and anchor corner block values and recalculate
        if (blockOutOfBoundsCorrection) {
            const flippedSurfaceBlock = surfaceBlock === "start" ? "end" : "start";
            const flippedAnchorBlock = anchorBlock === "start" ? "end" : "start";
            const flippedBlock = this.calculateBlock({
                surfaceRect: surfaceRect,
                anchorRect: anchorRect,
                anchorBlock: flippedAnchorBlock,
                surfaceBlock: flippedSurfaceBlock,
                yOffset: yOffset,
                positioning: positioning
            });
            // In the case that the flipped verion would require less out of bounds
            // correcting, use the flipped corner block values
            if (blockOutOfBoundsCorrection > flippedBlock.blockOutOfBoundsCorrection) {
                blockInset = flippedBlock.blockInset;
                blockOutOfBoundsCorrection = flippedBlock.blockOutOfBoundsCorrection;
                surfaceBlockProperty = flippedBlock.surfaceBlockProperty;
            }
        }
        // Calculate the inline positioning properties
        let { inlineInset: inlineInset, inlineOutOfBoundsCorrection: inlineOutOfBoundsCorrection, surfaceInlineProperty: surfaceInlineProperty } = this.calculateInline({
            surfaceRect: surfaceRect,
            anchorRect: anchorRect,
            anchorInline: anchorInline,
            surfaceInline: surfaceInline,
            xOffset: xOffset,
            positioning: positioning,
            isLTR: isLTR
        });
        // If the surface should be out of bounds in the inline direction, flip the
        // surface and anchor corner inline values and recalculate
        if (inlineOutOfBoundsCorrection) {
            const flippedSurfaceInline = surfaceInline === "start" ? "end" : "start";
            const flippedAnchorInline = anchorInline === "start" ? "end" : "start";
            const flippedInline = this.calculateInline({
                surfaceRect: surfaceRect,
                anchorRect: anchorRect,
                anchorInline: flippedAnchorInline,
                surfaceInline: flippedSurfaceInline,
                xOffset: xOffset,
                positioning: positioning,
                isLTR: isLTR
            });
            // In the case that the flipped verion would require less out of bounds
            // correcting, use the flipped corner inline values
            if (Math.abs(inlineOutOfBoundsCorrection) > Math.abs(flippedInline.inlineOutOfBoundsCorrection)) {
                inlineInset = flippedInline.inlineInset;
                inlineOutOfBoundsCorrection = flippedInline.inlineOutOfBoundsCorrection;
                surfaceInlineProperty = flippedInline.surfaceInlineProperty;
            }
        }
        // If we are simply repositioning the surface back inside the viewport,
        // subtract the out of bounds correction values from the positioning.
        if (repositionStrategy === "move") {
            blockInset = blockInset - blockOutOfBoundsCorrection;
            inlineInset = inlineInset - inlineOutOfBoundsCorrection;
        }
        this.surfaceStylesInternal = {
            "display": "block",
            "opacity": "1",
            [surfaceBlockProperty]: `${blockInset}px`,
            [surfaceInlineProperty]: `${inlineInset}px`
        };
        // In the case that we are resizing the surface to stay inside the viewport
        // we need to set height and width on the surface.
        if (repositionStrategy === "resize") {
            // Add a height property to the styles if there is block height correction
            if (blockOutOfBoundsCorrection) this.surfaceStylesInternal["height"] = `${surfaceRect.height - blockOutOfBoundsCorrection}px`;
            // Add a width property to the styles if there is block height correction
            if (inlineOutOfBoundsCorrection) this.surfaceStylesInternal["width"] = `${surfaceRect.width - inlineOutOfBoundsCorrection}px`;
        }
        this.host.requestUpdate();
    }
    /**
     * Calculates the css property, the inset, and the out of bounds correction
     * for the surface in the block direction.
     */ calculateBlock(config) {
        const { surfaceRect: surfaceRect, anchorRect: anchorRect, anchorBlock: anchorBlock, surfaceBlock: surfaceBlock, yOffset: yOffset, positioning: positioning } = config;
        // We use number booleans to multiply values rather than `if` / ternary
        // statements because it _heavily_ cuts down on nesting and readability
        const relativeToWindow = positioning === "fixed" ? 1 : 0;
        const isSurfaceBlockStart = surfaceBlock === "start" ? 1 : 0;
        const isSurfaceBlockEnd = surfaceBlock === "end" ? 1 : 0;
        const isOneBlockEnd = anchorBlock !== surfaceBlock ? 1 : 0;
        // Whether or not to apply the height of the anchor
        const blockAnchorOffset = isOneBlockEnd * anchorRect.height + yOffset;
        // The absolute block position of the anchor relative to window
        const blockTopLayerOffset = isSurfaceBlockStart * anchorRect.top + isSurfaceBlockEnd * (window.innerHeight - anchorRect.bottom);
        // If the surface's block would be out of bounds of the window, move it back
        // in
        const blockOutOfBoundsCorrection = Math.abs(Math.min(0, window.innerHeight - blockTopLayerOffset - blockAnchorOffset - surfaceRect.height));
        // The block logical value of the surface
        const blockInset = relativeToWindow * blockTopLayerOffset + blockAnchorOffset;
        const surfaceBlockProperty = surfaceBlock === "start" ? "inset-block-start" : "inset-block-end";
        return {
            blockInset: blockInset,
            blockOutOfBoundsCorrection: blockOutOfBoundsCorrection,
            surfaceBlockProperty: surfaceBlockProperty
        };
    }
    /**
     * Calculates the css property, the inset, and the out of bounds correction
     * for the surface in the inline direction.
     */ calculateInline(config) {
        const { isLTR: isLTRBool, surfaceInline: surfaceInline, anchorInline: anchorInline, anchorRect: anchorRect, surfaceRect: surfaceRect, xOffset: xOffset, positioning: positioning } = config;
        // We use number booleans to multiply values rather than `if` / ternary
        // statements because it _heavily_ cuts down on nesting and readability
        const relativeToWindow = positioning === "fixed" ? 1 : 0;
        const isLTR = isLTRBool ? 1 : 0;
        const isRTL = isLTRBool ? 0 : 1;
        const isSurfaceInlineStart = surfaceInline === "start" ? 1 : 0;
        const isSurfaceInlineEnd = surfaceInline === "end" ? 1 : 0;
        const isOneInlineEnd = anchorInline !== surfaceInline ? 1 : 0;
        // Whether or not to apply the width of the anchor
        const inlineAnchorOffset = isOneInlineEnd * anchorRect.width + xOffset;
        // The inline position of the anchor relative to window in LTR
        const inlineTopLayerOffsetLTR = isSurfaceInlineStart * anchorRect.left + isSurfaceInlineEnd * (window.innerWidth - anchorRect.right);
        // The inline position of the anchor relative to window in RTL
        const inlineTopLayerOffsetRTL = isSurfaceInlineStart * (window.innerWidth - anchorRect.right) + isSurfaceInlineEnd * anchorRect.left;
        // The inline position of the anchor relative to window
        const inlineTopLayerOffset = isLTR * inlineTopLayerOffsetLTR + isRTL * inlineTopLayerOffsetRTL;
        // If the surface's inline would be out of bounds of the window, move it
        // back in
        const inlineOutOfBoundsCorrection = Math.abs(Math.min(0, window.innerWidth - inlineTopLayerOffset - inlineAnchorOffset - surfaceRect.width));
        // The inline logical value of the surface
        const inlineInset = relativeToWindow * inlineTopLayerOffset + inlineAnchorOffset;
        const surfaceInlineProperty = surfaceInline === "start" ? "inset-inline-start" : "inset-inline-end";
        return {
            inlineInset: inlineInset,
            inlineOutOfBoundsCorrection: inlineOutOfBoundsCorrection,
            surfaceInlineProperty: surfaceInlineProperty
        };
    }
    hostUpdate() {
        this.onUpdate();
    }
    hostUpdated() {
        this.onUpdate();
    }
    /**
     * Checks whether the properties passed into the controller have changed since
     * the last positioning. If so, it will reposition if the surface is open or
     * close it if the surface should close.
     */ async onUpdate() {
        const props = this.getProperties();
        let hasChanged = false;
        for (const [key, value] of Object.entries(props)){
            // tslint:disable-next-line
            hasChanged = hasChanged || value !== this.lastValues[key];
            if (hasChanged) break;
        }
        const openChanged = this.lastValues.isOpen !== props.isOpen;
        const hasAnchor = !!props.anchorEl;
        const hasSurface = !!props.surfaceEl;
        if (hasChanged && hasAnchor && hasSurface) {
            // Only update isOpen, because if it's closed, we do not want to waste
            // time on a useless reposition calculation. So save the other "dirty"
            // values until next time it opens.
            this.lastValues.isOpen = props.isOpen;
            if (props.isOpen) {
                // We are going to do a reposition, so save the prop values for future
                // dirty checking.
                this.lastValues = props;
                await this.position();
                props.onOpen();
            } else if (openChanged) {
                await props.beforeClose();
                this.close();
                props.onClose();
            }
        }
    }
    /**
     * Hides the surface.
     */ close() {
        this.surfaceStylesInternal = {
            "display": "none"
        };
        this.host.requestUpdate();
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Indicies to access the TypeaheadRecord tuple type.
 */ const $b9ba952ae9eaad18$export$98cf6301406f682 = {
    INDEX: 0,
    ITEM: 1,
    TEXT: 2
};
class $b9ba952ae9eaad18$export$240481765d501bad {
    /**
     * @param getProperties A function that returns the options of the typeahead
     * controller:
     *
     * {
     *   getItems: A function that returns an array of menu items to be searched.
     *   typeaheadBufferTime: The maximum time between each keystroke to keep the
     *       current type buffer alive.
     * }
     */ constructor(getProperties){
        this.getProperties = getProperties;
        /**
         * Array of tuples that helps with indexing.
         */ this.typeaheadRecords = [];
        /**
         * Currently-typed text since last buffer timeout
         */ this.typaheadBuffer = "";
        /**
         * The timeout id from the current buffer's setTimeout
         */ this.cancelTypeaheadTimeout = 0;
        /**
         * If we are currently "typing"
         */ this.isTypingAhead = false;
        /**
         * The record of the last active item.
         */ this.lastActiveRecord = null;
        /**
         * Apply this listener to the element that will receive `keydown` events that
         * should trigger this controller.
         *
         * @param event The native browser `KeyboardEvent` from the `keydown` event.
         */ this.onKeydown = (event)=>{
            if (this.isTypingAhead) this.typeahead(event);
            else this.beginTypeahead(event);
        };
        /**
         * Ends the current typeahead and clears the buffer.
         */ this.endTypeahead = ()=>{
            this.isTypingAhead = false;
            this.typaheadBuffer = "";
            this.typeaheadRecords = [];
        };
    }
    get items() {
        return this.getProperties().getItems();
    }
    get active() {
        return this.getProperties().active;
    }
    /**
     * Sets up typingahead
     */ beginTypeahead(event) {
        if (!this.active) return;
        // We don't want to typeahead if the _beginning_ of the typeahead is a menu
        // navigation, or a selection. We will handle "Space" only if it's in the
        // middle of a typeahead
        if (event.code === "Space" || event.code === "Enter" || event.code.startsWith("Arrow") || event.code === "Escape") return;
        this.isTypingAhead = true;
        // Generates the record array data structure which is the index, the element
        // and a normalized header.
        this.typeaheadRecords = this.items.map((el, index)=>[
                index,
                el,
                el.typeaheadText.trim().toLowerCase()
            ]);
        this.lastActiveRecord = this.typeaheadRecords.find((record)=>record[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex === 0) ?? null;
        if (this.lastActiveRecord) this.lastActiveRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex = -1;
        this.typeahead(event);
    }
    /**
     * Performs the typeahead. Based on the normalized items and the current text
     * buffer, finds the _next_ item with matching text and activates it.
     *
     * @example
     *
     * items: Apple, Banana, Olive, Orange, Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Olive
     *
     * @example
     *
     * items: Apple, Banana, Olive (active), Orange, Cucumber
     * buffer: 'o'
     * user types: l
     *
     * activates Olive
     *
     * @example
     *
     * items: Apple, Banana, Olive (active), Orange, Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Orange
     *
     * @example
     *
     * items: Apple, Banana, Olive, Orange (active), Cucumber
     * buffer: ''
     * user types: o
     *
     * activates Olive
     */ typeahead(event) {
        if (event.defaultPrevented) return;
        clearTimeout(this.cancelTypeaheadTimeout);
        // Stop typingahead if one of the navigation or selection keys (except for
        // Space) are pressed
        if (event.code === "Enter" || event.code.startsWith("Arrow") || event.code === "Escape") {
            this.endTypeahead();
            if (this.lastActiveRecord) this.lastActiveRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex = -1;
            return;
        }
        // If Space is pressed, prevent it from selecting and closing the menu
        if (event.code === "Space") event.preventDefault();
        // Start up a new keystroke buffer timeout
        this.cancelTypeaheadTimeout = setTimeout(this.endTypeahead, this.getProperties().typeaheadBufferTime);
        this.typaheadBuffer += event.key.toLowerCase();
        const lastActiveIndex = this.lastActiveRecord ? this.lastActiveRecord[$b9ba952ae9eaad18$export$98cf6301406f682.INDEX] : -1;
        const numRecords = this.typeaheadRecords.length;
        /**
         * Sorting function that will resort the items starting with the given index
         *
         * @example
         *
         * this.typeaheadRecords =
         * 0: [0, <reference>, 'apple']
         * 1: [1, <reference>, 'apricot']
         * 2: [2, <reference>, 'banana']
         * 3: [3, <reference>, 'olive'] <-- lastActiveIndex
         * 4: [4, <reference>, 'orange']
         * 5: [5, <reference>, 'strawberry']
         *
         * this.typeaheadRecords.sort((a,b) => rebaseIndexOnActive(a)
         *                                       - rebaseIndexOnActive(b)) ===
         * 0: [3, <reference>, 'olive'] <-- lastActiveIndex
         * 1: [4, <reference>, 'orange']
         * 2: [5, <reference>, 'strawberry']
         * 3: [0, <reference>, 'apple']
         * 4: [1, <reference>, 'apricot']
         * 5: [2, <reference>, 'banana']
         */ const rebaseIndexOnActive = (record)=>{
            return (record[$b9ba952ae9eaad18$export$98cf6301406f682.INDEX] + numRecords - lastActiveIndex) % numRecords;
        };
        // records filtered and sorted / rebased around the last active index
        const matchingRecords = this.typeaheadRecords.filter((record)=>!record[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].disabled && record[$b9ba952ae9eaad18$export$98cf6301406f682.TEXT].startsWith(this.typaheadBuffer)).sort((a, b)=>rebaseIndexOnActive(a) - rebaseIndexOnActive(b));
        // Just leave if there's nothing that matches. Native select will just
        // choose the first thing that starts with the next letter in the alphabet
        // but that's out of scope and hard to localize
        if (matchingRecords.length === 0) {
            clearTimeout(this.cancelTypeaheadTimeout);
            if (this.lastActiveRecord) this.lastActiveRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex = -1;
            this.endTypeahead();
            return;
        }
        const isNewQuery = this.typaheadBuffer.length === 1;
        let nextRecord;
        // This is likely the case that someone is trying to "tab" through different
        // entries that start with the same letter
        if (this.lastActiveRecord === matchingRecords[0] && isNewQuery) nextRecord = matchingRecords[1] ?? matchingRecords[0];
        else nextRecord = matchingRecords[0];
        if (this.lastActiveRecord) this.lastActiveRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex = -1;
        this.lastActiveRecord = nextRecord;
        nextRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].tabIndex = 0;
        nextRecord[$b9ba952ae9eaad18$export$98cf6301406f682.ITEM].focus();
        return;
    }
}


const $ac4a8a27b612a26f$export$be4bca1903dfdce0 = 200;
const $ac4a8a27b612a26f$var$submenuNavKeys = new Set([
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowDown,
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowUp,
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).Home,
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).End
]);
const $ac4a8a27b612a26f$var$menuNavKeys = new Set([
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowLeft,
    (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowRight,
    ...$ac4a8a27b612a26f$var$submenuNavKeys
]);
/**
 * Gets the currently focused element on the page.
 *
 * @param activeDoc The document or shadowroot from which to start the search.
 *    Defaults to `window.document`
 * @return Returns the currently deeply focused element or `null` if none.
 */ function $ac4a8a27b612a26f$var$getFocusedElement(activeDoc = document) {
    let activeEl = activeDoc.activeElement;
    // Check for activeElement in the case that an element with a shadow root host
    // is currently focused.
    while(activeEl && activeEl?.shadowRoot?.activeElement)activeEl = activeEl.shadowRoot.activeElement;
    return activeEl;
}
class $ac4a8a27b612a26f$export$d9b273488cd8ce6f extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    /**
     * Whether the menu is animating upwards or downwards when opening. This is
     * helpful for calculating some animation calculations.
     */ get openDirection() {
        const menuCornerBlock = this.menuCorner.split("_")[0];
        return menuCornerBlock === "START" ? "DOWN" : "UP";
    }
    /**
     * The element which the menu should align to. If `anchor` is set to a
     * non-empty idref string, then `anchorEl` will resolve to the element with
     * the given id in the same root node. Otherwise, `null`.
     */ get anchorElement() {
        if (this.anchor) return this.getRootNode().querySelector(`#${this.anchor}`);
        return this.currentAnchorElement;
    }
    set anchorElement(element) {
        this.currentAnchorElement = element;
        this.requestUpdate("anchorElement");
    }
    constructor(){
        super();
        /**
         * The ID of the element in the same root node in which the menu should align
         * to. Overrides setting `anchorElement = elementReference`.
         *
         * __NOTE__: anchor or anchorElement must either be an HTMLElement or resolve
         * to an HTMLElement in order for menu to open.
         */ this.anchor = "";
        /**
         * Whether the positioning algorithim should calculate relative to the parent
         * of the anchor element (absolute) or relative to the window (fixed).
         *
         * Examples for `position = 'fixed'`:
         *
         * - If there is no `position:relative` in the given parent tree and the
         *   surface is `position:absolute`
         * - If the surface is `position:fixed`
         * - If the surface is in the "top layer"
         * - The anchor and the surface do not share a common `position:relative`
         *   ancestor
         *
         * When using positioning = fixed, in most cases, the menu should position
         * itself above most other `position:absolute` or `position:fixed` elements
         * when placed inside of them. e.g. using a menu inside of an `md-dialog`.
         *
         * __NOTE__: Fixed menus will not scroll with the page and will be fixed to
         * the window instead.
         */ this.positioning = "absolute";
        /**
         * Skips the opening and closing animations.
         */ this.quick = false;
        /**
         * Displays overflow content like a submenu.
         *
         * __NOTE__: This may cause adverse effects if you set
         * `md-menu {max-height:...}`
         * and have items overflowing items in the "y" direction.
         */ this.hasOverflow = false;
        /**
         * Opens the menu and makes it visible. Alternative to the `.show()` and
         * `.close()` methods
         */ this.open = false;
        /**
         * Offsets the menu's inline alignment from the anchor by the given number in
         * pixels. This value is direction aware and will follow the LTR / RTL
         * direction.
         *
         * e.g. LTR: positive -> right, negative -> left
         *      RTL: positive -> left, negative -> right
         */ this.xOffset = 0;
        /**
         * Offsets the menu's block alignment from the anchor by the given number in
         * pixels.
         *
         * e.g. positive -> down, negative -> up
         */ this.yOffset = 0;
        /**
         * The max time between the keystrokes of the typeahead menu behavior before
         * it clears the typeahead buffer.
         */ this.typeaheadDelay = $ac4a8a27b612a26f$export$be4bca1903dfdce0;
        /**
         * The corner of the anchor which to align the menu in the standard logical
         * property style of <block>-<inline> e.g. `'end-start'`.
         *
         * NOTE: This value may not be respected by the menu positioning algorithm
         * if the menu would render outisde the viewport.
         */ this.anchorCorner = (0, $b75158ca57cc5df0$export$ac61190d9fc311a9).END_START;
        /**
         * The corner of the menu which to align the anchor in the standard logical
         * property style of <block>-<inline> e.g. `'start-start'`.
         *
         * NOTE: This value may not be respected by the menu positioning algorithm
         * if the menu would render outisde the viewport.
         */ this.menuCorner = (0, $b75158ca57cc5df0$export$ac61190d9fc311a9).START_START;
        /**
         * Keeps the user clicks outside the menu.
         *
         * NOTE: clicking outside may still cause focusout to close the menu so see
         * `stayOpenOnFocusout`.
         */ this.stayOpenOnOutsideClick = false;
        /**
         * Keeps the menu open when focus leaves the menu's composed subtree.
         *
         * NOTE: Focusout behavior will stop propagation of the focusout event. Set
         * this property to true to opt-out of menu's focuout handling altogether.
         */ this.stayOpenOnFocusout = false;
        /**
         * After closing, does not restore focus to the last focused element before
         * the menu was opened.
         */ this.skipRestoreFocus = false;
        /**
         * The element that should be focused by default once opened.
         *
         * NOTE: When setting default focus to 'LIST_ROOT', remember to change
         * `tabindex` to `0` and change md-menu's display to something other than
         * `display: contents` when necessary.
         */ this.defaultFocus = (0, $d0f19546418686ff$export$867fb3ce62c0391d).FIRST_ITEM;
        this.typeaheadActive = true;
        /**
         * Whether or not the current menu is a submenu and should not handle specific
         * navigation keys.
         *
         * @exports
         */ this.isSubmenu = false;
        /**
         * The event path of the last window pointerdown event.
         */ this.pointerPath = [];
        this.isPointerDown = false;
        this.openCloseAnimationSignal = (0, $87a41e77ca765bfa$export$d3ca5f3874d77ca7)();
        this.listController = new (0, $8b797e238ab43300$export$201a9369da1d21c5)({
            isItem: (maybeItem)=>{
                return maybeItem.hasAttribute("md-menu-item");
            },
            getPossibleItems: ()=>this.slotItems,
            isRtl: ()=>getComputedStyle(this).direction === "rtl",
            deactivateItem: (item)=>{
                item.selected = false;
                item.tabIndex = -1;
            },
            activateItem: (item)=>{
                item.selected = true;
                item.tabIndex = 0;
            },
            isNavigableKey: (key)=>{
                if (!this.isSubmenu) return $ac4a8a27b612a26f$var$menuNavKeys.has(key);
                const isRtl = getComputedStyle(this).direction === "rtl";
                // we want md-submenu to handle the submenu's left/right arrow exit
                // key so it can close the menu instead of navigate the list.
                // Therefore we need to include all keys but left/right arrow close
                // key
                const arrowOpen = isRtl ? (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowLeft : (0, $8b797e238ab43300$export$71075aa407ffb4a1).ArrowRight;
                if (key === arrowOpen) return true;
                return $ac4a8a27b612a26f$var$submenuNavKeys.has(key);
            }
        });
        /**
         * The element that was focused before the menu opened.
         */ this.lastFocusedElement = null;
        /**
         * Handles typeahead navigation through the menu.
         */ this.typeaheadController = new (0, $b9ba952ae9eaad18$export$240481765d501bad)(()=>{
            return {
                getItems: ()=>this.items,
                typeaheadBufferTime: this.typeaheadDelay,
                active: this.typeaheadActive
            };
        });
        this.currentAnchorElement = null;
        this.internals = (0, $e29022299c408217$export$401bb396a24299b8)(this, this/* needed for closure */ .attachInternals());
        /**
         * Handles positioning the surface and aligning it to the anchor as well as
         * keeping it in the viewport.
         */ this.menuPositionController = new (0, $b75158ca57cc5df0$export$cf618d61ab331abd)(this, ()=>{
            return {
                anchorCorner: this.anchorCorner,
                surfaceCorner: this.menuCorner,
                surfaceEl: this.surfaceEl,
                anchorEl: this.anchorElement,
                positioning: this.positioning,
                isOpen: this.open,
                xOffset: this.xOffset,
                yOffset: this.yOffset,
                onOpen: this.onOpened,
                beforeClose: this.beforeClose,
                onClose: this.onClosed,
                // We can't resize components that have overflow like menus with
                // submenus because the overflow-y will show menu items / content
                // outside the bounds of the menu. (to be fixed w/ popover API)
                repositionStrategy: this.hasOverflow ? "move" : "resize"
            };
        });
        this.handleFocusout = async (event)=>{
            if (this.stayOpenOnFocusout || !this.open) return;
            if (event.relatedTarget) {
                // Don't close the menu if we are switching focus between menu,
                // md-menu-item, and md-list
                if ((0, $d0f19546418686ff$export$1353780e346ae2e)(event.relatedTarget, this)) return;
                const anchorEl = this.anchorElement;
                const wasAnchorClickFocused = (0, $d0f19546418686ff$export$1353780e346ae2e)(event.relatedTarget, anchorEl) && this.isPointerDown;
                if (wasAnchorClickFocused) return;
            } else if (this.isPointerDown && this.pointerPath.includes(this)) // If menu tabindex == -1 and the user clicks on the menu or a divider, we
            // want to keep the menu open.
            return;
            const oldRestoreFocus = this.skipRestoreFocus;
            // allow focus to continue to the next focused object rather than returning
            this.skipRestoreFocus = true;
            this.close();
            // await for close
            await this.updateComplete;
            // return to previous behavior
            this.skipRestoreFocus = oldRestoreFocus;
        };
        /**
         * Saves the last focused element focuses the new element based on
         * `defaultFocus`, and animates open.
         */ this.onOpened = async ()=>{
            this.lastFocusedElement = $ac4a8a27b612a26f$var$getFocusedElement();
            const items = this.items;
            const activeItemRecord = (0, $41813816dad5514e$export$f0f14253205ef68f)(items);
            if (activeItemRecord && this.defaultFocus !== (0, $d0f19546418686ff$export$867fb3ce62c0391d).NONE) activeItemRecord.item.tabIndex = -1;
            let animationAborted = !this.quick;
            if (this.quick) this.dispatchEvent(new Event("opening"));
            else animationAborted = !!await this.animateOpen();
            // This must come after the opening animation or else it may focus one of
            // the items before the animation has begun and causes the list to slide
            // (block-padding-of-the-menu)px at the end of the animation
            switch(this.defaultFocus){
                case (0, $d0f19546418686ff$export$867fb3ce62c0391d).FIRST_ITEM:
                    const first = (0, $41813816dad5514e$export$58eb32408bbaf737)(items);
                    if (first) {
                        first.tabIndex = 0;
                        first.focus();
                        await first.updateComplete;
                    }
                    break;
                case (0, $d0f19546418686ff$export$867fb3ce62c0391d).LAST_ITEM:
                    const last = (0, $41813816dad5514e$export$1a51146bbde9eca2)(items);
                    if (last) {
                        last.tabIndex = 0;
                        last.focus();
                        await last.updateComplete;
                    }
                    break;
                case (0, $d0f19546418686ff$export$867fb3ce62c0391d).LIST_ROOT:
                    this.focus();
                    break;
                default:
                case (0, $d0f19546418686ff$export$867fb3ce62c0391d).NONE:
                    break;
            }
            if (!animationAborted) this.dispatchEvent(new Event("opened"));
        };
        /**
         * Animates closed.
         */ this.beforeClose = async ()=>{
            this.open = false;
            if (!this.skipRestoreFocus) this.lastFocusedElement?.focus?.();
            if (!this.quick) await this.animateClose();
        };
        /**
         * Focuses the last focused element.
         */ this.onClosed = ()=>{
            if (this.quick) {
                this.dispatchEvent(new Event("closing"));
                this.dispatchEvent(new Event("closed"));
            }
        };
        this.onWindowPointerdown = (event)=>{
            this.isPointerDown = true;
            this.pointerPath = event.composedPath();
        };
        this.onWindowPointerup = ()=>{
            this.isPointerDown = false;
        };
        this.onWindowClick = (event)=>{
            if (!this.open) return;
            const path = event.composedPath();
            if (!this.stayOpenOnOutsideClick && !path.includes(this) && !path.includes(this.anchorElement)) this.open = false;
        };
        if (!(0, $650ed036964a13b8$export$6acf61af03e62db)) {
            this.internals.role = "menu";
            this.addEventListener("keydown", this.listController.handleKeydown);
            // Capture so that we can grab the event before it reaches the menu item
            // istelf. Specifically useful for the case where typeahead encounters a
            // space and we don't want the menu item to close the menu.
            this.addEventListener("keydown", this.captureKeydown, {
                capture: true
            });
            this.addEventListener("focusout", this.handleFocusout);
        }
    }
    /**
     * The menu items associated with this menu. The items must be `MenuItem`s and
     * have both the `md-menu-item` and `md-list-item` attributes.
     */ get items() {
        return this.listController.items;
    }
    willUpdate(changed) {
        if (!changed.has("open")) return;
        if (this.open) {
            this.removeAttribute("aria-hidden");
            return;
        }
        this.setAttribute("aria-hidden", "true");
    }
    render() {
        return this.renderSurface();
    }
    /**
     * Renders the positionable surface element and its contents.
     */ renderSurface() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
       <div
          class="menu ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getSurfaceClasses())}"
          style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(this.menuPositionController.surfaceStyles)}>
        ${this.renderElevation()}
        <div class="items">
          <div class="item-padding">
            ${this.renderMenuItems()}
          </div>
        </div>
       </div>
     `;
    }
    /**
     * Renders the menu items' slot
     */ renderMenuItems() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot
        @close-menu=${this.onCloseMenu}
        @deactivate-items=${this.onDeactivateItems}
        @request-activation=${this.onRequestActivation}
        @deactivate-typeahead=${this.handleDeactivateTypeahead}
        @activate-typeahead=${this.handleActivateTypeahead}
        @stay-open-on-focusout=${this.handleStayOpenOnFocusout}
        @close-on-focusout=${this.handleCloseOnFocusout}
        @slotchange=${this.listController.onSlotchange}></slot>`;
    }
    /**
     * Renders the elevation component.
     */ renderElevation() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-elevation part="elevation"></md-elevation>`;
    }
    getSurfaceClasses() {
        return {
            open: this.open,
            fixed: this.positioning === "fixed",
            "has-overflow": this.hasOverflow
        };
    }
    captureKeydown(event) {
        if (event.target === this && !event.defaultPrevented && (0, $d0f19546418686ff$export$40a976dcaba41fe1)(event.code)) {
            event.preventDefault();
            this.close();
        }
        this.typeaheadController.onKeydown(event);
    }
    /**
     * Performs the opening animation:
     *
     * https://direct.googleplex.com/#/spec/295000003+271060003
     *
     * @return A promise that resolve to `true` if the animation was aborted,
     *     `false` if it was not aborted.
     */ async animateOpen() {
        const surfaceEl = this.surfaceEl;
        const slotEl = this.slotEl;
        if (!surfaceEl || !slotEl) return true;
        const openDirection = this.openDirection;
        this.dispatchEvent(new Event("opening"));
        // needs to be imperative because we don't want to mix animation and Lit
        // render timing
        surfaceEl.classList.toggle("animating", true);
        const signal = this.openCloseAnimationSignal.start();
        const height = surfaceEl.offsetHeight;
        const openingUpwards = openDirection === "UP";
        const children = this.items;
        const FULL_DURATION = 500;
        const SURFACE_OPACITY_DURATION = 50;
        const ITEM_OPACITY_DURATION = 250;
        // We want to fit every child fade-in animation within the full duration of
        // the animation.
        const DELAY_BETWEEN_ITEMS = (FULL_DURATION - ITEM_OPACITY_DURATION) / children.length;
        const surfaceHeightAnimation = surfaceEl.animate([
            {
                height: "0px"
            },
            {
                height: `${height}px`
            }
        ], {
            duration: FULL_DURATION,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).EMPHASIZED
        });
        // When we are opening upwards, we want to make sure the last item is always
        // in view, so we need to translate it upwards the opposite direction of the
        // height animation
        const upPositionCorrectionAnimation = slotEl.animate([
            {
                transform: openingUpwards ? `translateY(-${height}px)` : ""
            },
            {
                transform: ""
            }
        ], {
            duration: FULL_DURATION,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).EMPHASIZED
        });
        const surfaceOpacityAnimation = surfaceEl.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], SURFACE_OPACITY_DURATION);
        const childrenAnimations = [];
        for(let i = 0; i < children.length; i++){
            // If we are animating upwards, then reverse the children list.
            const directionalIndex = openingUpwards ? children.length - 1 - i : i;
            const child = children[directionalIndex];
            const animation = child.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: ITEM_OPACITY_DURATION,
                delay: DELAY_BETWEEN_ITEMS * i
            });
            // Make them all initially hidden and then clean up at the end of each
            // animation.
            child.classList.toggle("md-menu-hidden", true);
            animation.addEventListener("finish", ()=>{
                child.classList.toggle("md-menu-hidden", false);
            });
            childrenAnimations.push([
                child,
                animation
            ]);
        }
        let resolveAnimation = (value)=>{};
        const animationFinished = new Promise((resolve)=>{
            resolveAnimation = resolve;
        });
        signal.addEventListener("abort", ()=>{
            surfaceHeightAnimation.cancel();
            upPositionCorrectionAnimation.cancel();
            surfaceOpacityAnimation.cancel();
            childrenAnimations.forEach(([child, animation])=>{
                child.classList.toggle("md-menu-hidden", false);
                animation.cancel();
            });
            resolveAnimation(true);
        });
        surfaceHeightAnimation.addEventListener("finish", ()=>{
            surfaceEl.classList.toggle("animating", false);
            this.openCloseAnimationSignal.finish();
            resolveAnimation(false);
        });
        return await animationFinished;
    }
    /**
     * Performs the closing animation:
     *
     * https://direct.googleplex.com/#/spec/295000003+271060003
     */ animateClose() {
        let resolve;
        let reject;
        // This promise blocks the surface position controller from setting
        // display: none on the surface which will interfere with this animation.
        const animationEnded = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        const surfaceEl = this.surfaceEl;
        const slotEl = this.slotEl;
        if (!surfaceEl || !slotEl) {
            reject();
            return animationEnded;
        }
        const openDirection = this.openDirection;
        const closingDownwards = openDirection === "UP";
        this.dispatchEvent(new Event("closing"));
        // needs to be imperative because we don't want to mix animation and Lit
        // render timing
        surfaceEl.classList.toggle("animating", true);
        const signal = this.openCloseAnimationSignal.start();
        const height = surfaceEl.offsetHeight;
        const children = this.items;
        const FULL_DURATION = 150;
        const SURFACE_OPACITY_DURATION = 50;
        // The surface fades away at the very end
        const SURFACE_OPACITY_DELAY = FULL_DURATION - SURFACE_OPACITY_DURATION;
        const ITEM_OPACITY_DURATION = 50;
        const ITEM_OPACITY_INITIAL_DELAY = 50;
        const END_HEIGHT_PERCENTAGE = .35;
        // We want to fit every child fade-out animation within the full duration of
        // the animation.
        const DELAY_BETWEEN_ITEMS = (FULL_DURATION - ITEM_OPACITY_INITIAL_DELAY - ITEM_OPACITY_DURATION) / children.length;
        // The mock has the animation shrink to 35%
        const surfaceHeightAnimation = surfaceEl.animate([
            {
                height: `${height}px`
            },
            {
                height: `${height * END_HEIGHT_PERCENTAGE}px`
            }
        ], {
            duration: FULL_DURATION,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).EMPHASIZED_ACCELERATE
        });
        // When we are closing downwards, we want to make sure the last item is
        // always in view, so we need to translate it upwards the opposite direction
        // of the height animation
        const downPositionCorrectionAnimation = slotEl.animate([
            {
                transform: ""
            },
            {
                transform: closingDownwards ? `translateY(-${height * (1 - END_HEIGHT_PERCENTAGE)}px)` : ""
            }
        ], {
            duration: FULL_DURATION,
            easing: (0, $87a41e77ca765bfa$export$c74aac628de95ab5).EMPHASIZED_ACCELERATE
        });
        const surfaceOpacityAnimation = surfaceEl.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: SURFACE_OPACITY_DURATION,
            delay: SURFACE_OPACITY_DELAY
        });
        const childrenAnimations = [];
        for(let i = 0; i < children.length; i++){
            // If the animation is closing upwards, then reverse the list of
            // children so that we animate in the opposite direction.
            const directionalIndex = closingDownwards ? i : children.length - 1 - i;
            const child = children[directionalIndex];
            const animation = child.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: ITEM_OPACITY_DURATION,
                delay: ITEM_OPACITY_INITIAL_DELAY + DELAY_BETWEEN_ITEMS * i
            });
            // Make sure the items stay hidden at the end of each child animation.
            // We clean this up at the end of the overall animation.
            animation.addEventListener("finish", ()=>{
                child.classList.toggle("md-menu-hidden", true);
            });
            childrenAnimations.push([
                child,
                animation
            ]);
        }
        signal.addEventListener("abort", ()=>{
            surfaceHeightAnimation.cancel();
            downPositionCorrectionAnimation.cancel();
            surfaceOpacityAnimation.cancel();
            childrenAnimations.forEach(([child, animation])=>{
                animation.cancel();
                child.classList.toggle("md-menu-hidden", false);
            });
            reject();
        });
        surfaceHeightAnimation.addEventListener("finish", ()=>{
            surfaceEl.classList.toggle("animating", false);
            childrenAnimations.forEach(([child])=>{
                child.classList.toggle("md-menu-hidden", false);
            });
            this.openCloseAnimationSignal.finish();
            this.dispatchEvent(new Event("closed"));
            resolve(true);
        });
        return animationEnded;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!(0, $650ed036964a13b8$export$6acf61af03e62db)) {
            window.addEventListener("click", this.onWindowClick, {
                capture: true
            });
            window.addEventListener("pointerdown", this.onWindowPointerdown);
            window.addEventListener("pointerup", this.onWindowPointerup);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (!(0, $650ed036964a13b8$export$6acf61af03e62db)) {
            window.removeEventListener("click", this.onWindowClick, {
                capture: true
            });
            window.removeEventListener("pointerdown", this.onWindowPointerdown);
            window.removeEventListener("pointerup", this.onWindowPointerup);
        }
    }
    onCloseMenu() {
        this.close();
    }
    onDeactivateItems(event) {
        event.stopPropagation();
        this.listController.onDeactivateItems();
    }
    onRequestActivation(event) {
        event.stopPropagation();
        this.listController.onRequestActivation(event);
    }
    handleDeactivateTypeahead(event) {
        // stopPropagation so that this does not deactivate any typeaheads in menus
        // nested above it e.g. md-sub-menu
        event.stopPropagation();
        this.typeaheadActive = false;
    }
    handleActivateTypeahead(event) {
        // stopPropagation so that this does not activate any typeaheads in menus
        // nested above it e.g. md-sub-menu
        event.stopPropagation();
        this.typeaheadActive = true;
    }
    handleStayOpenOnFocusout(event) {
        event.stopPropagation();
        this.stayOpenOnFocusout = true;
    }
    handleCloseOnFocusout(event) {
        event.stopPropagation();
        this.stayOpenOnFocusout = false;
    }
    close() {
        this.open = false;
        const maybeSubmenu = this.slotItems;
        maybeSubmenu.forEach((item)=>{
            item.close?.();
        });
    }
    show() {
        this.open = true;
    }
    /**
     * Activates the next item in the menu. If at the end of the menu, the first
     * item will be activated.
     *
     * @return The activated menu item or `null` if there are no items.
     */ activateNextItem() {
        return this.listController.activateNextItem() ?? null;
    }
    /**
     * Activates the previous item in the menu. If at the start of the menu, the
     * last item will be activated.
     *
     * @return The activated menu item or `null` if there are no items.
     */ activatePreviousItem() {
        return this.listController.activatePreviousItem() ?? null;
    }
}
(()=>{
    // We want to manage tabindex ourselves.
    (0, $e29022299c408217$export$132d69587a22c09)($ac4a8a27b612a26f$export$d9b273488cd8ce6f, {
        focusable: false
    });
})();
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".menu")
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "surfaceEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("slot")
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "slotEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "anchor", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "positioning", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "quick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-overflow"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "hasOverflow", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "x-offset"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "xOffset", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "y-offset"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "yOffset", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "typeahead-delay"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "typeaheadDelay", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "anchor-corner"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "anchorCorner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "menu-corner"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "menuCorner", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "stay-open-on-outside-click"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "stayOpenOnOutsideClick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "stay-open-on-focusout"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "stayOpenOnFocusout", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "skip-restore-focus"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "skipRestoreFocus", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "default-focus"
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "defaultFocus", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        flatten: true
    })
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "slotItems", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $ac4a8a27b612a26f$export$d9b273488cd8ce6f.prototype, "typeaheadActive", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $b262717e1e26c336$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--md-elevation-level: var(--md-menu-container-elevation, 2);--md-elevation-shadow-color: var(--md-menu-container-shadow-color, var(--md-sys-color-shadow, #000));min-width:112px;color:unset;display:contents}md-focus-ring{--md-focus-ring-shape: var(--md-menu-container-shape, 4px)}.menu{border-radius:var(--md-menu-container-shape, 4px);display:none;opacity:0;z-index:20;position:absolute;user-select:none;max-height:inherit;height:inherit;min-width:inherit;max-width:inherit}.fixed{position:fixed}.items{display:block;list-style-type:none;margin:0;outline:none;box-sizing:border-box;background-color:var(--md-menu-container-color, var(--md-sys-color-surface-container, #f3edf7));height:inherit;max-height:inherit;overflow:auto;min-width:inherit;max-width:inherit;border-radius:inherit}.item-padding{padding-block:8px}.has-overflow .items{overflow:visible}.animating .items{overflow:hidden}.has-overflow.animating .items{pointer-events:none}.animating ::slotted(.md-menu-hidden){opacity:0}slot{display:block;height:inherit;max-height:inherit}::slotted(:is(md-divider,[role=separator])){margin:8px 0}/*# sourceMappingURL=menu-styles.css.map */
`;



let $4a6f0850976ec68d$export$1cacc4875fdbad81 = class MdMenu extends (0, $ac4a8a27b612a26f$export$d9b273488cd8ce6f) {
};
$4a6f0850976ec68d$export$1cacc4875fdbad81.styles = [
    (0, $b262717e1e26c336$export$9dd6ff9ea0189349),
    (0, $ccb0b591ce994444$export$9dd6ff9ea0189349)
];
$4a6f0850976ec68d$export$1cacc4875fdbad81 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-menu")
], $4a6f0850976ec68d$export$1cacc4875fdbad81);







/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Re-dispatches an event from the provided element.
 *
 * This function is useful for forwarding non-composed events, such as `change`
 * events.
 *
 * @example
 * class MyInput extends LitElement {
 *   render() {
 *     return html`<input @change=${this.redispatchEvent}>`;
 *   }
 *
 *   protected redispatchEvent(event: Event) {
 *     redispatchEvent(this, event);
 *   }
 * }
 *
 * @param element The element to dispatch the event from.
 * @param event The event to re-dispatch.
 * @return Whether or not the event was dispatched (if cancelable).
 */ function $9051cc2e8fc17c65$export$a43eef78b734067e(element, event) {
    // For bubbling events in SSR light DOM (or composed), stop their propagation
    // and dispatch the copy.
    if (event.bubbles && (!element.shadowRoot || event.composed)) event.stopPropagation();
    const copy = Reflect.construct(event.constructor, [
        event.type,
        event
    ]);
    const dispatched = element.dispatchEvent(copy);
    if (!dispatched) event.preventDefault();
    return dispatched;
}
function $9051cc2e8fc17c65$export$db7569af3a356a43(element) {
    const event = new MouseEvent("click", {
        bubbles: true
    });
    element.dispatchEvent(event);
    return event;
}
function $9051cc2e8fc17c65$export$94f057a5fd2f0b4f(event) {
    // Event must start at the event target.
    if (event.currentTarget !== event.target) return false;
    // Event must not be retargeted from shadowRoot.
    if (event.composedPath()[0] !== event.target) return false;
    // Target must not be disabled; this should only occur for a synthetically
    // dispatched click.
    if (event.target.disabled) return false;
    // This is an activation if the event should not be squelched.
    return !$9051cc2e8fc17c65$var$squelchEvent(event);
}
// TODO(https://bugzilla.mozilla.org/show_bug.cgi?id=1804576)
//  Remove when Firefox bug is addressed.
function $9051cc2e8fc17c65$var$squelchEvent(event) {
    const squelched = $9051cc2e8fc17c65$var$isSquelchingEvents;
    if (squelched) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    $9051cc2e8fc17c65$var$squelchEventsForMicrotask();
    return squelched;
}
// Ignore events for one microtask only.
let $9051cc2e8fc17c65$var$isSquelchingEvents = false;
async function $9051cc2e8fc17c65$var$squelchEventsForMicrotask() {
    $9051cc2e8fc17c65$var$isSquelchingEvents = true;
    // Need to pause for just one microtask.
    // tslint:disable-next-line
    await null;
    $9051cc2e8fc17c65$var$isSquelchingEvents = false;
}






/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Given a list of select options, this function will return an array of
 * SelectOptionRecords that are selected.
 *
 * @return An array of SelectOptionRecords describing the options that are
 * selected.
 */ function $53b899d13550548a$export$d259dc0eeb1b76ed(items) {
    const selectedItemRecords = [];
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (item.selected) selectedItemRecords.push([
            item,
            i
        ]);
    }
    return selectedItemRecords;
}


var $40dd54aa034b33cd$var$_a;
const $40dd54aa034b33cd$var$VALUE = Symbol("value");
class $40dd54aa034b33cd$export$ef9b1a59e592288f extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Opens the menu synchronously with no animation.
         */ this.quick = false;
        /**
         * Whether or not the select is required.
         */ this.required = false;
        /**
         * Disables the select.
         */ this.disabled = false;
        /**
         * The error message that replaces supporting text when `error` is true. If
         * `errorText` is an empty string, then the supporting text will continue to
         * show.
         *
         * This error message overrides the error message displayed by
         * `reportValidity()`.
         */ this.errorText = "";
        /**
         * The floating label for the field.
         */ this.label = "";
        /**
         * Conveys additional information below the select, such as how it should
         * be used.
         */ this.supportingText = "";
        /**
         * Gets or sets whether or not the select is in a visually invalid state.
         *
         * This error state overrides the error state controlled by
         * `reportValidity()`.
         */ this.error = false;
        /**
         * Whether or not the underlying md-menu should be position: fixed to display
         * in a top-level manner, or position: absolute.
         *
         * position:fixed is useful for cases where select is inside of another
         * element with stacking context and hidden overflows such as `md-dialog`.
         */ this.menuPositioning = "absolute";
        /**
         * The max time between the keystrokes of the typeahead select / menu behavior
         * before it clears the typeahead buffer.
         */ this.typeaheadDelay = (0, $ac4a8a27b612a26f$export$be4bca1903dfdce0);
        /**
         * Whether or not the text field has a leading icon. Used for SSR.
         */ this.hasLeadingIcon = false;
        /**
         * Text to display in the field. Only set for SSR.
         */ this.displayText = "";
        this[$40dd54aa034b33cd$var$_a] = "";
        /**
         * Used for initializing select when the user sets the `value` directly.
         */ this.lastUserSetValue = null;
        /**
         * Used for initializing select when the user sets the `selectedIndex`
         * directly.
         */ this.lastUserSetSelectedIndex = null;
        /**
         * Used for `input` and `change` event change detection.
         */ this.lastSelectedOption = null;
        // tslint:disable-next-line:enforce-name-casing
        this.lastSelectedOptionRecords = [];
        /**
         * Whether or not a native error has been reported via `reportValidity()`.
         */ this.nativeError = false;
        /**
         * The validation message displayed from a native error via
         * `reportValidity()`.
         */ this.nativeErrorText = "";
        this.focused = false;
        this.open = false;
        this.customValidationMessage = "";
        this.internals = this/* needed for closure */ .attachInternals();
    }
    /**
     * The value of the currently selected option.
     *
     * Note: For SSR, set `[selected]` on the requested option and `displayText`
     * rather than setting `value` setting `value` will incur a DOM query.
     */ get value() {
        return this[$40dd54aa034b33cd$var$VALUE];
    }
    set value(value) {
        if (0, $650ed036964a13b8$export$6acf61af03e62db) return;
        this.lastUserSetValue = value;
        this.select(value);
    }
    get options() {
        // NOTE: this does a DOM query.
        return this.menu?.items ?? [];
    }
    /**
     * The index of the currently selected option.
     *
     * Note: For SSR, set `[selected]` on the requested option and `displayText`
     * rather than setting `selectedIndex` setting `selectedIndex` will incur a
     * DOM query.
     */ get selectedIndex() {
        // tslint:disable-next-line:enforce-name-casing
        const [_option, index] = (this.getSelectedOptions() ?? [])[0] ?? [];
        return index ?? -1;
    }
    set selectedIndex(index) {
        this.lastUserSetSelectedIndex = index;
        this.selectIndex(index);
    }
    /**
     * Returns an array of selected options.
     *
     * NOTE: md-select only suppoprts single selection.
     */ get selectedOptions() {
        return (this.getSelectedOptions() ?? []).map(([option])=>option);
    }
    /**
     * The HTML name to use in form submission.
     */ get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    /**
     * The associated form element with which this element's value will submit.
     */ get form() {
        return this.internals.form;
    }
    /**
     * The labels this element is associated with.
     */ get labels() {
        return this.internals.labels;
    }
    /**
     * Returns a ValidityState object that represents the validity states of the
     * checkbox.
     *
     * Note that selects will only set `valueMissing` if unselected and
     * `required`.
     */ get validity() {
        this.syncValidity();
        return this.internals.validity;
    }
    /**
     * Returns the native validation error message.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation#constraint_validation_process
     */ get validationMessage() {
        this.syncValidity();
        return this.internals.validationMessage;
    }
    /**
     * Returns whether an element will successfully validate based on forms
     * validation rules and constraints.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation#constraint_validation_process
     */ get willValidate() {
        this.syncValidity();
        return this.internals.willValidate;
    }
    get hasError() {
        return this.error || this.nativeError;
    }
    /**
     * Selects an option given the value of the option, and updates MdSelect's
     * value.
     */ select(value) {
        const optionToSelect = this.options.find((option)=>option.value === value);
        if (optionToSelect) this.selectItem(optionToSelect);
    }
    /**
     * Selects an option given the index of the option, and updates MdSelect's
     * value.
     */ selectIndex(index) {
        const optionToSelect = this.options[index];
        if (optionToSelect) this.selectItem(optionToSelect);
    }
    /**
     * Reset the select to its default value.
     */ reset() {
        for (const option of this.options)option.selected = option.hasAttribute("selected");
        this.updateValueAndDisplayText();
        this.nativeError = false;
        this.nativeErrorText = "";
    }
    /**
     * Checks the select's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/checkValidity
     *
     * @return true if the select is valid, or false if not.
     */ checkValidity() {
        this.syncValidity();
        return this.internals.checkValidity();
    }
    /**
     * Checks the select's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * This method will display or clear an error text message equal to the
     * select's `validationMessage`, unless the invalid event is canceled.
     *
     * Use `setCustomValidity()` to customize the `validationMessage`.
     *
     * This method can also be used to re-announce error messages to screen
     * readers.
     *
     * @return true if the select is valid, or false if not.
     */ reportValidity() {
        let invalidEvent;
        this.addEventListener("invalid", (event)=>{
            invalidEvent = event;
        }, {
            once: true
        });
        const valid = this.checkValidity();
        if (invalidEvent?.defaultPrevented) return valid;
        const prevMessage = this.getErrorText();
        this.nativeError = !valid;
        this.nativeErrorText = this.validationMessage;
        if (prevMessage === this.getErrorText()) this.field?.reannounceError();
        return valid;
    }
    /**
     * Sets the select's native validation error message. This is used to
     * customize `validationMessage`.
     *
     * When the error is not an empty string, the select is considered invalid
     * and `validity.customError` will be true.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/setCustomValidity
     *
     * @param error The error message to display.
     */ setCustomValidity(error) {
        this.customValidationMessage = error;
        this.syncValidity();
    }
    update(changed) {
        // In SSR the options will be ready to query, so try to figure out what
        // the value and display text should be.
        if (!this.hasUpdated) this.initUserSelection();
        super.update(changed);
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span
          class="select ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getRenderClasses())}"
          @focusout=${this.handleFocusout}>
        ${this.renderField()}
        ${this.renderMenu()}
      </span>
    `;
    }
    updated(changed) {
        if (changed.has("required")) this.syncValidity();
    }
    async firstUpdated(changed) {
        await this.menu?.updateComplete;
        // If this has been handled on update already due to SSR, try again.
        if (!this.lastSelectedOptionRecords.length) this.initUserSelection();
        // Case for when the DOM is streaming, there are no children, and a child
        // has [selected] set on it, we need to wait for DOM to render something.
        if (!this.lastSelectedOptionRecords.length && !(0, $650ed036964a13b8$export$6acf61af03e62db) && !this.options.length) setTimeout(()=>{
            this.updateValueAndDisplayText();
        });
        super.firstUpdated(changed);
    }
    getRenderClasses() {
        return {
            "disabled": this.disabled,
            "error": this.error,
            "open": this.open
        };
    }
    renderField() {
        // TODO(b/290078041): add aria-label/describedby
        return (0, $54f4e21f80f6eaaa$export$c0bb0b647f701bb5)`
      <${this.fieldTag}
          aria-haspopup="listbox"
          role="combobox"
          part="field"
          id="field"
          tabindex=${this.disabled ? "-1" : "0"}
          aria-label=${this.ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          aria-describedby="description"
          aria-expanded=${this.open ? "true" : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          aria-controls="listbox"
          class="field"
          label=${this.label}
          .focused=${this.focused || this.open}
          .populated=${!!this.displayText}
          .disabled=${this.disabled}
          .required=${this.required}
          .error=${this.hasError}
          ?has-start=${this.hasLeadingIcon}
          has-end
          supporting-text=${this.supportingText}
          error-text=${this.getErrorText()}
          @keydown=${this.handleKeydown}
          @click=${this.handleClick}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}>
         ${this.renderFieldContent()}
         <div id="description" slot="aria-describedby"></div>
      </${this.fieldTag}>`;
    }
    renderFieldContent() {
        return [
            this.renderLeadingIcon(),
            this.renderLabel(),
            this.renderTrailingIcon()
        ];
    }
    renderLeadingIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="icon leading" slot="start">
         <slot name="leading-icon" @slotchange=${this.handleIconChange}></slot>
      </span>
     `;
    }
    renderTrailingIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <span class="icon trailing" slot="end">
        <slot name="trailing-icon" @slotchange=${this.handleIconChange}>
          <svg height="5" viewBox="7 10 10 5" focusable="false">
            <polygon class="down" stroke="none" fill-rule="evenodd" points="7 10 12 15 17 10"></polygon>
            <polygon class="up" stroke="none" fill-rule="evenodd" points="7 15 12 10 17 15"></polygon>
          </svg>
        </slot>
      </span>
     `;
    }
    renderLabel() {
        // need to render &nbsp; so that line-height can apply and give it a
        // non-zero height
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div id="label">${this.displayText || (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`&nbsp;`}</div>`;
    }
    renderMenu() {
        const ariaLabel = this.label || this.ariaLabel;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <md-menu
          id="listbox"
          default-focus="none"
          role="listbox"
          tabindex="-1"
          aria-label=${ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          stay-open-on-focusout
          part="menu"
          exportparts="focus-ring: menu-focus-ring"
          anchor="field"
          .open=${this.open}
          .quick=${this.quick}
          .positioning=${this.menuPositioning}
          .typeaheadDelay=${this.typeaheadDelay}
          @opening=${this.handleOpening}
          @opened=${this.redispatchEvent}
          @closing=${this.redispatchEvent}
          @closed=${this.handleClosed}
          @close-menu=${this.handleCloseMenu}
          @request-selection=${this.handleRequestSelection}
          @request-deselection=${this.handleRequestDeselection}>
        ${this.renderMenuContent()}
      </md-menu>`;
    }
    renderMenuContent() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    /**
     * Handles opening the select on keydown and typahead selection when the menu
     * is closed.
     */ handleKeydown(event) {
        if (this.open || this.disabled || !this.menu) return;
        const typeaheadController = this.menu.typeaheadController;
        const isOpenKey = event.code === "Space" || event.code === "ArrowDown" || event.code === "Enter";
        // Do not open if currently typing ahead because the user may be typing the
        // spacebar to match a word with a space
        if (!typeaheadController.isTypingAhead && isOpenKey) {
            event.preventDefault();
            this.open = true;
            return;
        }
        const isPrintableKey = event.key.length === 1;
        // Handles typing ahead when the menu is closed by delegating the event to
        // the underlying menu's typeaheadController
        if (isPrintableKey) {
            typeaheadController.onKeydown(event);
            event.preventDefault();
            const { lastActiveRecord: lastActiveRecord } = typeaheadController;
            if (!lastActiveRecord) return;
            this.labelEl?.setAttribute?.("aria-live", "polite");
            const hasChanged = this.selectItem(lastActiveRecord[(0, $b9ba952ae9eaad18$export$98cf6301406f682).ITEM]);
            if (hasChanged) this.dispatchInteractionEvents();
        }
    }
    handleClick() {
        this.open = true;
    }
    handleFocus() {
        this.focused = true;
    }
    handleBlur() {
        this.focused = false;
    }
    /**
     * Handles closing the menu when the focus leaves the select's subtree.
     */ handleFocusout(event) {
        // Don't close the menu if we are switching focus between menu,
        // select-option, and field
        if (event.relatedTarget && (0, $d0f19546418686ff$export$1353780e346ae2e)(event.relatedTarget, this)) return;
        this.open = false;
    }
    /**
     * Gets a list of all selected select options as a list item record array.
     *
     * @return An array of selected list option records.
     */ getSelectedOptions() {
        if (!this.menu) {
            this.lastSelectedOptionRecords = [];
            return null;
        }
        const items = this.menu.items;
        this.lastSelectedOptionRecords = (0, $53b899d13550548a$export$d259dc0eeb1b76ed)(items);
        return this.lastSelectedOptionRecords;
    }
    async getUpdateComplete() {
        await this.menu?.updateComplete;
        return super.getUpdateComplete();
    }
    /**
     * Gets the selected options from the DOM, and updates the value and display
     * text to the first selected option's value and headline respectively.
     *
     * @return Whether or not the selected option has changed since last update.
     */ updateValueAndDisplayText() {
        const selectedOptions = this.getSelectedOptions() ?? [];
        // Used to determine whether or not we need to fire an input / change event
        // which fire whenever the option element changes (value or selectedIndex)
        // on user interaction.
        let hasSelectedOptionChanged = false;
        if (selectedOptions.length) {
            const [firstSelectedOption] = selectedOptions[0];
            hasSelectedOptionChanged = this.lastSelectedOption !== firstSelectedOption;
            this.lastSelectedOption = firstSelectedOption;
            this[$40dd54aa034b33cd$var$VALUE] = firstSelectedOption.value;
            this.displayText = firstSelectedOption.displayText;
        } else {
            hasSelectedOptionChanged = this.lastSelectedOption !== null;
            this.lastSelectedOption = null;
            this[$40dd54aa034b33cd$var$VALUE] = "";
            this.displayText = "";
        }
        this.internals.setFormValue(this.value);
        this.syncValidity();
        return hasSelectedOptionChanged;
    }
    /**
     * Focuses and activates the last selected item upon opening, and resets other
     * active items.
     */ async handleOpening(e) {
        this.labelEl?.removeAttribute?.("aria-live");
        this.redispatchEvent(e);
        const items = this.menu.items;
        const activeItem = (0, $41813816dad5514e$export$f0f14253205ef68f)(items)?.item;
        let [selectedItem] = this.lastSelectedOptionRecords[0] ?? [
            null
        ];
        // This is true if the user keys through the list but clicks out of the menu
        // thus no close-menu event is fired by an item and we can't clean up in
        // handleCloseMenu.
        if (activeItem && activeItem !== selectedItem) activeItem.tabIndex = -1;
        // in the case that nothing is selected, focus the first item
        selectedItem = selectedItem ?? items[0];
        if (selectedItem) {
            selectedItem.tabIndex = 0;
            selectedItem.focus();
        }
    }
    redispatchEvent(e) {
        (0, $9051cc2e8fc17c65$export$a43eef78b734067e)(this, e);
    }
    handleClosed(e) {
        this.open = false;
        this.redispatchEvent(e);
    }
    /**
     * Determines the reason for closing, and updates the UI accordingly.
     */ handleCloseMenu(event) {
        const reason = event.detail.reason;
        const item = event.detail.itemPath[0];
        this.open = false;
        let hasChanged = false;
        if (reason.kind === "click-selection") hasChanged = this.selectItem(item);
        else if (reason.kind === "keydown" && (0, $d0f19546418686ff$export$d75ca3510c3a838b)(reason.key)) hasChanged = this.selectItem(item);
        else {
            // This can happen on ESC being pressed
            item.tabIndex = -1;
            item.blur();
        }
        // Dispatch interaction events since selection has been made via keyboard
        // or mouse.
        if (hasChanged) this.dispatchInteractionEvents();
    }
    /**
     * Selects a given option, deselects other options, and updates the UI.
     *
     * @return Whether the last selected option has changed.
     */ selectItem(item) {
        this.lastSelectedOptionRecords.forEach(([option])=>{
            if (item !== option) option.selected = false;
        });
        item.selected = true;
        return this.updateValueAndDisplayText();
    }
    /**
     * Handles updating selection when an option element requests selection via
     * property / attribute change.
     */ handleRequestSelection(event) {
        const requestingOptionEl = event.target;
        // No-op if this item is already selected.
        if (this.lastSelectedOptionRecords.some(([option])=>option === requestingOptionEl)) return;
        this.selectItem(requestingOptionEl);
    }
    /**
     * Handles updating selection when an option element requests deselection via
     * property / attribute change.
     */ handleRequestDeselection(event) {
        const requestingOptionEl = event.target;
        // No-op if this item is not even in the list of tracked selected items.
        if (!this.lastSelectedOptionRecords.some(([option])=>option === requestingOptionEl)) return;
        this.updateValueAndDisplayText();
    }
    /**
     * Attempts to initialize the selected option from user-settable values like
     * SSR, setting `value`, or `selectedIndex` at startup.
     */ initUserSelection() {
        // User has set `.value` directly, but internals have not yet booted up.
        if (this.lastUserSetValue && !this.lastSelectedOptionRecords.length) this.select(this.lastUserSetValue);
        else if (this.lastUserSetSelectedIndex !== null && !this.lastSelectedOptionRecords.length) this.selectIndex(this.lastUserSetSelectedIndex);
        else this.updateValueAndDisplayText();
    }
    handleIconChange() {
        this.hasLeadingIcon = this.leadingIcons.length > 0;
    }
    /**
     * Dispatches the `input` and `change` events.
     */ dispatchInteractionEvents() {
        this.dispatchEvent(new Event("input", {
            bubbles: true,
            composed: true
        }));
        this.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    getErrorText() {
        return this.error ? this.errorText : this.nativeErrorText;
    }
    syncValidity() {
        const valueMissing = this.required && !this.value;
        const customError = !!this.customValidationMessage;
        const validationMessage = this.customValidationMessage || valueMissing && this.getRequiredValidationMessage() || "";
        this.internals.setValidity({
            valueMissing: valueMissing,
            customError: customError
        }, validationMessage);
    }
    // Returns the platform `<select>` validation message for i18n.
    getRequiredValidationMessage() {
        const select = document.createElement("select");
        select.required = true;
        return select.validationMessage;
    }
    /** @private */ formResetCallback() {
        this.reset();
    }
    /** @private */ formStateRestoreCallback(state) {
        this.value = state;
    }
}
$40dd54aa034b33cd$var$_a = $40dd54aa034b33cd$var$VALUE;
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($40dd54aa034b33cd$export$ef9b1a59e592288f);
})();
/** @nocollapse  */ $40dd54aa034b33cd$export$ef9b1a59e592288f.formAssociated = true;
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "quick", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "error-text"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "errorText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "supporting-text"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "supportingText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "error", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "menu-positioning"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "menuPositioning", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "typeahead-delay"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "typeaheadDelay", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-leading-icon"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "hasLeadingIcon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "display-text"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "displayText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "value", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "selected-index"
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "selectedIndex", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "nativeError", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "nativeErrorText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "focused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".field")
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "field", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("md-menu")
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "menu", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("#label")
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "labelEl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "leading-icon",
        flatten: true
    })
], $40dd54aa034b33cd$export$ef9b1a59e592288f.prototype, "leadingIcons", void 0);


class $687a1bd3fa1468eb$export$f951c75e0f0b4ff5 extends (0, $40dd54aa034b33cd$export$ef9b1a59e592288f) {
    constructor(){
        super(...arguments);
        this.fieldTag = (0, $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0)`md-outlined-field`;
    }
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $7ab0daeefa98471a$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_text-field-container-shape: var(--md-outlined-select-text-field-container-shape, 4px);--_text-field-disabled-input-text-color: var(--md-outlined-select-text-field-disabled-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-input-text-opacity: var(--md-outlined-select-text-field-disabled-input-text-opacity, 0.38);--_text-field-disabled-label-text-color: var(--md-outlined-select-text-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-label-text-opacity: var(--md-outlined-select-text-field-disabled-label-text-opacity, 0.38);--_text-field-disabled-leading-icon-color: var(--md-outlined-select-text-field-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-leading-icon-opacity: var(--md-outlined-select-text-field-disabled-leading-icon-opacity, 0.38);--_text-field-disabled-outline-color: var(--md-outlined-select-text-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-outline-opacity: var(--md-outlined-select-text-field-disabled-outline-opacity, 0.12);--_text-field-disabled-outline-width: var(--md-outlined-select-text-field-disabled-outline-width, 1px);--_text-field-disabled-supporting-text-color: var(--md-outlined-select-text-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-supporting-text-opacity: var(--md-outlined-select-text-field-disabled-supporting-text-opacity, 0.38);--_text-field-disabled-trailing-icon-color: var(--md-outlined-select-text-field-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-disabled-trailing-icon-opacity: var(--md-outlined-select-text-field-disabled-trailing-icon-opacity, 0.38);--_text-field-error-focus-input-text-color: var(--md-outlined-select-text-field-error-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-focus-label-text-color: var(--md-outlined-select-text-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-leading-icon-color: var(--md-outlined-select-text-field-error-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-focus-outline-color: var(--md-outlined-select-text-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-supporting-text-color: var(--md-outlined-select-text-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-focus-trailing-icon-color: var(--md-outlined-select-text-field-error-focus-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_text-field-error-hover-input-text-color: var(--md-outlined-select-text-field-error-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-hover-label-text-color: var(--md-outlined-select-text-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-hover-leading-icon-color: var(--md-outlined-select-text-field-error-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-hover-outline-color: var(--md-outlined-select-text-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-hover-supporting-text-color: var(--md-outlined-select-text-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-hover-trailing-icon-color: var(--md-outlined-select-text-field-error-hover-trailing-icon-color, var(--md-sys-color-on-error-container, #410e0b));--_text-field-error-input-text-color: var(--md-outlined-select-text-field-error-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-error-label-text-color: var(--md-outlined-select-text-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-leading-icon-color: var(--md-outlined-select-text-field-error-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-error-outline-color: var(--md-outlined-select-text-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_text-field-error-supporting-text-color: var(--md-outlined-select-text-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_text-field-error-trailing-icon-color: var(--md-outlined-select-text-field-error-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_text-field-focus-input-text-color: var(--md-outlined-select-text-field-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-focus-label-text-color: var(--md-outlined-select-text-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_text-field-focus-leading-icon-color: var(--md-outlined-select-text-field-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-focus-outline-color: var(--md-outlined-select-text-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_text-field-focus-outline-width: var(--md-outlined-select-text-field-focus-outline-width, 3px);--_text-field-focus-supporting-text-color: var(--md-outlined-select-text-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-focus-trailing-icon-color: var(--md-outlined-select-text-field-focus-trailing-icon-color, var(--md-sys-color-primary, #6750a4));--_text-field-hover-input-text-color: var(--md-outlined-select-text-field-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-label-text-color: var(--md-outlined-select-text-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-leading-icon-color: var(--md-outlined-select-text-field-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-hover-outline-color: var(--md-outlined-select-text-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-hover-outline-width: var(--md-outlined-select-text-field-hover-outline-width, 1px);--_text-field-hover-supporting-text-color: var(--md-outlined-select-text-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-hover-trailing-icon-color: var(--md-outlined-select-text-field-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-input-text-color: var(--md-outlined-select-text-field-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_text-field-input-text-font: var(--md-outlined-select-text-field-input-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-input-text-line-height: var(--md-outlined-select-text-field-input-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_text-field-input-text-size: var(--md-outlined-select-text-field-input-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_text-field-input-text-weight: var(--md-outlined-select-text-field-input-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-label-text-color: var(--md-outlined-select-text-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-label-text-font: var(--md-outlined-select-text-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-label-text-line-height: var(--md-outlined-select-text-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_text-field-label-text-populated-line-height: var(--md-outlined-select-text-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_text-field-label-text-populated-size: var(--md-outlined-select-text-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_text-field-label-text-size: var(--md-outlined-select-text-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_text-field-label-text-weight: var(--md-outlined-select-text-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-leading-icon-color: var(--md-outlined-select-text-field-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-leading-icon-size: var(--md-outlined-select-text-field-leading-icon-size, 24px);--_text-field-outline-color: var(--md-outlined-select-text-field-outline-color, var(--md-sys-color-outline, #79747e));--_text-field-outline-width: var(--md-outlined-select-text-field-outline-width, 1px);--_text-field-supporting-text-color: var(--md-outlined-select-text-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-supporting-text-font: var(--md-outlined-select-text-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_text-field-supporting-text-line-height: var(--md-outlined-select-text-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_text-field-supporting-text-size: var(--md-outlined-select-text-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_text-field-supporting-text-weight: var(--md-outlined-select-text-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_text-field-trailing-icon-color: var(--md-outlined-select-text-field-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_text-field-trailing-icon-size: var(--md-outlined-select-text-field-trailing-icon-size, 24px);--_text-field-container-shape-start-start: var( --md-outlined-select-text-field-container-shape-start-start, var(--_text-field-container-shape) );--_text-field-container-shape-start-end: var( --md-outlined-select-text-field-container-shape-start-end, var(--_text-field-container-shape) );--_text-field-container-shape-end-end: var( --md-outlined-select-text-field-container-shape-end-end, var(--_text-field-container-shape) );--_text-field-container-shape-end-start: var( --md-outlined-select-text-field-container-shape-end-start, var(--_text-field-container-shape) );--md-outlined-field-container-shape-end-end: var(--_text-field-container-shape-end-end);--md-outlined-field-container-shape-end-start: var(--_text-field-container-shape-end-start);--md-outlined-field-container-shape-start-end: var(--_text-field-container-shape-start-end);--md-outlined-field-container-shape-start-start: var(--_text-field-container-shape-start-start);--md-outlined-field-content-color: var(--_text-field-input-text-color);--md-outlined-field-content-font: var(--_text-field-input-text-font);--md-outlined-field-content-line-height: var(--_text-field-input-text-line-height);--md-outlined-field-content-size: var(--_text-field-input-text-size);--md-outlined-field-content-weight: var(--_text-field-input-text-weight);--md-outlined-field-disabled-content-color: var(--_text-field-disabled-input-text-color);--md-outlined-field-disabled-content-opacity: var(--_text-field-disabled-input-text-opacity);--md-outlined-field-disabled-label-text-color: var(--_text-field-disabled-label-text-color);--md-outlined-field-disabled-label-text-opacity: var(--_text-field-disabled-label-text-opacity);--md-outlined-field-disabled-leading-content-color: var(--_text-field-disabled-leading-icon-color);--md-outlined-field-disabled-leading-content-opacity: var(--_text-field-disabled-leading-icon-opacity);--md-outlined-field-disabled-outline-color: var(--_text-field-disabled-outline-color);--md-outlined-field-disabled-outline-opacity: var(--_text-field-disabled-outline-opacity);--md-outlined-field-disabled-outline-width: var(--_text-field-disabled-outline-width);--md-outlined-field-disabled-supporting-text-color: var(--_text-field-disabled-supporting-text-color);--md-outlined-field-disabled-supporting-text-opacity: var(--_text-field-disabled-supporting-text-opacity);--md-outlined-field-disabled-trailing-content-color: var(--_text-field-disabled-trailing-icon-color);--md-outlined-field-disabled-trailing-content-opacity: var(--_text-field-disabled-trailing-icon-opacity);--md-outlined-field-error-content-color: var(--_text-field-error-input-text-color);--md-outlined-field-error-focus-content-color: var(--_text-field-error-focus-input-text-color);--md-outlined-field-error-focus-label-text-color: var(--_text-field-error-focus-label-text-color);--md-outlined-field-error-focus-leading-content-color: var(--_text-field-error-focus-leading-icon-color);--md-outlined-field-error-focus-outline-color: var(--_text-field-error-focus-outline-color);--md-outlined-field-error-focus-supporting-text-color: var(--_text-field-error-focus-supporting-text-color);--md-outlined-field-error-focus-trailing-content-color: var(--_text-field-error-focus-trailing-icon-color);--md-outlined-field-error-hover-content-color: var(--_text-field-error-hover-input-text-color);--md-outlined-field-error-hover-label-text-color: var(--_text-field-error-hover-label-text-color);--md-outlined-field-error-hover-leading-content-color: var(--_text-field-error-hover-leading-icon-color);--md-outlined-field-error-hover-outline-color: var(--_text-field-error-hover-outline-color);--md-outlined-field-error-hover-supporting-text-color: var(--_text-field-error-hover-supporting-text-color);--md-outlined-field-error-hover-trailing-content-color: var(--_text-field-error-hover-trailing-icon-color);--md-outlined-field-error-label-text-color: var(--_text-field-error-label-text-color);--md-outlined-field-error-leading-content-color: var(--_text-field-error-leading-icon-color);--md-outlined-field-error-outline-color: var(--_text-field-error-outline-color);--md-outlined-field-error-supporting-text-color: var(--_text-field-error-supporting-text-color);--md-outlined-field-error-trailing-content-color: var(--_text-field-error-trailing-icon-color);--md-outlined-field-focus-content-color: var(--_text-field-focus-input-text-color);--md-outlined-field-focus-label-text-color: var(--_text-field-focus-label-text-color);--md-outlined-field-focus-leading-content-color: var(--_text-field-focus-leading-icon-color);--md-outlined-field-focus-outline-color: var(--_text-field-focus-outline-color);--md-outlined-field-focus-outline-width: var(--_text-field-focus-outline-width);--md-outlined-field-focus-supporting-text-color: var(--_text-field-focus-supporting-text-color);--md-outlined-field-focus-trailing-content-color: var(--_text-field-focus-trailing-icon-color);--md-outlined-field-hover-content-color: var(--_text-field-hover-input-text-color);--md-outlined-field-hover-label-text-color: var(--_text-field-hover-label-text-color);--md-outlined-field-hover-leading-content-color: var(--_text-field-hover-leading-icon-color);--md-outlined-field-hover-outline-color: var(--_text-field-hover-outline-color);--md-outlined-field-hover-outline-width: var(--_text-field-hover-outline-width);--md-outlined-field-hover-supporting-text-color: var(--_text-field-hover-supporting-text-color);--md-outlined-field-hover-trailing-content-color: var(--_text-field-hover-trailing-icon-color);--md-outlined-field-label-text-color: var(--_text-field-label-text-color);--md-outlined-field-label-text-font: var(--_text-field-label-text-font);--md-outlined-field-label-text-line-height: var(--_text-field-label-text-line-height);--md-outlined-field-label-text-populated-line-height: var(--_text-field-label-text-populated-line-height);--md-outlined-field-label-text-populated-size: var(--_text-field-label-text-populated-size);--md-outlined-field-label-text-size: var(--_text-field-label-text-size);--md-outlined-field-label-text-weight: var(--_text-field-label-text-weight);--md-outlined-field-leading-content-color: var(--_text-field-leading-icon-color);--md-outlined-field-outline-color: var(--_text-field-outline-color);--md-outlined-field-outline-width: var(--_text-field-outline-width);--md-outlined-field-supporting-text-color: var(--_text-field-supporting-text-color);--md-outlined-field-supporting-text-font: var(--_text-field-supporting-text-font);--md-outlined-field-supporting-text-line-height: var(--_text-field-supporting-text-line-height);--md-outlined-field-supporting-text-size: var(--_text-field-supporting-text-size);--md-outlined-field-supporting-text-weight: var(--_text-field-supporting-text-weight);--md-outlined-field-trailing-content-color: var(--_text-field-trailing-icon-color)}[has-start] .icon.leading{font-size:var(--_text-field-leading-icon-size);height:var(--_text-field-leading-icon-size);width:var(--_text-field-leading-icon-size)}.icon.trailing{font-size:var(--_text-field-trailing-icon-size);height:var(--_text-field-trailing-icon-size);width:var(--_text-field-trailing-icon-size)}/*# sourceMappingURL=outlined-select-styles.css.map */
`;


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $066043246a0d3666$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{color:unset;min-width:210px;display:flex}.field{cursor:default;outline:none}.select{position:relative;flex-direction:column}.icon.trailing svg,.icon ::slotted(*){fill:currentColor}.icon ::slotted(*){width:inherit;height:inherit;font-size:inherit}.icon slot{display:flex;height:100%;width:100%;align-items:center;justify-content:center}.icon.trailing :is(.up,.down){opacity:0;transition:opacity 75ms linear 75ms}.select:not(.open) .down,.select.open .up{opacity:1}.field,.select,md-menu{min-width:inherit;width:inherit;max-width:inherit;display:flex}.field,.select{width:100%}:host{display:inline-flex}:host([disabled]){pointer-events:none}/*# sourceMappingURL=shared-styles.css.map */
`;


let $3099e2f7b10d1f56$export$154d8bb04d2d7b9b = class MdOutlinedSelect extends (0, $687a1bd3fa1468eb$export$f951c75e0f0b4ff5) {
};
$3099e2f7b10d1f56$export$154d8bb04d2d7b9b.styles = [
    (0, $066043246a0d3666$export$9dd6ff9ea0189349),
    (0, $7ab0daeefa98471a$export$9dd6ff9ea0189349),
    (0, $654189bfba73b792$export$9dd6ff9ea0189349)
];
$3099e2f7b10d1f56$export$154d8bb04d2d7b9b = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-outlined-select")
], $3099e2f7b10d1f56$export$154d8bb04d2d7b9b);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $38ceadafc121eaa5$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@media(forced-colors: active){:host([disabled]),:host([disabled]) slot{color:GrayText;opacity:1}.list-item{position:relative}.list-item.selected::before{content:"";position:absolute;inset:0;box-sizing:border-box;border-radius:inherit;pointer-events:none;border:3px double CanvasText}}/*# sourceMappingURL=forced-colors-styles.css.map */
`;


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $5085b5bbc6889aed$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{display:flex;--md-ripple-hover-color: var(--md-menu-item-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-hover-opacity: var(--md-menu-item-hover-state-layer-opacity, 0.08);--md-ripple-pressed-color: var(--md-menu-item-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--md-ripple-pressed-opacity: var(--md-menu-item-pressed-state-layer-opacity, 0.12)}:host([disabled]){opacity:var(--md-menu-item-disabled-opacity, 0.3);pointer-events:none}md-focus-ring{z-index:1;--md-focus-ring-shape: 8px}a,button,li{background:none;border:none;padding:0;margin:0;text-align:unset;text-decoration:none}.list-item{border-radius:inherit;display:flex;flex:1;outline:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.list-item:not(.disabled){cursor:pointer}[slot=container]{pointer-events:none}md-ripple{border-radius:inherit}md-item{border-radius:inherit;flex:1;color:var(--md-menu-item-label-text-color, var(--md-sys-color-on-surface, #1d1b20));font-family:var(--md-menu-item-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));line-height:var(--md-menu-item-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));font-weight:var(--md-menu-item-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));min-height:var(--md-menu-item-one-line-container-height, 56px);padding-top:var(--md-menu-item-top-space, 12px);padding-bottom:var(--md-menu-item-bottom-space, 12px);padding-inline-start:var(--md-menu-item-leading-space, 16px);padding-inline-end:var(--md-menu-item-trailing-space, 16px)}md-item[multiline]{min-height:var(--md-menu-item-two-line-container-height, 72px)}[slot=supporting-text]{color:var(--md-menu-item-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-menu-item-supporting-text-font, var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-supporting-text-size, var(--md-sys-typescale-body-medium-size, 0.875rem));line-height:var(--md-menu-item-supporting-text-line-height, var(--md-sys-typescale-body-medium-line-height, 1.25rem));font-weight:var(--md-menu-item-supporting-text-weight, var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400)))}[slot=trailing-supporting-text]{color:var(--md-menu-item-trailing-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));font-family:var(--md-menu-item-trailing-supporting-text-font, var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto)));font-size:var(--md-menu-item-trailing-supporting-text-size, var(--md-sys-typescale-label-small-size, 0.6875rem));line-height:var(--md-menu-item-trailing-supporting-text-line-height, var(--md-sys-typescale-label-small-line-height, 1rem));font-weight:var(--md-menu-item-trailing-supporting-text-weight, var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500)))}:is([slot=start],[slot=end])::slotted(*){fill:currentColor}[slot=start]{color:var(--md-menu-item-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}[slot=end]{color:var(--md-menu-item-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f))}.list-item.selected{background-color:var(--md-menu-item-selected-container-color, var(--md-sys-color-secondary-container, #e8def8))}.selected:not(.disabled) ::slotted(*){color:var(--md-menu-item-selected-label-text-color, var(--md-sys-color-on-secondary-container, #1d192b))}/*# sourceMappingURL=menu-item-styles.css.map */
`;


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


class $896066df760d9067$export$6d08773d2e66f8f2 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Only needed for SSR.
         *
         * Add this attribute when an item has two lines to avoid a Flash Of Unstyled
         * Content. This attribute is not needed for single line items or items with
         * three or more lines.
         */ this.multiline = false;
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <slot name="container"></slot>
      <slot class="non-text" name="start"></slot>
      <div class="text">
        <slot name="overline"
            @slotchange=${this.handleTextSlotChange}></slot>
        <slot class="default-slot"
            @slotchange=${this.handleTextSlotChange}></slot>
        <slot name="headline"
            @slotchange=${this.handleTextSlotChange}></slot>
        <slot name="supporting-text"
            @slotchange=${this.handleTextSlotChange}></slot>
      </div>
      <slot class="non-text" name="trailing-supporting-text"></slot>
      <slot class="non-text" name="end"></slot>
    `;
    }
    handleTextSlotChange() {
        // Check if there's more than one text slot with content. If so, the item is
        // multiline, which has a different min-height than single line items.
        let isMultiline = false;
        let slotsWithContent = 0;
        for (const slot of this.textSlots){
            if ($896066df760d9067$var$slotHasContent(slot)) slotsWithContent += 1;
            if (slotsWithContent > 1) {
                isMultiline = true;
                break;
            }
        }
        this.multiline = isMultiline;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $896066df760d9067$export$6d08773d2e66f8f2.prototype, "multiline", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $24ba95ebfbdcf6b8$export$dcd0d083aa86c355)(".text slot")
], $896066df760d9067$export$6d08773d2e66f8f2.prototype, "textSlots", void 0);
function $896066df760d9067$var$slotHasContent(slot) {
    for (const node of slot.assignedNodes({
        flatten: true
    })){
        // Assume there's content if there's an element slotted in
        const isElement = node.nodeType === Node.ELEMENT_NODE;
        // If there's only text nodes for the default slot, check if there's
        // non-whitespace.
        const isTextWithContent = node.nodeType === Node.TEXT_NODE && node.textContent?.match(/\S/);
        if (isElement || isTextWithContent) return true;
    }
    return false;
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $5ad375687bf075a5$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{color:var(--md-sys-color-on-surface, #1d1b20);font-family:var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-body-large-size, 1rem);font-weight:var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400));line-height:var(--md-sys-typescale-body-large-line-height, 1.5rem);align-items:center;box-sizing:border-box;display:flex;gap:16px;min-height:56px;overflow:hidden;padding:12px 16px;position:relative;text-overflow:ellipsis}:host([multiline]){min-height:72px}[name=overline]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-label-small-size, 0.6875rem);font-weight:var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500));line-height:var(--md-sys-typescale-label-small-line-height, 1rem)}[name=supporting-text]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-body-medium-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-body-medium-size, 0.875rem);font-weight:var(--md-sys-typescale-body-medium-weight, var(--md-ref-typeface-weight-regular, 400));line-height:var(--md-sys-typescale-body-medium-line-height, 1.25rem)}[name=trailing-supporting-text]{color:var(--md-sys-color-on-surface-variant, #49454f);font-family:var(--md-sys-typescale-label-small-font, var(--md-ref-typeface-plain, Roboto));font-size:var(--md-sys-typescale-label-small-size, 0.6875rem);font-weight:var(--md-sys-typescale-label-small-weight, var(--md-ref-typeface-weight-medium, 500));line-height:var(--md-sys-typescale-label-small-line-height, 1rem)}[name=container]::slotted(*){inset:0;position:absolute}.default-slot{display:inline}.default-slot,::slotted(*){overflow:hidden;text-overflow:ellipsis}.text{display:flex;flex:1;flex-direction:column;overflow:hidden}/*# sourceMappingURL=item-styles.css.map */
`;


let $0f86e52a522b596f$export$41bcbf225b053afe = class MdItem extends (0, $896066df760d9067$export$6d08773d2e66f8f2) {
};
$0f86e52a522b596f$export$41bcbf225b053afe.styles = [
    (0, $5ad375687bf075a5$export$9dd6ff9ea0189349)
];
$0f86e52a522b596f$export$41bcbf225b053afe = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-item")
], $0f86e52a522b596f$export$41bcbf225b053afe);






/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $a3916556e3e444fc$export$7d56e9d10982f20d {
    /**
     * @param host The MenuItem in which to attach this controller to.
     * @param config The object that configures this controller's behavior.
     */ constructor(host, config){
        this.host = host;
        this.internalTypeaheadText = null;
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */ this.onClick = ()=>{
            if (this.host.keepOpen) return;
            this.host.dispatchEvent((0, $d0f19546418686ff$export$64a1f6bff471c972)(this.host, {
                kind: (0, $d0f19546418686ff$export$8fd8df51a9b835e6).CLICK_SELECTION
            }));
        };
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */ this.onKeydown = (event)=>{
            if (this.host.keepOpen || event.defaultPrevented) return;
            const keyCode = event.code;
            if (!event.defaultPrevented && (0, $d0f19546418686ff$export$40a976dcaba41fe1)(keyCode)) {
                event.preventDefault();
                this.host.dispatchEvent((0, $d0f19546418686ff$export$64a1f6bff471c972)(this.host, {
                    kind: (0, $d0f19546418686ff$export$8fd8df51a9b835e6).KEYDOWN,
                    key: keyCode
                }));
            }
        };
        const { getHeadlineElements: getHeadlineElements } = config;
        this.getHeadlineElements = getHeadlineElements;
        this.host.addController(this);
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot.
     */ get typeaheadText() {
        if (this.internalTypeaheadText !== null) return this.internalTypeaheadText;
        const headlineElements = this.getHeadlineElements();
        const textParts = [];
        headlineElements.forEach((headlineElement)=>{
            if (headlineElement.textContent && headlineElement.textContent.trim()) textParts.push(headlineElement.textContent.trim());
        });
        return textParts.join(" ");
    }
    /**
     * The recommended tag name to render as the list item.
     */ get tagName() {
        const type = this.host.type;
        switch(type){
            case "link":
                return "a";
            case "button":
                return "button";
            default:
            case "menuitem":
            case "option":
                return "li";
        }
    }
    /**
     * The recommended role of the menu item.
     */ get role() {
        return this.host.type === "option" ? "option" : "menuitem";
    }
    hostConnected() {
        this.host.toggleAttribute("md-menu-item", true);
    }
    hostUpdate() {
        if (this.host.href) this.host.type = "link";
    }
    /**
     * Use to set the typeaheadText when it changes.
     */ setTypeaheadText(text) {
        this.internalTypeaheadText = text;
    }
}


function $78452143995ab257$export$12bd8351dab009f9() {
    return new Event("request-selection", {
        bubbles: true,
        composed: true
    });
}
function $78452143995ab257$export$f8fd85ee345d830() {
    return new Event("request-deselection", {
        bubbles: true,
        composed: true
    });
}
class $78452143995ab257$export$91883953af628448 {
    /**
     * The recommended role of the select option.
     */ get role() {
        return this.menuItemController.role;
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot.
     */ get typeaheadText() {
        return this.menuItemController.typeaheadText;
    }
    setTypeaheadText(text) {
        this.menuItemController.setTypeaheadText(text);
    }
    /**
     * The text that is displayed in the select field when selected. If not set,
     * defaults to the textContent of the item slotted into the `"headline"` slot.
     */ get displayText() {
        if (this.internalDisplayText !== null) return this.internalDisplayText;
        const headlineElements = this.getHeadlineElements();
        const textParts = [];
        headlineElements.forEach((headlineElement)=>{
            if (headlineElement.textContent && headlineElement.textContent.trim()) textParts.push(headlineElement.textContent.trim());
        });
        return textParts.join(" ");
    }
    setDisplayText(text) {
        this.internalDisplayText = text;
    }
    /**
     * @param host The SelectOption in which to attach this controller to.
     * @param config The object that configures this controller's behavior.
     */ constructor(host, config){
        this.host = host;
        this.internalDisplayText = null;
        this.lastSelected = this.host.selected;
        this.firstUpdate = true;
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */ this.onClick = ()=>{
            this.menuItemController.onClick();
        };
        /**
         * Bind this click listener to the interactive element. Handles closing the
         * menu.
         */ this.onKeydown = (e)=>{
            this.menuItemController.onKeydown(e);
        };
        this.menuItemController = new (0, $a3916556e3e444fc$export$7d56e9d10982f20d)(host, config);
        this.getHeadlineElements = config.getHeadlineElements;
        host.addController(this);
    }
    hostUpdate() {
        if (this.lastSelected !== this.host.selected) this.host.ariaSelected = this.host.selected ? "true" : "false";
    }
    hostUpdated() {
        // Do not dispatch event on first update / boot-up.
        if (this.lastSelected !== this.host.selected && !this.firstUpdate) {
            // This section is really useful for when the user sets selected on the
            // option programmatically. Most other cases (click and keyboard) are
            // handled by md-select because it needs to coordinate the
            // single-selection behavior.
            if (this.host.selected) this.host.dispatchEvent($78452143995ab257$export$12bd8351dab009f9());
            else this.host.dispatchEvent($78452143995ab257$export$f8fd85ee345d830());
        }
        this.lastSelected = this.host.selected;
        this.firstUpdate = false;
    }
}


class $bf26b926efc284e3$export$f5fce6ea33ac0aee extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Disables the item and makes it non-selectable and non-interactive.
         */ this.disabled = false;
        /**
         * READONLY: self-identifies as a menu item and sets its identifying attribute
         */ this.isMenuItem = true;
        /**
         * Sets the item in the selected visual state when a submenu is opened.
         */ this.selected = false;
        /**
         * Form value of the option.
         */ this.value = "";
        this.type = "option";
        this.selectOptionController = new (0, $78452143995ab257$export$91883953af628448)(this, {
            getHeadlineElements: ()=>{
                return this.headlineElements;
            }
        });
    }
    /**
     * The text that is selectable via typeahead. If not set, defaults to the
     * innerText of the item slotted into the `"headline"` slot.
     */ get typeaheadText() {
        return this.selectOptionController.typeaheadText;
    }
    set typeaheadText(text) {
        this.selectOptionController.setTypeaheadText(text);
    }
    /**
     * The text that is displayed in the select field when selected. If not set,
     * defaults to the textContent of the item slotted into the `"headline"` slot.
     */ get displayText() {
        return this.selectOptionController.displayText;
    }
    set displayText(text) {
        this.selectOptionController.setDisplayText(text);
    }
    render() {
        return this.renderListItem((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <md-item>
        <div slot="container">
          ${this.renderRipple()}
          ${this.renderFocusRing()}
        </div>
        <slot name="start" slot="start"></slot>
        <slot name="end" slot="end"></slot>
        ${this.renderBody()}
      </md-item>
    `);
    }
    /**
     * Renders the root list item.
     *
     * @param content the child content of the list item.
     */ renderListItem(content) {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <li
        id="item"
        tabindex=${this.disabled ? -1 : 0}
        role=${this.selectOptionController.role}
        aria-label=${this.ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        aria-selected=${this.ariaSelected || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        aria-checked=${this.ariaChecked || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        aria-expanded=${this.ariaExpanded || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        aria-haspopup=${this.ariaHasPopup || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
        class="list-item ${(0, $0e5c059fc79abe53$export$56cc687933817664)(this.getRenderClasses())}"
        @click=${this.selectOptionController.onClick}
        @keydown=${this.selectOptionController.onKeydown}
      >${content}</li>
    `;
    }
    /**
     * Handles rendering of the ripple element.
     */ renderRipple() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <md-ripple
          part="ripple"
          for="item"
          ?disabled=${this.disabled}></md-ripple>`;
    }
    /**
     * Handles rendering of the focus ring.
     */ renderFocusRing() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <md-focus-ring
          part="focus-ring"
          for="item"
          inward></md-focus-ring>`;
    }
    /**
     * Classes applied to the list item root.
     */ getRenderClasses() {
        return {
            "disabled": this.disabled,
            "selected": this.selected
        };
    }
    /**
     * Handles rendering the headline and supporting text.
     */ renderBody() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <slot></slot>
      <slot name="overline" slot="overline"></slot>
      <slot name="headline" slot="headline"></slot>
      <slot name="supporting-text" slot="supporting-text"></slot>
      <slot name="trailing-supporting-text"
          slot="trailing-supporting-text"></slot>
    `;
    }
    focus() {
        // TODO(b/300334509): needed for some cases where delegatesFocus doesn't
        // work programmatically like in FF and select-option
        this.listItemRoot?.focus();
    }
}
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($bf26b926efc284e3$export$f5fce6ea33ac0aee);
})();
/** @nocollapse */ $bf26b926efc284e3$export$f5fce6ea33ac0aee.shadowRootOptions = {
    ...(0, $fe586ba0757c37f7$export$3f2f9f5909897157).shadowRootOptions,
    delegatesFocus: true
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "md-menu-item",
        reflect: true
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "isMenuItem", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "selected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".list-item")
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "listItemRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "headline"
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "headlineElements", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "typeahead-text"
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "typeaheadText", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "display-text"
    })
], $bf26b926efc284e3$export$f5fce6ea33ac0aee.prototype, "displayText", null);


let $7998ecca30a6f1cd$export$f72dba64a8742b61 = class MdSelectOption extends (0, $bf26b926efc284e3$export$f5fce6ea33ac0aee) {
};
$7998ecca30a6f1cd$export$f72dba64a8742b61.styles = [
    (0, $5085b5bbc6889aed$export$9dd6ff9ea0189349),
    (0, $38ceadafc121eaa5$export$9dd6ff9ea0189349)
];
$7998ecca30a6f1cd$export$f72dba64a8742b61 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-select-option")
], $7998ecca30a6f1cd$export$f72dba64a8742b61);




/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $450aff38e50573a9$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);border-width:1px;border-style:solid;border-color:rgba(0,0,0,.12);-webkit-overflow-scrolling:touch;display:inline-flex;flex-direction:column;box-sizing:border-box;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px);border-top-right-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child[dir=rtl]{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px);border-bottom-left-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child[dir=rtl]{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px);border-bottom-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-data-table__row--selected{background-color:rgba(98, 0, 238, 0.04)}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-color:rgba(0,0,0,.12)}.mdc-data-table__pagination,:host{border-top-color:rgba(0,0,0,.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-width:1px;border-bottom-style:solid}.mdc-data-table__pagination,:host{border-top-width:1px;border-top-style:solid}.mdc-data-table__row:last-child .mdc-data-table__cell{border-bottom:none}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:rgba(0, 0, 0, 0.04)}.mdc-data-table__header-cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__row{height:52px}.mdc-data-table__pagination,:host{min-height:52px}.mdc-data-table__header-row{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell{padding:0 16px 0 16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;overflow-x:auto;width:100%}.mdc-data-table__table{min-width:100%;border:0;white-space:nowrap;border-spacing:0;table-layout:fixed}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;overflow:hidden;text-align:left;text-overflow:ellipsis}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl]{text-align:right}.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;outline:none;text-align:left}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{width:28px;height:28px;padding:2px;transform:rotate(0.0001deg);margin-left:4px;margin-right:0;transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}.mdc-data-table__sort-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:28px;max-width:28px}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid rgba(0,0,0,0);border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid rgba(0,0,0,0);border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:28px;height:28px;margin-top:0px;margin-bottom:0px;margin-right:0px;margin-left:0px}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:28px;max-width:28px}.mdc-data-table__sort-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:28px;left:50%;width:28px;transform:translate(-50%, -50%)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{align-items:center;display:inline-flex;vertical-align:middle}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.mdc-data-table--sticky-header .mdc-data-table__header-cell{position:sticky;top:0;z-index:1}.mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.6)}.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.6);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.6))}.mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__progress-indicator{display:none;position:absolute;width:100%}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);height:100%;opacity:.32;position:absolute;top:0;width:100%}.mdc-data-table__pagination,:host{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;display:flex;justify-content:flex-end}.mdc-data-table__pagination-trailing{margin-left:4px;margin-right:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-end}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{margin-left:14px;margin-right:36px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{margin-left:0;margin-right:22px;align-items:center;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{margin-left:0;margin-right:12px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:80px;min-width:var(--mdc-menu-min-width, 80px);margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-36px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-list-item.mdc-list-item--with-one-line{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}:host{display:table-footer-group;vertical-align:inherit;background-color:var(--_footer-container-color);height:var(--_footer-container-height);color:var(--_footer-supporting-text-color);font-family:var(--_footer-supporting-text-font);line-height:var(--_footer-supporting-text-line-height);font-size:var(--_footer-supporting-text-size);letter-spacing:var(--_footer-supporting-text-tracking);font-weight:var(--_footer-supporting-text-weight);--md-icon-color: var(--md-sys-color-on-surface-variant, inherit);padding:0 16px;border-top:var(--_row-item-outline-width) solid var(--_row-item-outline-color);border-bottom-left-radius:var(--_container-shape);border-bottom-right-radius:var(--_container-shape)}/*# sourceMappingURL=data-table-footer.css.map */
`;



class $694d0b9cbeb5981b$export$9ba6c9d48364d1da extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    connectedCallback() {
        super.connectedCallback();
        this.role = "rowgroup";
        this.slot = "footer";
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <slot></slot>
    `;
    }
}


let $5389e73ffb885013$export$501594ae41a3ae61 = class MdDataTableFooter extends (0, $694d0b9cbeb5981b$export$9ba6c9d48364d1da) {
};
$5389e73ffb885013$export$501594ae41a3ae61.styles = [
    (0, $450aff38e50573a9$export$9dd6ff9ea0189349)
];
$5389e73ffb885013$export$501594ae41a3ae61 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-data-table-footer")
], $5389e73ffb885013$export$501594ae41a3ae61);




/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * CSS class names used in component.
 */ var $f6cfddedd77988a6$export$c1c0562ec8379000 = {
    CELL: "mdc-data-table__cell",
    CELL_NUMERIC: "mdc-data-table__cell--numeric",
    CONTENT: "mdc-data-table__content",
    HEADER_CELL: "mdc-data-table__header-cell",
    HEADER_CELL_LABEL: "mdc-data-table__header-cell-label",
    HEADER_CELL_SORTED: "mdc-data-table__header-cell--sorted",
    HEADER_CELL_SORTED_DESCENDING: "mdc-data-table__header-cell--sorted-descending",
    HEADER_CELL_WITH_SORT: "mdc-data-table__header-cell--with-sort",
    HEADER_CELL_WRAPPER: "mdc-data-table__header-cell-wrapper",
    HEADER_ROW: "mdc-data-table__header-row",
    HEADER_ROW_CHECKBOX: "mdc-data-table__header-row-checkbox",
    IN_PROGRESS: "mdc-data-table--in-progress",
    LINEAR_PROGRESS: "mdc-data-table__linear-progress",
    PAGINATION_ROWS_PER_PAGE_LABEL: "mdc-data-table__pagination-rows-per-page-label",
    PAGINATION_ROWS_PER_PAGE_SELECT: "mdc-data-table__pagination-rows-per-page-select",
    PROGRESS_INDICATOR: "mdc-data-table__progress-indicator",
    ROOT: "mdc-data-table",
    ROW: "mdc-data-table__row",
    ROW_CHECKBOX: "mdc-data-table__row-checkbox",
    ROW_SELECTED: "mdc-data-table__row--selected",
    SORT_ICON_BUTTON: "mdc-data-table__sort-icon-button",
    SORT_STATUS_LABEL: "mdc-data-table__sort-status-label",
    TABLE_CONTAINER: "mdc-data-table__table-container"
};
var $f6cfddedd77988a6$export$16bd37df0047a29c = {
    ARIA_SELECTED: "aria-selected",
    ARIA_SORT: "aria-sort"
};
var $f6cfddedd77988a6$export$15d6ddc168d35719 = {
    COLUMN_ID: "data-column-id",
    ROW_ID: "data-row-id"
};
var $f6cfddedd77988a6$export$e1252723db1c541 = {
    CONTENT: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.CONTENT,
    HEADER_CELL: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_CELL,
    HEADER_CELL_WITH_SORT: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_CELL_WITH_SORT,
    HEADER_ROW: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_ROW,
    HEADER_ROW_CHECKBOX: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_ROW_CHECKBOX,
    PROGRESS_INDICATOR: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.PROGRESS_INDICATOR,
    ROW: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW,
    ROW_CHECKBOX: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW_CHECKBOX,
    ROW_SELECTED: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW_SELECTED,
    SORT_ICON_BUTTON: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.SORT_ICON_BUTTON,
    SORT_STATUS_LABEL: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.SORT_STATUS_LABEL
};
var $f6cfddedd77988a6$export$defe85febe8b728c = {
    SORTED_IN_DESCENDING: "Sorted in descending order",
    SORTED_IN_ASCENDING: "Sorted in ascending order"
};
var $f6cfddedd77988a6$export$21c51bc433c16634 = {
    ARIA_SELECTED: $f6cfddedd77988a6$export$16bd37df0047a29c.ARIA_SELECTED,
    ARIA_SORT: $f6cfddedd77988a6$export$16bd37df0047a29c.ARIA_SORT,
    DATA_ROW_ID_ATTR: $f6cfddedd77988a6$export$15d6ddc168d35719.ROW_ID,
    HEADER_ROW_CHECKBOX_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.HEADER_ROW_CHECKBOX,
    ROW_CHECKBOX_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW_CHECKBOX,
    ROW_SELECTED_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW_SELECTED,
    ROW_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW
};
var $f6cfddedd77988a6$export$aff26e357adc6917;
(function(SortValue) {
    // Items are sorted in ascending order by this column.
    SortValue["ASCENDING"] = "ascending";
    // Items are sorted in descending order by this column.
    SortValue["DESCENDING"] = "descending";
    // There is no defined sort applied to the column.
    SortValue["NONE"] = "none";
    // A sort algorithm other than ascending or descending has been applied.
    SortValue["OTHER"] = "other";
})($f6cfddedd77988a6$export$aff26e357adc6917 || ($f6cfddedd77988a6$export$aff26e357adc6917 = {}));
var $f6cfddedd77988a6$export$4bf9923669ad6c63 = {
    ROW_CLICK: "MDCDataTable:rowClick",
    ROW_SELECTION_CHANGED: "MDCDataTable:rowSelectionChanged",
    SELECTED_ALL: "MDCDataTable:selectedAll",
    SORTED: "MDCDataTable:sorted",
    UNSELECTED_ALL: "MDCDataTable:unselectedAll"
};

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $d29cc2d0f1026d01$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d29cc2d0f1026d01$export$2e2bcd8739ae039 = $d29cc2d0f1026d01$export$a81b11d69c993162;



/**
 * The Foundation of data table component containing pure business logic, any
 * logic requiring DOM manipulation are delegated to adapter methods.
 */ var $14b9dedc87673f83$export$9d41abb262ebacf8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDataTableFoundation, _super);
    function MDCDataTableFoundation(adapter) {
        return _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCDataTableFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCDataTableFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                addClassAtRowIndex: function() {
                    return undefined;
                },
                getAttributeByHeaderCellIndex: function() {
                    return "";
                },
                getHeaderCellCount: function() {
                    return 0;
                },
                getHeaderCellElements: function() {
                    return [];
                },
                getRowCount: function() {
                    return 0;
                },
                getRowElements: function() {
                    return [];
                },
                getRowIdAtIndex: function() {
                    return "";
                },
                getRowIndexByChildElement: function() {
                    return 0;
                },
                getSelectedRowCount: function() {
                    return 0;
                },
                getTableContainerHeight: function() {
                    return 0;
                },
                getTableHeaderHeight: function() {
                    return 0;
                },
                isCheckboxAtRowIndexChecked: function() {
                    return false;
                },
                isHeaderRowCheckboxChecked: function() {
                    return false;
                },
                isRowsSelectable: function() {
                    return false;
                },
                notifyRowSelectionChanged: function() {
                    return undefined;
                },
                notifySelectedAll: function() {
                    return undefined;
                },
                notifySortAction: function() {
                    return undefined;
                },
                notifyUnselectedAll: function() {
                    return undefined;
                },
                notifyRowClick: function() {
                    return undefined;
                },
                registerHeaderRowCheckbox: function() {
                    return undefined;
                },
                registerRowCheckboxes: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                removeClassAtRowIndex: function() {
                    return undefined;
                },
                removeClassNameByHeaderCellIndex: function() {
                    return undefined;
                },
                setAttributeAtRowIndex: function() {
                    return undefined;
                },
                setAttributeByHeaderCellIndex: function() {
                    return undefined;
                },
                setClassNameByHeaderCellIndex: function() {
                    return undefined;
                },
                setHeaderRowCheckboxChecked: function() {
                    return undefined;
                },
                setHeaderRowCheckboxIndeterminate: function() {
                    return undefined;
                },
                setProgressIndicatorStyles: function() {
                    return undefined;
                },
                setRowCheckboxCheckedAtIndex: function() {
                    return undefined;
                },
                setSortStatusLabelByHeaderCellIndex: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Re-initializes header row checkbox and row checkboxes when selectable rows
     * are added or removed from table. Use this if registering checkbox is
     * synchronous.
     */ MDCDataTableFoundation.prototype.layout = function() {
        if (this.adapter.isRowsSelectable()) {
            this.adapter.registerHeaderRowCheckbox();
            this.adapter.registerRowCheckboxes();
            this.setHeaderRowCheckboxState();
        }
    };
    /**
     * Re-initializes header row checkbox and row checkboxes when selectable rows
     * are added or removed from table. Use this if registering checkbox is
     * asynchronous.
     */ MDCDataTableFoundation.prototype.layoutAsync = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.adapter.isRowsSelectable()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.adapter.registerHeaderRowCheckbox()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.registerRowCheckboxes()
                        ];
                    case 2:
                        _a.sent();
                        this.setHeaderRowCheckboxState();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @return Returns array of row elements.
     */ MDCDataTableFoundation.prototype.getRows = function() {
        return this.adapter.getRowElements();
    };
    /**
     * @return Array of header cell elements.
     */ MDCDataTableFoundation.prototype.getHeaderCells = function() {
        return this.adapter.getHeaderCellElements();
    };
    /**
     * Sets selected row ids. Overwrites previously selected rows.
     * @param rowIds Array of row ids that needs to be selected.
     */ MDCDataTableFoundation.prototype.setSelectedRowIds = function(rowIds) {
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++){
            var rowId = this.adapter.getRowIdAtIndex(rowIndex);
            var isSelected = false;
            if (rowId && rowIds.indexOf(rowId) >= 0) isSelected = true;
            this.adapter.setRowCheckboxCheckedAtIndex(rowIndex, isSelected);
            this.selectRowAtIndex(rowIndex, isSelected);
        }
        this.setHeaderRowCheckboxState();
    };
    /**
     * @return Returns array of all row ids.
     */ MDCDataTableFoundation.prototype.getRowIds = function() {
        var rowIds = [];
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++)rowIds.push(this.adapter.getRowIdAtIndex(rowIndex));
        return rowIds;
    };
    /**
     * @return Returns array of selected row ids.
     */ MDCDataTableFoundation.prototype.getSelectedRowIds = function() {
        var selectedRowIds = [];
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++)if (this.adapter.isCheckboxAtRowIndexChecked(rowIndex)) selectedRowIds.push(this.adapter.getRowIdAtIndex(rowIndex));
        return selectedRowIds;
    };
    /**
     * Handles header row checkbox change event.
     */ MDCDataTableFoundation.prototype.handleHeaderRowCheckboxChange = function() {
        var isHeaderChecked = this.adapter.isHeaderRowCheckboxChecked();
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++){
            this.adapter.setRowCheckboxCheckedAtIndex(rowIndex, isHeaderChecked);
            this.selectRowAtIndex(rowIndex, isHeaderChecked);
        }
        if (isHeaderChecked) this.adapter.notifySelectedAll();
        else this.adapter.notifyUnselectedAll();
    };
    /**
     * Handles change event originated from row checkboxes.
     */ MDCDataTableFoundation.prototype.handleRowCheckboxChange = function(event) {
        var rowIndex = this.adapter.getRowIndexByChildElement(event.target);
        if (rowIndex === -1) return;
        var selected = this.adapter.isCheckboxAtRowIndexChecked(rowIndex);
        this.selectRowAtIndex(rowIndex, selected);
        this.setHeaderRowCheckboxState();
        var rowId = this.adapter.getRowIdAtIndex(rowIndex);
        this.adapter.notifyRowSelectionChanged({
            rowId: rowId,
            rowIndex: rowIndex,
            selected: selected
        });
    };
    /**
     * Handles sort action on sortable header cell.
     */ MDCDataTableFoundation.prototype.handleSortAction = function(eventData) {
        var columnId = eventData.columnId, columnIndex = eventData.columnIndex, headerCell = eventData.headerCell;
        // Reset sort attributes / classes on other header cells.
        for(var index = 0; index < this.adapter.getHeaderCellCount(); index++){
            if (index === columnIndex) continue;
            this.adapter.removeClassNameByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED);
            this.adapter.removeClassNameByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE);
            this.adapter.setSortStatusLabelByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE);
        }
        // Set appropriate sort attributes / classes on target header cell.
        this.adapter.setClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED);
        var currentSortValue = this.adapter.getAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT);
        var sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE;
        // Set to descending if sorted on ascending order.
        if (currentSortValue === (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING) {
            this.adapter.setClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING;
        // Set to ascending if sorted on descending order.
        } else if (currentSortValue === (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING) {
            this.adapter.removeClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING;
        } else {
            // Set to ascending by default when not sorted.
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING;
        }
        this.adapter.setSortStatusLabelByHeaderCellIndex(columnIndex, sortValue);
        this.adapter.notifySortAction({
            columnId: columnId,
            columnIndex: columnIndex,
            headerCell: headerCell,
            sortValue: sortValue
        });
    };
    /**
     * Handles data table row click event.
     */ MDCDataTableFoundation.prototype.handleRowClick = function(_a) {
        var rowId = _a.rowId, row = _a.row;
        this.adapter.notifyRowClick({
            rowId: rowId,
            row: row
        });
    };
    /**
     * Shows progress indicator blocking only the table body content when in
     * loading state.
     */ MDCDataTableFoundation.prototype.showProgress = function() {
        var tableHeaderHeight = this.adapter.getTableHeaderHeight();
        // Calculate the height of table content (Not scroll content) excluding
        // header row height.
        var height = this.adapter.getTableContainerHeight() - tableHeaderHeight;
        var top = tableHeaderHeight;
        this.adapter.setProgressIndicatorStyles({
            height: height + "px",
            top: top + "px"
        });
        this.adapter.addClass((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
    };
    /**
     * Hides progress indicator when data table is finished loading.
     */ MDCDataTableFoundation.prototype.hideProgress = function() {
        this.adapter.removeClass((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
    };
    /**
     * Updates header row checkbox state based on number of rows selected.
     */ MDCDataTableFoundation.prototype.setHeaderRowCheckboxState = function() {
        if (this.adapter.getSelectedRowCount() === 0) {
            this.adapter.setHeaderRowCheckboxChecked(false);
            this.adapter.setHeaderRowCheckboxIndeterminate(false);
        } else if (this.adapter.getSelectedRowCount() === this.adapter.getRowCount()) {
            this.adapter.setHeaderRowCheckboxChecked(true);
            this.adapter.setHeaderRowCheckboxIndeterminate(false);
        } else {
            this.adapter.setHeaderRowCheckboxIndeterminate(true);
            this.adapter.setHeaderRowCheckboxChecked(false);
        }
    };
    /**
     * Sets the attributes of row element based on selection state.
     */ MDCDataTableFoundation.prototype.selectRowAtIndex = function(rowIndex, selected) {
        if (selected) {
            this.adapter.addClassAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED);
            this.adapter.setAttributeAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SELECTED, "true");
        } else {
            this.adapter.removeClassAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED);
            this.adapter.setAttributeAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SELECTED, "false");
        }
    };
    return MDCDataTableFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));





class $561eb2bf6e8f6bf0$export$df30df7ec97b32b5 extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        /**
         * Enable/disable pagination.
         */ this.paginated = false;
        /**
         * JSON array with the page sizes to be used in the pagination and shown as page size select options.
         */ this.pageSizes = "[10, 25, 100]";
        /**
         * Label to show before the page size select.
         */ this.pageSizesLabel = "Rows per page:";
        /**
         * Index of the first row to be shown on the current page.
         */ this.currentFirstRow = 1;
        /** @internal */ this.pageSizesArray = JSON.parse(this.pageSizes);
        /**
         * Size of the current page.
         */ this.currentPageSize = this.pageSizesArray[0];
        /**
         * Index of the last row to be shown on the current page.
         */ this.currentLastRow = this.currentPageSize;
        /**
         * Total number of rows in the data table to show in the pagination label and
         */ this.totalRows = 0;
        /**
         * Label pattern to show after the page size select that indicates the current rows shown in the page.
         * It should contain the following parameters: `:firstRow`, `:lastRow`, `:totalRows`
         */ this.paginationTotalLabel = ":firstRow-:lastRow of :totalRows";
        /**
         * Whether the data table is using a custom pagination function. If true, the automatic pagination is disabled and
         * the `current-first-row`, `current-last-row` and `current-page-size` attributes are not updated automatically.
         * You'll have to handle the pagination yourself by listening to the `paginate` event and updating the
         * `current-first-row`, `current-last-row` and `current-page-size` attributes accordingly.
         */ this.customPagination = false;
        /**
         * Whether the loading indicator is active.
         */ this.inProgress = false;
        /**
         * Overall height of the table. Available in three different measures.
         */ this.density = "";
        /** @internal */ this.mdcRoot = this.tableElement;
        /** @internal */ // @ts-expect-error (TypeScript bug)
        this.mdcFoundationClass = (0, $14b9dedc87673f83$export$9d41abb262ebacf8);
        this.columnFilters = new Map();
        /** @internal */ this.rowCallback = (e)=>this.mdcFoundation.handleRowCheckboxChange(e);
        /** @internal */ this.headerRowCallback = ()=>this.mdcFoundation.handleHeaderRowCheckboxChange();
        /** @internal */ this.filterColumnCallback = (e)=>{
            const event = e;
            // Don't filter if the column is using custom filtering
            if (event.detail.customFiltering) return;
            const { text: text, column: column } = event.detail;
            if (text === "") this.columnFilters.delete(column);
            else this.columnFilters.set(column, text);
            for (const row of this.rows)row.hidden = true;
            let rowsToShow = this.rows;
            for (let [column, filterText] of this.columnFilters)rowsToShow = this.rows.filter((row)=>{
                const index = this.columns.indexOf(column);
                let cellText = row.cells[index].textContent ?? "";
                if (!event.detail.caseSensitive) {
                    cellText = cellText.toLowerCase();
                    filterText = filterText.toLowerCase();
                }
                return cellText.search(filterText) !== -1;
            });
            this.showRows(rowsToShow);
            this.dispatchEvent(new CustomEvent("filtered", {
                detail: {
                    column: event.detail.column,
                    text: text,
                    caseSensitive: event.detail.caseSensitive,
                    columnIndex: this.columns.indexOf(column)
                }
            }));
        };
        this.sortColumnCallback = (e)=>{
            const event = e;
            const { column: column, isDescending: isDescending } = event.detail;
            // Don't sort if the column is using custom sorting
            if (!event.detail.customSorting) {
                this.inProgress = true;
                for (const col of this.columns.filter((col)=>col !== column && col.sortable)){
                    col.sorted = false;
                    col.sortedDescending = false;
                }
                const cells = this.rows.map((row)=>row.cells[this.columns.indexOf(column)]);
                cells.sort((a, b)=>{
                    let aValue = a.textContent;
                    let bValue = b.textContent;
                    if (column.type === "numeric" && (typeof aValue === "string" || typeof bValue === "string")) {
                        aValue = Number.parseFloat(aValue);
                        bValue = Number.parseFloat(bValue);
                    }
                    if (!isDescending) {
                        const temporary = aValue;
                        aValue = bValue;
                        bValue = temporary;
                    }
                    if (typeof aValue === "string" && typeof bValue === "string") return aValue.localeCompare(bValue);
                    return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                });
                // this.rows = cells.map((cell) => cell.parentElement as DataTableRow);
                for (const cell of cells){
                    const row = cell.parentElement;
                    row.parentElement?.append(row);
                }
                this.inProgress = false;
                column.sorted = true;
            }
            column.withSortButton = true;
            this.dispatchEvent(new CustomEvent("sorted", {
                detail: {
                    column: event.detail.column,
                    isDescending: isDescending
                }
            }));
        };
    }
    /** @internal */ get headerCheckboxRow() {
        return this.columns.filter((column)=>column.checkbox !== undefined)[0];
    }
    /** @internal */ get headerCheckbox() {
        return this.headerCheckboxRow?.checkbox;
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div class="mdc-data-table">
            <div class="mdc-data-table__table-container">
                <div class="mdc-data-table__table" aria-label="${this.ariaLabel}" role="table">
                    <div class="mdc-data-table__head" role="rowgroup">
                        <div class="mdc-data-table__header-row" role="row">
                            <slot name="header-cell" @slotchange=${this.onHeaderCellSlotChange}></slot>
                        </div>
                    </div>
                    <div class="mdc-data-table__content" role="rowgroup">
                        <slot name="row" @slotchange=${()=>this.requestUpdate()}></slot>
                    </div>
                </div>
            </div>

            ${this.renderPagination()}

            <slot name="footer"></slot>

            <div class="mdc-data-table__progress-indicator">
                <div class="mdc-data-table__scrim"></div>
                <md-linear-progress indeterminate class="mdc-data-table__linear-progress" role="progressbar"
                                    aria-label="Data is being loaded..."></md-linear-progress>
            </div>
        </div>
    `;
    }
    onHeaderCellSlotChange() {
        this.requestUpdate();
        const sortColumn = this.columns.find((column)=>column.sortable && column.sorted);
        if (sortColumn) // @ts-ignore
        sortColumn.onSortButtonClicked(new CustomEvent("icon-button-toggle-change", {
            detail: {
                selected: !sortColumn.sortedDescending
            }
        }));
    }
    renderPagination() {
        if (this.paginated) {
            const totalRows = this.totalRows || this.rows.length;
            const currentFirstRow = this.currentFirstRow < 1 ? 1 : this.currentFirstRow;
            const currentLastRow = this.currentLastRow > totalRows ? totalRows : this.currentLastRow;
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <md-data-table-footer>
              <div class="mdc-data-table__pagination-trailing">
                  <div class="mdc-data-table__pagination-rows-per-page">
                      <div class="mdc-data-table__pagination-rows-per-page-label">
                          ${this.pageSizesLabel}
                      </div>

                      <md-outlined-select type="number" class="mdc-data-table__pagination-rows-per-page-select" @input=${this.onPageSizeSelected}>
                          ${this.pageSizesArray.map((size)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                              <md-select-option value="${size}" ?selected="${this.currentPageSize === size}">
                                  <span slot="headline">${size}</span>
                              </md-select-option>
                          `)}
                      </md-outlined-select>
                  </div>

                  <div class="mdc-data-table__pagination-navigation">
                      <div class="mdc-data-table__pagination-total">
                          ${this.renderTemplate(this.paginationTotalLabel, {
                "firstRow": currentFirstRow,
                "lastRow": currentLastRow,
                totalRows: totalRows
            })}
                      </div>
                      <md-filled-icon-button class="mdc-data-table__pagination-button"
                                             data-page="first"
                                             ?disabled=${currentFirstRow <= 1}
                                             @click=${this.onPaginationButtonClicked}>
                          <slot name="pagination-first-button-icon">
                              <md-icon slot="icon">first_page</md-icon>
                          </slot>
                      </md-filled-icon-button>
                      <md-filled-icon-button class="mdc-data-table__pagination-button"
                                             data-page="previous"
                                             ?disabled=${currentFirstRow <= 1}
                                             @click=${this.onPaginationButtonClicked}>
                          <slot name="pagination-previous-button-icon">
                              <md-icon>chevron_left</md-icon>
                          </slot>
                      </md-filled-icon-button>
                      <md-filled-icon-button class="mdc-data-table__pagination-button"
                                             data-page="next"
                                             ?disabled=${currentLastRow >= totalRows}
                                             @click=${this.onPaginationButtonClicked}>
                          <slot name="pagination-next-button-icon">
                              <md-icon>chevron_right</md-icon>
                          </slot>
                      </md-filled-icon-button>
                      <md-filled-icon-button class="mdc-data-table__pagination-button"
                                             data-page="last"
                                             ?disabled=${currentLastRow >= totalRows}
                                             @click=${this.onPaginationButtonClicked}>
                          <slot name="pagination-last-button-icon">
                              <md-icon>last_page</md-icon>
                          </slot>
                      </md-filled-icon-button>
                  </div>
              </div>
              </div>
      `;
        }
        return "";
    }
    onPageSizeSelected(e) {
        this.currentPageSize = Number.parseInt(e.target.value);
        this.dispatchEvent(new CustomEvent("page-size-change", {
            detail: {
                pageSize: this.currentPageSize
            }
        }));
        this.paginate("first");
    }
    onPaginationButtonClicked(event) {
        let button = event.target;
        if (!(button instanceof (0, $cd79e67b408544c7$export$c25acd513dcc8062))) button = button.closest(".mdc-data-table__pagination-button");
        const action = button.dataset["page"];
        this.dispatchEvent(new CustomEvent("page-changed", {
            detail: {
                action: action
            }
        }));
        this.paginate(action);
    }
    paginate(action = "current") {
        this.pageSizesArray = JSON.parse(this.pageSizes);
        if (!this.pageSizesArray.includes(this.currentPageSize)) this.currentPageSize = this.pageSizesArray[0];
        this.dispatchEvent(new CustomEvent("paginate", {
            detail: {
                pageSize: this.currentPageSize,
                firstRow: this.currentFirstRow,
                lastRow: this.currentLastRow,
                action: action
            }
        }));
        if (this.paginated && !this.customPagination) {
            this.hideRows();
            switch(action){
                case "first":
                    this.currentFirstRow = 1;
                    this.currentLastRow = this.currentPageSize;
                    break;
                case "previous":
                    this.currentFirstRow -= this.currentPageSize;
                    this.currentLastRow -= this.currentPageSize;
                    if (this.currentFirstRow < 1) {
                        this.currentFirstRow = 1;
                        this.currentLastRow = this.currentPageSize;
                    }
                    break;
                case "next":
                    this.currentFirstRow += this.currentPageSize;
                    this.currentLastRow += this.currentPageSize;
                    break;
                case "last":
                    this.currentFirstRow = this.rows.length - this.currentPageSize + 1;
                    this.currentLastRow = this.rows.length;
                    break;
            }
            const rowsToShow = this.rows.slice(this.currentFirstRow - 1, this.currentLastRow);
            this.showRows(rowsToShow);
        }
    }
    firstUpdated() {
        super.firstUpdated();
        this.paginate("first");
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        for (const row of this.rows){
            row.removeEventListener("selected", this.rowCallback);
            row.addEventListener("selected", this.rowCallback);
            row.setAttribute("density", this.density);
        }
        for (const column of this.columns){
            column.removeEventListener("filter", this.filterColumnCallback);
            column.addEventListener("filter", this.filterColumnCallback);
            column.removeEventListener("sort", this.sortColumnCallback);
            column.addEventListener("sort", this.sortColumnCallback);
            column.setAttribute("density", this.density);
        }
        this.headerCheckboxRow?.removeEventListener("checked", this.headerRowCallback);
        this.headerCheckboxRow?.addEventListener("checked", this.headerRowCallback);
        this.paginate();
        if (this.inProgress) this.mdcFoundation?.showProgress();
        else this.mdcFoundation?.hideProgress();
        this.mdcFoundation?.layout();
    }
    createAdapter() {
        return {
            addClass: (className)=>{
                if (className === (0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS) this.tableElement.classList.add((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
            },
            removeClass: (className)=>{
                if (className === (0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS) this.tableElement.classList.remove((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
            },
            addClassAtRowIndex: (rowIndex, className)=>{
                if (className === (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED) this.rows[rowIndex].selected = true;
            },
            getRowCount: ()=>this.totalRows || this.rows.length,
            getRowElements: ()=>this.rows,
            getRowIdAtIndex: (rowIndex)=>this.rows?.[rowIndex].id ?? null,
            getRowIndexByChildElement: (el)=>this.rows.findIndex((row)=>row.contains(el)),
            getSelectedRowCount: ()=>this.rows.filter((row)=>row.selected).length,
            isCheckboxAtRowIndexChecked: (rowIndex)=>this.rows[rowIndex].selected,
            isHeaderRowCheckboxChecked: ()=>this.headerCheckbox?.checked ?? false,
            isRowsSelectable: ()=>this.headerCheckbox !== undefined || this.rows.filter((row)=>row.checkboxCell !== undefined).length > 0,
            notifyRowSelectionChanged: (data)=>{
                this.dispatchEvent(new CustomEvent("row-selection-changed", {
                    detail: {
                        row: this.rows[data.rowIndex],
                        rowIndex: data.rowIndex,
                        selected: data.selected
                    }
                }));
            },
            notifySelectedAll: ()=>{
                this.dispatchEvent(new CustomEvent("selected-all"));
            },
            notifyUnselectedAll: ()=>{
                this.dispatchEvent(new CustomEvent("unselected-all"));
            },
            notifyRowClick: (detail)=>{
                this.dispatchEvent(new CustomEvent("row-click", {
                    detail: detail
                }));
            },
            registerHeaderRowCheckbox: ()=>{},
            registerRowCheckboxes: ()=>{},
            removeClassAtRowIndex: (rowIndex, className)=>{
                if (className === (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED) this.rows[rowIndex].selected = false;
            },
            setAttributeAtRowIndex: (rowIndex, attr, value)=>{
                const row = this.rows[rowIndex];
                if (row) {
                    row.setAttribute(attr, value);
                    if (attr === (0, $f6cfddedd77988a6$export$16bd37df0047a29c).ARIA_SELECTED) row.selected = value === "true";
                }
            },
            setHeaderRowCheckboxChecked: (checked)=>{
                if (this.headerCheckbox) this.headerCheckbox.checked = checked;
            },
            setHeaderRowCheckboxIndeterminate: (indeterminate)=>{
                if (this.headerCheckbox) this.headerCheckbox.indeterminate = indeterminate;
            },
            setRowCheckboxCheckedAtIndex: (rowIndex, checked)=>{
                const row = this.rows[rowIndex];
                if (row) row.selected = checked;
            },
            getHeaderCellCount: ()=>this.columns.length,
            getHeaderCellElements: ()=>this.columns,
            getAttributeByHeaderCellIndex: (columnIndex, attribute)=>this.columns[columnIndex].getAttribute(attribute),
            setAttributeByHeaderCellIndex: (columnIndex, attribute, value)=>{
                this.columns[columnIndex].setAttribute(attribute, value);
            },
            setClassNameByHeaderCellIndex: (columnIndex, className)=>{
                const attributesMapping = {
                    [(0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED]: "sorted",
                    [(0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING]: "sortedDescending"
                };
                this.columns[columnIndex].toggleAttribute(attributesMapping[className], true);
            },
            removeClassNameByHeaderCellIndex: (columnIndex, className)=>{
                const attributesMapping = {
                    [(0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED]: "sorted",
                    [(0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING]: "sortedDescending"
                };
                this.columns[columnIndex].toggleAttribute(attributesMapping[className], false);
            },
            notifySortAction: (data)=>{
                this.dispatchEvent(new CustomEvent("sorted", {
                    detail: data
                }));
            },
            getTableContainerHeight: ()=>this.tableContainerElement.getBoundingClientRect().height,
            getTableHeaderHeight: ()=>this.headerRowElement.getBoundingClientRect().height,
            setProgressIndicatorStyles: (styles)=>{
                this.progressIndicator.style.top = styles.top;
                this.progressIndicator.style.height = styles.height;
            },
            setSortStatusLabelByHeaderCellIndex: (columnIndex, sortValue)=>{
                const column = this.columns[columnIndex];
                if (column.sortable) {
                    const mappings = {
                        [(0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING]: (0, $f6cfddedd77988a6$export$defe85febe8b728c).SORTED_IN_ASCENDING,
                        [(0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING]: (0, $f6cfddedd77988a6$export$defe85febe8b728c).SORTED_IN_DESCENDING
                    };
                    // @ts-ignore
                    column.sortButton.ariaLabel = mappings[sortValue];
                }
            }
        };
    }
    renderTemplate(template, params) {
        for (const [key, value] of Object.entries(params))template = template.replace(`:${key}`, value);
        return template;
    }
    hideRows(rows = this.rows) {
        for (const row of rows){
            row.hidden = true;
            row.classList.remove("without-bottom-border");
        }
    }
    showRows(rows = this.rows) {
        for (const row of rows)row.hidden = false;
        // Add bottom border to the last row
        rows.slice(-1)[0]?.classList.add("without-bottom-border");
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "paginated", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true,
        attribute: "page-sizes"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "pageSizes", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true,
        attribute: "page-sizes-label"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "pageSizesLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true,
        attribute: "current-first-row"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "currentFirstRow", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true,
        attribute: "current-page-size"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "currentPageSize", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true,
        attribute: "current-last-row"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "currentLastRow", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        attribute: "total-rows"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "totalRows", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "paginationTotalLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "custom-pagination"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "customPagination", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "in-progress"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "inProgress", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "density", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "header-cell",
        selector: "md-data-table-column"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "columns", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "row",
        selector: "md-data-table-row"
    })
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "rows", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-data-table")
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "tableElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-data-table__table-container")
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "tableContainerElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-data-table__header-row")
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "headerRowElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-data-table__progress-indicator")
], $561eb2bf6e8f6bf0$export$df30df7ec97b32b5.prototype, "progressIndicator", void 0);


let $2b43c6e5ab540efc$export$f71d146b14bfc827 = class MdDataTable extends (0, $561eb2bf6e8f6bf0$export$df30df7ec97b32b5) {
};
$2b43c6e5ab540efc$export$f71d146b14bfc827.styles = [
    (0, $6fd981ce4a184af5$export$9dd6ff9ea0189349)
];
$2b43c6e5ab540efc$export$f71d146b14bfc827 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-data-table")
], $2b43c6e5ab540efc$export$f71d146b14bfc827);












class $84404f1fdb33b8aa$export$2c84b7652092b48a extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Whether the row is selected.
         */ this.selected = false;
        /** @internal */ this.onCheckboxClicked = (e)=>{
            const event = e;
            this.selected = event.detail.checked;
            this.dispatchEvent(new CustomEvent("selected", {
                detail: {
                    selected: event.detail.checked
                }
            }));
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.role = "row";
        this.slot = "row";
    }
    /** @internal */ get checkboxCell() {
        return this.checkboxCells?.[0];
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <slot @slotchange="${this.requestUpdate}"></slot>`;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        const checkboxCell = this.checkboxCell;
        if (!checkboxCell && this.checkboxCells.length === 0) // Wait for the checkbox cell to be created
        for (const cell of this.cells)cell.updateComplete.then(()=>{
            if (cell.type === "checkbox" && !this.isUpdatePending) this.requestUpdate();
        });
        if (checkboxCell) {
            checkboxCell.removeEventListener("checked", this.onCheckboxClicked);
            checkboxCell.addEventListener("checked", this.onCheckboxClicked);
            const checkbox = checkboxCell.checkbox;
            if (checkbox) checkbox.checked = this.selected;
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $84404f1fdb33b8aa$export$2c84b7652092b48a.prototype, "selected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $84404f1fdb33b8aa$export$2c84b7652092b48a.prototype, "density", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        selector: "md-data-table-cell"
    })
], $84404f1fdb33b8aa$export$2c84b7652092b48a.prototype, "cells", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        selector: 'md-data-table-cell[type="checkbox"]'
    })
], $84404f1fdb33b8aa$export$2c84b7652092b48a.prototype, "checkboxCells", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $8c39dc7130eb489f$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);border-width:1px;border-style:solid;border-color:rgba(0,0,0,.12);-webkit-overflow-scrolling:touch;display:inline-flex;flex-direction:column;box-sizing:border-box;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px);border-top-right-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child[dir=rtl]{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px);border-bottom-left-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child[dir=rtl]{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px);border-bottom-right-radius:0}.mdc-data-table__row,:host{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-data-table__row--selected,:host([selected]){background-color:rgba(98, 0, 238, 0.04)}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-color:rgba(0,0,0,.12)}.mdc-data-table__pagination{border-top-color:rgba(0,0,0,.12)}.mdc-data-table__cell,.mdc-data-table__header-cell{border-bottom-width:1px;border-bottom-style:solid}.mdc-data-table__pagination{border-top-width:1px;border-top-style:solid}.mdc-data-table__row:last-child .mdc-data-table__cell{border-bottom:none}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:rgba(0, 0, 0, 0.04)}.mdc-data-table__header-cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__row,:host{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-row{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell{padding:0 16px 0 16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;overflow-x:auto;width:100%}.mdc-data-table__table{min-width:100%;border:0;white-space:nowrap;border-spacing:0;table-layout:fixed}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;overflow:hidden;text-align:left;text-overflow:ellipsis}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl]{text-align:right}.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;outline:none;text-align:left}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{width:28px;height:28px;padding:2px;transform:rotate(0.0001deg);margin-left:4px;margin-right:0;transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}.mdc-data-table__sort-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:28px;max-width:28px}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid rgba(0,0,0,0);border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid rgba(0,0,0,0);border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:28px;height:28px;margin-top:0px;margin-bottom:0px;margin-right:0px;margin-left:0px}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:28px;max-width:28px}.mdc-data-table__sort-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:28px;left:50%;width:28px;transform:translate(-50%, -50%)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{align-items:center;display:inline-flex;vertical-align:middle}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.mdc-data-table--sticky-header .mdc-data-table__header-cell{position:sticky;top:0;z-index:1}.mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.6)}.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.6);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.6))}.mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__progress-indicator{display:none;position:absolute;width:100%}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);height:100%;opacity:.32;position:absolute;top:0;width:100%}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;display:flex;justify-content:flex-end}.mdc-data-table__pagination-trailing{margin-left:4px;margin-right:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-end}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{margin-left:14px;margin-right:36px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{margin-left:0;margin-right:22px;align-items:center;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{margin-left:0;margin-right:12px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:80px;min-width:var(--mdc-menu-min-width, 80px);margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-36px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-list-item.mdc-list-item--with-one-line{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}:host([density=tight]){height:48px}:host([density=comfortable]){height:44px}:host([density=dense]){height:40px}:host([density=compact]){height:36px}:host{display:table-row;vertical-align:inherit;border-radius:var(--_container-shape);background-color:var(--_row-item-unselected-container-color);height:var(--_row-item-container-height)}:host:has(::slotted(md-data-table-cell[type=checkbox])){background-color:var(--_row-item-unselected-container-color)}:host(.without-bottom-border) ::slotted(md-data-table-cell),:host(:not([hidden]):last-of-type) ::slotted(md-data-table-cell){border-bottom:none}:host(:not([hidden]):last-of-type) ::slotted(md-data-table-cell:first-of-type){border-bottom-left-radius:var(--_container-shape)}:host(:not([hidden]):last-of-type) ::slotted(md-data-table-cell:last-of-type){border-bottom-right-radius:var(--_container-shape)}:host([selected]){background-color:var(--_row-item-selected-container-color)}:host([selected]:hover) ::slotted(md-data-table-cell){color:rgba(var(--_row-item-selected-hover-state-layer-color), var(--_row-item-selected-hover-state-layer-opacity))}:host(:not([selected]):hover) ::slotted(md-data-table-cell){color:rgba(var(--_row-item-unselected-hover-state-layer-color), var(--_row-item-unselected-hover-state-layer-opacity))}:host(:disabled) ::slotted(md-data-table-cell){color:rgba(var(--_row-item-disabled-label-text-color), var(row-item-disabled-label-text-opacity))}:host([hidden]){display:none}slot{vertical-align:inherit}/*# sourceMappingURL=data-table-row.css.map */
`;


let $0034b4d80f14af17$export$d2159284623e6941 = class MdDataTableRow extends (0, $84404f1fdb33b8aa$export$2c84b7652092b48a) {
};
$0034b4d80f14af17$export$d2159284623e6941.styles = [
    (0, $8c39dc7130eb489f$export$9dd6ff9ea0189349)
];
$0034b4d80f14af17$export$d2159284623e6941 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-data-table-row")
], $0034b4d80f14af17$export$d2159284623e6941);











/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 



/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $cc75f450970d2f86$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`@media(forced-colors: active){:host{--md-outlined-text-field-disabled-input-text-color: GrayText;--md-outlined-text-field-disabled-input-text-opacity: 1;--md-outlined-text-field-disabled-label-text-color: GrayText;--md-outlined-text-field-disabled-label-text-opacity: 1;--md-outlined-text-field-disabled-leading-icon-color: GrayText;--md-outlined-text-field-disabled-leading-icon-opacity: 1;--md-outlined-text-field-disabled-outline-color: GrayText;--md-outlined-text-field-disabled-outline-opacity: 1;--md-outlined-text-field-disabled-supporting-text-color: GrayText;--md-outlined-text-field-disabled-supporting-text-opacity: 1;--md-outlined-text-field-disabled-trailing-icon-color: GrayText;--md-outlined-text-field-disabled-trailing-icon-opacity: 1}}/*# sourceMappingURL=outlined-forced-colors-styles.css.map */
`;


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $ef22c7b25237f4cb$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_leading-space: var(--md-outlined-text-field-leading-space, 16px);--_trailing-space: var(--md-outlined-text-field-trailing-space, 16px);--_top-space: var(--md-outlined-text-field-top-space, 16px);--_bottom-space: var(--md-outlined-text-field-bottom-space, 16px);--_input-text-prefix-trailing-space: var(--md-outlined-text-field-input-text-prefix-trailing-space, 2px);--_input-text-suffix-leading-space: var(--md-outlined-text-field-input-text-suffix-leading-space, 2px);--_focus-caret-color: var(--md-outlined-text-field-focus-caret-color, var(--md-sys-color-primary, #6750a4));--_caret-color: var(--md-outlined-text-field-caret-color, var(--md-sys-color-primary, #6750a4));--_container-shape: var(--md-outlined-text-field-container-shape, 4px);--_disabled-input-text-color: var(--md-outlined-text-field-disabled-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-input-text-opacity: var(--md-outlined-text-field-disabled-input-text-opacity, 0.38);--_disabled-label-text-color: var(--md-outlined-text-field-disabled-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-label-text-opacity: var(--md-outlined-text-field-disabled-label-text-opacity, 0.38);--_disabled-leading-icon-color: var(--md-outlined-text-field-disabled-leading-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-leading-icon-opacity: var(--md-outlined-text-field-disabled-leading-icon-opacity, 0.38);--_disabled-outline-color: var(--md-outlined-text-field-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-opacity: var(--md-outlined-text-field-disabled-outline-opacity, 0.12);--_disabled-outline-width: var(--md-outlined-text-field-disabled-outline-width, 1px);--_disabled-supporting-text-color: var(--md-outlined-text-field-disabled-supporting-text-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-supporting-text-opacity: var(--md-outlined-text-field-disabled-supporting-text-opacity, 0.38);--_disabled-trailing-icon-color: var(--md-outlined-text-field-disabled-trailing-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-trailing-icon-opacity: var(--md-outlined-text-field-disabled-trailing-icon-opacity, 0.38);--_error-focus-caret-color: var(--md-outlined-text-field-error-focus-caret-color, var(--md-sys-color-error, #b3261e));--_error-focus-input-text-color: var(--md-outlined-text-field-error-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-focus-label-text-color: var(--md-outlined-text-field-error-focus-label-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-leading-icon-color: var(--md-outlined-text-field-error-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-focus-outline-color: var(--md-outlined-text-field-error-focus-outline-color, var(--md-sys-color-error, #b3261e));--_error-focus-supporting-text-color: var(--md-outlined-text-field-error-focus-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-focus-trailing-icon-color: var(--md-outlined-text-field-error-focus-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_error-hover-input-text-color: var(--md-outlined-text-field-error-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-hover-label-text-color: var(--md-outlined-text-field-error-hover-label-text-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-leading-icon-color: var(--md-outlined-text-field-error-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-hover-outline-color: var(--md-outlined-text-field-error-hover-outline-color, var(--md-sys-color-on-error-container, #410e0b));--_error-hover-supporting-text-color: var(--md-outlined-text-field-error-hover-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-hover-trailing-icon-color: var(--md-outlined-text-field-error-hover-trailing-icon-color, var(--md-sys-color-on-error-container, #410e0b));--_error-input-text-color: var(--md-outlined-text-field-error-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_error-label-text-color: var(--md-outlined-text-field-error-label-text-color, var(--md-sys-color-error, #b3261e));--_error-leading-icon-color: var(--md-outlined-text-field-error-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_error-outline-color: var(--md-outlined-text-field-error-outline-color, var(--md-sys-color-error, #b3261e));--_error-supporting-text-color: var(--md-outlined-text-field-error-supporting-text-color, var(--md-sys-color-error, #b3261e));--_error-trailing-icon-color: var(--md-outlined-text-field-error-trailing-icon-color, var(--md-sys-color-error, #b3261e));--_focus-input-text-color: var(--md-outlined-text-field-focus-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_focus-label-text-color: var(--md-outlined-text-field-focus-label-text-color, var(--md-sys-color-primary, #6750a4));--_focus-leading-icon-color: var(--md-outlined-text-field-focus-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-outline-color: var(--md-outlined-text-field-focus-outline-color, var(--md-sys-color-primary, #6750a4));--_focus-outline-width: var(--md-outlined-text-field-focus-outline-width, 3px);--_focus-supporting-text-color: var(--md-outlined-text-field-focus-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_focus-trailing-icon-color: var(--md-outlined-text-field-focus-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-input-text-color: var(--md-outlined-text-field-hover-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-label-text-color: var(--md-outlined-text-field-hover-label-text-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-leading-icon-color: var(--md-outlined-text-field-hover-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-outline-color: var(--md-outlined-text-field-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-outline-width: var(--md-outlined-text-field-hover-outline-width, 1px);--_hover-supporting-text-color: var(--md-outlined-text-field-hover-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-trailing-icon-color: var(--md-outlined-text-field-hover-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-color: var(--md-outlined-text-field-input-text-color, var(--md-sys-color-on-surface, #1d1b20));--_input-text-font: var(--md-outlined-text-field-input-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_input-text-line-height: var(--md-outlined-text-field-input-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_input-text-placeholder-color: var(--md-outlined-text-field-input-text-placeholder-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-prefix-color: var(--md-outlined-text-field-input-text-prefix-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-size: var(--md-outlined-text-field-input-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_input-text-suffix-color: var(--md-outlined-text-field-input-text-suffix-color, var(--md-sys-color-on-surface-variant, #49454f));--_input-text-weight: var(--md-outlined-text-field-input-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_label-text-color: var(--md-outlined-text-field-label-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_label-text-font: var(--md-outlined-text-field-label-text-font, var(--md-sys-typescale-body-large-font, var(--md-ref-typeface-plain, Roboto)));--_label-text-line-height: var(--md-outlined-text-field-label-text-line-height, var(--md-sys-typescale-body-large-line-height, 1.5rem));--_label-text-populated-line-height: var(--md-outlined-text-field-label-text-populated-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_label-text-populated-size: var(--md-outlined-text-field-label-text-populated-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_label-text-size: var(--md-outlined-text-field-label-text-size, var(--md-sys-typescale-body-large-size, 1rem));--_label-text-weight: var(--md-outlined-text-field-label-text-weight, var(--md-sys-typescale-body-large-weight, var(--md-ref-typeface-weight-regular, 400)));--_leading-icon-color: var(--md-outlined-text-field-leading-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_leading-icon-size: var(--md-outlined-text-field-leading-icon-size, 24px);--_outline-color: var(--md-outlined-text-field-outline-color, var(--md-sys-color-outline, #79747e));--_outline-width: var(--md-outlined-text-field-outline-width, 1px);--_supporting-text-color: var(--md-outlined-text-field-supporting-text-color, var(--md-sys-color-on-surface-variant, #49454f));--_supporting-text-font: var(--md-outlined-text-field-supporting-text-font, var(--md-sys-typescale-body-small-font, var(--md-ref-typeface-plain, Roboto)));--_supporting-text-line-height: var(--md-outlined-text-field-supporting-text-line-height, var(--md-sys-typescale-body-small-line-height, 1rem));--_supporting-text-size: var(--md-outlined-text-field-supporting-text-size, var(--md-sys-typescale-body-small-size, 0.75rem));--_supporting-text-weight: var(--md-outlined-text-field-supporting-text-weight, var(--md-sys-typescale-body-small-weight, var(--md-ref-typeface-weight-regular, 400)));--_trailing-icon-color: var(--md-outlined-text-field-trailing-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_trailing-icon-size: var(--md-outlined-text-field-trailing-icon-size, 24px);--_container-shape-start-start: var( --md-outlined-text-field-container-shape-start-start, var(--_container-shape) );--_container-shape-start-end: var( --md-outlined-text-field-container-shape-start-end, var(--_container-shape) );--_container-shape-end-end: var( --md-outlined-text-field-container-shape-end-end, var(--_container-shape) );--_container-shape-end-start: var( --md-outlined-text-field-container-shape-end-start, var(--_container-shape) );--md-outlined-field-bottom-space: var(--_bottom-space);--md-outlined-field-container-shape-end-end: var(--_container-shape-end-end);--md-outlined-field-container-shape-end-start: var(--_container-shape-end-start);--md-outlined-field-container-shape-start-end: var(--_container-shape-start-end);--md-outlined-field-container-shape-start-start: var(--_container-shape-start-start);--md-outlined-field-content-color: var(--_input-text-color);--md-outlined-field-content-font: var(--_input-text-font);--md-outlined-field-content-line-height: var(--_input-text-line-height);--md-outlined-field-content-size: var(--_input-text-size);--md-outlined-field-content-weight: var(--_input-text-weight);--md-outlined-field-disabled-content-color: var(--_disabled-input-text-color);--md-outlined-field-disabled-content-opacity: var(--_disabled-input-text-opacity);--md-outlined-field-disabled-label-text-color: var(--_disabled-label-text-color);--md-outlined-field-disabled-label-text-opacity: var(--_disabled-label-text-opacity);--md-outlined-field-disabled-leading-content-color: var(--_disabled-leading-icon-color);--md-outlined-field-disabled-leading-content-opacity: var(--_disabled-leading-icon-opacity);--md-outlined-field-disabled-outline-color: var(--_disabled-outline-color);--md-outlined-field-disabled-outline-opacity: var(--_disabled-outline-opacity);--md-outlined-field-disabled-outline-width: var(--_disabled-outline-width);--md-outlined-field-disabled-supporting-text-color: var(--_disabled-supporting-text-color);--md-outlined-field-disabled-supporting-text-opacity: var(--_disabled-supporting-text-opacity);--md-outlined-field-disabled-trailing-content-color: var(--_disabled-trailing-icon-color);--md-outlined-field-disabled-trailing-content-opacity: var(--_disabled-trailing-icon-opacity);--md-outlined-field-error-content-color: var(--_error-input-text-color);--md-outlined-field-error-focus-content-color: var(--_error-focus-input-text-color);--md-outlined-field-error-focus-label-text-color: var(--_error-focus-label-text-color);--md-outlined-field-error-focus-leading-content-color: var(--_error-focus-leading-icon-color);--md-outlined-field-error-focus-outline-color: var(--_error-focus-outline-color);--md-outlined-field-error-focus-supporting-text-color: var(--_error-focus-supporting-text-color);--md-outlined-field-error-focus-trailing-content-color: var(--_error-focus-trailing-icon-color);--md-outlined-field-error-hover-content-color: var(--_error-hover-input-text-color);--md-outlined-field-error-hover-label-text-color: var(--_error-hover-label-text-color);--md-outlined-field-error-hover-leading-content-color: var(--_error-hover-leading-icon-color);--md-outlined-field-error-hover-outline-color: var(--_error-hover-outline-color);--md-outlined-field-error-hover-supporting-text-color: var(--_error-hover-supporting-text-color);--md-outlined-field-error-hover-trailing-content-color: var(--_error-hover-trailing-icon-color);--md-outlined-field-error-label-text-color: var(--_error-label-text-color);--md-outlined-field-error-leading-content-color: var(--_error-leading-icon-color);--md-outlined-field-error-outline-color: var(--_error-outline-color);--md-outlined-field-error-supporting-text-color: var(--_error-supporting-text-color);--md-outlined-field-error-trailing-content-color: var(--_error-trailing-icon-color);--md-outlined-field-focus-content-color: var(--_focus-input-text-color);--md-outlined-field-focus-label-text-color: var(--_focus-label-text-color);--md-outlined-field-focus-leading-content-color: var(--_focus-leading-icon-color);--md-outlined-field-focus-outline-color: var(--_focus-outline-color);--md-outlined-field-focus-outline-width: var(--_focus-outline-width);--md-outlined-field-focus-supporting-text-color: var(--_focus-supporting-text-color);--md-outlined-field-focus-trailing-content-color: var(--_focus-trailing-icon-color);--md-outlined-field-hover-content-color: var(--_hover-input-text-color);--md-outlined-field-hover-label-text-color: var(--_hover-label-text-color);--md-outlined-field-hover-leading-content-color: var(--_hover-leading-icon-color);--md-outlined-field-hover-outline-color: var(--_hover-outline-color);--md-outlined-field-hover-outline-width: var(--_hover-outline-width);--md-outlined-field-hover-supporting-text-color: var(--_hover-supporting-text-color);--md-outlined-field-hover-trailing-content-color: var(--_hover-trailing-icon-color);--md-outlined-field-label-text-color: var(--_label-text-color);--md-outlined-field-label-text-font: var(--_label-text-font);--md-outlined-field-label-text-line-height: var(--_label-text-line-height);--md-outlined-field-label-text-populated-line-height: var(--_label-text-populated-line-height);--md-outlined-field-label-text-populated-size: var(--_label-text-populated-size);--md-outlined-field-label-text-size: var(--_label-text-size);--md-outlined-field-label-text-weight: var(--_label-text-weight);--md-outlined-field-leading-content-color: var(--_leading-icon-color);--md-outlined-field-leading-space: var(--_leading-space);--md-outlined-field-outline-color: var(--_outline-color);--md-outlined-field-outline-width: var(--_outline-width);--md-outlined-field-supporting-text-color: var(--_supporting-text-color);--md-outlined-field-supporting-text-font: var(--_supporting-text-font);--md-outlined-field-supporting-text-line-height: var(--_supporting-text-line-height);--md-outlined-field-supporting-text-size: var(--_supporting-text-size);--md-outlined-field-supporting-text-weight: var(--_supporting-text-weight);--md-outlined-field-top-space: var(--_top-space);--md-outlined-field-trailing-content-color: var(--_trailing-icon-color);--md-outlined-field-trailing-space: var(--_trailing-space)}/*# sourceMappingURL=outlined-styles.css.map */
`;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 








/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $6483ea4d2421a67d$export$d6fc19b99976db77 = {
    fromAttribute (value) {
        return value ?? "";
    },
    toAttribute (value) {
        return value || null;
    }
};


class $0296a7d852c22194$export$2c73285ae9390cec extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        /**
         * Gets or sets whether or not the text field is in a visually invalid state.
         *
         * This error state overrides the error state controlled by
         * `reportValidity()`.
         */ this.error = false;
        /**
         * The error message that replaces supporting text when `error` is true. If
         * `errorText` is an empty string, then the supporting text will continue to
         * show.
         *
         * This error message overrides the error message displayed by
         * `reportValidity()`.
         */ this.errorText = "";
        this.label = "";
        this.required = false;
        /**
         * The current value of the text field. It is always a string.
         */ this.value = "";
        /**
         * An optional prefix to display before the input value.
         */ this.prefixText = "";
        /**
         * An optional suffix to display after the input value.
         */ this.suffixText = "";
        /**
         * Whether or not the text field has a leading icon. Used for SSR.
         */ this.hasLeadingIcon = false;
        /**
         * Whether or not the text field has a trailing icon. Used for SSR.
         */ this.hasTrailingIcon = false;
        /**
         * Conveys additional information below the text field, such as how it should
         * be used.
         */ this.supportingText = "";
        /**
         * Override the input text CSS `direction`. Useful for RTL languages that use
         * LTR notation for fractions.
         */ this.textDirection = "";
        /**
         * The number of rows to display for a `type="textarea"` text field.
         * Defaults to 2.
         */ this.rows = 2;
        // <input> properties
        this.inputMode = "";
        /**
         * Defines the greatest value in the range of permitted values.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#max
         */ this.max = "";
        /**
         * The maximum number of characters a user can enter into the text field. Set
         * to -1 for none.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#maxlength
         */ this.maxLength = -1;
        /**
         * Defines the most negative value in the range of permitted values.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#min
         */ this.min = "";
        /**
         * The minimum number of characters a user can enter into the text field. Set
         * to -1 for none.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#minlength
         */ this.minLength = -1;
        /**
         * A regular expression that the text field's value must match to pass
         * constraint validation.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#pattern
         */ this.pattern = "";
        this.placeholder = "";
        /**
         * Indicates whether or not a user should be able to edit the text field's
         * value.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#readonly
         */ this.readOnly = false;
        /**
         * Returns or sets the element's step attribute, which works with min and max
         * to limit the increments at which a numeric or date-time value can be set.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#step
         */ this.step = "";
        /**
         * The `<input>` type to use, defaults to "text". The type greatly changes how
         * the text field behaves.
         *
         * Text fields support a limited number of `<input>` types:
         *
         * - text
         * - textarea
         * - email
         * - number
         * - password
         * - search
         * - tel
         * - url
         *
         * See
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
         * for more details on each input type.
         */ this.type = "text";
        /**
         * Describes what, if any, type of autocomplete functionality the input
         * should provide.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
         */ this.autocomplete = "";
        /**
         * Returns true when the text field has been interacted with. Native
         * validation errors only display in response to user interactions.
         */ this.dirty = false;
        this.focused = false;
        /**
         * Whether or not a native error has been reported via `reportValidity()`.
         */ this.nativeError = false;
        /**
         * The validation message displayed from a native error via
         * `reportValidity()`.
         */ this.nativeErrorText = "";
        // Needed for Safari, see https://bugs.webkit.org/show_bug.cgi?id=261432
        // Replace with this.internals.validity.customError when resolved.
        this.hasCustomValidityError = false;
        this.internals = this/* needed for closure */ .attachInternals();
    }
    /**
     * The associated form element with which this element's value will submit.
     */ get form() {
        return this.internals.form;
    }
    /**
     * The labels this element is associated with.
     */ get labels() {
        return this.internals.labels;
    }
    /**
     * The HTML name to use in form submission.
     */ get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    /**
     * Gets or sets the direction in which selection occurred.
     */ get selectionDirection() {
        return this.getInputOrTextarea().selectionDirection;
    }
    set selectionDirection(value) {
        this.getInputOrTextarea().selectionDirection = value;
    }
    /**
     * Gets or sets the end position or offset of a text selection.
     */ get selectionEnd() {
        return this.getInputOrTextarea().selectionEnd;
    }
    set selectionEnd(value) {
        this.getInputOrTextarea().selectionEnd = value;
    }
    /**
     * Gets or sets the starting position or offset of a text selection.
     */ get selectionStart() {
        return this.getInputOrTextarea().selectionStart;
    }
    set selectionStart(value) {
        this.getInputOrTextarea().selectionStart = value;
    }
    /**
     * Returns the text field's validation error message.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation
     */ get validationMessage() {
        this.syncValidity();
        return this.internals.validationMessage;
    }
    /**
     * Returns a `ValidityState` object that represents the validity states of the
     * text field.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/ValidityState
     */ get validity() {
        this.syncValidity();
        return this.internals.validity;
    }
    /**
     * The text field's value as a number.
     */ get valueAsNumber() {
        const input = this.getInput();
        if (!input) return NaN;
        return input.valueAsNumber;
    }
    set valueAsNumber(value) {
        const input = this.getInput();
        if (!input) return;
        input.valueAsNumber = value;
        this.value = input.value;
    }
    /**
     * The text field's value as a Date.
     */ get valueAsDate() {
        const input = this.getInput();
        if (!input) return null;
        return input.valueAsDate;
    }
    set valueAsDate(value) {
        const input = this.getInput();
        if (!input) return;
        input.valueAsDate = value;
        this.value = input.value;
    }
    /**
     * Returns whether an element will successfully validate based on forms
     * validation rules and constraints.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/ElementInternals/willValidate
     */ get willValidate() {
        this.syncValidity();
        return this.internals.willValidate;
    }
    get hasError() {
        return this.error || this.nativeError;
    }
    /**
     * Checks the text field's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/checkValidity
     *
     * @return true if the text field is valid, or false if not.
     */ checkValidity() {
        this.syncValidity();
        return this.internals.checkValidity();
    }
    /**
     * Checks the text field's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * This method will display or clear an error text message equal to the text
     * field's `validationMessage`, unless the invalid event is canceled.
     *
     * Use `setCustomValidity()` to customize the `validationMessage`.
     *
     * This method can also be used to re-announce error messages to screen
     * readers.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/reportValidity
     *
     * @return true if the text field is valid, or false if not.
     */ reportValidity() {
        let invalidEvent;
        this.addEventListener("invalid", (event)=>{
            invalidEvent = event;
        }, {
            once: true
        });
        const valid = this.checkValidity();
        if (invalidEvent?.defaultPrevented) return valid;
        const prevMessage = this.getErrorText();
        this.nativeError = !valid;
        this.nativeErrorText = this.validationMessage;
        if (prevMessage === this.getErrorText()) this.field?.reannounceError();
        return valid;
    }
    /**
     * Selects all the text in the text field.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/select
     */ select() {
        this.getInputOrTextarea().select();
    }
    /**
     * Sets a custom validation error message for the text field. Use this for
     * custom error message.
     *
     * When the error is not an empty string, the text field is considered invalid
     * and `validity.customError` will be true.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setCustomValidity
     *
     * @param error The error message to display.
     */ setCustomValidity(error) {
        this.hasCustomValidityError = !!error;
        this.internals.setValidity({
            customError: !!error
        }, error, this.getInputOrTextarea());
    }
    setRangeText(...args) {
        // Calling setRangeText with 1 vs 3-4 arguments has different behavior.
        // Use spread syntax and type casting to ensure correct usage.
        this.getInputOrTextarea().setRangeText(...args);
        this.value = this.getInputOrTextarea().value;
    }
    /**
     * Sets the start and end positions of a selection in the text field.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
     *
     * @param start The offset into the text field for the start of the selection.
     * @param end The offset into the text field for the end of the selection.
     * @param direction The direction in which the selection is performed.
     */ setSelectionRange(start, end, direction) {
        this.getInputOrTextarea().setSelectionRange(start, end, direction);
    }
    /**
     * Decrements the value of a numeric type text field by `step` or `n` `step`
     * number of times.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/stepDown
     *
     * @param stepDecrement The number of steps to decrement, defaults to 1.
     */ stepDown(stepDecrement) {
        const input = this.getInput();
        if (!input) return;
        input.stepDown(stepDecrement);
        this.value = input.value;
    }
    /**
     * Increments the value of a numeric type text field by `step` or `n` `step`
     * number of times.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/stepUp
     *
     * @param stepIncrement The number of steps to increment, defaults to 1.
     */ stepUp(stepIncrement) {
        const input = this.getInput();
        if (!input) return;
        input.stepUp(stepIncrement);
        this.value = input.value;
    }
    /**
     * Reset the text field to its default value.
     */ reset() {
        this.dirty = false;
        this.value = this.getAttribute("value") ?? "";
        this.nativeError = false;
        this.nativeErrorText = "";
    }
    attributeChangedCallback(attribute, newValue, oldValue) {
        if (attribute === "value" && this.dirty) // After user input, changing the value attribute no longer updates the
        // text field's value (until reset). This matches native <input> behavior.
        return;
        super.attributeChangedCallback(attribute, newValue, oldValue);
    }
    render() {
        const classes = {
            "disabled": this.disabled,
            "error": !this.disabled && this.hasError,
            "textarea": this.type === "textarea"
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
       <span class="text-field ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">
         ${this.renderField()}
       </span>
     `;
    }
    updated(changedProperties) {
        // Keep changedProperties arg so that subclasses may call it
        // If a property such as `type` changes and causes the internal <input>
        // value to change without dispatching an event, re-sync it.
        const value = this.getInputOrTextarea().value;
        if (this.value !== value) // Note this is typically inefficient in updated() since it schedules
        // another update. However, it is needed for the <input> to fully render
        // before checking its value.
        this.value = value;
        this.internals.setFormValue(value);
        // Sync validity when properties change, since validation properties may
        // have changed.
        this.syncValidity();
    }
    renderField() {
        return (0, $54f4e21f80f6eaaa$export$c0bb0b647f701bb5)`<${this.fieldTag}
      class="field"
      count=${this.value.length}
      ?disabled=${this.disabled}
      ?error=${this.hasError}
      error-text=${this.getErrorText()}
      ?focused=${this.focused}
      ?has-end=${this.hasTrailingIcon}
      ?has-start=${this.hasLeadingIcon}
      label=${this.label}
      max=${this.maxLength}
      ?populated=${!!this.value}
      ?required=${this.required}
      ?resizable=${this.type === "textarea"}
      supporting-text=${this.supportingText}
    >
      ${this.renderLeadingIcon()}
      ${this.renderInputOrTextarea()}
      ${this.renderTrailingIcon()}
      <div id="description" slot="aria-describedby"></div>
    </${this.fieldTag}>`;
    }
    renderLeadingIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
       <span class="icon leading" slot="start">
         <slot name="leading-icon" @slotchange=${this.handleIconChange}></slot>
       </span>
     `;
    }
    renderTrailingIcon() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
       <span class="icon trailing" slot="end">
         <slot name="trailing-icon" @slotchange=${this.handleIconChange}></slot>
       </span>
     `;
    }
    renderInputOrTextarea() {
        const style = {
            direction: this.textDirection
        };
        const ariaLabel = this.ariaLabel || this.label || (0, $e5ed8027d647799b$export$45b790e32b2810ee);
        // lit-anaylzer `autocomplete` types are too strict
        // tslint:disable-next-line:no-any
        const autocomplete = this.autocomplete;
        if (this.type === "textarea") return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <textarea
          class="input"
          style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(style)}
          aria-describedby="description"
          aria-invalid=${this.hasError}
          aria-label=${ariaLabel}
          autocomplete=${autocomplete || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          ?disabled=${this.disabled}
          maxlength=${this.maxLength > -1 ? this.maxLength : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          minlength=${this.minLength > -1 ? this.minLength : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          placeholder=${this.placeholder || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          ?readonly=${this.readOnly}
          ?required=${this.required}
          rows=${this.rows}
          .value=${(0, $6bc1ca53c26af3e9$export$28cf49ad70f82d12)(this.value)}
          @change=${this.handleChange}
          @focusin=${this.handleFocusin}
          @focusout=${this.handleFocusout}
          @input=${this.handleInput}
          @select=${this.redispatchEvent}
        ></textarea>
      `;
        const prefix = this.renderPrefix();
        const suffix = this.renderSuffix();
        // TODO(b/243805848): remove `as unknown as number` and `as any` once lit
        // analyzer is fixed
        // tslint:disable-next-line:no-any
        const inputMode = this.inputMode;
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="input-wrapper">
        ${prefix}
        <input
          class="input"
          style=${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(style)}
          aria-describedby="description"
          aria-invalid=${this.hasError}
          aria-label=${ariaLabel}
          autocomplete=${autocomplete || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          ?disabled=${this.disabled}
          inputmode=${inputMode || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          max=${this.max || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          maxlength=${this.maxLength > -1 ? this.maxLength : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          min=${this.min || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          minlength=${this.minLength > -1 ? this.minLength : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          pattern=${this.pattern || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          placeholder=${this.placeholder || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          ?readonly=${this.readOnly}
          ?required=${this.required}
          step=${this.step || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          type=${this.type}
          .value=${(0, $6bc1ca53c26af3e9$export$28cf49ad70f82d12)(this.value)}
          @change=${this.redispatchEvent}
          @focusin=${this.handleFocusin}
          @focusout=${this.handleFocusout}
          @input=${this.handleInput}
          @select=${this.redispatchEvent}
        >
        ${suffix}
      </div>
    `;
    }
    renderPrefix() {
        return this.renderAffix(this.prefixText, /* isSuffix */ false);
    }
    renderSuffix() {
        return this.renderAffix(this.suffixText, /* isSuffix */ true);
    }
    renderAffix(text, isSuffix) {
        if (!text) return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
        const classes = {
            "suffix": isSuffix,
            "prefix": !isSuffix
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<span class="${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}">${text}</span>`;
    }
    getErrorText() {
        return this.error ? this.errorText : this.nativeErrorText;
    }
    handleFocusin() {
        this.focused = true;
    }
    handleFocusout() {
        this.focused = false;
    }
    handleInput(event) {
        this.dirty = true;
        this.value = event.target.value;
        // Sync validity so that clients can check validity on input.
        this.syncValidity();
    }
    handleChange(event) {
        // Sync validity so that clients can check validity on change.
        this.syncValidity();
        this.redispatchEvent(event);
    }
    redispatchEvent(event) {
        (0, $9051cc2e8fc17c65$export$a43eef78b734067e)(this, event);
    }
    getInputOrTextarea() {
        if (!this.inputOrTextarea) {
            // If the input is not yet defined, synchronously render.
            // e.g.
            // const textField = document.createElement('md-outlined-text-field');
            // document.body.appendChild(textField);
            // textField.focus(); // synchronously render
            this.connectedCallback();
            this.scheduleUpdate();
        }
        if (this.isUpdatePending) // If there are pending updates, synchronously perform them. This ensures
        // that constraint validation properties (like `required`) are synced
        // before interacting with input APIs that depend on them.
        this.scheduleUpdate();
        return this.inputOrTextarea;
    }
    getInput() {
        if (this.type === "textarea") return null;
        return this.getInputOrTextarea();
    }
    syncValidity() {
        // Sync the internal <input>'s validity and the host's ElementInternals
        // validity. We do this to re-use native `<input>` validation messages.
        const input = this.getInputOrTextarea();
        if (this.hasCustomValidityError) input.setCustomValidity(this.internals.validationMessage);
        else input.setCustomValidity("");
        this.internals.setValidity(input.validity, input.validationMessage, this.getInputOrTextarea());
    }
    handleIconChange() {
        this.hasLeadingIcon = this.leadingIcons.length > 0;
        this.hasTrailingIcon = this.trailingIcons.length > 0;
    }
    /** @private */ formResetCallback() {
        this.reset();
    }
    /** @private */ formStateRestoreCallback(state) {
        this.value = state;
    }
}
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($0296a7d852c22194$export$2c73285ae9390cec);
})();
/** @nocollapse */ $0296a7d852c22194$export$2c73285ae9390cec.shadowRootOptions = {
    ...(0, $fe586ba0757c37f7$export$3f2f9f5909897157).shadowRootOptions,
    delegatesFocus: true
};
/** @nocollapse  */ $0296a7d852c22194$export$2c73285ae9390cec.formAssociated = true;
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "error", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "error-text"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "errorText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "label", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "prefix-text"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "prefixText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "suffix-text"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "suffixText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-leading-icon"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "hasLeadingIcon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "has-trailing-icon"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "hasTrailingIcon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "supporting-text"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "supportingText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        attribute: "text-direction"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "textDirection", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "rows", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "inputMode", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "max", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "maxLength", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "min", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "minLength", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "pattern", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        reflect: true,
        converter: (0, $6483ea4d2421a67d$export$d6fc19b99976db77)
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "placeholder", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "readOnly", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "step", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        reflect: true
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "autocomplete", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "dirty", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "focused", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "nativeError", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "nativeErrorText", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".input")
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "inputOrTextarea", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".field")
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "field", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "leading-icon"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "leadingIcons", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "trailing-icon"
    })
], $0296a7d852c22194$export$2c73285ae9390cec.prototype, "trailingIcons", void 0);


class $91eead1db2d40b9f$export$bae5880b1aae6586 extends (0, $0296a7d852c22194$export$2c73285ae9390cec) {
    constructor(){
        super(...arguments);
        this.fieldTag = (0, $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0)`md-outlined-field`;
    }
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $471e149c9ae5c5ba$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{display:inline-flex;outline:none;resize:both;-webkit-tap-highlight-color:rgba(0,0,0,0)}.text-field,.field{width:100%}.text-field{display:inline-flex}.field{cursor:text}.disabled .field{cursor:default}.text-field,.textarea .field{resize:inherit}.icon{color:currentColor;display:flex;fill:currentColor}.icon ::slotted(*){display:flex}[hasstart] .icon.leading{font-size:var(--_leading-icon-size);height:var(--_leading-icon-size);width:var(--_leading-icon-size)}[hasend] .icon.trailing{font-size:var(--_trailing-icon-size);height:var(--_trailing-icon-size);width:var(--_trailing-icon-size)}.input-wrapper{display:flex}.input-wrapper>*{all:inherit;padding:0}.input{caret-color:var(--_caret-color);overflow-x:hidden;text-align:inherit}.input::placeholder{color:currentColor;opacity:1}.input::-webkit-calendar-picker-indicator{display:none}.input::-webkit-search-decoration,.input::-webkit-search-cancel-button{display:none}@media(forced-colors: active){.input{background-color:Field}}:focus-within .input{caret-color:var(--_focus-caret-color)}.error:focus-within .input{caret-color:var(--_error-focus-caret-color)}.text-field:not(.disabled) .prefix{color:var(--_input-text-prefix-color)}.text-field:not(.disabled) .suffix{color:var(--_input-text-suffix-color)}.text-field:not(.disabled) .input::placeholder{color:var(--_input-text-placeholder-color)}.prefix,.suffix{text-wrap:nowrap;width:min-content}.prefix{padding-inline-end:var(--_input-text-prefix-trailing-space)}.suffix{padding-inline-start:var(--_input-text-suffix-leading-space)}/*# sourceMappingURL=shared-styles.css.map */
`;


let $b6606d9f5327cb96$export$a485842b69e9c913 = class MdOutlinedTextField extends (0, $91eead1db2d40b9f$export$bae5880b1aae6586) {
    constructor(){
        super(...arguments);
        this.fieldTag = (0, $54f4e21f80f6eaaa$export$c8ec6e1ec9fefcb0)`md-outlined-field`;
    }
};
$b6606d9f5327cb96$export$a485842b69e9c913.styles = [
    (0, $471e149c9ae5c5ba$export$9dd6ff9ea0189349),
    (0, $ef22c7b25237f4cb$export$9dd6ff9ea0189349),
    (0, $cc75f450970d2f86$export$9dd6ff9ea0189349)
];
$b6606d9f5327cb96$export$a485842b69e9c913 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-outlined-text-field")
], $b6606d9f5327cb96$export$a485842b69e9c913);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 



/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $d55f7a3c4823a88d$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_disabled-icon-color: var(--md-icon-button-disabled-icon-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-icon-opacity: var(--md-icon-button-disabled-icon-opacity, 0.38);--_icon-size: var(--md-icon-button-icon-size, 24px);--_selected-focus-icon-color: var(--md-icon-button-selected-focus-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-icon-color: var(--md-icon-button-selected-hover-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-state-layer-color: var(--md-icon-button-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-state-layer-opacity: var(--md-icon-button-selected-hover-state-layer-opacity, 0.08);--_selected-icon-color: var(--md-icon-button-selected-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-icon-color: var(--md-icon-button-selected-pressed-icon-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-state-layer-color: var(--md-icon-button-selected-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-state-layer-opacity: var(--md-icon-button-selected-pressed-state-layer-opacity, 0.12);--_state-layer-height: var(--md-icon-button-state-layer-height, 40px);--_state-layer-shape: var(--md-icon-button-state-layer-shape, 9999px);--_state-layer-width: var(--md-icon-button-state-layer-width, 40px);--_focus-icon-color: var(--md-icon-button-focus-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-icon-color: var(--md-icon-button-hover-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-color: var(--md-icon-button-hover-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_hover-state-layer-opacity: var(--md-icon-button-hover-state-layer-opacity, 0.08);--_icon-color: var(--md-icon-button-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-icon-color: var(--md-icon-button-pressed-icon-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-color: var(--md-icon-button-pressed-state-layer-color, var(--md-sys-color-on-surface-variant, #49454f));--_pressed-state-layer-opacity: var(--md-icon-button-pressed-state-layer-opacity, 0.12);--_container-shape-start-start: 0;--_container-shape-start-end: 0;--_container-shape-end-end: 0;--_container-shape-end-start: 0;--_container-height: 0;--_container-width: 0;height:var(--_state-layer-height);width:var(--_state-layer-width)}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_state-layer-height))/2) max(0px,(48px - var(--_state-layer-width))/2)}md-focus-ring{--md-focus-ring-shape-start-start: var(--_state-layer-shape);--md-focus-ring-shape-start-end: var(--_state-layer-shape);--md-focus-ring-shape-end-end: var(--_state-layer-shape);--md-focus-ring-shape-end-start: var(--_state-layer-shape)}.standard{background-color:rgba(0,0,0,0);color:var(--_icon-color);--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}.standard:hover{color:var(--_hover-icon-color)}.standard:focus{color:var(--_focus-icon-color)}.standard:active{color:var(--_pressed-icon-color)}.standard:disabled{color:var(--_disabled-icon-color)}md-ripple{border-radius:var(--_state-layer-shape)}.standard:disabled .icon{opacity:var(--_disabled-icon-opacity)}.selected{--md-ripple-hover-color: var(--_selected-hover-state-layer-color);--md-ripple-hover-opacity: var(--_selected-hover-state-layer-opacity);--md-ripple-pressed-color: var(--_selected-pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_selected-pressed-state-layer-opacity)}.selected:not(:disabled){color:var(--_selected-icon-color)}.selected:not(:disabled):hover{color:var(--_selected-hover-icon-color)}.selected:not(:disabled):focus{color:var(--_selected-focus-icon-color)}.selected:not(:disabled):active{color:var(--_selected-pressed-icon-color)}/*# sourceMappingURL=standard-styles.css.map */
`;


let $738879a8266d7869$export$c9f37605c9015635 = class MdIconButton extends (0, $cd79e67b408544c7$export$c25acd513dcc8062) {
    getRenderClasses() {
        return {
            ...super.getRenderClasses(),
            "standard": true
        };
    }
};
$738879a8266d7869$export$c9f37605c9015635.styles = [
    (0, $6c97ea26c9205f1f$export$9dd6ff9ea0189349),
    (0, $d55f7a3c4823a88d$export$9dd6ff9ea0189349)
];
$738879a8266d7869$export$c9f37605c9015635 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-icon-button")
], $738879a8266d7869$export$c9f37605c9015635);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 







class $55c0bb6004e8e175$export$48513f6b9f8ce62d extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    /**
     * The HTML name to use in form submission.
     */ get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    /**
     * The associated form element with which this element's value will submit.
     */ get form() {
        return this.internals.form;
    }
    /**
     * The labels this element is associated with.
     */ get labels() {
        return this.internals.labels;
    }
    /**
     * Returns a ValidityState object that represents the validity states of the
     * checkbox.
     *
     * Note that checkboxes will only set `valueMissing` if `required` and not
     * checked.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#validation
     */ get validity() {
        this.syncValidity();
        return this.internals.validity;
    }
    /**
     * Returns the native validation error message.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation#constraint_validation_process
     */ get validationMessage() {
        this.syncValidity();
        return this.internals.validationMessage;
    }
    /**
     * Returns whether an element will successfully validate based on forms
     * validation rules and constraints.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Constraint_validation#constraint_validation_process
     */ get willValidate() {
        this.syncValidity();
        return this.internals.willValidate;
    }
    constructor(){
        super();
        /**
         * Whether or not the checkbox is selected.
         */ this.checked = false;
        /**
         * Whether or not the checkbox is disabled.
         */ this.disabled = false;
        /**
         * Whether or not the checkbox is indeterminate.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#indeterminate_state_checkboxes
         */ this.indeterminate = false;
        /**
         * When true, require the checkbox to be selected when participating in
         * form submission.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#validation
         */ this.required = false;
        /**
         * The value of the checkbox that is submitted with a form when selected.
         *
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#value
         */ this.value = "on";
        this.prevChecked = false;
        this.prevDisabled = false;
        this.prevIndeterminate = false;
        // Needed for Safari, see https://bugs.webkit.org/show_bug.cgi?id=261432
        // Replace with this.internals.validity.customError when resolved.
        this.hasCustomValidityError = false;
        this.internals = this/* needed for closure */ .attachInternals();
        if (!(0, $650ed036964a13b8$export$6acf61af03e62db)) this.addEventListener("click", (event)=>{
            if (!(0, $9051cc2e8fc17c65$export$94f057a5fd2f0b4f)(event)) return;
            this.focus();
            (0, $9051cc2e8fc17c65$export$db7569af3a356a43)(this.input);
        });
    }
    /**
     * Checks the checkbox's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/checkValidity
     *
     * @return true if the checkbox is valid, or false if not.
     */ checkValidity() {
        this.syncValidity();
        return this.internals.checkValidity();
    }
    /**
     * Checks the checkbox's native validation and returns whether or not the
     * element is valid.
     *
     * If invalid, this method will dispatch the `invalid` event.
     *
     * The `validationMessage` is reported to the user by the browser. Use
     * `setCustomValidity()` to customize the `validationMessage`.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/reportValidity
     *
     * @return true if the checkbox is valid, or false if not.
     */ reportValidity() {
        this.syncValidity();
        return this.internals.reportValidity();
    }
    /**
     * Sets the checkbox's native validation error message. This is used to
     * customize `validationMessage`.
     *
     * When the error is not an empty string, the checkbox is considered invalid
     * and `validity.customError` will be true.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setCustomValidity
     *
     * @param error The error message to display.
     */ setCustomValidity(error) {
        this.hasCustomValidityError = !!error;
        this.internals.setValidity({
            customError: !!error
        }, error, this.getInput());
    }
    update(changed) {
        if (changed.has("checked") || changed.has("disabled") || changed.has("indeterminate")) {
            this.prevChecked = changed.get("checked") ?? this.checked;
            this.prevDisabled = changed.get("disabled") ?? this.disabled;
            this.prevIndeterminate = changed.get("indeterminate") ?? this.indeterminate;
        }
        const shouldAddFormValue = this.checked && !this.indeterminate;
        const state = String(this.checked);
        this.internals.setFormValue(shouldAddFormValue ? this.value : null, state);
        super.update(changed);
    }
    render() {
        const prevNone = !this.prevChecked && !this.prevIndeterminate;
        const prevChecked = this.prevChecked && !this.prevIndeterminate;
        const prevIndeterminate = this.prevIndeterminate;
        const isChecked = this.checked && !this.indeterminate;
        const isIndeterminate = this.indeterminate;
        const containerClasses = (0, $0e5c059fc79abe53$export$56cc687933817664)({
            "disabled": this.disabled,
            "selected": isChecked || isIndeterminate,
            "unselected": !isChecked && !isIndeterminate,
            "checked": isChecked,
            "indeterminate": isIndeterminate,
            "prev-unselected": prevNone,
            "prev-checked": prevChecked,
            "prev-indeterminate": prevIndeterminate,
            "prev-disabled": this.prevDisabled
        });
        // Needed for closure conformance
        const { ariaLabel: ariaLabel, ariaInvalid: ariaInvalid } = this;
        // Note: <input> needs to be rendered before the <svg> for
        // form.reportValidity() to work in Chrome.
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="container ${containerClasses}">
        <input type="checkbox"
          id="input"
          aria-checked=${isIndeterminate ? "mixed" : (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          aria-label=${ariaLabel || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          aria-invalid=${ariaInvalid || (0, $e5ed8027d647799b$export$45b790e32b2810ee)}
          ?disabled=${this.disabled}
          ?required=${this.required}
          .indeterminate=${this.indeterminate}
          .checked=${this.checked}
          @change=${this.handleChange}
        >

        <div class="outline"></div>
        <div class="background"></div>
        <md-focus-ring part="focus-ring" for="input"></md-focus-ring>
        <md-ripple for="input" ?disabled=${this.disabled}></md-ripple>
        <svg class="icon" viewBox="0 0 18 18" aria-hidden="true">
          <rect class="mark short" />
          <rect class="mark long" />
        </svg>
      </div>
    `;
    }
    updated() {
        // Sync validity when properties change, since validation properties may
        // have changed.
        this.syncValidity();
    }
    handleChange(event) {
        const target = event.target;
        this.checked = target.checked;
        this.indeterminate = target.indeterminate;
        (0, $9051cc2e8fc17c65$export$a43eef78b734067e)(this, event);
    }
    syncValidity() {
        // Sync the internal <input>'s validity and the host's ElementInternals
        // validity. We do this to re-use native `<input>` validation messages.
        const input = this.getInput();
        if (this.hasCustomValidityError) input.setCustomValidity(this.internals.validationMessage);
        else input.setCustomValidity("");
        this.internals.setValidity(input.validity, input.validationMessage, this.getInput());
    }
    getInput() {
        if (!this.input) {
            // If the input is not yet defined, synchronously render.
            this.connectedCallback();
            this.performUpdate();
        }
        if (this.isUpdatePending) // If there are pending updates, synchronously perform them. This ensures
        // that constraint validation properties (like `required`) are synced
        // before interacting with input APIs that depend on them.
        this.scheduleUpdate();
        return this.input;
    }
    /** @private */ formResetCallback() {
        // The checked property does not reflect, so the original attribute set by
        // the user is used to determine the default value.
        this.checked = this.hasAttribute("checked");
    }
    /** @private */ formStateRestoreCallback(state) {
        this.checked = state === "true";
    }
}
(()=>{
    (0, $0b7ed02cda79c042$export$889c2c63f7feb341)($55c0bb6004e8e175$export$48513f6b9f8ce62d);
})();
/** @nocollapse */ $55c0bb6004e8e175$export$48513f6b9f8ce62d.shadowRootOptions = {
    ...(0, $fe586ba0757c37f7$export$3f2f9f5909897157).shadowRootOptions,
    delegatesFocus: true
};
/** @nocollapse */ $55c0bb6004e8e175$export$48513f6b9f8ce62d.formAssociated = true;
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "checked", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "disabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "indeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "required", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "value", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "prevChecked", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "prevDisabled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $7162e77b40ffab5c$export$ca000e230c0caa3e)()
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "prevIndeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("input")
], $55c0bb6004e8e175$export$48513f6b9f8ce62d.prototype, "input", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $81272e3f067308e1$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{--_container-shape: var(--md-checkbox-container-shape, 2px);--_container-size: var(--md-checkbox-container-size, 18px);--_icon-size: var(--md-checkbox-icon-size, 18px);--_selected-container-color: var(--md-checkbox-selected-container-color, var(--md-sys-color-primary, #6750a4));--_selected-disabled-container-color: var(--md-checkbox-selected-disabled-container-color, var(--md-sys-color-on-surface, #1d1b20));--_selected-disabled-container-opacity: var(--md-checkbox-selected-disabled-container-opacity, 0.38);--_selected-disabled-icon-color: var(--md-checkbox-selected-disabled-icon-color, var(--md-sys-color-surface, #fef7ff));--_selected-focus-container-color: var(--md-checkbox-selected-focus-container-color, var(--md-sys-color-primary, #6750a4));--_selected-focus-icon-color: var(--md-checkbox-selected-focus-icon-color, var(--md-sys-color-on-primary, #fff));--_selected-hover-container-color: var(--md-checkbox-selected-hover-container-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-icon-color: var(--md-checkbox-selected-hover-icon-color, var(--md-sys-color-on-primary, #fff));--_selected-hover-state-layer-color: var(--md-checkbox-selected-hover-state-layer-color, var(--md-sys-color-primary, #6750a4));--_selected-hover-state-layer-opacity: var(--md-checkbox-selected-hover-state-layer-opacity, 0.08);--_selected-icon-color: var(--md-checkbox-selected-icon-color, var(--md-sys-color-on-primary, #fff));--_selected-pressed-container-color: var(--md-checkbox-selected-pressed-container-color, var(--md-sys-color-primary, #6750a4));--_selected-pressed-icon-color: var(--md-checkbox-selected-pressed-icon-color, var(--md-sys-color-on-primary, #fff));--_selected-pressed-state-layer-color: var(--md-checkbox-selected-pressed-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--_selected-pressed-state-layer-opacity: var(--md-checkbox-selected-pressed-state-layer-opacity, 0.12);--_state-layer-shape: var(--md-checkbox-state-layer-shape, 9999px);--_state-layer-size: var(--md-checkbox-state-layer-size, 40px);--_disabled-container-opacity: var(--md-checkbox-disabled-container-opacity, 0.38);--_disabled-outline-color: var(--md-checkbox-disabled-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_disabled-outline-width: var(--md-checkbox-disabled-outline-width, 2px);--_focus-outline-color: var(--md-checkbox-focus-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_focus-outline-width: var(--md-checkbox-focus-outline-width, 2px);--_hover-outline-color: var(--md-checkbox-hover-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-outline-width: var(--md-checkbox-hover-outline-width, 2px);--_hover-state-layer-color: var(--md-checkbox-hover-state-layer-color, var(--md-sys-color-on-surface, #1d1b20));--_hover-state-layer-opacity: var(--md-checkbox-hover-state-layer-opacity, 0.08);--_outline-color: var(--md-checkbox-outline-color, var(--md-sys-color-on-surface-variant, #49454f));--_outline-width: var(--md-checkbox-outline-width, 2px);--_pressed-outline-color: var(--md-checkbox-pressed-outline-color, var(--md-sys-color-on-surface, #1d1b20));--_pressed-outline-width: var(--md-checkbox-pressed-outline-width, 2px);--_pressed-state-layer-color: var(--md-checkbox-pressed-state-layer-color, var(--md-sys-color-primary, #6750a4));--_pressed-state-layer-opacity: var(--md-checkbox-pressed-state-layer-opacity, 0.12);--_container-shape-start-start: var( --md-checkbox-container-shape-start-start, var(--_container-shape) );--_container-shape-start-end: var( --md-checkbox-container-shape-start-end, var(--_container-shape) );--_container-shape-end-end: var( --md-checkbox-container-shape-end-end, var(--_container-shape) );--_container-shape-end-start: var( --md-checkbox-container-shape-end-start, var(--_container-shape) );border-start-start-radius:var(--_container-shape-start-start);border-start-end-radius:var(--_container-shape-start-end);border-end-end-radius:var(--_container-shape-end-end);border-end-start-radius:var(--_container-shape-end-start);display:inline-flex;height:var(--_container-size);position:relative;vertical-align:top;width:var(--_container-size);-webkit-tap-highlight-color:rgba(0,0,0,0)}:host([touch-target=wrapper]){margin:max(0px,(48px - var(--_container-size))/2)}md-focus-ring{height:44px;inset:unset;width:44px}input{appearance:none;height:48px;margin:0;opacity:0;outline:none;position:absolute;width:48px;z-index:1}:host([touch-target=none]) input{height:100%;width:100%}.container{border-radius:inherit;display:flex;height:100%;place-content:center;place-items:center;position:relative;width:100%}.outline,.background,.icon{inset:0;position:absolute}.outline,.background{border-radius:inherit}.outline{border-color:var(--_outline-color);border-style:solid;border-width:var(--_outline-width);box-sizing:border-box}.background{background-color:var(--_selected-container-color)}.background,.icon{opacity:0;transition-duration:150ms,50ms;transition-property:transform,opacity;transition-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15),linear;transform:scale(0.6)}:where(.selected) :is(.background,.icon){opacity:1;transition-duration:350ms,50ms;transition-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1),linear;transform:scale(1)}md-ripple{border-radius:var(--_state-layer-shape);height:var(--_state-layer-size);inset:unset;width:var(--_state-layer-size);--md-ripple-hover-color: var(--_hover-state-layer-color);--md-ripple-hover-opacity: var(--_hover-state-layer-opacity);--md-ripple-pressed-color: var(--_pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_pressed-state-layer-opacity)}.selected md-ripple{--md-ripple-hover-color: var(--_selected-hover-state-layer-color);--md-ripple-hover-opacity: var(--_selected-hover-state-layer-opacity);--md-ripple-pressed-color: var(--_selected-pressed-state-layer-color);--md-ripple-pressed-opacity: var(--_selected-pressed-state-layer-opacity)}.icon{fill:var(--_selected-icon-color);height:var(--_icon-size);width:var(--_icon-size)}.mark.short{height:2px;transition-property:transform,height;width:2px}.mark.long{height:2px;transition-property:transform,width;width:10px}.mark{animation-duration:150ms;animation-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15);transition-duration:150ms;transition-timing-function:cubic-bezier(0.3, 0, 0.8, 0.15)}.selected .mark{animation-duration:350ms;animation-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1);transition-duration:350ms;transition-timing-function:cubic-bezier(0.05, 0.7, 0.1, 1)}.checked .mark,.prev-checked.unselected .mark{transform:scaleY(-1) translate(7px, -14px) rotate(45deg)}.checked .mark.short,.prev-checked.unselected .mark.short{height:5.6568542495px}.checked .mark.long,.prev-checked.unselected .mark.long{width:11.313708499px}.indeterminate .mark,.prev-indeterminate.unselected .mark{transform:scaleY(-1) translate(4px, -10px) rotate(0deg)}.prev-unselected .mark{transition-property:none}.prev-unselected.checked .mark.long{animation-name:prev-unselected-to-checked}@keyframes prev-unselected-to-checked{from{width:0}}:where(:hover) .outline{border-color:var(--_hover-outline-color);border-width:var(--_hover-outline-width)}:where(:hover) .background{background:var(--_selected-hover-container-color)}:where(:hover) .icon{fill:var(--_selected-hover-icon-color)}:where(:focus-within) .outline{border-color:var(--_focus-outline-color);border-width:var(--_focus-outline-width)}:where(:focus-within) .background{background:var(--_selected-focus-container-color)}:where(:focus-within) .icon{fill:var(--_selected-focus-icon-color)}:where(:active) .outline{border-color:var(--_pressed-outline-color);border-width:var(--_pressed-outline-width)}:where(:active) .background{background:var(--_selected-pressed-container-color)}:where(:active) .icon{fill:var(--_selected-pressed-icon-color)}:where(.disabled,.prev-disabled) :is(.background,.icon,.mark){animation-duration:0s;transition-duration:0s}:where(.disabled) .outline{border-color:var(--_disabled-outline-color);border-width:var(--_disabled-outline-width);opacity:var(--_disabled-container-opacity)}:where(.selected.disabled) .outline{visibility:hidden}:where(.selected.disabled) .background{background:var(--_selected-disabled-container-color);opacity:var(--_selected-disabled-container-opacity)}:where(.disabled) .icon{fill:var(--_selected-disabled-icon-color)}@media(forced-colors: active){.background{background-color:CanvasText}.selected.disabled .background{background-color:GrayText;opacity:1}.outline{border-color:CanvasText}.disabled .outline{border-color:GrayText;opacity:1}.icon{fill:Canvas}}/*# sourceMappingURL=checkbox-styles.css.map */
`;


let $61c4ec917f8ce3ef$export$344e18d56fb6c2bd = class MdCheckbox extends (0, $55c0bb6004e8e175$export$48513f6b9f8ce62d) {
};
$61c4ec917f8ce3ef$export$344e18d56fb6c2bd.styles = [
    (0, $81272e3f067308e1$export$9dd6ff9ea0189349)
];
$61c4ec917f8ce3ef$export$344e18d56fb6c2bd = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-checkbox")
], $61c4ec917f8ce3ef$export$344e18d56fb6c2bd);


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $3cc2dfe75baea183$export$f04a61298a47a40f extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    connectedCallback() {
        super.connectedCallback();
        const ariaHidden = this.getAttribute("aria-hidden");
        if (ariaHidden === "false") {
            // Allow the user to set `aria-hidden="false"` to create an icon that is
            // announced by screenreaders.
            this.removeAttribute("aria-hidden");
            return;
        }
        // Needed for VoiceOver, which will create a "group" if the element is a
        // sibling to other content.
        this.setAttribute("aria-hidden", "true");
    }
}


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $9bf86e0f1a7a083d$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`:host{font-size:24px;width:24px;height:24px;color:inherit;font-variation-settings:inherit;font-weight:400;font-family:var(--md-icon-font, Material Symbols Outlined);display:inline-flex;font-style:normal;line-height:1;overflow:hidden;letter-spacing:normal;text-transform:none;user-select:none;white-space:nowrap;word-wrap:normal;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale}::slotted(svg){fill:currentColor}::slotted(*){height:100%;width:100%}/*# sourceMappingURL=icon-styles.css.map */
`;


let $1ac5c82b7e8476aa$export$7e69d8f77196ea34 = class MdIcon extends (0, $3cc2dfe75baea183$export$f04a61298a47a40f) {
};
/** @nocollapse */ $1ac5c82b7e8476aa$export$7e69d8f77196ea34.styles = [
    (0, $9bf86e0f1a7a083d$export$9dd6ff9ea0189349)
];
$1ac5c82b7e8476aa$export$7e69d8f77196ea34 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-icon")
], $1ac5c82b7e8476aa$export$7e69d8f77196ea34);


class $db477ee5a00a3a1f$export$9e15be805f9105a1 extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    connectedCallback() {
        super.connectedCallback();
        this.role = "column-header";
        this.slot = "header-cell";
    }
    /** @internal */ get checkbox() {
        return this.checkboxSlotElements?.[0];
    }
    constructor(){
        super();
        /**
         * Column type. If `checkbox`, the checkbox inside the column will be also created if not supplied via the default slot.
         * If `numeric`, the column label will be aligned to the right.
         */ this.type = "";
        /**
         * Whether the column can be sorted.
         */ this.sortable = false;
        /**
         * Whether the column is sorted.
         */ this.sorted = false;
        /**
         * Whether the column is sorted descending.
         */ this.sortedDescending = false;
        /**
         * Whether the column is displaying a sort button.
         */ this.withSortButton = false;
        /**
         * Whether the column is using a custom sorting function. If true, the column will not sort automatically and
         * you will need to handle the sorting yourself (see `sort` event).
         */ this.customSorting = false;
        /**
         * Whether the column can be filtered.
         */ this.filterable = false;
        /**
         * Label to show on the filter textfield.
         */ this.filterTextFieldLabel = "Filter";
        /**
         * Sets the filtering to be case-sensitive.
         */ this.filterCaseSensitive = false;
        /**
         * Whether the column is using a custom filtering function. If true, the column will not filter automatically and
         * you will need to handle the filtering yourself (see `filter` event).
         */ this.customFiltering = false;
        this.addEventListener("click", ()=>{
            this.withSortButton = !this.withSortButton;
        });
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        ${this.renderCheckbox()}
        ${this.renderSlot()}
    `;
    }
    renderCheckbox() {
        if (this.type === "checkbox") return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <slot name="checkbox" @slotchange=${this.onCheckboxSlotChanged}>
              <md-checkbox
                      class="mdc-data-table__header-row-checkbox"
                      @change=${this.onCheckboxClicked}
                      touch-target="wrapper"
                      aria-label="Toggle all rows"></md-checkbox>
          </slot>
      `;
        return "";
    }
    renderFilterTextField() {
        if (this.filterable && this.type !== "checkbox") return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <slot name="filter-textfield" class="mdc-data-table__filter-textfield">
              <md-outlined-text-field
                      label="${this.filterTextFieldLabel}"
                      style="--md-outlined-text-field-top-space: var(--_pagination-outlined-select-field-top-space); --md-outlined-text-field-bottom-space: var(--_pagination-outlined-select-field-bottom-space);"
                      @input=${this.onFilterTextFieldInput}
                      @keydown=${this.onFilterTextFieldKeyDown}
                      @click="${(e)=>e.stopPropagation()}"
              />
          </slot>
      `;
        return 0, $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    renderSlot() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div class="mdc-data-table__header-cell-filter-wrapper">
            ${this.sortable ? this.renderSortButton() : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <slot class="mdc-data-table__header-cell-label"></slot>`}
            ${this.renderFilterTextField()}
        </div>
    `;
    }
    renderSortButton() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div class="mdc-data-table__header-cell-wrapper">
            <md-icon-button ?selected=${this.sortedDescending}
                                     toggle
                                     @change=${this.onSortButtonClicked}
                                     @click="${(e)=>e.stopPropagation()}"
                                     aria-hidden="${this.withSortButton ? "false" : "true"}"
                                     ?hidden="${!this.withSortButton}">
                <slot name="sort-icon-on" slot="selected">
                    <md-icon>arrow_downward</md-icon>
                </slot>
                <slot name="sort-icon-off">
                    <md-icon>arrow_upward</md-icon>
                </slot>
            </md-icon-button>
            &nbsp;
            <slot class="mdc-data-table__header-cell-label"></slot>
        </div>
    `;
    }
    /** @internal */ onCheckboxClicked(e) {
        const checkbox = e.target;
        /**
         * Event emitted when the column checkbox has been checked or unchecked.
         *
         * Event detail: `CellCheckedEventDetail`;
         */ this.dispatchEvent(new CustomEvent("checked", {
            detail: {
                checked: checkbox.checked ?? false
            }
        }));
    }
    onCheckboxSlotChanged() {
        this.checkbox?.removeEventListener("change", this.onCheckboxClicked);
        this.checkbox?.addEventListener("change", this.onCheckboxClicked);
    }
    /** @internal */ onFilterTextFieldInput(e) {
        const textfield = e.target;
        /**
         * Event emitted when the user has typed in column filter textfield.
         *
         * Event detail: `FilterTextFieldInputEventDetail`;
         */ this.dispatchEvent(new CustomEvent("filter", {
            detail: {
                field: textfield,
                text: textfield.value,
                column: this,
                caseSensitive: this.filterCaseSensitive,
                customFiltering: this.customFiltering
            }
        }));
    }
    /** @internal */ onFilterTextFieldKeyDown(e) {
        const textfield = e.target;
        /**
         * Event emitted when the user has typed in column filter textfield.
         *
         * Event detail: `FilterTextFieldKeyDownEventDetail`;
         */ this.dispatchEvent(new CustomEvent("keydown", {
            detail: {
                field: textfield,
                key: e.key,
                column: this
            }
        }));
    }
    /** @internal */ onSortButtonClicked(e) {
        this.sortedDescending = this.sortButton?.selected ?? false;
        /**
         * Event emitted when the user has typed in column filter textfield.
         *
         * Event detail: `SortButtonClickedEventDetail`;
         */ this.dispatchEvent(new CustomEvent("sort", {
            detail: {
                column: this,
                isDescending: this.sortedDescending,
                customSorting: this.customSorting
            }
        }));
    }
    updated(_changedProperties) {
        if (_changedProperties.has("sorted")) this.withSortButton = this.sortable && this.sorted;
        super.updated(_changedProperties);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "sortable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "sorted", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "sorted-descending"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "sortedDescending", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "with-sort-button"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "withSortButton", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "custom-sorting"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "customSorting", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "filterable", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "filter-text-field-label"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "filterTextFieldLabel", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true,
        attribute: "filter-case-sensitive"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "filterCaseSensitive", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        attribute: "custom-filtering"
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "customFiltering", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("md-icon-button")
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "sortButton", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        slot: "checkbox",
        flatten: true
    })
], $db477ee5a00a3a1f$export$9e15be805f9105a1.prototype, "checkboxSlotElements", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $f03383f120cb1b9d$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);border-width:1px;border-style:solid;border-color:rgba(0,0,0,.12);-webkit-overflow-scrolling:touch;display:inline-flex;flex-direction:column;box-sizing:border-box;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px);border-top-right-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child[dir=rtl]{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px);border-bottom-left-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child[dir=rtl]{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px);border-bottom-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell,:host{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-data-table__row--selected{background-color:rgba(98, 0, 238, 0.04)}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.12)}.mdc-data-table__cell,.mdc-data-table__header-cell,:host{border-bottom-color:rgba(0,0,0,.12)}.mdc-data-table__pagination{border-top-color:rgba(0,0,0,.12)}.mdc-data-table__cell,.mdc-data-table__header-cell,:host{border-bottom-width:1px;border-bottom-style:solid}.mdc-data-table__pagination{border-top-width:1px;border-top-style:solid}.mdc-data-table__row:last-child .mdc-data-table__cell{border-bottom:none}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:rgba(0, 0, 0, 0.04)}.mdc-data-table__header-cell,:host{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__row{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-row{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell,:host{padding:0 16px 0 16px}.mdc-data-table__header-cell--checkbox,:host([type=checkbox]),.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,[dir=rtl] :host([type=checkbox]),[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;overflow-x:auto;width:100%}.mdc-data-table__table{min-width:100%;border:0;white-space:nowrap;border-spacing:0;table-layout:fixed}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;overflow:hidden;text-align:left;text-overflow:ellipsis}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl]{text-align:right}.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell,:host{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;outline:none;text-align:left}[dir=rtl] .mdc-data-table__header-cell,[dir=rtl] :host,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox,:host([type=checkbox]){width:1px}.mdc-data-table__header-cell--numeric,:host([type=numeric]){text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,[dir=rtl] :host([type=numeric]),.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{width:28px;height:28px;padding:2px;transform:rotate(0.0001deg);margin-left:4px;margin-right:0;transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}.mdc-data-table__sort-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:28px;max-width:28px}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid rgba(0,0,0,0);border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid rgba(0,0,0,0);border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:28px;height:28px;margin-top:0px;margin-bottom:0px;margin-right:0px;margin-left:0px}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:28px;max-width:28px}.mdc-data-table__sort-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:28px;left:50%;width:28px;transform:translate(-50%, -50%)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,:host([type=numeric]) .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,[dir=rtl] :host([type=numeric]) .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl],:host([type=numeric]) .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button,:host([sortedDescending]) .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button,:host([sorted]) .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{align-items:center;display:inline-flex;vertical-align:middle}.mdc-data-table__header-cell--with-sort,:host([sortable]){cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.mdc-data-table--sticky-header .mdc-data-table__header-cell,.mdc-data-table--sticky-header :host{position:sticky;top:0;z-index:1}.mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.6)}.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.6);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.6))}.mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button,:host([sorted]) .mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,:host([sorted]) .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after,:host([sorted]) .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,:host([sorted]) .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before,:host([sorted]) .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,:host([sorted]) .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before,:host([sorted]) .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after,:host([sorted]) .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after,:host([sorted]) .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded,:host([sorted]) .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__progress-indicator{display:none;position:absolute;width:100%}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);height:100%;opacity:.32;position:absolute;top:0;width:100%}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;display:flex;justify-content:flex-end}.mdc-data-table__pagination-trailing{margin-left:4px;margin-right:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-end}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{margin-left:14px;margin-right:36px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{margin-left:0;margin-right:22px;align-items:center;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{margin-left:0;margin-right:12px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:80px;min-width:var(--mdc-menu-min-width, 80px);margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-36px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-list-item.mdc-list-item--with-one-line{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}:host{display:table-cell;vertical-align:inherit;background-color:var(--_header-container-color);height:var(--_header-container-height);color:var(--_header-headline-color);font-family:var(--_header-headline-font);line-height:var(--_header-headline-line-height);font-size:var(--_header-headline-size);letter-spacing:var(--_header-headline-tracking);font-weight:var(--_header-headline-weight);border-bottom:var(--_row-item-outline-width) solid var(--_row-item-outline-color)}:host(:first-of-type){border-top-left-radius:var(--_container-shape)}:host(:last-of-type){border-top-right-radius:var(--_container-shape)}:host(:hover){color:var(--_header-headline-hover-color)}:host([type=checkbox]){padding:0 6px;width:50px}:host([sortable]) md-icon-button:hover{--md-icon-button-unselected-icon-color: var(--_header-hover-sorting-icon-button-color)}:host([sortable]) md-icon-button[hidden]{display:none}:host([filterable]):not([type=checkbox]){padding:8px 16px}:host([filterable]) .mdc-data-table__header-cell-filter-wrapper{flex-direction:column;display:flex;align-items:center;padding:8px 0}:host([filterable]) .mdc-data-table__header-cell-label{white-space:nowrap}:host([filterable]) .mdc-data-table__header-cell-filter-textfield{width:fit-content}/*# sourceMappingURL=data-table-column.css.map */
`;


let $588eef6b34c797bd$export$173b29e8b5079016 = class MdDataTableColumn extends (0, $db477ee5a00a3a1f$export$9e15be805f9105a1) {
};
$588eef6b34c797bd$export$173b29e8b5079016.styles = [
    (0, $f03383f120cb1b9d$export$9dd6ff9ea0189349)
];
$588eef6b34c797bd$export$173b29e8b5079016 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-data-table-column")
], $588eef6b34c797bd$export$173b29e8b5079016);









class $415c167c6b5f97e1$export$7836bdde8bddabaa extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.onCheckboxClicked = (e)=>{
            const checkbox = e.target;
            this.dispatchEvent(new CustomEvent("checked", {
                detail: {
                    checked: checkbox.checked
                }
            }));
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.role = "cell";
    }
    /** @internal */ get checkbox() {
        return this.checkboxSlotElements?.[0];
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <slot @slotchange=${this.onSlotChanged}>${this.renderCheckbox()}</slot>
    `;
    }
    renderCheckbox() {
        if (this.type === "checkbox") return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-checkbox class="mdc-data-table__row-checkbox" touch-target="wrapper" @change=${this.onCheckboxClicked}></md-checkbox>`;
        return "";
    }
    onSlotChanged() {
        this.requestUpdate();
        this.checkbox?.removeEventListener("change", this.onCheckboxClicked);
        this.checkbox?.addEventListener("change", this.onCheckboxClicked);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $415c167c6b5f97e1$export$7836bdde8bddabaa.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $43ca3aec390b0561$export$4682af2d9ee91415)({
        selector: "md-checkbox",
        flatten: true
    })
], $415c167c6b5f97e1$export$7836bdde8bddabaa.prototype, "checkboxSlotElements", void 0);


/**
  * @license
  * Copyright 2022 Google LLC
  * SPDX-License-Identifier: Apache-2.0
  */ 
const $c090f5bcdbda42f7$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);border-radius:4px;border-radius:var(--mdc-shape-medium, 4px);border-width:1px;border-style:solid;border-color:rgba(0,0,0,.12);-webkit-overflow-scrolling:touch;display:inline-flex;flex-direction:column;box-sizing:border-box;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium, 4px);border-top-right-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:first-child[dir=rtl]{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px);border-bottom-left-radius:0}.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-medium, 4px)}[dir=rtl] .mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child,.mdc-data-table.mdc-data-table--without-footer .mdc-data-table__row:last-child .mdc-data-table__cell:last-child[dir=rtl]{border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-medium, 4px);border-bottom-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-data-table__row--selected{background-color:rgba(98, 0, 238, 0.04)}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.12)}.mdc-data-table__cell,:host,.mdc-data-table__header-cell{border-bottom-color:rgba(0,0,0,.12)}.mdc-data-table__pagination{border-top-color:rgba(0,0,0,.12)}.mdc-data-table__cell,:host,.mdc-data-table__header-cell{border-bottom-width:1px;border-bottom-style:solid}.mdc-data-table__pagination{border-top-width:1px;border-top-style:solid}.mdc-data-table__row:last-child .mdc-data-table__cell,.mdc-data-table__row:last-child :host{border-bottom:none}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:rgba(0, 0, 0, 0.04)}.mdc-data-table__header-cell{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell,:host{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__row{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-row{height:56px}.mdc-data-table__cell,:host,.mdc-data-table__header-cell{padding:0 16px 0 16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox,:host([type=checkbox]){padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,[dir=rtl] .mdc-data-table__cell--checkbox,[dir=rtl] :host([type=checkbox]),.mdc-data-table__header-cell--checkbox[dir=rtl],.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;overflow-x:auto;width:100%}.mdc-data-table__table{min-width:100%;border:0;white-space:nowrap;border-spacing:0;table-layout:fixed}.mdc-data-table__cell,:host{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;overflow:hidden;text-align:left;text-overflow:ellipsis}[dir=rtl] .mdc-data-table__cell,[dir=rtl] :host,.mdc-data-table__cell[dir=rtl]{text-align:right}.mdc-data-table__cell--numeric,:host([type=numeric]){text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,[dir=rtl] :host([type=numeric]),.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox,:host([type=checkbox]){width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-subtitle2-font-size, 0.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height, 1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight, 500);letter-spacing:0.0071428571em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing, 0.0071428571em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform, inherit);box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;outline:none;text-align:left}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{width:28px;height:28px;padding:2px;transform:rotate(0.0001deg);margin-left:4px;margin-right:0;transition:transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}.mdc-data-table__sort-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:28px;max-width:28px}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid rgba(0,0,0,0);border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid rgba(0,0,0,0);border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:28px;height:28px;margin-top:0px;margin-bottom:0px;margin-right:0px;margin-left:0px}.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-data-table__sort-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:28px;max-width:28px}.mdc-data-table__sort-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:28px;left:50%;width:28px;transform:translate(-50%, -50%)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{align-items:center;display:inline-flex;vertical-align:middle}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px, 1px, 1px, 1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.mdc-data-table--sticky-header .mdc-data-table__header-cell{position:sticky;top:0;z-index:1}.mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.6)}.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.6);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.6))}.mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:rgba(0, 0, 0, 0.87)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button .mdc-icon-button__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__progress-indicator{display:none;position:absolute;width:100%}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface, #fff);height:100%;opacity:.32;position:absolute;top:0;width:100%}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);box-sizing:border-box;display:flex;justify-content:flex-end}.mdc-data-table__pagination-trailing{margin-left:4px;margin-right:0;align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-end}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{margin-left:14px;margin-right:36px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{margin-left:0;margin-right:22px;align-items:center;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{margin-left:0;margin-right:12px;white-space:nowrap}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:80px;min-width:var(--mdc-menu-min-width, 80px);margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-select-outlined-36px 250ms 1}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-list-item.mdc-list-item--with-one-line{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #6200ee))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}:host{display:table-cell;vertical-align:inherit;color:var(--_row-item-label-text-color);font-family:var(--_row-item-label-text-font);font-size:var(--_row-item-label-text-size);line-height:var(--_row-item-label-text-line-height);font-weight:var(--_row-item-label-text-weight);letter-spacing:var(--_row-item-label-text-tracking);border-bottom:var(--_row-item-outline-width) solid var(--_row-item-outline-color)}:host([type=checkbox]){padding:0 6px;width:50px}/*# sourceMappingURL=data-table-cell.css.map */
`;


let $ac725a0a5d1ac76f$export$cbdf25a127905dab = class MdDataTableCell extends (0, $415c167c6b5f97e1$export$7836bdde8bddabaa) {
};
$ac725a0a5d1ac76f$export$cbdf25a127905dab.styles = [
    (0, $c090f5bcdbda42f7$export$9dd6ff9ea0189349)
];
$ac725a0a5d1ac76f$export$cbdf25a127905dab = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("md-data-table-cell")
], $ac725a0a5d1ac76f$export$cbdf25a127905dab);







/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 






class $a39570f77cd8a4e3$export$88f8f840a3f2e46c extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.indeterminate = false;
        this.progress = 0;
        this.density = 0;
        this.closed = false;
    }
    open() {
        this.closed = false;
    }
    close() {
        this.closed = true;
    }
    /**
     * @soyTemplate
     */ render() {
        /** @classMap */ const classes = {
            "mdc-circular-progress--closed": this.closed,
            "mdc-circular-progress--indeterminate": this.indeterminate
        };
        const containerSideLength = 48 + this.density * 4;
        /** @styleMap */ const styles = {
            "width": `${containerSideLength}px`,
            "height": `${containerSideLength}px`
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div
        class="mdc-circular-progress ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
        style="${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(styles)}"
        role="progressbar"
        aria-label="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.ariaLabel)}"
        aria-valuemin="0"
        aria-valuemax="1"
        aria-valuenow="${(0, $4b98a879c21ea1bd$export$f68dd208b5df064d)(this.indeterminate ? undefined : this.progress)}">
        ${this.renderDeterminateContainer()}
        ${this.renderIndeterminateContainer()}
      </div>`;
    }
    /**
     * @soyTemplate
     */ renderDeterminateContainer() {
        const sideLength = 48 + this.density * 4;
        const center = sideLength / 2;
        const circleRadius = this.density >= -3 ? 18 + this.density * 11 / 6 : 12.5 + (this.density + 3) * 5 / 4;
        const circumference = 6.2831852 * circleRadius;
        const determinateStrokeDashOffset = (1 - this.progress) * circumference;
        const strokeWidth = this.density >= -3 ? 4 + this.density * (1 / 3) : 3 + (this.density + 3) * (1 / 6);
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-circular-progress__determinate-container">
        <svg class="mdc-circular-progress__determinate-circle-graphic"
             viewBox="0 0 ${sideLength} ${sideLength}">
          <circle class="mdc-circular-progress__determinate-track"
                  cx="${center}" cy="${center}" r="${circleRadius}"
                  stroke-width="${strokeWidth}"></circle>
          <circle class="mdc-circular-progress__determinate-circle"
                  cx="${center}" cy="${center}" r="${circleRadius}"
                  stroke-dasharray="${6.2831852 * circleRadius}"
                  stroke-dashoffset="${determinateStrokeDashOffset}"
                  stroke-width="${strokeWidth}"></circle>
        </svg>
      </div>`;
    }
    /**
     * @soyTemplate
     */ renderIndeterminateContainer() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-circular-progress__indeterminate-container">
        <div class="mdc-circular-progress__spinner-layer">
          ${this.renderIndeterminateSpinnerLayer()}
        </div>
      </div>`;
    }
    /**
     * @soyTemplate
     */ renderIndeterminateSpinnerLayer() {
        const sideLength = 48 + this.density * 4;
        const center = sideLength / 2;
        const circleRadius = this.density >= -3 ? 18 + this.density * 11 / 6 : 12.5 + (this.density + 3) * 5 / 4;
        const circumference = 6.2831852 * circleRadius;
        const halfCircumference = 0.5 * circumference;
        const strokeWidth = this.density >= -3 ? 4 + this.density * (1 / 3) : 3 + (this.density + 3) * (1 / 6);
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <div class="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left">
          <svg class="mdc-circular-progress__indeterminate-circle-graphic"
               viewBox="0 0 ${sideLength} ${sideLength}">
            <circle cx="${center}" cy="${center}" r="${circleRadius}"
                    stroke-dasharray="${circumference}"
                    stroke-dashoffset="${halfCircumference}"
                    stroke-width="${strokeWidth}"></circle>
          </svg>
        </div>
        <div class="mdc-circular-progress__gap-patch">
          <svg class="mdc-circular-progress__indeterminate-circle-graphic"
               viewBox="0 0 ${sideLength} ${sideLength}">
            <circle cx="${center}" cy="${center}" r="${circleRadius}"
                    stroke-dasharray="${circumference}"
                    stroke-dashoffset="${halfCircumference}"
                    stroke-width="${strokeWidth * 0.8}"></circle>
          </svg>
        </div>
        <div class="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right">
          <svg class="mdc-circular-progress__indeterminate-circle-graphic"
               viewBox="0 0 ${sideLength} ${sideLength}">
            <circle cx="${center}" cy="${center}" r="${circleRadius}"
                    stroke-dasharray="${circumference}"
                    stroke-dashoffset="${halfCircumference}"
                    stroke-width="${strokeWidth}"></circle>
          </svg>
        </div>`;
    }
    update(changedProperties) {
        super.update(changedProperties);
        // Bound progress value in interval [0, 1].
        if (changedProperties.has("progress")) {
            if (this.progress > 1) this.progress = 1;
            if (this.progress < 0) this.progress = 0;
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a39570f77cd8a4e3$export$88f8f840a3f2e46c.prototype, "indeterminate", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $a39570f77cd8a4e3$export$88f8f840a3f2e46c.prototype, "progress", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $a39570f77cd8a4e3$export$88f8f840a3f2e46c.prototype, "density", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a39570f77cd8a4e3$export$88f8f840a3f2e46c.prototype, "closed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e35ac34f4dd92dd0$export$ae33cbacf67da030),
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String,
        attribute: "aria-label"
    })
], $a39570f77cd8a4e3$export$88f8f840a3f2e46c.prototype, "ariaLabel", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $b00684df332d76a1$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-circular-progress__determinate-circle,.mdc-circular-progress__indeterminate-circle-graphic{stroke:#6200ee;stroke:var(--mdc-theme-primary, #6200ee)}.mdc-circular-progress__determinate-track{stroke:transparent}@keyframes mdc-circular-progress-container-rotate{to{transform:rotate(360deg)}}@keyframes mdc-circular-progress-spinner-layer-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}}@keyframes mdc-circular-progress-color-1-fade-in-out{from{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdc-circular-progress-color-2-fade-in-out{from{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-3-fade-in-out{from{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-4-fade-in-out{from{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}@keyframes mdc-circular-progress-left-spin{from{transform:rotate(265deg)}50%{transform:rotate(130deg)}to{transform:rotate(265deg)}}@keyframes mdc-circular-progress-right-spin{from{transform:rotate(-265deg)}50%{transform:rotate(-130deg)}to{transform:rotate(-265deg)}}.mdc-circular-progress{display:inline-flex;position:relative;direction:ltr;line-height:0;transition:opacity 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-circular-progress__determinate-container,.mdc-circular-progress__indeterminate-circle-graphic,.mdc-circular-progress__indeterminate-container,.mdc-circular-progress__spinner-layer{position:absolute;width:100%;height:100%}.mdc-circular-progress__determinate-container{transform:rotate(-90deg)}.mdc-circular-progress__indeterminate-container{font-size:0;letter-spacing:0;white-space:nowrap;opacity:0}.mdc-circular-progress__determinate-circle-graphic,.mdc-circular-progress__indeterminate-circle-graphic{fill:transparent}.mdc-circular-progress__determinate-circle{transition:stroke-dashoffset 500ms 0ms cubic-bezier(0, 0, 0.2, 1)}.mdc-circular-progress__gap-patch{position:absolute;top:0;left:47.5%;box-sizing:border-box;width:5%;height:100%;overflow:hidden}.mdc-circular-progress__gap-patch .mdc-circular-progress__indeterminate-circle-graphic{left:-900%;width:2000%;transform:rotate(180deg)}.mdc-circular-progress__circle-clipper{display:inline-flex;position:relative;width:50%;height:100%;overflow:hidden}.mdc-circular-progress__circle-clipper .mdc-circular-progress__indeterminate-circle-graphic{width:200%}.mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{left:-100%}.mdc-circular-progress--indeterminate .mdc-circular-progress__determinate-container{opacity:0}.mdc-circular-progress--indeterminate .mdc-circular-progress__indeterminate-container{opacity:1}.mdc-circular-progress--indeterminate .mdc-circular-progress__indeterminate-container{animation:mdc-circular-progress-container-rotate 1568.2352941176ms linear infinite}.mdc-circular-progress--indeterminate .mdc-circular-progress__spinner-layer{animation:mdc-circular-progress-spinner-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-1{animation:mdc-circular-progress-spinner-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both,mdc-circular-progress-color-1-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-2{animation:mdc-circular-progress-spinner-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both,mdc-circular-progress-color-2-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-3{animation:mdc-circular-progress-spinner-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both,mdc-circular-progress-color-3-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-4{animation:mdc-circular-progress-spinner-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both,mdc-circular-progress-color-4-fade-in-out 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-left .mdc-circular-progress__indeterminate-circle-graphic{animation:mdc-circular-progress-left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{animation:mdc-circular-progress-right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both}.mdc-circular-progress--closed{opacity:0}:host{display:inline-flex}.mdc-circular-progress__determinate-track{stroke:transparent;stroke:var(--mdc-circular-progress-track-color, transparent)}`;


/** @soyCompatible */ let $96b4653441ac8c85$export$9e72f56a493060bf = class CircularProgress extends (0, $a39570f77cd8a4e3$export$88f8f840a3f2e46c) {
};
$96b4653441ac8c85$export$9e72f56a493060bf.styles = [
    (0, $b00684df332d76a1$export$9dd6ff9ea0189349)
];
$96b4653441ac8c85$export$9e72f56a493060bf = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-circular-progress")
], $96b4653441ac8c85$export$9e72f56a493060bf);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ /**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $a3c29da612ac4bde$var$DEFAULT_TIMEOUT_SECONDS = 600;
const $a3c29da612ac4bde$var$EXPONENTIAL_BACKOFF_EXPONENT = 3;
const $a3c29da612ac4bde$export$782df2acbe10b22c = async (url, options = {}, timeoutSeconds = $a3c29da612ac4bde$var$DEFAULT_TIMEOUT_SECONDS, retries = 3, retryCount = 0, exponentialBackoffExponent = $a3c29da612ac4bde$var$EXPONENTIAL_BACKOFF_EXPONENT)=>{
    try {
        console.log("TimeOut in", timeoutSeconds);
        const response = await Promise.race([
            fetch(url, options),
            new Promise((_resolve, reject)=>setTimeout(()=>reject(new Error(`Request timed out after ${timeoutSeconds} seconds.`)), timeoutSeconds * 1000))
        ]);
        if (response) {
            if (!response.ok) {
                if ([
                    429,
                    503
                ].includes(response.status) && retries > 0) {
                    retryCount++;
                    retries--;
                    // wait with exponential backoff
                    await $a3c29da612ac4bde$var$sleep(retryCount * exponentialBackoffExponent);
                    return $a3c29da612ac4bde$export$782df2acbe10b22c(url, options, timeoutSeconds, retries, retryCount, exponentialBackoffExponent);
                } else throw "Request failed";
            }
            return response;
        } else throw "No response";
    } catch (error) {
        if (error.message === "Timeout" || error.message === "Network request failed" || options.method === "GET" || options.method === "HEAD") {
            if (retries > 0) {
                retryCount++;
                retries--;
                // wait with exponential backoff
                await $a3c29da612ac4bde$var$sleep(retryCount ** exponentialBackoffExponent);
                return $a3c29da612ac4bde$export$782df2acbe10b22c(url, options, timeoutSeconds, retries, retryCount, exponentialBackoffExponent);
            }
        } else throw error;
    }
};
/**
 * Function to stop or interrupt process for the amount of seconds
 * @param seconds 
 * @returns 
 */ function $a3c29da612ac4bde$var$sleep(seconds) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}


var $123ae602cd787ad4$var$ReviewStatus;
/**
   * @enum
   * Enum for review status
   */ (function(ReviewStatus) {
    ReviewStatus["Uploaded"] = "hochgeladen";
    ReviewStatus["Processing"] = "wird verarbeitet";
    ReviewStatus["Processed"] = "in Bearbeitung";
    ReviewStatus["Hitl"] = "Dokument pr\xfcfen";
    ReviewStatus["Completed"] = "Dokument fertig verarbeitet";
    ReviewStatus["Downloaded"] = "heruntergeladen";
})($123ae602cd787ad4$var$ReviewStatus || ($123ae602cd787ad4$var$ReviewStatus = {}));
class $123ae602cd787ad4$export$2398eb31525b8be1 {
    /**
   * @constructor
   * @param {string} reviewRequestID - The unique identifier for the review-request
   * @param {ReviewRequestType} type - The type of the review request.
   * @param {string} clientName - The name of the client.
   * @param {string} clientId - The ID of the client.
   * @param {string} consultantName - The name of the consultant.
   * @param {string} consultantID - The ID of the consultant.
   * @param {string} originalFilename - The original filename.
   * @param {string} originalStatus - The original status.
   * @param {string} status - The status.
   * @param {string} createTime - The creation time.
   * @param {string} lastStatusUpdateTime - The last status update time.
   * @param {string} resultBucket - The result bucket.
   * @param {string} resultObject - The result object.
   * @param {string} callbackUrl - The callback URL for workflows.
   * @param {string} pageImageUrlPrefix - The page image URL prefix.
   * @param {Array<string>} [pageImageNames=[]] - The page image names.
   * @param {string} reviewedByUserId - The userid of the user which reviewed the document.
   * @param {string} uploadedByUserId - The userid of the user which uploaded the document.
   * @param {(EntityLabel[] | GroupingLabel[] | ClassificationLabel[])} [labels=[]] - The labels.
   * @param {Array<string>} [splittedPdfObjects=[]] - The splitted PDF objects.
   * @param {Array<any>} [reviewedEntities=[]] - The entities after review.
   * @param {Array<any>} [originalEntities=[]] - The entities before review.
   */ constructor(reviewRequestID, type, clientName, clientId, consultantName, consultantID, originalFilename, originalStatus, status, resultBucket, resultObject, callbackUrl, createTime, lastStatusUpdateTime, pageImageUrlPrefix, pageImageNames = [], reviewedByUserId, uploadedByUserId, labels = [], splittedPdfObjects = [], reviewedEntities, originalEntities){
        /**
   * The page image names
   */ this.pageImageNames = [];
        /**
   * The entities after review
   */ this.reviewedEntities = [];
        /**
   * The entities before the review
   */ this.originalEntities = [];
        this.reviewRequestID = reviewRequestID;
        this.type = type;
        this.clientName = clientName;
        this.clientId = clientId;
        this.consultantName = consultantName;
        this.consultantID = consultantID;
        this.originalFilename = originalFilename;
        this.originalStatus = originalStatus;
        this.status = status;
        switch(this.originalStatus){
            case "uploaded":
                this.status = "hochgeladen";
                break;
            case "processing":
                this.status = "wird verarbeitet";
                break;
            case "processed":
                this.status = "in Bearbeitung";
                break;
            case "hitl":
                this.status = "Dokument pr\xfcfen";
                break;
            case "completed":
                this.status = "Dokument fertig verarbeitet";
                break;
            case "downloaded":
                this.status = "heruntergeladen";
                break;
        }
        this.createTime = createTime;
        this.lastStatusUpdateTime = lastStatusUpdateTime;
        this.resultBucket = resultBucket;
        this.resultObject = resultObject;
        this.callbackUrl = callbackUrl;
        this.pageImageUrlPrefix = pageImageUrlPrefix;
        this.pageImageNames = pageImageNames;
        this.reviewedByUserId = reviewedByUserId;
        this.uploadedByUserId = uploadedByUserId;
        this.labels = labels;
        this.splittedPdfObjects = splittedPdfObjects;
        this.reviewedEntities = reviewedEntities;
        this.originalEntities = originalEntities;
    }
    /**
   * Lists all review requests from the database
   * @static
   * @async
   * @function list
   * @param {Database} database - Database object
   * @param {string} accessToken - Access token for database access
   * @returns {Promise<ReviewRequest[]>} - Promise resolving to an array of ReviewRequest objects
   */ static async list(database, accessToken) {
        let reviewRequests = [];
        const sql = `SELECT re.reviewRequestID,
      re.processorType,
      cl.name as clientName,
      cl.clientID,
      con.name as consultantName,
      con.consultantID,
      re.originalFilename,
      re.status,
      re.resultBucket,
      re.resultObject,
      re.callbackUrl,
      re.createTime,
      re.lastStatusUpdateTime,
      re.pageImageUrlPrefix,
      re.pageImageNames,
      re.reviewedByUserId,
      re.uploadedByUserId,
      re.labels,
      re.splittedPdfObjects,
      re.reviewedEntities,
      re.originalEntities
    FROM
        ReviewRequest re
    JOIN
        ReviewRequestConsultantClient reccl
    ON
        reccl.reviewRequestID = re.reviewRequestID
    JOIN
        Consultant con
    ON
        reccl.consultantID = con.consultantID
    JOIN
        Client cl
    ON
        reccl.clientID = cl.clientID;`;
        const rows = await database.read(accessToken, sql);
        rows.forEach((row)=>{
            let type;
            let labels;
            if (row.processorType === "CUSTOM_SPLITTING_PROCESSOR") {
                type = "DocSplitter";
                labels = JSON.parse(row.labels);
            } else if (row.processorType === "CUSTOM_CLASSIFICATION_PROCESSOR") {
                type = "DAI_COMPLEX_CLASSIFICATION";
                labels = JSON.parse(row.labels);
            } else {
                type = "Entity";
                labels = JSON.parse(row.labels);
            }
            const reviewRequest = new $123ae602cd787ad4$export$2398eb31525b8be1(row.reviewRequestID, type, row.clientName, row.clientID, row.consultantName, row.consultantID, row.originalFilename, row.status, "", row.resultBucket, row.resultObject, row.callbackUrl, row.createTime, row.lastStatusUpdateTime, row.pageImageUrlPrefix, row.pageImageNames, row.reviewedByUserId, row.uploadedByUserId, labels, row.splittedPdfObjects, row.reviewedEntities, row.originalEntities);
            reviewRequests.push(reviewRequest);
        });
        console.log("ReviewRequests", reviewRequests);
        return reviewRequests;
    }
    /**
   * Updates the status of the review request
   * @async   
   * @function updateStatus
   * @param {Database} database - Database object
   * @param {string} accessToken - Access token for database access
   * @param {string} status - New status for the review request
   */ async updateStatus(database, accessToken, status) {
        const sql = `UPDATE ReviewRequest SET status = '${status}' WHERE reviewRequestID = '${this.reviewRequestID}'`;
        database.readWrite(accessToken, sql);
        this.originalStatus = status;
    }
    /**
   * Deletes the review request from the database
   * @async
   * @function delete
   * @param {Database} database - Database object
   * @param {string} accessToken - Access token for database access
   */ async delete(database, accessToken) {
        const sql = `DELETE FROM ReviewRequest WHERE reviewRequestID = '${this.reviewRequestID}'`;
        database.readWrite(accessToken, sql);
    }
    /**
   * Deletes multiple review requests from the database
   * @static
   * @async
   * @function deleteReviewRequests   
   * @param {Database} database - Database object
   * @param {string} accessToken - Access token for database access
   * @param {Array<string>} selectedReviewRequestsIDs - Array of review request IDs to delete
   */ static async deleteReviewRequests(database, accessToken, selectedReviewRequestsIDs) {
        const sql = `DELETE FROM ReviewRequest WHERE reviewRequestID IN ('${selectedReviewRequestsIDs.join("','")}')`;
        database.readWrite(accessToken, sql);
    }
    /**
  * Fetches the content of the review request from the specified URL
  * @async
  * @function getContent
  * @param {string} accessToken - Access token for fetching content
  * @returns {Promise<any>} - Promise resolving to the fetched content
  */ async getContent(accessToken) {
        const url = "https://" + this.resultBucket + ".storage.googleapis.com/" + this.resultObject;
        console.log("url: " + url);
        const response = await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(url, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
        if (!response.ok) throw response;
        const json = await response.json();
        return json;
    }
    /**
   * Saves content to the specified URL
   * @async 
   * @function saveContent
   * @param {string} accessToken - Access token for saving content
   * @param {string} content - Content to be saved
   * @returns {Promise<void>} - Promise indicating completion of the save operation
   */ async saveContent(accessToken, content, rejectReason = null) {
        // save content to GCS
        let url;
        url = `https://storage.googleapis.com/${this.resultBucket}/${this.resultObject}`;
        await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json"
            },
            body: content
        });
        // trigger Workflow callback
        url = this.callbackUrl;
        await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                reviewedByUserId: this.reviewedByUserId
            })
        });
    }
}




let $ae667ea854f4f8f2$export$7dd18cbe7c946e5f = class HitlReviewRequests extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
  
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }
    html, body {
      --mdc-data-table-width: 70.0vmin;
    }

    md-data-table {
      width: 95.0vw;
    }

    md-data-table-footer {
      gap: 10px;
      align-items: center;
    }

    mwc-button {
      margin-top: 8px;
      font-size: 2.4vmin;
    }

    md-data-table-cell {
      
      background-color: #ffffff;
      
    }

    md-data-table-column {
      background-color: #ffffff;
      
      overflow: hidden;
    }

    mdc-data-table-footer {
      background-color: #ffffff;
      font-size: 2.6vmin;
    }

    mwc-circular-progress{
        justify-content: center;
    }

  `;
    constructor(){
        super();
        /**
   * Selected review-requests
   */ this.selectedReviewRequests = [];
        /**
   * Queue selection
   */ this.queueSelection = [];
        /**
   * Boolean to proof loading
   */ this.loading = false;
        /**
   * Project id
   */ this.projectId = "dornbach13b";
        /**
   * Dialog text
   */ this.dialogText = document.createElement("p");
        /**
   * Ok Button for dialog
   */ this.footerButtonOk = document.createElement("mwc-button");
        /**
   * Cancel button for dialog
   */ this.footerButtonCancel = document.createElement("mwc-button");
        /**
   * Temp selected rows
   */ this.tempSelectedRows = [];
        /**
   * Special event from the package maicol07/material-web-additions/data-table/data-table.
   * It triggers if the row selection in the data-table changes
   * @param e 
   */ this.rowSelectionChanged = async (e)=>{
            this.tempSelectedRows = e.target.rows.filter((row)=>row.selected);
            this.selectedReviewRequests = e.target.rows.filter((row)=>row.selected).map((row)=>this.tempReviewRequests.find((reviewRequest)=>reviewRequest.reviewRequestID === row.dataset.id));
            console.log("rowSelectionChanged", e);
            console.log("selected ReviewRequests", this.selectedReviewRequests);
        };
    }
    async firstUpdated() {
        //Initialization review-requests
        if (this.database) {
            const accessToken = await this.getAccessToken();
            this.reviewRequests = await (0, $123ae602cd787ad4$export$2398eb31525b8be1).list(this.database, accessToken);
            this.tempReviewRequests = this.reviewRequests;
        }
    }
    render() {
        const template = [];
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">Aufgaben</h2>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
        <md-data-table
          id="dataTable"
          @selected-all=${this.rowSelectionChanged}
          @row-selection-changed=${this.rowSelectionChanged}
          @unselected-all=${this.rowSelectionChanged}
          aria-label="Review Request"
          density=""
          inProgress= true
          page-sizes="[10, 25, 100]"
          page-sizes-label="Zeilen pro Seite:"
          first-row-of-page=""
          current-page-size=""
          last-row-of-page=""
          paginated="true"
          pagination-total-label=":firstRow-:lastRow of :totalRows">
          <md-data-table-column type="checkbox" style="color: green;"></md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Mandantenname
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Mandantennummer
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Beratername
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Dokumentenname
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Status
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Letzte Änderung am
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Geprüft von
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Hochgeladen von
          </md-data-table-column>
          <md-data-table-column sortable="" filterable="" filter-text-field-label="Suchen">
            Erstellungsdatum
          </md-data-table-column>
          ${this.tempReviewRequests.map((reviewRequest)=>{
            const date = new Date(reviewRequest.createTime);
            const createTime = date.toLocaleDateString("de", {
                hour: "numeric",
                minute: "numeric",
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });
            const dateUpdate = new Date(reviewRequest.lastStatusUpdateTime);
            /**
             * Last time the reviewRequest has be changed
             */ const lastStatusUpdateTime = dateUpdate.toLocaleDateString("de", {
                hour: "numeric",
                minute: "numeric",
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
              <md-data-table-row data-id=${reviewRequest.reviewRequestID}>
                <md-data-table-cell type="checkbox"></md-data-table-cell>
                <md-data-table-cell>
                  ${reviewRequest.clientName}
                </md-data-table-cell>
                <md-data-table-cell type="numeric">
                  ${reviewRequest.clientId}
                </md-data-table-cell>
                <md-data-table-cell>
                  ${reviewRequest.consultantName}
                </md-data-table-cell>
                <md-data-table-cell>${reviewRequest.originalFilename}</md-data-table-cell>
                <md-data-table-cell>
                    <div id="currentStatus" style="display: inline; vertical-align: middle;">${reviewRequest.status}</div>
                    <div id="statusLoad"style="display: inline;">
                        ${reviewRequest.status == "wird verarbeitet" || reviewRequest.status == "in Bearbeitung" ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-circular-progress indeterminate density=-7></mwc-circular-progress>` : null}
                    </div>
                </md-data-table-cell>
                <md-data-table-cell>
                  ${lastStatusUpdateTime}
                </md-data-table-cell>
                <md-data-table-cell>
                  ${reviewRequest.reviewedByUserId}
                </md-data-table-cell>
                <md-data-table-cell>
                  ${reviewRequest.uploadedByUserId}
                </md-data-table-cell>
                <md-data-table-cell>
                  ${createTime}
                </md-data-table-cell>
              </md-data-table-row>
            `;
        })}
          <md-data-table-footer
            slot="footer"
            style="display: flex; align-items: left; justify-content: left;">
            <mwc-button
              raised
              @click=${this.reviewBatch}
              label="Dokument(e) prüfen"
              ?disabled=${this.selectedReviewRequests.length === 0 || this.selectedReviewRequests.filter((reviewRequest)=>reviewRequest.originalStatus == "hitl").length < this.selectedReviewRequests.length}></mwc-button>
            <mwc-button
              raised              
              label="Dokument(e) herunterladen"
              @click=${this.downloadBatch}
              ?disabled=${this.selectedReviewRequests.length === 0 || this.selectedReviewRequests.filter((reviewRequest)=>reviewRequest.originalStatus == "completed").length < this.selectedReviewRequests.length}></mwc-button>
            <mwc-button
              raised              
              label="Dokument(e) löschen"
              @click=${this.deleteBatch}
              ?disabled=${this.selectedReviewRequests.length === 0}></mwc-button>
          </md-data-table-footer>
        </md-data-table>
      </div>
    `);
        return template;
    }
    /**
   * Review batch
   */ async reviewBatch() {
        // ensure that the access token gets refreshed if necessary
        await this.getAccessToken(true);
        const reviewRequestUpdatedEvent = new CustomEvent("batch-review-triggered", {
            bubbles: true,
            detail: this.selectedReviewRequests
        });
        this.dispatchEvent(reviewRequestUpdatedEvent);
    }
    /**
   * Initializes the dialog
   */ initDialog() {
        this.dialog.innerHTML = "";
        this.footerButtonOk.innerHTML = "";
        this.footerButtonCancel.innerHTML = "";
        this.footerButtonOk.setAttribute("slot", "primaryAction");
        this.footerButtonOk.setAttribute("dialogAction", "ok");
        this.footerButtonOk.innerText = "Ok";
        this.footerButtonOk.classList.add("raised");
        this.footerButtonCancel.setAttribute("slot", "secondaryAction");
        this.footerButtonCancel.setAttribute("dialogAction", "cancel");
        this.footerButtonCancel.innerText = "Abbrechen";
        this.footerButtonCancel.classList.add("raised");
        this.dialogText.style.padding = "0px 20%";
        this.dialog.setAttribute("style", "border-color: #000000; border-width: 1px; color: #000000; font-size: 1.1em;");
    }
    /**
   * Deletes the batch of one or more review-requests
   * @param e 
   */ async deleteBatch(e) {
        e.preventDefault();
        const accessToken = await this.getAccessToken(true);
        this.initDialog();
        //Generates text for the user, if a single document or multiple documents are selected
        if (this.selectedReviewRequests.length > 1) this.dialogText.innerHTML = "Sind Sie sicher, das Sie die ausgew\xe4hlten Dokumente l\xf6schen m\xf6chten?";
        else this.dialogText.innerHTML = "Sind Sie sicher, das Sie das ausgew\xe4hlte Dokument l\xf6schen m\xf6chten?";
        this.footerButtonOk.addEventListener("click", ()=>{
            const nextDialog = this.dialog;
            const okButton = document.createElement("mwc-button");
            okButton.setAttribute("dialogAction", "ok");
            okButton.innerText = "Ok";
            okButton.classList.add("raised");
            this.dialogText.innerHTML = "";
            this.dialogText.innerHTML = "Dokumente werden gel\xf6scht..";
            nextDialog.innerHTML = "";
            //Circular progress bar
            const circularProgress = document.createElement("mwc-circular-progress");
            circularProgress.setAttribute("density", "-1");
            circularProgress.setAttribute("indeterminate", "true");
            nextDialog.append(circularProgress);
            nextDialog.appendChild(this.dialogText);
            nextDialog.style.textAlign = "-webkit-center";
            nextDialog.appendChild(okButton);
            nextDialog.open = true;
            //Check if there is review-request selected    
            if (this.selectedReviewRequests.length > 0) {
                const reviewRequestIds = this.selectedReviewRequests.map((reviewRequest)=>reviewRequest.reviewRequestID);
                (0, $123ae602cd787ad4$export$2398eb31525b8be1).deleteReviewRequests(this.database, accessToken, reviewRequestIds).then(()=>{
                    console.log(nextDialog);
                    this.tempSelectedRows.forEach((row)=>{
                        row.selected = false;
                    });
                    nextDialog.open = false;
                    nextDialog.innerHTML = "";
                    this.tempReviewRequests = this.reviewRequests.filter((reviewRequest)=>!this.selectedReviewRequests.includes(reviewRequest));
                    this.selectedReviewRequests = [];
                });
                this.requestUpdate();
            }
        });
        this.dialog.appendChild(this.dialogText);
        this.dialog.appendChild(this.footerButtonCancel);
        this.dialog.appendChild(this.footerButtonOk);
        this.dialog.open = true;
        this.dialog.addEventListener("closed", ()=>{
            this.footerButtonOk.innerHTML = "";
            this.dialog.innerHTML = "";
        });
    }
    /**
   * Download batch. Download the splitted PDFs
   */ async downloadBatch() {
        const dirHandle = await window.showDirectoryPicker({
            mode: "readwrite"
        });
        const accessToken = await this.getAccessToken(true);
        this.initDialog();
        this.dialogText.innerHTML = "Ihre Dokumente werden heruntergeladen..";
        this.dialog.innerHTML = "";
        /**
     * Circular progress https://www.npmjs.com/package/@material/mwc-circular-progress
     */ const circularProgress = document.createElement("mwc-circular-progress");
        circularProgress.setAttribute("density", "-1");
        circularProgress.setAttribute("indeterminate", "true");
        this.dialog.append(circularProgress);
        this.dialog.style.textAlign = "-webkit-center";
        this.dialog.appendChild(this.dialogText);
        this.dialog.appendChild(this.footerButtonOk);
        this.dialog.open = true;
        //The filename of each splitted document will be set, based on their type and page number
        this.selectedReviewRequests.forEach(async (reviewRequest)=>{
            reviewRequest.splittedPdfObjects.forEach(async (splittedPdfObject)=>{
                console.log(splittedPdfObject);
                let indexDocType = 0;
                let leadingZeroSet = "";
                const indexSecondUnderscore = reviewRequest.originalFilename.indexOf("_", reviewRequest.originalFilename.indexOf("_") + 1);
                const clientConsultantValues = reviewRequest.originalFilename.substr(0, indexSecondUnderscore + 1);
                const subStringFilenamePDF = reviewRequest.originalFilename.substr(indexSecondUnderscore + 1, reviewRequest.originalFilename.length);
                const subStringFilename = subStringFilenamePDF.substr(0, subStringFilenamePDF.length - 4);
                let label;
                switch(true){
                    case splittedPdfObject.toLowerCase().includes("rechnung"):
                        label = "RE";
                        indexDocType = splittedPdfObject.toLowerCase().indexOf("rechnung");
                        break;
                    case splittedPdfObject.toLowerCase().includes("anhang"):
                        label = "AN";
                        indexDocType = splittedPdfObject.toLowerCase().indexOf("anhang");
                        break;
                    case splittedPdfObject.toLowerCase().includes("sonstiges"):
                        label = "SO";
                        indexDocType = splittedPdfObject.toLowerCase().indexOf("sonstiges");
                        break;
                }
                leadingZeroSet = splittedPdfObject.toLowerCase().substring(indexDocType - 8, indexDocType - 1);
                const fileName = clientConsultantValues + label + "_" + subStringFilename + "-" + leadingZeroSet + ".pdf";
                const fileHandle = await dirHandle.getFileHandle(fileName, {
                    create: true
                });
                const fileStream = await fileHandle.createWritable();
                const splittedPdfUrl = "https://" + reviewRequest.resultBucket + ".storage.googleapis.com/" + splittedPdfObject;
                const response = await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(splittedPdfUrl, {
                    headers: {
                        authorization: `Bearer ${accessToken}`
                    }
                });
                const blob = await response.blob();
                await fileStream.write(blob);
                await fileStream.close().then(()=>{
                    this.dialog.open = false;
                });
            });
            // set status to downloaded
            if (this.database) {
                reviewRequest.updateStatus(this.database, accessToken, "downloaded");
                reviewRequest.status = "heruntergeladen";
                this.tempSelectedRows.forEach((row)=>{
                    row.selected = false;
                });
            }
        });
    }
    connectedCallback() {
        super.connectedCallback();
        //Interval in which review-requests are updated each 10 sec. = 10000 msec.
        this.timerId = setInterval(async ()=>{
            if (this.database) {
                const accessToken = await this.getAccessToken();
                this.reviewRequests = await (0, $123ae602cd787ad4$export$2398eb31525b8be1).list(this.database, accessToken);
                this.tempReviewRequests = this.reviewRequests;
            }
            this.requestUpdate();
            console.log("requestUpdate called");
        }, 10000);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        //Interval for review-requests get disconnected after leaving the page with this component
        if (this.timerId) clearInterval(this.timerId);
        console.log("Clear Interval from disconnectedCallback");
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ae667ea854f4f8f2$export$7dd18cbe7c946e5f.prototype, "loading", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $ae667ea854f4f8f2$export$7dd18cbe7c946e5f.prototype, "tempSelectedRows", void 0);
$ae667ea854f4f8f2$export$7dd18cbe7c946e5f = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-review-requests")
], $ae667ea854f4f8f2$export$7dd18cbe7c946e5f);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 





/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Human review
 */ class $26dcce1834f69c5f$var$HumanReview {
    constructor(state, state_message = ""){
        this.state_message = "";
        this.state = state;
        this.state_message = state_message;
    }
}
class $26dcce1834f69c5f$export$65528947809bf36b {
    constructor(reviewedDocumentJson, humanRevisionState, humanRevisionStateMessage, userId){
        /**
   * Revision id
   */ this.id = "0";
        /**
   * Revision parent ids
   */ this.parent_ids = [];
        /**
   * Create time
   */ this.create_time = new Date().toISOString();
        this.parent_ids = [];
        this.lastRevisionId = "0";
        reviewedDocumentJson.revisions = reviewedDocumentJson.revisions || [];
        const lastRevision = reviewedDocumentJson.revisions.slice().sort((a, b)=>{
            return a < b;
        }).pop();
        this.lastRevisionId = lastRevision?.id || this.lastRevisionId;
        lastRevision?.parent_ids?.push(this.lastRevisionId);
        this.parent_ids = lastRevision?.parent_ids || [
            this.lastRevisionId
        ];
        this.id = String((parseInt(this.lastRevisionId || "") || 0) + 1);
        if (humanRevisionState !== "rejected") humanRevisionState = "succeeded";
        this.create_time = new Date().toISOString();
        this.human_review = new $26dcce1834f69c5f$var$HumanReview(humanRevisionState, humanRevisionStateMessage);
        this.agent = userId;
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $4bde2cb0b28f1f1c$export$37b716936d129341 {
    constructor(labels, headerTitle, disablePrev = true, disableNext = true, type = "Entity", schemaFirst = true){
        let documentAnnotationData = {};
        documentAnnotationData.pages = [
            {
                "imageUrl": {
                    "privateDoNotAccessOrElseWrappedUrl": ""
                },
                "tokens": [],
                "kvPairs": [],
                "entities": [],
                "tables": [],
                "textBlocks": [],
                "angle": 0
            }
        ];
        // convert Document to DocumentAnnotationData which is different for splitting and entity extraction
        if (type === "DocSplitter") {
            // set groupingLabels
            documentAnnotationData.entityLabels = [];
            documentAnnotationData.groupingLabels = labels;
            documentAnnotationData.editConfig = {
                // enable refreshed CDS UI
                cdsRefresh: true
            };
        } else if (type === "DAI_COMPLEX_CLASSIFICATION") {
            documentAnnotationData.entityLabels = [];
            documentAnnotationData.classificationLabels = labels;
        } else {
            documentAnnotationData.entityLabels = labels;
            documentAnnotationData.editConfig = {
                // enable support for nested entities
                enableNestedEntities: true,
                // enable schema first labeling, e.g. show all values from the entityLabels even if they are not set in the document
                schemaFirst: schemaFirst
            };
        }
        // Whether rotate functionality should be activated or not. Defaults to false.
        documentAnnotationData.allowRotate = true;
        // Whether to show the escalate button.
        documentAnnotationData.showEscalateButton = true;
        // Display name of the document.
        documentAnnotationData.documentName = headerTitle;
        this.data = documentAnnotationData;
        // setup navigation layout
        this.navigation = new $4bde2cb0b28f1f1c$export$33b4d5f5f5f1d8f4(headerTitle, disablePrev, disableNext, type);
    }
}
class $4bde2cb0b28f1f1c$export$33b4d5f5f5f1d8f4 {
    constructor(headerTitle, disablePrev = true, disableNext = true, type){
        this.appMode = "HumanLabeling";
        // Controls whether to show/hide action button.
        this.isEditable = true;
        // Whether there was a local change, according to if there was/was not, the action button will be enabled/disabled. Required when isEditable is true.
        this.dataChanged = false;
        // Controls whether to always enable primary button.
        this.enablePrimaryButton = true;
        // Button text for save button. Default value is 'Save'.
        this.primaryButtonText = "Best\xe4tigen";
        // Optional text for secondary button. If not given, the secondary button will be invisible.
        this.secondaryButtonText = "Ablehnen";
        // Disable the confirm dialog for unsaved warning
        this.disableConfirmDialog = false;
        // Controls whether to show/hide header - will be overwritten by the constructor
        this.hideHeader = false;
        // Controls whether to show/hide back button.
        this.hideBackButton = false;
        // set the current tab type - will be overwritten by the constructor
        this.tabGroupConfig = {
            currentTabType: "Entity"
        };
        this.headerTitle = headerTitle;
        this.disablePrev = disablePrev;
        this.disableNext = disableNext;
        this.tabGroupConfig.currentTabType = type;
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $6c6850c499f46d9f$export$3b798af8cc0f34eb {
    constructor(label){
        this.label = label;
    }
    getLabelsWithNestedEntityLabels() {
        let labels = [
            this
        ];
        this.nestedEntityLabels?.forEach((nestedEntityLabel)=>{
            labels.push(nestedEntityLabel);
            labels.concat(nestedEntityLabel.getLabelsWithNestedEntityLabels());
        });
        return labels;
    }
    static fromJson(json) {
        const entityLabel = new $6c6850c499f46d9f$export$3b798af8cc0f34eb(json.label);
        if (json.requireCategory) entityLabel.requireCategory = json.requireCategory;
        if (json.labelDescription) entityLabel.labelDescription = json.labelDescription;
        if (json.normalizedValueType) entityLabel.normalizedValueType = json.normalizedValueType;
        if (Array.isArray(json.nestedEntityLabels)) {
            entityLabel.nestedEntityLabels = [];
            json.nestedEntityLabels.forEach((nestedEntityLabel)=>{
                entityLabel.nestedEntityLabels?.push($6c6850c499f46d9f$export$3b798af8cc0f34eb.fromJson(nestedEntityLabel));
            });
        }
        return entityLabel;
    }
}
function $6c6850c499f46d9f$export$5dc1095df0929c56(entities) {
    let entityLabels = [];
    entities?.forEach((entity)=>{
        if (!entityLabels.some((entityLabel)=>entityLabel.label === entity.type)) {
            let entityLabel = new $6c6850c499f46d9f$export$3b798af8cc0f34eb(entity.type);
            if (entity.properties?.length > 0) {
                const nestedEntityLabels = $6c6850c499f46d9f$export$5dc1095df0929c56(entity.properties);
                entityLabel.nestedEntityLabels = nestedEntityLabels;
            }
            entityLabels.push(entityLabel);
        }
    });
    return entityLabels;
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Entity object. It has a entity type and properties of an entity.
 */ class $8ba638f0d6587971$export$d385b1740434b54b {
    constructor(displayName){
        this.displayName = displayName;
    }
    static fromJson(json) {
        const groupingLabel = new $8ba638f0d6587971$export$d385b1740434b54b(json.displayName);
        return groupingLabel;
    }
}
function $8ba638f0d6587971$export$94896246077573fe(entities) {
    let groupingLabels = [];
    entities?.forEach((entity)=>{
        // only add grouping label if it does not exist yet
        if (!groupingLabels.some((groupingLabel)=>groupingLabel.displayName === entity.type)) {
            let groupingLabel = new $8ba638f0d6587971$export$d385b1740434b54b(entity.type);
            groupingLabels.push(groupingLabel);
        }
    });
    return groupingLabels;
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $fc90cd126e71c5b2$export$59e7611a9b95daae {
    constructor(values = []){
        this.label = "Document type";
        this.values = values;
    }
    static fromJson(json) {
        const classificationLabel = new $fc90cd126e71c5b2$export$59e7611a9b95daae(json.values);
        return classificationLabel;
    }
}
function $fc90cd126e71c5b2$export$253226dc27546fb7(entities) {
    const classificationLabel = new $fc90cd126e71c5b2$export$59e7611a9b95daae();
    let maxEntityConfidence = 0;
    entities?.forEach((entity)=>{
        // don't add entity if it already exists in the values of the classificationLabel
        if (!classificationLabel.values.some((value)=>value.label === entity.type)) {
            if (entity.confidence ?? 0 >= maxEntityConfidence) {
                maxEntityConfidence = entity.confidence ?? 0;
                classificationLabel.selectedValue = entity.type;
                classificationLabel.id = entity.id;
            }
        }
    });
    return [
        classificationLabel
    ];
}



var $0b50edd7ca734bea$var$NavEvent;
/**
 * @enum
 * Enum for navigation event
 */ (function(NavEvent) {
    NavEvent[NavEvent["BACK"] = 0] = "BACK";
    NavEvent[NavEvent["PREVIOUS"] = 1] = "PREVIOUS";
    NavEvent[NavEvent["NEXT"] = 2] = "NEXT";
})($0b50edd7ca734bea$var$NavEvent || ($0b50edd7ca734bea$var$NavEvent = {}));
let $0b50edd7ca734bea$export$6fffb60373372c0 = class HitlReviewDocument extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .over:hover {
      background-color: blue;
    }

    div.side-panel-wrapper.ng-star-inserted {
      width: 270px;
    }
  `;
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        // start reviewing first document
        this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
        console.log(this.observer);
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)` <div class="content-div"></div> `;
    }
    /**
   * Get access token
   * @param refresh 
   * @returns 
   */ async getAccessToken(refresh = false) {
        const accessToken = await new Promise((resolve, reject)=>{
            const getAccessToken = new CustomEvent("get-access-token", {
                bubbles: true,
                detail: {
                    refresh: refresh,
                    resolve: resolve,
                    reject: reject
                }
            });
            this.dispatchEvent(getAccessToken);
        });
        return accessToken;
    }
    /**
   * Review document
   * @param reviewRequest 
   */ async reviewDocument(reviewRequest) {
        this.rejectReason = "";
        const accessToken = await this.getAccessToken(true);
        const json = await reviewRequest.getContent(accessToken);
        // initialize human review state
        this.humanRevisionState = "requested";
        this.humanRevisionStateMessage = "";
        if (reviewRequest.labels.length === 0) {
            if (reviewRequest.type === "DocSplitter") reviewRequest.labels = (0, $8ba638f0d6587971$export$94896246077573fe)(json.entities);
            else if (reviewRequest.type === "DAI_COMPLEX_CLASSIFICATION") reviewRequest.labels = (0, $fc90cd126e71c5b2$export$253226dc27546fb7)(json.entities);
            else reviewRequest.labels = (0, $6c6850c499f46d9f$export$5dc1095df0929c56)(json.entities);
        }
        const headerTitle = reviewRequest.originalFilename;
        // add accessToken to pageImageNames
        const pageImageNames = reviewRequest.pageImageNames.map((pageImageName)=>{
            const url = new URL("https://" + reviewRequest.resultBucket + ".storage.googleapis.com/" + reviewRequest.pageImageUrlPrefix + "/" + pageImageName);
            url.searchParams.set("access_token", accessToken);
            return url.toString();
        });
        /*} else {
      pageImageNames = reviewRequest.pageImageNames;
    }*/ /**
     * Convert Document AI document Protbuf format to Document Input format
     */ const documentInput = new (0, $4bde2cb0b28f1f1c$export$37b716936d129341)(reviewRequest.labels, headerTitle, this.reviewRequestsIndex === 0, this.reviewRequests.length - 1 === this.reviewRequestsIndex, reviewRequest.type);
        // create component client SDK instance
        // @ts-ignore
        const sdk = new AIUIComponentClient("AIzaSyAF52EkQsFaubLRrMoXoYur9O4gFeA6iTk");
        // setup document view component and callback events
        var params = {
            component: "DocumentView",
            document: documentInput,
            /**
       * Save event triggered immediately when primary button is clicked
       */ save: async ()=>{
                const reviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                // ensure that the access token gets refreshed if necessary
                await this.getAccessToken(true);
            },
            /**
       * Save event triggered after save. 
       * It saves data in json
       * @param reviewedDocumentJson 
       * @returns 
       */ jsonSave: async (reviewedDocumentJson)=>{
                const reviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                console.log(reviewRequest);
                const dialog = document.getElementById("dialog");
                const missingRequiredLabels = [];
                for (const label of reviewRequest.labels)// check if required labels have been provided
                if (label instanceof (0, $6c6850c499f46d9f$export$3b798af8cc0f34eb) && label.requireCategory === "required") {
                    let found = false;
                    for (const entity of reviewedDocumentJson.entities)if (entity.type === label.label) {
                        found = true;
                        if (!entity.mention_text) missingRequiredLabels.push(label.label);
                    }
                    //If required labels are not found then push the labels in missingRequiredLabels
                    if (!found) missingRequiredLabels.push(label.label);
                }
                const missingEntityReviews = [];
                for (const entity of reviewedDocumentJson.entities){
                    console.log(entity);
                    // check if entities marked for review have been reviewed
                    if (entity.provenance?.type === 4) missingEntityReviews.push(entity.type);
                }
                // display message if validation failed and cancel saving
                if (missingRequiredLabels.length > 0 || missingEntityReviews.length > 0) {
                    dialog.heading = "Dokument Review Validierung fehlgeschlagen.";
                    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`The following required entities are missing values:
              ${missingRequiredLabels.join(", ")}<br />
              The following required entities are missing a mandatory review:
              ${missingEntityReviews.join(", ")}
              <mwc-button slot="primaryAction" dialogAction="ok"
                >Ok</mwc-button
              >`, dialog);
                    dialog.open = true;
                    return;
                }
                if (this.dragSrcEl) {
                    console.log("save due to drag");
                    console.log("original JSONreviewedDocumentJson", reviewedDocumentJson);
                    reviewedDocumentJson = this.movePage(reviewRequest, reviewedDocumentJson);
                    console.log("page moved JSONreviewedDocumentJson", reviewedDocumentJson);
                    this.reviewDocument(reviewRequest);
                    return;
                }
                /**
         * Create new revision of document to track changes
         */ const revision = new (0, $26dcce1834f69c5f$export$65528947809bf36b)(reviewedDocumentJson, this.humanRevisionState, this.humanRevisionStateMessage, this.userID);
                // remove lastRevisionId which is not allowed in the output
                delete revision.lastRevisionId;
                //Push new revision to reviewedDocumentJson
                reviewedDocumentJson.revisions.push(revision);
                /**
         * Content of reviewedDocumentJson as string
         */ const content = JSON.stringify(reviewedDocumentJson);
                if (dialog) {
                    dialog.heading = "Dokument wird gespeichert...";
                    dialog.addEventListener("closed", ()=>{
                        dialog.heading = "";
                    });
                    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-linear-progress indeterminate></mwc-linear-progress>`, dialog);
                    dialog.open = true;
                }
                reviewRequest.reviewedByUserId = this.userID;
                reviewRequest.saveContent(accessToken, content, this.rejectReason).then(()=>{
                    dialog.open = false;
                    this.reviewRequests = this.reviewRequests.filter((_, i)=>i !== this.reviewRequestsIndex);
                    if (this.reviewRequests.length > 0) {
                        this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex, this.reviewRequests.length - 1);
                        this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
                    } else this.closeReview();
                }).catch(()=>{
                    dialog.innerHTML = "";
                    dialog.heading = "";
                    dialog.heading = "Der Speicherungsvorgang wurde abgebrochen.";
                    this.closeButton.setAttribute("slot", "primaryAction");
                    this.closeButton.setAttribute("dialogAction", "ok");
                    this.closeButton.innerText = "Schlie\xdfen";
                    this.closeButton.classList.add("raised");
                    dialog.appendChild(this.closeButton);
                    dialog.open = true;
                    dialog.addEventListener("closed", ()=>{
                        dialog.heading = "";
                        dialog.innerHTML = "";
                    });
                });
            },
            secondaryButtonClick: async ()=>{
                // ensure that the access token gets refreshed if necessary
                await this.getAccessToken(true);
                // retrieve rejection reason from user
                const dialog = document.getElementById("dialog");
                if (dialog) {
                    dialog.innerHTML = "";
                    dialog.heading = "Geben Sie bitte an aus welchem Grund Sie das Dokument ablehnen";
                    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)` <mwc-textfield
                outlined
                style="width: 100%;margin-top: 12px;"
                required
                value=${this.rejectReason}
                label="Grund der Ablehnung"
                @change=${this.updateRejectReason}
              ></mwc-textfield>
              <mwc-button
                id="dialogSubmitButton"
                label="Dokument ablehnen"
                slot="primaryAction"
                dialogAction="ok"
                @click=${this.rejectDocument}
              ></mwc-button>`, dialog);
                    dialog.open = true;
                }
            },
            navigate: async (event)=>{
                // ensure that the access token gets refreshed if necessary
                await this.getAccessToken(true);
                if (event === 0) // back button clicked
                this.closeReview();
                else {
                    if (event === 1) // previous button clicked
                    this.reviewRequestsIndex = Math.max(this.reviewRequestsIndex - 1, 0);
                    else if (event === 2) // next button clicked
                    this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex + 1, this.reviewRequests.length - 1);
                    this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
                }
            },
            escalate: async ()=>{
                // ensure that the access token gets refreshed if necessary
                await this.getAccessToken(true);
                console.log("Escalation event");
                const dialog = document.getElementById("dialog");
                if (dialog) {
                    dialog.heading = "Escalate button clicked.";
                    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-button slot="primaryAction" dialogAction="ok"
              >Ok</mwc-button
            >`, dialog);
                    dialog.open = true;
                }
            }
        };
        /**
   * Retrieve element for rendering the main document view UI component
   */ const aiDocumentView = this.renderRoot.querySelector(".content-div");
        let documentViewElement = await sdk.render(aiDocumentView, params);
        if (reviewRequest.type === "DocSplitter") documentViewElement.isSplitter = true;
        console.log("json", json);
        console.log("imageUrls", pageImageNames);
        documentViewElement.docProtoJson = {
            json: json,
            imageUrls: pageImageNames
        };
        this.setupMovingPages();
    }
    /**
   * Setup moving pages
   */ setupMovingPages() {
        console.log("Setup moving pages");
        let documentSplitter = document.getElementsByTagName("ai-document-splitter")[0];
        // Setup an observer on the ai document splitter element
        const config = {
            childList: true
        };
        // Start observing the target node for configured mutations
        this.observer.observe(documentSplitter, config);
        this.setupDragSources();
    }
    /**
   * Setup drag sources
   */ setupDragSources() {
        console.log("Setting up drag sources");
        let splitterPageContainers = Array.from(document.getElementsByClassName("ai-splitter-page-container"));
        // setup drag and drop event listeners
        splitterPageContainers.forEach((element)=>{
            element.setAttribute("draggable", "true");
            element.addEventListener("dragstart", (e)=>this.handleDragStart(e));
            element.addEventListener("dragend", this.handleDragEnd);
        });
    }
    /**
   * Setup drop targets
   * @param currentPageElement 
   */ setupDropTargets(currentPageElement) {
        console.log("Setup drop targets");
        // add toggle at the end to allow moving a page to the end
        let splitterPageContainer = currentPageElement.cloneNode(true);
        splitterPageContainer.removeChild(splitterPageContainer.lastChild);
        while(splitterPageContainer.firstChild.firstChild)splitterPageContainer.firstChild.removeChild(splitterPageContainer.firstChild.firstChild);
        splitterPageContainer.id = "temp-split-toggle-container";
        splitterPageContainer.style.width = null;
        currentPageElement.parentElement.appendChild(splitterPageContainer);
        let splitterPageContainers = Array.from(currentPageElement.parentElement.children);
        let currentPageIndex = splitterPageContainers.indexOf(currentPageElement);
        let excludeElements;
        if (currentPageIndex < splitterPageContainers.length - 1) excludeElements = [
            currentPageElement.firstChild,
            splitterPageContainers[currentPageIndex + 1].firstChild
        ];
        else excludeElements = [
            currentPageElement.firstChild
        ];
        let splitToggleContainers = Array.from(document.getElementsByClassName("ai-document-split-toggle-container"));
        splitToggleContainers.forEach((splitToggleContainer)=>{
            if (Array.from(splitToggleContainer.classList).includes("ai-document-split-toggle-container")) {
                if (!excludeElements.includes(splitToggleContainer)) {
                    splitToggleContainer.classList.add("drop-target");
                    splitToggleContainer.addEventListener("dragover", (e)=>this.handleDragOver(e));
                    splitToggleContainer.addEventListener("dragenter", (e)=>this.handleDragEnter(e));
                    splitToggleContainer.addEventListener("dragleave", this.handleDragLeave);
                    splitToggleContainer.addEventListener("drop", (e)=>this.handleDrop(e));
                }
            }
        });
    }
    /**
   * Removes the drop targets
   */ removeDropTargets() {
        console.log("Remove drop targets");
        // remove temporary split toggle container
        let splitterPageContainer = document.getElementById("temp-split-toggle-container");
        if (splitterPageContainer) {
            console.log("SplitterPageContainer is not empty");
            splitterPageContainer.remove();
        }
        let splitToggleContainers = Array.from(document.getElementsByClassName("ai-document-split-toggle-container"));
        splitToggleContainers.forEach((splitToggleContainer)=>{
            console.log("Classes will be removed");
            splitToggleContainer.classList.remove("drop-target");
            splitToggleContainer.classList.remove("over");
            splitToggleContainer.removeEventListener("dragover", (e)=>this.handleDragOver(e));
            splitToggleContainer.removeEventListener("dragenter", (e)=>this.handleDragEnter(e));
            splitToggleContainer.removeEventListener("dragleave", this.handleDragLeave);
            splitToggleContainer.removeEventListener("drop", (e)=>this.handleDrop(e));
        });
    }
    /**
   * Move page
   * @param reviewRequest 
   * @param documentJson 
   * @returns 
   */ movePage(reviewRequest, documentJson) {
        console.log("Move page method is executed");
        if (this.srcPageIndex < this.dstPageIndex) {
            // first shuffle page image URLs
            reviewRequest.pageImageNames.splice(this.dstPageIndex - 1, 0, reviewRequest.pageImageNames.splice(this.srcPageIndex, 1)[0]);
            // now change page numbers
            documentJson.pages.forEach((page)=>{
                // if page is the source page, change the page number to the destination page, note: dstPageIndex is the index of the page after which it will be inserted, thus no +1 is required for page number
                if (page.page_number - 1 === this.srcPageIndex) {
                    console.log("Change page number to destination number");
                    page.page_number = this.dstPageIndex;
                } else if (page.page_number - 1 > this.srcPageIndex && page.page_number - 1 < this.dstPageIndex) {
                    page.page_number = page.page_number - 1;
                    console.log("Change page number to page number before destination number");
                }
            });
            // insert page object into right position in page array
            documentJson.pages.splice(this.dstPageIndex - 1, 0, documentJson.pages.splice(this.srcPageIndex, 1)[0]);
            // switch page numbers inside entities object
            documentJson.entities.forEach((entity)=>{
                //  array holding page_ref to delete from current entity
                let remove_page_ref_indices = [];
                // array holding page_ref for new entity
                let new_entity_page_refs = [];
                // check if destination is in current entity
                const destinationPageInCurrentEntity = entity.page_anchor.page_refs.find((page_refs_find)=>page_refs_find.page === this.dstPageIndex - 1);
                console.log("Destination page is current entity", destinationPageInCurrentEntity);
                // iterate over page_refs of entity
                entity.page_anchor.page_refs.forEach((page_ref)=>{
                    // if page is the source page
                    if (page_ref.page === this.srcPageIndex) {
                        // shift page number down 
                        page_ref.page = this.dstPageIndex - 1;
                        console.log("Shift page number down");
                        // if page is not the only one in the entity and page number is not the page before the destination (note: dstPageIndex is one larger than the index of the page after which the page should be dropped)
                        if (entity.page_anchor.page_refs.length > 1 && !destinationPageInCurrentEntity) {
                            new_entity_page_refs.push(page_ref);
                            remove_page_ref_indices.push(entity.page_anchor.page_refs.indexOf(page_ref));
                        }
                    } else if (page_ref.page > this.srcPageIndex && page_ref.page < this.dstPageIndex) {
                        page_ref.page = page_ref.page - 1;
                        // if page_ref is not the only one in the entity and page_ref is not the page before the destination (note: dstPageIndex is one larger than the index of the page after which the page should be dropped)
                        if (entity.page_anchor.page_refs.length > 1 && !destinationPageInCurrentEntity) {
                            new_entity_page_refs.push(page_ref);
                            remove_page_ref_indices.push(entity.page_anchor.page_refs.indexOf(page_ref));
                        }
                    }
                });
                // remove page_ref from entity if a new entity was created
                remove_page_ref_indices.forEach((remove_page_ref_index)=>{
                    console.log("Remove page ref from entity if new entity was created");
                    entity.page_anchor.page_refs.splice(remove_page_ref_index, 1);
                });
                // create new entity with page_ref
                if (new_entity_page_refs.length > 0) {
                    console.log("create new entity with page_ref");
                    const new_entity = structuredClone(entity);
                    new_entity.page_anchor.page_refs = [];
                    new_entity_page_refs.forEach((page_ref)=>{
                        new_entity.page_anchor.page_refs.push(page_ref);
                    });
                    documentJson.entities.push(new_entity);
                }
            });
        } else {
            // first shuffle page image names
            reviewRequest.pageImageNames.splice(this.dstPageIndex, 0, reviewRequest.pageImageNames.splice(this.srcPageIndex, 1)[0]);
            console.log("Shuffle page image names");
            // now change page numbers
            documentJson.pages.forEach((page)=>{
                // if page is the source page, change the page number to the destination page, note: dstPageIndex is the index of the page before which it will be inserted, thus +1 is required for page number
                if (page.page_number - 1 === this.srcPageIndex) {
                    page.page_number = this.dstPageIndex + 1;
                    console.log("page number is equal destination page index + 1");
                } else if (page.page_number - 1 < this.srcPageIndex && page.page_number - 1 >= this.dstPageIndex) page.page_number = page.page_number + 1;
            });
            // insert page object into right position in page array
            documentJson.pages.splice(this.dstPageIndex, 0, documentJson.pages.splice(this.srcPageIndex, 1)[0]);
            console.log("documentJson after page index change", documentJson);
            // switch page numbers inside entities object
            documentJson.entities.forEach((entity)=>{
                //  array holding page_ref to delete from current entity
                let remove_page_ref_indices = [];
                // array holding page_ref for new entity
                let new_entity_page_refs = [];
                // check if destination is in current entity
                const destinationPageInCurrentEntity = entity.page_anchor.page_refs.find((page_refs_find)=>page_refs_find.page === this.dstPageIndex);
                // iterate over page_refs of entity
                entity.page_anchor.page_refs.forEach((page_ref)=>{
                    // if page is the source page
                    if (page_ref.page === this.srcPageIndex) {
                        console.log("same page");
                        // shift page number up
                        page_ref.page = this.dstPageIndex;
                        // if page is not the only one in the entity and page number is not the destination page (note: dstPageIndex is the index of the page which the page should be dropped to)
                        if (entity.page_anchor.page_refs.length > 1 && !destinationPageInCurrentEntity) {
                            console.log("remove page_ref from entity", page_ref);
                            new_entity_page_refs.push(page_ref);
                            remove_page_ref_indices.push(entity.page_anchor.page_refs.indexOf(page_ref));
                        }
                    } else if (page_ref.page < this.srcPageIndex && page_ref.page >= this.dstPageIndex) {
                        console.log("other page");
                        page_ref.page = page_ref.page + 1;
                        // if page_ref is not the only one in the entity and page_ref is not the destination page (note: dstPageIndex is the index of the page which the page should be dropped to)
                        if (entity.page_anchor.page_refs.length > 1 && !destinationPageInCurrentEntity) {
                            console.log("remove page_ref from entity", page_ref);
                            new_entity_page_refs.push(page_ref);
                            remove_page_ref_indices.push(entity.page_anchor.page_refs.indexOf(page_ref));
                        }
                    }
                });
                // remove page_ref from entity if a new entity was created
                remove_page_ref_indices.forEach((remove_page_ref_index)=>{
                    entity.page_anchor.page_refs.splice(remove_page_ref_index, 1);
                });
                // create new entity with page_ref
                if (new_entity_page_refs.length > 0) {
                    const new_entity = structuredClone(entity);
                    new_entity.page_anchor.page_refs = [];
                    new_entity_page_refs.forEach((page_ref)=>{
                        new_entity.page_anchor.page_refs.push(page_ref);
                    });
                    documentJson.entities.push(new_entity);
                }
            });
            console.log("documentJson after entity move", documentJson);
        }
        /*if (!documentJson.pages[0].groupMetadata) {
      documentJson.pages[0].groupMetadata = {confidence:0.0, groupingLabel:groupingLabels[0]}
    }; */ this.srcPageIndex = undefined;
        this.dstPageIndex = undefined;
        return documentJson;
    }
    closeReview() {
        console.log("Close review");
        const dialog = document.getElementById("dialog");
        dialog.heading = "";
        const reviewRequestUpdatedEvent = new CustomEvent("manage-batch-and-queues-triggered", {
            bubbles: true,
            detail: this.reviewRequests
        });
        this.dispatchEvent(reviewRequestUpdatedEvent);
    }
    constructor(...args){
        super(...args);
        this.reviewRequestsIndex = 0;
        /**
  * Close button
  */ this.closeButton = document.createElement("mwc-button");
        this.rejectReason = "";
        this.humanRevisionStateMessage = "";
        this.humanRevisionState = "requested";
        /** 
   * Create an observer for monitoring splitter to setup drag sources
   */ this.observer = new MutationObserver(this.setupDragSources);
        /**
   * Drag Source Element
   */ this.dragSrcEl = null;
        /**
   * Drag Counter
   */ this.dragCounter = 0;
        this.updateRejectReason = async (e)=>{
            // ensure that the access token gets refreshed if necessary
            await this.getAccessToken(true);
            const rejectReason = e.target.value;
            this.rejectReason = rejectReason;
        };
        this.rejectDocument = async ()=>{
            // ensure that the access token gets refreshed if necessary
            await this.getAccessToken(true);
            this.humanRevisionStateMessage = this.rejectReason;
            this.humanRevisionState = "rejected";
            document.getElementsByClassName("primary-button")[0].click();
        };
        /**
   * handle drag & drop for document splitting
   * @param e 
   */ this.handleDragStart = (e)=>{
            console.log("handleDragStart", e);
            if (this.dragSrcEl != null) this.dragSrcEl.style.opacity = "0.4";
            this.setupDropTargets(e.target);
            this.dragSrcEl = e.target;
        };
        /**
   * Handle drag end event of document page
   * @param _ 
   */ this.handleDragEnd = (_)=>{
            console.log("Handle drag end");
            if (this.dragSrcEl != null) this.dragSrcEl.style.opacity = "1";
            this.dragCounter = 0;
            this.removeDropTargets();
        };
        /**
   * Handle drag over event of document page
   * @param e 
   * @returns 
   */ this.handleDragOver = (e)=>{
            e.preventDefault();
            console.log("Handle drag over");
            return false;
        };
        /**
   * Handle drag enter event of document page
   * @param _ 
   */ this.handleDragEnter = (e)=>{
            console.log("Drag enter", e);
            this.dragCounter++;
            if (this.dragSrcEl && this.dragSrcEl.parentElement != this.dragSrcEl && this.dragCounter == 1) this.dragSrcEl.classList.add("over");
        };
        /**
   * Handle drag leave event of document page
   * @param e 
   */ this.handleDragLeave = (_)=>{
            console.log("Handle drag enter");
            this.dragCounter--;
            if (this.dragCounter == 0 && this.dragSrcEl) this.dragSrcEl.classList.remove("over");
        };
        /**
   * Handle drop event of document page
   * @param e 
   * @returns 
   */ this.handleDrop = (e)=>{
            e.stopPropagation();
            console.log("Handle drop is called");
            if (this.dragSrcEl && this.dragSrcEl.parentElement) {
                const children = Array.from(this.dragSrcEl.parentElement.children);
                this.srcPageIndex = children.indexOf(this.dragSrcEl);
                console.log("Source page " + this.srcPageIndex);
                this.dstPageIndex = children.indexOf(this.dragSrcEl.parentElement);
                console.log("Destination page " + this.dstPageIndex);
            }
            // we need to trigger the save event to get the current document and then reload the document with the new page order
            if (this.srcPageIndex != this.dstPageIndex && this.srcPageIndex + 1 != this.dstPageIndex) document.getElementsByClassName("primary-button")[0].click();
            this.dragSrcEl = null;
            return false;
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $0b50edd7ca734bea$export$6fffb60373372c0.prototype, "reviewRequestsIndex", void 0);
$0b50edd7ca734bea$export$6fffb60373372c0 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-review-document")
], $0b50edd7ca734bea$export$6fffb60373372c0);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ 











/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ 












/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $e00bef1e7bfd6d3e$export$c1c0562ec8379000 = {
    CLOSING: "mdc-dialog--closing",
    OPEN: "mdc-dialog--open",
    OPENING: "mdc-dialog--opening",
    SCROLLABLE: "mdc-dialog--scrollable",
    SCROLL_LOCK: "mdc-dialog-scroll-lock",
    STACKED: "mdc-dialog--stacked",
    FULLSCREEN: "mdc-dialog--fullscreen",
    // Class for showing a scroll divider on full-screen dialog header element.
    // Should only be displayed on scrollable content, when the dialog content is
    // scrolled "underneath" the header.
    SCROLL_DIVIDER_HEADER: "mdc-dialog-scroll-divider-header",
    // Class for showing a scroll divider on a full-screen dialog footer element.
    // Should only be displayed on scrolalble content, when the dialog content is
    // obscured "underneath" the footer.
    SCROLL_DIVIDER_FOOTER: "mdc-dialog-scroll-divider-footer",
    // The "surface scrim" is a scrim covering only the surface of a dialog. This
    // is used in situations where a confirmation dialog is shown over an already
    // opened full-screen dialog. On larger screen-sizes, the full-screen dialog
    // is sized as a modal and so in these situations we display a "surface scrim"
    // to prevent a "double scrim" (where the scrim from the secondary
    // confirmation dialog would overlap with the scrim from the full-screen
    // dialog).
    SURFACE_SCRIM_SHOWN: "mdc-dialog__surface-scrim--shown",
    // "Showing" animating class for the surface-scrim.
    SURFACE_SCRIM_SHOWING: "mdc-dialog__surface-scrim--showing",
    // "Hiding" animating class for the surface-scrim.
    SURFACE_SCRIM_HIDING: "mdc-dialog__surface-scrim--hiding",
    // Class to hide a dialog's scrim (used in conjunction with a surface-scrim).
    // Note that we only hide the original scrim rather than removing it entirely
    // to prevent interactions with the content behind this scrim, and to capture
    // scrim clicks.
    SCRIM_HIDDEN: "mdc-dialog__scrim--hidden"
};
var $e00bef1e7bfd6d3e$export$21c51bc433c16634 = {
    ACTION_ATTRIBUTE: "data-mdc-dialog-action",
    BUTTON_DEFAULT_ATTRIBUTE: "data-mdc-dialog-button-default",
    BUTTON_SELECTOR: ".mdc-dialog__button",
    CLOSED_EVENT: "MDCDialog:closed",
    CLOSE_ACTION: "close",
    CLOSING_EVENT: "MDCDialog:closing",
    CONTAINER_SELECTOR: ".mdc-dialog__container",
    CONTENT_SELECTOR: ".mdc-dialog__content",
    DESTROY_ACTION: "destroy",
    INITIAL_FOCUS_ATTRIBUTE: "data-mdc-dialog-initial-focus",
    OPENED_EVENT: "MDCDialog:opened",
    OPENING_EVENT: "MDCDialog:opening",
    SCRIM_SELECTOR: ".mdc-dialog__scrim",
    SUPPRESS_DEFAULT_PRESS_SELECTOR: [
        "textarea",
        ".mdc-menu .mdc-list-item",
        ".mdc-menu .mdc-deprecated-list-item"
    ].join(", "),
    SURFACE_SELECTOR: ".mdc-dialog__surface"
};
var $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae = {
    DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
    DIALOG_ANIMATION_OPEN_TIME_MS: 150
};


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * AnimationFrame provides a user-friendly abstraction around requesting
 * and canceling animation frames.
 */ var $846f1fa63c8b3180$export$1f3d5b43727c648a = /** @class */ function() {
    function AnimationFrame() {
        this.rafIDs = new Map();
    }
    /**
     * Requests an animation frame. Cancels any existing frame with the same key.
     * @param {string} key The key for this callback.
     * @param {FrameRequestCallback} callback The callback to be executed.
     */ AnimationFrame.prototype.request = function(key, callback) {
        var _this = this;
        this.cancel(key);
        var frameID = requestAnimationFrame(function(frame) {
            _this.rafIDs.delete(key);
            // Callback must come *after* the key is deleted so that nested calls to
            // request with the same key are not deleted.
            callback(frame);
        });
        this.rafIDs.set(key, frameID);
    };
    /**
     * Cancels a queued callback with the given key.
     * @param {string} key The key for this callback.
     */ AnimationFrame.prototype.cancel = function(key) {
        var rafID = this.rafIDs.get(key);
        if (rafID) {
            cancelAnimationFrame(rafID);
            this.rafIDs.delete(key);
        }
    };
    /**
     * Cancels all queued callback.
     */ AnimationFrame.prototype.cancelAll = function() {
        var _this = this;
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            _this.cancel(key);
        });
    };
    /**
     * Returns the queue of unexecuted callback keys.
     */ AnimationFrame.prototype.getQueue = function() {
        var queue = [];
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            queue.push(key);
        });
        return queue;
    };
    return AnimationFrame;
}();


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $1b63c6dc0ee62d45$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$1b63c6dc0ee62d45$export$2e2bcd8739ae039 = $1b63c6dc0ee62d45$export$a81b11d69c993162;



var $4b6d9c4c22d1910a$var$AnimationKeys;
(function(AnimationKeys) {
    AnimationKeys["POLL_SCROLL_POS"] = "poll_scroll_position";
    AnimationKeys["POLL_LAYOUT_CHANGE"] = "poll_layout_change";
})($4b6d9c4c22d1910a$var$AnimationKeys || ($4b6d9c4c22d1910a$var$AnimationKeys = {}));
var $4b6d9c4c22d1910a$export$dac9922df5f517f1 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDialogFoundation, _super);
    function MDCDialogFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCDialogFoundation.defaultAdapter), adapter)) || this;
        _this.dialogOpen = false;
        _this.isFullscreen = false;
        _this.animationFrame = 0;
        _this.animationTimer = 0;
        _this.escapeKeyAction = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).CLOSE_ACTION;
        _this.scrimClickAction = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).CLOSE_ACTION;
        _this.autoStackButtons = true;
        _this.areButtonsStacked = false;
        _this.suppressDefaultPressSelector = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).SUPPRESS_DEFAULT_PRESS_SELECTOR;
        _this.animFrame = new (0, $846f1fa63c8b3180$export$1f3d5b43727c648a)();
        _this.contentScrollHandler = function() {
            _this.handleScrollEvent();
        };
        _this.windowResizeHandler = function() {
            _this.layout();
        };
        _this.windowOrientationChangeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCDialogFoundation, "cssClasses", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "strings", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "numbers", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "defaultAdapter", {
        get: function() {
            return {
                addBodyClass: function() {
                    return undefined;
                },
                addClass: function() {
                    return undefined;
                },
                areButtonsStacked: function() {
                    return false;
                },
                clickDefaultButton: function() {
                    return undefined;
                },
                eventTargetMatches: function() {
                    return false;
                },
                getActionFromEvent: function() {
                    return "";
                },
                getInitialFocusEl: function() {
                    return null;
                },
                hasClass: function() {
                    return false;
                },
                isContentScrollable: function() {
                    return false;
                },
                notifyClosed: function() {
                    return undefined;
                },
                notifyClosing: function() {
                    return undefined;
                },
                notifyOpened: function() {
                    return undefined;
                },
                notifyOpening: function() {
                    return undefined;
                },
                releaseFocus: function() {
                    return undefined;
                },
                removeBodyClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                reverseButtons: function() {
                    return undefined;
                },
                trapFocus: function() {
                    return undefined;
                },
                registerContentEventHandler: function() {
                    return undefined;
                },
                deregisterContentEventHandler: function() {
                    return undefined;
                },
                isScrollableContentAtTop: function() {
                    return false;
                },
                isScrollableContentAtBottom: function() {
                    return false;
                },
                registerWindowEventHandler: function() {
                    return undefined;
                },
                deregisterWindowEventHandler: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCDialogFoundation.prototype.init = function() {
        if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED)) this.setAutoStackButtons(false);
        this.isFullscreen = this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).FULLSCREEN);
    };
    MDCDialogFoundation.prototype.destroy = function() {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
            this.handleAnimationTimerEnd();
        }
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
        this.animFrame.cancelAll();
        this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
    };
    MDCDialogFoundation.prototype.open = function(dialogOptions) {
        var _this = this;
        this.dialogOpen = true;
        this.adapter.notifyOpening();
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPENING);
        if (this.isFullscreen) // A scroll event listener is registered even if the dialog is not
        // scrollable on open, since the window resize event, or orientation
        // change may make the dialog scrollable after it is opened.
        this.adapter.registerContentEventHandler("scroll", this.contentScrollHandler);
        if (dialogOptions && dialogOptions.isAboveFullscreenDialog) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCRIM_HIDDEN);
        this.adapter.registerWindowEventHandler("resize", this.windowResizeHandler);
        this.adapter.registerWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
        // Wait a frame once display is no longer "none", to establish basis for
        // animation
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPEN);
            _this.adapter.addBodyClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_LOCK);
            _this.layout();
            _this.animationTimer = setTimeout(function() {
                _this.handleAnimationTimerEnd();
                _this.adapter.trapFocus(_this.adapter.getInitialFocusEl());
                _this.adapter.notifyOpened();
            }, (0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae).DIALOG_ANIMATION_OPEN_TIME_MS);
        });
    };
    MDCDialogFoundation.prototype.close = function(action) {
        var _this = this;
        if (action === void 0) action = "";
        if (!this.dialogOpen) // Avoid redundant close calls (and events), e.g. from keydown on elements
        // that inherently emit click
        return;
        this.dialogOpen = false;
        this.adapter.notifyClosing(action);
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).CLOSING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPEN);
        this.adapter.removeBodyClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_LOCK);
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
        this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = 0;
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(function() {
            _this.adapter.releaseFocus();
            _this.handleAnimationTimerEnd();
            _this.adapter.notifyClosed(action);
        }, (0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae).DIALOG_ANIMATION_CLOSE_TIME_MS);
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Shows the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.showSurfaceScrim = function() {
        var _this = this;
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        });
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Hides the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.hideSurfaceScrim = function() {
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
    };
    /**
     * Handles `transitionend` event triggered when surface scrim animation is
     * finished.
     */ MDCDialogFoundation.prototype.handleSurfaceScrimTransitionEnd = function() {
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
    };
    MDCDialogFoundation.prototype.isOpen = function() {
        return this.dialogOpen;
    };
    MDCDialogFoundation.prototype.getEscapeKeyAction = function() {
        return this.escapeKeyAction;
    };
    MDCDialogFoundation.prototype.setEscapeKeyAction = function(action) {
        this.escapeKeyAction = action;
    };
    MDCDialogFoundation.prototype.getScrimClickAction = function() {
        return this.scrimClickAction;
    };
    MDCDialogFoundation.prototype.setScrimClickAction = function(action) {
        this.scrimClickAction = action;
    };
    MDCDialogFoundation.prototype.getAutoStackButtons = function() {
        return this.autoStackButtons;
    };
    MDCDialogFoundation.prototype.setAutoStackButtons = function(autoStack) {
        this.autoStackButtons = autoStack;
    };
    MDCDialogFoundation.prototype.getSuppressDefaultPressSelector = function() {
        return this.suppressDefaultPressSelector;
    };
    MDCDialogFoundation.prototype.setSuppressDefaultPressSelector = function(selector) {
        this.suppressDefaultPressSelector = selector;
    };
    MDCDialogFoundation.prototype.layout = function() {
        var _this = this;
        this.animFrame.request($4b6d9c4c22d1910a$var$AnimationKeys.POLL_LAYOUT_CHANGE, function() {
            _this.layoutInternal();
        });
    };
    /** Handles click on the dialog root element. */ MDCDialogFoundation.prototype.handleClick = function(evt) {
        var isScrim = this.adapter.eventTargetMatches(evt.target, (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).SCRIM_SELECTOR);
        // Check for scrim click first since it doesn't require querying ancestors.
        if (isScrim && this.scrimClickAction !== "") this.close(this.scrimClickAction);
        else {
            var action = this.adapter.getActionFromEvent(evt);
            if (action) this.close(action);
        }
    };
    /** Handles keydown on the dialog root element. */ MDCDialogFoundation.prototype.handleKeydown = function(evt) {
        var isEnter = evt.key === "Enter" || evt.keyCode === 13;
        if (!isEnter) return;
        var action = this.adapter.getActionFromEvent(evt);
        if (action) // Action button callback is handled in `handleClick`,
        // since space/enter keydowns on buttons trigger click events.
        return;
        // `composedPath` is used here, when available, to account for use cases
        // where a target meant to suppress the default press behaviour
        // may exist in a shadow root.
        // For example, a textarea inside a web component:
        // <mwc-dialog>
        //   <horizontal-layout>
        //     #shadow-root (open)
        //       <mwc-textarea>
        //         #shadow-root (open)
        //           <textarea></textarea>
        //       </mwc-textarea>
        //   </horizontal-layout>
        // </mwc-dialog>
        var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
        var isDefault = this.suppressDefaultPressSelector ? !this.adapter.eventTargetMatches(target, this.suppressDefaultPressSelector) : true;
        if (isEnter && isDefault) this.adapter.clickDefaultButton();
    };
    /** Handles keydown on the document. */ MDCDialogFoundation.prototype.handleDocumentKeydown = function(evt) {
        var isEscape = evt.key === "Escape" || evt.keyCode === 27;
        if (isEscape && this.escapeKeyAction !== "") this.close(this.escapeKeyAction);
    };
    /**
     * Handles scroll event on the dialog's content element -- showing a scroll
     * divider on the header or footer based on the scroll position. This handler
     * should only be registered on full-screen dialogs with scrollable content.
     */ MDCDialogFoundation.prototype.handleScrollEvent = function() {
        var _this = this;
        // Since scroll events can fire at a high rate, we throttle these events by
        // using requestAnimationFrame.
        this.animFrame.request($4b6d9c4c22d1910a$var$AnimationKeys.POLL_SCROLL_POS, function() {
            _this.toggleScrollDividerHeader();
            _this.toggleScrollDividerFooter();
        });
    };
    MDCDialogFoundation.prototype.layoutInternal = function() {
        if (this.autoStackButtons) this.detectStackedButtons();
        this.toggleScrollableClasses();
    };
    MDCDialogFoundation.prototype.handleAnimationTimerEnd = function() {
        this.animationTimer = 0;
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPENING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).CLOSING);
    };
    /**
     * Runs the given logic on the next animation frame, using setTimeout to
     * factor in Firefox reflow behavior.
     */ MDCDialogFoundation.prototype.runNextAnimationFrame = function(callback) {
        var _this = this;
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = requestAnimationFrame(function() {
            _this.animationFrame = 0;
            clearTimeout(_this.animationTimer);
            _this.animationTimer = setTimeout(callback, 0);
        });
    };
    MDCDialogFoundation.prototype.detectStackedButtons = function() {
        // Remove the class first to let us measure the buttons' natural positions.
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED);
        var areButtonsStacked = this.adapter.areButtonsStacked();
        if (areButtonsStacked) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED);
        if (areButtonsStacked !== this.areButtonsStacked) {
            this.adapter.reverseButtons();
            this.areButtonsStacked = areButtonsStacked;
        }
    };
    MDCDialogFoundation.prototype.toggleScrollableClasses = function() {
        // Remove the class first to let us measure the natural height of the
        // content.
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLLABLE);
        if (this.adapter.isContentScrollable()) {
            this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLLABLE);
            if (this.isFullscreen) {
                // If dialog is full-screen and scrollable, check if a scroll divider
                // should be shown.
                this.toggleScrollDividerHeader();
                this.toggleScrollDividerFooter();
            }
        }
    };
    MDCDialogFoundation.prototype.toggleScrollDividerHeader = function() {
        if (!this.adapter.isScrollableContentAtTop()) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
        else if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER)) this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
    };
    MDCDialogFoundation.prototype.toggleScrollDividerFooter = function() {
        if (!this.adapter.isScrollableContentAtBottom()) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
        else if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER)) this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
    };
    return MDCDialogFoundation;
}((0, $1b63c6dc0ee62d45$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$4b6d9c4c22d1910a$export$2e2bcd8739ae039 = $4b6d9c4c22d1910a$export$dac9922df5f517f1;


/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Determine whether the current browser supports passive event listeners, and
 * if so, use them.
 */ function $805a599b9bd39576$export$82e1592afef3b60f(globalObj) {
    if (globalObj === void 0) globalObj = window;
    return $805a599b9bd39576$var$supportsPassiveOption(globalObj) ? {
        passive: true
    } : false;
}
function $805a599b9bd39576$var$supportsPassiveOption(globalObj) {
    if (globalObj === void 0) globalObj = window;
    // See
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    var passiveSupported = false;
    try {
        var options = {
            // This function will be called when the browser
            // attempts to access the passive property.
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        var handler = function() {};
        globalObj.document.addEventListener("test", handler, options);
        globalObj.document.removeEventListener("test", handler, options);
    } catch (err) {
        passiveSupported = false;
    }
    return passiveSupported;
}


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function $76efd949163c93ea$export$ff7f7c97cdce86e(element, selector) {
    if (element.closest) return element.closest(selector);
    var el = element;
    while(el){
        if ($76efd949163c93ea$export$de994efd351b291c(el, selector)) return el;
        el = el.parentElement;
    }
    return null;
}
function $76efd949163c93ea$export$de994efd351b291c(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
}
function $76efd949163c93ea$export$30f5493effae393e(element) {
    // Check the offsetParent. If the element inherits display: none from any
    // parent, the offsetParent property will be null (see
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
    // This check ensures we only clone the node when necessary.
    var htmlEl = element;
    if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
    var clone = htmlEl.cloneNode(true);
    clone.style.setProperty("position", "absolute");
    clone.style.setProperty("transform", "translate(-9999px, -9999px)");
    document.documentElement.appendChild(clone);
    var scrollWidth = clone.scrollWidth;
    document.documentElement.removeChild(clone);
    return scrollWidth;
}







const $44d075addde26d99$var$blockingElements = document.$blockingElements;
class $44d075addde26d99$export$569e42c9a98af7b7 extends (0, $9f4ac11f71c3796c$export$a1a7283d3ef4b3a1) {
    constructor(){
        super(...arguments);
        this.hideActions = false;
        this.stacked = false;
        this.heading = "";
        this.scrimClickAction = "close";
        this.escapeKeyAction = "close";
        this.open = false;
        this.defaultAction = "close";
        this.actionAttribute = "dialogAction";
        this.initialFocusAttribute = "dialogInitialFocus";
        this.initialSupressDefaultPressSelector = "";
        this.mdcFoundationClass = (0, $4b6d9c4c22d1910a$export$2e2bcd8739ae039);
        this.boundHandleClick = null;
        this.boundHandleKeydown = null;
        this.boundHandleDocumentKeydown = null;
    }
    set suppressDefaultPressSelector(selector) {
        if (this.mdcFoundation) this.mdcFoundation.setSuppressDefaultPressSelector(selector);
        else this.initialSupressDefaultPressSelector = selector;
    }
    /**
     * @export
     */ get suppressDefaultPressSelector() {
        return this.mdcFoundation ? this.mdcFoundation.getSuppressDefaultPressSelector() : this.initialSupressDefaultPressSelector;
    }
    get primaryButton() {
        let assignedNodes = this.primarySlot.assignedNodes();
        assignedNodes = assignedNodes.filter((node)=>node instanceof HTMLElement);
        const button = assignedNodes[0];
        return button ? button : null;
    }
    emitNotification(name, action) {
        const init = {
            detail: action ? {
                action: action
            } : {}
        };
        const ev = new CustomEvent(name, init);
        this.dispatchEvent(ev);
    }
    getInitialFocusEl() {
        const initFocusSelector = `[${this.initialFocusAttribute}]`;
        // only search light DOM. This typically handles all the cases
        const lightDomQs = this.querySelector(initFocusSelector);
        if (lightDomQs) return lightDomQs;
        // if not in light dom, search each flattened distributed node.
        const primarySlot = this.primarySlot;
        const primaryNodes = primarySlot.assignedNodes({
            flatten: true
        });
        const primaryFocusElement = this.searchNodeTreesForAttribute(primaryNodes, this.initialFocusAttribute);
        if (primaryFocusElement) return primaryFocusElement;
        const secondarySlot = this.secondarySlot;
        const secondaryNodes = secondarySlot.assignedNodes({
            flatten: true
        });
        const secondaryFocusElement = this.searchNodeTreesForAttribute(secondaryNodes, this.initialFocusAttribute);
        if (secondaryFocusElement) return secondaryFocusElement;
        const contentSlot = this.contentSlot;
        const contentNodes = contentSlot.assignedNodes({
            flatten: true
        });
        const initFocusElement = this.searchNodeTreesForAttribute(contentNodes, this.initialFocusAttribute);
        return initFocusElement;
    }
    searchNodeTreesForAttribute(nodes, attribute) {
        for (const node of nodes){
            if (!(node instanceof HTMLElement)) continue;
            if (node.hasAttribute(attribute)) return node;
            else {
                const selection = node.querySelector(`[${attribute}]`);
                if (selection) return selection;
            }
        }
        return null;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $748a8e1d68854803$export$122d35ad43dccfa3)(this.mdcRoot)), {
            addBodyClass: ()=>document.body.style.overflow = "hidden",
            removeBodyClass: ()=>document.body.style.overflow = "",
            areButtonsStacked: ()=>this.stacked,
            clickDefaultButton: ()=>{
                const primary = this.primaryButton;
                if (primary) primary.click();
            },
            eventTargetMatches: (target, selector)=>target ? (0, $76efd949163c93ea$export$de994efd351b291c)(target, selector) : false,
            getActionFromEvent: (e)=>{
                if (!e.target) return "";
                const element = (0, $76efd949163c93ea$export$ff7f7c97cdce86e)(e.target, `[${this.actionAttribute}]`);
                const action = element && element.getAttribute(this.actionAttribute);
                return action;
            },
            getInitialFocusEl: ()=>{
                return this.getInitialFocusEl();
            },
            isContentScrollable: ()=>{
                const el = this.contentElement;
                return el ? el.scrollHeight > el.offsetHeight : false;
            },
            notifyClosed: (action)=>this.emitNotification("closed", action),
            notifyClosing: (action)=>{
                if (!this.closingDueToDisconnect) // Don't set our open state to closed just because we were
                // disconnected. That way if we get reconnected, we'll know to
                // re-open.
                this.open = false;
                this.emitNotification("closing", action);
            },
            notifyOpened: ()=>this.emitNotification("opened"),
            notifyOpening: ()=>{
                this.open = true;
                this.emitNotification("opening");
            },
            reverseButtons: ()=>{},
            releaseFocus: ()=>{
                $44d075addde26d99$var$blockingElements.remove(this);
            },
            trapFocus: (el)=>{
                if (!this.isConnected) // this is the case where it is opened and closed and then removed
                // from DOM before the animation has completed. Blocking Elements will
                // throw if this is the case
                return;
                $44d075addde26d99$var$blockingElements.push(this);
                if (el) el.focus();
            },
            registerContentEventHandler: (evtType, handler)=>{
                const el = this.contentElement;
                el.addEventListener(evtType, handler);
            },
            deregisterContentEventHandler: (evtType, handler)=>{
                const el = this.contentElement;
                el.removeEventListener(evtType, handler);
            },
            isScrollableContentAtTop: ()=>{
                const el = this.contentElement;
                return el ? el.scrollTop === 0 : false;
            },
            isScrollableContentAtBottom: ()=>{
                const el = this.contentElement;
                return el ? Math.ceil(el.scrollHeight - el.scrollTop) === el.clientHeight : false;
            },
            registerWindowEventHandler: (evtType, handler)=>{
                window.addEventListener(evtType, handler, (0, $805a599b9bd39576$export$82e1592afef3b60f)());
            },
            deregisterWindowEventHandler: (evtType, handler)=>{
                window.removeEventListener(evtType, handler, (0, $805a599b9bd39576$export$82e1592afef3b60f)());
            }
        });
    }
    render() {
        const classes = {
            [(0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED]: this.stacked
        };
        let heading = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``;
        if (this.heading) heading = this.renderHeading();
        const actionsClasses = {
            "mdc-dialog__actions": !this.hideActions
        };
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div class="mdc-dialog ${(0, $0e5c059fc79abe53$export$56cc687933817664)(classes)}"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="title"
        aria-describedby="content">
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          ${heading}
          <div id="content" class="mdc-dialog__content">
            <slot id="contentSlot"></slot>
          </div>
          <footer
              id="actions"
              class="${(0, $0e5c059fc79abe53$export$56cc687933817664)(actionsClasses)}">
            <span>
              <slot name="secondaryAction"></slot>
            </span>
            <span>
             <slot name="primaryAction"></slot>
            </span>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>`;
    }
    renderHeading() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <h2 id="title" class="mdc-dialog__title">${this.heading}</h2>`;
    }
    firstUpdated() {
        super.firstUpdated();
        this.mdcFoundation.setAutoStackButtons(true);
        if (this.initialSupressDefaultPressSelector) this.suppressDefaultPressSelector = this.initialSupressDefaultPressSelector;
        else this.suppressDefaultPressSelector = [
            this.suppressDefaultPressSelector,
            "mwc-textarea",
            "mwc-menu mwc-list-item",
            "mwc-select mwc-list-item"
        ].join(", ");
        this.boundHandleClick = this.mdcFoundation.handleClick.bind(this.mdcFoundation);
        this.boundHandleKeydown = this.mdcFoundation.handleKeydown.bind(this.mdcFoundation);
        this.boundHandleDocumentKeydown = this.mdcFoundation.handleDocumentKeydown.bind(this.mdcFoundation);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.open && this.mdcFoundation && !this.mdcFoundation.isOpen()) {
            // We probably got disconnected while we were still open. Re-open,
            // matching the behavior of native <dialog>.
            this.setEventListeners();
            this.mdcFoundation.open();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.open && this.mdcFoundation) {
            // If this dialog is opened and then disconnected, we want to close
            // the foundation, so that 1) any pending timers are cancelled
            // (in particular for trapFocus), and 2) if we reconnect, we can open
            // the foundation again to retrigger animations and focus.
            this.removeEventListeners();
            this.closingDueToDisconnect = true;
            this.mdcFoundation.close(this.currentAction || this.defaultAction);
            this.closingDueToDisconnect = false;
            this.currentAction = undefined;
            // When we close normally, the releaseFocus callback handles removing
            // ourselves from the blocking elements stack. However, that callback
            // happens on a delay, and when we are closing due to a disconnect we
            // need to remove ourselves before the blocking element polyfill's
            // mutation observer notices and logs a warning, since it's not valid to
            // be in the blocking elements stack while disconnected.
            $44d075addde26d99$var$blockingElements.remove(this);
        }
    }
    forceLayout() {
        this.mdcFoundation.layout();
    }
    focus() {
        const initialFocusEl = this.getInitialFocusEl();
        initialFocusEl && initialFocusEl.focus();
    }
    blur() {
        if (!this.shadowRoot) return;
        const activeEl = this.shadowRoot.activeElement;
        if (activeEl) {
            if (activeEl instanceof HTMLElement) activeEl.blur();
        } else {
            const root = this.getRootNode();
            const activeEl = root instanceof Document ? root.activeElement : null;
            if (activeEl instanceof HTMLElement) activeEl.blur();
        }
    }
    setEventListeners() {
        if (this.boundHandleClick) this.mdcRoot.addEventListener("click", this.boundHandleClick);
        if (this.boundHandleKeydown) this.mdcRoot.addEventListener("keydown", this.boundHandleKeydown, (0, $805a599b9bd39576$export$82e1592afef3b60f)());
        if (this.boundHandleDocumentKeydown) document.addEventListener("keydown", this.boundHandleDocumentKeydown, (0, $805a599b9bd39576$export$82e1592afef3b60f)());
    }
    removeEventListeners() {
        if (this.boundHandleClick) this.mdcRoot.removeEventListener("click", this.boundHandleClick);
        if (this.boundHandleKeydown) this.mdcRoot.removeEventListener("keydown", this.boundHandleKeydown);
        if (this.boundHandleDocumentKeydown) document.removeEventListener("keydown", this.boundHandleDocumentKeydown);
    }
    close() {
        this.open = false;
    }
    show() {
        this.open = true;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-dialog")
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "mdcRoot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)('slot[name="primaryAction"]')
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "primarySlot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)('slot[name="secondaryAction"]')
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "secondarySlot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)("#contentSlot")
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "contentSlot", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-dialog__content")
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "contentElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $10a410638b7df95b$export$2fa187e846a241c4)(".mdc-container")
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "conatinerElement", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "hideActions", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function() {
        this.forceLayout();
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "stacked", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "heading", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(newAction) {
        this.mdcFoundation.setScrimClickAction(newAction);
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "scrimClickAction", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(newAction) {
        this.mdcFoundation.setEscapeKeyAction(newAction);
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "escapeKeyAction", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $7087db5d0615d2d8$export$b6ae1bc530f4c149)(function(isOpen) {
        // Check isConnected because we could have been disconnected before first
        // update. If we're now closed, then we shouldn't start the MDC foundation
        // opening animation. If we're now closed, then we've already closed the
        // foundation in disconnectedCallback.
        if (this.mdcFoundation && this.isConnected) {
            if (isOpen) {
                this.setEventListeners();
                this.mdcFoundation.open();
            } else {
                this.removeEventListeners();
                this.mdcFoundation.close(this.currentAction || this.defaultAction);
                this.currentAction = undefined;
            }
        }
    })
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "open", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "defaultAction", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "actionAttribute", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)()
], $44d075addde26d99$export$569e42c9a98af7b7.prototype, "initialFocusAttribute", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $dcc2ff5336d54cea$export$9dd6ff9ea0189349 = (0, $3233927aa82734f9$export$dbf350e5966cf602)`.mdc-dialog .mdc-dialog__surface{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-dialog .mdc-dialog__scrim{background-color:rgba(0,0,0,.32)}.mdc-dialog .mdc-dialog__surface-scrim{background-color:rgba(0,0,0,.32)}.mdc-dialog .mdc-dialog__title{color:rgba(0,0,0,.87)}.mdc-dialog .mdc-dialog__content{color:rgba(0,0,0,.6)}.mdc-dialog .mdc-dialog__close{color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-dialog .mdc-dialog__close .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close .mdc-icon-button__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-surface, #000))}.mdc-dialog .mdc-dialog__close:hover .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions,.mdc-dialog.mdc-dialog--scrollable.mdc-dialog-scroll-divider-footer .mdc-dialog__actions{border-color:rgba(0,0,0,.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:1px solid rgba(0,0,0,.12);margin-bottom:0}.mdc-dialog.mdc-dialog-scroll-divider-header.mdc-dialog--fullscreen .mdc-dialog__header{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 1px 5px 0px rgba(0,0,0,.12)}.mdc-dialog .mdc-dialog__surface{border-radius:4px;border-radius:var(--mdc-shape-medium, 4px)}.mdc-dialog__surface{box-shadow:0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0,0,0,.12)}.mdc-dialog__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-headline6-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size, 1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height, 2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight, 500);letter-spacing:0.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing, 0.0125em);text-decoration:inherit;text-decoration:var(--mdc-typography-headline6-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform, inherit)}.mdc-dialog__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-body1-font-size, 1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height, 1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight, 400);letter-spacing:0.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing, 0.03125em);text-decoration:inherit;text-decoration:var(--mdc-typography-body1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform, inherit)}.mdc-elevation-overlay{position:absolute;border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity, 0);transition:opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:#fff;background-color:var(--mdc-elevation-overlay-color, #fff)}.mdc-dialog,.mdc-dialog__scrim{position:fixed;top:0;left:0;align-items:center;justify-content:center;box-sizing:border-box;width:100%;height:100%}.mdc-dialog{display:none;z-index:7;z-index:var(--mdc-dialog-z-index, 7)}.mdc-dialog .mdc-dialog__content{padding:20px 24px 20px 24px}.mdc-dialog .mdc-dialog__surface{min-width:280px}@media(max-width: 592px){.mdc-dialog .mdc-dialog__surface{max-width:calc(100vw - 32px)}}@media(min-width: 592px){.mdc-dialog .mdc-dialog__surface{max-width:560px}}.mdc-dialog .mdc-dialog__surface{max-height:calc(100% - 32px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:none}@media(max-width: 960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px;width:560px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media(max-width: 720px)and (max-width: 672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:calc(100vw - 112px)}}@media(max-width: 720px)and (min-width: 672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:560px}}@media(max-width: 720px)and (max-height: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:calc(100vh - 160px)}}@media(max-width: 720px)and (min-height: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px}}@media(max-width: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media(max-width: 720px)and (max-height: 400px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{height:100%;max-height:100vh;max-width:100vw;width:100vw;border-radius:0}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{padding:0 16px 9px;justify-content:flex-start}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:calc(16px - 2 * 12px)}}@media(max-width: 600px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{height:100%;max-height:100vh;max-width:100vw;width:100vw;border-radius:0}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{padding:0 16px 9px;justify-content:flex-start}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:calc(16px - 2 * 12px)}}@media(min-width: 960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:calc(100vw - 400px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}.mdc-dialog.mdc-dialog__scrim--hidden .mdc-dialog__scrim{opacity:0}.mdc-dialog__scrim{opacity:0;z-index:-1}.mdc-dialog__container{display:flex;flex-direction:row;align-items:center;justify-content:space-around;box-sizing:border-box;height:100%;transform:scale(0.8);opacity:0;pointer-events:none}.mdc-dialog__surface{position:relative;display:flex;flex-direction:column;flex-grow:0;flex-shrink:0;box-sizing:border-box;max-width:100%;max-height:100%;pointer-events:auto;overflow-y:auto}.mdc-dialog__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}[dir=rtl] .mdc-dialog__surface,.mdc-dialog__surface[dir=rtl]{text-align:right}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-dialog__surface{outline:2px solid windowText}}.mdc-dialog__surface::before{position:absolute;box-sizing:border-box;width:100%;height:100%;top:0;left:0;border:2px solid transparent;border-radius:inherit;content:"";pointer-events:none}@media screen and (forced-colors: active){.mdc-dialog__surface::before{border-color:CanvasText}}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.mdc-dialog__surface::before{content:none}}.mdc-dialog__title{display:block;margin-top:0;position:relative;flex-shrink:0;box-sizing:border-box;margin:0 0 1px;padding:0 24px 9px}.mdc-dialog__title::before{display:inline-block;width:0;height:40px;content:"";vertical-align:0}[dir=rtl] .mdc-dialog__title,.mdc-dialog__title[dir=rtl]{text-align:right}.mdc-dialog--scrollable .mdc-dialog__title{margin-bottom:1px;padding-bottom:15px}.mdc-dialog--fullscreen .mdc-dialog__header{align-items:baseline;border-bottom:1px solid transparent;display:inline-flex;justify-content:space-between;padding:0 24px 9px;z-index:1}@media screen and (forced-colors: active){.mdc-dialog--fullscreen .mdc-dialog__header{border-bottom-color:CanvasText}}.mdc-dialog--fullscreen .mdc-dialog__header .mdc-dialog__close{right:-12px}.mdc-dialog--fullscreen .mdc-dialog__title{margin-bottom:0;padding:0;border-bottom:0}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:0;margin-bottom:0}.mdc-dialog--fullscreen .mdc-dialog__close{top:5px}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top:1px solid transparent}@media screen and (forced-colors: active){.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top-color:CanvasText}}.mdc-dialog__content{flex-grow:1;box-sizing:border-box;margin:0;overflow:auto}.mdc-dialog__content>:first-child{margin-top:0}.mdc-dialog__content>:last-child{margin-bottom:0}.mdc-dialog__title+.mdc-dialog__content,.mdc-dialog__header+.mdc-dialog__content{padding-top:0}.mdc-dialog--scrollable .mdc-dialog__title+.mdc-dialog__content{padding-top:8px;padding-bottom:8px}.mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:6px 0 0}.mdc-dialog--scrollable .mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:0}.mdc-dialog__actions{display:flex;position:relative;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;box-sizing:border-box;min-height:52px;margin:0;padding:8px;border-top:1px solid transparent}@media screen and (forced-colors: active){.mdc-dialog__actions{border-top-color:CanvasText}}.mdc-dialog--stacked .mdc-dialog__actions{flex-direction:column;align-items:flex-end}.mdc-dialog__button{margin-left:8px;margin-right:0;max-width:100%;text-align:right}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{margin-left:0;margin-right:8px}.mdc-dialog__button:first-child{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button:first-child,.mdc-dialog__button:first-child[dir=rtl]{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{text-align:left}.mdc-dialog--stacked .mdc-dialog__button:not(:first-child){margin-top:12px}.mdc-dialog--open,.mdc-dialog--opening,.mdc-dialog--closing{display:flex}.mdc-dialog--opening .mdc-dialog__scrim{transition:opacity 150ms linear}.mdc-dialog--opening .mdc-dialog__container{transition:opacity 75ms linear,transform 150ms 0ms cubic-bezier(0, 0, 0.2, 1)}.mdc-dialog--closing .mdc-dialog__scrim,.mdc-dialog--closing .mdc-dialog__container{transition:opacity 75ms linear}.mdc-dialog--closing .mdc-dialog__container{transform:none}.mdc-dialog--open .mdc-dialog__scrim{opacity:1}.mdc-dialog--open .mdc-dialog__container{transform:none;opacity:1}.mdc-dialog--open.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim{opacity:1;z-index:1}.mdc-dialog--open.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{transition:opacity 75ms linear}.mdc-dialog--open.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim{transition:opacity 150ms linear}.mdc-dialog__surface-scrim{display:none;opacity:0;position:absolute;width:100%;height:100%}.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{display:block}.mdc-dialog-scroll-lock{overflow:hidden}.mdc-dialog--no-content-padding .mdc-dialog__content{padding:0}.mdc-dialog--sheet .mdc-dialog__close{right:12px;top:9px;position:absolute;z-index:1}#actions:not(.mdc-dialog__actions){display:none}.mdc-dialog__surface{box-shadow:var(--mdc-dialog-box-shadow, 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12))}@media(min-width: 560px){.mdc-dialog .mdc-dialog__surface{max-width:560px;max-width:var(--mdc-dialog-max-width, 560px)}}.mdc-dialog .mdc-dialog__scrim{background-color:rgba(0, 0, 0, 0.32);background-color:var(--mdc-dialog-scrim-color, rgba(0, 0, 0, 0.32))}.mdc-dialog .mdc-dialog__title{color:rgba(0, 0, 0, 0.87);color:var(--mdc-dialog-heading-ink-color, rgba(0, 0, 0, 0.87))}.mdc-dialog .mdc-dialog__content{color:rgba(0, 0, 0, 0.6);color:var(--mdc-dialog-content-ink-color, rgba(0, 0, 0, 0.6))}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions{border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-dialog-scroll-divider-color, rgba(0, 0, 0, 0.12))}.mdc-dialog .mdc-dialog__surface{min-width:280px;min-width:var(--mdc-dialog-min-width, 280px)}.mdc-dialog .mdc-dialog__surface{max-height:var(--mdc-dialog-max-height, calc(100% - 32px))}#actions ::slotted(*){margin-left:8px;margin-right:0;max-width:100%;text-align:right}[dir=rtl] #actions ::slotted(*),#actions ::slotted(*[dir=rtl]){margin-left:0;margin-right:8px}[dir=rtl] #actions ::slotted(*),#actions ::slotted(*[dir=rtl]){text-align:left}.mdc-dialog--stacked #actions{flex-direction:column-reverse}.mdc-dialog--stacked #actions *:not(:last-child) ::slotted(*){flex-basis:.000000001px;margin-top:12px}`;


let $bee48aeaccc09aae$export$3ddf2d174ce01153 = class Dialog extends (0, $44d075addde26d99$export$569e42c9a98af7b7) {
};
$bee48aeaccc09aae$export$3ddf2d174ce01153.styles = [
    (0, $dcc2ff5336d54cea$export$9dd6ff9ea0189349)
];
$bee48aeaccc09aae$export$3ddf2d174ce01153 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("mwc-dialog")
], $bee48aeaccc09aae$export$3ddf2d174ce01153);




/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $f73fd576365dd66d$export$1f44aaf2ec115b54 {
    /**
     * Constructs a new User object.
     * @constructor
     * @param {string} userID - The unique identifier of the user.
     * @param {string} firstName - The first name of the user.
     * @param {string} lastName - The last name of the user.
     * @param {string} role - The role of the user.
     */ constructor(userID, firstName, lastName, role){
        this.userID = userID;
        this.firstName = firstName;
        this.lastName = lastName;
        this.role = role;
    }
    /**
     * Retrieves a list of users from the database.
     * @static
     * @async
     * @function list
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for database access.
     * @returns {Promise<User[]>} - A promise that resolves to an array of User objects.
     */ static async list(database, accessToken) {
        const users = [];
        if (database) {
            const sql = "SELECT * FROM User;";
            const rows = await database.read(accessToken, sql);
            rows.forEach((row)=>{
                const user = new $f73fd576365dd66d$export$1f44aaf2ec115b54(row.userID, row.firstName, row.lastName, row.role);
                users.push(user);
            });
        }
        return users;
    }
    /**
     * Saves the new user to the database.
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for executing SQL statements in the database.
     * @return {Promise<void>} - A promise indicating the completion of the save operation.
     */ async save(database, accessToken) {
        const sql = `INSERT INTO User (UserID, FirstName, LastName, Role) VALUES ('${this.userID}','${this.firstName}','${this.lastName}','${this.role}')`;
        await database.readWrite(accessToken, sql);
    }
    /**
     * Deletes multiple users from the database based on their user IDs.
     * @param {Database} database - The database object.
     * @param {string} accessToken - The access token for database access.
     * @param {Array<string>} selectedUserIDs - An array of user IDs to delete.
     */ static async deleteUsers(database, accessToken, selectedUserIDs) {
        const sql = `DELETE FROM User WHERE userID in ('${selectedUserIDs.join("','")}')`;
        database.readWrite(accessToken, sql);
    }
}




let $8f6bb05fecb6d55e$export$582a43a6209fd7d0 = class HitlUsers extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }

    md-data-table-footer {
      gap: 10px;
      align-items: center;
    }

    md-outlined-text-field {
      padding: 10px 0 10px;
      width: 100%;
    }

    mwc-select {
      width: 100%;
    }
    md-data-table-cell {
      background-color: #ffffff;
    }
    md-data-table-column {
      background-color: #ffffff;
    }
    md-data-table-footer {
      background-color: #ffffff;
    }
    .capitalize {
      text-transform: capitalize;
    }
    .tooltip {
        position: relative;
        display: inline-block;
        border-bottom: 1px dotted black;
      }
      
      .tooltip .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.3s;
      }
      
      .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
      }
      
      .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
  `;
    constructor(){
        super();
        /**
   * Selected users
   */ this.selectedUsers = [];
        /**
   * Boolean per default its false. When a new client should be created this value becomes true and makes the a new row visible, if the value persists as true. 
   */ this.addUser = false;
        /**
   * Dialog text
   */ this.dialogText = document.createElement("p");
        /**
   * Ok button for dialog
   */ this.footerButtonOk = document.createElement("mwc-button");
        /**
   * Cancel button for dialog
   */ this.footerButtonCancel = document.createElement("mwc-button");
        /**
   * E-mail text for copy dialog
  */ this.emailText = document.createElement("p");
        /**
   * Password text for copy dialog
   */ this.passwordText = document.createElement("p");
        /**
   * Copy e-mail button
   */ this.copyEmailButton = document.createElement("mwc-icon-button");
        /**
   * Copy password button
   */ this.copyPasswordButton = document.createElement("mwc-icon-button");
        /**
   * Copy e-mail tip div tag
   */ this.emailTip = document.createElement("div");
        /**
   * Copy password tip div tag
   */ this.passwordTip = document.createElement("div");
        /**
   * Copy e-mail tip text
   */ this.emailTipText = document.createElement("span");
        /**
   * Copy password tip text
   */ this.passwordTipText = document.createElement("span");
        /**
   * Copy e-mail div tag
   */ this.emailDiv = document.createElement("div");
        /**
   * Copy password div tag
   */ this.passwordDiv = document.createElement("div");
        /**
   * Temp selected rows
   */ this.tempSelectedRows = [];
        /**
   * Admin group id. It will readed from the file .env
   */ this.ADMIN_GROUP_ID = "groups/00lnxbz926vqqme";
        /**
   * User group id. It will readed from the file .env
   */ this.USER_GROUP_ID = "groups/02bn6wsx2i7bmvm";
        /**
   * Customer id. It will readed from the file .env
   */ this.CUSTOMER_ID = "C040qydp8";
        /**
   * Organisation unit path. It will readed from the file .env. 
   * Depending on the project has to be changed in terraform.tfvars
   */ this.ORG_UNIT_PATH = "/DORNBACH GmbH";
        /**
   * Special event from the package maicol07/material-web-additions/data-table/data-table.
   * It triggers if the row selection in the data-table changes
   * @param e 
   */ this.rowSelectionChanged = async (e)=>{
            console.log("rowSelectionChanged", e);
            this.tempSelectedRows = e.target.rows.filter((row)=>row.selected);
            this.selectedUsers = e.target.rows.filter((row)=>row.selected).map((row)=>this.users.find((user)=>user.userID === row.dataset.id));
            console.log("selectedUsers", this.selectedUsers);
        };
        /**
   * Save new user
   * @param e 
   */ this.saveUser = async (e)=>{
            const firstName = this.renderRoot.querySelector("#firstName").value;
            const lastName = this.renderRoot.querySelector("#lastName").value;
            //If first- and lastname are not empty
            if (firstName.length > 0 && lastName.length > 0) {
                const accessToken = await this.getAccessToken(true, "https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/admin.directory.user", false);
                /**
     * E-mail of the new user
     */ const userID = (await this.emailGeneration(accessToken, firstName.toLowerCase(), lastName.toLowerCase())).toString();
                /**
     * Role of the new user
     */ const role = this.renderRoot.querySelector("#role").value;
                /**
     * Stores the firstname with the first char as uppercase
     */ let firstNameUppercase;
                /**
     * Stores the lastname with the first char as uppercase
     */ let lastNameUppercase;
                //If firstname has a higher length than 1, then make the first char of the firstname uppercase
                if (firstName.length > 1) firstNameUppercase = firstName.charAt(0).toUpperCase() + firstName.slice(1);
                else firstNameUppercase = firstName.toUpperCase();
                //If lastname has a higher length than 1, then make the first char of the lastname uppercase
                if (lastName.length > 1) lastNameUppercase = lastName.charAt(0).toUpperCase() + lastName.slice(1);
                else lastNameUppercase = lastName.toUpperCase();
                /**
     * The current group id will be stored in this var
     */ let groupId;
                //If the new user has the role ADMIN or DATA-ADMIN then group id is equal admin group id
                if (role === "ADMIN" || role === "DATA-ADMIN") groupId = this.ADMIN_GROUP_ID;
                else groupId = this.USER_GROUP_ID;
                /**
     * The new user which will be inserted in Spanner database
     */ const user = new (0, $f73fd576365dd66d$export$1f44aaf2ec115b54)(userID, firstNameUppercase, lastNameUppercase, role);
                /**
     * Initialpassword for the new User
     */ const initialPassword = new Array(10).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz").map((x)=>(function(chars) {
                        let umax = Math.pow(2, 32), r = new Uint32Array(1), max = umax - umax % chars.length;
                        do crypto.getRandomValues(r);
                        while (r[0] > max);
                        return chars[r[0] % chars.length];
                    })(x)).join("");
                //Generate user with password in admin.google
                await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(`https://admin.googleapis.com/admin/directory/v1/users`, {
                    //Should send the user an invitation
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        name: {
                            givenName: user.firstName,
                            familyName: user.lastName
                        },
                        password: initialPassword,
                        primaryEmail: user.userID,
                        changePasswordAtNextLogin: true,
                        orgUnitPath: this.ORG_UNIT_PATH
                    })
                });
                this.dialog.innerHTML = `Benutzer erstellt.`;
                this.copyEmailButton.setAttribute("icon", "content_copy");
                this.copyEmailButton.addEventListener("click", ()=>this.copyClipboard(e, "E-Mail", userID));
                this.emailText.innerHTML = `E-Mail: ${userID}`;
                this.emailTip.classList.add("tooltip");
                this.emailTipText.classList.add("tooltiptext");
                this.emailTipText.innerHTML = "E-Mail kopieren";
                this.emailTip.appendChild(this.copyEmailButton);
                this.emailTip.appendChild(this.emailTipText);
                this.emailDiv.appendChild(this.emailText);
                this.emailDiv.appendChild(this.emailTip);
                this.passwordText.innerHTML = `Initialpasswort: ${initialPassword}`;
                this.copyPasswordButton.setAttribute("icon", "content_copy");
                this.copyPasswordButton.addEventListener("click", ()=>this.copyClipboard(e, "Password", initialPassword));
                this.passwordTip.classList.add("tooltip");
                this.passwordTipText.classList.add("tooltiptext");
                this.passwordTipText.innerHTML = "Passwort kopieren";
                this.passwordTip.appendChild(this.copyPasswordButton);
                this.passwordTip.appendChild(this.passwordTipText);
                this.passwordDiv.appendChild(this.passwordText);
                this.passwordDiv.appendChild(this.passwordTip);
                this.footerButtonOk.setAttribute("slot", "primaryAction");
                this.footerButtonOk.setAttribute("dialogAction", "ok");
                this.footerButtonOk.innerText = "Ok";
                this.footerButtonOk.classList.add("raised");
                this.dialog.appendChild(this.emailDiv);
                this.dialog.appendChild(this.passwordDiv);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
                this.dialog.addEventListener("closed", ()=>{
                    this.tempSelectedRows.forEach((row)=>{
                        row.selected = false;
                    });
                    //TODO: Verschieben in andere Methode
                    this.selectedUsers = [];
                    this.dialog.innerHTML = "";
                    this.emailDiv.innerHTML = "";
                    this.passwordDiv.innerHTML = "";
                    this.emailText.innerHTML = "";
                    this.emailTip.innerHTML = "";
                    this.passwordText.innerHTML = "";
                    this.passwordTip.innerHTML = "";
                });
                // wait 5 seconds before adding user to group
                await new Promise((resolve)=>setTimeout(resolve, 5000));
                // add user to group in admin.google
                const url = `https://cloudidentity.googleapis.com/v1/${groupId}/memberships`; //Add existing users to group
                await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(url, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "preferredMemberKey": {
                            id: userID
                        },
                        roles: [
                            {
                                name: "MEMBER"
                            }
                        ]
                    })
                }).then(async (response)=>{
                    console.log(response);
                }).catch((error)=>console.error(error));
                user.save(this.database, accessToken);
                this.users = this.users.concat([
                    user
                ]);
                this.addUser = false;
            } else {
                //Cases to assign dialog text a value
                switch(true){
                    //If firstname and lastname are empty
                    case !firstName && !lastName:
                        this.dialogText.innerHTML = "Geben Sie bitte den Vor- und Nachnamen des neuen Benutzers an";
                        break;
                    //If only firstname is empty
                    case !firstName:
                        this.dialogText.innerHTML = "Geben Sie bitte den Vornamen des neuen Benutzers an";
                        break;
                    //If only lastname is empty
                    case !lastName:
                        this.dialogText.innerHTML = "Geben Sie bitte den Nachnamen des neuen Benutzers an";
                        break;
                }
                this.initDialog();
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
                this.footerButtonOk.addEventListener("click", ()=>{
                    this.dialog.open = false;
                });
            }
        };
        /**
   * Generate a new password for an existing user
   * @param e 
   */ this.generatePassword = async (e)=>{
            const accessToken = await this.getAccessToken(true, "https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/admin.directory.user", false);
            //If the user exists then set a new password
            if (this.users.find((user)=>user.userID == this.selectedUsers[0].userID)) {
                const initialPassword = new Array(10).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz").map((x)=>(function(chars) {
                        let umax = Math.pow(2, 32), r = new Uint32Array(1), max = umax - umax % chars.length;
                        do crypto.getRandomValues(r);
                        while (r[0] > max);
                        return chars[r[0] % chars.length];
                    })(x)).join("");
                await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(`https://admin.googleapis.com/admin/directory/v1/users/${this.selectedUsers[0].userID}`, {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        password: initialPassword,
                        primaryEmail: this.selectedUsers[0].userID,
                        changePasswordAtNextLogin: true
                    })
                });
                this.dialog.innerHTML = "";
                this.dialog.innerHTML = `Benutzer Passwort generiert. `;
                this.dialog.setAttribute("style", "border-color: #000000; border-width: 1px; font-size: 1.1em;");
                this.dialogText.style.color = "#000000";
                this.dialogText.style.padding = "0px 20%";
                this.emailText.innerHTML = `E-Mail: ${this.selectedUsers[0].userID}`;
                this.copyEmailButton.setAttribute("icon", "content_copy");
                this.emailTip.classList.add("tooltip");
                this.emailTipText.classList.add("tooltiptext");
                this.emailTipText.innerHTML = "E-Mail kopieren";
                this.emailTip.appendChild(this.copyEmailButton);
                this.emailTip.appendChild(this.emailTipText);
                this.emailDiv.appendChild(this.emailText);
                this.emailDiv.appendChild(this.emailTip);
                this.copyEmailButton.addEventListener("click", ()=>this.copyClipboard(e, "E-Mail", this.selectedUsers[0].userID));
                this.passwordText.innerHTML = `Initialpasswort: ${initialPassword}`;
                this.copyPasswordButton.setAttribute("icon", "content_copy");
                this.passwordTip.classList.add("tooltip");
                this.passwordTipText.classList.add("tooltiptext");
                this.passwordTipText.innerHTML = "Passwort kopieren";
                this.passwordTip.appendChild(this.copyPasswordButton);
                this.passwordTip.appendChild(this.passwordTipText);
                this.passwordDiv.appendChild(this.passwordText);
                this.passwordDiv.appendChild(this.passwordTip);
                this.copyPasswordButton.addEventListener("click", ()=>this.copyClipboard(e, "Password", initialPassword));
                this.dialog.appendChild(this.emailDiv);
                this.dialog.appendChild(this.passwordDiv);
                this.footerButtonOk.setAttribute("slot", "primaryAction");
                this.footerButtonOk.setAttribute("dialogAction", "ok");
                this.footerButtonOk.innerText = "Ok";
                this.footerButtonOk.classList.add("raised");
                this.dialog.appendChild(this.emailDiv);
                this.dialog.appendChild(this.passwordDiv);
                this.dialog.appendChild(this.footerButtonOk);
                //If dialog is closed then reset all values
                this.dialog.addEventListener("closed", ()=>{
                    this.tempSelectedRows.forEach((row)=>{
                        row.selected = false;
                    });
                    this.selectedUsers = [];
                    this.dialog.innerHTML = "";
                    this.emailDiv.innerHTML = "";
                    this.passwordDiv.innerHTML = "";
                    this.emailText.innerHTML = "";
                    this.emailTip.innerHTML = "";
                    this.passwordText.innerHTML = "";
                    this.passwordTip.innerHTML = "";
                });
                this.dialog.open = true;
            }
        };
        /**
   * Copy e-mail or password from the dialog to the clipboard
   * @param e 
   * @param type 
   * @param input 
   */ this.copyClipboard = async (e, type, input)=>{
            e.stopPropagation();
            //Switch case between e-mail and password
            switch(type){
                case "E-Mail":
                    //Copy e-mail to the clipboard
                    navigator.clipboard.writeText(input);
                    this.emailTipText.innerHTML = "";
                    this.emailTipText.innerHTML = "E-Mail kopiert";
                    //Changes the text of the email tip text if 3 sec. = 3000 msec. have passed
                    setTimeout(()=>{
                        this.emailTipText.innerHTML = "E-Mail kopieren";
                    }, 3000);
                    break;
                case "Password":
                    //Copy password to the clipboard
                    navigator.clipboard.writeText(input);
                    this.passwordTipText.innerHTML = "";
                    this.passwordTipText.innerHTML = "Passwort kopiert";
                    //Changes the text of the password tip text if 3 sec. = 3000 msec. have passed
                    setTimeout(()=>{
                        this.passwordTipText.innerHTML = "Passwort kopieren";
                    }, 3000);
                    break;
            }
        };
        /**
   * Delete selected user 
   * @param e 
   */ this.deleteUser = async (e)=>{
            e.preventDefault();
            /**
     * Access token for groups in admin.google
     */ this.initDialog();
            //If more than one user got selected then put the text in dialog text
            if (this.selectedUsers.length > 1) this.dialogText.innerHTML = "Sind Sie sicher, das Sie die ausgew\xe4hlten Benutzer m\xf6chten?";
            else this.dialogText.innerHTML = "Sind Sie sicher, das Sie den ausgew\xe4hlte Benutzer l\xf6schen m\xf6chten?";
            //Click event for delete confirmation
            const footerButtonOkClickHandler = async ()=>{
                const accessToken = await this.getAccessToken(true, "https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/cloud-identity.groups https://www.googleapis.com/auth/admin.directory.group https://www.googleapis.com/auth/admin.directory.group.member https://www.googleapis.com/auth/admin.directory.user", false);
                this.dialog.innerHTML = "";
                const okButton = document.createElement("mwc-button");
                okButton.setAttribute("dialogAction", "ok");
                okButton.innerText = "Ok";
                okButton.classList.add("raised");
                const circularProgress = document.createElement("mwc-circular-progress");
                circularProgress.setAttribute("density", "-1");
                circularProgress.setAttribute("indeterminate", "true");
                //The shown text if more than one user are selected
                if (this.selectedUsers.length > 1) {
                    this.dialogText.innerHTML = "Benutzer werden gel\xf6scht..";
                    this.dialogText.appendChild(circularProgress);
                //The shown text if only one user is selected
                } else {
                    this.dialogText.innerHTML = "Benutzer wird gel\xf6scht..";
                    this.dialogText.appendChild(circularProgress);
                }
                this.dialog.style.textAlign = "-webkit-center";
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(okButton);
                this.dialog.open = true;
                this.dialog.addEventListener("closed", ()=>{
                    okButton.remove();
                });
                /**
         * Selected user ids
         */ const selectedUserIDs = this.selectedUsers.map((user)=>user.userID);
                //Users will filtered based on the removed user(s)
                this.users = this.users.filter((user)=>!this.selectedUsers.includes(user));
                //Delete users
                (0, $f73fd576365dd66d$export$1f44aaf2ec115b54).deleteUsers(this.database, accessToken, selectedUserIDs).then(()=>{
                    this.tempSelectedRows.forEach((row)=>{
                        row.selected = false;
                    });
                    this.dialog.open = false;
                    console.log("User deleted in spanner");
                });
                this.selectedUsers.forEach(async (user)=>{
                    //DELETE User from directory Users (All existing users)
                    await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(`https://admin.googleapis.com/admin/directory/v1/users/${user.userID}`, {
                        method: "DELETE",
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "application/json"
                        }
                    }).then((response)=>{
                        //If it comes response then close dialog
                        console.log(response);
                        this.dialog.innerHTML = "";
                        console.log("User deleted in admin.google");
                        this.selectedUsers = [];
                        this.requestUpdate();
                    }).catch((error)=>console.log(error));
                });
            };
            this.footerButtonOk.addEventListener("click", footerButtonOkClickHandler);
            this.dialog.appendChild(this.dialogText);
            this.dialog.appendChild(this.footerButtonCancel);
            this.dialog.appendChild(this.footerButtonOk);
            this.dialog.open = true;
            this.dialog.addEventListener("closed", ()=>{
                this.footerButtonOk.innerHTML = "";
                this.footerButtonOk.removeEventListener("click", footerButtonOkClickHandler);
            });
        };
        this.gisUserPromise = new Promise((resolve, reject)=>{
            this.gisLoadOkay = resolve;
            this.gisLoadFail = reject;
        });
    }
    async firstUpdated() {
        const accessToken = await this.getAccessToken();
        //Initialization users
        if (this.database) {
            this.users = await (0, $f73fd576365dd66d$export$1f44aaf2ec115b54).list(this.database, accessToken);
            console.log("users", this.users);
        }
    }
    render() {
        const template = [];
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">Benutzer Administration</h2>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
          <md-data-table
            aria-label="Benutzer Administration"
            density=""
            page-sizes-label="Zeilen pro Seite:"
            first-row-of-page=""
            current-page-size=""
            last-row-of-page=""
            paginated="true"
            pagination-total-label=":firstRow-:lastRow of :totalRows"
            @row-selection-changed=${this.rowSelectionChanged}
            @selected-all=${this.rowSelectionChanged}
            @unselected-all=${this.rowSelectionChanged}>
            <md-data-table-column type="checkbox"></md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              E-Mail
            </md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Vorname
            </md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Nachname
            </md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Rolle
            </md-data-table-column>
            ${this.addUser ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-data-table-row data-id="-1">
                  <md-data-table-cell>
  <mwc-icon-button @click=${()=>this.addUser = false} icon="cancel"></mwc-icon-button></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell>
                  <md-outlined-text-field id="firstName" class="capitalize" label="Vorname" @keydown="${this.handleKey}">
                  </md-outlined-text-field>
                  </md-data-table-cell>
                  <md-data-table-cell><md-outlined-text-field id="lastName" class="capitalize" label="Nachname" @keydown="${this.handleKey}">
                    </md-outlined-text-field></md-data-table-cell>
                    </md-data-table-cell>
                  <md-data-table-cell><mwc-select id="role" label="Rolle" fixedMenuPosition=true>                    
                    <mwc-list-item value="USER" selected>USER</mwc-list-item>
                    <mwc-list-item value="ADMIN">ADMIN</mwc-list-item>
                    <mwc-list-item value="DATA-ADMIN">DATA-ADMIN</mwc-list-item>
                </mwc-select>
                </md-data-table-cell>
                </md-data-table-row>` : null}
            ${this.users.map((user)=>{
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <md-data-table-row data-id=${user.userID}>
                  <md-data-table-cell
                    type="checkbox"
                    class="user-checkbox"></md-data-table-cell>
                  <md-data-table-cell>${user.userID}</md-data-table-cell>  
                  <md-data-table-cell>${user.firstName}</md-data-table-cell>
                  <md-data-table-cell>${user.lastName}</md-data-table-cell>
                  <md-data-table-cell>${user.role}</md-data-table-cell>
                </md-data-table-row>
              `;
        })}
            <md-data-table-footer
              slot="footer"
              style="display: flex; align-items: left; justify-content: left;">
              <mwc-button
                raised
                @click=${()=>this.addUser = true}
                label="Neuen Benutzer hinzufügen"
                ?disabled=${this.addUser}></mwc-button>
              <mwc-button
                raised
                @click=${this.saveUser}
                label="Neuen Benutzer speichern"
                ?disabled=${!this.addUser}></mwc-button>
              <mwc-button
                raised
                @click=${this.deleteUser}
                label="Ausgewählten Benutzer löschen"
                ?disabled=${this.addUser || this.selectedUsers.length === 0}></mwc-button>
                <mwc-button
                raised
                @click=${this.generatePassword}
                label="Neues Passwort generieren"
                ?disabled=${this.addUser || this.selectedUsers.length === 0 || this.selectedUsers.length > 1}></mwc-button>
            </md-data-table-footer>
          </md-data-table>
        </div>
      </div>
    `);
        return template;
    }
    async connectedCallback() {
        super.connectedCallback();
        //Interval in which users are updated each minute = 60000 msec.
        this.timerId = setInterval(async ()=>{
            if (this.database) {
                const accessToken = await this.getAccessToken();
                this.users = await (0, $f73fd576365dd66d$export$1f44aaf2ec115b54).list(this.database, accessToken);
            }
            this.requestUpdate();
            console.log("requestUpdate called");
        }, 60000);
        await this.gisUserPromise;
        //Dialog click event
        this.dialog.addEventListener("click", (event)=>{
            const rect = this.dialog.getBoundingClientRect();
            const isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
            if (!isInDialog) this.dialog.open = false;
        });
    }
    //Interval will stopped by leaving the page administration
    disconnectedCallback() {
        super.disconnectedCallback();
        //Interval for users get disconnected after leaving the page with this component
        if (this.timerId) clearInterval(this.timerId);
        console.log("Clear Interval from disconnectedCallback");
    }
    /** 
   * Handeling interaction with new consultant using keyboard keys
   * @param e KeyboardEvent is an event which describes a key action 
   * 
   */ handleKey(e) {
        const firstName = this.renderRoot.querySelector("#firstName");
        const lastName = this.renderRoot.querySelector("#lastName");
        if (e.key === "Enter") {
            if (firstName.value.trim() !== "" && lastName.value.trim() !== "") this.saveUser(e);
            else {
                if (firstName.value.trim() == "") firstName.focus();
                else if (lastName.value.trim() == "") lastName.focus();
            }
        } else if (e.key == "Escape") this.addUser = false;
    }
    /**
   * Generate Email for new User
   * @param accessToken 
   * @param firstname 
   * @param lastname 
   * @returns Promise<string>
   */ async emailGeneration(accessToken, firstname, lastname) {
        /**
     * List all users
     */ let listUsers = [];
        /**
     * List all e-mails of the users from listUsers
     */ const listEMails = [];
        const regexSpecialSymbols = /[äöü]/i;
        //Replace Ä, Ö and or Ü because emails cannot have these symbols
        if (regexSpecialSymbols.test(firstname)) firstname = firstname.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue");
        else if (regexSpecialSymbols.test(lastname)) lastname = lastname.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue");
        //Call to get list of users from admin.google
        await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(`https://admin.googleapis.com/admin/directory/v1/users?customer=${this.CUSTOMER_ID}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            }
        }).then(async (response)=>{
            //If response is ok then the data will be loaded
            if (response.ok) {
                const data = await response.json();
                //Assign listUsers data.users 
                listUsers = data.users;
            } else //If response is not ok then it gives an error response with the status and the status text
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }).catch((error)=>{
            console.error(error);
        });
        listUsers.map((user, index)=>{
            //Each e-mail will assigned to listEMails with the same index
            listEMails[index] = user.primaryEmail;
        });
        /**
     * Counter for e-mails
     */ let counter = 1;
        /**
     * Var for default email for the new user
     */ let defaultEmail = `${firstname}.${lastname}@anydoc.ai`;
        //Check if E-Mail exists
        listEMails.forEach((email)=>{
            //If the e-mail exists then set a counter
            if (email == defaultEmail) defaultEmail = `${firstname}.${lastname}${counter}@anydoc.ai`;
            else if (email == `${firstname}.${lastname}${counter}@anydoc.ai`) counter++;
        });
        return defaultEmail;
    }
    /**
   * Initialize new dialog
  */ initDialog() {
        this.dialog.innerHTML = "";
        this.footerButtonOk.innerHTML = "";
        this.footerButtonOk.setAttribute("slot", "primaryAction");
        this.footerButtonOk.setAttribute("dialogAction", "ok");
        this.footerButtonOk.innerText = "Ok";
        this.footerButtonOk.classList.add("raised");
        this.footerButtonCancel.setAttribute("slot", "secondaryAction");
        this.footerButtonCancel.setAttribute("dialogAction", "cancel");
        this.footerButtonCancel.innerText = "Abbrechen";
        this.footerButtonCancel.classList.add("raised");
        this.dialogText.style.color = "#000000";
        this.dialogText.style.padding = "0px 20%";
        this.dialog.setAttribute("style", "border-color: #000000; border-width: 1px; font-size: 1.1em;");
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $8f6bb05fecb6d55e$export$582a43a6209fd7d0.prototype, "selectedUsers", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8f6bb05fecb6d55e$export$582a43a6209fd7d0.prototype, "addUser", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $8f6bb05fecb6d55e$export$582a43a6209fd7d0.prototype, "tempSelectedRows", void 0);
$8f6bb05fecb6d55e$export$582a43a6209fd7d0 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-users")
], $8f6bb05fecb6d55e$export$582a43a6209fd7d0);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 * Part of admin page
 * Component which shows all consultants in a data-table
 */ 
















let $8bded9149e1bfba7$export$4c82982b5e630f03 = class HitlConsultants extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }

    md-data-table-footer {
      gap: 10px;
      align-items: center;
    }

    md-outlined-text-field {
      padding: 10px 0 10px;
      width: 100%;
    }

    .mwc-select {
      width: 300%;
    }
    md-data-table-cell {
        background-color: #ffffff;
        
    }
    md-data-table-cell[type="numeric"]{
        text-align: right;
    }
    md-data-table-column {
        background-color: #ffffff;
    }
    md-data-table-footer {
        background-color: #ffffff;
    }
    div mdc-data-table__pagination-trailing {
        background-color: #ffffff;
    }
  `;
    async firstUpdated() {
        const accessToken = await this.getAccessToken(true);
        //Initializes consultants
        if (this.database) {
            this.clientConsultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
            this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        //Interval in which consultants are updated each 20 sec. = 20000 msec.
        this.timerId = setInterval(async ()=>{
            if (this.database) {
                const accessToken = await this.getAccessToken(true);
                this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
            }
            this.requestUpdate();
            console.log("consultant called");
        }, 20000);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        //Interval for consultants get disconnected after leaving the page with this component
        if (this.timerId) clearInterval(this.timerId);
        console.log("Clear Interval from disconnectedCallback");
    }
    render() {
        const template = [];
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">Berater Administration</h2>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
          <md-data-table
            aria-label="Berater Administration"
            density=""
            page-sizes-label="Zeilen pro Seite:"
            first-row-of-page=""
            current-page-size=""
            last-row-of-page=""
            paginated="true"
            pagination-total-label=":firstRow-:lastRow of :totalRows"
            @row-selection-changed=${this.rowSelectionChanged}
            @selected-all=${this.rowSelectionChanged}
            @unselected-all=${this.rowSelectionChanged}>
            <md-data-table-column type="checkbox"></md-data-table-column>
            <md-data-table-column type="numeric" sortable="" filterable=""  filter-text-field-label="Suchen">
              Beraternummer
            </md-data-table-column>
            <md-data-table-column></md-data-table-column>
            <md-data-table-column></md-data-table-column>
            <md-data-table-column></md-data-table-column>
            <md-data-table-column></md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Name
            </md-data-table-column>
            ${this.addConsultant ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-data-table-row data-id="-1">
                  <md-data-table-cell>
                    <mwc-icon-button @click=${()=>this.addConsultant = false} icon="cancel">
                    </mwc-icon-button>
                  </md-data-table-cell>
                  <md-data-table-cell>
                  <md-outlined-text-field type="number" id="consultantID" label="Beraternummer" required @keydown="${this.handleEnterKeySaveNewConsultant}">
                  </md-outlined-text-field>
                  </md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell>
                    <md-outlined-text-field id="name" label="Name" @keydown="${this.handleEnterKeySaveNewConsultant}">
                    </md-outlined-text-field></md-data-table-cell>
                </md-data-table-row>` : null}
            ${this.clientConsultants.map((consultant)=>{
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <md-data-table-row data-id=${consultant.consultantID}>
                  <md-data-table-cell type="checkbox"></md-data-table-cell>
                  <md-data-table-cell type="numeric">${consultant.consultantID}</md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell></md-data-table-cell>
                  <md-data-table-cell>
                  <mwc-textfield
                    outlined
                    id='name-${consultant.consultantID}'
                    TextFieldType="text"
                    value= ${consultant.name}
                    @keydown="${this.handleKeyUpdateConsultantName}"
                    ?disabled=${this.selectedConsultants.length === 0 || this.selectedConsultants.length > 1 || !this.selectedConsultants.includes(consultant)}>
                    ${consultant.name}
                    </mwc-textfield>
                  </md-data-table-cell>
                </md-data-table-row>
              `;
        })}
            <md-data-table-footer
              slot="footer"
              style="display: flex; align-items: left; justify-content: left;">
              <mwc-button
                raised
                @click=${()=>this.addConsultant = true}
                label="Neuen Berater hinzufügen"
                ?disabled=${this.addConsultant}></mwc-button>
              <mwc-button
                raised
                @click=${this.saveConsultant}
                label="Neuen Berater speichern"
                ?disabled=${!this.addConsultant}></mwc-button>
              <mwc-button
                raised
                @click=${this.deleteConsultants}
                label="Ausgewählte Berater löschen"
                ?disabled=${this.addConsultant || this.selectedConsultants.length === 0}></mwc-button>
              <mwc-button
                raised
                @click=${this.updateConsultantName}
                label="Änderungen speichern"
                ?disabled=${this.addConsultant || this.selectedConsultants.length === 0}
                >
                </mwc-button>
                ${this.selectedConsultants.length > 0 ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-button
                    raised
                    @click=${this.cancelEdit}
                    label="Bearbeitung abbrechen"
                    icon="cancel"
                    ></mwc-button>` : null}
            </md-data-table-footer>
          </md-data-table>
        </div>
      </div>
    `);
        return template;
    }
    /**
   * Handeling interaction with consultant name using keyboard keys
   * @param e 
   */ handleKeyUpdateConsultantName(e) {
        if (e.key === "Enter") this.updateConsultantName(e);
        else if (e.key === "Escape") this.cancelEdit(e);
    }
    /**
   * Handeling interaction with new consultant using keyboard keys
   * @param e 
   */ handleEnterKeySaveNewConsultant(e) {
        if (e.key === "Enter") this.saveConsultant(e);
        else if (e.key === "Escape") this.addConsultant = false;
    }
    dialogInit() {
        this.dialog.innerHTML = "";
        this.footerButtonOk.setAttribute("slot", "primaryAction");
        this.footerButtonOk.setAttribute("dialogAction", "ok");
        this.footerButtonOk.innerText = "Ok";
        this.footerButtonOk.classList.add("raised");
        this.dialog.style.borderColor = "#000000";
        this.dialog.style.borderWidth = "1px";
        this.dialogText.style.color = "#000000";
        this.dialogText.style.padding = "0px 20%";
        this.dialog.style.fontSize = "1.1em";
    }
    constructor(...args){
        super(...args);
        /**
   * Consultant array
   */ this.clientConsultants = [];
        /**
   * Selected consultants
   */ this.selectedConsultants = [];
        /**
   * Boolean per default its false. When a new consultant should be created this value becomes true and makes the a new row visible, if the value persists as true.
   */ this.addConsultant = false;
        /**
   * Dialog text
   */ this.dialogText = document.createElement("p");
        /**
   * Ok Button for dialog
   */ this.footerButtonOk = document.createElement("mwc-button");
        /**
   * Temp selected rows
   */ this.tempSelectedRows = [];
        /**
   * Special event from the package maicol07/material-web-additions/data-table/data-table.
   * It triggers if the row selection in the data-table changes
   * @param e 
   */ this.rowSelectionChanged = async (e)=>{
            console.log("rowSelectionChanged", e);
            this.tempSelectedRows = e.target.rows.filter((row)=>row.selected);
            this.selectedConsultants = e.target.rows.filter((row)=>row.selected).map((row)=>this.clientConsultants.find((consultant)=>consultant.consultantID === BigInt(row.dataset.id)));
        };
        /**
   * Updates consultant name
   * @param _ 
   */ this.updateConsultantName = async (_)=>{
            const accessToken = await this.getAccessToken(true);
            const consultantName = this.renderRoot.querySelector(`#name-${this.selectedConsultants[0].consultantID}`).value;
            //If consultant name exists then the name will be updated
            if (consultantName.length > 0) {
                const newConsultant = new (0, $4b442ec5a0972f6e$export$386caa7e7ce11190)(this.selectedConsultants[0].consultantID, consultantName);
                newConsultant.updateConsultant(this.database, accessToken).then(()=>console.log("Name updated"));
                this.consultants.forEach((consultant)=>{
                    if (this.selectedConsultants[0].consultantID == consultant.consultantID) consultant.name = consultantName;
                });
                this.tempSelectedRows.forEach((row)=>{
                    row.selected = false;
                });
                this.selectedConsultants = [];
                this.requestUpdate();
            } else {
                this.dialogInit();
                this.dialogText.innerText = "Geben Sie bitte einen Beratername ein";
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
                this.footerButtonOk.addEventListener("click", ()=>{
                    this.dialog.open = false;
                });
            }
        };
        /**
   * Save new consultant
   * @param _ 
   */ this.saveConsultant = async (_)=>{
            let consultantID = this.renderRoot.querySelector("#consultantID").value;
            let name = this.renderRoot.querySelector("#name").value;
            this.dialogInit();
            //If consultant id has min. one number and is not equal 0 and name is not empty then it searches that it does not exists a consultant-client connection 
            if (consultantID.length > 0 && name.length > 0 && consultantID != "0") {
                if (!this.clientConsultants.find((consultant)=>consultant.consultantID == BigInt(consultantID))) {
                    const consultant = new (0, $4b442ec5a0972f6e$export$386caa7e7ce11190)(BigInt(consultantID), name);
                    const accessToken = await this.getAccessToken(true);
                    //Saves the new consultant
                    consultant.save(this.database, accessToken).then(async ()=>{
                        this.clientConsultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
                    });
                    //Reset boolean, to not show the creation row
                    this.addConsultant = false;
                    this.requestUpdate();
                //If consultant-client connection exists, then it shows a pop up window to tell the user to use another consultant id
                } else {
                    this.dialogText.innerHTML = "Die angegebene Beraternummer existiert schon";
                    this.dialog.appendChild(this.dialogText);
                    this.dialog.appendChild(this.footerButtonOk);
                    this.dialog.open = true;
                }
            } else {
                //If consultant id and name are empty
                if (consultantID.length == 0 && name.length == 0) this.dialogText.innerHTML = "Geben Sie bitte eine Beraternummer und Name ein!";
                else if (name.length > 0) this.dialogText.innerHTML = "Geben Sie bitte eine Beraternummer ein!";
                else if (consultantID == "0") this.dialogText.innerHTML = "Geben Sie bitte eine andere Beraternummer ein!";
                else this.dialogText.innerHTML = "Geben Sie bitte einen Beraternamen ein!";
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
            }
        };
        this.cancelEdit = (_)=>{
            this.tempSelectedRows.forEach((row)=>{
                let textfield = this.shadowRoot?.getElementById(`name-${row.dataset.id}`);
                const consultant = this.consultants.find((consultant)=>consultant.consultantID == BigInt(row.dataset.id));
                if (textfield.value != consultant?.name) {
                    textfield.setAttribute("value", consultant.name);
                    return;
                }
            });
            this.tempSelectedRows.forEach((row)=>{
                row.selected = false;
            });
            this.selectedConsultants = [];
            this.requestUpdate();
        };
        this.deleteConsultants = async (_)=>{
            const accessToken = await this.getAccessToken(true);
            const selectedConsultantIDs = this.selectedConsultants.map((consultant)=>consultant.consultantID);
            const sql = `DELETE FROM Consultant WHERE consultantID in (${selectedConsultantIDs.join(",")})`;
            if (this.database) {
                this.database.readWrite(accessToken, sql);
                this.tempSelectedRows.forEach((row)=>{
                    row.selected = false;
                });
                this.clientConsultants = this.clientConsultants.filter((consultant)=>!this.selectedConsultants.includes(consultant));
                this.selectedConsultants = [];
            }
            this.requestUpdate();
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $8bded9149e1bfba7$export$4c82982b5e630f03.prototype, "clientConsultants", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $8bded9149e1bfba7$export$4c82982b5e630f03.prototype, "selectedConsultants", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $8bded9149e1bfba7$export$4c82982b5e630f03.prototype, "addConsultant", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $8bded9149e1bfba7$export$4c82982b5e630f03.prototype, "tempSelectedRows", void 0);
$8bded9149e1bfba7$export$4c82982b5e630f03 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-consultants")
], $8bded9149e1bfba7$export$4c82982b5e630f03);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */ 


















let $db310749540aabef$export$d7657580fd67a8fa = class HitlClients extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }

    md-data-table-footer {
      gap: 10px;
      align-items: center;
    }

    md-outlined-text-field {
      padding: 10px 0 10px;
      width: 100%;
    }

    md-data-table-cell {
        background-color: #ffffff;
    }

    md-data-table-column {
        background-color: #ffffff;
    }

    md-data-table-footer {
        background-color: #ffffff;
    }

    mwc-select {
        margin: 8px 0px;
        width: -webkit-fill-available;
    }
  `;
    async firstUpdated() {
        const accessToken = await this.getAccessToken();
        //Initialization clients and consultantClients
        this.clients = await (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).list(this.database, accessToken);
        this.consultantClients = await (0, $4945805059647a0f$export$dfdc0de57fad5ba8).list(this.database, accessToken);
        //Set event for the mwc-selector for each row
        if (!this.eventListenersAdded) {
            const selects = this.renderRoot?.querySelectorAll("mwc-select.consultant-select");
            if (selects) {
                selects.forEach((item)=>{
                    item.addEventListener("selected", this.addConsultantToClient);
                });
                this.eventListenersAdded = true;
            }
        }
    }
    async connectedCallback() {
        super.connectedCallback();
        //Interval in which consultants are updated each 5 sec. = 5000 msec.
        this.timerId = setInterval(async ()=>{
            this.updateConsultants();
            console.log("Connected Callback clients");
        }, 5000);
    }
    async disconnectedCallback() {
        super.disconnectedCallback();
        //Interval for consultants get disconnected after leaving the page with this component
        if (this.timerId) clearInterval(this.timerId);
    }
    render() {
        console.log("rendering hitl-clients");
        const template = [];
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">Mandanten Administration</h2>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
          <md-data-table
            aria-label="Mandanten Administration"
            density=""
            page-sizes-label="Zeilen pro Seite:"
            first-row-of-page=""
            current-page-size=""
            last-row-of-page=""
            paginated="true"
            pagination-total-label=":firstRow-:lastRow of :totalRows"
            @row-selection-changed=${this.rowSelectionChanged}
            @selected-all=${this.rowSelectionChanged}
            @unselected-all=${this.rowSelectionChanged}>
            <md-data-table-column type="checkbox"></md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Mandantennummer
            </md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Name
            </md-data-table-column>
            <md-data-table-column sortable="" filterable=""  filter-text-field-label="Suchen">
              Zugeordneter Berater
            </md-data-table-column>
            ${this.addClient ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<md-data-table-row data-id="-1">
                  <md-data-table-cell>
  <mwc-icon-button @click=${()=>{
            this.addClient = false;
            this.newClient = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(BigInt(0), "");
        }} icon="cancel"></mwc-icon-button></md-data-table-cell>                
                  <md-data-table-cell>
                    <md-outlined-text-field @input=${this.inputClientID} type="number" required id="clientID" label="Mandantennummer" maxlength="5" value=${this.newClient.clientID}
                    @keydown="${this.handleKeySaveNewClient}"
                    >
                    </md-outlined-text-field>
                  </md-data-table-cell>
                  <md-data-table-cell>
                    <md-outlined-text-field @input=${this.inputName} required id="name" label="Name" value=${this.newClient.name}
                    @keydown="${this.handleKeySaveNewClient}"
                    >
                 </md-outlined-text-field>
                  </md-data-table-cell>                  
                  <md-data-table-cell>
                </md-data-table-cell> 
                </md-data-table-row>` : null}
            ${this.clients.map((client)=>{
            return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <md-data-table-row data-id=${client.clientID}>
                  <md-data-table-cell type="checkbox"></md-data-table-cell>
                  <md-data-table-cell type="numeric">${client.clientID}</md-data-table-cell>
                  <md-data-table-cell>
                    <mwc-textfield
                    outlined
                    id='name-${client.clientID}'
                    TextFieldType="text"
                    value= ${client.name}
                    @keydown="${this.handleKeyUpdateClientName}"
                    ?disabled=${this.selectedClients.length === 0 || this.selectedClients.length > 1 || !this.selectedClients.includes(client)}
                    >
                    ${client.name}
                    </mwc-textfield>
                  </md-data-table-cell>
                  <md-data-table-cell>
                    <mwc-select
                    outlined
                      label="Berater"
                      fixedMenuPosition="true"
                      class="consultant-select"
                      ?disabled=${this.selectedClients.length === 0 || this.selectedClients.length > 1 || !this.selectedClients.includes(client)}
                      >
                      ${this.consultants.map((consultant)=>{
                return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                        ${this.consultantClients.find((consultantClient)=>BigInt(consultantClient.consultantID) == consultant.consultantID && BigInt(consultantClient.clientID) == client.clientID) ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                <mwc-list-item selected value="${consultant.consultantID}">
                                    ${consultant.consultantID} - ${consultant.name}
                                </mwc-list-item>` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                <mwc-list-item value="${consultant.consultantID}">
                                    ${consultant.consultantID} - ${consultant.name}
                                </mwc-list-item>`}
                        `;
            })}
                        <mwc-list-item ?selected=${this.consultantClients.find((consultantClient)=>BigInt(consultantClient.clientID) == client.clientID) == undefined} value='0n'>
                            Berater
                        </mwc-list-item>
                    </mwc-select>
                  </md-data-table-cell>
                </md-data-table-row>
              `;
        })}
            <md-data-table-footer
              slot="footer"
              style="display: flex; align-items: left; justify-content: left;">
              <mwc-button
                raised
                @click=${()=>this.addClient = true}
                label="Neuen Mandanten hinzufügen"
                ?disabled=${this.addClient}></mwc-button>
              <mwc-button
                raised
                @click=${this.saveClient}
                label="Neuen Mandanten speichern"
                ?disabled=${!this.addClient}></mwc-button>
              <mwc-button
                raised
                @click=${this.deleteClients}
                label="Ausgewählte Mandanten löschen"
                ?disabled=${this.addClient || this.selectedClients.length === 0}></mwc-button>
              <mwc-button
                raised
                @click=${this.updateClientName}
                label="Änderungen speichern"
                ?disabled=${this.addClient || this.selectedClients.length === 0}
                ></mwc-button>
              ${this.selectedClients.length > 0 ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<mwc-button
                raised
                @click=${this.cancelEdit}
                label="Bearbeitung abbrechen"
                icon="cancel"
                ></mwc-button>` : null}
            </md-data-table-footer>
          </md-data-table>
        </div>
      </div>
    `);
        return template;
    }
    /**
   * Handeling interaction with client name using keyboard keys
   * @param e 
   */ handleKeyUpdateClientName(e) {
        if (e.key === "Enter") this.updateClientName(e);
        else if (e.key === "Escape") this.cancelEdit(e);
    }
    /**
   * Handeling interaction with new client using keyboard keys
   * @param e 
   */ handleKeySaveNewClient(e) {
        if (e.key === "Enter") this.saveClient(e);
        else if (e.key === "Escape") {
            this.addClient = false;
            this.newClient = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(BigInt(0), "");
        }
    }
    /**
   * Initialization of the dialog
   */ dialogInit() {
        this.dialog.innerHTML = "";
        this.footerButtonOk.setAttribute("slot", "primaryAction");
        this.footerButtonOk.setAttribute("dialogAction", "ok");
        this.footerButtonOk.innerText = "Ok";
        this.footerButtonOk.classList.add("raised");
        this.dialogText.style.color = "#000000";
        this.dialogText.style.padding = "0px 20%";
        this.dialog.setAttribute("style", "border-color: #000000; border-width: 1px; font-size: 1.1em;");
    }
    constructor(...args){
        super(...args);
        /**
   * Selected clients
   */ this.selectedClients = [];
        /**
   * Boolean per default its false. When a new client should be created this value becomes true and makes the a new row visible, if the value persists as true. 
   * 
   */ this.addClient = false;
        /**
   * Variable for new client
   */ this.newClient = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(BigInt(0), "");
        /**
   * Dialog text
   */ this.dialogText = document.createElement("p");
        /**
   * Ok Button for dialog
   */ this.footerButtonOk = document.createElement("mwc-button");
        /**
   * Temp selected rows
   */ this.tempSelectedRows = [];
        /**
   * Boolean to check if event listener was set. 
   * Default: false
   */ this.eventListenersAdded = false;
        /**
   * Special event from the package maicol07/material-web-additions/data-table/data-table.
   * It triggers if the row selection in the data-table changes
   * @param e 
   */ this.rowSelectionChanged = async (e)=>{
            console.log("rowSelectionChanged", e);
            this.tempSelectedRows = e.target.rows.filter((row)=>row.selected);
            this.selectedClients = e.target.rows.filter((row)=>row.selected).map((row)=>this.clients.find((client)=>client.clientID === BigInt(row.dataset.id)));
        };
        /**
   * Updates client name
   * @param _ 
   */ this.updateClientName = async (_)=>{
            const accessToken = await this.getAccessToken(true);
            const clientName = this.renderRoot.querySelector(`#name-${this.selectedClients[0].clientID}`).value;
            //If client name exists then the name will be updated
            if (clientName) {
                const newClient = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(this.selectedClients[0].clientID, clientName);
                newClient.updateClient(this.database, accessToken).then(()=>console.log("Name updated"));
                this.clients.forEach((client)=>{
                    if (this.selectedClients[0].clientID == client.clientID) client.name = clientName;
                });
                this.tempSelectedRows.forEach((row)=>{
                    row.selected = false;
                });
                this.selectedClients = [];
                this.requestUpdate();
            //If clientname is empty, then the user gets a pop up to put a value in the field
            } else {
                this.dialogText.innerHTML = "Geben Sie bitte den Namen des Mandanten ein";
                this.dialogInit();
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
                this.footerButtonOk.addEventListener("click", ()=>{
                    this.dialog.open = false;
                });
            }
        };
        /**
   * Cancel clientName edit
   * @param _ 
   */ this.cancelEdit = (_)=>{
            this.tempSelectedRows.forEach((row)=>{
                let textfield = this.shadowRoot?.getElementById(`name-${row.dataset.id}`);
                const client = this.clients.find((client)=>client.clientID == BigInt(row.dataset.id));
                if (textfield.value != client?.name) {
                    textfield.setAttribute("value", client.name);
                    return;
                }
            });
            this.tempSelectedRows.forEach((row)=>{
                row.selected = false;
            });
            this.selectedClients = [];
            this.requestUpdate();
        };
        /**
   * Update consultants list
   */ this.updateConsultants = async ()=>{
            const accessToken = await this.getAccessToken(true);
            if (this.database) {
                this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
                this.consultantClients = await (0, $4945805059647a0f$export$dfdc0de57fad5ba8).list(this.database, accessToken);
                this.requestUpdate();
            }
        };
        /**
   * Update client list
   * @param _ 
   */ this.updateClients = async (_)=>{
            const client = this.clients.find((client)=>this.newClient.clientID == client.clientID);
            console.log(client);
            const accessToken = await this.getAccessToken(true);
            if (this.database) this.clients = await (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).list(this.database, accessToken);
            this.requestUpdate();
        };
        /**
   * Client id input for the new created client
   * @param e 
   */ this.inputClientID = async (e)=>{
            const clientID = e.target.value;
            this.newClient.clientID = BigInt(clientID);
        };
        /**
   * Client name input for the new created client
   * @param e 
   */ this.inputName = async (e)=>{
            const name = e.target.value;
            this.newClient.name = name;
        };
        /**
   * Save new client
   * @param _ 
   */ this.saveClient = async (_)=>{
            //Checks if the client does not exists
            if (this.database && this.newClient.clientID.toString().length == 5 && this.newClient.name != "") {
                if (!this.clients.find((client)=>client.clientID == this.newClient.clientID) && !this.clients.find((client)=>client.name == this.newClient.name)) {
                    const accessToken = await this.getAccessToken(true);
                    this.newClient.save(this.database, accessToken).then(async ()=>{
                        this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
                        this.consultantClients = await (0, $4945805059647a0f$export$dfdc0de57fad5ba8).list(this.database, accessToken);
                        this.clients = await (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).list(this.database, accessToken);
                    });
                    const client = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(BigInt(this.newClient.clientID), this.newClient.name);
                    this.clients = this.clients.concat([
                        client
                    ]);
                    this.addClient = false;
                    this.dispatchEvent(new CustomEvent("clients-changed", {
                        detail: this.clients,
                        bubbles: true,
                        composed: true
                    }));
                    this.newClient = new (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6)(BigInt(0), "");
                } else if (this.clients.find((client)=>client.name == this.newClient.name)) {
                    this.dialogInit();
                    this.dialogText.innerHTML = "Der angegebene Mandantennname existiert schon";
                    this.dialog.appendChild(this.dialogText);
                    this.dialog.appendChild(this.footerButtonOk);
                    this.dialog.open = true;
                } else {
                    //Give a notification if the used clientID is used by another client
                    this.dialogInit();
                    this.dialogText.innerHTML = "Die angegebene Mandantennummer existiert schon";
                    this.dialog.appendChild(this.dialogText);
                    this.dialog.appendChild(this.footerButtonOk);
                    this.dialog.open = true;
                }
            //If the client exists then a pop up window gets shown
            } else {
                this.dialogInit();
                if (this.newClient.clientID.toString().length != 5 && this.newClient.name == "") this.dialogText.innerHTML = "Geben Sie bitte eine Mandantennummer und einen Mandantenname ein!";
                else if (this.newClient.name == "") this.dialogText.innerHTML = "Geben Sie bitte einen Mandantenname ein!";
                else this.dialogText.innerHTML = "Geben Sie bitte eine Mandantennummer mit einer Zeichenl\xe4nge von 5 ein!";
                this.dialog.appendChild(this.dialogText);
                this.dialog.appendChild(this.footerButtonOk);
                this.dialog.open = true;
            }
        };
        //This method is to delete clients
        /**
   * Deletes clients
   * @param _ 
   */ this.deleteClients = async (_)=>{
            const accessToken = await this.getAccessToken(true);
            const selectedClientsIDs = this.selectedClients.map((client)=>client.clientID);
            //If a consultant-client connection is found, then the connection will deleted and then the client(s)
            if (this.consultantClients.find((item)=>selectedClientsIDs.find((clientID)=>item.clientID == clientID))) {
                const filteredClients = selectedClientsIDs.filter((clientID)=>this.consultantClients.filter((consultantClient)=>consultantClient.clientID == clientID));
                (0, $4945805059647a0f$export$dfdc0de57fad5ba8).deleteConsultantClients(this.database, accessToken, filteredClients).then(()=>{
                    (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).deleteClients(this.database, accessToken, selectedClientsIDs);
                });
            //If consultant-client connection got not found then it deletes only the client(s)  
            } else (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).deleteClients(this.database, accessToken, selectedClientsIDs);
            //Resets selection of the rows to unselected
            this.tempSelectedRows.forEach((row)=>{
                row.selected = false;
            });
            this.clients = this.clients.filter((client)=>!this.selectedClients.includes(client));
            //Empties the selectedClient list
            this.selectedClients = [];
            console.log(this.clients);
            this.requestUpdate();
        };
        /**
   * Add consultant to client
   * @param e 
   */ this.addConsultantToClient = async (e)=>{
            e.preventDefault();
            const accessToken = await this.getAccessToken(true);
            //Prevents the event to trigger if the event type is not selected
            if (e instanceof CustomEvent && e.type === "selected") {
                console.log("addConsultantToClient", e);
                const conditionConsultant = e.detail.index == this.consultants.length;
                const detail = e.detail;
                let consultantID = conditionConsultant ? null : this.consultants[detail.index].consultantID;
                //If consultant id and selected client exists then it sets the new consultant-client connection
                if (consultantID && this.selectedClients[0]) {
                    const clientID = this.selectedClients[0].clientID;
                    const consultant = this.consultants.find((consultant)=>consultant.consultantID == consultantID);
                    //If client id and consultant exist then it search a client with the clientID
                    if (clientID && consultant) {
                        const client = this.clients.find((client)=>client.clientID === BigInt(clientID));
                        //If client exists then it will be proved if a consultant-client connection exists then it updates the value from old value to new value
                        if (client) {
                            if (this.consultantClients.find((consultantClient)=>consultantClient.clientID == client.clientID) && this.database) {
                                console.log("Update");
                                //Deletes old consultant-client connection
                                (0, $4945805059647a0f$export$dfdc0de57fad5ba8).delete(this.database, accessToken, clientID).then(()=>{
                                    const consClient = new (0, $4945805059647a0f$export$dfdc0de57fad5ba8)(consultant.consultantID, client.clientID);
                                    //Sets new consultant-client connection
                                    if (this.database) consClient.save(this.database, accessToken).then(()=>{
                                        //Resets selection of each row
                                        this.tempSelectedRows.forEach((row)=>{
                                            row.selected = false;
                                        });
                                        this.selectedClients = [];
                                    });
                                });
                            //If there is no connection consultant-client for the current client, then the new connection will be build
                            } else {
                                console.log("Insert");
                                const consClient = new (0, $4945805059647a0f$export$dfdc0de57fad5ba8)(consultant.consultantID, client.clientID);
                                //Sets new consultant-client connection
                                consClient.save(this.database, accessToken).then(()=>{
                                    this.tempSelectedRows.forEach((row)=>{
                                        row.selected = false;
                                    });
                                    this.selectedClients = [];
                                });
                            }
                        }
                    }
                //If consultant id not exists (also default value "Berater") and the selected client exists, then it deletes the consultant-client connection
                } else if (this.selectedClients[0]) {
                    //Delete consultant-client connection
                    (0, $4945805059647a0f$export$dfdc0de57fad5ba8).delete(this.database, accessToken, this.selectedClients[0].clientID).then(()=>{
                        console.log("Verkn\xfcpfung gel\xf6scht");
                    });
                    this.tempSelectedRows.forEach((row)=>{
                        row.selected = false;
                    });
                    this.selectedClients = [];
                }
                this.requestUpdate();
            }
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $db310749540aabef$export$d7657580fd67a8fa.prototype, "selectedClients", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $db310749540aabef$export$d7657580fd67a8fa.prototype, "addClient", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Object
    })
], $db310749540aabef$export$d7657580fd67a8fa.prototype, "newClient", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Array
    })
], $db310749540aabef$export$d7657580fd67a8fa.prototype, "tempSelectedRows", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $db310749540aabef$export$d7657580fd67a8fa.prototype, "eventListenersAdded", void 0);
$db310749540aabef$export$d7657580fd67a8fa = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-clients")
], $db310749540aabef$export$d7657580fd67a8fa);




let $1ffb3cce8806882a$export$fea06732ae026252 = class HitlAdministration extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      gap: 12px;
    }
  `;
    async firstUpdated() {
        const accessToken = await this.getAccessToken(true);
        if (this.database) this.users = await (0, $f73fd576365dd66d$export$1f44aaf2ec115b54).list(this.database, accessToken);
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    ${!this.users.find((user)=>user.userID == this.userID && user.role == "DATA-ADMIN") ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<hitl-users
        .dialog=${this.dialog}
        .database=${this.database}
        @get-access-token=${this.getAccessTokenEvent}></hitl-users>` : null}
      <hitl-consultants
        .dialog=${this.dialog}
        .database=${this.database}
        .clients=${this.clients}
        .consultants=${this.consultants}
        @get-access-token=${this.getAccessTokenEvent}></hitl-consultants>
      <hitl-clients
        .dialog=${this.dialog}
        .database=${this.database}
        .clients=${this.clients}
        .consultants=${this.consultants}
        @get-access-token=${this.getAccessTokenEvent}></hitl-clients>
    `;
    }
};
$1ffb3cce8806882a$export$fea06732ae026252 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-administration")
], $1ffb3cce8806882a$export$fea06732ae026252);




/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Database class for database operations
 */ class $621f8db5c0ed726a$export$6feb5ea51a7b0b47 {
    constructor(databaseName){
        /**
   * Spanner session
   */ this.session = "";
        /**
   * Create Spanner session
   * @param accessToken 
   */ this.createSession = async (accessToken)=>{
            try {
                const response = await fetch(`https://spanner.googleapis.com/v1/${this.databaseName}/sessions`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + accessToken
                    }
                });
                if (!response.ok) throw response;
                const json = await response.json();
                this.session = json.name;
            } catch (error) {
                console.log("Failed on creating session");
                console.log(error);
            }
        };
        /**
   * Read database values using sql
   * @param accessToken 
   * @param sql 
   * @returns 
   */ this.read = async (accessToken, sql)=>{
            const executeSqlResponse = await this.executeSql(accessToken, sql);
            console.log("executeSqlResponse", executeSqlResponse);
            const rows = [];
            if (executeSqlResponse.rows) executeSqlResponse.rows.forEach((rowEntry)=>{
                let row = {};
                for (const [index, field] of executeSqlResponse.metadata.rowType.fields.entries())row[field.name] = rowEntry[index];
                rows.push(row);
            });
            return rows;
        };
        /**
   * Read-write database values using sql
   * @param accessToken 
   * @param sql 
   * @returns 
   */ this.readWrite = async (accessToken, sql)=>{
            const transaction = {
                begin: {
                    readWrite: {
                        readLockMode: "PESSIMISTIC"
                    }
                }
            };
            const executeSqlResponse = await this.executeSql(accessToken, sql, transaction);
            console.log("executeSqlResponse", executeSqlResponse);
            const transactionID = executeSqlResponse.metadata.transaction.id;
            const commitTransactionResponse = await this.commitTransaction(accessToken, transactionID);
            console.log("commitTransactionResponse", commitTransactionResponse);
            const rows = [];
            if (executeSqlResponse.rows) executeSqlResponse.rows.forEach((rowEntry)=>{
                let row = {};
                for (const [index, field] of executeSqlResponse.metadata.rowType.fields.entries())row[field.name] = rowEntry[index];
                rows.push(row);
            });
            return rows;
        };
        /**
   * Commit sql transaction
   * @param accessToken 
   * @param transactionId 
   * @returns 
   */ this.commitTransaction = async (accessToken, transactionId)=>{
            if (!this.session) await this.createSession(accessToken);
            try {
                const response = await fetch(`https://spanner.googleapis.com/v1/${this.session}:commit`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                    body: JSON.stringify({
                        transactionId: transactionId
                    })
                });
                if (!response.ok) throw response;
                const json = await response.json();
                return json;
            } catch (error) {
                console.log("Failed committing transaction");
                console.log(error);
                return [];
            }
        };
        this.executeSql = async (accessToken, sql, transaction)=>{
            if (!this.session) await this.createSession(accessToken);
            try {
                const response = await fetch(`https://spanner.googleapis.com/v1/${this.session}:executeSql`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                    body: JSON.stringify({
                        sql: sql,
                        transaction: transaction
                    })
                });
                if (!response.ok) throw response;
                const json = await response.json();
                return json;
            } catch (error) {
                console.log("Failed executing SQL query");
                console.log(error);
                return [];
            }
        };
        this.databaseName = databaseName;
    }
}







/**
 * to prevent an access token expiration, how many minutes before the expiration should the accessToken be renewed?
 * @param {number} MINUTES_BEFORE_ACCESS_TOKEN_RENEWAL
 */ const $a11674b82d2f3758$var$MINUTES_BEFORE_ACCESS_TOKEN_RENEWAL = 10;
var $a11674b82d2f3758$var$ComponentType;
/**
 * Component types
 */ (function(ComponentType) {
    ComponentType[ComponentType["Login"] = 0] = "Login";
    ComponentType[ComponentType["Upload"] = 1] = "Upload";
    ComponentType[ComponentType["ManageReviewRequests"] = 2] = "ManageReviewRequests";
    ComponentType[ComponentType["ReviewDocument"] = 3] = "ReviewDocument";
    ComponentType[ComponentType["Admin"] = 4] = "Admin";
})($a11674b82d2f3758$var$ComponentType || ($a11674b82d2f3758$var$ComponentType = {}));
let $a11674b82d2f3758$export$71c93d36757fcdb1 = class HitlApp extends (0, $c92cdd4fda4c057c$export$8f6e358395896ae9) {
    static #_ = this.styles = (0, $3233927aa82734f9$export$dbf350e5966cf602)`
    .dialog-style {
        --mdc-dialog-content-ink-color: #000000;
        color: var(--mdc-dialog-content-ink-color);
        --mdc-shape-medium: 0px;
    }
    .mdc-dialog .mdc-dialog__content {
        color: #000000;
        height: 100px;
        justify-content: center;
        display: flex;
        align-items: center;
    }
    .mdc-dialog .mdc-dialog__surface {
        border-radius: 4px;
        border-color: black;
        border-width: 1px;
        border-style: solid;
    }
    .mdc-dialog__actions {
        display: none;
}`;
    createRenderRoot() {
        return this;
    }
    /**
   * Access token ad
   */ #accessTokenAD;
    /**
   * Access token
   */ #accessToken;
    /**
   * Access token expiration
   */ #accessTokenExpiration;
    firstUpdated() {
        // load AI UI component scripts into document head
        let scriptElement = document.createElement("script");
        scriptElement.src = "https://aiui.googleapis.com/v1/component/client.js?key=AIzaSyAF52EkQsFaubLRrMoXoYur9O4gFeA6iTk";
        scriptElement.src += "&version=1.0";
        document.head.appendChild(scriptElement);
        if (this.identityType === "gis") {
            // load Google Identity Services library and register callbacks to ensure that GIS is loaded before login button is used
            let scriptElement = document.createElement("script");
            scriptElement.src = "https://accounts.google.com/gsi/client";
            scriptElement.onload = this.setupIdentityServices.bind(this);
            document.head.appendChild(scriptElement);
            this.loginRequired = true;
        } else if (this.identityType === "ad") {
            const configuration = {
                auth: {
                    clientId: "628593642649-uh1hldisk6jaikjs984sf2ql2j60fd85.apps.googleusercontent.com",
                    authority: undefined
                }
            };
            this.ADclientApplication = new (0, $cc634fcd0c4f5425$export$89f4855ef88b7920)(configuration);
            this.loginRequired = true;
            this.setupCompleted = true;
        } else {
            this.loginRequired = false;
            this.setupCompleted = true;
        }
        /**
     * Drawer for navigation menu
     */ const drawer = document.getElementsByTagName("mwc-drawer")[0];
        if (drawer) {
            const container = drawer.parentNode;
            if (container) container.addEventListener("MDCTopAppBar:nav", ()=>{
                drawer.open = !drawer.open;
            });
        }
        const databaseName = "projects/dornbach13b/instances/tfgen-spanid-20231130141121698/databases/hitl";
        this.database = new (0, $621f8db5c0ed726a$export$6feb5ea51a7b0b47)(databaseName);
        this.dialog = this.renderRoot.querySelector("#dialog");
    }
    connectedCallback() {
        super.connectedCallback();
        //Interval in which timer is updated each 1 sec. = 1000 msec.
        this.timerId = setInterval(async ()=>{
            this.remainingTime = "";
            this.remainingTime = this.getRemainingTimeUntilExpiration();
            this.requestUpdate();
        }, 1000);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        //Interval for timer gets disconnected after logout
        if (this.timerId) clearInterval(this.timerId);
    }
    render() {
        const template = [];
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
        <mwc-dialog id="dialog"></mwc-dialog>
      `);
        //Drawer composition
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
      <mwc-drawer hasHeader type="modal">
        <div>
          <mwc-list>
            <mwc-list-item
              graphic="icon"
              @click=${()=>this.changeComponentTo(1)}>
              <slot>Hochladen</slot>
              <mwc-icon slot="graphic">upload</mwc-icon>
            </mwc-list-item>
            <mwc-list-item
              graphic="icon"
              @click=${()=>this.changeComponentTo(2)}>
              <slot>Aufgabenübersicht</slot>
              <mwc-icon slot="graphic">description</mwc-icon>
            </mwc-list-item>
            ${this.users.find((user)=>user.userID == this.userID && (user.role == "ADMIN" || user.role == "DATA-ADMIN")) //user has admin or data-admin role
         ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                  <mwc-list-item
                    graphic="icon"
                    @click=${()=>this.changeComponentTo(4)}>
                    <slot>Administration</slot>
                    <mwc-icon slot="graphic">admin_panel_settings</mwc-icon>
                  </mwc-list-item>
                ` : null}
                  <mwc-list-item graphic="icon" @click=${this.logout}>
                    <slot>Abmelden</slot>
                    <mwc-icon slot="graphic">logout</mwc-icon>
                  </mwc-list-item>
          </mwc-list>
          <div style="margin: 0px 16px;"><p style="text-align:center;">Verbleibende Sitzungszeit</p></div>
          <div style="border-style: solid; margin: 0px 16px;"><p style="text-align:center;">${this.remainingTime}</p></div>
        </div>
        <div slot="appContent">
          <mwc-top-app-bar-fixed id="header" ?centertitle=${true}>
            ${!this.loginRequired ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                  <mwc-icon-button
                    slot="navigationIcon"
                    icon="menu"></mwc-icon-button>
                ` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)``}
            <div slot="title">
              <span>anydoc.ai</span>
            </div>

            <div slot="actionItems">
              ${this.loginRequired // login required
         ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                    <mwc-button
                      raised
                      style="margin: auto; max-width: 25ex;"
                      @click=${this.login}
                      label="Anmelden"
                      icon="login"
                      ?disabled=${!this.setupCompleted}></mwc-button>
                  ` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                    <span
                      style="margin: auto;max-width: 25ex;"
                      id="userID"
                      label="Benutzer ID">
                      ${this.userID}
                    </span>
                  `}
            </div>
          </mwc-top-app-bar-fixed>
        </div>
      </mwc-drawer>
      
    `);
        //Component will be rendered if it is the current one
        switch(this.componentType){
            //Component to set hitl-upload
            case 1:
                template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <hitl-upload
              .dialog=${this.dialog}
              .database=${this.database}
              .clients=${this.clients}
              .consultants=${this.consultants}
              .filterClients=${this.filterClients}
              .filterConsultants=${this.filterConsultants}
              @get-access-token=${this.getAccessTokenEvent}
              userID=${this.userID}></hitl-upload>
          `);
                break;
            //Component to set hitl-review-requests
            case 2:
                template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <div class="content-wrapper">
            ${!this.userID ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                  <hitl-review-requests
                    .dialog=${this.dialog}
                    .database=${this.database}
                    .reviewRequests=${this.reviewRequests}
                    @review-requests-updated=${this.addReviewRequests}
                    @get-access-token=${this.getAccessTokenEvent}
                    @batch-review-triggered=${this.startBatchReview}
                  ></hitl-review-requests>
                </div>
                `}
          </div>
        `);
                break;
            //Component to set hitl-review-document
            case 3:
                template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <hitl-review-document
            @manage-batch-and-queues-triggered=${this.ManageReviewRequests}
            .reviewRequests=${this.reviewRequests}
            .userID=${this.userID}
            @get-access-token=${this.getAccessTokenEvent}></hitl-review-document>
        `);
                break;
            //Component to set hitl-administration
            case 4:
                template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="content-wrapper">
              <hitl-administration
                .userID=${this.userID}
                .dialog=${this.dialog}
                .database=${this.database}
                .users=${this.users}
                .clients=${this.clients}
                .consultants=${this.consultants}                
                @get-access-token=${this.getAccessTokenEvent}
                @clients-changed=${this.clientsChanged}></hitl-administration>
            </div>
          `);
                break;
            default:
                //If none of the other components is set this one, also the login is set
                template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <login></login>
          `);
        }
        template.push((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
              </main>
            </div>
          </mwc-drawer>
          `);
        return template;
    }
    /**
   * Change current component for another i.e. Upload -> Admin
   * @param component 
   */ changeComponentTo(component) {
        this.componentType = component;
        const drawer = document.getElementsByTagName("mwc-drawer")[0];
        drawer.open = !drawer;
    }
    /**
   * Setup identity services
   */ setupIdentityServices() {
        this.setupCompleted = true;
        this.initTokenClient = google.accounts.oauth2.initTokenClient;
    }
    /**
   * Add new review-request
   * @param e 
   */ async addReviewRequests(e) {
        const newReviewRequests = e.detail;
        this.reviewRequests = this.reviewRequests.concat(newReviewRequests);
    }
    /**
   * Replace review-requests
   * @param e 
   */ async replaceReviewRequests(e) {
        this.reviewRequests = e.detail;
    }
    /**
   * Start batch review
   * @param e 
   */ startBatchReview(e) {
        console.log("startBatchReview", e);
        this.reviewRequests = e.detail;
        this.componentType = 3;
    }
    /**
   * Component ManageReviewRequest is set and cleanup leftover from DocumentView component
   * @param e 
   */ ManageReviewRequests(e) {
        document.querySelectorAll(".cdk-overlay-container").forEach((element)=>element.innerHTML = "");
        this.reviewRequests = e.detail;
        this.componentType = 2;
    }
    /**
   * Client changed event
   * @param e 
   */ clientsChanged(e) {
        console.log("clientsChanged", e);
        this.clients = e.detail;
    }
    /**
   * Gets the reimaining time until the access token expire
   * @returns 
   */ getRemainingTimeUntilExpiration() {
        const currentTime = new Date();
        const timeUntilExpiration = this.#accessTokenExpiration.getTime() - currentTime.getTime();
        // Convert milliseconds to minutes
        const minutes = Math.floor(timeUntilExpiration / 60000);
        // Convert remaining milliseconds to seconds
        const seconds = Math.floor(timeUntilExpiration % 60000 / 1000);
        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(seconds).padStart(2, "0");
        return `${formattedMinutes}:${formattedSeconds}`;
    }
    constructor(...args){
        super(...args);
        /**
   * current component type. The default component type is login
   */ this.componentType = 0;
        /**
   * Identity type
   */ this.identityType = "none";
        /**
   * Boolean for login is required
   */ this.loginRequired = false;
        /**
   * Boolean for setup completed
   */ this.setupCompleted = false;
        /**
   * Timer id for connected- and callback
   */ this.timerId = "";
        this.#accessTokenAD = "";
        this.#accessToken = "";
        this.#accessTokenExpiration = new Date();
        /**
   *  Current method to get accessToken
   */ this.getAccessToken = async (refresh = false, scope = "https://www.googleapis.com/auth/cloud-platform email profile", cache = true)=>{
            //If cache is true, refresh is false and expiration of the access token is newer than the current date
            if (cache && !refresh && this.#accessToken && this.#accessTokenExpiration > new Date() || //Or if cache is true, refresh is true and expiration of the access token is newer than the current time     
            cache && refresh && this.#accessTokenExpiration > new Date(new Date().getTime() + $a11674b82d2f3758$var$MINUTES_BEFORE_ACCESS_TOKEN_RENEWAL * 60000)) return this.#accessToken;
            else if (refresh) {
                // The access token is missing, invalid, or expired, prompt for user consent to obtain one.
                if (this.identityType === "gis") try {
                    /**
           * Settle this promise in the response callback for requestAccessToken()
           */ const promise = new Promise((resolve, reject)=>{
                        if (this.initTokenClient) {
                            const tokenClient = this.initTokenClient({
                                client_id: "628593642649-uh1hldisk6jaikjs984sf2ql2j60fd85.apps.googleusercontent.com",
                                scope: scope,
                                prompt: "",
                                callback: (tokenResponse)=>{
                                    if (tokenResponse.error !== undefined) {
                                        console.log("tokenResponse has an error");
                                        reject(tokenResponse.error_description);
                                    }
                                    resolve(tokenResponse);
                                },
                                error_callback: (error)=>{
                                    console.log("error_callback");
                                    reject(error);
                                }
                            });
                            tokenClient.requestAccessToken();
                        } else reject("initTokenClient not defined");
                    });
                    /**
           * Stores token response
           */ const tokenResponse = await promise;
                    if (cache) {
                        this.#accessToken = tokenResponse.access_token;
                        this.#accessTokenExpiration = new Date(new Date().getTime() + parseInt(tokenResponse.expires_in) * 1000);
                    }
                } catch (error) {
                    console.log("requesting access token failed");
                    this.userID = "";
                    this.loginRequired = true;
                    const dialog = document.getElementById("dialog");
                    if (dialog) {
                        dialog.innerHTML = "";
                        dialog.heading = "Anmeldung fehlgeschlagen, aktualisieren Sie bitte die Seite"; //
                        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                <mwc-button slot="primaryAction" id="ok" dialogAction="ok">
                  Ok
                </mwc-button>
              `, dialog);
                        const primaryButtonOk = document.getElementById("ok");
                        if (primaryButtonOk) primaryButtonOk.addEventListener("click", ()=>{
                            console.log("Seite aktualisiert");
                            location.reload();
                        });
                        dialog.addEventListener("closed", ()=>{
                            location.reload();
                        });
                        dialog.open = true;
                    }
                }
                else if (this.identityType === "ad" && this.ADclientApplication) {
                    const loginResponse = await this.ADclientApplication.loginPopup({
                        scopes: [
                            "openid",
                            "profile",
                            "email"
                        ]
                    });
                    if (loginResponse.idToken) {
                        /**
           * Call STS (Google's Security Token Service) for token exchange
           */ const stsUrl = "https://sts.googleapis.com/v1/token";
                        const body = JSON.stringify({
                            /**
             * Indicates the type of grant being requested
             */ grantType: "urn:ietf:params:oauth:grant-type:token-exchange",
                            /**
             * Specifies the target resource for which the access token is intended
             */ audience: "//iam.googleapis.com/locations/global/workforcePools/undefined/providers/undefined",
                            /**
             * Defines the scope of the access token being requested
             */ scope: "https://www.googleapis.com/auth/cloud-platform",
                            /**
             * Indicates the type of token being requested
             */ requestedTokenType: "urn:ietf:params:oauth:token-type:access_token",
                            /**
             * Contains the ID token obtained during the authentication process
             */ subjectToken: loginResponse.idToken,
                            /**
             * Specifies the type of token being exchanged
             */ subjectTokenType: "urn:ietf:params:oauth:token-type:id_token",
                            /**
             * Additional options
             */ options: JSON.stringify({
                                userProject: undefined
                            })
                        });
                        const tokenResponse = await fetch(stsUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: body
                        });
                        const tokenResponseJson = await tokenResponse.json();
                        if (cache) {
                            this.#accessTokenAD = loginResponse.accessToken;
                            this.#accessToken = tokenResponseJson.access_token;
                            this.#accessTokenExpiration = new Date(new Date().getTime() + parseInt(tokenResponseJson.expires_in) * 1000);
                            console.log("AccessToken expires at", this.#accessTokenExpiration.getMilliseconds());
                        }
                    }
                }
            } else {
                console.log("cannot fetch access token due to missing user action (e.g. button click)");
                this.userID = "";
                this.loginRequired = true;
                const dialog = document.getElementById("dialog");
                if (dialog) {
                    dialog.heading = "";
                    dialog.innerHTML = "";
                    dialog.heading = "Sie wurden abgemeldet. Aktualisieren Sie bitte die Seite"; //Anmeldung fehlgeschlagen
                    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <mwc-button slot="primaryAction" dialogAction="ok" @click=${(_)=>{
                        location.reload();
                    }}>
              Ok
            </mwc-button>
          `, dialog);
                    dialog.open = true;
                }
            }
            return this.#accessToken;
        };
        /**
   * Login for current user
   */ this.login = async ()=>{
            await this.getAccessToken(true);
            // fetch user info
            let userInfoUrl;
            let accessToken;
            //If identity type is gis then set
            //userInfoUrl is https://www.googleapis.com/oauth2/v1/userinfo
            //Access token is #accessToken
            if (this.identityType === "gis") {
                userInfoUrl = "https://www.googleapis.com/oauth2/v1/userinfo";
                accessToken = this.#accessToken;
            //If identity type is ad then set
            //userInfoUrl is https://graph.microsoft.com/oidc/userinfo
            //Access token is #accessTokenAD
            } else if (this.identityType === "ad") {
                userInfoUrl = "https://graph.microsoft.com/oidc/userinfo";
                accessToken = this.#accessTokenAD;
            }
            //If user info url is not empty then login the user
            if (userInfoUrl) {
                const response = await (0, $a3c29da612ac4bde$export$782df2acbe10b22c)(userInfoUrl, {
                    headers: {
                        authorization: `Bearer ${accessToken}`
                    }
                }, 5000, 3);
                const json = await response.json();
                console.log(json);
                this.userID = json.email;
            }
            this.loginRequired = false;
            this.initialize();
            this.changeComponentTo(2);
        };
        /**
   * Logout user
   */ this.logout = async ()=>{
            this.#accessToken = "";
            this.#accessTokenAD = "";
            this.#accessTokenExpiration = new Date(0);
            this.userID = "";
            this.loginRequired = true;
            const drawer = document.getElementsByTagName("mwc-drawer")[0];
            drawer.open = false;
            location.reload();
        };
        /**
   * Initialize variables
   */ this.initialize = async ()=>{
            if (this.database) {
                const accessToken = await this.getAccessToken();
                this.users = await (0, $f73fd576365dd66d$export$1f44aaf2ec115b54).list(this.database, accessToken);
                this.clients = await (0, $f31384e0b0aee8c7$export$1f2bb630327ac4b6).list(this.database, accessToken);
                this.consultants = await (0, $4b442ec5a0972f6e$export$386caa7e7ce11190).list(this.database, accessToken);
                this.consultantClients = await (0, $4945805059647a0f$export$dfdc0de57fad5ba8).list(this.database, accessToken);
                this.filterClients = this.clients;
                this.filterConsultants = this.consultants;
                this.reviewRequests = await (0, $123ae602cd787ad4$export$2398eb31525b8be1).list(this.database, accessToken);
            }
        };
    }
};
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Number
    })
], $a11674b82d2f3758$export$71c93d36757fcdb1.prototype, "componentType", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a11674b82d2f3758$export$71c93d36757fcdb1.prototype, "identityType", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $a11674b82d2f3758$export$71c93d36757fcdb1.prototype, "loginRequired", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: Boolean
    })
], $a11674b82d2f3758$export$71c93d36757fcdb1.prototype, "setupCompleted", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $b2fdcbe153c88f81$export$d541bacb2bda4494)({
        type: String
    })
], $a11674b82d2f3758$export$71c93d36757fcdb1.prototype, "remainingTime", void 0);
$a11674b82d2f3758$export$71c93d36757fcdb1 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $07706bf0c990b886$export$da64fc29f17f9d0e)("hitl-app")
], $a11674b82d2f3758$export$71c93d36757fcdb1);


//# sourceMappingURL=index.bdda560b.js.map
